var rv = Object.defineProperty;
var sv = (n, e, t) => e in n ? rv(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Ae = (n, e, t) => sv(n, typeof e != "symbol" ? e + "" : e, t);
import * as i0 from "vue";
import { defineComponent as H, ref as R, computed as L, createElementBlock as C, openBlock as v, normalizeStyle as He, normalizeClass as J, createCommentVNode as _, Fragment as re, createElementVNode as y, createBlock as V, Teleport as S2, createVNode as U, toDisplayString as j, resolveComponent as _2, resolveDirective as f1, renderList as De, withDirectives as vo, resolveDynamicComponent as qr, withCtx as B, renderSlot as le, createTextVNode as Se, onMounted as We, getCurrentInstance as qn, inject as Uo, shallowRef as mr, watch as Ee, onUnmounted as Ei, h as lt, Text as av, unref as k, createStaticVNode as mi, withModifiers as It, nextTick as Ve, getCurrentScope as h1, onScopeDispose as ru, shallowReadonly as Sr, toRefs as Zn, mergeProps as ze, watchSyncEffect as lv, withKeys as Zt, normalizeProps as Ra, vShow as E2, provide as Oi, watchEffect as dt, markRaw as O2, Comment as T2, cloneVNode as p1, toRef as dv, camelize as A2, toHandlerKey as uv, reactive as Zr, mergeDefaults as cv, watchPostEffect as fv, effectScope as I2, onBeforeUnmount as ps, readonly as D2, guardReactiveProps as su, toHandlers as hv, useSlots as pv, customRef as N2, vModelText as m1, triggerRef as r0, toRaw as vt, isRef as mv, Transition as gv, version as vv, isProxy as P2, onBeforeMount as bv } from "vue";
const yv = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xv = ["stroke"], Cv = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wv = { "clip-path": "url(#clip0_1149_4076)" }, kv = ["stroke"], $v = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mv = { "clip-path": "url(#clip0_216_1715)" }, Sv = ["stroke"], _v = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ev = ["stroke"], Ov = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tv = ["stroke"], Av = {
  key: 3,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Iv = ["stroke"], Dv = {
  key: 4,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nv = { "clip-path": "url(#clip0_1284_4541)" }, Pv = ["stroke"], Lv = {
  key: 5,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rv = ["stroke"], Fv = {
  key: 6,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bv = ["stroke"], Vv = {
  key: 7,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zv = ["stroke"], Hv = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jv = ["stroke"], Wv = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uv = ["stroke"], Kv = {
  key: 9,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gv = ["stroke"], Yv = {
  key: 10,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qv = ["stroke"], Zv = {
  key: 11,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jv = ["stroke"], Xv = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qv = { "clip-path": "url(#clip0_216_1635)" }, eb = ["stroke"], tb = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nb = ["stroke"], ob = {
  key: 13,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ib = ["stroke"], rb = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sb = { "clip-path": "url(#clip0_420_4795)" }, ab = ["stroke"], lb = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, db = ["stroke"], ub = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cb = ["stroke"], fb = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hb = ["stroke"], pb = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mb = { "clip-path": "url(#clip0_216_305)" }, gb = ["stroke"], vb = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bb = ["stroke"], yb = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xb = { "clip-path": "url(#clip0_29_265)" }, Cb = ["stroke"], wb = {
  key: 17,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kb = ["stroke"], $b = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mb = ["stroke"], Sb = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _b = ["stroke"], Eb = {
  key: 19,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ob = ["stroke"], Tb = {
  key: 20,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ab = ["stroke"], Ib = {
  key: 21,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Db = ["stroke"], Nb = {
  key: 22,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pb = ["stroke"], Lb = {
  key: 23,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rb = { "clip-path": "url(#clip0_14_151)" }, Fb = ["stroke"], Bb = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vb = ["stroke"], zb = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hb = ["stroke"], jb = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wb = ["stroke"], Ub = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kb = { "clip-path": "url(#clip0_623_6932)" }, Gb = ["stroke"], Yb = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qb = { "clip-path": "url(#clip0_1278_4537)" }, Zb = ["stroke"], Jb = {
  key: 26,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xb = ["stroke"], Qb = {
  key: 27,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e8 = { "clip-path": "url(#clip0_1028_3519)" }, t8 = ["stroke"], n8 = {
  key: 28,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o8 = ["stroke"], i8 = {
  key: 29,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r8 = ["stroke"], s8 = {
  key: 30,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a8 = ["stroke"], l8 = {
  key: 31,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d8 = ["stroke"], u8 = {
  key: 32,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, c8 = { "clip-path": "url(#clip0_935_3470)" }, f8 = ["stroke"], h8 = {
  key: 33,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p8 = ["stroke"], m8 = {
  key: 34,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g8 = ["stroke"], v8 = ["stroke"], b8 = {
  key: 35,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y8 = ["stroke"], x8 = {
  key: 36,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C8 = ["stroke"], w8 = {
  key: 37,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, k8 = ["stroke"], $8 = {
  key: 38,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M8 = ["stroke"], S8 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _8 = ["stroke"], E8 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O8 = ["stroke"], T8 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A8 = ["stroke"], I8 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, D8 = ["stroke"], N8 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P8 = ["stroke"], L8 = {
  key: 41,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R8 = { "clip-path": "url(#clip0_274_1881)" }, F8 = ["stroke"], B8 = {
  key: 42,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V8 = ["stroke"], z8 = {
  key: 43,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H8 = {
  key: 44,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j8 = { "clip-path": "url(#clip0_733_3458)" }, W8 = ["stroke"], U8 = {
  key: 45,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K8 = ["stroke"], G8 = {
  key: 46,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y8 = ["stroke"], q8 = {
  key: 47,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z8 = ["stroke"], J8 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X8 = { "clip-path": "url(#clip0_185_4118)" }, Q8 = ["stroke"], e7 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t7 = { "clip-path": "url(#clip0_20_174)" }, n7 = ["stroke"], o7 = {
  key: 49,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, i7 = { "clip-path": "url(#clip0_289_2100)" }, r7 = ["stroke"], s7 = {
  key: 50,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a7 = { "clip-path": "url(#clip0_31_222)" }, l7 = ["stroke"], d7 = {
  key: 51,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u7 = { "clip-path": "url(#clip0_2326_100)" }, c7 = ["stroke"], f7 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h7 = { "clip-path": "url(#clip0_623_6937)" }, p7 = ["stroke"], m7 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g7 = ["stroke"], v7 = {
  key: 53,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b7 = ["stroke"], y7 = {
  key: 54,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x7 = ["stroke"], C7 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, w7 = ["stroke"], k7 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $7 = ["stroke"], M7 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S7 = ["stroke"], _7 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E7 = ["stroke"], O7 = {
  key: 57,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T7 = { "clip-path": "url(#clip0_376_2459)" }, A7 = ["stroke"], I7 = {
  key: 58,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, D7 = ["stroke"], N7 = {
  key: 59,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P7 = ["stroke"], L7 = {
  key: 60,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R7 = ["stroke"], F7 = ["stroke"], B7 = ["stroke"], V7 = {
  key: 61,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z7 = ["stroke"], H7 = ["stroke"], j7 = ["stroke"], W7 = {
  key: 62,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U7 = { "clip-path": "url(#clip0_123_362)" }, K7 = ["stroke"], G7 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y7 = ["stroke"], q7 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z7 = ["stroke"], J7 = {
  key: 64,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X7 = { "clip-path": "url(#clip0_1110_3523)" }, Q7 = ["stroke"], ey = {
  key: 65,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ty = { "clip-path": "url(#clip0_443_3358)" }, ny = ["stroke"], oy = {
  key: 0,
  width: "40",
  height: "40",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iy = ["stroke"], ry = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sy = ["stroke"], ay = {
  key: 67,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ly = ["stroke"], dy = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uy = { "clip-path": "url(#clip0_409_7312)" }, cy = ["stroke"], fy = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hy = ["stroke"], py = {
  key: 69,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, my = ["stroke"], gy = {
  key: 70,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vy = ["stroke"], by = {
  key: 71,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yy = { "clip-path": "url(#clip0_193_1263)" }, xy = ["stroke"], Cy = ["stroke"], wy = {
  key: 72,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ky = ["stroke"], $y = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, My = { "clip-path": "url(#clip0_623_6952)" }, Sy = ["stroke"], _y = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ey = ["stroke"], Oy = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ty = { "clip-path": "url(#clip0_143_692)" }, Ay = ["stroke"], Iy = {
  key: 74,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dy = ["stroke"], Ny = {
  key: 75,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Py = { "clip-path": "url(#clip0_320_2117)" }, Ly = ["stroke"], Ry = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fy = { "clip-path": "url(#clip0_1123_3023)" }, By = ["stroke"], Vy = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zy = ["stroke"], Hy = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jy = ["stroke"], Wy = {
  key: 77,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uy = { "clip-path": "url(#clip0_1010_3523)" }, Ky = ["stroke"], Gy = {
  key: 78,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yy = { "clip-path": "url(#clip0_1380_4541)" }, qy = ["stroke"], Zy = {
  key: 79,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jy = ["stroke"], Xy = {
  key: 80,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qy = ["stroke"], ex = {
  key: 81,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tx = { "clip-path": "url(#clip0_339_2098)" }, nx = ["stroke"], ox = {
  key: 82,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ix = ["stroke"], rx = ["width", "height", "stroke"], sx = ["width", "height", "stroke"], ax = {
  key: 85,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lx = ["stroke"], dx = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ux = { "clip-path": "url(#clip0_708_814)" }, cx = ["stroke"], fx = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hx = { "clip-path": "url(#clip0_143_686)" }, px = ["stroke"], mx = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gx = ["stroke"], vx = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bx = ["stroke"], yx = {
  key: 88,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xx = {
  key: 89,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, Cx = ["stroke"], wx = {
  key: 90,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, kx = ["stroke"], $x = ["stroke"], Mx = ["stroke"], Sx = ["stroke"], _x = ["stroke"], Ex = ["stroke"], Ox = {
  key: 91,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tx = { "clip-path": "url(#clip0_3046_543)" }, Ax = ["stroke"], Ix = {
  key: 92,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dx = ["stroke"], Nx = {
  key: 93,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Px = ["stroke"], Lx = ["stroke"], Rx = {
  key: 94,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fx = { "clip-path": "url(#clip0_3046_554)" }, Bx = ["stroke"], Vx = {
  key: 95,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zx = ["fill"], Hx = {
  key: 96,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jx = ["fill"], Wx = {
  key: 97,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ux = ["fill"], Kx = {
  key: 98,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gx = ["fill"], Yx = {
  key: 99,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qx = ["stroke"], Zx = {
  key: 100,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jx = ["stroke"], Xx = {
  key: 101,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qx = { "clip-path": "url(#clip0_3210_119)" }, eC = ["stroke"], tC = {
  key: 102,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, nC = ["stroke"], oC = ["stroke"], iC = ["stroke"], rC = ["stroke"], sC = {
  key: 103,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aC = ["stroke"], lC = {
  key: 104,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dC = ["stroke"], uC = {
  key: 105,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cC = ["stroke"], fC = {
  key: 106,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hC = ["stroke"], pC = {
  key: 107,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mC = { "clip-path": "url(#clip0_11_6)" }, gC = ["stroke"], vC = ["stroke"], bC = ["stroke"], yC = ["stroke"], xC = {
  key: 108,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CC = { "clip-path": "url(#clip0_3620_119)" }, wC = ["stroke"], kC = {
  key: 109,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $C = ["stroke"], MC = {
  key: 110,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SC = { "clip-path": "url(#clip0_435_288)" }, _C = ["stroke"], EC = { id: "clip0_435_288" }, OC = ["fill"], TC = {
  key: 111,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AC = ["stroke"], IC = {
  key: 112,
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DC = {
  key: 113,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NC = ["stroke"], PC = ["stroke"], ye = /* @__PURE__ */ H({
  __name: "BaseIcon",
  props: {
    icon: {},
    size: { default: void 0 },
    color: { default: void 0 },
    bgColor: { default: void 0 },
    hoverState: { type: Boolean, default: !1 },
    hoverColor: { default: void 0 }
  },
  setup(n) {
    const e = n, t = R(!1), o = {
      "--color-background-default": "#ffffff",
      "--color-background-subtle": "#f1f5f9",
      "--color-background-subtle-hover": "#f8fafc",
      "--color-background-emphasis": "#0e1014",
      "--color-background-brand-emphasis": "#444ce7",
      "--color-background-brand-emphasis-hover": "#3538cd",
      "--color-background-brand-disabled": "#a4bcfd",
      "--color-background-brand-default": "#eef4ff",
      "--color-background-brand-default-hover": "#e0eaff",
      "--color-background-success-default": "#ecfdf3",
      "--color-background-warning-default": "#fffaeb",
      "--color-background-danger-default": "#fef3f2",
      "--color-background-danger-subtle": "#fee4e2",
      "--color-background-danger-emphasis": "#d92d20",
      "--color-background-danger-emphasis-hover": "#b42318",
      "--color-background-danger-disabled": "#fda29b",
      "--color-foreground-on-emphasis": "#ffffff",
      "--color-foreground-subtle": "#94a3b8",
      "--color-foreground-default": "#5f6c85",
      "--color-foreground-emphasis": "#1c1f27",
      "--color-foreground-brand-default": "#444ce7",
      "--color-foreground-brand-hover": "#3538cd",
      "--color-foreground-brand-emphasis": "#2d31a6",
      "--color-foreground-success-default": "#03874c",
      "--color-foreground-warning-default": "#b25504",
      "--color-foreground-danger-default": "#d92d20",
      "--color-border-default": "#cbd5e1",
      "--color-border-subtle": "#e2e8f0",
      "--color-border-on-emphasis": "#ffffff",
      "--color-border-brand-default": "#c7d7fe",
      "--color-border-brand-emphasis": "#444ce7",
      "--color-border-success-default": "#bcf6d1",
      "--color-border-success-emphasis": "#03874c",
      "--color-border-warning-default": "#fcebb1",
      "--color-border-warning-emphasis": "#b25504",
      "--color-border-danger-default": "#fecdca",
      "--color-border-danger-emphasis": "#d92d20"
    }, i = (l) => {
      const d = l.match(/^var\((--color-[a-z0-9-]+)\)$/i);
      if (!d)
        return l;
      const u = d[1].toLowerCase(), c = o[u];
      return c ? `var(${u}, ${c})` : l;
    }, r = L(() => {
      const l = e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "var(--color-foreground-emphasis, #1c1f27)";
      return i(l);
    }), s = () => {
      e.hoverState && (t.value = !0);
    }, a = () => {
      t.value = !1;
    };
    return (l, d) => (v(), C("div", {
      class: J([
        "flex items-center justify-center",
        { "cursor-pointer": t.value, "rounded-full p-1.5": n.bgColor }
      ]),
      style: He({ backgroundColor: n.bgColor }),
      onMouseenter: s,
      onMouseleave: a
    }, [
      n.icon === "alert-circle" ? (v(), C(re, { key: 0 }, [
        n.size === 24 ? (v(), C("svg", yv, [
          y("path", {
            d: "M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, xv)
        ])) : (v(), C("svg", Cv, [
          y("g", wv, [
            y("path", {
              d: "M8 5.33334V8.00001M8 10.6667H8.00667M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.3181 1.33334 8 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, kv)
          ]),
          d[0] || (d[0] = y("defs", null, [
            y("clipPath", { id: "clip0_1149_4076" }, [
              y("rect", {
                width: "16",
                height: "16",
                fill: "white"
              })
            ])
          ], -1))
        ]))
      ], 64)) : _("", !0),
      n.icon === "alert-triangle" ? (v(), C(re, { key: 1 }, [
        n.size === 12 ? (v(), C("svg", $v, [
          y("g", Mv, [
            y("path", {
              d: "M5.99989 4.50001V6.50001M5.99989 8.50001H6.00489M5.14489 1.93001L0.909888 9.00001C0.822572 9.15122 0.776372 9.32266 0.775883 9.49727C0.775394 9.67188 0.820634 9.84358 0.907102 9.99527C0.993569 10.147 1.11825 10.2734 1.26874 10.3619C1.41923 10.4505 1.59029 10.4981 1.76489 10.5H10.2349C10.4095 10.4981 10.5805 10.4505 10.731 10.3619C10.8815 10.2734 11.0062 10.147 11.0927 9.99527C11.1791 9.84358 11.2244 9.67188 11.2239 9.49727C11.2234 9.32266 11.1772 9.15122 11.0899 9.00001L6.85489 1.93001C6.76575 1.78306 6.64025 1.66157 6.49049 1.57725C6.34072 1.49293 6.17176 1.44864 5.99989 1.44864C5.82802 1.44864 5.65905 1.49293 5.50929 1.57725C5.35953 1.66157 5.23402 1.78306 5.14489 1.93001Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Sv)
          ]),
          d[1] || (d[1] = y("defs", null, [
            y("clipPath", { id: "clip0_216_1715" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", _v, [
          y("path", {
            d: "M8 6.00001V8.66668M8 11.3333H8.00667M6.86 2.57335L1.21333 12C1.09691 12.2016 1.03531 12.4302 1.03466 12.663C1.03401 12.8958 1.09433 13.1248 1.20962 13.327C1.32491 13.5293 1.49115 13.6978 1.6918 13.8159C1.89246 13.934 2.12053 13.9975 2.35333 14H13.6467C13.8795 13.9975 14.1075 13.934 14.3082 13.8159C14.5088 13.6978 14.6751 13.5293 14.7904 13.327C14.9057 13.1248 14.966 12.8958 14.9653 12.663C14.9647 12.4302 14.9031 12.2016 14.7867 12L9.14 2.57335C9.02115 2.37742 8.85381 2.21543 8.65413 2.103C8.45444 1.99058 8.22915 1.93152 8 1.93152C7.77084 1.93152 7.54555 1.99058 7.34587 2.103C7.14618 2.21543 6.97885 2.37742 6.86 2.57335Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Ev)
        ]))
      ], 64)) : _("", !0),
      n.icon === "align-right" ? (v(), C("svg", Ov, [
        y("path", {
          d: "M14 14V2M2 8H11.3333M11.3333 8L6.66667 3.33333M11.3333 8L6.66667 12.6667",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Tv)
      ])) : _("", !0),
      n.icon === "archive" ? (v(), C("svg", Av, [
        y("path", {
          d: "M2.66667 5.33106C2.55733 5.32824 2.47793 5.32191 2.40655 5.30771C1.87763 5.2025 1.46416 4.78904 1.35896 4.26012C1.33334 4.13132 1.33334 3.97644 1.33334 3.66667C1.33334 3.3569 1.33334 3.20201 1.35896 3.07321C1.46416 2.54429 1.87763 2.13083 2.40655 2.02562C2.53535 2 2.69023 2 3 2H13C13.3098 2 13.4647 2 13.5935 2.02562C14.1224 2.13083 14.5358 2.54429 14.641 3.07321C14.6667 3.20201 14.6667 3.3569 14.6667 3.66667C14.6667 3.97644 14.6667 4.13132 14.641 4.26012C14.5358 4.78904 14.1224 5.2025 13.5935 5.30771C13.5221 5.32191 13.4427 5.32824 13.3333 5.33106M6.66667 8.66667H9.33334M2.66667 5.33333H13.3333V10.8C13.3333 11.9201 13.3333 12.4802 13.1153 12.908C12.9236 13.2843 12.6176 13.5903 12.2413 13.782C11.8135 14 11.2534 14 10.1333 14H5.86667C4.74656 14 4.18651 14 3.75869 13.782C3.38236 13.5903 3.0764 13.2843 2.88466 12.908C2.66667 12.4802 2.66667 11.9201 2.66667 10.8V5.33333Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Iv)
      ])) : _("", !0),
      n.icon === "arrow-circle-broken-right" ? (v(), C("svg", Dv, [
        y("g", Nv, [
          y("path", {
            d: "M2.22526 4.66668C3.37796 2.67401 5.53244 1.33334 8.00005 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00005 14.6667C5.53244 14.6667 3.37796 13.326 2.22526 11.3333M8 10.6667L10.6667 8.00001M10.6667 8.00001L8 5.33334M10.6667 8.00001H1.33334",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Pv)
        ]),
        d[2] || (d[2] = y("defs", null, [
          y("clipPath", { id: "clip0_1284_4541" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "arrow-down" ? (v(), C("svg", Lv, [
        y("path", {
          d: "M8 3.33334V12.6667M8 12.6667L12.6667 8.00001M8 12.6667L3.33334 8.00001",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Rv)
      ])) : _("", !0),
      n.icon === "arrow-down-right" ? (v(), C("svg", Fv, [
        y("path", {
          d: "M4.66666 4.66666L11.3333 11.3333M11.3333 11.3333V4.66666M11.3333 11.3333H4.66666",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Bv)
      ])) : _("", !0),
      n.icon === "arrow-left" ? (v(), C("svg", Vv, [
        y("path", {
          d: "M12.6667 7.99998H3.33334M3.33334 7.99998L8 12.6666M3.33334 7.99998L8 3.33331",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, zv)
      ])) : _("", !0),
      n.icon === "arrow-right" ? (v(), C(re, { key: 8 }, [
        n.size === 14 ? (v(), C("svg", Hv, [
          y("path", {
            d: "M2.91663 6.99999H11.0833M11.0833 6.99999L6.99996 2.91666M11.0833 6.99999L6.99996 11.0833",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, jv)
        ])) : (v(), C("svg", Wv, [
          y("path", {
            d: "M3.33334 7.99998H12.6667M12.6667 7.99998L8 3.33331M12.6667 7.99998L8 12.6666",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Uv)
        ]))
      ], 64)) : _("", !0),
      n.icon === "arrow-up" ? (v(), C("svg", Kv, [
        y("path", {
          d: "M8 12.6666V3.33331M8 3.33331L3.33334 7.99998M8 3.33331L12.6667 7.99998",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Gv)
      ])) : _("", !0),
      n.icon === "arrow-up-right" ? (v(), C("svg", Yv, [
        y("path", {
          d: "M4.66666 11.3334L11.3333 4.66669M11.3333 4.66669H4.66666M11.3333 4.66669V11.3334",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, qv)
      ])) : _("", !0),
      n.icon === "award" ? (v(), C("svg", Zv, [
        y("path", {
          d: "M5.726 10.0044L5 14L8 12.6842L11 14L10.274 10M12 6C12 8.20914 10.2091 10 8 10C5.79086 10 4 8.20914 4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Jv)
      ])) : _("", !0),
      n.icon === "bell" ? (v(), C(re, { key: 12 }, [
        n.size === 12 ? (v(), C("svg", Xv, [
          y("g", Qv, [
            y("path", {
              d: "M4.67698 10.5C5.02954 10.8112 5.49266 11 5.99989 11C6.50711 11 6.97023 10.8112 7.3228 10.5M8.99989 4C8.99989 3.20435 8.68382 2.44129 8.12121 1.87868C7.5586 1.31607 6.79554 1 5.99989 1C5.20424 1 4.44118 1.31607 3.87857 1.87868C3.31596 2.44129 2.99989 3.20435 2.99989 4C2.99989 5.54509 2.61012 6.60298 2.17472 7.30271C1.80745 7.89294 1.62382 8.18805 1.63055 8.27038C1.63801 8.36154 1.65732 8.3963 1.73078 8.45079C1.79712 8.5 2.09618 8.5 2.69431 8.5H9.30546C9.90359 8.5 10.2027 8.5 10.269 8.45079C10.3425 8.3963 10.3618 8.36154 10.3692 8.27038C10.376 8.18805 10.1923 7.89294 9.82506 7.30271C9.38965 6.60298 8.99989 5.54509 8.99989 4Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, eb)
          ]),
          d[3] || (d[3] = y("defs", null, [
            y("clipPath", { id: "clip0_216_1635" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", tb, [
          y("path", {
            d: "M6.23612 14C6.70621 14.4149 7.3237 14.6666 8 14.6666C8.6763 14.6666 9.2938 14.4149 9.76389 14M12 5.33331C12 4.27245 11.5786 3.25503 10.8284 2.50489C10.0783 1.75474 9.06087 1.33331 8 1.33331C6.93914 1.33331 5.92172 1.75474 5.17158 2.50489C4.42143 3.25503 4 4.27245 4 5.33331C4 7.39344 3.48032 8.80395 2.89978 9.73692C2.41009 10.5239 2.16524 10.9174 2.17422 11.0272C2.18416 11.1487 2.20991 11.195 2.30785 11.2677C2.39631 11.3333 2.79506 11.3333 3.59257 11.3333H12.4074C13.2049 11.3333 13.6037 11.3333 13.6922 11.2677C13.7901 11.195 13.8158 11.1487 13.8258 11.0272C13.8348 10.9174 13.5899 10.5239 13.1002 9.73692C12.5197 8.80395 12 7.39344 12 5.33331Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, nb)
        ]))
      ], 64)) : _("", !0),
      n.icon === "bookmark" ? (v(), C("svg", ob, [
        y("path", {
          d: "M12.6667 14L8 10.6667L3.33334 14V3.33333C3.33334 2.97971 3.47381 2.64057 3.72386 2.39052C3.97391 2.14048 4.31305 2 4.66667 2H11.3333C11.687 2 12.0261 2.14048 12.2761 2.39052C12.5262 2.64057 12.6667 2.97971 12.6667 3.33333V14Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ib)
      ])) : _("", !0),
      n.icon === "calendar" ? (v(), C(re, { key: 14 }, [
        n.size === 12 ? (v(), C("svg", rb, [
          y("g", sb, [
            y("path", {
              d: "M8 1V3M4 1V3M1.5 5H10.5M2.5 2H9.5C10.0523 2 10.5 2.44772 10.5 3V10C10.5 10.5523 10.0523 11 9.5 11H2.5C1.94772 11 1.5 10.5523 1.5 10V3C1.5 2.44772 1.94772 2 2.5 2Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, ab)
          ]),
          d[4] || (d[4] = y("defs", null, [
            y("clipPath", { id: "clip0_420_4795" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", lb, [
          y("path", {
            d: "M10.6667 1.33331V3.99998M5.33333 1.33331V3.99998M2 6.66665H14M3.33333 2.66665H12.6667C13.403 2.66665 14 3.2636 14 3.99998V13.3333C14 14.0697 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0697 2 13.3333V3.99998C2 3.2636 2.59695 2.66665 3.33333 2.66665Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, db)
        ]))
      ], 64)) : _("", !0),
      n.icon === "check" ? (v(), C(re, { key: 15 }, [
        n.size === 12 ? (v(), C("svg", ub, [
          y("path", {
            d: "M13.3333 4L6 11.3333L2.66666 8",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, cb)
        ])) : (v(), C("svg", fb, [
          y("path", {
            d: "M13.3333 4L6 11.3333L2.66666 8",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, hb)
        ]))
      ], 64)) : _("", !0),
      n.icon === "check-circle" ? (v(), C(re, { key: 16 }, [
        n.size === 12 ? (v(), C("svg", pb, [
          y("g", mb, [
            y("path", {
              d: "M11 5.53999V5.99999C10.9994 7.0782 10.6503 8.12733 10.0047 8.99091C9.35908 9.85448 8.45164 10.4862 7.41768 10.7919C6.38372 11.0977 5.27863 11.0609 4.26723 10.6873C3.25584 10.3136 2.39233 9.62304 1.80548 8.71853C1.21863 7.81401 0.939896 6.74403 1.01084 5.66815C1.08178 4.59228 1.4986 3.56816 2.19914 2.74853C2.89968 1.9289 3.84639 1.35768 4.89809 1.12007C5.9498 0.882448 7.05013 0.991162 8.035 1.42999M11 1.99999L6 7.00499L4.5 5.50499",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, gb)
          ]),
          d[5] || (d[5] = y("defs", null, [
            y("clipPath", { id: "clip0_216_305" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : n.size === 24 ? (v(), C("svg", vb, [
          y("path", {
            d: "M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, bb)
        ])) : (v(), C("svg", yb, [
          y("g", xb, [
            y("path", {
              d: "M14.6667 7.38668V8.00001C14.6658 9.43763 14.2003 10.8365 13.3396 11.9879C12.4788 13.1393 11.2689 13.9817 9.89023 14.3893C8.51162 14.7969 7.03817 14.7479 5.68964 14.2497C4.34112 13.7515 3.18976 12.8307 2.4073 11.6247C1.62484 10.4187 1.25319 8.99205 1.34778 7.55755C1.44237 6.12305 1.99813 4.75756 2.93218 3.66473C3.86623 2.57189 5.12852 1.81027 6.53079 1.49344C7.93306 1.17662 9.40017 1.32157 10.7133 1.90668M14.6667 2.66668L8 9.34001L6 7.34001",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Cb)
          ]),
          d[6] || (d[6] = y("defs", null, [
            y("clipPath", { id: "clip0_29_265" }, [
              y("rect", {
                width: "16",
                height: "16",
                fill: "white"
              })
            ])
          ], -1))
        ]))
      ], 64)) : _("", !0),
      n.icon === "chevron-down" ? (v(), C("svg", wb, [
        y("path", {
          d: "M4 6L8 10L12 6",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, kb)
      ])) : _("", !0),
      n.icon === "chevron-left" ? (v(), C(re, { key: 18 }, [
        n.size === 24 ? (v(), C("svg", $b, [
          y("path", {
            d: "M15 18L9 12L15 6",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Mb)
        ])) : (v(), C("svg", Sb, [
          y("path", {
            d: "M10 12L6 8L10 4",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _b)
        ]))
      ], 64)) : _("", !0),
      n.icon === "chevron-right" ? (v(), C("svg", Eb, [
        y("path", {
          d: "M6 12L10 8L6 4",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Ob)
      ])) : _("", !0),
      n.icon === "chevron-up" ? (v(), C("svg", Tb, [
        y("path", {
          d: "M12 10L8 6L4 10",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Ab)
      ])) : _("", !0),
      n.icon === "chevron-selector-vertical" ? (v(), C("svg", Ib, [
        y("path", {
          d: "M4.66666 9.99999L7.99999 13.3333L11.3333 9.99999M4.66666 5.99999L7.99999 2.66666L11.3333 5.99999",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Db)
      ])) : _("", !0),
      n.icon === "clipboard" ? (v(), C("svg", Nb, [
        y("path", {
          d: "M10.6667 2.66668H12C12.3536 2.66668 12.6928 2.80715 12.9428 3.0572C13.1928 3.30725 13.3333 3.64639 13.3333 4.00001V13.3333C13.3333 13.687 13.1928 14.0261 12.9428 14.2762C12.6928 14.5262 12.3536 14.6667 12 14.6667H3.99999C3.64637 14.6667 3.30723 14.5262 3.05718 14.2762C2.80713 14.0261 2.66666 13.687 2.66666 13.3333V4.00001C2.66666 3.64639 2.80713 3.30725 3.05718 3.0572C3.30723 2.80715 3.64637 2.66668 3.99999 2.66668H5.33332M5.99999 1.33334H9.99999C10.3682 1.33334 10.6667 1.63182 10.6667 2.00001V3.33334C10.6667 3.70153 10.3682 4.00001 9.99999 4.00001H5.99999C5.6318 4.00001 5.33332 3.70153 5.33332 3.33334V2.00001C5.33332 1.63182 5.6318 1.33334 5.99999 1.33334Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Pb)
      ])) : _("", !0),
      n.icon === "clock" ? (v(), C("svg", Lb, [
        y("g", Rb, [
          y("path", {
            d: "M8.00001 4.00001V8.00001L10.6667 9.33334M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.31811 1.33334 8.00001 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Fb)
        ]),
        d[7] || (d[7] = y("defs", null, [
          y("clipPath", { id: "clip0_14_151" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "close" ? (v(), C(re, { key: 24 }, [
        n.size === 12 ? (v(), C("svg", Bb, [
          y("path", {
            d: "M9 3L3 9M3 3L9 9",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Vb)
        ])) : n.size === 24 ? (v(), C("svg", zb, [
          y("path", {
            d: "M18 6L6 18M6 6L18 18",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Hb)
        ])) : (v(), C("svg", jb, [
          y("path", {
            d: "M12 4L4 12M4 4L12 12",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Wb)
        ]))
      ], 64)) : _("", !0),
      n.icon === "close-circle" ? (v(), C(re, { key: 25 }, [
        n.size === 12 ? (v(), C("svg", Ub, [
          y("g", Kb, [
            y("path", {
              d: "M7.5 4.5L4.5 7.5M4.5 4.5L7.5 7.5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z",
              stroke: r.value,
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Gb)
          ]),
          d[8] || (d[8] = y("defs", null, [
            y("clipPath", { id: "clip0_623_6932" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", Yb, [
          y("g", qb, [
            y("path", {
              d: "M10 6.00001L6.00001 10M6.00001 6.00001L10 10M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.31811 1.33334 8.00001 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Zb)
          ]),
          d[9] || (d[9] = y("defs", null, [
            y("clipPath", { id: "clip0_1278_4537" }, [
              y("rect", {
                width: "16",
                height: "16",
                fill: "white"
              })
            ])
          ], -1))
        ]))
      ], 64)) : _("", !0),
      n.icon === "code-01" ? (v(), C("svg", Jb, [
        y("path", {
          d: "M10.6667 12L14.6667 8L10.6667 4M5.33334 4L1.33334 8L5.33334 12",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Xb)
      ])) : _("", !0),
      n.icon === "copy" ? (v(), C("svg", Qb, [
        y("g", e8, [
          y("path", {
            d: "M3.33334 9.99998C2.71209 9.99998 2.40146 9.99998 2.15643 9.89849C1.82973 9.76316 1.57016 9.50359 1.43484 9.17689C1.33334 8.93186 1.33334 8.62123 1.33334 7.99998V3.46665C1.33334 2.71991 1.33334 2.34654 1.47867 2.06133C1.6065 1.81044 1.81047 1.60647 2.06136 1.47864C2.34657 1.33331 2.71994 1.33331 3.46668 1.33331H8.00001C8.62126 1.33331 8.93189 1.33331 9.17692 1.43481C9.50362 1.57013 9.76319 1.8297 9.89852 2.1564C10 2.40143 10 2.71206 10 3.33331M8.13334 14.6666H12.5333C13.2801 14.6666 13.6534 14.6666 13.9387 14.5213C14.1895 14.3935 14.3935 14.1895 14.5214 13.9386C14.6667 13.6534 14.6667 13.28 14.6667 12.5333V8.13331C14.6667 7.38658 14.6667 7.01321 14.5214 6.72799C14.3935 6.47711 14.1895 6.27314 13.9387 6.1453C13.6534 5.99998 13.2801 5.99998 12.5333 5.99998H8.13334C7.38661 5.99998 7.01324 5.99998 6.72802 6.1453C6.47714 6.27314 6.27317 6.47711 6.14533 6.72799C6.00001 7.01321 6.00001 7.38658 6.00001 8.13331V12.5333C6.00001 13.28 6.00001 13.6534 6.14533 13.9386C6.27317 14.1895 6.47714 14.3935 6.72802 14.5213C7.01324 14.6666 7.38661 14.6666 8.13334 14.6666Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, t8)
        ]),
        d[10] || (d[10] = y("defs", null, [
          y("clipPath", { id: "clip0_1028_3519" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "database" ? (v(), C("svg", n8, [
        y("path", {
          d: "M14 3.33331C14 4.43788 11.3137 5.33331 8 5.33331C4.68629 5.33331 2 4.43788 2 3.33331M14 3.33331C14 2.22874 11.3137 1.33331 8 1.33331C4.68629 1.33331 2 2.22874 2 3.33331M14 3.33331V12.6666C14 13.7733 11.3333 14.6666 8 14.6666C4.66667 14.6666 2 13.7733 2 12.6666V3.33331M14 7.99998C14 9.10665 11.3333 9.99998 8 9.99998C4.66667 9.99998 2 9.10665 2 7.99998",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, o8)
      ])) : _("", !0),
      n.icon === "dataflow" ? (v(), C("svg", i8, [
        y("path", {
          d: "M11.3333 13.3333H11.2C10.0799 13.3333 9.51984 13.3333 9.09202 13.1153C8.71569 12.9236 8.40973 12.6176 8.21799 12.2413C8 11.8135 8 11.2534 8 10.1333V5.86665C8 4.74654 8 4.18649 8.21799 3.75867C8.40973 3.38234 8.71569 3.07638 9.09202 2.88463C9.51984 2.66665 10.0799 2.66665 11.2 2.66665H11.3333M11.3333 13.3333C11.3333 14.0697 11.9303 14.6666 12.6667 14.6666C13.403 14.6666 14 14.0697 14 13.3333C14 12.5969 13.403 12 12.6667 12C11.9303 12 11.3333 12.5969 11.3333 13.3333ZM11.3333 2.66665C11.3333 3.40303 11.9303 3.99998 12.6667 3.99998C13.403 3.99998 14 3.40303 14 2.66665C14 1.93027 13.403 1.33331 12.6667 1.33331C11.9303 1.33331 11.3333 1.93027 11.3333 2.66665ZM4.66667 7.99998L11.3333 7.99998M4.66667 7.99998C4.66667 8.73636 4.06971 9.33331 3.33333 9.33331C2.59695 9.33331 2 8.73636 2 7.99998C2 7.2636 2.59695 6.66665 3.33333 6.66665C4.06971 6.66665 4.66667 7.2636 4.66667 7.99998ZM11.3333 7.99998C11.3333 8.73636 11.9303 9.33331 12.6667 9.33331C13.403 9.33331 14 8.73636 14 7.99998C14 7.2636 13.403 6.66665 12.6667 6.66665C11.9303 6.66665 11.3333 7.2636 11.3333 7.99998Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, r8)
      ])) : _("", !0),
      n.icon === "download" ? (v(), C("svg", s8, [
        y("path", {
          d: "M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M4.66667 6.66667L8 10M8 10L11.3333 6.66667M8 10L8 2",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, a8)
      ])) : _("", !0),
      n.icon === "edit" ? (v(), C("svg", l8, [
        y("path", {
          d: "M8 13.3333H14M11 2.33334C11.2652 2.06813 11.6249 1.91913 12 1.91913C12.1857 1.91913 12.3696 1.95571 12.5412 2.02678C12.7128 2.09785 12.8687 2.20202 13 2.33334C13.1313 2.46466 13.2355 2.62057 13.3066 2.79215C13.3776 2.96373 13.4142 3.14762 13.4142 3.33334C13.4142 3.51906 13.3776 3.70296 13.3066 3.87454C13.2355 4.04612 13.1313 4.20202 13 4.33334L4.66667 12.6667L2 13.3333L2.66667 10.6667L11 2.33334Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, d8)
      ])) : _("", !0),
      n.icon === "edit-02" ? (v(), C("svg", u8, [
        y("g", c8, [
          y("path", {
            d: "M7.33334 2.66666H4.53334C3.41324 2.66666 2.85319 2.66666 2.42536 2.88464C2.04904 3.07639 1.74308 3.38235 1.55133 3.75867C1.33334 4.1865 1.33334 4.74655 1.33334 5.86666V11.4667C1.33334 12.5868 1.33334 13.1468 1.55133 13.5746C1.74308 13.951 2.04904 14.2569 2.42536 14.4487C2.85319 14.6667 3.41324 14.6667 4.53334 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1154 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.33333 10.6667H6.44969C6.77581 10.6667 6.93887 10.6667 7.09232 10.6298C7.22837 10.5972 7.35843 10.5433 7.47772 10.4702C7.61228 10.3877 7.72758 10.2724 7.95818 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.7811 1.11437 12.8856 1.11437 12.3333 1.66665L5.95817 8.04182C5.72756 8.27242 5.61226 8.38772 5.52981 8.52228C5.4567 8.64157 5.40283 8.77163 5.37017 8.90768C5.33333 9.06113 5.33333 9.22419 5.33333 9.55031V10.6667Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, f8)
        ]),
        d[11] || (d[11] = y("defs", null, [
          y("clipPath", { id: "clip0_935_3470" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "equal" ? (v(), C("svg", h8, [
        y("path", {
          d: "M3.33334 6H12.6667M3.33334 10H12.6667",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, p8)
      ])) : _("", !0),
      n.icon === "eye" ? (v(), C("svg", m8, [
        y("path", {
          d: "M1.61342 8.47543C1.52262 8.33167 1.47723 8.25979 1.45182 8.14892C1.43273 8.06565 1.43273 7.93431 1.45182 7.85104C1.47723 7.74017 1.52262 7.66829 1.61341 7.52453C2.36369 6.33654 4.59693 3.33331 8.00027 3.33331C11.4036 3.33331 13.6369 6.33654 14.3871 7.52453C14.4779 7.66829 14.5233 7.74017 14.5487 7.85104C14.5678 7.93431 14.5678 8.06565 14.5487 8.14892C14.5233 8.25979 14.4779 8.33167 14.3871 8.47543C13.6369 9.66342 11.4036 12.6666 8.00027 12.6666C4.59693 12.6666 2.36369 9.66342 1.61342 8.47543Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, g8),
        y("path", {
          d: "M8.00027 9.99998C9.10484 9.99998 10.0003 9.10455 10.0003 7.99998C10.0003 6.89541 9.10484 5.99998 8.00027 5.99998C6.8957 5.99998 6.00027 6.89541 6.00027 7.99998C6.00027 9.10455 6.8957 9.99998 8.00027 9.99998Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, v8)
      ])) : _("", !0),
      n.icon === "file-attachment" ? (v(), C("svg", b8, [
        y("path", {
          d: "M13.3333 4.66665V4.53331C13.3333 3.41321 13.3333 2.85316 13.1153 2.42533C12.9236 2.04901 12.6176 1.74305 12.2413 1.5513C11.8135 1.33331 11.2534 1.33331 10.1333 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74655 14.6666 5.86666 14.6666H8.33332M12 12V8.33331C12 7.78103 12.4477 7.33331 13 7.33331C13.5523 7.33331 14 7.78103 14 8.33331V12C14 13.1045 13.1046 14 12 14C10.8954 14 9.99999 13.1045 9.99999 12V9.33331",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, y8)
      ])) : _("", !0),
      n.icon === "file-check" ? (v(), C("svg", x8, [
        y("path", {
          d: "M9.33332 1.513V4.26669C9.33332 4.64006 9.33332 4.82675 9.40599 4.96935C9.4699 5.0948 9.57189 5.19678 9.69733 5.2607C9.83994 5.33336 10.0266 5.33336 10.4 5.33336H13.1537M5.99999 10.6666L7.33332 12L10.3333 8.99998M9.33332 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74655 14.6666 5.86666 14.6666H10.1333C11.2534 14.6666 11.8135 14.6666 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1153 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4666V5.33331L9.33332 1.33331Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, C8)
      ])) : _("", !0),
      n.icon === "file-text" ? (v(), C("svg", w8, [
        y("path", {
          d: "M9.33332 1.33331H3.99999C3.64637 1.33331 3.30723 1.47379 3.05718 1.72384C2.80713 1.97389 2.66666 2.31302 2.66666 2.66665V13.3333C2.66666 13.6869 2.80713 14.0261 3.05718 14.2761C3.30723 14.5262 3.64637 14.6666 3.99999 14.6666H12C12.3536 14.6666 12.6928 14.5262 12.9428 14.2761C13.1928 14.0261 13.3333 13.6869 13.3333 13.3333V5.33331M9.33332 1.33331L13.3333 5.33331M9.33332 1.33331L9.33332 5.33331L13.3333 5.33331M10.6667 8.66665H5.33332M10.6667 11.3333H5.33332M6.66666 5.99998H5.33332",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, k8)
      ])) : _("", !0),
      n.icon === "file-plus" ? (v(), C("svg", $8, [
        y("path", {
          d: "M13.3333 6.99998V4.53331C13.3333 3.41321 13.3333 2.85316 13.1153 2.42533C12.9236 2.04901 12.6176 1.74305 12.2413 1.5513C11.8135 1.33331 11.2534 1.33331 10.1333 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74655 14.6666 5.86666 14.6666H7.99999M9.33332 7.33331H5.33332M6.66666 9.99998H5.33332M10.6667 4.66665H5.33332M12 14V12M12 12V9.99998M12 12H9.99999M12 12H14",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, M8)
      ])) : _("", !0),
      n.icon === "file-upload" ? (v(), C(re, { key: 39 }, [
        n.size === 20 ? (v(), C("svg", S8, [
          y("path", {
            d: "M16.6667 10.4167V5.66666C16.6667 4.26653 16.6667 3.56646 16.3942 3.03168C16.1545 2.56128 15.7721 2.17882 15.3017 1.93914C14.7669 1.66666 14.0668 1.66666 12.6667 1.66666H7.33334C5.93321 1.66666 5.23315 1.66666 4.69837 1.93914C4.22796 2.17882 3.84551 2.56128 3.60583 3.03168C3.33334 3.56646 3.33334 4.26653 3.33334 5.66666V14.3333C3.33334 15.7335 3.33334 16.4335 3.60583 16.9683C3.84551 17.4387 4.22796 17.8212 4.69837 18.0608C5.23315 18.3333 5.93317 18.3333 7.33323 18.3333H10.4167M11.6667 9.16666H6.66668M8.33334 12.5H6.66668M13.3333 5.83332H6.66668M12.5 15.8333L15 18.3333M15 18.3333L17.5 15.8333M15 18.3333V13.3333",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _8)
        ])) : (v(), C("svg", E8, [
          y("path", {
            d: "M13.3333 8.33331V4.53331C13.3333 3.41321 13.3333 2.85316 13.1153 2.42533C12.9236 2.04901 12.6176 1.74305 12.2413 1.5513C11.8135 1.33331 11.2534 1.33331 10.1333 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74652 14.6666 5.86656 14.6666H8.33332M9.33332 7.33331H5.33332M6.66666 9.99998H5.33332M10.6667 4.66665H5.33332M9.99999 12.6666L12 14.6666M12 14.6666L14 12.6666M12 14.6666V10.6666",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, O8)
        ]))
      ], 64)) : _("", !0),
      n.icon === "flag" ? (v(), C(re, { key: 40 }, [
        n.size === 12 ? (v(), C("svg", T8, [
          y("path", {
            d: "M2 7.5C2 7.5 2.5 7 4 7C5.5 7 6.5 8 8 8C9.5 8 10 7.5 10 7.5V1.5C10 1.5 9.5 2 8 2C6.5 2 5.5 1 4 1C2.5 1 2 1.5 2 1.5V7.5ZM2 7.5V11",
            stroke: r.value,
            "stroke-width": "1.33",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, A8)
        ])) : n.size === 24 ? (v(), C("svg", I8, [
          y("path", {
            d: "M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, D8)
        ])) : (v(), C("svg", N8, [
          y("path", {
            d: "M2.66669 10C2.66669 10 3.33335 9.33334 5.33335 9.33334C7.33335 9.33334 8.66669 10.6667 10.6667 10.6667C12.6667 10.6667 13.3334 10 13.3334 10V2.00001C13.3334 2.00001 12.6667 2.66668 10.6667 2.66668C8.66669 2.66668 7.33335 1.33334 5.33335 1.33334C3.33335 1.33334 2.66669 2.00001 2.66669 2.00001V10ZM2.66669 10V14.6667",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, P8)
        ]))
      ], 64)) : _("", !0),
      n.icon === "gift" ? (v(), C("svg", L8, [
        y("g", R8, [
          y("path", {
            d: "M13.3333 8.00001V14.6667H2.66665V8.00001M7.99998 14.6667V4.66668M7.99998 4.66668H4.99998C4.55795 4.66668 4.13403 4.49108 3.82147 4.17852C3.50891 3.86596 3.33331 3.44204 3.33331 3.00001C3.33331 2.55798 3.50891 2.13406 3.82147 1.8215C4.13403 1.50894 4.55795 1.33334 4.99998 1.33334C7.33331 1.33334 7.99998 4.66668 7.99998 4.66668ZM7.99998 4.66668H11C11.442 4.66668 11.8659 4.49108 12.1785 4.17852C12.4911 3.86596 12.6666 3.44204 12.6666 3.00001C12.6666 2.55798 12.4911 2.13406 12.1785 1.8215C11.8659 1.50894 11.442 1.33334 11 1.33334C8.66665 1.33334 7.99998 4.66668 7.99998 4.66668ZM1.33331 4.66668H14.6666V8.00001H1.33331V4.66668Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, F8)
        ]),
        d[12] || (d[12] = y("defs", null, [
          y("clipPath", { id: "clip0_274_1881" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "heart" ? (v(), C("svg", B8, [
        y("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.99541 3.42388C6.66251 1.8656 4.43981 1.44643 2.76978 2.87334C1.09974 4.30026 0.864625 6.68598 2.17611 8.3736C3.26652 9.77674 6.56649 12.7361 7.64805 13.6939C7.76905 13.801 7.82955 13.8546 7.90012 13.8757C7.96172 13.8941 8.02911 13.8941 8.09071 13.8757C8.16128 13.8546 8.22178 13.801 8.34278 13.6939C9.42433 12.7361 12.7243 9.77674 13.8147 8.3736C15.1262 6.68598 14.9198 4.28525 13.221 2.87334C11.5223 1.46144 9.32832 1.8656 7.99541 3.42388Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, V8)
      ])) : _("", !0),
      n.icon === "heart-filled" ? (v(), C("svg", z8, [...d[13] || (d[13] = [
        y("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.99541 3.42388C6.66251 1.8656 4.43981 1.44643 2.76978 2.87334C1.09974 4.30026 0.864625 6.68598 2.17611 8.3736C3.26652 9.77674 6.56649 12.7361 7.64805 13.6939C7.76905 13.801 7.82955 13.8546 7.90012 13.8757C7.96172 13.8941 8.02911 13.8941 8.09071 13.8757C8.16128 13.8546 8.22178 13.801 8.34278 13.6939C9.42433 12.7361 12.7243 9.77674 13.8147 8.3736C15.1262 6.68598 14.9198 4.28525 13.221 2.87334C11.5223 1.46144 9.32832 1.8656 7.99541 3.42388Z",
          fill: "#D92D20",
          stroke: "#D92D20",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])])) : _("", !0),
      n.icon === "help-circle" ? (v(), C("svg", H8, [
        y("g", j8, [
          y("path", {
            d: "M6.05998 6.00001C6.21672 5.55446 6.52608 5.17875 6.93328 4.93943C7.34048 4.70012 7.81924 4.61264 8.28476 4.69248C8.75028 4.77233 9.17252 5.01436 9.4767 5.3757C9.78087 5.73703 9.94735 6.19436 9.94665 6.66668C9.94665 8.00001 7.94665 8.66668 7.94665 8.66668M7.99998 11.3333H8.00665M14.6666 8.00001C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00001C1.33331 4.31811 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.31811 14.6666 8.00001Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, W8)
        ]),
        d[14] || (d[14] = y("defs", null, [
          y("clipPath", { id: "clip0_733_3458" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "hourglass" ? (v(), C("svg", U8, [
        y("path", {
          d: "M5.99998 12.3333H9.99998M4.39998 1.33334H11.6C11.9733 1.33334 12.16 1.33334 12.3026 1.40601C12.4281 1.46992 12.5301 1.57191 12.594 1.69735C12.6666 1.83996 12.6666 2.02664 12.6666 2.40001V3.78302C12.6666 4.10914 12.6666 4.2722 12.6298 4.42565C12.5971 4.5617 12.5433 4.69176 12.4702 4.81106C12.3877 4.94561 12.2724 5.06091 12.0418 5.29151L10.0876 7.24576C9.82355 7.50977 9.69154 7.64178 9.64208 7.794C9.59858 7.92789 9.59858 8.07213 9.64208 8.20602C9.69154 8.35824 9.82355 8.49025 10.0876 8.75426L12.0418 10.7085C12.2724 10.9391 12.3877 11.0544 12.4702 11.189C12.5433 11.3083 12.5971 11.4383 12.6298 11.5744C12.6666 11.7278 12.6666 11.8909 12.6666 12.217V13.6C12.6666 13.9734 12.6666 14.1601 12.594 14.3027C12.5301 14.4281 12.4281 14.5301 12.3026 14.594C12.16 14.6667 11.9733 14.6667 11.6 14.6667H4.39998C4.02661 14.6667 3.83993 14.6667 3.69732 14.594C3.57188 14.5301 3.46989 14.4281 3.40598 14.3027C3.33331 14.1601 3.33331 13.9734 3.33331 13.6V12.217C3.33331 11.8909 3.33331 11.7278 3.37015 11.5744C3.40282 11.4383 3.45669 11.3083 3.52979 11.189C3.61225 11.0544 3.72755 10.9391 3.95815 10.7085L5.9124 8.75426C6.17641 8.49025 6.30842 8.35824 6.35787 8.20602C6.40138 8.07213 6.40138 7.92789 6.35787 7.794C6.30842 7.64178 6.17641 7.50977 5.9124 7.24576L3.95815 5.29151C3.72755 5.06091 3.61225 4.94561 3.52979 4.81106C3.45669 4.69176 3.40282 4.5617 3.37015 4.42565C3.33331 4.2722 3.33331 4.10914 3.33331 3.78302V2.40001C3.33331 2.02664 3.33331 1.83996 3.40598 1.69735C3.46989 1.57191 3.57188 1.46992 3.69732 1.40601C3.83993 1.33334 4.02661 1.33334 4.39998 1.33334Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, K8)
      ])) : _("", !0),
      n.icon === "image" ? (v(), C("svg", G8, [
        y("path", {
          d: "M3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14ZM3.33333 14L10.6667 6.66667L14 10M6.66667 5.66667C6.66667 6.21895 6.21895 6.66667 5.66667 6.66667C5.11438 6.66667 4.66667 6.21895 4.66667 5.66667C4.66667 5.11438 5.11438 4.66667 5.66667 4.66667C6.21895 4.66667 6.66667 5.11438 6.66667 5.66667Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Y8)
      ])) : _("", !0),
      n.icon === "inbox" ? (v(), C("svg", q8, [
        y("path", {
          d: "M14.6666 7.99999H10.6666L9.33331 9.99999H6.66665L5.33331 7.99999H1.33331M14.6666 7.99999V12C14.6666 12.3536 14.5262 12.6928 14.2761 12.9428C14.0261 13.1928 13.6869 13.3333 13.3333 13.3333H2.66665C2.31302 13.3333 1.97389 13.1928 1.72384 12.9428C1.47379 12.6928 1.33331 12.3536 1.33331 12V7.99999M14.6666 7.99999L12.3666 3.40666C12.2563 3.18451 12.0861 2.99757 11.8753 2.86684C11.6645 2.73612 11.4214 2.66679 11.1733 2.66666H4.82665C4.57859 2.66679 4.33549 2.73612 4.12468 2.86684C3.91386 2.99757 3.7437 3.18451 3.63331 3.40666L1.33331 7.99999",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Z8)
      ])) : _("", !0),
      n.icon === "info" ? (v(), C(re, { key: 48 }, [
        n.size === 14 ? (v(), C("svg", J8, [
          y("g", X8, [
            y("path", {
              d: "M7.00008 9.33332V6.99999M7.00008 4.66666H7.00591M12.8334 6.99999C12.8334 10.2216 10.2217 12.8333 7.00008 12.8333C3.77842 12.8333 1.16675 10.2216 1.16675 6.99999C1.16675 3.77833 3.77842 1.16666 7.00008 1.16666C10.2217 1.16666 12.8334 3.77833 12.8334 6.99999Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Q8)
          ]),
          d[15] || (d[15] = y("defs", null, [
            y("clipPath", { id: "clip0_185_4118" }, [
              y("rect", {
                width: "14",
                height: "14",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", e7, [
          y("g", t7, [
            y("path", {
              d: "M7.99998 10.6667V8.00001M7.99998 5.33334H8.00665M14.6666 8.00001C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00001C1.33331 4.31811 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.31811 14.6666 8.00001Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, n7)
          ]),
          d[16] || (d[16] = y("defs", null, [
            y("clipPath", { id: "clip0_20_174" }, [
              y("rect", {
                width: "16",
                height: "16",
                fill: "white"
              })
            ])
          ], -1))
        ]))
      ], 64)) : _("", !0),
      n.icon === "layers" ? (v(), C("svg", o7, [
        y("g", i7, [
          y("path", {
            d: "M1.33331 11.3333L7.99998 14.6666L14.6666 11.3333M1.33331 7.99998L7.99998 11.3333L14.6666 7.99998M7.99998 1.33331L1.33331 4.66665L7.99998 7.99998L14.6666 4.66665L7.99998 1.33331Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, r7)
        ]),
        d[17] || (d[17] = y("defs", null, [
          y("clipPath", { id: "clip0_289_2100" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "link" ? (v(), C("svg", s7, [
        y("g", a7, [
          y("path", {
            d: "M6.66668 8.66666C6.95298 9.04942 7.31825 9.36612 7.73771 9.59529C8.15717 9.82446 8.62102 9.96074 9.09778 9.99489C9.57454 10.029 10.0531 9.96024 10.5009 9.79318C10.9487 9.62613 11.3554 9.36471 11.6933 9.02666L13.6933 7.02666C14.3005 6.39799 14.6365 5.55598 14.6289 4.68199C14.6213 3.808 14.2708 2.97196 13.6527 2.35394C13.0347 1.73591 12.1987 1.38535 11.3247 1.37775C10.4507 1.37016 9.60868 1.70614 8.98001 2.31333L7.83334 3.45333M9.33334 7.33333C9.04704 6.95058 8.68177 6.63388 8.26231 6.4047C7.84285 6.17553 7.37901 6.03925 6.90224 6.00511C6.42548 5.97096 5.94695 6.03975 5.49911 6.20681C5.05127 6.37387 4.6446 6.63528 4.30668 6.97333L2.30668 8.97333C1.69948 9.602 1.3635 10.444 1.3711 11.318C1.37869 12.192 1.72926 13.028 2.34728 13.6461C2.96531 14.2641 3.80135 14.6147 4.67534 14.6222C5.54933 14.6298 6.39134 14.2939 7.02001 13.6867L8.16001 12.5467",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, l7)
        ]),
        d[18] || (d[18] = y("defs", null, [
          y("clipPath", { id: "clip0_31_222" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "lightbulb" ? (v(), C("svg", d7, [
        y("g", u7, [
          y("path", {
            d: "M6.66665 11.7724V13.3333C6.66665 14.0697 7.2636 14.6666 7.99998 14.6666C8.73636 14.6666 9.33331 14.0697 9.33331 13.3333V11.7724M7.99998 1.33331V1.99998M1.99998 7.99998H1.33331M3.66665 3.66665L3.26658 3.26658M12.3333 3.66665L12.7335 3.26658M14.6666 7.99998H14M12 7.99998C12 10.2091 10.2091 12 7.99998 12C5.79084 12 3.99998 10.2091 3.99998 7.99998C3.99998 5.79084 5.79084 3.99998 7.99998 3.99998C10.2091 3.99998 12 5.79084 12 7.99998Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, c7)
        ]),
        d[19] || (d[19] = y("defs", null, [
          y("clipPath", { id: "clip0_2326_100" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "loading" ? (v(), C(re, { key: 52 }, [
        n.size === 12 ? (v(), C("svg", f7, [
          y("g", h7, [
            y("path", {
              d: "M6 1.125V2.375M6 9V11M2.875 6H1.125M10.625 6H9.875M9.22855 9.22855L8.875 8.875M9.33211 2.70789L8.625 3.415M2.46079 9.53921L3.875 8.125M2.56434 2.60434L3.625 3.665",
              stroke: r.value,
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, p7)
          ]),
          d[20] || (d[20] = y("defs", null, [
            y("clipPath", { id: "clip0_623_6937" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", m7, [
          y("path", {
            d: "M8 1.5V3.16667M8 12V14.6667M3.83333 8H1.5M14.1667 8H13.1667M12.3047 12.3047L11.8333 11.8333M12.4428 3.61052L11.5 4.55333M3.28105 12.719L5.16667 10.8333M3.41912 3.47245L4.83333 4.88667",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, g7)
        ]))
      ], 64)) : _("", !0),
      n.icon === "log-out" ? (v(), C("svg", v7, [
        y("path", {
          d: "M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8L6 8",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, b7)
      ])) : _("", !0),
      n.icon === "mail" ? (v(), C("svg", y7, [
        y("path", {
          d: "M14.6666 4.00002C14.6666 3.26669 14.0666 2.66669 13.3333 2.66669H2.66665C1.93331 2.66669 1.33331 3.26669 1.33331 4.00002M14.6666 4.00002V12C14.6666 12.7334 14.0666 13.3334 13.3333 13.3334H2.66665C1.93331 13.3334 1.33331 12.7334 1.33331 12V4.00002M14.6666 4.00002L7.99998 8.66669L1.33331 4.00002",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, x7)
      ])) : _("", !0),
      n.icon === "menu" ? (v(), C(re, { key: 55 }, [
        n.size === 24 ? (v(), C("svg", C7, [
          y("path", {
            d: "M3 12H21M3 6H21M3 18H21",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, w7)
        ])) : (v(), C("svg", k7, [
          y("path", {
            d: "M2 8H14M2 4H14M2 12H14",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, $7)
        ]))
      ], 64)) : _("", !0),
      n.icon === "message-circle" ? (v(), C(re, { key: 56 }, [
        n.size === 14 ? (v(), C("svg", M7, [
          y("path", {
            d: "M12.25 6.70835C12.252 7.47827 12.0721 8.23778 11.725 8.92502C11.3134 9.74853 10.6807 10.4412 9.89768 10.9254C9.11467 11.4097 8.21231 11.6663 7.29167 11.6667C6.52174 11.6687 5.76223 11.4888 5.075 11.1417L1.75 12.25L2.85833 8.92502C2.51121 8.23778 2.33133 7.47827 2.33333 6.70835C2.33369 5.78771 2.59036 4.88535 3.07459 4.10234C3.55882 3.31933 4.25148 2.6866 5.075 2.27502C5.76223 1.92789 6.52174 1.74801 7.29167 1.75002H7.58333C8.7992 1.8171 9.94761 2.33029 10.8087 3.19135C11.6697 4.05241 12.1829 5.20081 12.25 6.41668V6.70835Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, S7)
        ])) : (v(), C("svg", _7, [
          y("path", {
            d: "M14 7.66669C14.0023 8.5466 13.7967 9.41461 13.4 10.2C12.9296 11.1412 12.2065 11.9328 11.3116 12.4862C10.4168 13.0396 9.3855 13.3329 8.33333 13.3334C7.45342 13.3356 6.58541 13.1301 5.8 12.7334L2 14L3.26667 10.2C2.86995 9.41461 2.66437 8.5466 2.66667 7.66669C2.66707 6.61452 2.96041 5.58325 3.51381 4.68839C4.06722 3.79352 4.85884 3.0704 5.8 2.60002C6.58541 2.20331 7.45342 1.99772 8.33333 2.00002H8.66667C10.0562 2.07668 11.3687 2.66319 12.3528 3.64726C13.3368 4.63132 13.9233 5.94379 14 7.33335V7.66669Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, E7)
        ]))
      ], 64)) : _("", !0),
      n.icon === "message-circle-02" ? (v(), C("svg", O7, [
        y("g", T7, [
          y("path", {
            d: "M4.06289 7.48584C4.02145 7.2188 3.99995 6.94522 3.99995 6.66665C3.99995 3.72113 6.40348 1.33331 9.36838 1.33331C12.3333 1.33331 14.7368 3.72113 14.7368 6.66665C14.7368 7.33203 14.6141 7.96895 14.3901 8.55632C14.3435 8.6783 14.3203 8.7393 14.3097 8.78692C14.2992 8.8341 14.2952 8.8673 14.2941 8.91561C14.2929 8.96438 14.2995 9.0181 14.3128 9.12553L14.5811 11.3057C14.6102 11.5417 14.6247 11.6597 14.5855 11.7455C14.5511 11.8206 14.49 11.8803 14.414 11.913C14.3274 11.9503 14.2097 11.933 13.9745 11.8985L11.8509 11.5873C11.7401 11.571 11.6846 11.5629 11.6341 11.5632C11.5842 11.5634 11.5496 11.5671 11.5007 11.5774C11.4513 11.5878 11.3882 11.6114 11.262 11.6587C10.6731 11.8793 10.0349 12 9.36838 12C9.08958 12 8.81575 11.9789 8.54842 11.9382M5.0877 14.6666C7.0643 14.6666 8.66665 13.025 8.66665 11C8.66665 8.97494 7.0643 7.33331 5.0877 7.33331C3.1111 7.33331 1.50875 8.97494 1.50875 11C1.50875 11.407 1.5735 11.7986 1.69301 12.1645C1.74353 12.3191 1.76879 12.3964 1.77708 12.4493C1.78574 12.5044 1.78726 12.5354 1.78403 12.5911C1.78095 12.6445 1.76759 12.7048 1.74088 12.8255L1.33331 14.6666L3.32985 14.394C3.43882 14.3791 3.49331 14.3717 3.54089 14.372C3.59099 14.3723 3.61758 14.375 3.66672 14.3848C3.71338 14.3941 3.78275 14.4186 3.92149 14.4676C4.28704 14.5966 4.67938 14.6666 5.0877 14.6666Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, A7)
        ]),
        d[21] || (d[21] = y("defs", null, [
          y("clipPath", { id: "clip0_376_2459" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "minus" ? (v(), C("svg", I7, [
        y("path", {
          d: "M3.33331 8H12.6666",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, D7)
      ])) : _("", !0),
      n.icon === "monitor" ? (v(), C("svg", N7, [
        y("path", {
          d: "M5.33331 14H10.6666M7.99998 11.3333V14M4.53331 11.3333H11.4666C12.5868 11.3333 13.1468 11.3333 13.5746 11.1153C13.951 10.9236 14.2569 10.6176 14.4487 10.2413C14.6666 9.81349 14.6666 9.25344 14.6666 8.13333V5.2C14.6666 4.0799 14.6666 3.51984 14.4487 3.09202C14.2569 2.71569 13.951 2.40973 13.5746 2.21799C13.1468 2 12.5868 2 11.4666 2H4.53331C3.41321 2 2.85316 2 2.42533 2.21799C2.04901 2.40973 1.74305 2.71569 1.5513 3.09202C1.33331 3.51984 1.33331 4.0799 1.33331 5.2V8.13333C1.33331 9.25344 1.33331 9.81349 1.5513 10.2413C1.74305 10.6176 2.04901 10.9236 2.42533 11.1153C2.85316 11.3333 3.41321 11.3333 4.53331 11.3333Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, P7)
      ])) : _("", !0),
      n.icon === "more-horizontal" ? (v(), C("svg", L7, [
        y("path", {
          d: "M8.00002 8.66665C8.36821 8.66665 8.66669 8.36817 8.66669 7.99998C8.66669 7.63179 8.36821 7.33331 8.00002 7.33331C7.63183 7.33331 7.33335 7.63179 7.33335 7.99998C7.33335 8.36817 7.63183 8.66665 8.00002 8.66665Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, R7),
        y("path", {
          d: "M12.6667 8.66665C13.0349 8.66665 13.3334 8.36817 13.3334 7.99998C13.3334 7.63179 13.0349 7.33331 12.6667 7.33331C12.2985 7.33331 12 7.63179 12 7.99998C12 8.36817 12.2985 8.66665 12.6667 8.66665Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, F7),
        y("path", {
          d: "M3.33335 8.66665C3.70154 8.66665 4.00002 8.36817 4.00002 7.99998C4.00002 7.63179 3.70154 7.33331 3.33335 7.33331C2.96516 7.33331 2.66669 7.63179 2.66669 7.99998C2.66669 8.36817 2.96516 8.66665 3.33335 8.66665Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, B7)
      ])) : _("", !0),
      n.icon === "more-vertical" ? (v(), C("svg", V7, [
        y("path", {
          d: "M7.99998 8.66669C8.36817 8.66669 8.66665 8.36821 8.66665 8.00002C8.66665 7.63183 8.36817 7.33335 7.99998 7.33335C7.63179 7.33335 7.33331 7.63183 7.33331 8.00002C7.33331 8.36821 7.63179 8.66669 7.99998 8.66669Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, z7),
        y("path", {
          d: "M7.99998 4.00002C8.36817 4.00002 8.66665 3.70154 8.66665 3.33335C8.66665 2.96516 8.36817 2.66669 7.99998 2.66669C7.63179 2.66669 7.33331 2.96516 7.33331 3.33335C7.33331 3.70154 7.63179 4.00002 7.99998 4.00002Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, H7),
        y("path", {
          d: "M7.99998 13.3334C8.36817 13.3334 8.66665 13.0349 8.66665 12.6667C8.66665 12.2985 8.36817 12 7.99998 12C7.63179 12 7.33331 12.2985 7.33331 12.6667C7.33331 13.0349 7.63179 13.3334 7.99998 13.3334Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, j7)
      ])) : _("", !0),
      n.icon === "paperclip" ? (v(), C("svg", W7, [
        y("g", U7, [
          y("path", {
            d: "M14.2934 7.36665L8.1667 13.4933C7.41613 14.2439 6.39815 14.6655 5.3367 14.6655C4.27524 14.6655 3.25726 14.2439 2.5067 13.4933C1.75613 12.7428 1.33447 11.7248 1.33447 10.6633C1.33447 9.60186 1.75613 8.58388 2.5067 7.83332L8.63336 1.70665C9.13374 1.20628 9.81239 0.925171 10.52 0.925171C11.2277 0.925171 11.9063 1.20628 12.4067 1.70665C12.9071 2.20703 13.1882 2.88568 13.1882 3.59332C13.1882 4.30096 12.9071 4.97961 12.4067 5.47999L6.27336 11.6067C6.02318 11.8568 5.68385 11.9974 5.33003 11.9974C4.97621 11.9974 4.63688 11.8568 4.3867 11.6067C4.13651 11.3565 3.99596 11.0171 3.99596 10.6633C3.99596 10.3095 4.13651 9.97018 4.3867 9.71999L10.0467 4.06665",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, K7)
        ]),
        d[22] || (d[22] = y("defs", null, [
          y("clipPath", { id: "clip0_123_362" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "passport" ? (v(), C(re, { key: 63 }, [
        n.size === 20 ? (v(), C("svg", G7, [
          y("path", {
            d: "M8.33331 13.3334H11.6666M7.33331 18.3334H12.6666C14.0668 18.3334 14.7668 18.3334 15.3016 18.0609C15.772 17.8212 16.1545 17.4387 16.3942 16.9683C16.6666 16.4336 16.6666 15.7335 16.6666 14.3334V5.66669C16.6666 4.26656 16.6666 3.56649 16.3942 3.03171C16.1545 2.56131 15.772 2.17885 15.3016 1.93917C14.7668 1.66669 14.0668 1.66669 12.6666 1.66669H7.33331C5.93318 1.66669 5.23312 1.66669 4.69834 1.93917C4.22793 2.17885 3.84548 2.56131 3.6058 3.03171C3.33331 3.56649 3.33331 4.26656 3.33331 5.66669V14.3334C3.33331 15.7335 3.33331 16.4336 3.6058 16.9683C3.84548 17.4387 4.22793 17.8212 4.69834 18.0609C5.23312 18.3334 5.93318 18.3334 7.33331 18.3334ZM12.5 7.50002C12.5 8.88073 11.3807 10 9.99998 10C8.61927 10 7.49998 8.88073 7.49998 7.50002C7.49998 6.11931 8.61927 5.00002 9.99998 5.00002C11.3807 5.00002 12.5 6.11931 12.5 7.50002Z",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Y7)
        ])) : (v(), C("svg", q7, [
          y("path", {
            d: "M6.66669 10.6666H9.33335M5.86669 14.6666H10.1334C11.2535 14.6666 11.8135 14.6666 12.2413 14.4487C12.6177 14.2569 12.9236 13.951 13.1154 13.5746C13.3334 13.1468 13.3334 12.5868 13.3334 11.4666V4.53331C13.3334 3.41321 13.3334 2.85316 13.1154 2.42533C12.9236 2.04901 12.6177 1.74305 12.2413 1.5513C11.8135 1.33331 11.2535 1.33331 10.1334 1.33331H5.86669C4.74658 1.33331 4.18653 1.33331 3.75871 1.5513C3.38238 1.74305 3.07642 2.04901 2.88467 2.42533C2.66669 2.85316 2.66669 3.41321 2.66669 4.53331V11.4666C2.66669 12.5868 2.66669 13.1468 2.88467 13.5746C3.07642 13.951 3.38238 14.2569 3.75871 14.4487C4.18653 14.6666 4.74658 14.6666 5.86669 14.6666ZM10 5.99998C10 7.10455 9.10459 7.99998 8.00002 7.99998C6.89545 7.99998 6.00002 7.10455 6.00002 5.99998C6.00002 4.89541 6.89545 3.99998 8.00002 3.99998C9.10459 3.99998 10 4.89541 10 5.99998Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Z7)
        ]))
      ], 64)) : _("", !0),
      n.icon === "pause" ? (v(), C("svg", J7, [
        y("g", X7, [
          y("path", {
            d: "M6.33331 10V6.00001M9.66665 10V6.00001M14.6666 8.00001C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00001C1.33331 4.31811 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.31811 14.6666 8.00001Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Q7)
        ]),
        d[23] || (d[23] = y("defs", null, [
          y("clipPath", { id: "clip0_1110_3523" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "phone" ? (v(), C("svg", ey, [
        y("g", ty, [
          y("path", {
            d: "M14.6666 11.28V13.28C14.6674 13.4657 14.6294 13.6495 14.555 13.8196C14.4806 13.9897 14.3715 14.1424 14.2347 14.2679C14.0979 14.3934 13.9364 14.489 13.7605 14.5485C13.5846 14.608 13.3982 14.6301 13.2133 14.6133C11.1619 14.3904 9.19131 13.6894 7.45998 12.5667C5.84919 11.5431 4.48353 10.1775 3.45998 8.56668C2.33329 6.82748 1.63214 4.84734 1.41331 2.78668C1.39665 2.60233 1.41856 2.41652 1.47764 2.2411C1.53673 2.06567 1.63169 1.90447 1.75649 1.76776C1.88128 1.63105 2.03318 1.52182 2.2025 1.44703C2.37183 1.37224 2.55487 1.33352 2.73998 1.33335H4.73998C5.06351 1.33016 5.37717 1.44473 5.62248 1.6557C5.8678 1.86667 6.02803 2.15964 6.07331 2.48001C6.15772 3.12006 6.31428 3.7485 6.53998 4.35335C6.62967 4.59196 6.64908 4.85129 6.59591 5.1006C6.54274 5.34991 6.41922 5.57875 6.23998 5.76001L5.39331 6.60668C6.34235 8.27571 7.72428 9.65764 9.39331 10.6067L10.24 9.76001C10.4212 9.58077 10.6501 9.45725 10.8994 9.40408C11.1487 9.35091 11.408 9.37032 11.6466 9.46001C12.2515 9.68571 12.8799 9.84227 13.52 9.92668C13.8438 9.97237 14.1396 10.1355 14.351 10.385C14.5624 10.6345 14.6748 10.9531 14.6666 11.28Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, ny)
        ]),
        d[24] || (d[24] = y("defs", null, [
          y("clipPath", { id: "clip0_443_3358" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "plus" ? (v(), C(re, { key: 66 }, [
        n.size === 40 ? (v(), C("svg", oy, [
          y("path", {
            d: "M7.99998 3.33334V12.6667M3.33331 8.00001H12.6666",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, iy)
        ])) : (v(), C("svg", ry, [
          y("path", {
            d: "M7.99998 3.33334V12.6667M3.33331 8.00001H12.6666",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, sy)
        ]))
      ], 64)) : _("", !0),
      n.icon === "qr-code" ? (v(), C("svg", ay, [
        y("path", {
          d: "M4.66667 8.00001H8V11.3333M2.00667 8.00001H2M5.34 11.3333H5.33333M8.00667 14H8M14.0067 8.00001H14M2 11.3333H3M10.3333 8.00001H11.6667M2 14H5.33333M8 1.33334V5.33334M11.7333 14H12.9333C13.3067 14 13.4934 14 13.636 13.9273C13.7614 13.8634 13.8634 13.7614 13.9273 13.636C14 13.4934 14 13.3067 14 12.9333V11.7333C14 11.36 14 11.1733 13.9273 11.0307C13.8634 10.9052 13.7614 10.8033 13.636 10.7393C13.4934 10.6667 13.3067 10.6667 12.9333 10.6667H11.7333C11.36 10.6667 11.1733 10.6667 11.0307 10.7393C10.9052 10.8033 10.8032 10.9052 10.7393 11.0307C10.6667 11.1733 10.6667 11.36 10.6667 11.7333V12.9333C10.6667 13.3067 10.6667 13.4934 10.7393 13.636C10.8032 13.7614 10.9052 13.8634 11.0307 13.9273C11.1733 14 11.36 14 11.7333 14ZM11.7333 5.33334H12.9333C13.3067 5.33334 13.4934 5.33334 13.636 5.26068C13.7614 5.19677 13.8634 5.09478 13.9273 4.96934C14 4.82673 14 4.64005 14 4.26668V3.06668C14 2.69331 14 2.50662 13.9273 2.36402C13.8634 2.23858 13.7614 2.13659 13.636 2.07267C13.4934 2.00001 13.3067 2.00001 12.9333 2.00001H11.7333C11.36 2.00001 11.1733 2.00001 11.0307 2.07267C10.9052 2.13659 10.8032 2.23858 10.7393 2.36402C10.6667 2.50662 10.6667 2.69331 10.6667 3.06668V4.26668C10.6667 4.64005 10.6667 4.82673 10.7393 4.96934C10.8032 5.09478 10.9052 5.19677 11.0307 5.26068C11.1733 5.33334 11.36 5.33334 11.7333 5.33334ZM3.06667 5.33334H4.26667C4.64004 5.33334 4.82672 5.33334 4.96933 5.26068C5.09477 5.19677 5.19676 5.09478 5.26067 4.96934C5.33333 4.82673 5.33333 4.64005 5.33333 4.26668V3.06668C5.33333 2.69331 5.33333 2.50662 5.26067 2.36402C5.19676 2.23858 5.09477 2.13659 4.96933 2.07267C4.82672 2.00001 4.64004 2.00001 4.26667 2.00001H3.06667C2.6933 2.00001 2.50661 2.00001 2.36401 2.07267C2.23856 2.13659 2.13658 2.23858 2.07266 2.36402C2 2.50662 2 2.69331 2 3.06668V4.26668C2 4.64005 2 4.82673 2.07266 4.96934C2.13658 5.09478 2.23856 5.19677 2.36401 5.26068C2.50661 5.33334 2.6933 5.33334 3.06667 5.33334Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ly)
      ])) : _("", !0),
      n.icon === "refresh-cw" ? (v(), C(re, { key: 68 }, [
        n.size === 12 ? (v(), C("svg", dy, [
          y("g", uy, [
            y("path", {
              d: "M10.5 5C10.5 5 9.49751 3.63411 8.68308 2.81912C7.86866 2.00413 6.7432 1.5 5.5 1.5C3.01472 1.5 1 3.51472 1 6C1 8.48528 3.01472 10.5 5.5 10.5C7.55155 10.5 9.28244 9.12714 9.82412 7.25M10.5 5V2M10.5 5H7.5",
              stroke: r.value,
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, cy)
          ]),
          d[25] || (d[25] = y("defs", null, [
            y("clipPath", { id: "clip0_409_7312" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", fy, [
          y("path", {
            d: "M14 6.66667C14 6.66667 12.6633 4.84548 11.5774 3.75883C10.4915 2.67218 8.99091 2 7.33331 2C4.0196 2 1.33331 4.68629 1.33331 8C1.33331 11.3137 4.0196 14 7.33331 14C10.0687 14 12.3766 12.1695 13.0988 9.66667M14 6.66667V2.66667M14 6.66667H9.99998",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, hy)
        ]))
      ], 64)) : _("", !0),
      n.icon === "reset" ? (v(), C("svg", py, [
        y("path", {
          d: "M1.33337 6.66667C1.33337 6.66667 2.67003 4.84548 3.75593 3.75883C4.84183 2.67218 6.34244 2 8.00004 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8.00004 14C5.26465 14 2.95678 12.1695 2.23455 9.66667M1.33337 6.66667V2.66667M1.33337 6.66667H5.33337",
          stroke: n.color ? t.value && n.hoverColor ? n.hoverColor : n.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, my)
      ])) : _("", !0),
      n.icon === "search" ? (v(), C("svg", gy, [
        y("path", {
          d: "M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, vy)
      ])) : _("", !0),
      n.icon === "settings" ? (v(), C("svg", by, [
        y("g", yy, [
          y("path", {
            d: "M8.00002 9.99999C9.10459 9.99999 10 9.10456 10 7.99999C10 6.89542 9.10459 5.99999 8.00002 5.99999C6.89545 5.99999 6.00002 6.89542 6.00002 7.99999C6.00002 9.10456 6.89545 9.99999 8.00002 9.99999Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, xy),
          y("path", {
            d: "M12.9334 9.99999C12.8446 10.2011 12.8181 10.4241 12.8574 10.6404C12.8966 10.8566 12.9997 11.0562 13.1534 11.2133L13.1934 11.2533C13.3173 11.3772 13.4157 11.5242 13.4828 11.6861C13.5499 11.8479 13.5844 12.0214 13.5844 12.1967C13.5844 12.3719 13.5499 12.5454 13.4828 12.7072C13.4157 12.8691 13.3173 13.0162 13.1934 13.14C13.0695 13.264 12.9225 13.3623 12.7606 13.4294C12.5987 13.4965 12.4252 13.531 12.25 13.531C12.0748 13.531 11.9013 13.4965 11.7394 13.4294C11.5776 13.3623 11.4305 13.264 11.3067 13.14L11.2667 13.1C11.1096 12.9463 10.91 12.8432 10.6937 12.804C10.4775 12.7648 10.2544 12.7912 10.0534 12.88C9.85617 12.9645 9.68801 13.1048 9.56956 13.2837C9.45111 13.4625 9.38754 13.6721 9.38669 13.8867V14C9.38669 14.3536 9.24621 14.6928 8.99616 14.9428C8.74611 15.1928 8.40698 15.3333 8.05335 15.3333C7.69973 15.3333 7.36059 15.1928 7.11055 14.9428C6.8605 14.6928 6.72002 14.3536 6.72002 14V13.94C6.71486 13.7193 6.64343 13.5053 6.51503 13.3258C6.38662 13.1463 6.20718 13.0095 6.00002 12.9333C5.79894 12.8446 5.57589 12.8181 5.35963 12.8573C5.14336 12.8965 4.94381 12.9996 4.78669 13.1533L4.74669 13.1933C4.62286 13.3173 4.4758 13.4156 4.31394 13.4827C4.15208 13.5498 3.97857 13.5844 3.80335 13.5844C3.62813 13.5844 3.45463 13.5498 3.29277 13.4827C3.1309 13.4156 2.98385 13.3173 2.86002 13.1933C2.73605 13.0695 2.63771 12.9224 2.57061 12.7606C2.50351 12.5987 2.46897 12.4252 2.46897 12.25C2.46897 12.0748 2.50351 11.9013 2.57061 11.7394C2.63771 11.5775 2.73605 11.4305 2.86002 11.3067L2.90002 11.2667C3.05371 11.1095 3.15681 10.91 3.19602 10.6937C3.23524 10.4775 3.20876 10.2544 3.12002 10.0533C3.03551 9.85614 2.89519 9.68798 2.71633 9.56953C2.53747 9.45108 2.32788 9.38751 2.11335 9.38666H2.00002C1.6464 9.38666 1.30726 9.24618 1.05721 8.99613C0.807163 8.74608 0.666687 8.40695 0.666687 8.05332C0.666687 7.6997 0.807163 7.36056 1.05721 7.11051C1.30726 6.86047 1.6464 6.71999 2.00002 6.71999H2.06002C2.28068 6.71483 2.49469 6.6434 2.67422 6.515C2.85375 6.38659 2.9905 6.20715 3.06669 5.99999C3.15543 5.79891 3.1819 5.57586 3.14269 5.3596C3.10348 5.14333 3.00038 4.94378 2.84669 4.78666L2.80669 4.74666C2.68272 4.62283 2.58437 4.47577 2.51727 4.31391C2.45018 4.15205 2.41564 3.97854 2.41564 3.80332C2.41564 3.6281 2.45018 3.4546 2.51727 3.29274C2.58437 3.13087 2.68272 2.98382 2.80669 2.85999C2.93052 2.73602 3.07757 2.63768 3.23943 2.57058C3.4013 2.50348 3.5748 2.46894 3.75002 2.46894C3.92524 2.46894 4.09874 2.50348 4.26061 2.57058C4.42247 2.63768 4.56952 2.73602 4.69335 2.85999L4.73335 2.89999C4.89047 3.05368 5.09003 3.15678 5.30629 3.19599C5.52256 3.23521 5.74561 3.20873 5.94669 3.11999H6.00002C6.1972 3.03548 6.36537 2.89516 6.48382 2.7163C6.60227 2.53744 6.66583 2.32785 6.66669 2.11332V1.99999C6.66669 1.64637 6.80716 1.30723 7.05721 1.05718C7.30726 0.807132 7.6464 0.666656 8.00002 0.666656C8.35364 0.666656 8.69278 0.807132 8.94283 1.05718C9.19288 1.30723 9.33335 1.64637 9.33335 1.99999V2.05999C9.33421 2.27451 9.39778 2.48411 9.51623 2.66297C9.63468 2.84183 9.80284 2.98215 10 3.06666C10.2011 3.1554 10.4241 3.18187 10.6404 3.14266C10.8567 3.10345 11.0562 3.00035 11.2134 2.84666L11.2534 2.80666C11.3772 2.68269 11.5242 2.58434 11.6861 2.51724C11.848 2.45014 12.0215 2.41561 12.1967 2.41561C12.3719 2.41561 12.5454 2.45014 12.7073 2.51724C12.8691 2.58434 13.0162 2.68269 13.14 2.80666C13.264 2.93049 13.3623 3.07754 13.4294 3.2394C13.4965 3.40127 13.5311 3.57477 13.5311 3.74999C13.5311 3.92521 13.4965 4.09871 13.4294 4.26058C13.3623 4.42244 13.264 4.56949 13.14 4.69332L13.1 4.73332C12.9463 4.89044 12.8432 5.09 12.804 5.30626C12.7648 5.52253 12.7913 5.74558 12.88 5.94666V5.99999C12.9645 6.19717 13.1049 6.36533 13.2837 6.48379C13.4626 6.60224 13.6722 6.6658 13.8867 6.66666H14C14.3536 6.66666 14.6928 6.80713 14.9428 7.05718C15.1929 7.30723 15.3334 7.64637 15.3334 7.99999C15.3334 8.35361 15.1929 8.69275 14.9428 8.9428C14.6928 9.19285 14.3536 9.33332 14 9.33332H13.94C13.7255 9.33418 13.5159 9.39774 13.337 9.5162C13.1582 9.63465 13.0179 9.80281 12.9334 9.99999Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Cy)
        ]),
        d[26] || (d[26] = y("defs", null, [
          y("clipPath", { id: "clip0_193_1263" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "share" ? (v(), C("svg", wy, [
        y("path", {
          d: "M13.8609 8.40495C14.0237 8.26545 14.105 8.1957 14.1348 8.1127C14.161 8.03985 14.161 7.96017 14.1348 7.88732C14.105 7.80432 14.0237 7.73457 13.8609 7.59507L8.21375 2.75466C7.9336 2.51453 7.79353 2.39446 7.67493 2.39152C7.57186 2.38896 7.47341 2.43425 7.40828 2.51416C7.33333 2.60612 7.33333 2.79061 7.33333 3.15959V6.0231C5.91021 6.27207 4.60773 6.99318 3.63981 8.07592C2.58455 9.25635 2.00082 10.784 2 12.3673V12.7753C2.69956 11.9326 3.573 11.251 4.56051 10.7773C5.43113 10.3596 6.37228 10.1122 7.33333 10.047V12.8404C7.33333 13.2094 7.33333 13.3939 7.40828 13.4859C7.47341 13.5658 7.57186 13.6111 7.67493 13.6085C7.79353 13.6056 7.9336 13.4855 8.21375 13.2454L13.8609 8.40495Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ky)
      ])) : _("", !0),
      n.icon === "slash" ? (v(), C(re, { key: 73 }, [
        n.size === 12 ? (v(), C("svg", $y, [
          y("g", My, [
            y("path", {
              d: "M2.465 2.465L9.535 9.535M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z",
              stroke: r.value,
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Sy)
          ]),
          d[27] || (d[27] = y("defs", null, [
            y("clipPath", { id: "clip0_623_6952" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : n.size === 24 ? (v(), C("svg", _y, [
          y("path", {
            d: "M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Ey)
        ])) : (v(), C("svg", Oy, [
          y("g", Ty, [
            y("path", {
              d: "M3.28665 3.28665L12.7133 12.7133M14.6666 7.99998C14.6666 11.6819 11.6819 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6819 1.33331 7.99998C1.33331 4.31808 4.31808 1.33331 7.99998 1.33331C11.6819 1.33331 14.6666 4.31808 14.6666 7.99998Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Ay)
          ]),
          d[28] || (d[28] = y("defs", null, [
            y("clipPath", { id: "clip0_143_692" }, [
              y("rect", {
                width: "16",
                height: "16",
                fill: "white"
              })
            ])
          ], -1))
        ]))
      ], 64)) : _("", !0),
      n.icon === "slash-divider" ? (v(), C("svg", Iy, [
        y("path", {
          d: "M5 14.5L11 1.5",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }, null, 8, Dy)
      ])) : _("", !0),
      n.icon === "slider" ? (v(), C("svg", Ny, [
        y("g", Py, [
          y("path", {
            d: "M2.66669 14V9.33333M2.66669 6.66667V2M8.00002 14V8M8.00002 5.33333V2M13.3334 14V10.6667M13.3334 8V2M0.666687 9.33333H4.66669M6.00002 5.33333H10M11.3334 10.6667H15.3334",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Ly)
        ]),
        d[29] || (d[29] = y("defs", null, [
          y("clipPath", { id: "clip0_320_2117" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "star" ? (v(), C(re, { key: 76 }, [
        n.size === 12 ? (v(), C("svg", Ry, [
          y("g", Fy, [
            y("path", {
              d: "M6 1L7.545 4.13L11 4.635L8.5 7.07L9.09 10.51L6 8.885L2.91 10.51L3.5 7.07L1 4.635L4.455 4.13L6 1Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, By)
          ]),
          d[30] || (d[30] = y("defs", null, [
            y("clipPath", { id: "clip0_1123_3023" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : n.size === 24 ? (v(), C("svg", Vy, [
          y("path", {
            d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, zy)
        ])) : (v(), C("svg", Hy, [
          y("path", {
            d: "M7.99998 1.33331L10.06 5.50665L14.6666 6.17998L11.3333 9.42665L12.12 14.0133L7.99998 11.8466L3.87998 14.0133L4.66665 9.42665L1.33331 6.17998L5.93998 5.50665L7.99998 1.33331Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, jy)
        ]))
      ], 64)) : _("", !0),
      n.icon === "star-02" ? (v(), C("svg", Wy, [
        y("g", Uy, [
          y("path", {
            d: "M2.99998 14.6666V11.3333M2.99998 4.66665V1.33331M1.33331 2.99998H4.66665M1.33331 13H4.66665M8.66665 1.99998L7.51053 5.00589C7.32252 5.49471 7.22852 5.73912 7.08233 5.9447C6.95277 6.12691 6.79358 6.28611 6.61137 6.41567C6.40578 6.56185 6.16137 6.65585 5.67255 6.84386L2.66665 7.99998L5.67255 9.1561C6.16137 9.34411 6.40578 9.43811 6.61137 9.58429C6.79358 9.71385 6.95277 9.87305 7.08233 10.0553C7.22852 10.2608 7.32252 10.5053 7.51053 10.9941L8.66665 14L9.82276 10.9941C10.0108 10.5053 10.1048 10.2608 10.251 10.0553C10.3805 9.87305 10.5397 9.71385 10.7219 9.58429C10.9275 9.43811 11.1719 9.34411 11.6607 9.1561L14.6666 7.99998L11.6607 6.84386C11.1719 6.65585 10.9275 6.56185 10.7219 6.41567C10.5397 6.28611 10.3805 6.12691 10.251 5.9447C10.1048 5.73912 10.0108 5.49471 9.82276 5.00589L8.66665 1.99998Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Ky)
        ]),
        d[31] || (d[31] = y("defs", null, [
          y("clipPath", { id: "clip0_1010_3523" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "tag" ? (v(), C("svg", Gy, [
        y("g", Yy, [
          y("path", {
            d: "M5.33331 5.33331H5.33998M1.33331 3.46665L1.33331 6.44966C1.33331 6.77578 1.33331 6.93884 1.37015 7.09229C1.40282 7.22834 1.45669 7.35839 1.52979 7.47769C1.61225 7.61225 1.72755 7.72755 1.95815 7.95815L7.07057 13.0706C7.8626 13.8626 8.25862 14.2586 8.71528 14.407C9.11696 14.5375 9.54966 14.5375 9.95135 14.407C10.408 14.2586 10.804 13.8626 11.5961 13.0706L13.0706 11.5961C13.8626 10.804 14.2586 10.408 14.407 9.95135C14.5375 9.54966 14.5375 9.11696 14.407 8.71528C14.2586 8.25862 13.8626 7.8626 13.0706 7.07057L7.95815 1.95815C7.72755 1.72755 7.61225 1.61225 7.47769 1.52979C7.35839 1.45669 7.22834 1.40282 7.09229 1.37015C6.93884 1.33331 6.77578 1.33331 6.44966 1.33331L3.46665 1.33331C2.71991 1.33331 2.34654 1.33331 2.06133 1.47864C1.81044 1.60647 1.60647 1.81044 1.47864 2.06133C1.33331 2.34654 1.33331 2.71991 1.33331 3.46665ZM5.66665 5.33331C5.66665 5.51741 5.51741 5.66665 5.33331 5.66665C5.14922 5.66665 4.99998 5.51741 4.99998 5.33331C4.99998 5.14922 5.14922 4.99998 5.33331 4.99998C5.51741 4.99998 5.66665 5.14922 5.66665 5.33331Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, qy)
        ]),
        d[32] || (d[32] = y("defs", null, [
          y("clipPath", { id: "clip0_1380_4541" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "toggle" ? (v(), C("svg", Zy, [
        y("path", {
          d: "M11.3333 11.3334H4.66665C2.8257 11.3334 1.33331 9.84097 1.33331 8.00002C1.33331 6.15907 2.8257 4.66669 4.66665 4.66669H11.3333M11.3333 11.3334C13.1743 11.3334 14.6666 9.84097 14.6666 8.00002C14.6666 6.15907 13.1743 4.66669 11.3333 4.66669M11.3333 11.3334C9.49236 11.3334 7.99998 9.84097 7.99998 8.00002C7.99998 6.15907 9.49236 4.66669 11.3333 4.66669",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Jy)
      ])) : _("", !0),
      n.icon === "trash" ? (v(), C("svg", Xy, [
        y("path", {
          d: "M2 3.99998H3.33333M3.33333 3.99998H14M3.33333 3.99998L3.33333 13.3333C3.33333 13.6869 3.47381 14.0261 3.72386 14.2761C3.97391 14.5262 4.31304 14.6666 4.66667 14.6666H11.3333C11.687 14.6666 12.0261 14.5262 12.2761 14.2761C12.5262 14.0261 12.6667 13.6869 12.6667 13.3333V3.99998M5.33333 3.99998V2.66665C5.33333 2.31302 5.47381 1.97389 5.72386 1.72384C5.97391 1.47379 6.31304 1.33331 6.66667 1.33331H9.33333C9.68696 1.33331 10.0261 1.47379 10.2761 1.72384C10.5262 1.97389 10.6667 2.31302 10.6667 2.66665V3.99998M6.66667 7.33331V11.3333M9.33333 7.33331V11.3333",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Qy)
      ])) : _("", !0),
      n.icon === "upload" ? (v(), C("svg", ex, [
        y("g", tx, [
          y("path", {
            d: "M10.6666 10.6667L7.99997 8.00001M7.99997 8.00001L5.33331 10.6667M7.99997 8.00001L7.99997 14M13.5933 12.26C14.2435 11.9055 14.7572 11.3446 15.0532 10.6658C15.3492 9.98692 15.4108 9.22883 15.2281 8.51114C15.0454 7.79344 14.629 7.15702 14.0444 6.70231C13.4599 6.2476 12.7405 6.0005 12 6.00001H11.16C10.9582 5.2195 10.5821 4.4949 10.0599 3.88067C9.5378 3.26644 8.8832 2.77858 8.14537 2.45375C7.40754 2.12892 6.60567 1.97558 5.80005 2.00526C4.99443 2.03495 4.20602 2.24688 3.49409 2.62512C2.78216 3.00336 2.16525 3.53808 1.68972 4.18906C1.2142 4.84005 0.892434 5.59037 0.748627 6.38361C0.60482 7.17684 0.64271 7.99236 0.859449 8.76885C1.07619 9.54534 1.46613 10.2626 1.99997 10.8667",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, nx)
        ]),
        d[33] || (d[33] = y("defs", null, [
          y("clipPath", { id: "clip0_339_2098" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "user" ? (v(), C("svg", ox, [
        y("path", {
          d: "M13.3334 14V12.6667C13.3334 11.9594 13.0524 11.2811 12.5523 10.781C12.0522 10.281 11.3739 10 10.6667 10H5.33335C4.62611 10 3.94783 10.281 3.44774 10.781C2.94764 11.2811 2.66669 11.9594 2.66669 12.6667V14M10.6667 4.66667C10.6667 6.13943 9.47278 7.33333 8.00002 7.33333C6.52726 7.33333 5.33335 6.13943 5.33335 4.66667C5.33335 3.19391 6.52726 2 8.00002 2C9.47278 2 10.6667 3.19391 10.6667 4.66667Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ix)
      ])) : _("", !0),
      n.icon === "user-switch" ? (v(), C("svg", {
        key: 83,
        width: n.size || 16,
        height: n.size || 16,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        stroke: r.value,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [...d[34] || (d[34] = [
        y("circle", {
          cx: "6",
          cy: "7",
          r: "3"
        }, null, -1),
        y("path", { d: "M1.5 20v-2a4.5 4.5 0 0 1 9 0v2M16 7h6.5m-3-3 3 3-3 3M22.5 17H16m3-3-3 3 3 3" }, null, -1)
      ])], 8, rx)) : _("", !0),
      n.icon === "arrows-switch" ? (v(), C("svg", {
        key: 84,
        width: n.size || 16,
        height: n.size || 16,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        stroke: r.value,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [...d[35] || (d[35] = [
        y("path", { d: "M3 7h18m-4-4 4 4-4 4M21 17H3m4-4-4 4 4 4" }, null, -1)
      ])], 8, sx)) : _("", !0),
      n.icon === "user-right" ? (v(), C("svg", ax, [
        y("path", {
          d: "M12.6666 14L14.6666 12M14.6666 12L12.6666 10M14.6666 12H10.6666M7.99998 10.3333H4.99998C4.0696 10.3333 3.60442 10.3333 3.22588 10.4482C2.37362 10.7067 1.70667 11.3736 1.44814 12.2259C1.33331 12.6044 1.33331 13.0696 1.33331 14M9.66665 5C9.66665 6.65685 8.3235 8 6.66665 8C5.00979 8 3.66665 6.65685 3.66665 5C3.66665 3.34315 5.00979 2 6.66665 2C8.3235 2 9.66665 3.34315 9.66665 5Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, lx)
      ])) : _("", !0),
      n.icon === "users" ? (v(), C(re, { key: 86 }, [
        n.size === 12 ? (v(), C("svg", dx, [
          y("g", ux, [
            y("path", {
              d: "M8.5 10.5V9.5C8.5 8.96957 8.28929 8.46086 7.91421 8.08579C7.53914 7.71071 7.03043 7.5 6.5 7.5H2.5C1.96957 7.5 1.46086 7.71071 1.08579 8.08579C0.710714 8.46086 0.5 8.96957 0.5 9.5V10.5M11.5 10.5V9.5C11.4997 9.05686 11.3522 8.62639 11.0807 8.27616C10.8092 7.92593 10.4291 7.67578 10 7.565M8 1.565C8.43021 1.67515 8.81152 1.92535 9.08382 2.27616C9.35612 2.62696 9.50392 3.05841 9.50392 3.5025C9.50392 3.94659 9.35612 4.37804 9.08382 4.72884C8.81152 5.07965 8.43021 5.32985 8 5.44M6.5 3.5C6.5 4.60457 5.60457 5.5 4.5 5.5C3.39543 5.5 2.5 4.60457 2.5 3.5C2.5 2.39543 3.39543 1.5 4.5 1.5C5.60457 1.5 6.5 2.39543 6.5 3.5Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, cx)
          ]),
          d[36] || (d[36] = y("defs", null, [
            y("clipPath", { id: "clip0_708_814" }, [
              y("rect", {
                width: "12",
                height: "12",
                fill: "white"
              })
            ])
          ], -1))
        ])) : (v(), C("svg", fx, [
          y("g", hx, [
            y("path", {
              d: "M11.3334 14V12.6667C11.3334 11.9594 11.0524 11.2811 10.5523 10.781C10.0522 10.281 9.37393 10 8.66669 10H3.33335C2.62611 10 1.94783 10.281 1.44774 10.781C0.947639 11.2811 0.666687 11.9594 0.666687 12.6667V14M15.3334 14V12.6667C15.3329 12.0758 15.1363 11.5018 14.7743 11.0349C14.4123 10.5679 13.9054 10.2344 13.3334 10.0867M10.6667 2.08667C11.2403 2.23353 11.7487 2.56713 12.1118 3.03487C12.4748 3.50261 12.6719 4.07789 12.6719 4.67C12.6719 5.26211 12.4748 5.83739 12.1118 6.30513C11.7487 6.77287 11.2403 7.10647 10.6667 7.25333M8.66669 4.66667C8.66669 6.13943 7.47278 7.33333 6.00002 7.33333C4.52726 7.33333 3.33335 6.13943 3.33335 4.66667C3.33335 3.19391 4.52726 2 6.00002 2C7.47278 2 8.66669 3.19391 8.66669 4.66667Z",
              stroke: r.value,
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, px)
          ]),
          d[37] || (d[37] = y("defs", null, [
            y("clipPath", { id: "clip0_143_686" }, [
              y("rect", {
                width: "16",
                height: "16",
                fill: "white"
              })
            ])
          ], -1))
        ]))
      ], 64)) : _("", !0),
      n.icon === "users-plus" ? (v(), C(re, { key: 87 }, [
        n.size === 24 ? (v(), C("svg", mx, [
          y("path", {
            d: "M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
            stroke: r.value,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, gx)
        ])) : (v(), C("svg", vx, [
          y("path", {
            d: "M12.6666 14V10M10.6666 12H14.6666M7.99998 10H5.33331C4.0908 10 3.46955 10 2.97949 10.203C2.32608 10.4736 1.80695 10.9928 1.5363 11.6462C1.33331 12.1362 1.33331 12.7575 1.33331 14M10.3333 2.19384C11.3106 2.58943 12 3.54754 12 4.66667C12 5.78579 11.3106 6.7439 10.3333 7.13949M8.99998 4.66667C8.99998 6.13943 7.80607 7.33333 6.33331 7.33333C4.86055 7.33333 3.66665 6.13943 3.66665 4.66667C3.66665 3.19391 4.86055 2 6.33331 2C7.80607 2 8.99998 3.19391 8.99998 4.66667Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, bx)
        ]))
      ], 64)) : _("", !0),
      n.icon === "users-check" ? (v(), C("svg", yx, [...d[38] || (d[38] = [
        y("path", {
          d: "M10.6666 12L11.9999 13.3333L14.6666 10.6667M7.99992 10H5.33325C4.09074 10 3.46949 10 2.97943 10.203C2.32602 10.4736 1.80689 10.9928 1.53624 11.6462C1.33325 12.1362 1.33325 12.7575 1.33325 14M10.3333 2.19384C11.3105 2.58943 11.9999 3.54754 11.9999 4.66667C11.9999 5.78579 11.3105 6.7439 10.3333 7.13949M8.99992 4.66667C8.99992 6.13943 7.80601 7.33333 6.33325 7.33333C4.86049 7.33333 3.66659 6.13943 3.66659 4.66667C3.66659 3.19391 4.86049 2 6.33325 2C7.80601 2 8.99992 3.19391 8.99992 4.66667Z",
          stroke: "#03874C",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])])) : _("", !0),
      n.icon === "briefcase" ? (v(), C("svg", xx, [
        y("path", {
          d: "M10.6667 4.66667C10.6667 4.04669 10.6667 3.7367 10.5985 3.48236C10.4136 2.79218 9.87449 2.25308 9.18431 2.06815C8.92997 2 8.61998 2 8 2C7.38002 2 7.07003 2 6.8157 2.06815C6.12551 2.25308 5.58642 2.79218 5.40148 3.48236C5.33334 3.7367 5.33334 4.04669 5.33334 4.66667M3.46667 14H12.5333C13.2801 14 13.6534 14 13.9387 13.8547C14.1895 13.7268 14.3935 13.5229 14.5213 13.272C14.6667 12.9868 14.6667 12.6134 14.6667 11.8667V6.8C14.6667 6.05326 14.6667 5.6799 14.5213 5.39468C14.3935 5.1438 14.1895 4.93982 13.9387 4.81199C13.6534 4.66667 13.2801 4.66667 12.5333 4.66667H3.46667C2.71993 4.66667 2.34656 4.66667 2.06135 4.81199C1.81047 4.93982 1.60649 5.1438 1.47866 5.39468C1.33334 5.6799 1.33334 6.05326 1.33334 6.8V11.8667C1.33334 12.6134 1.33334 12.9868 1.47866 13.272C1.60649 13.5229 1.81047 13.7268 2.06135 13.8547C2.34656 14 2.71993 14 3.46667 14Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Cx)
      ])) : _("", !0),
      n.icon === "drag-drop" ? (v(), C("svg", wx, [
        y("path", {
          d: "M5.49665 8.65997C5.86484 8.65997 6.16332 8.3615 6.16332 7.99331C6.16332 7.62512 5.86484 7.32664 5.49665 7.32664C5.12846 7.32664 4.82999 7.62512 4.82999 7.99331C4.82999 8.3615 5.12846 8.65997 5.49665 8.65997Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, kx),
        y("path", {
          d: "M5.49665 3.99331C5.86484 3.99331 6.16332 3.69483 6.16332 3.32664C6.16332 2.95845 5.86484 2.65997 5.49665 2.65997C5.12846 2.65997 4.82999 2.95845 4.82999 3.32664C4.82999 3.69483 5.12846 3.99331 5.49665 3.99331Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, $x),
        y("path", {
          d: "M5.49665 13.3266C5.86484 13.3266 6.16332 13.0282 6.16332 12.66C6.16332 12.2918 5.86484 11.9933 5.49665 11.9933C5.12846 11.9933 4.82999 12.2918 4.82999 12.66C4.82999 13.0282 5.12846 13.3266 5.49665 13.3266Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Mx),
        y("path", {
          d: "M10.4967 8.65997C10.8648 8.65997 11.1633 8.3615 11.1633 7.99331C11.1633 7.62512 10.8648 7.32664 10.4967 7.32664C10.1285 7.32664 9.82999 7.62512 9.82999 7.99331C9.82999 8.3615 10.1285 8.65997 10.4967 8.65997Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Sx),
        y("path", {
          d: "M10.4967 3.99331C10.8648 3.99331 11.1633 3.69483 11.1633 3.32664C11.1633 2.95845 10.8648 2.65997 10.4967 2.65997C10.1285 2.65997 9.82999 2.95845 9.82999 3.32664C9.82999 3.69483 10.1285 3.99331 10.4967 3.99331Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, _x),
        y("path", {
          d: "M10.4967 13.3266C10.8648 13.3266 11.1633 13.0282 11.1633 12.66C11.1633 12.2918 10.8648 11.9933 10.4967 11.9933C10.1285 11.9933 9.82999 12.2918 9.82999 12.66C9.82999 13.0282 10.1285 13.3266 10.4967 13.3266Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Ex)
      ])) : _("", !0),
      n.icon === "globe" ? (v(), C("svg", Ox, [
        y("g", Tx, [
          y("path", {
            d: "M2.05064 4.98853L4.90933 7.03042C5.05808 7.13666 5.13246 7.18979 5.2103 7.20203C5.27879 7.2128 5.34894 7.20195 5.41097 7.17098C5.48147 7.13578 5.53631 7.06266 5.64599 6.91642L6.25006 6.11099C6.28107 6.06964 6.29658 6.04896 6.31481 6.03112C6.33099 6.01528 6.34875 6.00113 6.3678 5.9889C6.38926 5.97511 6.41288 5.96462 6.46012 5.94362L9.03918 4.79737C9.14609 4.74986 9.19954 4.7261 9.23985 4.689C9.2755 4.65618 9.30357 4.61598 9.3221 4.57121C9.34305 4.52058 9.34694 4.46222 9.35472 4.34548L9.54356 1.51292M8.99998 8.99998L10.744 9.74741C10.9463 9.83413 11.0475 9.87749 11.1011 9.94951C11.1481 10.0127 11.1712 10.0905 11.1664 10.1691C11.1608 10.2587 11.0998 10.3503 10.9777 10.5335L10.1583 11.7625C10.1004 11.8493 10.0715 11.8927 10.0332 11.9242C9.99938 11.952 9.96038 11.9729 9.91845 11.9856C9.87108 12 9.8189 12 9.71455 12H8.38439C8.24615 12 8.17704 12 8.11823 11.9769C8.0663 11.9564 8.02033 11.9233 7.98453 11.8805C7.94399 11.832 7.92213 11.7664 7.87842 11.6353L7.40317 10.2096C7.37739 10.1322 7.3645 10.0935 7.3611 10.0542C7.3581 10.0194 7.36059 9.98428 7.3685 9.9502C7.37742 9.91177 7.39565 9.87531 7.43211 9.80239L7.79312 9.08037C7.86647 8.93367 7.90314 8.86032 7.95963 8.81479C8.00941 8.77465 8.06968 8.74969 8.13326 8.74286C8.20541 8.73512 8.2832 8.76105 8.4388 8.81292L8.99998 8.99998ZM14.6666 7.99998C14.6666 11.6819 11.6819 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6819 1.33331 7.99998C1.33331 4.31808 4.31808 1.33331 7.99998 1.33331C11.6819 1.33331 14.6666 4.31808 14.6666 7.99998Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Ax)
        ]),
        d[39] || (d[39] = y("defs", null, [
          y("clipPath", { id: "clip0_3046_543" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "graduation-hat" ? (v(), C("svg", Ix, [
        y("path", {
          d: "M3.33331 6.66667V10.6741C3.33331 10.9134 3.33331 11.0331 3.36975 11.1387C3.40197 11.2321 3.45456 11.3172 3.5237 11.3878C3.60189 11.4676 3.70891 11.5211 3.92295 11.6282L7.52295 13.4282C7.69786 13.5156 7.78532 13.5593 7.87705 13.5765C7.95829 13.5918 8.04167 13.5918 8.12291 13.5765C8.21464 13.5593 8.30211 13.5156 8.47701 13.4282L12.077 11.6282C12.291 11.5211 12.3981 11.4676 12.4763 11.3878C12.5454 11.3172 12.598 11.2321 12.6302 11.1387C12.6666 11.0331 12.6666 10.9134 12.6666 10.6741V6.66667M1.33331 5.66667L7.76147 2.45259C7.84892 2.40887 7.89265 2.387 7.93851 2.3784C7.97914 2.37078 8.02082 2.37078 8.06145 2.3784C8.10731 2.387 8.15104 2.40887 8.23849 2.45259L14.6666 5.66667L8.23849 8.88075C8.15104 8.92447 8.10731 8.94634 8.06145 8.95494C8.02082 8.96256 7.97914 8.96256 7.93851 8.95494C7.89265 8.94634 7.84892 8.92447 7.76147 8.88075L1.33331 5.66667Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Dx)
      ])) : _("", !0),
      n.icon === "marker-pin" ? (v(), C("svg", Nx, [
        y("path", {
          d: "M8.00002 8.66668C9.10459 8.66668 10 7.77125 10 6.66668C10 5.56211 9.10459 4.66668 8.00002 4.66668C6.89545 4.66668 6.00002 5.56211 6.00002 6.66668C6.00002 7.77125 6.89545 8.66668 8.00002 8.66668Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Px),
        y("path", {
          d: "M8.00002 14.6667C10.6667 12 13.3334 9.61219 13.3334 6.66668C13.3334 3.72116 10.9455 1.33334 8.00002 1.33334C5.0545 1.33334 2.66669 3.72116 2.66669 6.66668C2.66669 9.61219 5.33335 12 8.00002 14.6667Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Lx)
      ])) : _("", !0),
      n.icon === "pie-chart" ? (v(), C("svg", Rx, [
        y("g", Fx, [
          y("path", {
            d: "M14.1402 10.5933C13.7161 11.5963 13.0528 12.4801 12.2082 13.1675C11.3636 13.8549 10.3634 14.325 9.29521 14.5365C8.22698 14.7481 7.1232 14.6948 6.08035 14.3812C5.0375 14.0676 4.08733 13.5034 3.31293 12.7378C2.53852 11.9722 1.96346 11.0285 1.63801 9.98931C1.31255 8.9501 1.24662 7.847 1.44598 6.77643C1.64534 5.70586 2.10391 4.70042 2.78161 3.84803C3.45931 2.99563 4.3355 2.32222 5.33358 1.88667M14.1594 5.44878C14.4263 6.09309 14.59 6.77425 14.6456 7.46723C14.6593 7.63843 14.6662 7.72403 14.6322 7.80114C14.6038 7.86555 14.5475 7.9265 14.4856 7.95996C14.4115 8.00001 14.3188 8.00001 14.1336 8.00001H8.53358C8.3469 8.00001 8.25356 8.00001 8.18225 7.96367C8.11953 7.93172 8.06854 7.88072 8.03658 7.818C8.00025 7.7467 8.00025 7.65336 8.00025 7.46667V1.86667C8.00025 1.68143 8.00025 1.58881 8.0403 1.51466C8.07375 1.45272 8.1347 1.39646 8.19911 1.36807C8.27622 1.33407 8.36182 1.34094 8.53302 1.35466C9.22601 1.41022 9.90716 1.57393 10.5515 1.84081C11.3603 2.17584 12.0952 2.6669 12.7143 3.28596C13.3334 3.90502 13.8244 4.63995 14.1594 5.44878Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Bx)
        ]),
        d[40] || (d[40] = y("defs", null, [
          y("clipPath", { id: "clip0_3046_554" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "widget-br" ? (v(), C("svg", Vx, [
        y("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM8.25 9.5C8.25 9.08579 8.58579 8.75 9 8.75H11.5C11.9142 8.75 12.25 9.08579 12.25 9.5V11.5C12.25 11.9142 11.9142 12.25 11.5 12.25H9C8.58579 12.25 8.25 11.9142 8.25 11.5V9.5ZM9.75 10.25V10.75H10.75V10.25H9.75Z",
          fill: r.value
        }, null, 8, zx)
      ])) : _("", !0),
      n.icon === "widget-bl" ? (v(), C("svg", Hx, [
        y("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM3.75 9.5C3.75 9.08579 4.08579 8.75 4.5 8.75H7C7.41421 8.75 7.75 9.08579 7.75 9.5V11.5C7.75 11.9142 7.41421 12.25 7 12.25H4.5C4.08579 12.25 3.75 11.9142 3.75 11.5V9.5ZM5.25 10.25V10.75H6.25V10.25H5.25Z",
          fill: r.value
        }, null, 8, jx)
      ])) : _("", !0),
      n.icon === "widget-tr" ? (v(), C("svg", Wx, [
        y("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM8.25 4.5C8.25 4.08579 8.58579 3.75 9 3.75H11.5C11.9142 3.75 12.25 4.08579 12.25 4.5V6.5C12.25 6.91421 11.9142 7.25 11.5 7.25H9C8.58579 7.25 8.25 6.91421 8.25 6.5V4.5ZM9.75 5.25V5.75H10.75V5.25H9.75Z",
          fill: r.value
        }, null, 8, Ux)
      ])) : _("", !0),
      n.icon === "widget-tl" ? (v(), C("svg", Kx, [
        y("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75H7C7.41421 3.75 7.75 4.08579 7.75 4.5V6.5C7.75 6.91421 7.41421 7.25 7 7.25H4.5C4.08579 7.25 3.75 6.91421 3.75 6.5V4.5ZM5.25 5.25V5.75H6.25V5.25H5.25Z",
          fill: r.value
        }, null, 8, Gx)
      ])) : _("", !0),
      n.icon === "flex-align-top" ? (v(), C("svg", Yx, [
        y("path", {
          d: "M11.6667 4.33333L4.33333 4.33333M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, qx)
      ])) : _("", !0),
      n.icon === "flex-align-bottom" ? (v(), C("svg", Zx, [
        y("path", {
          d: "M11.6667 11.7333L4.33333 11.7333M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Jx)
      ])) : _("", !0),
      n.icon === "image-user" ? (v(), C("svg", Xx, [
        y("g", Qx, [
          y("path", {
            d: "M2.66666 14.5449C3.06838 14.6666 3.61097 14.6666 4.53331 14.6666H11.4666C12.389 14.6666 12.9316 14.6666 13.3333 14.5449M2.66666 14.5449C2.58053 14.5188 2.50087 14.4871 2.42533 14.4487C2.04901 14.2569 1.74305 13.951 1.5513 13.5746C1.33331 13.1468 1.33331 12.5868 1.33331 11.4666V4.53331C1.33331 3.41321 1.33331 2.85316 1.5513 2.42533C1.74305 2.04901 2.04901 1.74305 2.42533 1.5513C2.85316 1.33331 3.41321 1.33331 4.53331 1.33331H11.4666C12.5868 1.33331 13.1468 1.33331 13.5746 1.5513C13.951 1.74305 14.2569 2.04901 14.4487 2.42533C14.6666 2.85316 14.6666 3.41321 14.6666 4.53331V11.4666C14.6666 12.5868 14.6666 13.1468 14.4487 13.5746C14.2569 13.951 13.951 14.2569 13.5746 14.4487C13.4991 14.4871 13.4194 14.5188 13.3333 14.5449M2.66666 14.5449C2.66688 14.0054 2.67012 13.7199 2.71789 13.4797C2.9283 12.4219 3.75523 11.595 4.81307 11.3846C5.07067 11.3333 5.38044 11.3333 5.99998 11.3333H9.99998C10.6195 11.3333 10.9293 11.3333 11.1869 11.3846C12.2447 11.595 13.0717 12.4219 13.2821 13.4797C13.3298 13.7199 13.3331 14.0054 13.3333 14.5449M10.6666 6.33331C10.6666 7.80607 9.47274 8.99998 7.99998 8.99998C6.52722 8.99998 5.33331 7.80607 5.33331 6.33331C5.33331 4.86055 6.52722 3.66665 7.99998 3.66665C9.47274 3.66665 10.6666 4.86055 10.6666 6.33331Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, eC)
        ]),
        d[41] || (d[41] = y("defs", null, [
          y("clipPath", { id: "clip0_3210_119" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "grid-01" ? (v(), C("svg", tC, [
        y("path", {
          d: "M5.6 2H3.06667C2.6933 2 2.50661 2 2.36401 2.07266C2.23856 2.13658 2.13658 2.23856 2.07266 2.36401C2 2.50661 2 2.6933 2 3.06667V5.6C2 5.97337 2 6.16005 2.07266 6.30266C2.13658 6.4281 2.23856 6.53009 2.36401 6.594C2.50661 6.66667 2.6933 6.66667 3.06667 6.66667H5.6C5.97337 6.66667 6.16005 6.66667 6.30266 6.594C6.4281 6.53009 6.53009 6.4281 6.594 6.30266C6.66667 6.16005 6.66667 5.97337 6.66667 5.6V3.06667C6.66667 2.6933 6.66667 2.50661 6.594 2.36401C6.53009 2.23856 6.4281 2.13658 6.30266 2.07266C6.16005 2 5.97337 2 5.6 2Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, nC),
        y("path", {
          d: "M12.9333 2H10.4C10.0266 2 9.83995 2 9.69734 2.07266C9.5719 2.13658 9.46991 2.23856 9.406 2.36401C9.33333 2.50661 9.33333 2.6933 9.33333 3.06667V5.6C9.33333 5.97337 9.33333 6.16005 9.406 6.30266C9.46991 6.4281 9.5719 6.53009 9.69734 6.594C9.83995 6.66667 10.0266 6.66667 10.4 6.66667H12.9333C13.3067 6.66667 13.4934 6.66667 13.636 6.594C13.7614 6.53009 13.8634 6.4281 13.9273 6.30266C14 6.16005 14 5.97337 14 5.6V3.06667C14 2.6933 14 2.50661 13.9273 2.36401C13.8634 2.23856 13.7614 2.13658 13.636 2.07266C13.4934 2 13.3067 2 12.9333 2Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, oC),
        y("path", {
          d: "M12.9333 9.33333H10.4C10.0266 9.33333 9.83995 9.33333 9.69734 9.406C9.5719 9.46991 9.46991 9.5719 9.406 9.69734C9.33333 9.83995 9.33333 10.0266 9.33333 10.4V12.9333C9.33333 13.3067 9.33333 13.4934 9.406 13.636C9.46991 13.7614 9.5719 13.8634 9.69734 13.9273C9.83995 14 10.0266 14 10.4 14H12.9333C13.3067 14 13.4934 14 13.636 13.9273C13.7614 13.8634 13.8634 13.7614 13.9273 13.636C14 13.4934 14 13.3067 14 12.9333V10.4C14 10.0266 14 9.83995 13.9273 9.69734C13.8634 9.5719 13.7614 9.46991 13.636 9.406C13.4934 9.33333 13.3067 9.33333 12.9333 9.33333Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, iC),
        y("path", {
          d: "M5.6 9.33333H3.06667C2.6933 9.33333 2.50661 9.33333 2.36401 9.406C2.23856 9.46991 2.13658 9.5719 2.07266 9.69734C2 9.83995 2 10.0266 2 10.4V12.9333C2 13.3067 2 13.4934 2.07266 13.636C2.13658 13.7614 2.23856 13.8634 2.36401 13.9273C2.50661 14 2.6933 14 3.06667 14H5.6C5.97337 14 6.16005 14 6.30266 13.9273C6.4281 13.8634 6.53009 13.7614 6.594 13.636C6.66667 13.4934 6.66667 13.3067 6.66667 12.9333V10.4C6.66667 10.0266 6.66667 9.83995 6.594 9.69734C6.53009 9.5719 6.4281 9.46991 6.30266 9.406C6.16005 9.33333 5.97337 9.33333 5.6 9.33333Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, rC)
      ])) : _("", !0),
      n.icon === "grid-03" ? (v(), C("svg", sC, [
        y("path", {
          d: "M5.33333 2H4.13333C3.3866 2 3.01323 2 2.72801 2.14532C2.47713 2.27316 2.27316 2.47713 2.14532 2.72801C2 3.01323 2 3.3866 2 4.13333V5.33333M5.33333 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V10.6667M14 5.33333V4.13333C14 3.3866 14 3.01323 13.8547 2.72801C13.7268 2.47713 13.5229 2.27316 13.272 2.14532C12.9868 2 12.6134 2 11.8667 2H10.6667M14 10.6667V11.8667C14 12.6134 14 12.9868 13.8547 13.272C13.7268 13.5229 13.5229 13.7268 13.272 13.8547C12.9868 14 12.6134 14 11.8667 14H10.6667M10.6667 8C10.6667 9.47276 9.47276 10.6667 8 10.6667C6.52724 10.6667 5.33333 9.47276 5.33333 8C5.33333 6.52724 6.52724 5.33333 8 5.33333C9.47276 5.33333 10.6667 6.52724 10.6667 8Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, aC)
      ])) : _("", !0),
      n.icon === "phone-01" ? (v(), C("svg", lC, [
        y("path", {
          d: "M7.99998 11.6666H8.00665M5.46665 14.6666H10.5333C11.2801 14.6666 11.6534 14.6666 11.9386 14.5213C12.1895 14.3935 12.3935 14.1895 12.5213 13.9386C12.6666 13.6534 12.6666 13.28 12.6666 12.5333V3.46665C12.6666 2.71991 12.6666 2.34654 12.5213 2.06133C12.3935 1.81044 12.1895 1.60647 11.9386 1.47864C11.6534 1.33331 11.28 1.33331 10.5333 1.33331H5.46665C4.71991 1.33331 4.34654 1.33331 4.06133 1.47864C3.81044 1.60647 3.60647 1.81044 3.47864 2.06133C3.33331 2.34654 3.33331 2.71991 3.33331 3.46665V12.5333C3.33331 13.28 3.33331 13.6534 3.47864 13.9386C3.60647 14.1895 3.81044 14.3935 4.06133 14.5213C4.34654 14.6666 4.71991 14.6666 5.46665 14.6666ZM8.33331 11.6666C8.33331 11.8507 8.18407 12 7.99998 12C7.81588 12 7.66665 11.8507 7.66665 11.6666C7.66665 11.4826 7.81588 11.3333 7.99998 11.3333C8.18407 11.3333 8.33331 11.4826 8.33331 11.6666Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, dC)
      ])) : _("", !0),
      n.icon === "bar-chart" ? (v(), C("svg", uC, [
        y("path", {
          d: "M6 4.66667H3.06667C2.6933 4.66667 2.50661 4.66667 2.36401 4.73933C2.23856 4.80324 2.13658 4.90523 2.07266 5.03067C2 5.17328 2 5.35997 2 5.73333V12.9333C2 13.3067 2 13.4934 2.07266 13.636C2.13658 13.7614 2.23856 13.8634 2.36401 13.9273C2.50661 14 2.6933 14 3.06667 14H6M6 14H10M6 14L6 3.06667C6 2.6933 6 2.50661 6.07266 2.36401C6.13658 2.23857 6.23857 2.13658 6.36401 2.07266C6.50661 2 6.6933 2 7.06667 2L8.93333 2C9.3067 2 9.49339 2 9.63599 2.07266C9.76144 2.13658 9.86342 2.23856 9.92734 2.36401C10 2.50661 10 2.6933 10 3.06667V14M10 7.33333H12.9333C13.3067 7.33333 13.4934 7.33333 13.636 7.406C13.7614 7.46991 13.8634 7.5719 13.9273 7.69734C14 7.83995 14 8.02663 14 8.4V12.9333C14 13.3067 14 13.4934 13.9273 13.636C13.8634 13.7614 13.7614 13.8634 13.636 13.9273C13.4934 14 13.3067 14 12.9333 14H10",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, cC)
      ])) : _("", !0),
      n.icon === "home" ? (v(), C("svg", fC, [
        y("path", {
          d: "M5.33333 11.3333H10.6667M7.34513 1.84268L2.82359 5.35943C2.52135 5.59451 2.37022 5.71205 2.26135 5.85925C2.16491 5.98964 2.09307 6.13654 2.04935 6.29272C2 6.46903 2 6.66048 2 7.04338V11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27316 13.5229 2.47713 13.7268 2.72801 13.8547C3.01323 14 3.3866 14 4.13333 14H11.8667C12.6134 14 12.9868 14 13.272 13.8547C13.5229 13.7268 13.7268 13.5229 13.8547 13.272C14 12.9868 14 12.6134 14 11.8667V7.04338C14 6.66048 14 6.46903 13.9506 6.29272C13.9069 6.13654 13.8351 5.98964 13.7386 5.85925C13.6298 5.71205 13.4787 5.59451 13.1764 5.35943L8.65487 1.84268C8.42065 1.66051 8.30354 1.56943 8.17423 1.53442C8.06013 1.50352 7.93987 1.50352 7.82577 1.53442C7.69646 1.56943 7.57935 1.66051 7.34513 1.84268Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, hC)
      ])) : _("", !0),
      n.icon === "palette" ? (v(), C("svg", pC, [
        y("g", mC, [
          y("path", {
            d: "M1.33337 7.99998C1.33337 11.6819 4.31814 14.6666 8.00004 14.6666C9.10461 14.6666 10 13.7712 10 12.6666V12.3333C10 12.0237 10 11.8689 10.0172 11.7389C10.1353 10.8415 10.8415 10.1352 11.739 10.0171C11.869 9.99998 12.0238 9.99998 12.3334 9.99998H12.6667C13.7713 9.99998 14.6667 9.10455 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00004 1.33331C4.31814 1.33331 1.33337 4.31808 1.33337 7.99998Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, gC),
          y("path", {
            d: "M4.66671 8.66665C5.0349 8.66665 5.33337 8.36817 5.33337 7.99998C5.33337 7.63179 5.0349 7.33331 4.66671 7.33331C4.29852 7.33331 4.00004 7.63179 4.00004 7.99998C4.00004 8.36817 4.29852 8.66665 4.66671 8.66665Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, vC),
          y("path", {
            d: "M10.6667 5.99998C11.0349 5.99998 11.3334 5.7015 11.3334 5.33331C11.3334 4.96512 11.0349 4.66665 10.6667 4.66665C10.2985 4.66665 10 4.96512 10 5.33331C10 5.7015 10.2985 5.99998 10.6667 5.99998Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, bC),
          y("path", {
            d: "M6.66671 5.33331C7.0349 5.33331 7.33337 5.03484 7.33337 4.66665C7.33337 4.29846 7.0349 3.99998 6.66671 3.99998C6.29852 3.99998 6.00004 4.29846 6.00004 4.66665C6.00004 5.03484 6.29852 5.33331 6.66671 5.33331Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, yC)
        ]),
        d[42] || (d[42] = y("defs", null, [
          y("clipPath", { id: "clip0_11_6" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "puzzle-piece" ? (v(), C("svg", xC, [
        y("g", CC, [
          y("path", {
            d: "M8.00004 1.33334L10.4 3.73334C12 -0.466657 16.4667 4.00001 12.2667 5.60001L14.6667 8.00001L12.2667 10.4C10.6667 6.20001 6.20004 10.6667 10.4 12.2667L8.00004 14.6667L5.60004 12.2667C4.00004 16.4667 -0.466626 12 3.73337 10.4L1.33337 8.00001L3.73337 5.60001C5.33337 9.80001 9.80004 5.33334 5.60004 3.73334L8.00004 1.33334Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, wC)
        ]),
        d[43] || (d[43] = y("defs", null, [
          y("clipPath", { id: "clip0_3620_119" }, [
            y("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ], -1))
      ])) : _("", !0),
      n.icon === "save" ? (v(), C("svg", kC, [
        y("path", {
          d: "M4.08333 1.75V3.73333C4.08333 4.06003 4.08333 4.22338 4.14691 4.34816C4.20284 4.45792 4.29208 4.54716 4.40184 4.60309C4.52662 4.66667 4.68997 4.66667 5.01667 4.66667H8.98333C9.31003 4.66667 9.47338 4.66667 9.59816 4.60309C9.70792 4.54716 9.79716 4.45792 9.85309 4.34816C9.91667 4.22338 9.91667 4.06003 9.91667 3.73333V2.33333M9.91667 12.25V8.51667C9.91667 8.18997 9.91667 8.02662 9.85309 7.90184C9.79716 7.79208 9.70792 7.70284 9.59816 7.64691C9.47338 7.58333 9.31003 7.58333 8.98333 7.58333H5.01667C4.68997 7.58333 4.52662 7.58333 4.40184 7.64691C4.29208 7.70284 4.20284 7.79208 4.14691 7.90184C4.08333 8.02662 4.08333 8.18997 4.08333 8.51667V12.25M12.25 5.43987V9.45C12.25 10.4301 12.25 10.9201 12.0593 11.2945C11.8915 11.6238 11.6238 11.8915 11.2945 12.0593C10.9201 12.25 10.4301 12.25 9.45 12.25H4.55C3.56991 12.25 3.07986 12.25 2.70552 12.0593C2.37623 11.8915 2.10852 11.6238 1.94074 11.2945C1.75 10.9201 1.75 10.4301 1.75 9.45V4.55C1.75 3.56991 1.75 3.07986 1.94074 2.70552C2.10852 2.37623 2.37623 2.10852 2.70552 1.94074C3.07986 1.75 3.56991 1.75 4.55 1.75H8.56013C8.84549 1.75 8.98817 1.75 9.12244 1.78224C9.24148 1.81081 9.35528 1.85795 9.45967 1.92192C9.5774 1.99407 9.67829 2.09496 9.88007 2.29673L11.7033 4.11993C11.905 4.32171 12.0059 4.4226 12.0781 4.54033C12.142 4.64472 12.1892 4.75852 12.2178 4.87756C12.25 5.01183 12.25 5.15451 12.25 5.43987Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, $C)
      ])) : _("", !0),
      n.icon === "heart-hand" ? (v(), C("svg", MC, [
        y("g", SC, [
          y("path", {
            d: "M4 13.3914H5.7402C5.96709 13.3914 6.19259 13.4184 6.41254 13.4724L8.25126 13.9193C8.65023 14.0164 9.06585 14.0259 9.46898 13.9476L11.502 13.5521C12.039 13.4475 12.5331 13.1903 12.9202 12.8137L14.3586 11.4145C14.7694 11.0156 14.7694 10.3683 14.3586 9.96871C13.9888 9.60896 13.4032 9.56846 12.9848 9.87354L11.3084 11.0966C11.0683 11.2721 10.7762 11.3666 10.4758 11.3666H8.857L9.88738 11.3665C10.4681 11.3665 10.9386 10.9089 10.9386 10.3439V10.1394C10.9386 9.67033 10.6104 9.26131 10.1427 9.14792L8.5524 8.76116C8.29359 8.69839 8.02854 8.66667 7.7621 8.66667C7.11889 8.66667 5.9546 9.19921 5.9546 9.19921L4 10.0166M1.33334 9.73334L1.33334 13.6C1.33334 13.9734 1.33334 14.1601 1.406 14.3027C1.46991 14.4281 1.5719 14.5301 1.69734 14.594C1.83995 14.6667 2.02663 14.6667 2.4 14.6667H2.93334C3.3067 14.6667 3.49339 14.6667 3.636 14.594C3.76144 14.5301 3.86342 14.4281 3.92734 14.3027C4 14.1601 4 13.9734 4 13.6V9.73334C4 9.35997 4 9.17328 3.92734 9.03067C3.86342 8.90523 3.76144 8.80325 3.636 8.73933C3.49339 8.66667 3.3067 8.66667 2.93334 8.66667H2.4C2.02663 8.66667 1.83995 8.66667 1.69734 8.73933C1.5719 8.80325 1.46991 8.90523 1.406 9.03067C1.33334 9.17328 1.33334 9.35997 1.33334 9.73334ZM11.4609 2.39484C11.063 1.56227 10.1457 1.12119 9.25362 1.54692C8.36153 1.97264 7.98147 2.98225 8.35497 3.86855C8.58581 4.41631 9.24717 5.48 9.71873 6.21269C9.89296 6.48341 9.98008 6.61877 10.1073 6.69795C10.2165 6.76587 10.3531 6.80249 10.4816 6.79824C10.6314 6.79328 10.7745 6.71962 11.0608 6.57229C11.8355 6.17354 12.9401 5.58304 13.4139 5.22408C14.1805 4.64328 14.3704 3.57572 13.7964 2.76416C13.2225 1.9526 12.2218 1.87275 11.4609 2.39484Z",
            stroke: r.value,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _C)
        ]),
        y("defs", null, [
          y("clipPath", EC, [
            y("rect", {
              width: "16",
              height: "16",
              fill: r.value
            }, null, 8, OC)
          ])
        ])
      ])) : _("", !0),
      n.icon === "credit-card" ? (v(), C("svg", TC, [
        y("path", {
          d: "M14.6667 6.66665H1.33334M7.33334 9.33331H4M1.33334 5.46665L1.33334 10.5333C1.33334 11.28 1.33334 11.6534 1.47866 11.9386C1.60649 12.1895 1.81047 12.3935 2.06135 12.5213C2.34656 12.6666 2.71993 12.6666 3.46667 12.6666L12.5333 12.6666C13.2801 12.6666 13.6534 12.6666 13.9387 12.5213C14.1895 12.3935 14.3935 12.1895 14.5213 11.9386C14.6667 11.6534 14.6667 11.28 14.6667 10.5333V5.46665C14.6667 4.71991 14.6667 4.34654 14.5213 4.06133C14.3935 3.81044 14.1895 3.60647 13.9387 3.47864C13.6534 3.33331 13.2801 3.33331 12.5333 3.33331L3.46667 3.33331C2.71993 3.33331 2.34656 3.33331 2.06135 3.47864C1.81047 3.60647 1.60649 3.81044 1.47866 4.06133C1.33334 4.34654 1.33334 4.71991 1.33334 5.46665Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, AC)
      ])) : _("", !0),
      n.icon === "certified" ? (v(), C("svg", IC, [...d[44] || (d[44] = [
        y("path", {
          d: "M5.41667 7.41667L6.75 8.75L9.75 5.75M11.3508 2.749C11.4881 3.08102 11.7516 3.34493 12.0834 3.48271L13.2468 3.96465C13.5789 4.10219 13.8427 4.366 13.9802 4.69804C14.1177 5.03008 14.1177 5.40316 13.9802 5.73521L13.4986 6.89787C13.361 7.23006 13.3608 7.60352 13.499 7.93555L13.9798 9.09786C14.048 9.26232 14.0831 9.4386 14.0831 9.61663C14.0831 9.79466 14.0481 9.97095 13.98 10.1354C13.9118 10.2999 13.812 10.4494 13.6861 10.5752C13.5602 10.7011 13.4107 10.8009 13.2462 10.869L12.0836 11.3506C11.7516 11.4879 11.4877 11.7514 11.3499 12.0832L10.868 13.2467C10.7304 13.5787 10.4666 13.8425 10.1346 13.9801C9.80257 14.1176 9.42951 14.1176 9.09748 13.9801L7.93486 13.4985C7.60282 13.3613 7.22988 13.3616 6.89805 13.4993L5.7346 13.9805C5.40275 14.1177 5.03001 14.1176 4.69825 13.9802C4.36648 13.8428 4.10283 13.5793 3.96521 13.2476L3.48315 12.0837C3.34587 11.7517 3.08236 11.4878 2.75056 11.35L1.58711 10.8681C1.25522 10.7306 0.991504 10.467 0.853921 10.1351C0.716339 9.80326 0.716152 9.43035 0.853403 9.09836L1.33498 7.9357C1.47217 7.60365 1.47189 7.2307 1.3342 6.89885L0.853315 5.73452C0.785135 5.57007 0.750029 5.39379 0.75 5.21575C0.749971 5.03772 0.785022 4.86143 0.853149 4.69696C0.921275 4.53248 1.02114 4.38303 1.14705 4.25717C1.27295 4.1313 1.42242 4.03148 1.58691 3.9634L2.74953 3.48181C3.08125 3.34465 3.34499 3.08147 3.48287 2.75004L3.96479 1.58654C4.10232 1.2545 4.36612 0.990689 4.69815 0.853153C5.03018 0.715616 5.40325 0.715616 5.73528 0.853153L6.8979 1.33474C7.22994 1.47194 7.60287 1.47166 7.9347 1.33396L9.09865 0.853899C9.43063 0.71644 9.80362 0.716468 10.1356 0.853978C10.4676 0.991487 10.7313 1.25522 10.8689 1.58718L11.3509 2.75102L11.3508 2.749Z",
          stroke: "#444CE7",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])])) : _("", !0),
      n.icon === "youtube" ? (v(), C("svg", DC, [
        y("path", {
          d: "M14.3876 4.7999C14.3156 4.51229 14.169 4.24876 13.9626 4.03595C13.7561 3.82313 13.4972 3.66856 13.2119 3.58785C12.1695 3.33331 8.00004 3.33331 8.00004 3.33331C8.00004 3.33331 3.83056 3.33331 2.78819 3.61209C2.5029 3.6928 2.24396 3.84737 2.03753 4.06019C1.8311 4.273 1.68448 4.53653 1.61249 4.82414C1.42172 5.882 1.32841 6.95513 1.33372 8.03004C1.32692 9.11304 1.42024 10.1944 1.61249 11.2602C1.69186 11.5389 1.84176 11.7924 2.04771 11.9962C2.25366 12.2 2.5087 12.3473 2.78819 12.4238C3.83056 12.7025 8.00004 12.7025 8.00004 12.7025C8.00004 12.7025 12.1695 12.7025 13.2119 12.4238C13.4972 12.343 13.7561 12.1885 13.9626 11.9756C14.169 11.7628 14.3156 11.4993 14.3876 11.2117C14.5769 10.1618 14.6702 9.09685 14.6664 8.03004C14.6732 6.94704 14.5798 5.86573 14.3876 4.7999Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, NC),
        y("path", {
          d: "M6.50004 6.3102C6.50004 5.99201 6.50004 5.83292 6.56654 5.7441C6.62448 5.6667 6.71318 5.61827 6.80963 5.61138C6.9203 5.60348 7.05412 5.68951 7.32178 5.86157L9.95032 7.55135C10.1826 7.70066 10.2987 7.77531 10.3388 7.87024C10.3739 7.95318 10.3739 8.04678 10.3388 8.12972C10.2987 8.22465 10.1826 8.2993 9.95032 8.44861L7.32178 10.1384C7.05412 10.3105 6.9203 10.3965 6.80963 10.3886C6.71318 10.3817 6.62448 10.3333 6.56654 10.2559C6.50004 10.167 6.50004 10.0079 6.50004 9.68976V6.3102Z",
          stroke: r.value,
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, PC)
      ])) : _("", !0)
    ], 38));
  }
}), LC = { class: "ml-2" }, RC = { class: "block text-mgm-txt-xs font-normal text-foreground-default" }, WG = /* @__PURE__ */ H({
  __name: "BaseAlert",
  props: {
    open: { type: Boolean, default: !1 },
    type: { default: "default" },
    title: { default: null },
    description: { default: null }
  },
  setup(n) {
    const e = n, t = L(() => e.type === "default" ? {
      background: "bg-background-subtle",
      color: "var(--color-foreground-emphasis)",
      icon: "info"
    } : e.type === "info" ? {
      background: "bg-background-brand-default",
      color: "var(--color-foreground-brand-default)",
      icon: "info"
    } : e.type === "success" ? {
      background: "bg-background-success-default",
      color: "var(--color-foreground-success-default)",
      icon: "check-circle"
    } : e.type === "attention" ? {
      background: "bg-background-warning-default",
      color: "var(--color-foreground-warning-default)",
      icon: "alert-triangle"
    } : e.type === "error" ? {
      background: "bg-background-danger-default",
      color: "var(--color-foreground-danger-default)",
      icon: "slash"
    } : {
      background: "bg-background-subtle",
      color: "var(--color-foreground-emphasis)",
      icon: "info"
    });
    return (o, i) => (v(), V(S2, { to: "body" }, [
      n.open ? (v(), C("div", {
        key: 0,
        role: "alert",
        class: J([
          "fixed bottom-6 right-6 z-[2147483647] flex min-w-[343px] max-w-[400px] animate-slideUpAndFade items-start rounded-[5px] p-3 shadow-[0px_12px_16px_-4px_rgba(28,31,39,0.08),0px_4px_6px_-2px_rgba(28,31,39,0.03)]",
          t.value.background
        ])
      }, [
        U(ye, {
          class: "pt-px",
          color: t.value.color,
          icon: t.value.icon
        }, null, 8, ["color", "icon"]),
        y("p", LC, [
          y("span", {
            class: "block text-mgm-txt-sm font-medium",
            style: He({ color: t.value.color })
          }, j(n.title), 5),
          y("span", RC, j(n.description), 1)
        ])
      ], 2)) : _("", !0)
    ]));
  }
}), FC = ["alt", "src"], BC = { class: "uppercase" }, VC = {
  key: 1,
  class: "flex items-center space-x-2 text-foreground-emphasis"
}, zC = { class: "flex flex-shrink-0 -space-x-1" }, HC = {
  key: 0,
  class: "flex-shrink-0"
}, jC = { key: 1 }, UG = /* @__PURE__ */ H({
  __name: "BaseAvatar",
  props: {
    type: { default: "single" },
    size: { default: "sd" },
    shape: { default: "circle" },
    border: { type: Boolean, default: !1 },
    src: { default: null },
    fallback: { default: "" },
    alt: { default: "" },
    groupAvatarsUrls: { default: () => [] },
    groupCustomSize: { default: "sm" },
    groupCustomTotalUsers: { default: null },
    plus: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (e, t) => {
      var r, s, a;
      const o = _2("BaseAvatar", !0), i = f1("tooltip");
      return n.type === "single" ? (v(), C("div", {
        key: 0,
        class: J([
          "overflow-hidden",
          {
            "h-4 w-4": n.size === "2xs",
            "h-5 w-5": n.size === "xs",
            "h-6 w-6": n.size === "sm",
            "h-8 w-8": n.size === "sd",
            "h-10 w-10": n.size === "md",
            "h-12 w-12": n.size === "lg",
            "h-16 w-16": n.size === "xl",
            "h-[120px] w-[120px]": n.size === "2xl",
            "w-full": n.size === "full",
            "rounded-full": n.shape === "circle",
            "rounded-none": n.shape === "squared",
            "rounded-[5px]": n.shape === "rounded",
            "border-2 border-border-on-emphasis": n.border
          }
        ])
      }, [
        n.src ? (v(), C("img", {
          key: 0,
          class: "h-full w-full object-cover",
          alt: n.alt,
          src: n.src
        }, null, 8, FC)) : (v(), C("div", {
          key: 1,
          class: J([
            "flex h-full w-full items-center justify-center bg-background-subtle font-semibold uppercase text-foreground-default",
            {
              "text-mgm-txt-xs": n.size === "xs" || n.size === "sm" || n.size === "sd",
              "text-mgm-txt-sm": n.size === "md" || n.size === "lg" || n.size === "xl",
              "text-mgm-dspl-xs": n.size === "2xl" || n.size === "full"
            }
          ])
        }, [
          y("span", BC, j(n.fallback), 1)
        ], 2))
      ], 2)) : n.type === "group" ? (v(), C("div", VC, [
        y("div", zC, [
          n.plus ? (v(), C("div", {
            key: 0,
            class: J([
              "flex items-center justify-center rounded-full  bg-background-subtle text-[10px] font-semibold text-foreground-default ring-[1.5px] ring-border-on-emphasis",
              {
                "h-6 w-6": n.groupCustomSize === "sm",
                "h-8 w-8": n.groupCustomSize === "sd"
              }
            ])
          }, " + ", 2)) : _("", !0),
          (v(!0), C(re, null, De(n.groupAvatarsUrls, (l, d) => vo((v(), V(o, {
            key: d,
            class: "ring-2 ring-border-on-emphasis",
            src: l.url,
            size: n.groupCustomSize
          }, null, 8, ["src", "size"])), [
            [i, l.tooltip]
          ])), 128)),
          n.groupCustomTotalUsers && (n.groupCustomTotalUsers > ((r = n.groupAvatarsUrls) == null ? void 0 : r.length) || n.groupCustomTotalUsers === 0) ? (v(), C("div", {
            key: 1,
            class: J([
              "flex max-w-none items-center justify-center rounded-full bg-background-subtle p-1 pr-2 text-center text-[10px] font-semibold text-foreground-default ring-2 ring-border-on-emphasis",
              {
                "h-6 w-6": n.groupCustomSize === "sm",
                "h-8 w-8": n.groupCustomSize === "sd"
              }
            ])
          }, [
            n.groupCustomTotalUsers > ((s = n.groupAvatarsUrls) == null ? void 0 : s.length) ? (v(), C("span", HC, " +" + j(n.groupCustomTotalUsers - ((a = n.groupAvatarsUrls) == null ? void 0 : a.length)), 1)) : n.groupCustomTotalUsers === 0 ? (v(), C("span", jC, j(n.groupCustomTotalUsers), 1)) : _("", !0)
          ], 2)) : _("", !0)
        ])
      ])) : _("", !0);
    };
  }
}), Jc = /* @__PURE__ */ H({
  __name: "BaseBadge",
  props: {
    size: { default: "sm" },
    color: { default: "blue" },
    text: { default: void 0 },
    iconType: { default: "none" },
    iconName: { default: void 0 },
    link: { default: void 0 }
  },
  setup(n) {
    const e = n, t = L(() => {
      switch (e.color) {
        case "blue":
          return {
            badge: "bg-background-brand-default-hover text-foreground-brand-default",
            icon: "var(--color-foreground-brand-default)"
          };
        case "green":
          return {
            badge: "bg-background-success-default text-foreground-success-default",
            icon: "var(--color-foreground-success-default)"
          };
        case "grey":
          return {
            badge: "bg-background-subtle text-foreground-default",
            icon: "var(--color-foreground-default)"
          };
        case "navy":
          return { badge: "bg-[#F8F9FC] text-[#3E4784]", icon: "#3E4784" };
        case "purple":
          return { badge: "bg-[#F4F3FF] text-[#6938EF]", icon: "#6938EF" };
        case "red":
          return {
            badge: "bg-background-danger-subtle text-foreground-danger-default",
            icon: "var(--color-foreground-danger-default)"
          };
        case "yellow":
          return {
            badge: "bg-background-warning-default text-foreground-warning-default",
            icon: "var(--color-foreground-warning-default)"
          };
        default:
          return {
            badge: "bg-background-brand-default-hover text-foreground-brand-default",
            icon: "var(--color-foreground-brand-default)"
          };
      }
    });
    return (o, i) => (v(), V(qr(n.link ? "a" : "div"), {
      class: J([
        "flex w-fit items-center justify-center rounded-[48px] font-medium",
        t.value.badge,
        {
          "h-4 min-w-[44px] px-1.5 py-0.5 text-mgm-txt-xs": n.size === "xs",
          "h-6 min-w-[53px] px-2 py-0.5  text-mgm-txt-sm": n.size === "sm",
          // Default
          "h-7 min-w-[57px] px-2.5 py-1 text-mgm-txt-sm": n.size === "md",
          "h-8 min-w-[61px] px-3 py-1.5 text-mgm-txt-sm": n.size === "lg"
        }
      ]),
      href: n.link,
      target: "_blank"
    }, {
      default: B(() => [
        n.iconType === "custom" ? le(o.$slots, "icon", { key: 0 }) : n.iconType === "dot" ? (v(), C(re, { key: 1 }, [
          Se("•")
        ], 64)) : n.iconType === "icon" && n.iconName ? (v(), V(ye, {
          key: 2,
          icon: n.iconName,
          color: t.value.icon,
          size: n.size === "lg" ? 14 : 12
        }, null, 8, ["icon", "color", "size"])) : _("", !0),
        y("span", {
          class: J([
            "truncate",
            {
              "pl-1": n.iconType !== "none" && ["xs", "sm"].includes(n.size),
              "pl-1.5": n.iconType !== "none" && n.size === "md",
              "pl-2": n.iconType !== "none" && n.size === "lg"
            }
          ])
        }, [
          le(o.$slots, "default", {}, () => [
            Se(j(n.text), 1)
          ])
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "href"]));
  }
}), WC = { class: "mb-5" }, UC = { class: "text-mgm-txt-sm font-normal" }, KC = { class: "text-foreground-subtle" }, KG = /* @__PURE__ */ H({
  __name: "BaseBreadcrumb",
  props: {
    current: {},
    previous: {}
  },
  setup(n) {
    return (e, t) => {
      const o = _2("RouterLink");
      return v(), C("nav", WC, [
        y("p", UC, [
          U(o, {
            class: "text-foreground-default",
            to: { name: `${n.previous.route}` }
          }, {
            default: B(() => [
              Se(j(n.previous.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          y("span", KC, j(` / ${n.current}`), 1)
        ])
      ]);
    };
  }
}), GC = ["disabled", "type"], Ul = /* @__PURE__ */ H({
  __name: "BaseButton",
  props: {
    customColor: { default: null },
    customRgbColor: { default: null },
    danger: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    icon: { default: "" },
    iconPosition: { default: "left" },
    size: { default: "sm" },
    state: { default: "primary" },
    text: { default: "" },
    type: { default: "button" }
  },
  setup(n) {
    const e = n, t = L(() => ({
      prmr: "primary",
      scdr: "secondary",
      trtr: "tertiary"
    })[e.state] ?? e.state), o = L(() => e.disabled ? t.value === "secondary" ? e.danger ? "var(--color-background-danger-disabled)" : "var(--color-foreground-subtle)" : t.value === "tertiary" ? e.danger ? "var(--color-background-danger-disabled)" : "var(--color-background-brand-disabled)" : "var(--color-foreground-on-emphasis)" : t.value === "secondary" ? e.danger ? "var(--color-foreground-danger-default)" : "var(--color-foreground-default)" : t.value === "tertiary" ? e.danger ? "var(--color-foreground-danger-default)" : "var(--color-foreground-brand-default)" : "var(--color-foreground-on-emphasis)");
    return We(() => {
    }), (i, r) => (v(), C("button", {
      class: J([
        "box-border rounded-3xl border text-mgm-txt-sm font-medium disabled:cursor-not-allowed",
        {
          "flex items-center justify-center gap-2": n.icon,
          "flex-row-reverse": n.icon && n.iconPosition === "right",
          // size
          "px-[13px] py-[7px]": n.size === "sm",
          "px-[15px] py-[9px]": n.size === "md",
          "px-[17px] py-[11px]": n.size === "lg",
          "px-[23px] py-[13px]": n.size === "xl",
          // state primary
          "text-foreground-on-emphasis shadow-[0_1px_2px_rgba(28,31,39,0.05)]": t.value === "primary",
          "focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-border-brand-default": t.value === "primary" && !n.danger,
          "border-border-brand-emphasis bg-background-brand-emphasis enabled:hover:border-foreground-brand-hover enabled:hover:bg-background-brand-emphasis-hover disabled:border-background-brand-disabled disabled:bg-background-brand-disabled": t.value === "primary" && !n.danger && !n.customColor,
          "border-border-danger-emphasis bg-background-danger-emphasis enabled:hover:border-background-danger-emphasis-hover enabled:hover:bg-background-danger-emphasis-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-border-danger-default disabled:border-background-danger-disabled disabled:bg-background-danger-disabled": t.value === "primary" && n.danger,
          // state secondary
          "shadow-[0_1px_2px_rgba(28,31,39,0.05)]": t.value === "secondary",
          "border-border-subtle text-foreground-default bg-background-default enabled:hover:border-border-default enabled:hover:text-foreground-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-background-subtle disabled:!border-background-subtle disabled:!text-foreground-subtle": t.value === "secondary" && !n.danger,
          "border-border-danger-default text-foreground-danger-default enabled:hover:border-background-danger-disabled enabled:hover:text-background-danger-emphasis-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-border-danger-default disabled:border-background-danger-subtle disabled:text-background-danger-disabled": t.value === "secondary" && n.danger,
          // state tertiary
          "border-transparent shadow-none": t.value === "tertiary",
          "text-foreground-brand-default enabled:hover:text-foreground-brand-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-border-brand-default disabled:text-background-brand-disabled": t.value === "tertiary" && !n.danger,
          " text-foreground-danger-default enabled:hover:text-background-danger-emphasis-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-border-danger-default disabled:text-background-danger-disabled": t.value === "tertiary" && n.danger,
          // custom color
          "enabled:hover:opacity-40": n.customColor
        }
      ]),
      style: He({
        borderColor: n.customColor ? n.customColor && n.disabled ? "transparent" : n.customColor : void 0,
        backgroundColor: n.customColor ? n.customColor && n.disabled ? `rgba(${n.customRgbColor}, 0.2)` : n.customColor : void 0
      }),
      disabled: n.disabled,
      type: n.type
    }, [
      n.icon ? (v(), V(ye, {
        key: 0,
        color: o.value,
        icon: n.icon
      }, null, 8, ["color", "icon"])) : _("", !0),
      Se(" " + j(n.text) + " ", 1),
      le(i.$slots, "default")
    ], 14, GC));
  }
});
/*!
  * shared v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Vo = typeof window < "u";
let _n, rr;
if (process.env.NODE_ENV !== "production") {
  const n = Vo && window.performance;
  n && n.mark && n.measure && n.clearMarks && // @ts-ignore browser compat
  n.clearMeasures && (_n = (e) => {
    n.mark(e);
  }, rr = (e, t, o) => {
    n.measure(e, t, o), n.clearMarks(t), n.clearMarks(o);
  });
}
const YC = /\{([0-9a-zA-Z]+)\}/g;
function L2(n, ...e) {
  return e.length === 1 && qe(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), n.replace(YC, (t, o) => e.hasOwnProperty(o) ? e[o] : "");
}
const Ko = (n, e = !1) => e ? Symbol.for(n) : Symbol(n), qC = (n, e, t) => ZC({ l: n, k: e, s: t }), ZC = (n) => JSON.stringify(n).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), qt = (n) => typeof n == "number" && isFinite(n), JC = (n) => F2(n) === "[object Date]", Kl = (n) => F2(n) === "[object RegExp]", au = (n) => Ke(n) && Object.keys(n).length === 0, Xt = Object.assign;
let s0;
const g1 = () => s0 || (s0 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function a0(n) {
  return n.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const XC = Object.prototype.hasOwnProperty;
function Gl(n, e) {
  return XC.call(n, e);
}
const Et = Array.isArray, ft = (n) => typeof n == "function", ge = (n) => typeof n == "string", $t = (n) => typeof n == "boolean", qe = (n) => n !== null && typeof n == "object", QC = (n) => qe(n) && ft(n.then) && ft(n.catch), R2 = Object.prototype.toString, F2 = (n) => R2.call(n), Ke = (n) => {
  if (!qe(n))
    return !1;
  const e = Object.getPrototypeOf(n);
  return e === null || e.constructor === Object;
}, ew = (n) => n == null ? "" : Et(n) || Ke(n) && n.toString === R2 ? JSON.stringify(n, null, 2) : String(n);
function tw(n, e = "") {
  return n.reduce((t, o, i) => i === 0 ? t + o : t + e + o, "");
}
const l0 = 2;
function nw(n, e = 0, t = n.length) {
  const o = n.split(/\r?\n/);
  let i = 0;
  const r = [];
  for (let s = 0; s < o.length; s++)
    if (i += o[s].length + 1, i >= e) {
      for (let a = s - l0; a <= s + l0 || t > i; a++) {
        if (a < 0 || a >= o.length)
          continue;
        const l = a + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[a]}`);
        const d = o[a].length;
        if (a === s) {
          const u = e - (i - d) + 1, c = Math.max(1, t > i ? d - u : t - e);
          r.push("   |  " + " ".repeat(u) + "^".repeat(c));
        } else if (a > s) {
          if (t > i) {
            const u = Math.max(Math.min(t - i, d), 1);
            r.push("   |  " + "^".repeat(u));
          }
          i += d + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function v1(n) {
  let e = n;
  return () => ++e;
}
function ms(n, e) {
  typeof console < "u" && (console.warn("[intlify] " + n), e && console.warn(e.stack));
}
const d0 = {};
function ow(n) {
  d0[n] || (d0[n] = !0, ms(n));
}
function iw() {
  const n = /* @__PURE__ */ new Map();
  return {
    events: n,
    on(t, o) {
      const i = n.get(t);
      i && i.push(o) || n.set(t, [o]);
    },
    off(t, o) {
      const i = n.get(t);
      i && i.splice(i.indexOf(o) >>> 0, 1);
    },
    emit(t, o) {
      (n.get(t) || []).slice().map((i) => i(o)), (n.get("*") || []).slice().map((i) => i(t, o));
    }
  };
}
const Za = (n) => !qe(n) || Et(n);
function Il(n, e) {
  if (Za(n) || Za(e))
    throw new Error("Invalid value");
  const t = [{ src: n, des: e }];
  for (; t.length; ) {
    const { src: o, des: i } = t.pop();
    Object.keys(o).forEach((r) => {
      Za(o[r]) || Za(i[r]) ? i[r] = o[r] : t.push({ src: o[r], des: i[r] });
    });
  }
}
/*!
  * message-compiler v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const rw = /\{([0-9a-zA-Z]+)\}/g;
function sw(n, ...e) {
  return e.length === 1 && aw(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), n.replace(rw, (t, o) => e.hasOwnProperty(o) ? e[o] : "");
}
const aw = (n) => n !== null && typeof n == "object", Ft = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, lw = {
  // tokenizer error messages
  [Ft.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Ft.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Ft.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Ft.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Ft.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Ft.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Ft.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Ft.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Ft.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Ft.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Ft.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Ft.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Ft.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Ft.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Ft.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Ft.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function B2(n, e, t = {}) {
  const { domain: o, messages: i, args: r } = t, s = sw((i || lw)[n] || "", ...r || []), a = new SyntaxError(String(s));
  return a.code = n, a.domain = o, a;
}
/*!
  * core-base v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function dw() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (g1().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Ti = [];
Ti[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ti[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ti[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Ti[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Ti[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Ti[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Ti[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const uw = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function cw(n) {
  return uw.test(n);
}
function fw(n) {
  const e = n.charCodeAt(0), t = n.charCodeAt(n.length - 1);
  return e === t && (e === 34 || e === 39) ? n.slice(1, -1) : n;
}
function hw(n) {
  if (n == null)
    return "o";
  switch (n.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return n;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function pw(n) {
  const e = n.trim();
  return n.charAt(0) === "0" && isNaN(parseInt(n)) ? !1 : cw(e) ? fw(e) : "*" + e;
}
function mw(n) {
  const e = [];
  let t = -1, o = 0, i = 0, r, s, a, l, d, u, c;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    s === void 0 ? s = a : s += a;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    s !== void 0 && (e.push(s), s = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), i++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, o = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (i = 0, s === void 0 || (s = pw(s), s === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const p = n[t + 1];
    if (o === 5 && p === "'" || o === 6 && p === '"')
      return t++, a = "\\" + p, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (t++, r = n[t], !(r === "\\" && h())) {
      if (l = hw(r), c = Ti[o], d = c[l] || c.l || 8, d === 8 || (o = d[0], d[1] !== void 0 && (u = f[d[1]], u && (a = r, u() === !1))))
        return;
      if (o === 7)
        return e;
    }
}
const u0 = /* @__PURE__ */ new Map();
function gw(n, e) {
  return qe(n) ? n[e] : null;
}
function vw(n, e) {
  if (!qe(n))
    return null;
  let t = u0.get(e);
  if (t || (t = mw(e), t && u0.set(e, t)), !t)
    return null;
  const o = t.length;
  let i = n, r = 0;
  for (; r < o; ) {
    const s = i[t[r]];
    if (s === void 0 || ft(i))
      return null;
    i = s, r++;
  }
  return i;
}
const bw = (n) => n, yw = (n) => "", xw = "text", Cw = (n) => n.length === 0 ? "" : tw(n), ww = ew;
function c0(n, e) {
  return n = Math.abs(n), e === 2 ? n ? n > 1 ? 1 : 0 : 1 : n ? Math.min(n, 2) : 0;
}
function kw(n) {
  const e = qt(n.pluralIndex) ? n.pluralIndex : -1;
  return n.named && (qt(n.named.count) || qt(n.named.n)) ? qt(n.named.count) ? n.named.count : qt(n.named.n) ? n.named.n : e : e;
}
function $w(n, e) {
  e.count || (e.count = n), e.n || (e.n = n);
}
function Mw(n = {}) {
  const e = n.locale, t = kw(n), o = qe(n.pluralRules) && ge(e) && ft(n.pluralRules[e]) ? n.pluralRules[e] : c0, i = qe(n.pluralRules) && ge(e) && ft(n.pluralRules[e]) ? c0 : void 0, r = (b) => b[o(t, b.length, i)], s = n.list || [], a = (b) => s[b], l = n.named || {};
  qt(n.pluralIndex) && $w(t, l);
  const d = (b) => l[b];
  function u(b) {
    const x = ft(n.messages) ? n.messages(b) : qe(n.messages) ? n.messages[b] : !1;
    return x || (n.parent ? n.parent.message(b) : yw);
  }
  const c = (b) => n.modifiers ? n.modifiers[b] : bw, f = Ke(n.processor) && ft(n.processor.normalize) ? n.processor.normalize : Cw, h = Ke(n.processor) && ft(n.processor.interpolate) ? n.processor.interpolate : ww, p = Ke(n.processor) && ge(n.processor.type) ? n.processor.type : xw, g = {
    list: a,
    named: d,
    plural: r,
    linked: (b, ...x) => {
      const [w, M] = x;
      let $ = "text", T = "";
      x.length === 1 ? qe(w) ? (T = w.modifier || T, $ = w.type || $) : ge(w) && (T = w || T) : x.length === 2 && (ge(w) && (T = w || T), ge(M) && ($ = M || $));
      const E = u(b)(g), S = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        $ === "vnode" && Et(E) && T ? E[0] : E
      );
      return T ? c(T)(S, $) : S;
    },
    message: u,
    type: p,
    interpolate: h,
    normalize: f,
    values: Xt({}, s, l)
  };
  return g;
}
let ua = null;
function Sw(n) {
  ua = n;
}
function _w(n, e, t) {
  ua && ua.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: n,
    version: e,
    meta: t
  });
}
const Ew = /* @__PURE__ */ Ow(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Ow(n) {
  return (e) => ua && ua.emit(n, e);
}
const an = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, Tw = {
  [an.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [an.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [an.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [an.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [an.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [an.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [an.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function sr(n, ...e) {
  return L2(Tw[n], ...e);
}
const V2 = Ft.__EXTEND_POINT__, Fi = v1(V2), Vt = {
  INVALID_ARGUMENT: V2,
  INVALID_DATE_ARGUMENT: Fi(),
  INVALID_ISO_DATE_ARGUMENT: Fi(),
  NOT_SUPPORT_NON_STRING_MESSAGE: Fi(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Fi(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Fi(),
  NOT_SUPPORT_LOCALE_TYPE: Fi(),
  __EXTEND_POINT__: Fi()
  // 25
};
function No(n) {
  return B2(n, null, process.env.NODE_ENV !== "production" ? { messages: Aw } : void 0);
}
const Aw = {
  [Vt.INVALID_ARGUMENT]: "Invalid arguments",
  [Vt.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Vt.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Vt.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Vt.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Vt.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Vt.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function b1(n, e) {
  return e.locale != null ? f0(e.locale) : f0(n.locale);
}
let Uu;
function f0(n) {
  if (ge(n))
    return n;
  if (ft(n)) {
    if (n.resolvedOnce && Uu != null)
      return Uu;
    if (n.constructor.name === "Function") {
      const e = n();
      if (QC(e))
        throw No(Vt.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Uu = e;
    } else
      throw No(Vt.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw No(Vt.NOT_SUPPORT_LOCALE_TYPE);
}
function Iw(n, e, t) {
  return [.../* @__PURE__ */ new Set([
    t,
    ...Et(e) ? e : qe(e) ? Object.keys(e) : ge(e) ? [e] : [t]
  ])];
}
function z2(n, e, t) {
  const o = ge(t) ? t : Yl, i = n;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let r = i.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let s = [t];
    for (; Et(s); )
      s = h0(r, s, e);
    const a = Et(e) || !Ke(e) ? e : e.default ? e.default : null;
    s = ge(a) ? [a] : a, Et(s) && h0(r, s, !1), i.__localeChainCache.set(o, r);
  }
  return r;
}
function h0(n, e, t) {
  let o = !0;
  for (let i = 0; i < e.length && $t(o); i++) {
    const r = e[i];
    ge(r) && (o = Dw(n, e[i], t));
  }
  return o;
}
function Dw(n, e, t) {
  let o;
  const i = e.split("-");
  do {
    const r = i.join("-");
    o = Nw(n, r, t), i.splice(-1, 1);
  } while (i.length && o === !0);
  return o;
}
function Nw(n, e, t) {
  let o = !1;
  if (!n.includes(e) && (o = !0, e)) {
    o = e[e.length - 1] !== "!";
    const i = e.replace(/!/g, "");
    n.push(i), (Et(t) || Ke(t)) && t[i] && (o = t[i]);
  }
  return o;
}
const Pw = "9.9.0", lu = -1, Yl = "en-US", ql = "", p0 = (n) => `${n.charAt(0).toLocaleUpperCase()}${n.substr(1)}`;
function Lw() {
  return {
    upper: (n, e) => e === "text" && ge(n) ? n.toUpperCase() : e === "vnode" && qe(n) && "__v_isVNode" in n ? n.children.toUpperCase() : n,
    lower: (n, e) => e === "text" && ge(n) ? n.toLowerCase() : e === "vnode" && qe(n) && "__v_isVNode" in n ? n.children.toLowerCase() : n,
    capitalize: (n, e) => e === "text" && ge(n) ? p0(n) : e === "vnode" && qe(n) && "__v_isVNode" in n ? p0(n.children) : n
  };
}
let Rw, H2;
function Fw(n) {
  H2 = n;
}
let j2;
function Bw(n) {
  j2 = n;
}
let W2 = null;
const Vw = /* @__NO_SIDE_EFFECTS__ */ (n) => {
  W2 = n;
}, zw = /* @__NO_SIDE_EFFECTS__ */ () => W2;
let U2 = null;
const m0 = (n) => {
  U2 = n;
}, Hw = () => U2;
let g0 = 0;
function jw(n = {}) {
  const e = ft(n.onWarn) ? n.onWarn : ms, t = ge(n.version) ? n.version : Pw, o = ge(n.locale) || ft(n.locale) ? n.locale : Yl, i = ft(o) ? Yl : o, r = Et(n.fallbackLocale) || Ke(n.fallbackLocale) || ge(n.fallbackLocale) || n.fallbackLocale === !1 ? n.fallbackLocale : i, s = Ke(n.messages) ? n.messages : { [i]: {} }, a = Ke(n.datetimeFormats) ? n.datetimeFormats : { [i]: {} }, l = Ke(n.numberFormats) ? n.numberFormats : { [i]: {} }, d = Xt({}, n.modifiers || {}, Lw()), u = n.pluralRules || {}, c = ft(n.missing) ? n.missing : null, f = $t(n.missingWarn) || Kl(n.missingWarn) ? n.missingWarn : !0, h = $t(n.fallbackWarn) || Kl(n.fallbackWarn) ? n.fallbackWarn : !0, p = !!n.fallbackFormat, m = !!n.unresolving, g = ft(n.postTranslation) ? n.postTranslation : null, b = Ke(n.processor) ? n.processor : null, x = $t(n.warnHtmlMessage) ? n.warnHtmlMessage : !0, w = !!n.escapeParameter, M = ft(n.messageCompiler) ? n.messageCompiler : Rw;
  process.env.NODE_ENV !== "production" && ft(n.messageCompiler) && ow(sr(an.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const $ = ft(n.messageResolver) ? n.messageResolver : H2 || gw, T = ft(n.localeFallbacker) ? n.localeFallbacker : j2 || Iw, E = qe(n.fallbackContext) ? n.fallbackContext : void 0, S = n, D = qe(S.__datetimeFormatters) ? S.__datetimeFormatters : /* @__PURE__ */ new Map(), I = qe(S.__numberFormatters) ? S.__numberFormatters : /* @__PURE__ */ new Map(), z = qe(S.__meta) ? S.__meta : {};
  g0++;
  const F = {
    version: t,
    cid: g0,
    locale: o,
    fallbackLocale: r,
    messages: s,
    modifiers: d,
    pluralRules: u,
    missing: c,
    missingWarn: f,
    fallbackWarn: h,
    fallbackFormat: p,
    unresolving: m,
    postTranslation: g,
    processor: b,
    warnHtmlMessage: x,
    escapeParameter: w,
    messageCompiler: M,
    messageResolver: $,
    localeFallbacker: T,
    fallbackContext: E,
    onWarn: e,
    __meta: z
  };
  return F.datetimeFormats = a, F.numberFormats = l, F.__datetimeFormatters = D, F.__numberFormatters = I, process.env.NODE_ENV !== "production" && (F.__v_emitter = S.__v_emitter != null ? S.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && _w(F, t, z), F;
}
function du(n, e) {
  return n instanceof RegExp ? n.test(e) : n;
}
function K2(n, e) {
  return n instanceof RegExp ? n.test(e) : n;
}
function y1(n, e, t, o, i) {
  const { missing: r, onWarn: s } = n;
  if (process.env.NODE_ENV !== "production") {
    const a = n.__v_emitter;
    a && a.emit("missing", {
      locale: t,
      key: e,
      type: i,
      groupId: `${i}:${e}`
    });
  }
  if (r !== null) {
    const a = r(n, t, e, i);
    return ge(a) ? a : e;
  } else
    return process.env.NODE_ENV !== "production" && K2(o, e) && s(sr(an.NOT_FOUND_KEY, { key: e, locale: t })), e;
}
function $s(n, e, t) {
  const o = n;
  o.__localeChainCache = /* @__PURE__ */ new Map(), n.localeFallbacker(n, t, e);
}
const Jr = (n) => qe(n) && (n.t === 0 || n.type === 0) && ("b" in n || "body" in n), v0 = () => "", Bn = (n) => ft(n);
function b0(n, ...e) {
  const { fallbackFormat: t, postTranslation: o, unresolving: i, messageCompiler: r, fallbackLocale: s, messages: a } = n, [l, d] = Xc(...e), u = $t(d.missingWarn) ? d.missingWarn : n.missingWarn, c = $t(d.fallbackWarn) ? d.fallbackWarn : n.fallbackWarn, f = $t(d.escapeParameter) ? d.escapeParameter : n.escapeParameter, h = !!d.resolvedMessage, p = ge(d.default) || $t(d.default) ? $t(d.default) ? r ? l : () => l : d.default : t ? r ? l : () => l : "", m = t || p !== "", g = b1(n, d);
  f && Ww(d);
  let [b, x, w] = h ? [
    l,
    g,
    a[g] || {}
  ] : G2(n, l, g, s, c, u), M = b, $ = l;
  if (!h && !(ge(M) || Jr(M) || Bn(M)) && m && (M = p, $ = M), !h && (!(ge(M) || Jr(M) || Bn(M)) || !ge(x)))
    return i ? lu : l;
  if (process.env.NODE_ENV !== "production" && ge(M) && n.messageCompiler == null)
    return ms(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let T = !1;
  const E = () => {
    T = !0;
  }, S = Bn(M) ? M : Y2(n, l, x, M, $, E);
  if (T)
    return M;
  const D = Yw(n, x, w, d), I = Mw(D), z = Uw(n, S, I), F = o ? o(z, l) : z;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Y = {
      timestamp: Date.now(),
      key: ge(l) ? l : Bn(M) ? M.key : "",
      locale: x || (Bn(M) ? M.locale : ""),
      format: ge(M) ? M : Bn(M) ? M.source : "",
      message: F
    };
    Y.meta = Xt({}, n.__meta, /* @__PURE__ */ zw() || {}), Ew(Y);
  }
  return F;
}
function Ww(n) {
  Et(n.list) ? n.list = n.list.map((e) => ge(e) ? a0(e) : e) : qe(n.named) && Object.keys(n.named).forEach((e) => {
    ge(n.named[e]) && (n.named[e] = a0(n.named[e]));
  });
}
function G2(n, e, t, o, i, r) {
  const { messages: s, onWarn: a, messageResolver: l, localeFallbacker: d } = n, u = d(n, o, t);
  let c = {}, f, h = null, p = t, m = null;
  const g = "translate";
  for (let b = 0; b < u.length; b++) {
    if (f = m = u[b], process.env.NODE_ENV !== "production" && t !== f && du(i, e) && a(sr(an.FALLBACK_TO_TRANSLATE, {
      key: e,
      target: f
    })), process.env.NODE_ENV !== "production" && t !== f) {
      const T = n.__v_emitter;
      T && T.emit("fallback", {
        type: g,
        key: e,
        from: p,
        to: m,
        groupId: `${g}:${e}`
      });
    }
    c = s[f] || {};
    let x = null, w, M;
    if (process.env.NODE_ENV !== "production" && Vo && (x = window.performance.now(), w = "intlify-message-resolve-start", M = "intlify-message-resolve-end", _n && _n(w)), (h = l(c, e)) === null && (h = c[e]), process.env.NODE_ENV !== "production" && Vo) {
      const T = window.performance.now(), E = n.__v_emitter;
      E && x && h && E.emit("message-resolve", {
        type: "message-resolve",
        key: e,
        message: h,
        time: T - x,
        groupId: `${g}:${e}`
      }), w && M && _n && rr && (_n(M), rr("intlify message resolve", w, M));
    }
    if (ge(h) || Jr(h) || Bn(h))
      break;
    const $ = y1(
      n,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      e,
      f,
      r,
      g
    );
    $ !== e && (h = $), p = m;
  }
  return [h, f, c];
}
function Y2(n, e, t, o, i, r) {
  const { messageCompiler: s, warnHtmlMessage: a } = n;
  if (Bn(o)) {
    const f = o;
    return f.locale = f.locale || t, f.key = f.key || e, f;
  }
  if (s == null) {
    const f = (() => o);
    return f.locale = t, f.key = e, f;
  }
  let l = null, d, u;
  process.env.NODE_ENV !== "production" && Vo && (l = window.performance.now(), d = "intlify-message-compilation-start", u = "intlify-message-compilation-end", _n && _n(d));
  const c = s(o, Kw(n, t, i, o, a, r));
  if (process.env.NODE_ENV !== "production" && Vo) {
    const f = window.performance.now(), h = n.__v_emitter;
    h && l && h.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: f - l,
      groupId: `translate:${e}`
    }), d && u && _n && rr && (_n(u), rr("intlify message compilation", d, u));
  }
  return c.locale = t, c.key = e, c.source = o, c;
}
function Uw(n, e, t) {
  let o = null, i, r;
  process.env.NODE_ENV !== "production" && Vo && (o = window.performance.now(), i = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", _n && _n(i));
  const s = e(t);
  if (process.env.NODE_ENV !== "production" && Vo) {
    const a = window.performance.now(), l = n.__v_emitter;
    l && o && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: s,
      time: a - o,
      groupId: `translate:${e.key}`
    }), i && r && _n && rr && (_n(r), rr("intlify message evaluation", i, r));
  }
  return s;
}
function Xc(...n) {
  const [e, t, o] = n, i = {};
  if (!ge(e) && !qt(e) && !Bn(e) && !Jr(e))
    throw No(Vt.INVALID_ARGUMENT);
  const r = qt(e) ? String(e) : (Bn(e), e);
  return qt(t) ? i.plural = t : ge(t) ? i.default = t : Ke(t) && !au(t) ? i.named = t : Et(t) && (i.list = t), qt(o) ? i.plural = o : ge(o) ? i.default = o : Ke(o) && Xt(i, o), [r, i];
}
function Kw(n, e, t, o, i, r) {
  return {
    locale: e,
    key: t,
    warnHtmlMessage: i,
    onError: (s) => {
      if (r && r(s), process.env.NODE_ENV !== "production") {
        const a = Gw(o), l = `Message compilation error: ${s.message}`, d = s.location && a && nw(a, s.location.start.offset, s.location.end.offset), u = n.__v_emitter;
        u && a && u.emit("compile-error", {
          message: a,
          error: s.message,
          start: s.location && s.location.start.offset,
          end: s.location && s.location.end.offset,
          groupId: `translate:${t}`
        }), console.error(d ? `${l}
${d}` : l);
      } else
        throw s;
    },
    onCacheKey: (s) => qC(e, t, s)
  };
}
function Gw(n) {
  if (ge(n))
    return n;
  if (n.loc && n.loc.source)
    return n.loc.source;
}
function Yw(n, e, t, o) {
  const { modifiers: i, pluralRules: r, messageResolver: s, fallbackLocale: a, fallbackWarn: l, missingWarn: d, fallbackContext: u } = n, f = {
    locale: e,
    modifiers: i,
    pluralRules: r,
    messages: (h) => {
      let p = s(t, h);
      if (p == null && u) {
        const [, , m] = G2(u, h, e, a, l, d);
        p = s(m, h);
      }
      if (ge(p) || Jr(p)) {
        let m = !1;
        const b = Y2(n, h, e, p, h, () => {
          m = !0;
        });
        return m ? v0 : b;
      } else return Bn(p) ? p : v0;
    }
  };
  return n.processor && (f.processor = n.processor), o.list && (f.list = o.list), o.named && (f.named = o.named), qt(o.plural) && (f.pluralIndex = o.plural), f;
}
const y0 = typeof Intl < "u", q2 = {
  dateTimeFormat: y0 && typeof Intl.DateTimeFormat < "u",
  numberFormat: y0 && typeof Intl.NumberFormat < "u"
};
function x0(n, ...e) {
  const { datetimeFormats: t, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: s } = n, { __datetimeFormatters: a } = n;
  if (process.env.NODE_ENV !== "production" && !q2.dateTimeFormat)
    return r(sr(an.CANNOT_FORMAT_DATE)), ql;
  const [l, d, u, c] = Qc(...e), f = $t(u.missingWarn) ? u.missingWarn : n.missingWarn, h = $t(u.fallbackWarn) ? u.fallbackWarn : n.fallbackWarn, p = !!u.part, m = b1(n, u), g = s(
    n,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    m
  );
  if (!ge(l) || l === "")
    return new Intl.DateTimeFormat(m, c).format(d);
  let b = {}, x, w = null, M = m, $ = null;
  const T = "datetime format";
  for (let D = 0; D < g.length; D++) {
    if (x = $ = g[D], process.env.NODE_ENV !== "production" && m !== x && du(h, l) && r(sr(an.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: x
    })), process.env.NODE_ENV !== "production" && m !== x) {
      const I = n.__v_emitter;
      I && I.emit("fallback", {
        type: T,
        key: l,
        from: M,
        to: $,
        groupId: `${T}:${l}`
      });
    }
    if (b = t[x] || {}, w = b[l], Ke(w))
      break;
    y1(n, l, x, f, T), M = $;
  }
  if (!Ke(w) || !ge(x))
    return o ? lu : l;
  let E = `${x}__${l}`;
  au(c) || (E = `${E}__${JSON.stringify(c)}`);
  let S = a.get(E);
  return S || (S = new Intl.DateTimeFormat(x, Xt({}, w, c)), a.set(E, S)), p ? S.formatToParts(d) : S.format(d);
}
const Z2 = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Qc(...n) {
  const [e, t, o, i] = n, r = {};
  let s = {}, a;
  if (ge(e)) {
    const l = e.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw No(Vt.INVALID_ISO_DATE_ARGUMENT);
    const d = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    a = new Date(d);
    try {
      a.toISOString();
    } catch {
      throw No(Vt.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (JC(e)) {
    if (isNaN(e.getTime()))
      throw No(Vt.INVALID_DATE_ARGUMENT);
    a = e;
  } else if (qt(e))
    a = e;
  else
    throw No(Vt.INVALID_ARGUMENT);
  return ge(t) ? r.key = t : Ke(t) && Object.keys(t).forEach((l) => {
    Z2.includes(l) ? s[l] = t[l] : r[l] = t[l];
  }), ge(o) ? r.locale = o : Ke(o) && (s = o), Ke(i) && (s = i), [r.key || "", a, r, s];
}
function C0(n, e, t) {
  const o = n;
  for (const i in t) {
    const r = `${e}__${i}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function w0(n, ...e) {
  const { numberFormats: t, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: s } = n, { __numberFormatters: a } = n;
  if (process.env.NODE_ENV !== "production" && !q2.numberFormat)
    return r(sr(an.CANNOT_FORMAT_NUMBER)), ql;
  const [l, d, u, c] = ef(...e), f = $t(u.missingWarn) ? u.missingWarn : n.missingWarn, h = $t(u.fallbackWarn) ? u.fallbackWarn : n.fallbackWarn, p = !!u.part, m = b1(n, u), g = s(
    n,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    m
  );
  if (!ge(l) || l === "")
    return new Intl.NumberFormat(m, c).format(d);
  let b = {}, x, w = null, M = m, $ = null;
  const T = "number format";
  for (let D = 0; D < g.length; D++) {
    if (x = $ = g[D], process.env.NODE_ENV !== "production" && m !== x && du(h, l) && r(sr(an.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: x
    })), process.env.NODE_ENV !== "production" && m !== x) {
      const I = n.__v_emitter;
      I && I.emit("fallback", {
        type: T,
        key: l,
        from: M,
        to: $,
        groupId: `${T}:${l}`
      });
    }
    if (b = t[x] || {}, w = b[l], Ke(w))
      break;
    y1(n, l, x, f, T), M = $;
  }
  if (!Ke(w) || !ge(x))
    return o ? lu : l;
  let E = `${x}__${l}`;
  au(c) || (E = `${E}__${JSON.stringify(c)}`);
  let S = a.get(E);
  return S || (S = new Intl.NumberFormat(x, Xt({}, w, c)), a.set(E, S)), p ? S.formatToParts(d) : S.format(d);
}
const J2 = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function ef(...n) {
  const [e, t, o, i] = n, r = {};
  let s = {};
  if (!qt(e))
    throw No(Vt.INVALID_ARGUMENT);
  const a = e;
  return ge(t) ? r.key = t : Ke(t) && Object.keys(t).forEach((l) => {
    J2.includes(l) ? s[l] = t[l] : r[l] = t[l];
  }), ge(o) ? r.locale = o : Ke(o) && (s = o), Ke(i) && (s = i), [r.key || "", a, r, s];
}
function k0(n, e, t) {
  const o = n;
  for (const i in t) {
    const r = `${e}__${i}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
dw();
/*!
  * vue-i18n v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const qw = "9.9.0";
function Zw() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (g1().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const X2 = an.__EXTEND_POINT__, Xo = v1(X2), Rn = {
  FALLBACK_TO_ROOT: X2,
  NOT_SUPPORTED_PRESERVE: Xo(),
  NOT_SUPPORTED_FORMATTER: Xo(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Xo(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: Xo(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: Xo(),
  NOT_FOUND_PARENT_SCOPE: Xo(),
  IGNORE_OBJ_FLATTEN: Xo(),
  NOTICE_DROP_ALLOW_COMPOSITION: Xo()
  // 17
}, Jw = {
  [Rn.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Rn.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Rn.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Rn.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Rn.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Rn.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Rn.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Rn.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Rn.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function x1(n, ...e) {
  return L2(Jw[n], ...e);
}
const Q2 = Vt.__EXTEND_POINT__, pn = v1(Q2), kt = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Q2,
  // legacy module errors
  INVALID_ARGUMENT: pn(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: pn(),
  NOT_INSTALLED: pn(),
  NOT_AVAILABLE_IN_LEGACY_MODE: pn(),
  // directive module errors
  REQUIRED_VALUE: pn(),
  INVALID_VALUE: pn(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: pn(),
  NOT_INSTALLED_WITH_PROVIDE: pn(),
  // unexpected error
  UNEXPECTED_ERROR: pn(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: pn(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: pn(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: pn(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: pn(),
  // for enhancement
  __EXTEND_POINT__: pn()
  // 40
};
function ca(n, ...e) {
  return B2(n, null, process.env.NODE_ENV !== "production" ? { messages: Xw, args: e } : void 0);
}
const Xw = {
  [kt.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [kt.INVALID_ARGUMENT]: "Invalid argument",
  [kt.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [kt.NOT_INSTALLED]: "Need to install with `app.use` function",
  [kt.UNEXPECTED_ERROR]: "Unexpected error",
  [kt.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [kt.REQUIRED_VALUE]: "Required in value: {0}",
  [kt.INVALID_VALUE]: "Invalid value",
  [kt.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [kt.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [kt.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [kt.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [kt.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [kt.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, tf = /* @__PURE__ */ Ko("__translateVNode"), nf = /* @__PURE__ */ Ko("__datetimeParts"), of = /* @__PURE__ */ Ko("__numberParts"), rf = /* @__PURE__ */ Ko("__enableEmitter"), sf = /* @__PURE__ */ Ko("__disableEmitter"), Qw = Ko("__setPluralRules"), ek = /* @__PURE__ */ Ko("__injectWithOption"), af = /* @__PURE__ */ Ko("__dispose");
function fa(n) {
  if (!qe(n))
    return n;
  for (const e in n)
    if (Gl(n, e))
      if (!e.includes("."))
        qe(n[e]) && fa(n[e]);
      else {
        const t = e.split("."), o = t.length - 1;
        let i = n, r = !1;
        for (let s = 0; s < o; s++) {
          if (t[s] in i || (i[t[s]] = {}), !qe(i[t[s]])) {
            process.env.NODE_ENV !== "production" && ms(x1(Rn.IGNORE_OBJ_FLATTEN, {
              key: t[s]
            })), r = !0;
            break;
          }
          i = i[t[s]];
        }
        r || (i[t[o]] = n[e], delete n[e]), qe(i[t[o]]) && fa(i[t[o]]);
      }
  return n;
}
function e6(n, e) {
  const { messages: t, __i18n: o, messageResolver: i, flatJson: r } = e, s = Ke(t) ? t : Et(o) ? {} : { [n]: {} };
  if (Et(o) && o.forEach((a) => {
    if ("locale" in a && "resource" in a) {
      const { locale: l, resource: d } = a;
      l ? (s[l] = s[l] || {}, Il(d, s[l])) : Il(d, s);
    } else
      ge(a) && Il(JSON.parse(a), s);
  }), i == null && r)
    for (const a in s)
      Gl(s, a) && fa(s[a]);
  return s;
}
function t6(n) {
  return n.type;
}
function tk(n, e, t) {
  let o = qe(e.messages) ? e.messages : {};
  "__i18nGlobal" in t && (o = e6(n.locale.value, {
    messages: o,
    __i18n: t.__i18nGlobal
  }));
  const i = Object.keys(o);
  i.length && i.forEach((r) => {
    n.mergeLocaleMessage(r, o[r]);
  });
  {
    if (qe(e.datetimeFormats)) {
      const r = Object.keys(e.datetimeFormats);
      r.length && r.forEach((s) => {
        n.mergeDateTimeFormat(s, e.datetimeFormats[s]);
      });
    }
    if (qe(e.numberFormats)) {
      const r = Object.keys(e.numberFormats);
      r.length && r.forEach((s) => {
        n.mergeNumberFormat(s, e.numberFormats[s]);
      });
    }
  }
}
function $0(n) {
  return U(av, null, n, 0);
}
const M0 = "__INTLIFY_META__", S0 = () => [], nk = () => !1;
let _0 = 0;
function E0(n) {
  return ((e, t, o, i) => n(t, o, qn() || void 0, i));
}
const ok = /* @__NO_SIDE_EFFECTS__ */ () => {
  const n = qn();
  let e = null;
  return n && (e = t6(n)[M0]) ? { [M0]: e } : null;
};
function ik(n = {}, e) {
  const { __root: t, __injectWithOption: o } = n, i = t === void 0, r = n.flatJson, s = Vo ? R : mr;
  let a = $t(n.inheritLocale) ? n.inheritLocale : !0;
  const l = s(
    // prettier-ignore
    t && a ? t.locale.value : ge(n.locale) ? n.locale : Yl
  ), d = s(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : ge(n.fallbackLocale) || Et(n.fallbackLocale) || Ke(n.fallbackLocale) || n.fallbackLocale === !1 ? n.fallbackLocale : l.value
  ), u = s(e6(l.value, n)), c = s(Ke(n.datetimeFormats) ? n.datetimeFormats : { [l.value]: {} }), f = s(Ke(n.numberFormats) ? n.numberFormats : { [l.value]: {} });
  let h = t ? t.missingWarn : $t(n.missingWarn) || Kl(n.missingWarn) ? n.missingWarn : !0, p = t ? t.fallbackWarn : $t(n.fallbackWarn) || Kl(n.fallbackWarn) ? n.fallbackWarn : !0, m = t ? t.fallbackRoot : $t(n.fallbackRoot) ? n.fallbackRoot : !0, g = !!n.fallbackFormat, b = ft(n.missing) ? n.missing : null, x = ft(n.missing) ? E0(n.missing) : null, w = ft(n.postTranslation) ? n.postTranslation : null, M = t ? t.warnHtmlMessage : $t(n.warnHtmlMessage) ? n.warnHtmlMessage : !0, $ = !!n.escapeParameter;
  const T = t ? t.modifiers : Ke(n.modifiers) ? n.modifiers : {};
  let E = n.pluralRules || t && t.pluralRules, S;
  S = (() => {
    i && m0(null);
    const K = {
      version: qw,
      locale: l.value,
      fallbackLocale: d.value,
      messages: u.value,
      modifiers: T,
      pluralRules: E,
      missing: x === null ? void 0 : x,
      missingWarn: h,
      fallbackWarn: p,
      fallbackFormat: g,
      unresolving: !0,
      postTranslation: w === null ? void 0 : w,
      warnHtmlMessage: M,
      escapeParameter: $,
      messageResolver: n.messageResolver,
      messageCompiler: n.messageCompiler,
      __meta: { framework: "vue" }
    };
    K.datetimeFormats = c.value, K.numberFormats = f.value, K.__datetimeFormatters = Ke(S) ? S.__datetimeFormatters : void 0, K.__numberFormatters = Ke(S) ? S.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (K.__v_emitter = Ke(S) ? S.__v_emitter : void 0);
    const ee = jw(K);
    return i && m0(ee), ee;
  })(), $s(S, l.value, d.value);
  function I() {
    return [
      l.value,
      d.value,
      u.value,
      c.value,
      f.value
    ];
  }
  const z = L({
    get: () => l.value,
    set: (K) => {
      l.value = K, S.locale = l.value;
    }
  }), F = L({
    get: () => d.value,
    set: (K) => {
      d.value = K, S.fallbackLocale = d.value, $s(S, l.value, K);
    }
  }), Y = L(() => u.value), ie = /* @__PURE__ */ L(() => c.value), W = /* @__PURE__ */ L(() => f.value);
  function te() {
    return ft(w) ? w : null;
  }
  function ce(K) {
    w = K, S.postTranslation = K;
  }
  function we() {
    return b;
  }
  function ke(K) {
    K !== null && (x = E0(K)), b = K, S.missing = x;
  }
  function rt(K, ee) {
    return K !== "translate" || !ee.resolvedMessage;
  }
  const ut = (K, ee, $e, Ze, on, An) => {
    I();
    let rn;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, i || (S.fallbackContext = t ? Hw() : void 0), rn = K(S);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, i || (S.fallbackContext = void 0);
    }
    if ($e !== "translate exists" && // for not `te` (e.g `t`)
    qt(rn) && rn === lu || $e === "translate exists" && !rn) {
      const [hn, Jo] = ee();
      if (process.env.NODE_ENV !== "production" && t && ge(hn) && rt($e, Jo) && (m && (du(p, hn) || K2(h, hn)) && ms(x1(Rn.FALLBACK_TO_ROOT, {
        key: hn,
        type: $e
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Xe } = S;
        Xe && m && Xe.emit("fallback", {
          type: $e,
          key: hn,
          to: "global",
          groupId: `${$e}:${hn}`
        });
      }
      return t && m ? Ze(t) : on(hn);
    } else {
      if (An(rn))
        return rn;
      throw ca(kt.UNEXPECTED_RETURN_TYPE);
    }
  };
  function it(...K) {
    return ut((ee) => Reflect.apply(b0, null, [ee, ...K]), () => Xc(...K), "translate", (ee) => Reflect.apply(ee.t, ee, [...K]), (ee) => ee, (ee) => ge(ee));
  }
  function Ut(...K) {
    const [ee, $e, Ze] = K;
    if (Ze && !qe(Ze))
      throw ca(kt.INVALID_ARGUMENT);
    return it(ee, $e, Xt({ resolvedMessage: !0 }, Ze || {}));
  }
  function nn(...K) {
    return ut((ee) => Reflect.apply(x0, null, [ee, ...K]), () => Qc(...K), "datetime format", (ee) => Reflect.apply(ee.d, ee, [...K]), () => ql, (ee) => ge(ee));
  }
  function ct(...K) {
    return ut((ee) => Reflect.apply(w0, null, [ee, ...K]), () => ef(...K), "number format", (ee) => Reflect.apply(ee.n, ee, [...K]), () => ql, (ee) => ge(ee));
  }
  function At(K) {
    return K.map((ee) => ge(ee) || qt(ee) || $t(ee) ? $0(String(ee)) : ee);
  }
  const Cn = {
    normalize: At,
    interpolate: (K) => K,
    type: "vnode"
  };
  function io(...K) {
    return ut(
      (ee) => {
        let $e;
        const Ze = ee;
        try {
          Ze.processor = Cn, $e = Reflect.apply(b0, null, [Ze, ...K]);
        } finally {
          Ze.processor = null;
        }
        return $e;
      },
      () => Xc(...K),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ee) => ee[tf](...K),
      (ee) => [$0(ee)],
      (ee) => Et(ee)
    );
  }
  function Ni(...K) {
    return ut(
      (ee) => Reflect.apply(w0, null, [ee, ...K]),
      () => ef(...K),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ee) => ee[of](...K),
      S0,
      (ee) => ge(ee) || Et(ee)
    );
  }
  function Zo(...K) {
    return ut(
      (ee) => Reflect.apply(x0, null, [ee, ...K]),
      () => Qc(...K),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ee) => ee[nf](...K),
      S0,
      (ee) => ge(ee) || Et(ee)
    );
  }
  function ro(K) {
    E = K, S.pluralRules = E;
  }
  function Pi(K, ee) {
    return ut(() => {
      if (!K)
        return !1;
      const $e = ge(ee) ? ee : l.value, Ze = Z($e), on = S.messageResolver(Ze, K);
      return Jr(on) || Bn(on) || ge(on);
    }, () => [K], "translate exists", ($e) => Reflect.apply($e.te, $e, [K, ee]), nk, ($e) => $t($e));
  }
  function Li(K) {
    let ee = null;
    const $e = z2(S, d.value, l.value);
    for (let Ze = 0; Ze < $e.length; Ze++) {
      const on = u.value[$e[Ze]] || {}, An = S.messageResolver(on, K);
      if (An != null) {
        ee = An;
        break;
      }
    }
    return ee;
  }
  function X(K) {
    const ee = Li(K);
    return ee ?? (t ? t.tm(K) || {} : {});
  }
  function Z(K) {
    return u.value[K] || {};
  }
  function N(K, ee) {
    if (r) {
      const $e = { [K]: ee };
      for (const Ze in $e)
        Gl($e, Ze) && fa($e[Ze]);
      ee = $e[K];
    }
    u.value[K] = ee, S.messages = u.value;
  }
  function q(K, ee) {
    u.value[K] = u.value[K] || {};
    const $e = { [K]: ee };
    for (const Ze in $e)
      Gl($e, Ze) && fa($e[Ze]);
    ee = $e[K], Il(ee, u.value[K]), S.messages = u.value;
  }
  function de(K) {
    return c.value[K] || {};
  }
  function fe(K, ee) {
    c.value[K] = ee, S.datetimeFormats = c.value, C0(S, K, ee);
  }
  function Be(K, ee) {
    c.value[K] = Xt(c.value[K] || {}, ee), S.datetimeFormats = c.value, C0(S, K, ee);
  }
  function ve(K) {
    return f.value[K] || {};
  }
  function ae(K, ee) {
    f.value[K] = ee, S.numberFormats = f.value, k0(S, K, ee);
  }
  function Ne(K, ee) {
    f.value[K] = Xt(f.value[K] || {}, ee), S.numberFormats = f.value, k0(S, K, ee);
  }
  _0++, t && Vo && (Ee(t.locale, (K) => {
    a && (l.value = K, S.locale = K, $s(S, l.value, d.value));
  }), Ee(t.fallbackLocale, (K) => {
    a && (d.value = K, S.fallbackLocale = K, $s(S, l.value, d.value));
  }));
  const ne = {
    id: _0,
    locale: z,
    fallbackLocale: F,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(K) {
      a = K, K && t && (l.value = t.locale.value, d.value = t.fallbackLocale.value, $s(S, l.value, d.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: Y,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return E || {};
    },
    get isGlobal() {
      return i;
    },
    get missingWarn() {
      return h;
    },
    set missingWarn(K) {
      h = K, S.missingWarn = h;
    },
    get fallbackWarn() {
      return p;
    },
    set fallbackWarn(K) {
      p = K, S.fallbackWarn = p;
    },
    get fallbackRoot() {
      return m;
    },
    set fallbackRoot(K) {
      m = K;
    },
    get fallbackFormat() {
      return g;
    },
    set fallbackFormat(K) {
      g = K, S.fallbackFormat = g;
    },
    get warnHtmlMessage() {
      return M;
    },
    set warnHtmlMessage(K) {
      M = K, S.warnHtmlMessage = K;
    },
    get escapeParameter() {
      return $;
    },
    set escapeParameter(K) {
      $ = K, S.escapeParameter = K;
    },
    t: it,
    getLocaleMessage: Z,
    setLocaleMessage: N,
    mergeLocaleMessage: q,
    getPostTranslationHandler: te,
    setPostTranslationHandler: ce,
    getMissingHandler: we,
    setMissingHandler: ke,
    [Qw]: ro
  };
  return ne.datetimeFormats = ie, ne.numberFormats = W, ne.rt = Ut, ne.te = Pi, ne.tm = X, ne.d = nn, ne.n = ct, ne.getDateTimeFormat = de, ne.setDateTimeFormat = fe, ne.mergeDateTimeFormat = Be, ne.getNumberFormat = ve, ne.setNumberFormat = ae, ne.mergeNumberFormat = Ne, ne[ek] = o, ne[tf] = io, ne[nf] = Zo, ne[of] = Ni, process.env.NODE_ENV !== "production" && (ne[rf] = (K) => {
    S.__v_emitter = K;
  }, ne[sf] = () => {
    S.__v_emitter = void 0;
  }), ne;
}
const C1 = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (n) => n === "parent" || n === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function rk({ slots: n }, e) {
  return e.length === 1 && e[0] === "default" ? (n.default ? n.default() : []).reduce((o, i) => [
    ...o,
    // prettier-ignore
    ...i.type === re ? i.children : [i]
  ], []) : e.reduce((t, o) => {
    const i = n[o];
    return i && (t[o] = i()), t;
  }, {});
}
function n6(n) {
  return re;
}
Xt({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (n) => qt(n) || !isNaN(n)
  }
}, C1);
function sk(n) {
  return Et(n) && !ge(n[0]);
}
function o6(n, e, t, o) {
  const { slots: i, attrs: r } = e;
  return () => {
    const s = { part: !0 };
    let a = {};
    n.locale && (s.locale = n.locale), ge(n.format) ? s.key = n.format : qe(n.format) && (ge(n.format.key) && (s.key = n.format.key), a = Object.keys(n.format).reduce((f, h) => t.includes(h) ? Xt({}, f, { [h]: n.format[h] }) : f, {}));
    const l = o(n.value, s, a);
    let d = [s.key];
    Et(l) ? d = l.map((f, h) => {
      const p = i[f.type], m = p ? p({ [f.type]: f.value, index: h, parts: l }) : [f.value];
      return sk(m) && (m[0].key = `${f.type}-${h}`), m;
    }) : ge(l) && (d = [l]);
    const u = Xt({}, r), c = ge(n.tag) || qe(n.tag) ? n.tag : n6();
    return lt(c, u, d);
  };
}
Xt({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, C1);
Xt({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, C1);
function O0(n, e) {
}
const ak = /* @__PURE__ */ Ko("global-vue-i18n");
function Tn(n = {}) {
  const e = qn();
  if (e == null)
    throw ca(kt.MUST_BE_CALL_SETUP_TOP);
  if (!e.isCE && e.appContext.app != null && !e.appContext.app.__VUE_I18N_SYMBOL__)
    throw ca(kt.NOT_INSTALLED);
  const t = lk(e), o = uk(t), i = t6(e), r = dk(n, i);
  if (r === "global")
    return tk(o, n, i), o;
  if (r === "parent") {
    let l = ck(t, e, n.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && ms(x1(Rn.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  const s = t;
  let a = s.__getInstance(e);
  if (a == null) {
    const l = Xt({}, n);
    "__i18n" in i && (l.__i18n = i.__i18n), o && (l.__root = o), a = ik(l), s.__composerExtend && (a[af] = s.__composerExtend(a)), hk(s, e, a), s.__setInstance(e, a);
  }
  return a;
}
function lk(n) {
  {
    const e = Uo(n.isCE ? ak : n.appContext.app.__VUE_I18N_SYMBOL__);
    if (!e)
      throw ca(n.isCE ? kt.NOT_INSTALLED_WITH_PROVIDE : kt.UNEXPECTED_ERROR);
    return e;
  }
}
function dk(n, e) {
  return au(n) ? "__i18n" in e ? "local" : "global" : n.useScope ? n.useScope : "local";
}
function uk(n) {
  return n.mode === "composition" ? n.global : n.global.__composer;
}
function ck(n, e, t = !1) {
  let o = null;
  const i = e.root;
  let r = fk(e, t);
  for (; r != null; ) {
    const s = n;
    if (n.mode === "composition" && (o = s.__getInstance(r)), o != null || i === r)
      break;
    r = r.parent;
  }
  return o;
}
function fk(n, e = !1) {
  return n == null ? null : e && n.vnode.ctx || n.parent;
}
function hk(n, e, t) {
  let o = null;
  We(() => {
    if (process.env.NODE_ENV !== "production" && e.vnode.el) {
      e.vnode.el.__VUE_I18N__ = t, o = iw();
      const i = t;
      i[rf] && i[rf](o), o.on("*", O0);
    }
  }, e), Ei(() => {
    const i = t;
    process.env.NODE_ENV !== "production" && e.vnode.el && e.vnode.el.__VUE_I18N__ && (o && o.off("*", O0), i[sf] && i[sf](), delete e.vnode.el.__VUE_I18N__), n.__deleteInstance(e);
    const r = i[af];
    r && (r(), delete i[af]);
  }, e);
}
Zw();
Fw(vw);
Bw(z2);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const n = g1();
  n.__INTLIFY__ = !0, Sw(n.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const pk = ["src"], mk = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center text-mgm-txt-xs font-medium text-foreground-brand-default"
}, gk = {
  key: 0,
  class: "flex flex-row gap-1 items-center mb-1"
}, vk = { class: "text-mgm-txt-sm text-foreground-default" }, bk = {
  key: 1,
  class: "flex flex-row justify-start items-center gap-2 mb-1"
}, yk = { class: "w-full line-clamp-2" }, xk = {
  key: 0,
  class: "text-left text-mgm-txt-md font-medium text-foreground-emphasis w-full"
}, Ck = { class: "line-clamp-2" }, wk = ["innerHTML"], GG = /* @__PURE__ */ H({
  __name: "BaseCard",
  props: {
    title: { default: "" },
    description: { default: "" },
    imgUrl: { default: "" },
    points: { default: void 0 },
    badgeStatus: { default: void 0 },
    lockMobile: { type: Boolean, default: !1 },
    clickable: { type: Boolean, default: !0 },
    displayPoints: { type: Boolean, default: !0 },
    containImg: { type: Boolean, default: !1 },
    date: { default: "" },
    status: { default: null }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = {
      interested: {
        labelKey: "ugc.ongoing.status.interested",
        dotClass: "bg-border-warning-emphasis",
        textClass: "text-foreground-warning-default"
      },
      toValidate: {
        labelKey: "ugc.ongoing.status.toValidate",
        dotClass: "bg-border-default",
        textClass: "text-foreground-default"
      },
      modificationRequested: {
        labelKey: "ugc.ongoing.status.modificationRequested",
        dotClass: "bg-border-warning-emphasis",
        textClass: "text-foreground-warning-default"
      },
      challengeActionNeeded: {
        labelKey: "challenges.ongoing.status.actionNeeded",
        dotClass: "bg-border-warning-emphasis",
        textClass: "text-foreground-warning-default"
      },
      challengeToValidate: {
        labelKey: "challenges.ongoing.status.toValidate",
        dotClass: "bg-border-default",
        textClass: "text-foreground-default"
      },
      eventActionNeeded: {
        labelKey: "events.ongoing.status.actionNeeded",
        dotClass: "bg-border-warning-emphasis",
        textClass: "text-foreground-warning-default"
      },
      eventToValidate: {
        labelKey: "events.ongoing.status.toValidate",
        dotClass: "bg-border-default",
        textClass: "text-foreground-default"
      }
    }, o = n, { t: i } = Tn({ useScope: "global" }), r = L(
      () => o.status ? t[o.status] : null
    ), s = L(() => {
      var u;
      const d = (u = o.badgeStatus) == null ? void 0 : u.points;
      return d != null && d !== "";
    }), a = e, l = () => {
      a("click");
    };
    return (d, u) => (v(), V(qr(n.clickable ? "button" : "div"), {
      class: J([
        "relative flex flex-row w-full justify-start rounded-[5px] border border-border-subtle bg-background-default px-4 py-[18px]",
        {
          "lg:!w-[262px] lg:!flex-col": !n.lockMobile,
          "cursor-pointer hover:shadow-[0px_4px_8px_-2px_rgba(28,31,39,0.1),0px_2px_4px_-2px_rgba(28,31,39,0.06)] focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default focus:outline-none": n.clickable
        }
      ]),
      onClick: l
    }, {
      default: B(() => [
        y("div", {
          class: J([
            "overflow-hidden relative h-16 w-16 shrink-0",
            { "lg:!h-[128px] lg:!w-full lg:rounded-none": !n.lockMobile }
          ])
        }, [
          y("img", {
            class: J("h-full rounded-[5px] w-full object-cover"),
            src: n.imgUrl
          }, null, 8, pk),
          n.displayPoints ? (v(), C("span", mk, j(n.points), 1)) : _("", !0)
        ], 2),
        y("div", {
          class: J([
            "pl-4 max-w-full overflow-hidden",
            { "lg:!pl-0 lg:!pt-4": !n.lockMobile }
          ])
        }, [
          n.date ? (v(), C("div", gk, [
            U(ye, {
              icon: "calendar",
              size: 14,
              color: "var(--color-foreground-default)"
            }),
            y("p", vk, j(n.date), 1)
          ])) : _("", !0),
          r.value ? (v(), C("div", bk, [
            y("span", {
              class: J(["block w-2 h-2 rounded-full", r.value.dotClass])
            }, null, 2),
            y("p", {
              class: J(["text-mgm-txt-sm font-medium", r.value.textClass])
            }, j(k(i)(r.value.labelKey)), 3)
          ])) : _("", !0),
          y("div", yk, [
            n.title ? (v(), C("p", xk, j(n.title), 1)) : _("", !0)
          ]),
          y("div", Ck, [
            n.description ? (v(), C("div", {
              key: 0,
              class: "base-card__description text-left text-mgm-txt-sm font-normal text-foreground-default",
              innerHTML: n.description
            }, null, 8, wk)) : _("", !0)
          ]),
          s.value ? (v(), V(Jc, {
            key: 2,
            size: "sm",
            class: "mt-2",
            text: n.badgeStatus.points,
            "icon-type": "icon",
            "icon-name": "star"
          }, null, 8, ["text"])) : n.badgeStatus ? (v(), V(Jc, {
            key: 3,
            class: "mt-2",
            size: "xs",
            color: n.badgeStatus.color,
            text: n.badgeStatus.text
          }, null, 8, ["color", "text"])) : _("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), kk = {
  key: 0,
  class: "mx-auto max-w-[343px]"
}, $k = { class: "text-center text-mgm-txt-sm font-medium text-foreground-emphasis" }, Mk = {
  key: 1,
  type: "button",
  class: "relative block w-full rounded-lg border-2 border-dashed border-border-subtle p-12 text-center hover:border-border-subtle focus:outline-none focus:ring-2 focus:ring-border-default focus:ring-offset-2"
}, Sk = {
  key: 1,
  class: "mx-auto h-12 w-12 text-border-subtle",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 48 48",
  "aria-hidden": "true"
}, _k = { class: "mt-2 block text-sm font-medium text-foreground-emphasis" }, Ek = { class: "mt-14 text-center" }, Ok = { class: "text-mgm-txt-sm font-medium text-foreground-emphasis" }, Tk = {
  key: 3,
  class: "mx-auto h-56 w-[296px] rounded-lg border border-border-subtle bg-background-default p-8 shadow-[0_12px_16px_-4px_rgba(28,31,39,0.08),0_14px_6px_-2px_rgba(28,31,39,0.03)]"
}, Ak = /* @__PURE__ */ H({
  __name: "BaseEmptyState",
  props: {
    type: { default: "empty-list" },
    text: { default: "" }
  },
  setup(n) {
    return (e, t) => n.type === "empty-list" ? (v(), C("div", kk, [
      t[0] || (t[0] = mi('<div class="gradient__grey__06" data-v-a95300f6><div class="flex h-14 w-[255px] flex-col justify-between rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-a95300f6><div class="gradient__grey__05 h-3 w-24 rounded-lg" data-v-a95300f6></div><div class="h-3 w-[184px] rounded-lg bg-background-subtle" data-v-a95300f6></div></div><div class="mt-2 h-14 w-[255px] rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-a95300f6><div class="gradient__grey__05 h-3 w-24 rounded-lg" data-v-a95300f6></div></div></div>', 1)),
      y("p", $k, j(n.text), 1)
    ])) : ["create-campaign", "add-element"].includes(n.type) ? (v(), C("button", Mk, [
      n.type === "add-element" ? (v(), V(ye, {
        key: 0,
        class: "mx-auto mb-4",
        icon: "plus",
        size: 40
      })) : n.type === "create-campaign" ? (v(), C("svg", Sk, [...t[1] || (t[1] = [
        y("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
        }, null, -1)
      ])])) : _("", !0),
      y("span", _k, j(n.text), 1)
    ])) : n.type === "awaiting-match" ? (v(), C("div", {
      key: 2,
      class: J(["mx-auto", e.$slots.content ? "max-w-[560px]" : "max-w-[263px]"])
    }, [
      t[2] || (t[2] = mi('<div class="relative mx-auto flex h-14 w-[215px] rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-a95300f6><div class="gradient__colorful__01 mr-2 h-8 w-8 rounded-full" data-v-a95300f6></div><div class="h-3 w-20 rounded-lg bg-border-subtle" data-v-a95300f6></div><div class="absolute top-8 left-10 z-[1] flex h-14 w-[215px] justify-between rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-a95300f6><div class="gradient__colorful__02 h-8 w-8 rounded-full" data-v-a95300f6></div><div class="flex h-full flex-col justify-between" data-v-a95300f6><div class="h-3 w-20 rounded-lg bg-border-subtle" data-v-a95300f6></div><div class="h-3 w-[143px] rounded-lg bg-border-subtle" data-v-a95300f6></div></div></div></div>', 1)),
      y("div", Ek, [
        le(e.$slots, "content", {}, () => [
          y("p", Ok, j(n.text), 1)
        ], !0)
      ])
    ], 2)) : n.type === "no-relation-selected" ? (v(), C("div", Tk, [...t[3] || (t[3] = [
      mi('<div class="mb-8 flex items-center justify-between" data-v-a95300f6><div class="gradient__grey__01 h-14 w-14 rounded-full" data-v-a95300f6></div><div class="flex h-11 flex-col justify-between" data-v-a95300f6><div class="gradient__grey__02 h-4 w-20 rounded-lg" data-v-a95300f6></div><div class="gradient__grey__03 h-4 w-40 rounded-lg" data-v-a95300f6></div></div></div><div data-v-a95300f6><div class="flex h-[72px] flex-col justify-between" data-v-a95300f6><div class="gradient__grey__04 h-4 w-[232px] rounded-lg" data-v-a95300f6></div><div class="gradient__grey__04 h-4 w-[232px] rounded-lg" data-v-a95300f6></div><div class="gradient__grey__04 h-4 w-[232px] rounded-lg" data-v-a95300f6></div></div></div>', 2)
    ])])) : _("", !0);
  }
}), Ai = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [o, i] of e)
    t[o] = i;
  return t;
}, YG = /* @__PURE__ */ Ai(Ak, [["__scopeId", "data-v-a95300f6"]]), Ik = { class: "flex h-2 w-full items-center justify-between rounded-full bg-background-brand-default" }, Dk = {
  key: 2,
  class: "h-full w-full rounded-full bg-background-brand-emphasis"
}, Nk = {
  key: 3,
  class: "h-full w-full rounded-full bg-[#DD2590]"
}, qG = /* @__PURE__ */ H({
  __name: "BaseHorizontalBarChart",
  props: {
    helpeeCount: {},
    helperCount: {}
  },
  setup(n) {
    const e = n, t = (o) => o / (e.helpeeCount + e.helperCount) * 100;
    return (o, i) => (v(), C("div", Ik, [
      n.helpeeCount === 0 && n.helperCount === 0 ? (v(), C(re, { key: 0 }, [
        i[0] || (i[0] = y("div", { class: "h-full w-1 rounded-l-full bg-background-brand-emphasis" }, null, -1)),
        i[1] || (i[1] = y("div", { class: "h-full w-1 rounded-r-full bg-[#DD2590]" }, null, -1))
      ], 64)) : n.helpeeCount > 0 && n.helperCount > 0 ? (v(), C(re, { key: 1 }, [
        y("div", {
          class: "h-full rounded-l-full bg-background-brand-emphasis",
          style: He({
            width: `calc(${t(n.helperCount)}% - 1px)`
          })
        }, null, 4),
        y("div", {
          class: "h-full rounded-r-full bg-[#DD2590]",
          style: He({
            width: `calc(${t(n.helpeeCount)}% - 1px)`
          })
        }, null, 4)
      ], 64)) : n.helpeeCount === 0 && n.helperCount > 0 ? (v(), C("div", Dk)) : n.helpeeCount > 0 && n.helperCount === 0 ? (v(), C("div", Nk)) : _("", !0)
    ]));
  }
}), Pk = {}, Lk = { class: "mx-auto flex items-center justify-center" };
function Rk(n, e) {
  return v(), C("div", Lk, [...e[0] || (e[0] = [
    mi('<svg class="animate-spin" width="89" height="88" viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="40" stroke="var(--color-background-subtle)" stroke-width="8"></circle><path d="M42.5 4C65.696 4 84.5 21.6474 84.5 43.4167C84.5 48.9517 83.2844 54.2202 81.09 59" stroke="url(#paint0_linear_4454_43945)" stroke-width="8" stroke-linecap="round"></path><defs><linearGradient id="paint0_linear_4454_43945" x1="56.959" y1="7.19767" x2="81.8309" y2="44.767" gradientUnits="userSpaceOnUse"><stop stop-color="var(--color-background-subtle)"></stop><stop offset="1" stop-color="var(--color-foreground-brand-default)"></stop></linearGradient></defs></svg>', 1)
  ])]);
}
const ZG = /* @__PURE__ */ Ai(Pk, [["render", Rk]]), Fk = { class: "md:flex" }, Bk = { class: "h-40 w-40" }, Vk = {
  class: "h-40 w-40",
  viewBox: "0 0 160 160",
  xmlns: "http://www.w3.org/2000/svg"
}, zk = ["d", "fill"], Hk = { class: "mt-4 md:ml-4 md:mt-0" }, jk = { class: "text-mgm-txt-sm font-normal text-foreground-default" }, JG = /* @__PURE__ */ H({
  __name: "BasePieChart",
  props: {
    data: {},
    locale: { default: "en" }
  },
  setup(n) {
    const e = n, { t, locale: o } = Tn(), i = L(() => {
      const a = e.data, l = a.reduce((c, f) => c + ((f == null ? void 0 : f.value) || 0), 0), d = 40;
      let u = 0;
      return a.map((c) => {
        const f = c != null && c.value ? c.value / l * 360 : 0, h = u, p = h + f;
        u += f;
        const [m, g] = s(80, 80, 80, h), [b, x] = s(80, 80, 80, p), [w, M] = s(80, 80, d, h), [$, T] = s(80, 80, d, p), E = f > 180 ? 1 : 0;
        return {
          ...c,
          d: `M ${m} ${g} A 80 80 0 ${E} 1 ${b} ${x} L ${$} ${T} A ${d} ${d} 0 ${E} 0 ${w} ${M} z`
        };
      });
    }), r = L(() => e.data.reduce((a, l) => a + ((l == null ? void 0 : l.value) || 0), 0)), s = (a, l, d, u) => {
      const c = (u - 90) * (Math.PI / 180);
      return [a + d * Math.cos(c), l + d * Math.sin(c)];
    };
    return (a, l) => {
      const d = f1("tooltip");
      return v(), C("div", Fk, [
        y("div", Bk, [
          (v(), C("svg", Vk, [
            y("g", null, [
              (v(!0), C(re, null, De(i.value, (u, c) => (v(), C(re, { key: c }, [
                u.value ? vo((v(), C("path", {
                  key: 0,
                  class: "cursor-pointer transition-all duration-300 ease-in-out outline-none",
                  d: u.d,
                  fill: u.color,
                  stroke: "white",
                  "stroke-width": "1"
                }, null, 8, zk)), [
                  [d, {
                    content: `<span>${u.label}${k(o) === "fr" ? " " : ""}: ${(u.value / r.value * 100).toFixed(
                      1
                    )}% <span style='color:var(--color-border-default, #cbd5e1);text-transform: lowercase;'>• ${u.value} ${k(t)("generic.users.name")}</span></span>`,
                    html: !0
                  }]
                ]) : _("", !0)
              ], 64))), 128))
            ])
          ]))
        ]),
        y("div", Hk, [
          (v(!0), C(re, null, De(i.value, (u, c) => vo((v(), C("div", {
            key: `legend-${c}`,
            class: "mb-1 flex cursor-pointer items-center"
          }, [
            y("div", {
              class: "mr-2 h-2 w-2 rounded-full",
              style: He({ backgroundColor: u.color })
            }, null, 4),
            y("span", jk, j(u.label), 1)
          ])), [
            [d, {
              content: `<span>${u.label}${k(o) === "fr" ? " " : ""}: ${(u.value ? u.value / r.value * 100 : 0).toFixed(
                1
              )}% <span style='color:var(--color-border-default, #cbd5e1);text-transform: lowercase;'>• ${u.value} ${k(t)("generic.users.name")}</span></span>`,
              html: !0
            }]
          ])), 128))
        ])
      ]);
    };
  }
}), Wk = { class: "relative w-fit" }, Uk = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "126",
  height: "103",
  class: "overflow-visible",
  viewBox: "0 0 126 103",
  fill: "none"
}, Kk = ["d"], Gk = { class: "absolute left-0 right-0 bottom-[14px] w-full text-center text-background-brand-disabled text-mgm-txt-xl font-normal" }, Yk = { class: "text-foreground-on-emphasis text-mgm-dspl-lg font-normal" }, XG = /* @__PURE__ */ H({
  __name: "BaseProgressRing",
  props: {
    progress: {}
  },
  setup(n) {
    const e = n, t = L(() => {
      switch (e.progress) {
        case 1:
          return "M15.0819 99.1089C9.76659 92.0553 6.07408 83.9152 4.26796 75.2698C2.46183 66.6243 2.58663 57.6868 4.63345 49.0951";
        case 2:
          return "M15.0819 99.1089C9.76659 92.0553 6.07408 83.9152 4.26796 75.2698C2.46183 66.6243 2.58663 57.6868 4.63345 49.0951C6.68026 40.5035 10.5986 32.4697 16.1088 25.5672C21.6189 18.6648 28.585 13.0639 36.5096 9.1645";
        case 3:
          return "M15.0819 99.1089C7.06831 88.4746 2.81993 75.4766 3.00585 62.1623C3.19176 48.8479 7.80141 35.9737 16.1088 25.5672C24.4161 15.1608 35.9492 7.81341 48.8915 4.68234C61.8338 1.55127 75.4499 2.8144 87.5954 8.27279";
        case 4:
          return "M15.0819 99.1089C9.76659 92.0553 6.07408 83.9152 4.26796 75.2698C2.46183 66.6243 2.58663 57.6868 4.63345 49.0951C6.68026 40.5035 10.5986 32.4697 16.1088 25.5672C21.6189 18.6648 28.585 13.0639 36.5096 9.1645C44.4343 5.26509 53.1221 3.16328 61.9528 3.00914C70.7836 2.855 79.5394 4.65232 87.5954 8.27279C95.6513 11.8933 102.809 17.2476 108.556 23.9535C114.304 30.6595 118.5 38.5516 120.846 47.0666";
        default:
          return "M15.0819 99.1089C8.36477 90.195 4.2672 79.5842 3.24979 68.4692C2.23238 57.3543 4.33547 46.1759 9.32264 36.1907C14.3098 26.2054 21.9833 17.8092 31.4806 11.9458C40.9779 6.08249 51.9224 2.98448 63.0838 3.00006C74.2452 3.01564 85.181 6.1442 94.6618 12.034C104.143 17.9239 111.793 26.3415 116.752 36.3406C121.711 46.3398 123.783 57.524 122.735 68.6361C121.686 79.7481 117.559 90.3475 110.817 99.2426";
      }
    });
    return (o, i) => (v(), C("div", Wk, [
      (v(), C("svg", Uk, [
        i[0] || (i[0] = y("path", {
          d: "M111 99C118.535 88.9717 123 76.5054 123 62.9963C123 29.8613 96.1371 3 63 3C29.8629 3 3 29.8613 3 62.9963C3 76.5054 7.46507 88.9717 15 99",
          stroke: "var(--color-background-brand-disabled)",
          "stroke-width": "6",
          "stroke-linecap": "round",
          "stroke-dasharray": "12 12"
        }, null, -1)),
        n.progress !== 0 ? (v(), C("path", {
          key: 0,
          d: t.value,
          stroke: "white",
          "stroke-width": "6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Kk)) : _("", !0)
      ])),
      y("p", Gk, [
        y("span", Yk, j(n.progress), 1),
        i[1] || (i[1] = Se(" / 5 ", -1))
      ])
    ]));
  }
}), qk = ["for"], _e = /* @__PURE__ */ H({
  __name: "FieldLabel",
  props: {
    description: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    id: { default: null },
    label: { default: null }
  },
  setup(n) {
    return (e, t) => (v(), C("label", {
      for: n.id || void 0,
      class: J(["block", {
        "text-mgm-txt-sm font-medium text-foreground-emphasis": !n.error && !n.description,
        "text-mgm-txt-xs font-normal text-foreground-default": n.description,
        "text-mgm-txt-xs font-medium text-foreground-danger-default": n.error
      }])
    }, [
      Se(j(n.label) + " ", 1),
      le(e.$slots, "default")
    ], 10, qk));
  }
}), Zk = {
  key: 0,
  class: "mb-3"
}, Jk = {
  key: 0,
  class: "flex items-start"
}, Xk = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, Qk = ["src"], e$ = {
  key: 1,
  class: "text-mgm-txt-sm font-semibold uppercase text-foreground-default"
}, t$ = { type: "button" }, n$ = ["id", "accept"], o$ = ["for"], QG = /* @__PURE__ */ H({
  __name: "FieldAvatarUploader",
  props: {
    accept: { default: "image/*" },
    iconCta: { default: null },
    cta: { default: null },
    id: {},
    label: { default: null },
    description: { default: null },
    locale: { default: "en" },
    modelValue: { default: null },
    previewUrl: { default: void 0 },
    fallback: { default: "" },
    placeholderIcon: { default: "user" },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = R(), o = R(""), i = e, r = (s) => {
      const a = s.target;
      if (a && a.files) {
        let l = null;
        l = a.files[0], l && (o.value = URL.createObjectURL(l)), i("update:modelValue", l), i("change", l);
      }
    };
    return (s, a) => {
      var l, d;
      return v(), C("div", {
        ref_key: "root",
        ref: t
      }, [
        n.label || n.description ? (v(), C("div", Zk, [
          n.label ? (v(), C("div", Jk, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", Xk, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", {
          class: J(`flex w-full items-center ${n.variant === "vertical" ? "flex-col" : ""}`)
        }, [
          y("div", {
            class: J(`flex items-center justify-center overflow-hidden rounded-full bg-background-subtle ${n.variant === "vertical" ? "mb-4 w-24 h-24" : "mr-4 h-10 w-10 "}`)
          }, [
            o.value || n.previewUrl ? (v(), C("img", {
              key: 0,
              class: "h-full w-full object-cover",
              src: o.value || n.previewUrl,
              alt: "avatar"
            }, null, 8, Qk)) : n.fallback ? (v(), C("span", e$, j(n.fallback), 1)) : (v(), V(ye, {
              key: 2,
              icon: n.placeholderIcon,
              color: "var(--color-foreground-default)"
            }, null, 8, ["icon"]))
          ], 2),
          y("button", t$, [
            y("input", {
              id: n.id,
              class: "sr-only",
              accept: n.accept,
              tabindex: "-1",
              type: "file",
              onChange: r
            }, null, 40, n$),
            y("label", {
              class: "box-border inline-flex gap-1 cursor-pointer rounded-3xl border border-border-subtle px-[15px] py-[9px] text-mgm-txt-sm font-medium text-foreground-default shadow-[0_1px_2px_rgba(28,31,39,0.05)] hover:border-border-default hover:text-foreground-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-[3px] focus:ring-background-subtle disabled:border-background-subtle disabled:text-foreground-subtle",
              for: n.id,
              onClick: a[0] || (a[0] = It(() => {
              }, ["stop"]))
            }, [
              n.iconCta ? (v(), V(ye, {
                key: 0,
                icon: n.iconCta,
                color: "var(--color-foreground-default)"
              }, null, 8, ["icon"])) : _("", !0),
              Se(" " + j(n.cta), 1)
            ], 8, o$)
          ])
        ], 2),
        n.validation && ((l = n.validation.$errors) != null && l.length) ? (v(), V(_e, {
          key: 1,
          class: "mt-1",
          label: (d = n.validation.$errors[0]) == null ? void 0 : d.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ], 512);
    };
  }
}), i$ = {
  key: 0,
  class: "relative flex items-center"
}, r$ = ["for"], s$ = { class: "flex h-5 items-center" }, a$ = ["id", "checked", "disabled", "name", "required"], l$ = {
  key: 1,
  class: "relative flex items-center"
}, d$ = { class: "flex h-5 items-center" }, u$ = ["id", "checked", "disabled", "name", "required"], c$ = ["for"], ha = /* @__PURE__ */ H({
  __name: "FieldCheckbox",
  props: {
    modelValue: { type: Boolean, default: !1 },
    id: {},
    label: { type: Boolean, default: !0 },
    labelFullWidth: { type: Boolean, default: !1 },
    customColor: { default: null },
    customRgbColor: { default: null },
    selectAll: { type: Boolean, default: !1 },
    forceHover: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    errorState: { type: Boolean, default: !1 },
    validation: { default: null },
    reverse: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = R(), i = e;
    We(() => {
      if (t.modelValue && t.customColor && t.customRgbColor && !t.disabled) {
        const l = document.head.appendChild(
          document.createElement("style")
        );
        l.innerHTML = `#${t.id}:before {border-color: ${t.customColor}; background-color: rgba(${t.customRgbColor}, 0.2); color: ${t.customColor};`;
      }
    });
    const r = (l) => {
      if (l.target && t.customColor && t.customRgbColor) {
        const u = document.head.appendChild(
          document.createElement("style")
        );
        u.innerHTML = `#${t.id}:focus {border-color: ${t.customColor} !important; background-color: rgba(${t.customRgbColor}, 0.2) !important; box-shadow: 0px 1px 2px rgba(${t.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${t.customRgbColor}, 0.08) !important;`;
      }
    }, s = (l) => {
      const d = l.target;
      if (i("change", d.checked, t.id), i("update:modelValue", d.checked), d && t.customColor && t.customRgbColor && !t.disabled) {
        const u = document.head.appendChild(
          document.createElement("style")
        );
        u.innerHTML = `#${t.id}:before {border-color: ${t.customColor}; background-color: rgba(${t.customRgbColor}, 0.2); color: ${t.customColor};`;
      }
    }, a = () => {
      if (o.value && t.customColor && t.customRgbColor && !t.modelValue && !t.disabled) {
        const l = document.head.appendChild(
          document.createElement("style")
        );
        l.innerHTML = `#${t.id}:hover {border-color: ${t.customColor}; background-color: rgba(${t.customRgbColor}, 0.2);`;
      }
    };
    return (l, d) => {
      var u, c, f, h;
      return v(), C("fieldset", {
        ref_key: "root",
        ref: o,
        onMouseenter: a
      }, [
        n.reverse ? (v(), C("div", i$, [
          y("div", {
            class: J(["mr-2", { "w-full": n.labelFullWidth }])
          }, [
            n.label ? (v(), C("label", {
              key: 0,
              for: `${n.id}`,
              class: "block cursor-pointer text-mgm-txt-md font-normal text-foreground-default mt-1"
            }, [
              le(l.$slots, "default"),
              n.required ? (v(), C("span", {
                key: 0,
                class: J([
                  "text-mgm-txt-sm font-medium",
                  { "text-foreground-brand-default": !n.customColor }
                ]),
                style: He({ color: n.customColor || void 0 })
              }, " * ", 6)) : _("", !0)
            ], 8, r$)) : _("", !0),
            n.validation && ((u = n.validation.$errors) != null && u.length) ? (v(), V(_e, {
              key: 1,
              class: "mt-1",
              label: (c = n.validation.$errors[0]) == null ? void 0 : c.$message,
              error: ""
            }, null, 8, ["label"])) : _("", !0)
          ], 2),
          y("div", s$, [
            y("input", {
              id: `${n.id}`,
              class: J([
                "relative box-border h-5 w-5 rounded-[5px] border border-solid border-border-default bg-background-default outline-none disabled:bg-background-subtle-hover",
                {
                  "border-border-subtle focus:border-border-brand-emphasis focus:bg-background-brand-default focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": !n.customColor && !n.disabled,
                  "before:border-border-brand-emphasis before:bg-background-brand-emphasis before:text-foreground-on-emphasis": !n.customColor && n.modelValue && !n.disabled,
                  "before:!border-border-danger-emphasis before:!bg-background-danger-emphasis": n.errorState && n.modelValue && !n.disabled,
                  "before:border-border-default before:bg-background-subtle-hover before:text-foreground-subtle": n.modelValue && n.disabled,
                  "before:absolute before:bottom-0 before:left-[-1px] before:right-0 before:top-[-1px] before:flex before:h-5 before:w-5 before:items-center before:justify-center before:rounded-[5px] before:border before:border-solid before:text-[14px]": n.modelValue,
                  "cursor-pointer": !n.disabled,
                  "selectAll before:pb-[2px]": n.selectAll,
                  "border-border-brand-emphasis bg-background-brand-default-hover": n.forceHover && !n.customColor && !n.disabled,
                  "hover:border-border-brand-emphasis hover:bg-background-brand-default-hover": !n.forceHover && !n.customColor && !n.disabled
                }
              ]),
              checked: n.modelValue,
              disabled: n.disabled,
              name: `${n.id}`,
              required: n.required,
              type: "checkbox",
              onInput: s,
              onFocus: r
            }, null, 42, a$)
          ])
        ])) : (v(), C("div", l$, [
          y("div", d$, [
            y("input", {
              id: `${n.id}`,
              class: J([
                "relative box-border h-5 w-5 rounded-[5px] border border-solid border-border-default bg-background-default outline-none disabled:bg-background-subtle-hover",
                {
                  "border-border-subtle focus:border-border-brand-emphasis focus:bg-background-brand-default focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": !n.customColor && !n.disabled,
                  "before:border-border-brand-emphasis before:bg-background-brand-emphasis before:text-foreground-on-emphasis": !n.customColor && n.modelValue && !n.disabled,
                  "before:!border-border-danger-emphasis before:!bg-background-danger-emphasis": n.errorState && n.modelValue && !n.disabled,
                  "before:border-border-default before:bg-background-subtle-hover before:text-foreground-subtle": n.modelValue && n.disabled,
                  "before:absolute before:bottom-0 before:left-[-1px] before:right-0 before:top-[-1px] before:flex before:h-5 before:w-5 before:items-center before:justify-center before:rounded-[5px] before:border before:border-solid before:text-[14px]": n.modelValue,
                  "cursor-pointer": !n.disabled,
                  "selectAll before:pb-[2px]": n.selectAll,
                  "border-border-brand-emphasis bg-background-brand-default-hover": n.forceHover && !n.customColor && !n.disabled,
                  "hover:border-border-brand-emphasis hover:bg-background-brand-default-hover": !n.forceHover && !n.customColor && !n.disabled
                }
              ]),
              checked: n.modelValue,
              disabled: n.disabled,
              name: `${n.id}`,
              required: n.required,
              type: "checkbox",
              onInput: s,
              onFocus: r
            }, null, 42, u$)
          ]),
          y("div", {
            class: J(["ml-2", { "w-full": n.labelFullWidth }])
          }, [
            n.label ? (v(), C("label", {
              key: 0,
              for: `${n.id}`,
              class: "block cursor-pointer text-mgm-txt-md font-normal text-foreground-default mt-1"
            }, [
              le(l.$slots, "default"),
              n.required ? (v(), C("span", {
                key: 0,
                class: J([
                  "text-mgm-txt-sm font-medium",
                  { "text-foreground-brand-default": !n.customColor }
                ]),
                style: He({ color: n.customColor || void 0 })
              }, " * ", 6)) : _("", !0)
            ], 8, c$)) : _("", !0),
            n.validation && ((f = n.validation.$errors) != null && f.length) ? (v(), V(_e, {
              key: 1,
              class: "mt-1",
              label: (h = n.validation.$errors[0]) == null ? void 0 : h.$message,
              error: ""
            }, null, 8, ["label"])) : _("", !0)
          ], 2)
        ]))
      ], 544);
    };
  }
});
var Ds = { exports: {} }, f$ = Ds.exports, T0;
function h$() {
  return T0 || (T0 = 1, (function(n, e) {
    (function(t, o) {
      o(e);
    })(f$, (function(t) {
      var o = {
        weekdays: {
          shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ]
        },
        months: {
          shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ]
        },
        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        firstDayOfWeek: 0,
        ordinal: function(i) {
          var r = i % 100;
          if (r > 3 && r < 21)
            return "th";
          switch (r % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: ["AM", "PM"],
        yearAriaLabel: "Year",
        monthAriaLabel: "Month",
        hourAriaLabel: "Hour",
        minuteAriaLabel: "Minute",
        time_24hr: !1
      };
      t.default = o, t.english = o, Object.defineProperty(t, "__esModule", { value: !0 });
    }));
  })(Ds, Ds.exports)), Ds.exports;
}
var p$ = h$(), Ns = { exports: {} }, m$ = Ns.exports, A0;
function g$() {
  return A0 || (A0 = 1, (function(n, e) {
    (function(t, o) {
      o(e);
    })(m$, (function(t) {
      var o = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
        l10ns: {}
      }, i = {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
          longhand: [
            "dimanche",
            "lundi",
            "mardi",
            "mercredi",
            "jeudi",
            "vendredi",
            "samedi"
          ]
        },
        months: {
          shorthand: [
            "janv",
            "févr",
            "mars",
            "avr",
            "mai",
            "juin",
            "juil",
            "août",
            "sept",
            "oct",
            "nov",
            "déc"
          ],
          longhand: [
            "janvier",
            "février",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "août",
            "septembre",
            "octobre",
            "novembre",
            "décembre"
          ]
        },
        ordinal: function(s) {
          return s > 1 ? "" : "er";
        },
        rangeSeparator: " au ",
        weekAbbreviation: "Sem",
        scrollTitle: "Défiler pour augmenter la valeur",
        toggleTitle: "Cliquer pour basculer",
        time_24hr: !0
      };
      o.l10ns.fr = i;
      var r = o.l10ns;
      t.French = i, t.default = r, Object.defineProperty(t, "__esModule", { value: !0 });
    }));
  })(Ns, Ns.exports)), Ns.exports;
}
var v$ = g$(), Ku = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], zr = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(n) {
    return typeof console < "u" && console.warn(n);
  },
  getWeek: function(n) {
    var e = new Date(n.getTime());
    e.setHours(0, 0, 0, 0), e.setDate(e.getDate() + 3 - (e.getDay() + 6) % 7);
    var t = new Date(e.getFullYear(), 0, 4);
    return 1 + Math.round(((e.getTime() - t.getTime()) / 864e5 - 3 + (t.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, pa = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(n) {
    var e = n % 100;
    if (e > 3 && e < 21)
      return "th";
    switch (e % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, gn = function(n, e) {
  return e === void 0 && (e = 2), ("000" + n).slice(e * -1);
}, Pn = function(n) {
  return n === !0 ? 1 : 0;
};
function I0(n, e) {
  var t;
  return function() {
    var o = this, i = arguments;
    clearTimeout(t), t = setTimeout(function() {
      return n.apply(o, i);
    }, e);
  };
}
var Gu = function(n) {
  return n instanceof Array ? n : [n];
};
function sn(n, e, t) {
  if (t === !0)
    return n.classList.add(e);
  n.classList.remove(e);
}
function Ge(n, e, t) {
  var o = window.document.createElement(n);
  return e = e || "", t = t || "", o.className = e, t !== void 0 && (o.textContent = t), o;
}
function Ja(n) {
  for (; n.firstChild; )
    n.removeChild(n.firstChild);
}
function i6(n, e) {
  if (e(n))
    return n;
  if (n.parentNode)
    return i6(n.parentNode, e);
}
function Xa(n, e) {
  var t = Ge("div", "numInputWrapper"), o = Ge("input", "numInput " + n), i = Ge("span", "arrowUp"), r = Ge("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? o.type = "number" : (o.type = "text", o.pattern = "\\d*"), e !== void 0)
    for (var s in e)
      o.setAttribute(s, e[s]);
  return t.appendChild(o), t.appendChild(i), t.appendChild(r), t;
}
function kn(n) {
  try {
    if (typeof n.composedPath == "function") {
      var e = n.composedPath();
      return e[0];
    }
    return n.target;
  } catch {
    return n.target;
  }
}
var Yu = function() {
}, Zl = function(n, e, t) {
  return t.months[e ? "shorthand" : "longhand"][n];
}, b$ = {
  D: Yu,
  F: function(n, e, t) {
    n.setMonth(t.months.longhand.indexOf(e));
  },
  G: function(n, e) {
    n.setHours((n.getHours() >= 12 ? 12 : 0) + parseFloat(e));
  },
  H: function(n, e) {
    n.setHours(parseFloat(e));
  },
  J: function(n, e) {
    n.setDate(parseFloat(e));
  },
  K: function(n, e, t) {
    n.setHours(n.getHours() % 12 + 12 * Pn(new RegExp(t.amPM[1], "i").test(e)));
  },
  M: function(n, e, t) {
    n.setMonth(t.months.shorthand.indexOf(e));
  },
  S: function(n, e) {
    n.setSeconds(parseFloat(e));
  },
  U: function(n, e) {
    return new Date(parseFloat(e) * 1e3);
  },
  W: function(n, e, t) {
    var o = parseInt(e), i = new Date(n.getFullYear(), 0, 2 + (o - 1) * 7, 0, 0, 0, 0);
    return i.setDate(i.getDate() - i.getDay() + t.firstDayOfWeek), i;
  },
  Y: function(n, e) {
    n.setFullYear(parseFloat(e));
  },
  Z: function(n, e) {
    return new Date(e);
  },
  d: function(n, e) {
    n.setDate(parseFloat(e));
  },
  h: function(n, e) {
    n.setHours((n.getHours() >= 12 ? 12 : 0) + parseFloat(e));
  },
  i: function(n, e) {
    n.setMinutes(parseFloat(e));
  },
  j: function(n, e) {
    n.setDate(parseFloat(e));
  },
  l: Yu,
  m: function(n, e) {
    n.setMonth(parseFloat(e) - 1);
  },
  n: function(n, e) {
    n.setMonth(parseFloat(e) - 1);
  },
  s: function(n, e) {
    n.setSeconds(parseFloat(e));
  },
  u: function(n, e) {
    return new Date(parseFloat(e));
  },
  w: Yu,
  y: function(n, e) {
    n.setFullYear(2e3 + parseFloat(e));
  }
}, Wi = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, Gs = {
  Z: function(n) {
    return n.toISOString();
  },
  D: function(n, e, t) {
    return e.weekdays.shorthand[Gs.w(n, e, t)];
  },
  F: function(n, e, t) {
    return Zl(Gs.n(n, e, t) - 1, !1, e);
  },
  G: function(n, e, t) {
    return gn(Gs.h(n, e, t));
  },
  H: function(n) {
    return gn(n.getHours());
  },
  J: function(n, e) {
    return e.ordinal !== void 0 ? n.getDate() + e.ordinal(n.getDate()) : n.getDate();
  },
  K: function(n, e) {
    return e.amPM[Pn(n.getHours() > 11)];
  },
  M: function(n, e) {
    return Zl(n.getMonth(), !0, e);
  },
  S: function(n) {
    return gn(n.getSeconds());
  },
  U: function(n) {
    return n.getTime() / 1e3;
  },
  W: function(n, e, t) {
    return t.getWeek(n);
  },
  Y: function(n) {
    return gn(n.getFullYear(), 4);
  },
  d: function(n) {
    return gn(n.getDate());
  },
  h: function(n) {
    return n.getHours() % 12 ? n.getHours() % 12 : 12;
  },
  i: function(n) {
    return gn(n.getMinutes());
  },
  j: function(n) {
    return n.getDate();
  },
  l: function(n, e) {
    return e.weekdays.longhand[n.getDay()];
  },
  m: function(n) {
    return gn(n.getMonth() + 1);
  },
  n: function(n) {
    return n.getMonth() + 1;
  },
  s: function(n) {
    return n.getSeconds();
  },
  u: function(n) {
    return n.getTime();
  },
  w: function(n) {
    return n.getDay();
  },
  y: function(n) {
    return String(n.getFullYear()).substring(2);
  }
}, r6 = function(n) {
  var e = n.config, t = e === void 0 ? zr : e, o = n.l10n, i = o === void 0 ? pa : o, r = n.isMobile, s = r === void 0 ? !1 : r;
  return function(a, l, d) {
    var u = d || i;
    return t.formatDate !== void 0 && !s ? t.formatDate(a, l, u) : l.split("").map(function(c, f, h) {
      return Gs[c] && h[f - 1] !== "\\" ? Gs[c](a, u, t) : c !== "\\" ? c : "";
    }).join("");
  };
}, lf = function(n) {
  var e = n.config, t = e === void 0 ? zr : e, o = n.l10n, i = o === void 0 ? pa : o;
  return function(r, s, a, l) {
    if (!(r !== 0 && !r)) {
      var d = l || i, u, c = r;
      if (r instanceof Date)
        u = new Date(r.getTime());
      else if (typeof r != "string" && r.toFixed !== void 0)
        u = new Date(r);
      else if (typeof r == "string") {
        var f = s || (t || zr).dateFormat, h = String(r).trim();
        if (h === "today")
          u = /* @__PURE__ */ new Date(), a = !0;
        else if (t && t.parseDate)
          u = t.parseDate(r, f);
        else if (/Z$/.test(h) || /GMT$/.test(h))
          u = new Date(r);
        else {
          for (var p = void 0, m = [], g = 0, b = 0, x = ""; g < f.length; g++) {
            var w = f[g], M = w === "\\", $ = f[g - 1] === "\\" || M;
            if (Wi[w] && !$) {
              x += Wi[w];
              var T = new RegExp(x).exec(r);
              T && (p = !0) && m[w !== "Y" ? "push" : "unshift"]({
                fn: b$[w],
                val: T[++b]
              });
            } else M || (x += ".");
          }
          u = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), m.forEach(function(E) {
            var S = E.fn, D = E.val;
            return u = S(u, D, d) || u;
          }), u = p ? u : void 0;
        }
      }
      if (!(u instanceof Date && !isNaN(u.getTime()))) {
        t.errorHandler(new Error("Invalid date provided: " + c));
        return;
      }
      return a === !0 && u.setHours(0, 0, 0, 0), u;
    }
  };
};
function $n(n, e, t) {
  return t === void 0 && (t = !0), t !== !1 ? new Date(n.getTime()).setHours(0, 0, 0, 0) - new Date(e.getTime()).setHours(0, 0, 0, 0) : n.getTime() - e.getTime();
}
var y$ = function(n, e, t) {
  return n > Math.min(e, t) && n < Math.max(e, t);
}, qu = function(n, e, t) {
  return n * 3600 + e * 60 + t;
}, x$ = function(n) {
  var e = Math.floor(n / 3600), t = (n - e * 3600) / 60;
  return [e, t, n - e * 3600 - t * 60];
}, C$ = {
  DAY: 864e5
};
function Zu(n) {
  var e = n.defaultHour, t = n.defaultMinute, o = n.defaultSeconds;
  if (n.minDate !== void 0) {
    var i = n.minDate.getHours(), r = n.minDate.getMinutes(), s = n.minDate.getSeconds();
    e < i && (e = i), e === i && t < r && (t = r), e === i && t === r && o < s && (o = n.minDate.getSeconds());
  }
  if (n.maxDate !== void 0) {
    var a = n.maxDate.getHours(), l = n.maxDate.getMinutes();
    e = Math.min(e, a), e === a && (t = Math.min(l, t)), e === a && t === l && (o = n.maxDate.getSeconds());
  }
  return { hours: e, minutes: t, seconds: o };
}
typeof Object.assign != "function" && (Object.assign = function(n) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  if (!n)
    throw TypeError("Cannot convert undefined or null to object");
  for (var o = function(a) {
    a && Object.keys(a).forEach(function(l) {
      return n[l] = a[l];
    });
  }, i = 0, r = e; i < r.length; i++) {
    var s = r[i];
    o(s);
  }
  return n;
});
var Yt = function() {
  return Yt = Object.assign || function(n) {
    for (var e, t = 1, o = arguments.length; t < o; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
    }
    return n;
  }, Yt.apply(this, arguments);
}, D0 = function() {
  for (var n = 0, e = 0, t = arguments.length; e < t; e++) n += arguments[e].length;
  for (var o = Array(n), i = 0, e = 0; e < t; e++)
    for (var r = arguments[e], s = 0, a = r.length; s < a; s++, i++)
      o[i] = r[s];
  return o;
}, w$ = 300;
function k$(n, e) {
  var t = {
    config: Yt(Yt({}, zr), Ct.defaultConfig),
    l10n: pa
  };
  t.parseDate = lf({ config: t.config, l10n: t.l10n }), t._handlers = [], t.pluginElements = [], t.loadedPlugins = [], t._bind = m, t._setHoursFromDate = f, t._positionCalendar = de, t.changeMonth = ut, t.changeYear = oo, t.clear = it, t.close = Ut, t.onMouseOver = ro, t._createElement = Ge, t.createDay = T, t.destroy = nn, t.isEnabled = Cn, t.jumpToDate = x, t.updateValue = In, t.open = Li, t.redraw = ve, t.set = K, t.setDate = $e, t.toggle = Jo;
  function o() {
    t.utils = {
      getDaysInMonth: function(O, A) {
        return O === void 0 && (O = t.currentMonth), A === void 0 && (A = t.currentYear), O === 1 && (A % 4 === 0 && A % 100 !== 0 || A % 400 === 0) ? 29 : t.l10n.daysInMonth[O];
      }
    };
  }
  function i() {
    t.element = t.input = n, t.isOpen = !1, Z(), q(), An(), on(), o(), t.isMobile || $(), b(), (t.selectedDates.length || t.config.noCalendar) && (t.config.enableTime && f(t.config.noCalendar ? t.latestSelectedDateObj : void 0), In(!1)), a();
    var O = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !t.isMobile && O && de(), Xe("onReady");
  }
  function r() {
    var O;
    return ((O = t.calendarContainer) === null || O === void 0 ? void 0 : O.getRootNode()).activeElement || document.activeElement;
  }
  function s(O) {
    return O.bind(t);
  }
  function a() {
    var O = t.config;
    O.weekNumbers === !1 && O.showMonths === 1 || O.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (t.calendarContainer !== void 0 && (t.calendarContainer.style.visibility = "hidden", t.calendarContainer.style.display = "block"), t.daysContainer !== void 0) {
        var A = (t.days.offsetWidth + 1) * O.showMonths;
        t.daysContainer.style.width = A + "px", t.calendarContainer.style.width = A + (t.weekWrapper !== void 0 ? t.weekWrapper.offsetWidth : 0) + "px", t.calendarContainer.style.removeProperty("visibility"), t.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function l(O) {
    if (t.selectedDates.length === 0) {
      var A = t.config.minDate === void 0 || $n(/* @__PURE__ */ new Date(), t.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(t.config.minDate.getTime()), P = Zu(t.config);
      A.setHours(P.hours, P.minutes, P.seconds, A.getMilliseconds()), t.selectedDates = [A], t.latestSelectedDateObj = A;
    }
    O !== void 0 && O.type !== "blur" && qa(O);
    var G = t._input.value;
    c(), In(), t._input.value !== G && t._debouncedChange();
  }
  function d(O, A) {
    return O % 12 + 12 * Pn(A === t.l10n.amPM[1]);
  }
  function u(O) {
    switch (O % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return O % 12;
    }
  }
  function c() {
    if (!(t.hourElement === void 0 || t.minuteElement === void 0)) {
      var O = (parseInt(t.hourElement.value.slice(-2), 10) || 0) % 24, A = (parseInt(t.minuteElement.value, 10) || 0) % 60, P = t.secondElement !== void 0 ? (parseInt(t.secondElement.value, 10) || 0) % 60 : 0;
      t.amPM !== void 0 && (O = d(O, t.amPM.textContent));
      var G = t.config.minTime !== void 0 || t.config.minDate && t.minDateHasTime && t.latestSelectedDateObj && $n(t.latestSelectedDateObj, t.config.minDate, !0) === 0, se = t.config.maxTime !== void 0 || t.config.maxDate && t.maxDateHasTime && t.latestSelectedDateObj && $n(t.latestSelectedDateObj, t.config.maxDate, !0) === 0;
      if (t.config.maxTime !== void 0 && t.config.minTime !== void 0 && t.config.minTime > t.config.maxTime) {
        var ue = qu(t.config.minTime.getHours(), t.config.minTime.getMinutes(), t.config.minTime.getSeconds()), Ie = qu(t.config.maxTime.getHours(), t.config.maxTime.getMinutes(), t.config.maxTime.getSeconds()), pe = qu(O, A, P);
        if (pe > Ie && pe < ue) {
          var Fe = x$(ue);
          O = Fe[0], A = Fe[1], P = Fe[2];
        }
      } else {
        if (se) {
          var me = t.config.maxTime !== void 0 ? t.config.maxTime : t.config.maxDate;
          O = Math.min(O, me.getHours()), O === me.getHours() && (A = Math.min(A, me.getMinutes())), A === me.getMinutes() && (P = Math.min(P, me.getSeconds()));
        }
        if (G) {
          var Oe = t.config.minTime !== void 0 ? t.config.minTime : t.config.minDate;
          O = Math.max(O, Oe.getHours()), O === Oe.getHours() && A < Oe.getMinutes() && (A = Oe.getMinutes()), A === Oe.getMinutes() && (P = Math.max(P, Oe.getSeconds()));
        }
      }
      h(O, A, P);
    }
  }
  function f(O) {
    var A = O || t.latestSelectedDateObj;
    A && A instanceof Date && h(A.getHours(), A.getMinutes(), A.getSeconds());
  }
  function h(O, A, P) {
    t.latestSelectedDateObj !== void 0 && t.latestSelectedDateObj.setHours(O % 24, A, P || 0, 0), !(!t.hourElement || !t.minuteElement || t.isMobile) && (t.hourElement.value = gn(t.config.time_24hr ? O : (12 + O) % 12 + 12 * Pn(O % 12 === 0)), t.minuteElement.value = gn(A), t.amPM !== void 0 && (t.amPM.textContent = t.l10n.amPM[Pn(O >= 12)]), t.secondElement !== void 0 && (t.secondElement.value = gn(P)));
  }
  function p(O) {
    var A = kn(O), P = parseInt(A.value) + (O.delta || 0);
    (P / 1e3 > 1 || O.key === "Enter" && !/[^\d]/.test(P.toString())) && oo(P);
  }
  function m(O, A, P, G) {
    if (A instanceof Array)
      return A.forEach(function(se) {
        return m(O, se, P, G);
      });
    if (O instanceof Array)
      return O.forEach(function(se) {
        return m(se, A, P, G);
      });
    O.addEventListener(A, P, G), t._handlers.push({
      remove: function() {
        return O.removeEventListener(A, P, G);
      }
    });
  }
  function g() {
    Xe("onChange");
  }
  function b() {
    if (t.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(P) {
      Array.prototype.forEach.call(t.element.querySelectorAll("[data-" + P + "]"), function(G) {
        return m(G, "click", t[P]);
      });
    }), t.isMobile) {
      hn();
      return;
    }
    var O = I0(Pi, 50);
    if (t._debouncedChange = I0(g, w$), t.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && m(t.daysContainer, "mouseover", function(P) {
      t.config.mode === "range" && ro(kn(P));
    }), m(t._input, "keydown", Zo), t.calendarContainer !== void 0 && m(t.calendarContainer, "keydown", Zo), !t.config.inline && !t.config.static && m(window, "resize", O), window.ontouchstart !== void 0 ? m(window.document, "touchstart", At) : m(window.document, "mousedown", At), m(window.document, "focus", At, { capture: !0 }), t.config.clickOpens === !0 && (m(t._input, "focus", t.open), m(t._input, "click", t.open)), t.daysContainer !== void 0 && (m(t.monthNav, "click", Ya), m(t.monthNav, ["keyup", "increment"], p), m(t.daysContainer, "click", Ne)), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0) {
      var A = function(P) {
        return kn(P).select();
      };
      m(t.timeContainer, ["increment"], l), m(t.timeContainer, "blur", l, { capture: !0 }), m(t.timeContainer, "click", w), m([t.hourElement, t.minuteElement], ["focus", "click"], A), t.secondElement !== void 0 && m(t.secondElement, "focus", function() {
        return t.secondElement && t.secondElement.select();
      }), t.amPM !== void 0 && m(t.amPM, "click", function(P) {
        l(P);
      });
    }
    t.config.allowInput && m(t._input, "blur", Ni);
  }
  function x(O, A) {
    var P = O !== void 0 ? t.parseDate(O) : t.latestSelectedDateObj || (t.config.minDate && t.config.minDate > t.now ? t.config.minDate : t.config.maxDate && t.config.maxDate < t.now ? t.config.maxDate : t.now), G = t.currentYear, se = t.currentMonth;
    try {
      P !== void 0 && (t.currentYear = P.getFullYear(), t.currentMonth = P.getMonth());
    } catch (ue) {
      ue.message = "Invalid date supplied: " + P, t.config.errorHandler(ue);
    }
    A && t.currentYear !== G && (Xe("onYearChange"), Y()), A && (t.currentYear !== G || t.currentMonth !== se) && Xe("onMonthChange"), t.redraw();
  }
  function w(O) {
    var A = kn(O);
    ~A.className.indexOf("arrow") && M(O, A.classList.contains("arrowUp") ? 1 : -1);
  }
  function M(O, A, P) {
    var G = O && kn(O), se = P || G && G.parentNode && G.parentNode.firstChild, ue = wr("increment");
    ue.delta = A, se && se.dispatchEvent(ue);
  }
  function $() {
    var O = window.document.createDocumentFragment();
    if (t.calendarContainer = Ge("div", "flatpickr-calendar"), t.calendarContainer.tabIndex = -1, !t.config.noCalendar) {
      if (O.appendChild(te()), t.innerContainer = Ge("div", "flatpickr-innerContainer"), t.config.weekNumbers) {
        var A = rt(), P = A.weekWrapper, G = A.weekNumbers;
        t.innerContainer.appendChild(P), t.weekNumbers = G, t.weekWrapper = P;
      }
      t.rContainer = Ge("div", "flatpickr-rContainer"), t.rContainer.appendChild(we()), t.daysContainer || (t.daysContainer = Ge("div", "flatpickr-days"), t.daysContainer.tabIndex = -1), F(), t.rContainer.appendChild(t.daysContainer), t.innerContainer.appendChild(t.rContainer), O.appendChild(t.innerContainer);
    }
    t.config.enableTime && O.appendChild(ce()), sn(t.calendarContainer, "rangeMode", t.config.mode === "range"), sn(t.calendarContainer, "animate", t.config.animate === !0), sn(t.calendarContainer, "multiMonth", t.config.showMonths > 1), t.calendarContainer.appendChild(O);
    var se = t.config.appendTo !== void 0 && t.config.appendTo.nodeType !== void 0;
    if ((t.config.inline || t.config.static) && (t.calendarContainer.classList.add(t.config.inline ? "inline" : "static"), t.config.inline && (!se && t.element.parentNode ? t.element.parentNode.insertBefore(t.calendarContainer, t._input.nextSibling) : t.config.appendTo !== void 0 && t.config.appendTo.appendChild(t.calendarContainer)), t.config.static)) {
      var ue = Ge("div", "flatpickr-wrapper");
      t.element.parentNode && t.element.parentNode.insertBefore(ue, t.element), ue.appendChild(t.element), t.altInput && ue.appendChild(t.altInput), ue.appendChild(t.calendarContainer);
    }
    !t.config.static && !t.config.inline && (t.config.appendTo !== void 0 ? t.config.appendTo : window.document.body).appendChild(t.calendarContainer);
  }
  function T(O, A, P, G) {
    var se = Cn(A, !0), ue = Ge("span", O, A.getDate().toString());
    return ue.dateObj = A, ue.$i = G, ue.setAttribute("aria-label", t.formatDate(A, t.config.ariaDateFormat)), O.indexOf("hidden") === -1 && $n(A, t.now) === 0 && (t.todayDateElem = ue, ue.classList.add("today"), ue.setAttribute("aria-current", "date")), se ? (ue.tabIndex = -1, kr(A) && (ue.classList.add("selected"), t.selectedDateElem = ue, t.config.mode === "range" && (sn(ue, "startRange", t.selectedDates[0] && $n(A, t.selectedDates[0], !0) === 0), sn(ue, "endRange", t.selectedDates[1] && $n(A, t.selectedDates[1], !0) === 0), O === "nextMonthDay" && ue.classList.add("inRange")))) : ue.classList.add("flatpickr-disabled"), t.config.mode === "range" && Ga(A) && !kr(A) && ue.classList.add("inRange"), t.weekNumbers && t.config.showMonths === 1 && O !== "prevMonthDay" && G % 7 === 6 && t.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + t.config.getWeek(A) + "</span>"), Xe("onDayCreate", ue), ue;
  }
  function E(O) {
    O.focus(), t.config.mode === "range" && ro(O);
  }
  function S(O) {
    for (var A = O > 0 ? 0 : t.config.showMonths - 1, P = O > 0 ? t.config.showMonths : -1, G = A; G != P; G += O)
      for (var se = t.daysContainer.children[G], ue = O > 0 ? 0 : se.children.length - 1, Ie = O > 0 ? se.children.length : -1, pe = ue; pe != Ie; pe += O) {
        var Fe = se.children[pe];
        if (Fe.className.indexOf("hidden") === -1 && Cn(Fe.dateObj))
          return Fe;
      }
  }
  function D(O, A) {
    for (var P = O.className.indexOf("Month") === -1 ? O.dateObj.getMonth() : t.currentMonth, G = A > 0 ? t.config.showMonths : -1, se = A > 0 ? 1 : -1, ue = P - t.currentMonth; ue != G; ue += se)
      for (var Ie = t.daysContainer.children[ue], pe = P - t.currentMonth === ue ? O.$i + A : A < 0 ? Ie.children.length - 1 : 0, Fe = Ie.children.length, me = pe; me >= 0 && me < Fe && me != (A > 0 ? Fe : -1); me += se) {
        var Oe = Ie.children[me];
        if (Oe.className.indexOf("hidden") === -1 && Cn(Oe.dateObj) && Math.abs(O.$i - me) >= Math.abs(A))
          return E(Oe);
      }
    t.changeMonth(se), I(S(se), 0);
  }
  function I(O, A) {
    var P = r(), G = io(P || document.body), se = O !== void 0 ? O : G ? P : t.selectedDateElem !== void 0 && io(t.selectedDateElem) ? t.selectedDateElem : t.todayDateElem !== void 0 && io(t.todayDateElem) ? t.todayDateElem : S(A > 0 ? 1 : -1);
    se === void 0 ? t._input.focus() : G ? D(se, A) : E(se);
  }
  function z(O, A) {
    for (var P = (new Date(O, A, 1).getDay() - t.l10n.firstDayOfWeek + 7) % 7, G = t.utils.getDaysInMonth((A - 1 + 12) % 12, O), se = t.utils.getDaysInMonth(A, O), ue = window.document.createDocumentFragment(), Ie = t.config.showMonths > 1, pe = Ie ? "prevMonthDay hidden" : "prevMonthDay", Fe = Ie ? "nextMonthDay hidden" : "nextMonthDay", me = G + 1 - P, Oe = 0; me <= G; me++, Oe++)
      ue.appendChild(T("flatpickr-day " + pe, new Date(O, A - 1, me), me, Oe));
    for (me = 1; me <= se; me++, Oe++)
      ue.appendChild(T("flatpickr-day", new Date(O, A, me), me, Oe));
    for (var tt = se + 1; tt <= 42 - P && (t.config.showMonths === 1 || Oe % 7 !== 0); tt++, Oe++)
      ue.appendChild(T("flatpickr-day " + Fe, new Date(O, A + 1, tt % se), tt, Oe));
    var so = Ge("div", "dayContainer");
    return so.appendChild(ue), so;
  }
  function F() {
    if (t.daysContainer !== void 0) {
      Ja(t.daysContainer), t.weekNumbers && Ja(t.weekNumbers);
      for (var O = document.createDocumentFragment(), A = 0; A < t.config.showMonths; A++) {
        var P = new Date(t.currentYear, t.currentMonth, 1);
        P.setMonth(t.currentMonth + A), O.appendChild(z(P.getFullYear(), P.getMonth()));
      }
      t.daysContainer.appendChild(O), t.days = t.daysContainer.firstChild, t.config.mode === "range" && t.selectedDates.length === 1 && ro();
    }
  }
  function Y() {
    if (!(t.config.showMonths > 1 || t.config.monthSelectorType !== "dropdown")) {
      var O = function(G) {
        return t.config.minDate !== void 0 && t.currentYear === t.config.minDate.getFullYear() && G < t.config.minDate.getMonth() ? !1 : !(t.config.maxDate !== void 0 && t.currentYear === t.config.maxDate.getFullYear() && G > t.config.maxDate.getMonth());
      };
      t.monthsDropdownContainer.tabIndex = -1, t.monthsDropdownContainer.innerHTML = "";
      for (var A = 0; A < 12; A++)
        if (O(A)) {
          var P = Ge("option", "flatpickr-monthDropdown-month");
          P.value = new Date(t.currentYear, A).getMonth().toString(), P.textContent = Zl(A, t.config.shorthandCurrentMonth, t.l10n), P.tabIndex = -1, t.currentMonth === A && (P.selected = !0), t.monthsDropdownContainer.appendChild(P);
        }
    }
  }
  function ie() {
    var O = Ge("div", "flatpickr-month"), A = window.document.createDocumentFragment(), P;
    t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? P = Ge("span", "cur-month") : (t.monthsDropdownContainer = Ge("select", "flatpickr-monthDropdown-months"), t.monthsDropdownContainer.setAttribute("aria-label", t.l10n.monthAriaLabel), m(t.monthsDropdownContainer, "change", function(Ie) {
      var pe = kn(Ie), Fe = parseInt(pe.value, 10);
      t.changeMonth(Fe - t.currentMonth), Xe("onMonthChange");
    }), Y(), P = t.monthsDropdownContainer);
    var G = Xa("cur-year", { tabindex: "-1" }), se = G.getElementsByTagName("input")[0];
    se.setAttribute("aria-label", t.l10n.yearAriaLabel), t.config.minDate && se.setAttribute("min", t.config.minDate.getFullYear().toString()), t.config.maxDate && (se.setAttribute("max", t.config.maxDate.getFullYear().toString()), se.disabled = !!t.config.minDate && t.config.minDate.getFullYear() === t.config.maxDate.getFullYear());
    var ue = Ge("div", "flatpickr-current-month");
    return ue.appendChild(P), ue.appendChild(G), A.appendChild(ue), O.appendChild(A), {
      container: O,
      yearElement: se,
      monthElement: P
    };
  }
  function W() {
    Ja(t.monthNav), t.monthNav.appendChild(t.prevMonthNav), t.config.showMonths && (t.yearElements = [], t.monthElements = []);
    for (var O = t.config.showMonths; O--; ) {
      var A = ie();
      t.yearElements.push(A.yearElement), t.monthElements.push(A.monthElement), t.monthNav.appendChild(A.container);
    }
    t.monthNav.appendChild(t.nextMonthNav);
  }
  function te() {
    return t.monthNav = Ge("div", "flatpickr-months"), t.yearElements = [], t.monthElements = [], t.prevMonthNav = Ge("span", "flatpickr-prev-month"), t.prevMonthNav.innerHTML = t.config.prevArrow, t.nextMonthNav = Ge("span", "flatpickr-next-month"), t.nextMonthNav.innerHTML = t.config.nextArrow, W(), Object.defineProperty(t, "_hidePrevMonthArrow", {
      get: function() {
        return t.__hidePrevMonthArrow;
      },
      set: function(O) {
        t.__hidePrevMonthArrow !== O && (sn(t.prevMonthNav, "flatpickr-disabled", O), t.__hidePrevMonthArrow = O);
      }
    }), Object.defineProperty(t, "_hideNextMonthArrow", {
      get: function() {
        return t.__hideNextMonthArrow;
      },
      set: function(O) {
        t.__hideNextMonthArrow !== O && (sn(t.nextMonthNav, "flatpickr-disabled", O), t.__hideNextMonthArrow = O);
      }
    }), t.currentYearElement = t.yearElements[0], Ri(), t.monthNav;
  }
  function ce() {
    t.calendarContainer.classList.add("hasTime"), t.config.noCalendar && t.calendarContainer.classList.add("noCalendar");
    var O = Zu(t.config);
    t.timeContainer = Ge("div", "flatpickr-time"), t.timeContainer.tabIndex = -1;
    var A = Ge("span", "flatpickr-time-separator", ":"), P = Xa("flatpickr-hour", {
      "aria-label": t.l10n.hourAriaLabel
    });
    t.hourElement = P.getElementsByTagName("input")[0];
    var G = Xa("flatpickr-minute", {
      "aria-label": t.l10n.minuteAriaLabel
    });
    if (t.minuteElement = G.getElementsByTagName("input")[0], t.hourElement.tabIndex = t.minuteElement.tabIndex = -1, t.hourElement.value = gn(t.latestSelectedDateObj ? t.latestSelectedDateObj.getHours() : t.config.time_24hr ? O.hours : u(O.hours)), t.minuteElement.value = gn(t.latestSelectedDateObj ? t.latestSelectedDateObj.getMinutes() : O.minutes), t.hourElement.setAttribute("step", t.config.hourIncrement.toString()), t.minuteElement.setAttribute("step", t.config.minuteIncrement.toString()), t.hourElement.setAttribute("min", t.config.time_24hr ? "0" : "1"), t.hourElement.setAttribute("max", t.config.time_24hr ? "23" : "12"), t.hourElement.setAttribute("maxlength", "2"), t.minuteElement.setAttribute("min", "0"), t.minuteElement.setAttribute("max", "59"), t.minuteElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(P), t.timeContainer.appendChild(A), t.timeContainer.appendChild(G), t.config.time_24hr && t.timeContainer.classList.add("time24hr"), t.config.enableSeconds) {
      t.timeContainer.classList.add("hasSeconds");
      var se = Xa("flatpickr-second");
      t.secondElement = se.getElementsByTagName("input")[0], t.secondElement.value = gn(t.latestSelectedDateObj ? t.latestSelectedDateObj.getSeconds() : O.seconds), t.secondElement.setAttribute("step", t.minuteElement.getAttribute("step")), t.secondElement.setAttribute("min", "0"), t.secondElement.setAttribute("max", "59"), t.secondElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(Ge("span", "flatpickr-time-separator", ":")), t.timeContainer.appendChild(se);
    }
    return t.config.time_24hr || (t.amPM = Ge("span", "flatpickr-am-pm", t.l10n.amPM[Pn((t.latestSelectedDateObj ? t.hourElement.value : t.config.defaultHour) > 11)]), t.amPM.title = t.l10n.toggleTitle, t.amPM.tabIndex = -1, t.timeContainer.appendChild(t.amPM)), t.timeContainer;
  }
  function we() {
    t.weekdayContainer ? Ja(t.weekdayContainer) : t.weekdayContainer = Ge("div", "flatpickr-weekdays");
    for (var O = t.config.showMonths; O--; ) {
      var A = Ge("div", "flatpickr-weekdaycontainer");
      t.weekdayContainer.appendChild(A);
    }
    return ke(), t.weekdayContainer;
  }
  function ke() {
    if (t.weekdayContainer) {
      var O = t.l10n.firstDayOfWeek, A = D0(t.l10n.weekdays.shorthand);
      O > 0 && O < A.length && (A = D0(A.splice(O, A.length), A.splice(0, O)));
      for (var P = t.config.showMonths; P--; )
        t.weekdayContainer.children[P].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + A.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function rt() {
    t.calendarContainer.classList.add("hasWeeks");
    var O = Ge("div", "flatpickr-weekwrapper");
    O.appendChild(Ge("span", "flatpickr-weekday", t.l10n.weekAbbreviation));
    var A = Ge("div", "flatpickr-weeks");
    return O.appendChild(A), {
      weekWrapper: O,
      weekNumbers: A
    };
  }
  function ut(O, A) {
    A === void 0 && (A = !0);
    var P = A ? O : O - t.currentMonth;
    P < 0 && t._hidePrevMonthArrow === !0 || P > 0 && t._hideNextMonthArrow === !0 || (t.currentMonth += P, (t.currentMonth < 0 || t.currentMonth > 11) && (t.currentYear += t.currentMonth > 11 ? 1 : -1, t.currentMonth = (t.currentMonth + 12) % 12, Xe("onYearChange"), Y()), F(), Xe("onMonthChange"), Ri());
  }
  function it(O, A) {
    if (O === void 0 && (O = !0), A === void 0 && (A = !0), t.input.value = "", t.altInput !== void 0 && (t.altInput.value = ""), t.mobileInput !== void 0 && (t.mobileInput.value = ""), t.selectedDates = [], t.latestSelectedDateObj = void 0, A === !0 && (t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth()), t.config.enableTime === !0) {
      var P = Zu(t.config), G = P.hours, se = P.minutes, ue = P.seconds;
      h(G, se, ue);
    }
    t.redraw(), O && Xe("onChange");
  }
  function Ut() {
    t.isOpen = !1, t.isMobile || (t.calendarContainer !== void 0 && t.calendarContainer.classList.remove("open"), t._input !== void 0 && t._input.classList.remove("active")), Xe("onClose");
  }
  function nn() {
    t.config !== void 0 && Xe("onDestroy");
    for (var O = t._handlers.length; O--; )
      t._handlers[O].remove();
    if (t._handlers = [], t.mobileInput)
      t.mobileInput.parentNode && t.mobileInput.parentNode.removeChild(t.mobileInput), t.mobileInput = void 0;
    else if (t.calendarContainer && t.calendarContainer.parentNode)
      if (t.config.static && t.calendarContainer.parentNode) {
        var A = t.calendarContainer.parentNode;
        if (A.lastChild && A.removeChild(A.lastChild), A.parentNode) {
          for (; A.firstChild; )
            A.parentNode.insertBefore(A.firstChild, A);
          A.parentNode.removeChild(A);
        }
      } else
        t.calendarContainer.parentNode.removeChild(t.calendarContainer);
    t.altInput && (t.input.type = "text", t.altInput.parentNode && t.altInput.parentNode.removeChild(t.altInput), delete t.altInput), t.input && (t.input.type = t.input._type, t.input.classList.remove("flatpickr-input"), t.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(P) {
      try {
        delete t[P];
      } catch {
      }
    });
  }
  function ct(O) {
    return t.calendarContainer.contains(O);
  }
  function At(O) {
    if (t.isOpen && !t.config.inline) {
      var A = kn(O), P = ct(A), G = A === t.input || A === t.altInput || t.element.contains(A) || O.path && O.path.indexOf && (~O.path.indexOf(t.input) || ~O.path.indexOf(t.altInput)), se = !G && !P && !ct(O.relatedTarget), ue = !t.config.ignoredFocusElements.some(function(Ie) {
        return Ie.contains(A);
      });
      se && ue && (t.config.allowInput && t.setDate(t._input.value, !1, t.config.altInput ? t.config.altFormat : t.config.dateFormat), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0 && t.input.value !== "" && t.input.value !== void 0 && l(), t.close(), t.config && t.config.mode === "range" && t.selectedDates.length === 1 && t.clear(!1));
    }
  }
  function oo(O) {
    if (!(!O || t.config.minDate && O < t.config.minDate.getFullYear() || t.config.maxDate && O > t.config.maxDate.getFullYear())) {
      var A = O, P = t.currentYear !== A;
      t.currentYear = A || t.currentYear, t.config.maxDate && t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth = Math.min(t.config.maxDate.getMonth(), t.currentMonth) : t.config.minDate && t.currentYear === t.config.minDate.getFullYear() && (t.currentMonth = Math.max(t.config.minDate.getMonth(), t.currentMonth)), P && (t.redraw(), Xe("onYearChange"), Y());
    }
  }
  function Cn(O, A) {
    var P;
    A === void 0 && (A = !0);
    var G = t.parseDate(O, void 0, A);
    if (t.config.minDate && G && $n(G, t.config.minDate, A !== void 0 ? A : !t.minDateHasTime) < 0 || t.config.maxDate && G && $n(G, t.config.maxDate, A !== void 0 ? A : !t.maxDateHasTime) > 0)
      return !1;
    if (!t.config.enable && t.config.disable.length === 0)
      return !0;
    if (G === void 0)
      return !1;
    for (var se = !!t.config.enable, ue = (P = t.config.enable) !== null && P !== void 0 ? P : t.config.disable, Ie = 0, pe = void 0; Ie < ue.length; Ie++) {
      if (pe = ue[Ie], typeof pe == "function" && pe(G))
        return se;
      if (pe instanceof Date && G !== void 0 && pe.getTime() === G.getTime())
        return se;
      if (typeof pe == "string") {
        var Fe = t.parseDate(pe, void 0, !0);
        return Fe && Fe.getTime() === G.getTime() ? se : !se;
      } else if (typeof pe == "object" && G !== void 0 && pe.from && pe.to && G.getTime() >= pe.from.getTime() && G.getTime() <= pe.to.getTime())
        return se;
    }
    return !se;
  }
  function io(O) {
    return t.daysContainer !== void 0 ? O.className.indexOf("hidden") === -1 && O.className.indexOf("flatpickr-disabled") === -1 && t.daysContainer.contains(O) : !1;
  }
  function Ni(O) {
    var A = O.target === t._input, P = t._input.value.trimEnd() !== $r();
    A && P && !(O.relatedTarget && ct(O.relatedTarget)) && t.setDate(t._input.value, !0, O.target === t.altInput ? t.config.altFormat : t.config.dateFormat);
  }
  function Zo(O) {
    var A = kn(O), P = t.config.wrap ? n.contains(A) : A === t._input, G = t.config.allowInput, se = t.isOpen && (!G || !P), ue = t.config.inline && P && !G;
    if (O.keyCode === 13 && P) {
      if (G)
        return t.setDate(t._input.value, !0, A === t.altInput ? t.config.altFormat : t.config.dateFormat), t.close(), A.blur();
      t.open();
    } else if (ct(A) || se || ue) {
      var Ie = !!t.timeContainer && t.timeContainer.contains(A);
      switch (O.keyCode) {
        case 13:
          Ie ? (O.preventDefault(), l(), ae()) : Ne(O);
          break;
        case 27:
          O.preventDefault(), ae();
          break;
        case 8:
        case 46:
          P && !t.config.allowInput && (O.preventDefault(), t.clear());
          break;
        case 37:
        case 39:
          if (!Ie && !P) {
            O.preventDefault();
            var pe = r();
            if (t.daysContainer !== void 0 && (G === !1 || pe && io(pe))) {
              var Fe = O.keyCode === 39 ? 1 : -1;
              O.ctrlKey ? (O.stopPropagation(), ut(Fe), I(S(1), 0)) : I(void 0, Fe);
            }
          } else t.hourElement && t.hourElement.focus();
          break;
        case 38:
        case 40:
          O.preventDefault();
          var me = O.keyCode === 40 ? 1 : -1;
          t.daysContainer && A.$i !== void 0 || A === t.input || A === t.altInput ? O.ctrlKey ? (O.stopPropagation(), oo(t.currentYear - me), I(S(1), 0)) : Ie || I(void 0, me * 7) : A === t.currentYearElement ? oo(t.currentYear - me) : t.config.enableTime && (!Ie && t.hourElement && t.hourElement.focus(), l(O), t._debouncedChange());
          break;
        case 9:
          if (Ie) {
            var Oe = [
              t.hourElement,
              t.minuteElement,
              t.secondElement,
              t.amPM
            ].concat(t.pluginElements).filter(function(wn) {
              return wn;
            }), tt = Oe.indexOf(A);
            if (tt !== -1) {
              var so = Oe[tt + (O.shiftKey ? -1 : 1)];
              O.preventDefault(), (so || t._input).focus();
            }
          } else !t.config.noCalendar && t.daysContainer && t.daysContainer.contains(A) && O.shiftKey && (O.preventDefault(), t._input.focus());
          break;
      }
    }
    if (t.amPM !== void 0 && A === t.amPM)
      switch (O.key) {
        case t.l10n.amPM[0].charAt(0):
        case t.l10n.amPM[0].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[0], c(), In();
          break;
        case t.l10n.amPM[1].charAt(0):
        case t.l10n.amPM[1].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[1], c(), In();
          break;
      }
    (P || ct(A)) && Xe("onKeyDown", O);
  }
  function ro(O, A) {
    if (A === void 0 && (A = "flatpickr-day"), !(t.selectedDates.length !== 1 || O && (!O.classList.contains(A) || O.classList.contains("flatpickr-disabled")))) {
      for (var P = O ? O.dateObj.getTime() : t.days.firstElementChild.dateObj.getTime(), G = t.parseDate(t.selectedDates[0], void 0, !0).getTime(), se = Math.min(P, t.selectedDates[0].getTime()), ue = Math.max(P, t.selectedDates[0].getTime()), Ie = !1, pe = 0, Fe = 0, me = se; me < ue; me += C$.DAY)
        Cn(new Date(me), !0) || (Ie = Ie || me > se && me < ue, me < G && (!pe || me > pe) ? pe = me : me > G && (!Fe || me < Fe) && (Fe = me));
      var Oe = Array.from(t.rContainer.querySelectorAll("*:nth-child(-n+" + t.config.showMonths + ") > ." + A));
      Oe.forEach(function(tt) {
        var so = tt.dateObj, wn = so.getTime(), ks = pe > 0 && wn < pe || Fe > 0 && wn > Fe;
        if (ks) {
          tt.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(Mr) {
            tt.classList.remove(Mr);
          });
          return;
        } else if (Ie && !ks)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(Mr) {
          tt.classList.remove(Mr);
        }), O !== void 0 && (O.classList.add(P <= t.selectedDates[0].getTime() ? "startRange" : "endRange"), G < P && wn === G ? tt.classList.add("startRange") : G > P && wn === G && tt.classList.add("endRange"), wn >= pe && (Fe === 0 || wn <= Fe) && y$(wn, G, P) && tt.classList.add("inRange"));
      });
    }
  }
  function Pi() {
    t.isOpen && !t.config.static && !t.config.inline && de();
  }
  function Li(O, A) {
    if (A === void 0 && (A = t._positionElement), t.isMobile === !0) {
      if (O) {
        O.preventDefault();
        var P = kn(O);
        P && P.blur();
      }
      t.mobileInput !== void 0 && (t.mobileInput.focus(), t.mobileInput.click()), Xe("onOpen");
      return;
    } else if (t._input.disabled || t.config.inline)
      return;
    var G = t.isOpen;
    t.isOpen = !0, G || (t.calendarContainer.classList.add("open"), t._input.classList.add("active"), Xe("onOpen"), de(A)), t.config.enableTime === !0 && t.config.noCalendar === !0 && t.config.allowInput === !1 && (O === void 0 || !t.timeContainer.contains(O.relatedTarget)) && setTimeout(function() {
      return t.hourElement.select();
    }, 50);
  }
  function X(O) {
    return function(A) {
      var P = t.config["_" + O + "Date"] = t.parseDate(A, t.config.dateFormat), G = t.config["_" + (O === "min" ? "max" : "min") + "Date"];
      P !== void 0 && (t[O === "min" ? "minDateHasTime" : "maxDateHasTime"] = P.getHours() > 0 || P.getMinutes() > 0 || P.getSeconds() > 0), t.selectedDates && (t.selectedDates = t.selectedDates.filter(function(se) {
        return Cn(se);
      }), !t.selectedDates.length && O === "min" && f(P), In()), t.daysContainer && (ve(), P !== void 0 ? t.currentYearElement[O] = P.getFullYear().toString() : t.currentYearElement.removeAttribute(O), t.currentYearElement.disabled = !!G && P !== void 0 && G.getFullYear() === P.getFullYear());
    };
  }
  function Z() {
    var O = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], A = Yt(Yt({}, JSON.parse(JSON.stringify(n.dataset || {}))), e), P = {};
    t.config.parseDate = A.parseDate, t.config.formatDate = A.formatDate, Object.defineProperty(t.config, "enable", {
      get: function() {
        return t.config._enable;
      },
      set: function(Oe) {
        t.config._enable = Ze(Oe);
      }
    }), Object.defineProperty(t.config, "disable", {
      get: function() {
        return t.config._disable;
      },
      set: function(Oe) {
        t.config._disable = Ze(Oe);
      }
    });
    var G = A.mode === "time";
    if (!A.dateFormat && (A.enableTime || G)) {
      var se = Ct.defaultConfig.dateFormat || zr.dateFormat;
      P.dateFormat = A.noCalendar || G ? "H:i" + (A.enableSeconds ? ":S" : "") : se + " H:i" + (A.enableSeconds ? ":S" : "");
    }
    if (A.altInput && (A.enableTime || G) && !A.altFormat) {
      var ue = Ct.defaultConfig.altFormat || zr.altFormat;
      P.altFormat = A.noCalendar || G ? "h:i" + (A.enableSeconds ? ":S K" : " K") : ue + (" h:i" + (A.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(t.config, "minDate", {
      get: function() {
        return t.config._minDate;
      },
      set: X("min")
    }), Object.defineProperty(t.config, "maxDate", {
      get: function() {
        return t.config._maxDate;
      },
      set: X("max")
    });
    var Ie = function(Oe) {
      return function(tt) {
        t.config[Oe === "min" ? "_minTime" : "_maxTime"] = t.parseDate(tt, "H:i:S");
      };
    };
    Object.defineProperty(t.config, "minTime", {
      get: function() {
        return t.config._minTime;
      },
      set: Ie("min")
    }), Object.defineProperty(t.config, "maxTime", {
      get: function() {
        return t.config._maxTime;
      },
      set: Ie("max")
    }), A.mode === "time" && (t.config.noCalendar = !0, t.config.enableTime = !0), Object.assign(t.config, P, A);
    for (var pe = 0; pe < O.length; pe++)
      t.config[O[pe]] = t.config[O[pe]] === !0 || t.config[O[pe]] === "true";
    Ku.filter(function(Oe) {
      return t.config[Oe] !== void 0;
    }).forEach(function(Oe) {
      t.config[Oe] = Gu(t.config[Oe] || []).map(s);
    }), t.isMobile = !t.config.disableMobile && !t.config.inline && t.config.mode === "single" && !t.config.disable.length && !t.config.enable && !t.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var pe = 0; pe < t.config.plugins.length; pe++) {
      var Fe = t.config.plugins[pe](t) || {};
      for (var me in Fe)
        Ku.indexOf(me) > -1 ? t.config[me] = Gu(Fe[me]).map(s).concat(t.config[me]) : typeof A[me] > "u" && (t.config[me] = Fe[me]);
    }
    A.altInputClass || (t.config.altInputClass = N().className + " " + t.config.altInputClass), Xe("onParseConfig");
  }
  function N() {
    return t.config.wrap ? n.querySelector("[data-input]") : n;
  }
  function q() {
    typeof t.config.locale != "object" && typeof Ct.l10ns[t.config.locale] > "u" && t.config.errorHandler(new Error("flatpickr: invalid locale " + t.config.locale)), t.l10n = Yt(Yt({}, Ct.l10ns.default), typeof t.config.locale == "object" ? t.config.locale : t.config.locale !== "default" ? Ct.l10ns[t.config.locale] : void 0), Wi.D = "(" + t.l10n.weekdays.shorthand.join("|") + ")", Wi.l = "(" + t.l10n.weekdays.longhand.join("|") + ")", Wi.M = "(" + t.l10n.months.shorthand.join("|") + ")", Wi.F = "(" + t.l10n.months.longhand.join("|") + ")", Wi.K = "(" + t.l10n.amPM[0] + "|" + t.l10n.amPM[1] + "|" + t.l10n.amPM[0].toLowerCase() + "|" + t.l10n.amPM[1].toLowerCase() + ")";
    var O = Yt(Yt({}, e), JSON.parse(JSON.stringify(n.dataset || {})));
    O.time_24hr === void 0 && Ct.defaultConfig.time_24hr === void 0 && (t.config.time_24hr = t.l10n.time_24hr), t.formatDate = r6(t), t.parseDate = lf({ config: t.config, l10n: t.l10n });
  }
  function de(O) {
    if (typeof t.config.position == "function")
      return void t.config.position(t, O);
    if (t.calendarContainer !== void 0) {
      Xe("onPreCalendarPosition");
      var A = O || t._positionElement, P = Array.prototype.reduce.call(t.calendarContainer.children, (function(ov, iv) {
        return ov + iv.offsetHeight;
      }), 0), G = t.calendarContainer.offsetWidth, se = t.config.position.split(" "), ue = se[0], Ie = se.length > 1 ? se[1] : null, pe = A.getBoundingClientRect(), Fe = window.innerHeight - pe.bottom, me = ue === "above" || ue !== "below" && Fe < P && pe.top > P, Oe = window.pageYOffset + pe.top + (me ? -P - 2 : A.offsetHeight + 2);
      if (sn(t.calendarContainer, "arrowTop", !me), sn(t.calendarContainer, "arrowBottom", me), !t.config.inline) {
        var tt = window.pageXOffset + pe.left, so = !1, wn = !1;
        Ie === "center" ? (tt -= (G - pe.width) / 2, so = !0) : Ie === "right" && (tt -= G - pe.width, wn = !0), sn(t.calendarContainer, "arrowLeft", !so && !wn), sn(t.calendarContainer, "arrowCenter", so), sn(t.calendarContainer, "arrowRight", wn);
        var ks = window.document.body.offsetWidth - (window.pageXOffset + pe.right), Mr = tt + G > window.document.body.offsetWidth, Z9 = ks + G > window.document.body.offsetWidth;
        if (sn(t.calendarContainer, "rightMost", Mr), !t.config.static)
          if (t.calendarContainer.style.top = Oe + "px", !Mr)
            t.calendarContainer.style.left = tt + "px", t.calendarContainer.style.right = "auto";
          else if (!Z9)
            t.calendarContainer.style.left = "auto", t.calendarContainer.style.right = ks + "px";
          else {
            var Wu = fe();
            if (Wu === void 0)
              return;
            var J9 = window.document.body.offsetWidth, X9 = Math.max(0, J9 / 2 - G / 2), Q9 = ".flatpickr-calendar.centerMost:before", ev = ".flatpickr-calendar.centerMost:after", tv = Wu.cssRules.length, nv = "{left:" + pe.left + "px;right:auto;}";
            sn(t.calendarContainer, "rightMost", !1), sn(t.calendarContainer, "centerMost", !0), Wu.insertRule(Q9 + "," + ev + nv, tv), t.calendarContainer.style.left = X9 + "px", t.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function fe() {
    for (var O = null, A = 0; A < document.styleSheets.length; A++) {
      var P = document.styleSheets[A];
      if (P.cssRules) {
        try {
          P.cssRules;
        } catch {
          continue;
        }
        O = P;
        break;
      }
    }
    return O ?? Be();
  }
  function Be() {
    var O = document.createElement("style");
    return document.head.appendChild(O), O.sheet;
  }
  function ve() {
    t.config.noCalendar || t.isMobile || (Y(), Ri(), F());
  }
  function ae() {
    t._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(t.close, 0) : t.close();
  }
  function Ne(O) {
    O.preventDefault(), O.stopPropagation();
    var A = function(Oe) {
      return Oe.classList && Oe.classList.contains("flatpickr-day") && !Oe.classList.contains("flatpickr-disabled") && !Oe.classList.contains("notAllowed");
    }, P = i6(kn(O), A);
    if (P !== void 0) {
      var G = P, se = t.latestSelectedDateObj = new Date(G.dateObj.getTime()), ue = (se.getMonth() < t.currentMonth || se.getMonth() > t.currentMonth + t.config.showMonths - 1) && t.config.mode !== "range";
      if (t.selectedDateElem = G, t.config.mode === "single")
        t.selectedDates = [se];
      else if (t.config.mode === "multiple") {
        var Ie = kr(se);
        Ie ? t.selectedDates.splice(parseInt(Ie), 1) : t.selectedDates.push(se);
      } else t.config.mode === "range" && (t.selectedDates.length === 2 && t.clear(!1, !1), t.latestSelectedDateObj = se, t.selectedDates.push(se), $n(se, t.selectedDates[0], !0) !== 0 && t.selectedDates.sort(function(Oe, tt) {
        return Oe.getTime() - tt.getTime();
      }));
      if (c(), ue) {
        var pe = t.currentYear !== se.getFullYear();
        t.currentYear = se.getFullYear(), t.currentMonth = se.getMonth(), pe && (Xe("onYearChange"), Y()), Xe("onMonthChange");
      }
      if (Ri(), F(), In(), !ue && t.config.mode !== "range" && t.config.showMonths === 1 ? E(G) : t.selectedDateElem !== void 0 && t.hourElement === void 0 && t.selectedDateElem && t.selectedDateElem.focus(), t.hourElement !== void 0 && t.hourElement !== void 0 && t.hourElement.focus(), t.config.closeOnSelect) {
        var Fe = t.config.mode === "single" && !t.config.enableTime, me = t.config.mode === "range" && t.selectedDates.length === 2 && !t.config.enableTime;
        (Fe || me) && ae();
      }
      g();
    }
  }
  var ne = {
    locale: [q, ke],
    showMonths: [W, a, we],
    minDate: [x],
    maxDate: [x],
    positionElement: [rn],
    clickOpens: [
      function() {
        t.config.clickOpens === !0 ? (m(t._input, "focus", t.open), m(t._input, "click", t.open)) : (t._input.removeEventListener("focus", t.open), t._input.removeEventListener("click", t.open));
      }
    ]
  };
  function K(O, A) {
    if (O !== null && typeof O == "object") {
      Object.assign(t.config, O);
      for (var P in O)
        ne[P] !== void 0 && ne[P].forEach(function(G) {
          return G();
        });
    } else
      t.config[O] = A, ne[O] !== void 0 ? ne[O].forEach(function(G) {
        return G();
      }) : Ku.indexOf(O) > -1 && (t.config[O] = Gu(A));
    t.redraw(), In(!0);
  }
  function ee(O, A) {
    var P = [];
    if (O instanceof Array)
      P = O.map(function(G) {
        return t.parseDate(G, A);
      });
    else if (O instanceof Date || typeof O == "number")
      P = [t.parseDate(O, A)];
    else if (typeof O == "string")
      switch (t.config.mode) {
        case "single":
        case "time":
          P = [t.parseDate(O, A)];
          break;
        case "multiple":
          P = O.split(t.config.conjunction).map(function(G) {
            return t.parseDate(G, A);
          });
          break;
        case "range":
          P = O.split(t.l10n.rangeSeparator).map(function(G) {
            return t.parseDate(G, A);
          });
          break;
      }
    else
      t.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(O)));
    t.selectedDates = t.config.allowInvalidPreload ? P : P.filter(function(G) {
      return G instanceof Date && Cn(G, !1);
    }), t.config.mode === "range" && t.selectedDates.sort(function(G, se) {
      return G.getTime() - se.getTime();
    });
  }
  function $e(O, A, P) {
    if (A === void 0 && (A = !1), P === void 0 && (P = t.config.dateFormat), O !== 0 && !O || O instanceof Array && O.length === 0)
      return t.clear(A);
    ee(O, P), t.latestSelectedDateObj = t.selectedDates[t.selectedDates.length - 1], t.redraw(), x(void 0, A), f(), t.selectedDates.length === 0 && t.clear(!1), In(A), A && Xe("onChange");
  }
  function Ze(O) {
    return O.slice().map(function(A) {
      return typeof A == "string" || typeof A == "number" || A instanceof Date ? t.parseDate(A, void 0, !0) : A && typeof A == "object" && A.from && A.to ? {
        from: t.parseDate(A.from, void 0),
        to: t.parseDate(A.to, void 0)
      } : A;
    }).filter(function(A) {
      return A;
    });
  }
  function on() {
    t.selectedDates = [], t.now = t.parseDate(t.config.now) || /* @__PURE__ */ new Date();
    var O = t.config.defaultDate || ((t.input.nodeName === "INPUT" || t.input.nodeName === "TEXTAREA") && t.input.placeholder && t.input.value === t.input.placeholder ? null : t.input.value);
    O && ee(O, t.config.dateFormat), t._initialDate = t.selectedDates.length > 0 ? t.selectedDates[0] : t.config.minDate && t.config.minDate.getTime() > t.now.getTime() ? t.config.minDate : t.config.maxDate && t.config.maxDate.getTime() < t.now.getTime() ? t.config.maxDate : t.now, t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth(), t.selectedDates.length > 0 && (t.latestSelectedDateObj = t.selectedDates[0]), t.config.minTime !== void 0 && (t.config.minTime = t.parseDate(t.config.minTime, "H:i")), t.config.maxTime !== void 0 && (t.config.maxTime = t.parseDate(t.config.maxTime, "H:i")), t.minDateHasTime = !!t.config.minDate && (t.config.minDate.getHours() > 0 || t.config.minDate.getMinutes() > 0 || t.config.minDate.getSeconds() > 0), t.maxDateHasTime = !!t.config.maxDate && (t.config.maxDate.getHours() > 0 || t.config.maxDate.getMinutes() > 0 || t.config.maxDate.getSeconds() > 0);
  }
  function An() {
    if (t.input = N(), !t.input) {
      t.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    t.input._type = t.input.type, t.input.type = "text", t.input.classList.add("flatpickr-input"), t._input = t.input, t.config.altInput && (t.altInput = Ge(t.input.nodeName, t.config.altInputClass), t._input = t.altInput, t.altInput.placeholder = t.input.placeholder, t.altInput.disabled = t.input.disabled, t.altInput.required = t.input.required, t.altInput.tabIndex = t.input.tabIndex, t.altInput.type = "text", t.input.setAttribute("type", "hidden"), !t.config.static && t.input.parentNode && t.input.parentNode.insertBefore(t.altInput, t.input.nextSibling)), t.config.allowInput || t._input.setAttribute("readonly", "readonly"), rn();
  }
  function rn() {
    t._positionElement = t.config.positionElement || t._input;
  }
  function hn() {
    var O = t.config.enableTime ? t.config.noCalendar ? "time" : "datetime-local" : "date";
    t.mobileInput = Ge("input", t.input.className + " flatpickr-mobile"), t.mobileInput.tabIndex = 1, t.mobileInput.type = O, t.mobileInput.disabled = t.input.disabled, t.mobileInput.required = t.input.required, t.mobileInput.placeholder = t.input.placeholder, t.mobileFormatStr = O === "datetime-local" ? "Y-m-d\\TH:i:S" : O === "date" ? "Y-m-d" : "H:i:S", t.selectedDates.length > 0 && (t.mobileInput.defaultValue = t.mobileInput.value = t.formatDate(t.selectedDates[0], t.mobileFormatStr)), t.config.minDate && (t.mobileInput.min = t.formatDate(t.config.minDate, "Y-m-d")), t.config.maxDate && (t.mobileInput.max = t.formatDate(t.config.maxDate, "Y-m-d")), t.input.getAttribute("step") && (t.mobileInput.step = String(t.input.getAttribute("step"))), t.input.type = "hidden", t.altInput !== void 0 && (t.altInput.type = "hidden");
    try {
      t.input.parentNode && t.input.parentNode.insertBefore(t.mobileInput, t.input.nextSibling);
    } catch {
    }
    m(t.mobileInput, "change", function(A) {
      t.setDate(kn(A).value, !1, t.mobileFormatStr), Xe("onChange"), Xe("onClose");
    });
  }
  function Jo(O) {
    if (t.isOpen === !0)
      return t.close();
    t.open(O);
  }
  function Xe(O, A) {
    if (t.config !== void 0) {
      var P = t.config[O];
      if (P !== void 0 && P.length > 0)
        for (var G = 0; P[G] && G < P.length; G++)
          P[G](t.selectedDates, t.input.value, t, A);
      O === "onChange" && (t.input.dispatchEvent(wr("change")), t.input.dispatchEvent(wr("input")));
    }
  }
  function wr(O) {
    var A = document.createEvent("Event");
    return A.initEvent(O, !0, !0), A;
  }
  function kr(O) {
    for (var A = 0; A < t.selectedDates.length; A++) {
      var P = t.selectedDates[A];
      if (P instanceof Date && $n(P, O) === 0)
        return "" + A;
    }
    return !1;
  }
  function Ga(O) {
    return t.config.mode !== "range" || t.selectedDates.length < 2 ? !1 : $n(O, t.selectedDates[0]) >= 0 && $n(O, t.selectedDates[1]) <= 0;
  }
  function Ri() {
    t.config.noCalendar || t.isMobile || !t.monthNav || (t.yearElements.forEach(function(O, A) {
      var P = new Date(t.currentYear, t.currentMonth, 1);
      P.setMonth(t.currentMonth + A), t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? t.monthElements[A].textContent = Zl(P.getMonth(), t.config.shorthandCurrentMonth, t.l10n) + " " : t.monthsDropdownContainer.value = P.getMonth().toString(), O.value = P.getFullYear().toString();
    }), t._hidePrevMonthArrow = t.config.minDate !== void 0 && (t.currentYear === t.config.minDate.getFullYear() ? t.currentMonth <= t.config.minDate.getMonth() : t.currentYear < t.config.minDate.getFullYear()), t._hideNextMonthArrow = t.config.maxDate !== void 0 && (t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth + 1 > t.config.maxDate.getMonth() : t.currentYear > t.config.maxDate.getFullYear()));
  }
  function $r(O) {
    var A = O || (t.config.altInput ? t.config.altFormat : t.config.dateFormat);
    return t.selectedDates.map(function(P) {
      return t.formatDate(P, A);
    }).filter(function(P, G, se) {
      return t.config.mode !== "range" || t.config.enableTime || se.indexOf(P) === G;
    }).join(t.config.mode !== "range" ? t.config.conjunction : t.l10n.rangeSeparator);
  }
  function In(O) {
    O === void 0 && (O = !0), t.mobileInput !== void 0 && t.mobileFormatStr && (t.mobileInput.value = t.latestSelectedDateObj !== void 0 ? t.formatDate(t.latestSelectedDateObj, t.mobileFormatStr) : ""), t.input.value = $r(t.config.dateFormat), t.altInput !== void 0 && (t.altInput.value = $r(t.config.altFormat)), O !== !1 && Xe("onValueUpdate");
  }
  function Ya(O) {
    var A = kn(O), P = t.prevMonthNav.contains(A), G = t.nextMonthNav.contains(A);
    P || G ? ut(P ? -1 : 1) : t.yearElements.indexOf(A) >= 0 ? A.select() : A.classList.contains("arrowUp") ? t.changeYear(t.currentYear + 1) : A.classList.contains("arrowDown") && t.changeYear(t.currentYear - 1);
  }
  function qa(O) {
    O.preventDefault();
    var A = O.type === "keydown", P = kn(O), G = P;
    t.amPM !== void 0 && P === t.amPM && (t.amPM.textContent = t.l10n.amPM[Pn(t.amPM.textContent === t.l10n.amPM[0])]);
    var se = parseFloat(G.getAttribute("min")), ue = parseFloat(G.getAttribute("max")), Ie = parseFloat(G.getAttribute("step")), pe = parseInt(G.value, 10), Fe = O.delta || (A ? O.which === 38 ? 1 : -1 : 0), me = pe + Ie * Fe;
    if (typeof G.value < "u" && G.value.length === 2) {
      var Oe = G === t.hourElement, tt = G === t.minuteElement;
      me < se ? (me = ue + me + Pn(!Oe) + (Pn(Oe) && Pn(!t.amPM)), tt && M(void 0, -1, t.hourElement)) : me > ue && (me = G === t.hourElement ? me - ue - Pn(!t.amPM) : se, tt && M(void 0, 1, t.hourElement)), t.amPM && Oe && (Ie === 1 ? me + pe === 23 : Math.abs(me - pe) > Ie) && (t.amPM.textContent = t.l10n.amPM[Pn(t.amPM.textContent === t.l10n.amPM[0])]), G.value = gn(me);
    }
  }
  return i(), t;
}
function Hr(n, e) {
  for (var t = Array.prototype.slice.call(n).filter(function(s) {
    return s instanceof HTMLElement;
  }), o = [], i = 0; i < t.length; i++) {
    var r = t[i];
    try {
      if (r.getAttribute("data-fp-omit") !== null)
        continue;
      r._flatpickr !== void 0 && (r._flatpickr.destroy(), r._flatpickr = void 0), r._flatpickr = k$(r, e || {}), o.push(r._flatpickr);
    } catch (s) {
      console.error(s);
    }
  }
  return o.length === 1 ? o[0] : o;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(n) {
  return Hr(this, n);
}, HTMLElement.prototype.flatpickr = function(n) {
  return Hr([this], n);
});
var Ct = function(n, e) {
  return typeof n == "string" ? Hr(window.document.querySelectorAll(n), e) : n instanceof Node ? Hr([n], e) : Hr(n, e);
};
Ct.defaultConfig = {};
Ct.l10ns = {
  en: Yt({}, pa),
  default: Yt({}, pa)
};
Ct.localize = function(n) {
  Ct.l10ns.default = Yt(Yt({}, Ct.l10ns.default), n);
};
Ct.setDefaults = function(n) {
  Ct.defaultConfig = Yt(Yt({}, Ct.defaultConfig), n);
};
Ct.parseDate = lf({});
Ct.formatDate = r6({});
Ct.compareDates = $n;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(n) {
  return Hr(this, n);
});
Date.prototype.fp_incr = function(n) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof n == "string" ? parseInt(n, 10) : n));
};
typeof window < "u" && (window.flatpickr = Ct);
const s6 = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], $$ = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function N0(n) {
  return n.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function P0(n) {
  return n instanceof Array ? n : [n];
}
function Ju(n) {
  return n && n.length ? n : null;
}
const L0 = [...s6, ...$$], M$ = ["locale", "showMonths"], S$ = H({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return lt("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...L0.map(N0)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => s6
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = Ct(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let n = Object.assign({}, this.config);
      this.events.forEach((t) => {
        let o = Ct.defaultConfig[t] || [], i = (...r) => {
          this.$emit(N0(t), ...r);
        };
        n[t] = P0(n[t] || []).concat(o, i);
      });
      const e = this.onClose.bind(this);
      return n.onClose = P0(n.onClose || []).concat(e), n.defaultDate = this.modelValue || n.defaultDate, n;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(n) {
      const e = n.target;
      Ve().then(() => {
        this.$emit("update:modelValue", Ju(e.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(n) {
      this.$emit("blur", Ju(n.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(n, e) {
      this.$emit("update:modelValue", e);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(n) {
      n ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(n) {
        if (!this.fp)
          return;
        let e = Object.assign({}, n);
        L0.forEach((t) => {
          delete e[t];
        }), this.fp.set(e), M$.forEach((t) => {
          typeof e[t] < "u" && this.fp.set(t, e[t]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(n) {
      var e;
      !this.$el || n === Ju(this.$el.value) || (e = this.fp) === null || e === void 0 || e.setDate(n, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
}), _$ = { class: "w-full" }, E$ = {
  key: 0,
  class: "mb-1.5"
}, O$ = {
  key: 0,
  class: "flex items-start"
}, T$ = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, A$ = { class: "relative w-full" }, eY = /* @__PURE__ */ H({
  __name: "FieldDatePicker",
  props: {
    modelValue: { default: null },
    locale: { default: "en" },
    id: { default: null },
    label: { default: null },
    description: { default: null },
    placeholder: { default: null },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    disabled: { type: Boolean, default: !1 },
    minDate: { default: void 0 },
    dateOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = L(() => ({
      disableMobile: !0,
      locale: t.locale === "fr" ? v$.French : p$.english,
      altFormat: t.locale === "fr" ? "j F, Y" : "F j, Y",
      altInput: !0,
      dateFormat: t.dateOnly ? "Y-m-d" : "Z",
      enableTime: !1,
      noCalendar: !1,
      minDate: t.minDate,
      onReady: (s, a, l) => {
        l.altInput && (t.id != null && (l.altInput.id = `${t.id}-display`), t.label && l.altInput.setAttribute("aria-label", t.label));
      },
      onChange: (s, a, l) => {
        if (!s.length) {
          r("update:modelValue", null);
          return;
        }
        if (t.dateOnly) {
          r("update:modelValue", l.formatDate(s[0], "Y-m-d"));
          return;
        }
        const d = l.formatDate(s[0], "Y-m-d");
        r("update:modelValue", `${d}T01:00:00.000Z`);
      }
    })), i = R(t.modelValue || null);
    Ee(
      () => t.modelValue,
      (s) => {
        i.value = s ?? null;
      }
    );
    const r = e;
    return (s, a) => {
      var l, d, u, c;
      return v(), C("div", _$, [
        n.label || n.description ? (v(), C("div", E$, [
          n.label ? (v(), C("div", O$, [
            U(_e, {
              for: n.id == null ? void 0 : `${n.id}-display`,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", T$, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", A$, [
          U(ye, {
            class: "absolute bottom-0 left-2.5 top-0",
            icon: "calendar",
            color: "var(--color-foreground-default)"
          }),
          U(k(S$), {
            id: `${n.id}`,
            modelValue: i.value,
            "onUpdate:modelValue": a[0] || (a[0] = (f) => i.value = f),
            config: o.value,
            class: J([
              "box-border block w-full rounded-[4.16px] py-2.5 pl-9 pr-3 text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle placeholder:text-foreground-subtle",
              (d = (l = n.validation) == null ? void 0 : l.$errors) != null && d.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default"
            ]),
            placeholder: n.placeholder,
            disabled: n.disabled
          }, null, 8, ["id", "modelValue", "config", "class", "placeholder", "disabled"])
        ]),
        n.validation && ((u = n.validation.$errors) != null && u.length) ? (v(), V(_e, {
          key: 1,
          class: "mt-[3px]",
          label: (c = n.validation.$errors[0]) == null ? void 0 : c.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ]);
    };
  }
}), I$ = ["top", "right", "bottom", "left"], ki = Math.min, Mn = Math.max, Jl = Math.round, Qa = Math.floor, go = (n) => ({
  x: n,
  y: n
}), D$ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, N$ = {
  start: "end",
  end: "start"
};
function df(n, e, t) {
  return Mn(n, ki(e, t));
}
function zo(n, e) {
  return typeof n == "function" ? n(e) : n;
}
function Ho(n) {
  return n.split("-")[0];
}
function gs(n) {
  return n.split("-")[1];
}
function w1(n) {
  return n === "x" ? "y" : "x";
}
function k1(n) {
  return n === "y" ? "height" : "width";
}
const P$ = /* @__PURE__ */ new Set(["top", "bottom"]);
function mo(n) {
  return P$.has(Ho(n)) ? "y" : "x";
}
function $1(n) {
  return w1(mo(n));
}
function L$(n, e, t) {
  t === void 0 && (t = !1);
  const o = gs(n), i = $1(n), r = k1(i);
  let s = i === "x" ? o === (t ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = Xl(s)), [s, Xl(s)];
}
function R$(n) {
  const e = Xl(n);
  return [uf(n), e, uf(e)];
}
function uf(n) {
  return n.replace(/start|end/g, (e) => N$[e]);
}
const R0 = ["left", "right"], F0 = ["right", "left"], F$ = ["top", "bottom"], B$ = ["bottom", "top"];
function V$(n, e, t) {
  switch (n) {
    case "top":
    case "bottom":
      return t ? e ? F0 : R0 : e ? R0 : F0;
    case "left":
    case "right":
      return e ? F$ : B$;
    default:
      return [];
  }
}
function z$(n, e, t, o) {
  const i = gs(n);
  let r = V$(Ho(n), t === "start", o);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(uf)))), r;
}
function Xl(n) {
  return n.replace(/left|right|bottom|top/g, (e) => D$[e]);
}
function H$(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function a6(n) {
  return typeof n != "number" ? H$(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function Ql(n) {
  const {
    x: e,
    y: t,
    width: o,
    height: i
  } = n;
  return {
    width: o,
    height: i,
    top: t,
    left: e,
    right: e + o,
    bottom: t + i,
    x: e,
    y: t
  };
}
function B0(n, e, t) {
  let {
    reference: o,
    floating: i
  } = n;
  const r = mo(e), s = $1(e), a = k1(s), l = Ho(e), d = r === "y", u = o.x + o.width / 2 - i.width / 2, c = o.y + o.height / 2 - i.height / 2, f = o[a] / 2 - i[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: o.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: c
      };
      break;
    case "left":
      h = {
        x: o.x - i.width,
        y: c
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (gs(e)) {
    case "start":
      h[s] -= f * (t && d ? -1 : 1);
      break;
    case "end":
      h[s] += f * (t && d ? -1 : 1);
      break;
  }
  return h;
}
const j$ = async (n, e, t) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = t, a = r.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let d = await s.getElementRects({
    reference: n,
    floating: e,
    strategy: i
  }), {
    x: u,
    y: c
  } = B0(d, o, l), f = o, h = {}, p = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: g,
      fn: b
    } = a[m], {
      x,
      y: w,
      data: M,
      reset: $
    } = await b({
      x: u,
      y: c,
      initialPlacement: o,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: d,
      platform: s,
      elements: {
        reference: n,
        floating: e
      }
    });
    u = x ?? u, c = w ?? c, h = {
      ...h,
      [g]: {
        ...h[g],
        ...M
      }
    }, $ && p <= 50 && (p++, typeof $ == "object" && ($.placement && (f = $.placement), $.rects && (d = $.rects === !0 ? await s.getElementRects({
      reference: n,
      floating: e,
      strategy: i
    }) : $.rects), {
      x: u,
      y: c
    } = B0(d, f, l)), m = -1);
  }
  return {
    x: u,
    y: c,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function ma(n, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: s,
    elements: a,
    strategy: l
  } = n, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: c = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = zo(e, n), p = a6(h), g = a[f ? c === "floating" ? "reference" : "floating" : c], b = Ql(await r.getClippingRect({
    element: (t = await (r.isElement == null ? void 0 : r.isElement(g))) == null || t ? g : g.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: l
  })), x = c === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a.floating)), M = await (r.isElement == null ? void 0 : r.isElement(w)) ? await (r.getScale == null ? void 0 : r.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = Ql(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (b.top - $.top + p.top) / M.y,
    bottom: ($.bottom - b.bottom + p.bottom) / M.y,
    left: (b.left - $.left + p.left) / M.x,
    right: ($.right - b.right + p.right) / M.x
  };
}
const W$ = (n) => ({
  name: "arrow",
  options: n,
  async fn(e) {
    const {
      x: t,
      y: o,
      placement: i,
      rects: r,
      platform: s,
      elements: a,
      middlewareData: l
    } = e, {
      element: d,
      padding: u = 0
    } = zo(n, e) || {};
    if (d == null)
      return {};
    const c = a6(u), f = {
      x: t,
      y: o
    }, h = $1(i), p = k1(h), m = await s.getDimensions(d), g = h === "y", b = g ? "top" : "left", x = g ? "bottom" : "right", w = g ? "clientHeight" : "clientWidth", M = r.reference[p] + r.reference[h] - f[h] - r.floating[p], $ = f[h] - r.reference[h], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let E = T ? T[w] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(T))) && (E = a.floating[w] || r.floating[p]);
    const S = M / 2 - $ / 2, D = E / 2 - m[p] / 2 - 1, I = ki(c[b], D), z = ki(c[x], D), F = I, Y = E - m[p] - z, ie = E / 2 - m[p] / 2 + S, W = df(F, ie, Y), te = !l.arrow && gs(i) != null && ie !== W && r.reference[p] / 2 - (ie < F ? I : z) - m[p] / 2 < 0, ce = te ? ie < F ? ie - F : ie - Y : 0;
    return {
      [h]: f[h] + ce,
      data: {
        [h]: W,
        centerOffset: ie - W - ce,
        ...te && {
          alignmentOffset: ce
        }
      },
      reset: te
    };
  }
}), U$ = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(e) {
      var t, o;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: d
      } = e, {
        mainAxis: u = !0,
        crossAxis: c = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...g
      } = zo(n, e);
      if ((t = r.arrow) != null && t.alignmentOffset)
        return {};
      const b = Ho(i), x = mo(a), w = Ho(a) === a, M = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), $ = f || (w || !m ? [Xl(a)] : R$(a)), T = p !== "none";
      !f && T && $.push(...z$(a, m, p, M));
      const E = [a, ...$], S = await ma(e, g), D = [];
      let I = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (u && D.push(S[b]), c) {
        const ie = L$(i, s, M);
        D.push(S[ie[0]], S[ie[1]]);
      }
      if (I = [...I, {
        placement: i,
        overflows: D
      }], !D.every((ie) => ie <= 0)) {
        var z, F;
        const ie = (((z = r.flip) == null ? void 0 : z.index) || 0) + 1, W = E[ie];
        if (W && (!(c === "alignment" ? x !== mo(W) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((we) => mo(we.placement) === x ? we.overflows[0] > 0 : !0)))
          return {
            data: {
              index: ie,
              overflows: I
            },
            reset: {
              placement: W
            }
          };
        let te = (F = I.filter((ce) => ce.overflows[0] <= 0).sort((ce, we) => ce.overflows[1] - we.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!te)
          switch (h) {
            case "bestFit": {
              var Y;
              const ce = (Y = I.filter((we) => {
                if (T) {
                  const ke = mo(we.placement);
                  return ke === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ke === "y";
                }
                return !0;
              }).map((we) => [we.placement, we.overflows.filter((ke) => ke > 0).reduce((ke, rt) => ke + rt, 0)]).sort((we, ke) => we[1] - ke[1])[0]) == null ? void 0 : Y[0];
              ce && (te = ce);
              break;
            }
            case "initialPlacement":
              te = a;
              break;
          }
        if (i !== te)
          return {
            reset: {
              placement: te
            }
          };
      }
      return {};
    }
  };
};
function V0(n, e) {
  return {
    top: n.top - e.height,
    right: n.right - e.width,
    bottom: n.bottom - e.height,
    left: n.left - e.width
  };
}
function z0(n) {
  return I$.some((e) => n[e] >= 0);
}
const K$ = function(n) {
  return n === void 0 && (n = {}), {
    name: "hide",
    options: n,
    async fn(e) {
      const {
        rects: t
      } = e, {
        strategy: o = "referenceHidden",
        ...i
      } = zo(n, e);
      switch (o) {
        case "referenceHidden": {
          const r = await ma(e, {
            ...i,
            elementContext: "reference"
          }), s = V0(r, t.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: z0(s)
            }
          };
        }
        case "escaped": {
          const r = await ma(e, {
            ...i,
            altBoundary: !0
          }), s = V0(r, t.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: z0(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, l6 = /* @__PURE__ */ new Set(["left", "top"]);
async function G$(n, e) {
  const {
    placement: t,
    platform: o,
    elements: i
  } = n, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = Ho(t), a = gs(t), l = mo(t) === "y", d = l6.has(s) ? -1 : 1, u = r && l ? -1 : 1, c = zo(e, n);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * d
  } : {
    x: f * d,
    y: h * u
  };
}
const Y$ = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(e) {
      var t, o;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: a
      } = e, l = await G$(e, n);
      return s === ((t = a.offset) == null ? void 0 : t.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: i + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, q$ = function(n) {
  return n === void 0 && (n = {}), {
    name: "shift",
    options: n,
    async fn(e) {
      const {
        x: t,
        y: o,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (g) => {
            let {
              x: b,
              y: x
            } = g;
            return {
              x: b,
              y: x
            };
          }
        },
        ...l
      } = zo(n, e), d = {
        x: t,
        y: o
      }, u = await ma(e, l), c = mo(Ho(i)), f = w1(c);
      let h = d[f], p = d[c];
      if (r) {
        const g = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", x = h + u[g], w = h - u[b];
        h = df(x, h, w);
      }
      if (s) {
        const g = c === "y" ? "top" : "left", b = c === "y" ? "bottom" : "right", x = p + u[g], w = p - u[b];
        p = df(x, p, w);
      }
      const m = a.fn({
        ...e,
        [f]: h,
        [c]: p
      });
      return {
        ...m,
        data: {
          x: m.x - t,
          y: m.y - o,
          enabled: {
            [f]: r,
            [c]: s
          }
        }
      };
    }
  };
}, Z$ = function(n) {
  return n === void 0 && (n = {}), {
    options: n,
    fn(e) {
      const {
        x: t,
        y: o,
        placement: i,
        rects: r,
        middlewareData: s
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: d = !0
      } = zo(n, e), u = {
        x: t,
        y: o
      }, c = mo(i), f = w1(c);
      let h = u[f], p = u[c];
      const m = zo(a, e), g = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const w = f === "y" ? "height" : "width", M = r.reference[f] - r.floating[w] + g.mainAxis, $ = r.reference[f] + r.reference[w] - g.mainAxis;
        h < M ? h = M : h > $ && (h = $);
      }
      if (d) {
        var b, x;
        const w = f === "y" ? "width" : "height", M = l6.has(Ho(i)), $ = r.reference[c] - r.floating[w] + (M && ((b = s.offset) == null ? void 0 : b[c]) || 0) + (M ? 0 : g.crossAxis), T = r.reference[c] + r.reference[w] + (M ? 0 : ((x = s.offset) == null ? void 0 : x[c]) || 0) - (M ? g.crossAxis : 0);
        p < $ ? p = $ : p > T && (p = T);
      }
      return {
        [f]: h,
        [c]: p
      };
    }
  };
}, J$ = function(n) {
  return n === void 0 && (n = {}), {
    name: "size",
    options: n,
    async fn(e) {
      var t, o;
      const {
        placement: i,
        rects: r,
        platform: s,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...d
      } = zo(n, e), u = await ma(e, d), c = Ho(i), f = gs(i), h = mo(i) === "y", {
        width: p,
        height: m
      } = r.floating;
      let g, b;
      c === "top" || c === "bottom" ? (g = c, b = f === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = c, g = f === "end" ? "top" : "bottom");
      const x = m - u.top - u.bottom, w = p - u.left - u.right, M = ki(m - u[g], x), $ = ki(p - u[b], w), T = !e.middlewareData.shift;
      let E = M, S = $;
      if ((t = e.middlewareData.shift) != null && t.enabled.x && (S = w), (o = e.middlewareData.shift) != null && o.enabled.y && (E = x), T && !f) {
        const I = Mn(u.left, 0), z = Mn(u.right, 0), F = Mn(u.top, 0), Y = Mn(u.bottom, 0);
        h ? S = p - 2 * (I !== 0 || z !== 0 ? I + z : Mn(u.left, u.right)) : E = m - 2 * (F !== 0 || Y !== 0 ? F + Y : Mn(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: S,
        availableHeight: E
      });
      const D = await s.getDimensions(a.floating);
      return p !== D.width || m !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function uu() {
  return typeof window < "u";
}
function gr(n) {
  return M1(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function En(n) {
  var e;
  return (n == null || (e = n.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Co(n) {
  var e;
  return (e = (M1(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : e.documentElement;
}
function M1(n) {
  return uu() ? n instanceof Node || n instanceof En(n).Node : !1;
}
function eo(n) {
  return uu() ? n instanceof Element || n instanceof En(n).Element : !1;
}
function bo(n) {
  return uu() ? n instanceof HTMLElement || n instanceof En(n).HTMLElement : !1;
}
function H0(n) {
  return !uu() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof En(n).ShadowRoot;
}
const X$ = /* @__PURE__ */ new Set(["inline", "contents"]);
function Fa(n) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: o,
    display: i
  } = to(n);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + t) && !X$.has(i);
}
const Q$ = /* @__PURE__ */ new Set(["table", "td", "th"]);
function eM(n) {
  return Q$.has(gr(n));
}
const tM = [":popover-open", ":modal"];
function cu(n) {
  return tM.some((e) => {
    try {
      return n.matches(e);
    } catch {
      return !1;
    }
  });
}
const nM = ["transform", "translate", "scale", "rotate", "perspective"], oM = ["transform", "translate", "scale", "rotate", "perspective", "filter"], iM = ["paint", "layout", "strict", "content"];
function S1(n) {
  const e = _1(), t = eo(n) ? to(n) : n;
  return nM.some((o) => t[o] ? t[o] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || oM.some((o) => (t.willChange || "").includes(o)) || iM.some((o) => (t.contain || "").includes(o));
}
function rM(n) {
  let e = $i(n);
  for (; bo(e) && !Xr(e); ) {
    if (S1(e))
      return e;
    if (cu(e))
      return null;
    e = $i(e);
  }
  return null;
}
function _1() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const sM = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Xr(n) {
  return sM.has(gr(n));
}
function to(n) {
  return En(n).getComputedStyle(n);
}
function fu(n) {
  return eo(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function $i(n) {
  if (gr(n) === "html")
    return n;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    H0(n) && n.host || // Fallback.
    Co(n)
  );
  return H0(e) ? e.host : e;
}
function d6(n) {
  const e = $i(n);
  return Xr(e) ? n.ownerDocument ? n.ownerDocument.body : n.body : bo(e) && Fa(e) ? e : d6(e);
}
function ga(n, e, t) {
  var o;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const i = d6(n), r = i === ((o = n.ownerDocument) == null ? void 0 : o.body), s = En(i);
  if (r) {
    const a = cf(s);
    return e.concat(s, s.visualViewport || [], Fa(i) ? i : [], a && t ? ga(a) : []);
  }
  return e.concat(i, ga(i, [], t));
}
function cf(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
function u6(n) {
  const e = to(n);
  let t = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = bo(n), r = i ? n.offsetWidth : t, s = i ? n.offsetHeight : o, a = Jl(t) !== r || Jl(o) !== s;
  return a && (t = r, o = s), {
    width: t,
    height: o,
    $: a
  };
}
function E1(n) {
  return eo(n) ? n : n.contextElement;
}
function jr(n) {
  const e = E1(n);
  if (!bo(e))
    return go(1);
  const t = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = u6(e);
  let s = (r ? Jl(t.width) : t.width) / o, a = (r ? Jl(t.height) : t.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const aM = /* @__PURE__ */ go(0);
function c6(n) {
  const e = En(n);
  return !_1() || !e.visualViewport ? aM : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function lM(n, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== En(n) ? !1 : e;
}
function ar(n, e, t, o) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const i = n.getBoundingClientRect(), r = E1(n);
  let s = go(1);
  e && (o ? eo(o) && (s = jr(o)) : s = jr(n));
  const a = lM(r, t, o) ? c6(r) : go(0);
  let l = (i.left + a.x) / s.x, d = (i.top + a.y) / s.y, u = i.width / s.x, c = i.height / s.y;
  if (r) {
    const f = En(r), h = o && eo(o) ? En(o) : o;
    let p = f, m = cf(p);
    for (; m && o && h !== p; ) {
      const g = jr(m), b = m.getBoundingClientRect(), x = to(m), w = b.left + (m.clientLeft + parseFloat(x.paddingLeft)) * g.x, M = b.top + (m.clientTop + parseFloat(x.paddingTop)) * g.y;
      l *= g.x, d *= g.y, u *= g.x, c *= g.y, l += w, d += M, p = En(m), m = cf(p);
    }
  }
  return Ql({
    width: u,
    height: c,
    x: l,
    y: d
  });
}
function hu(n, e) {
  const t = fu(n).scrollLeft;
  return e ? e.left + t : ar(Co(n)).left + t;
}
function f6(n, e) {
  const t = n.getBoundingClientRect(), o = t.left + e.scrollLeft - hu(n, t), i = t.top + e.scrollTop;
  return {
    x: o,
    y: i
  };
}
function dM(n) {
  let {
    elements: e,
    rect: t,
    offsetParent: o,
    strategy: i
  } = n;
  const r = i === "fixed", s = Co(o), a = e ? cu(e.floating) : !1;
  if (o === s || a && r)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = go(1);
  const u = go(0), c = bo(o);
  if ((c || !c && !r) && ((gr(o) !== "body" || Fa(s)) && (l = fu(o)), bo(o))) {
    const h = ar(o);
    d = jr(o), u.x = h.x + o.clientLeft, u.y = h.y + o.clientTop;
  }
  const f = s && !c && !r ? f6(s, l) : go(0);
  return {
    width: t.width * d.x,
    height: t.height * d.y,
    x: t.x * d.x - l.scrollLeft * d.x + u.x + f.x,
    y: t.y * d.y - l.scrollTop * d.y + u.y + f.y
  };
}
function uM(n) {
  return Array.from(n.getClientRects());
}
function cM(n) {
  const e = Co(n), t = fu(n), o = n.ownerDocument.body, i = Mn(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), r = Mn(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -t.scrollLeft + hu(n);
  const a = -t.scrollTop;
  return to(o).direction === "rtl" && (s += Mn(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: a
  };
}
const j0 = 25;
function fM(n, e) {
  const t = En(n), o = Co(n), i = t.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, a = 0, l = 0;
  if (i) {
    r = i.width, s = i.height;
    const u = _1();
    (!u || u && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  const d = hu(o);
  if (d <= 0) {
    const u = o.ownerDocument, c = u.body, f = getComputedStyle(c), h = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, p = Math.abs(o.clientWidth - c.clientWidth - h);
    p <= j0 && (r -= p);
  } else d <= j0 && (r += d);
  return {
    width: r,
    height: s,
    x: a,
    y: l
  };
}
const hM = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function pM(n, e) {
  const t = ar(n, !0, e === "fixed"), o = t.top + n.clientTop, i = t.left + n.clientLeft, r = bo(n) ? jr(n) : go(1), s = n.clientWidth * r.x, a = n.clientHeight * r.y, l = i * r.x, d = o * r.y;
  return {
    width: s,
    height: a,
    x: l,
    y: d
  };
}
function W0(n, e, t) {
  let o;
  if (e === "viewport")
    o = fM(n, t);
  else if (e === "document")
    o = cM(Co(n));
  else if (eo(e))
    o = pM(e, t);
  else {
    const i = c6(n);
    o = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return Ql(o);
}
function h6(n, e) {
  const t = $i(n);
  return t === e || !eo(t) || Xr(t) ? !1 : to(t).position === "fixed" || h6(t, e);
}
function mM(n, e) {
  const t = e.get(n);
  if (t)
    return t;
  let o = ga(n, [], !1).filter((a) => eo(a) && gr(a) !== "body"), i = null;
  const r = to(n).position === "fixed";
  let s = r ? $i(n) : n;
  for (; eo(s) && !Xr(s); ) {
    const a = to(s), l = S1(s);
    !l && a.position === "fixed" && (i = null), (r ? !l && !i : !l && a.position === "static" && !!i && hM.has(i.position) || Fa(s) && !l && h6(n, s)) ? o = o.filter((u) => u !== s) : i = a, s = $i(s);
  }
  return e.set(n, o), o;
}
function gM(n) {
  let {
    element: e,
    boundary: t,
    rootBoundary: o,
    strategy: i
  } = n;
  const s = [...t === "clippingAncestors" ? cu(e) ? [] : mM(e, this._c) : [].concat(t), o], a = s[0], l = s.reduce((d, u) => {
    const c = W0(e, u, i);
    return d.top = Mn(c.top, d.top), d.right = ki(c.right, d.right), d.bottom = ki(c.bottom, d.bottom), d.left = Mn(c.left, d.left), d;
  }, W0(e, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function vM(n) {
  const {
    width: e,
    height: t
  } = u6(n);
  return {
    width: e,
    height: t
  };
}
function bM(n, e, t) {
  const o = bo(e), i = Co(e), r = t === "fixed", s = ar(n, !0, r, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = go(0);
  function d() {
    l.x = hu(i);
  }
  if (o || !o && !r)
    if ((gr(e) !== "body" || Fa(i)) && (a = fu(e)), o) {
      const h = ar(e, !0, r, e);
      l.x = h.x + e.clientLeft, l.y = h.y + e.clientTop;
    } else i && d();
  r && !o && i && d();
  const u = i && !o && !r ? f6(i, a) : go(0), c = s.left + a.scrollLeft - l.x - u.x, f = s.top + a.scrollTop - l.y - u.y;
  return {
    x: c,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Xu(n) {
  return to(n).position === "static";
}
function U0(n, e) {
  if (!bo(n) || to(n).position === "fixed")
    return null;
  if (e)
    return e(n);
  let t = n.offsetParent;
  return Co(n) === t && (t = t.ownerDocument.body), t;
}
function p6(n, e) {
  const t = En(n);
  if (cu(n))
    return t;
  if (!bo(n)) {
    let i = $i(n);
    for (; i && !Xr(i); ) {
      if (eo(i) && !Xu(i))
        return i;
      i = $i(i);
    }
    return t;
  }
  let o = U0(n, e);
  for (; o && eM(o) && Xu(o); )
    o = U0(o, e);
  return o && Xr(o) && Xu(o) && !S1(o) ? t : o || rM(n) || t;
}
const yM = async function(n) {
  const e = this.getOffsetParent || p6, t = this.getDimensions, o = await t(n.floating);
  return {
    reference: bM(n.reference, await e(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function xM(n) {
  return to(n).direction === "rtl";
}
const CM = {
  convertOffsetParentRelativeRectToViewportRelativeRect: dM,
  getDocumentElement: Co,
  getClippingRect: gM,
  getOffsetParent: p6,
  getElementRects: yM,
  getClientRects: uM,
  getDimensions: vM,
  getScale: jr,
  isElement: eo,
  isRTL: xM
};
function m6(n, e) {
  return n.x === e.x && n.y === e.y && n.width === e.width && n.height === e.height;
}
function wM(n, e) {
  let t = null, o;
  const i = Co(n);
  function r() {
    var a;
    clearTimeout(o), (a = t) == null || a.disconnect(), t = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), r();
    const d = n.getBoundingClientRect(), {
      left: u,
      top: c,
      width: f,
      height: h
    } = d;
    if (a || e(), !f || !h)
      return;
    const p = Qa(c), m = Qa(i.clientWidth - (u + f)), g = Qa(i.clientHeight - (c + h)), b = Qa(u), w = {
      rootMargin: -p + "px " + -m + "px " + -g + "px " + -b + "px",
      threshold: Mn(0, ki(1, l)) || 1
    };
    let M = !0;
    function $(T) {
      const E = T[0].intersectionRatio;
      if (E !== l) {
        if (!M)
          return s();
        E ? s(!1, E) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !m6(d, n.getBoundingClientRect()) && s(), M = !1;
    }
    try {
      t = new IntersectionObserver($, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      t = new IntersectionObserver($, w);
    }
    t.observe(n);
  }
  return s(!0), r;
}
function kM(n, e, t, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, d = E1(n), u = i || r ? [...d ? ga(d) : [], ...ga(e)] : [];
  u.forEach((b) => {
    i && b.addEventListener("scroll", t, {
      passive: !0
    }), r && b.addEventListener("resize", t);
  });
  const c = d && a ? wM(d, t) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((b) => {
    let [x] = b;
    x && x.target === d && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(e);
    })), t();
  }), d && !l && h.observe(d), h.observe(e));
  let p, m = l ? ar(n) : null;
  l && g();
  function g() {
    const b = ar(n);
    m && !m6(m, b) && t(), m = b, p = requestAnimationFrame(g);
  }
  return t(), () => {
    var b;
    u.forEach((x) => {
      i && x.removeEventListener("scroll", t), r && x.removeEventListener("resize", t);
    }), c == null || c(), (b = h) == null || b.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const $M = Y$, MM = q$, K0 = U$, SM = J$, _M = K$, EM = W$, OM = Z$, TM = (n, e, t) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: CM,
    ...t
  }, r = {
    ...i.platform,
    _c: o
  };
  return j$(n, e, {
    ...i,
    platform: r
  });
};
function AM(n) {
  return n != null && typeof n == "object" && "$el" in n;
}
function ff(n) {
  if (AM(n)) {
    const e = n.$el;
    return M1(e) && gr(e) === "#comment" ? null : e;
  }
  return n;
}
function Pr(n) {
  return typeof n == "function" ? n() : k(n);
}
function IM(n) {
  return {
    name: "arrow",
    options: n,
    fn(e) {
      const t = ff(Pr(n.element));
      return t == null ? {} : EM({
        element: t,
        padding: n.padding
      }).fn(e);
    }
  };
}
function g6(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function G0(n, e) {
  const t = g6(n);
  return Math.round(e * t) / t;
}
function DM(n, e, t) {
  t === void 0 && (t = {});
  const o = t.whileElementsMounted, i = L(() => {
    var E;
    return (E = Pr(t.open)) != null ? E : !0;
  }), r = L(() => Pr(t.middleware)), s = L(() => {
    var E;
    return (E = Pr(t.placement)) != null ? E : "bottom";
  }), a = L(() => {
    var E;
    return (E = Pr(t.strategy)) != null ? E : "absolute";
  }), l = L(() => {
    var E;
    return (E = Pr(t.transform)) != null ? E : !0;
  }), d = L(() => ff(n.value)), u = L(() => ff(e.value)), c = R(0), f = R(0), h = R(a.value), p = R(s.value), m = mr({}), g = R(!1), b = L(() => {
    const E = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return E;
    const S = G0(u.value, c.value), D = G0(u.value, f.value);
    return l.value ? {
      ...E,
      transform: "translate(" + S + "px, " + D + "px)",
      ...g6(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: S + "px",
      top: D + "px"
    };
  });
  let x;
  function w() {
    if (d.value == null || u.value == null)
      return;
    const E = i.value;
    TM(d.value, u.value, {
      middleware: r.value,
      placement: s.value,
      strategy: a.value
    }).then((S) => {
      c.value = S.x, f.value = S.y, h.value = S.strategy, p.value = S.placement, m.value = S.middlewareData, g.value = E !== !1;
    });
  }
  function M() {
    typeof x == "function" && (x(), x = void 0);
  }
  function $() {
    if (M(), o === void 0) {
      w();
      return;
    }
    if (d.value != null && u.value != null) {
      x = o(d.value, u.value, w);
      return;
    }
  }
  function T() {
    i.value || (g.value = !1);
  }
  return Ee([r, s, a, i], w, {
    flush: "sync"
  }), Ee([d, u], $, {
    flush: "sync"
  }), Ee(i, T, {
    flush: "sync"
  }), h1() && ru(M), {
    x: Sr(c),
    y: Sr(f),
    strategy: Sr(h),
    placement: Sr(p),
    middlewareData: Sr(m),
    isPositioned: Sr(g),
    floatingStyles: b,
    update: w
  };
}
function Rt(n, e) {
  const t = typeof n == "string" && !e ? `${n}Context` : e, o = Symbol(t);
  return [(i) => {
    const r = Uo(o, i);
    if (r || r === null)
      return r;
    throw new Error(
      `Injection \`${o.toString()}\` not found. Component must be used within ${Array.isArray(n) ? `one of the following components: ${n.join(
        ", "
      )}` : `\`${n}\``}`
    );
  }, (i) => (Oi(o, i), i)];
}
function O1(n, e, t) {
  const o = t.originalEvent.target, i = new CustomEvent(n, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  e && o.addEventListener(n, e, { once: !0 }), o.dispatchEvent(i);
}
function NM(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var PM = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var o, i, r;
    if (Array.isArray(e)) {
      if (o = e.length, o != t.length) return !1;
      for (i = o; i-- !== 0; )
        if (!n(e[i], t[i])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (r = Object.keys(e), o = r.length, o !== Object.keys(t).length) return !1;
    for (i = o; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[i])) return !1;
    for (i = o; i-- !== 0; ) {
      var s = r[i];
      if (!n(e[s], t[s])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
};
const Gi = /* @__PURE__ */ NM(PM);
function Qu(n) {
  return n == null;
}
function LM(n, e) {
  var t;
  const o = mr();
  return dt(() => {
    o.value = n();
  }, {
    ...e,
    flush: (t = void 0) != null ? t : "sync"
  }), D2(o);
}
function vs(n) {
  return h1() ? (ru(n), !0) : !1;
}
function RM() {
  const n = /* @__PURE__ */ new Set(), e = (t) => {
    n.delete(t);
  };
  return {
    on: (t) => {
      n.add(t);
      const o = () => e(t);
      return vs(o), {
        off: o
      };
    },
    off: e,
    trigger: (...t) => Promise.all(Array.from(n).map((o) => o(...t)))
  };
}
function FM(n) {
  let e = !1, t;
  const o = I2(!0);
  return (...i) => (e || (t = o.run(() => n(...i)), e = !0), t);
}
function BM(n) {
  let e = 0, t, o;
  const i = () => {
    e -= 1, o && e <= 0 && (o.stop(), t = void 0, o = void 0);
  };
  return (...r) => (e += 1, t || (o = I2(!0), t = o.run(() => n(...r))), vs(i), t);
}
function Ro(n) {
  return typeof n == "function" ? n() : k(n);
}
const Go = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const VM = (n) => typeof n < "u", zM = (n) => n != null, HM = Object.prototype.toString, jM = (n) => HM.call(n) === "[object Object]", WM = () => {
}, Y0 = /* @__PURE__ */ UM();
function UM() {
  var n, e;
  return Go && ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function KM(n) {
  return qn();
}
function GM(n, e = 1e4) {
  return N2((t, o) => {
    let i = Ro(n), r;
    const s = () => setTimeout(() => {
      i = Ro(n), o();
    }, Ro(e));
    return vs(() => {
      clearTimeout(r);
    }), {
      get() {
        return t(), i;
      },
      set(a) {
        i = a, o(), clearTimeout(r), r = s();
      }
    };
  });
}
function YM(n, e) {
  KM() && ps(n, e);
}
function v6(n, e, t = {}) {
  const {
    immediate: o = !0
  } = t, i = R(!1);
  let r = null;
  function s() {
    r && (clearTimeout(r), r = null);
  }
  function a() {
    i.value = !1, s();
  }
  function l(...d) {
    s(), i.value = !0, r = setTimeout(() => {
      i.value = !1, r = null, n(...d);
    }, Ro(e));
  }
  return o && (i.value = !0, Go && l()), vs(a), {
    isPending: D2(i),
    start: l,
    stop: a
  };
}
function Yo(n) {
  var e;
  const t = Ro(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const pu = Go ? window : void 0;
function Qr(...n) {
  let e, t, o, i;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([t, o, i] = n, e = pu) : [e, t, o, i] = n, !e)
    return WM;
  Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
  const r = [], s = () => {
    r.forEach((u) => u()), r.length = 0;
  }, a = (u, c, f, h) => (u.addEventListener(c, f, h), () => u.removeEventListener(c, f, h)), l = Ee(
    () => [Yo(e), Ro(i)],
    ([u, c]) => {
      if (s(), !u)
        return;
      const f = jM(c) ? { ...c } : c;
      r.push(
        ...t.flatMap((h) => o.map((p) => a(u, h, p, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), s();
  };
  return vs(d), d;
}
function qM(n) {
  return typeof n == "function" ? n : typeof n == "string" ? (e) => e.key === n : Array.isArray(n) ? (e) => n.includes(e.key) : () => !0;
}
function ZM(...n) {
  let e, t, o = {};
  n.length === 3 ? (e = n[0], t = n[1], o = n[2]) : n.length === 2 ? typeof n[1] == "object" ? (e = !0, t = n[0], o = n[1]) : (e = n[0], t = n[1]) : (e = !0, t = n[0]);
  const {
    target: i = pu,
    eventName: r = "keydown",
    passive: s = !1,
    dedupe: a = !1
  } = o, l = qM(e);
  return Qr(i, r, (d) => {
    d.repeat && Ro(a) || l(d) && t(d);
  }, s);
}
function b6() {
  const n = R(!1), e = qn();
  return e && We(() => {
    n.value = !0;
  }, e), n;
}
function JM(n) {
  const e = b6();
  return L(() => (e.value, !!n()));
}
function y6(n, e, t = {}) {
  const { window: o = pu, ...i } = t;
  let r;
  const s = JM(() => o && "MutationObserver" in o), a = () => {
    r && (r.disconnect(), r = void 0);
  }, l = L(() => {
    const f = Ro(n), h = (Array.isArray(f) ? f : [f]).map(Yo).filter(zM);
    return new Set(h);
  }), d = Ee(
    () => l.value,
    (f) => {
      a(), s.value && f.size && (r = new MutationObserver(e), f.forEach((h) => r.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => r == null ? void 0 : r.takeRecords(), c = () => {
    a(), d();
  };
  return vs(c), {
    isSupported: s,
    stop: c,
    takeRecords: u
  };
}
function XM(n = {}) {
  var e;
  const {
    window: t = pu,
    deep: o = !0,
    triggerOnRemoval: i = !1
  } = n, r = (e = n.document) != null ? e : t == null ? void 0 : t.document, s = () => {
    var d;
    let u = r == null ? void 0 : r.activeElement;
    if (o)
      for (; u != null && u.shadowRoot; )
        u = (d = u == null ? void 0 : u.shadowRoot) == null ? void 0 : d.activeElement;
    return u;
  }, a = R(), l = () => {
    a.value = s();
  };
  return t && (Qr(t, "blur", (d) => {
    d.relatedTarget === null && l();
  }, !0), Qr(t, "focus", l, !0)), i && y6(r, (d) => {
    d.filter((u) => u.removedNodes.length).map((u) => Array.from(u.removedNodes)).flat().forEach((u) => {
      u === a.value && l();
    });
  }, {
    childList: !0,
    subtree: !0
  }), l(), a;
}
function QM(n) {
  return JSON.parse(JSON.stringify(n));
}
function eS(n, e = {}) {
  const t = XM(e), o = L(() => Yo(n));
  return { focused: L(() => o.value && t.value ? o.value.contains(t.value) : !1) };
}
function Hn(n, e, t, o = {}) {
  var i, r, s;
  const {
    clone: a = !1,
    passive: l = !1,
    eventName: d,
    deep: u = !1,
    defaultValue: c,
    shouldEmit: f
  } = o, h = qn(), p = t || (h == null ? void 0 : h.emit) || ((i = h == null ? void 0 : h.$emit) == null ? void 0 : i.bind(h)) || ((s = (r = h == null ? void 0 : h.proxy) == null ? void 0 : r.$emit) == null ? void 0 : s.bind(h == null ? void 0 : h.proxy));
  let m = d;
  e || (e = "modelValue"), m = m || `update:${e.toString()}`;
  const g = (w) => a ? typeof a == "function" ? a(w) : QM(w) : w, b = () => VM(n[e]) ? g(n[e]) : c, x = (w) => {
    f ? f(w) && p(m, w) : p(m, w);
  };
  if (l) {
    const w = b(), M = R(w);
    let $ = !1;
    return Ee(
      () => n[e],
      (T) => {
        $ || ($ = !0, M.value = g(T), Ve(() => $ = !1));
      }
    ), Ee(
      M,
      (T) => {
        !$ && (T !== n[e] || u) && x(T);
      },
      { deep: u }
    ), M;
  } else
    return L({
      get() {
        return b();
      },
      set(w) {
        x(w);
      }
    });
}
function T1(n) {
  return n ? n.flatMap((e) => e.type === re ? T1(e.children) : [e]) : [];
}
const tS = ["INPUT", "TEXTAREA"];
function x6(n, e, t, o = {}) {
  if (!e || o.enableIgnoredElement && tS.includes(e.nodeName))
    return null;
  const {
    arrowKeyOptions: i = "both",
    attributeName: r = "[data-radix-vue-collection-item]",
    itemsArray: s = [],
    loop: a = !0,
    dir: l = "ltr",
    preventScroll: d = !0,
    focus: u = !1
  } = o, [c, f, h, p, m, g] = [
    n.key === "ArrowRight",
    n.key === "ArrowLeft",
    n.key === "ArrowUp",
    n.key === "ArrowDown",
    n.key === "Home",
    n.key === "End"
  ], b = h || p, x = c || f;
  if (!m && !g && (!b && !x || i === "vertical" && x || i === "horizontal" && b))
    return null;
  const w = t ? Array.from(t.querySelectorAll(r)) : s;
  if (!w.length)
    return null;
  d && n.preventDefault();
  let M = null;
  return x || b ? M = C6(w, e, {
    goForward: b ? p : l === "ltr" ? c : f,
    loop: a
  }) : m ? M = w.at(0) || null : g && (M = w.at(-1) || null), u && (M == null || M.focus()), M;
}
function C6(n, e, t, o = n.length) {
  if (--o === 0)
    return null;
  const i = n.indexOf(e), r = t.goForward ? i + 1 : i - 1;
  if (!t.loop && (r < 0 || r >= n.length))
    return null;
  const s = (r + n.length) % n.length, a = n[s];
  return a ? a.hasAttribute("disabled") && a.getAttribute("disabled") !== "false" ? C6(
    n,
    a,
    t,
    o
  ) : a : null;
}
function ec(n) {
  if (n === null || typeof n != "object")
    return !1;
  const e = Object.getPrototypeOf(n);
  return e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || Symbol.iterator in n ? !1 : Symbol.toStringTag in n ? Object.prototype.toString.call(n) === "[object Module]" : !0;
}
function hf(n, e, t = ".", o) {
  if (!ec(e))
    return hf(n, {}, t);
  const i = Object.assign({}, e);
  for (const r in n) {
    if (r === "__proto__" || r === "constructor")
      continue;
    const s = n[r];
    s != null && (Array.isArray(s) && Array.isArray(i[r]) ? i[r] = [...s, ...i[r]] : ec(s) && ec(i[r]) ? i[r] = hf(
      s,
      i[r],
      (t ? `${t}.` : "") + r.toString()
    ) : i[r] = s);
  }
  return i;
}
function nS(n) {
  return (...e) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    e.reduce((t, o) => hf(t, o, ""), {})
  );
}
const oS = nS(), [mu] = Rt("ConfigProvider");
let iS = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", rS = (n = 21) => {
  let e = "", t = n;
  for (; t--; )
    e += iS[Math.random() * 64 | 0];
  return e;
};
const sS = BM(() => {
  const n = R(/* @__PURE__ */ new Map()), e = R(), t = L(() => {
    for (const s of n.value.values())
      if (s)
        return !0;
    return !1;
  }), o = mu({
    scrollBody: R(!0)
  });
  let i = null;
  const r = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = e.value ?? "", Y0 && (i == null || i()), e.value = void 0;
  };
  return Ee(t, (s, a) => {
    var l;
    if (!Go)
      return;
    if (!s) {
      a && r();
      return;
    }
    e.value === void 0 && (e.value = document.body.style.overflow);
    const d = window.innerWidth - document.documentElement.clientWidth, u = { padding: d, margin: 0 }, c = (l = o.scrollBody) != null && l.value ? typeof o.scrollBody.value == "object" ? oS({
      padding: o.scrollBody.value.padding === !0 ? d : o.scrollBody.value.padding,
      margin: o.scrollBody.value.margin === !0 ? d : o.scrollBody.value.margin
    }, u) : u : { padding: 0, margin: 0 };
    d > 0 && (document.body.style.paddingRight = typeof c.padding == "number" ? `${c.padding}px` : String(c.padding), document.body.style.marginRight = typeof c.margin == "number" ? `${c.margin}px` : String(c.margin), document.body.style.setProperty("--scrollbar-width", `${d}px`), document.body.style.overflow = "hidden"), Y0 && (i = Qr(
      document,
      "touchmove",
      (f) => {
        var h;
        f.target === document.documentElement && (f.touches.length > 1 || (h = f.preventDefault) == null || h.call(f));
      },
      { passive: !1 }
    )), Ve(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), n;
});
function A1(n) {
  const e = rS(6), t = sS();
  t.value.set(e, n ?? !1);
  const o = L({
    get: () => t.value.get(e) ?? !1,
    set: (i) => t.value.set(e, i)
  });
  return YM(() => {
    t.value.delete(e);
  }), o;
}
function I1(n) {
  const e = mu({
    dir: R("ltr")
  });
  return L(() => {
    var t;
    return (n == null ? void 0 : n.value) || ((t = e.dir) == null ? void 0 : t.value) || "ltr";
  });
}
function gu(n) {
  const e = qn(), t = e == null ? void 0 : e.type.emits, o = {};
  return t != null && t.length || console.warn(
    `No emitted event found. Please check component: ${e == null ? void 0 : e.type.__name}`
  ), t == null || t.forEach((i) => {
    o[uv(A2(i))] = (...r) => n(i, ...r);
  }), o;
}
let tc = 0;
function aS() {
  dt((n) => {
    if (!Go)
      return;
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      e[0] ?? q0()
    ), document.body.insertAdjacentElement(
      "beforeend",
      e[1] ?? q0()
    ), tc++, n(() => {
      tc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), tc--;
    });
  });
}
function q0() {
  const n = document.createElement("span");
  return n.setAttribute("data-radix-focus-guard", ""), n.tabIndex = 0, n.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", n;
}
function w6(n) {
  return L(() => {
    var e;
    return Ro(n) ? !!((e = Yo(n)) != null && e.closest("form")) : !0;
  });
}
function vu(n) {
  const e = qn(), t = Object.keys((e == null ? void 0 : e.type.props) ?? {}).reduce((i, r) => {
    const s = (e == null ? void 0 : e.type.props[r]).default;
    return s !== void 0 && (i[r] = s), i;
  }, {}), o = dv(n);
  return L(() => {
    const i = {}, r = (e == null ? void 0 : e.vnode.props) ?? {};
    return Object.keys(r).forEach((s) => {
      i[A2(s)] = r[s];
    }), Object.keys({ ...t, ...i }).reduce((s, a) => (o.value[a] !== void 0 && (s[a] = o.value[a]), s), {});
  });
}
function Ba(n, e) {
  const t = vu(n), o = e ? gu(e) : {};
  return L(() => ({
    ...t.value,
    ...o
  }));
}
function Ce() {
  const n = qn(), e = R(), t = L(() => {
    var s, a;
    return ["#text", "#comment"].includes((s = e.value) == null ? void 0 : s.$el.nodeName) ? (a = e.value) == null ? void 0 : a.$el.nextElementSibling : Yo(e);
  }), o = Object.assign({}, n.exposed), i = {};
  for (const s in n.props)
    Object.defineProperty(i, s, {
      enumerable: !0,
      configurable: !0,
      get: () => n.props[s]
    });
  if (Object.keys(o).length > 0)
    for (const s in o)
      Object.defineProperty(i, s, {
        enumerable: !0,
        configurable: !0,
        get: () => o[s]
      });
  Object.defineProperty(i, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => n.vnode.el
  }), n.exposed = i;
  function r(s) {
    e.value = s, !(s instanceof Element || !s) && (Object.defineProperty(i, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => s.$el
    }), n.exposed = i);
  }
  return { forwardRef: r, currentRef: e, currentElement: t };
}
function lS(n, e) {
  const t = GM(!1, 300), o = R(null), i = RM();
  function r() {
    o.value = null, t.value = !1;
  }
  function s(a, l) {
    const d = a.currentTarget, u = { x: a.clientX, y: a.clientY }, c = dS(u, d.getBoundingClientRect()), f = uS(u, c), h = cS(l.getBoundingClientRect()), p = hS([...f, ...h]);
    o.value = p, t.value = !0;
  }
  return dt((a) => {
    if (n.value && e.value) {
      const l = (u) => s(u, e.value), d = (u) => s(u, n.value);
      n.value.addEventListener("pointerleave", l), e.value.addEventListener("pointerleave", d), a(() => {
        var u, c;
        (u = n.value) == null || u.removeEventListener("pointerleave", l), (c = e.value) == null || c.removeEventListener("pointerleave", d);
      });
    }
  }), dt((a) => {
    var l;
    if (o.value) {
      const d = (u) => {
        var c, f;
        if (!o.value)
          return;
        const h = u.target, p = { x: u.clientX, y: u.clientY }, m = ((c = n.value) == null ? void 0 : c.contains(h)) || ((f = e.value) == null ? void 0 : f.contains(h)), g = !fS(p, o.value), b = h.hasAttribute("data-grace-area-trigger");
        m ? r() : (g || b) && (r(), i.trigger());
      };
      (l = n.value) == null || l.ownerDocument.addEventListener("pointermove", d), a(() => {
        var u;
        return (u = n.value) == null ? void 0 : u.ownerDocument.removeEventListener("pointermove", d);
      });
    }
  }), {
    isPointerInTransit: t,
    onPointerExit: i.on
  };
}
function dS(n, e) {
  const t = Math.abs(e.top - n.y), o = Math.abs(e.bottom - n.y), i = Math.abs(e.right - n.x), r = Math.abs(e.left - n.x);
  switch (Math.min(t, o, i, r)) {
    case r:
      return "left";
    case i:
      return "right";
    case t:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function uS(n, e, t = 5) {
  const o = [];
  switch (e) {
    case "top":
      o.push(
        { x: n.x - t, y: n.y + t },
        { x: n.x + t, y: n.y + t }
      );
      break;
    case "bottom":
      o.push(
        { x: n.x - t, y: n.y - t },
        { x: n.x + t, y: n.y - t }
      );
      break;
    case "left":
      o.push(
        { x: n.x + t, y: n.y - t },
        { x: n.x + t, y: n.y + t }
      );
      break;
    case "right":
      o.push(
        { x: n.x - t, y: n.y - t },
        { x: n.x - t, y: n.y + t }
      );
      break;
  }
  return o;
}
function cS(n) {
  const { top: e, right: t, bottom: o, left: i } = n;
  return [
    { x: i, y: e },
    { x: t, y: e },
    { x: t, y: o },
    { x: i, y: o }
  ];
}
function fS(n, e) {
  const { x: t, y: o } = n;
  let i = !1;
  for (let r = 0, s = e.length - 1; r < e.length; s = r++) {
    const a = e[r].x, l = e[r].y, d = e[s].x, u = e[s].y;
    l > o != u > o && t < (d - a) * (o - l) / (u - l) + a && (i = !i);
  }
  return i;
}
function hS(n) {
  const e = n.slice();
  return e.sort((t, o) => t.x < o.x ? -1 : t.x > o.x ? 1 : t.y < o.y ? -1 : t.y > o.y ? 1 : 0), pS(e);
}
function pS(n) {
  if (n.length <= 1)
    return n.slice();
  const e = [];
  for (let o = 0; o < n.length; o++) {
    const i = n[o];
    for (; e.length >= 2; ) {
      const r = e[e.length - 1], s = e[e.length - 2];
      if ((r.x - s.x) * (i.y - s.y) >= (r.y - s.y) * (i.x - s.x))
        e.pop();
      else break;
    }
    e.push(i);
  }
  e.pop();
  const t = [];
  for (let o = n.length - 1; o >= 0; o--) {
    const i = n[o];
    for (; t.length >= 2; ) {
      const r = t[t.length - 1], s = t[t.length - 2];
      if ((r.x - s.x) * (i.y - s.y) >= (r.y - s.y) * (i.x - s.x))
        t.pop();
      else break;
    }
    t.push(i);
  }
  return t.pop(), e.length === 1 && t.length === 1 && e[0].x === t[0].x && e[0].y === t[0].y ? e : e.concat(t);
}
var mS = function(n) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(n) ? n[0] : n;
  return e.ownerDocument.body;
}, _r = /* @__PURE__ */ new WeakMap(), el = /* @__PURE__ */ new WeakMap(), tl = {}, nc = 0, k6 = function(n) {
  return n && (n.host || k6(n.parentNode));
}, gS = function(n, e) {
  return e.map(function(t) {
    if (n.contains(t))
      return t;
    var o = k6(t);
    return o && n.contains(o) ? o : (console.error("aria-hidden", t, "in not contained inside", n, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, vS = function(n, e, t, o) {
  var i = gS(e, Array.isArray(n) ? n : [n]);
  tl[t] || (tl[t] = /* @__PURE__ */ new WeakMap());
  var r = tl[t], s = [], a = /* @__PURE__ */ new Set(), l = new Set(i), d = function(c) {
    !c || a.has(c) || (a.add(c), d(c.parentNode));
  };
  i.forEach(d);
  var u = function(c) {
    !c || l.has(c) || Array.prototype.forEach.call(c.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(o), p = h !== null && h !== "false", m = (_r.get(f) || 0) + 1, g = (r.get(f) || 0) + 1;
          _r.set(f, m), r.set(f, g), s.push(f), m === 1 && p && el.set(f, !0), g === 1 && f.setAttribute(t, "true"), p || f.setAttribute(o, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return u(e), a.clear(), nc++, function() {
    s.forEach(function(c) {
      var f = _r.get(c) - 1, h = r.get(c) - 1;
      _r.set(c, f), r.set(c, h), f || (el.has(c) || c.removeAttribute(o), el.delete(c)), h || c.removeAttribute(t);
    }), nc--, nc || (_r = /* @__PURE__ */ new WeakMap(), _r = /* @__PURE__ */ new WeakMap(), el = /* @__PURE__ */ new WeakMap(), tl = {});
  };
}, bS = function(n, e, t) {
  t === void 0 && (t = "data-aria-hidden");
  var o = Array.from(Array.isArray(n) ? n : [n]), i = mS(n);
  return i ? (o.push.apply(o, Array.from(i.querySelectorAll("[aria-live]"))), vS(o, i, t, "aria-hidden")) : function() {
    return null;
  };
};
function D1(n) {
  let e;
  Ee(() => Yo(n), (t) => {
    t ? e = bS(t) : e && e();
  }), Ei(() => {
    e && e();
  });
}
let yS = 0;
function Kn(n, e = "radix") {
  const t = mu({ useId: void 0 });
  return i0.useId ? `${e}-${i0.useId()}` : t.useId ? `${e}-${t.useId()}` : `${e}-${++yS}`;
}
function xS(n) {
  const e = R(), t = L(() => {
    var i;
    return ((i = e.value) == null ? void 0 : i.width) ?? 0;
  }), o = L(() => {
    var i;
    return ((i = e.value) == null ? void 0 : i.height) ?? 0;
  });
  return We(() => {
    const i = Yo(n);
    if (i) {
      e.value = { width: i.offsetWidth, height: i.offsetHeight };
      const r = new ResizeObserver((s) => {
        if (!Array.isArray(s) || !s.length)
          return;
        const a = s[0];
        let l, d;
        if ("borderBoxSize" in a) {
          const u = a.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          l = c.inlineSize, d = c.blockSize;
        } else
          l = i.offsetWidth, d = i.offsetHeight;
        e.value = { width: l, height: d };
      });
      return r.observe(i, { box: "border-box" }), () => r.unobserve(i);
    } else
      e.value = void 0;
  }), {
    width: t,
    height: o
  };
}
function CS(n, e) {
  const t = R(n);
  function o(i) {
    return e[t.value][i] ?? t.value;
  }
  return {
    state: t,
    dispatch: (i) => {
      t.value = o(i);
    }
  };
}
const N1 = H({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(n, { attrs: e, slots: t }) {
    return () => {
      var o, i;
      if (!t.default)
        return null;
      const r = T1(t.default()), s = r.findIndex((u) => u.type !== T2);
      if (s === -1)
        return r;
      const a = r[s];
      (o = a.props) == null || delete o.ref;
      const l = a.props ? ze(e, a.props) : e;
      e.class && (i = a.props) != null && i.class && delete a.props.class;
      const d = p1(a, l);
      for (const u in l)
        u.startsWith("on") && (d.props || (d.props = {}), d.props[u] = l[u]);
      return r.length === 1 ? d : (r[s] = d, r);
    };
  }
}), Re = H({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(n, { attrs: e, slots: t }) {
    const o = n.asChild ? "template" : n.as;
    return typeof o == "string" && ["area", "img", "input"].includes(o) ? () => lt(o, e) : o !== "template" ? () => lt(n.as, e, { default: t.default }) : () => lt(N1, e, { default: t.default });
  }
});
function $6() {
  const n = R(), e = L(() => {
    var t, o;
    return ["#text", "#comment"].includes((t = n.value) == null ? void 0 : t.$el.nodeName) ? (o = n.value) == null ? void 0 : o.$el.nextElementSibling : Yo(n);
  });
  return {
    primitiveElement: n,
    currentElement: e
  };
}
const [M6, wS] = Rt("CollapsibleRoot"), kS = /* @__PURE__ */ H({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(n, { expose: e, emit: t }) {
    const o = n, i = Hn(o, "open", t, {
      defaultValue: o.defaultOpen,
      passive: o.open === void 0
    }), r = Hn(o, "disabled");
    return wS({
      contentId: "",
      disabled: r,
      open: i,
      onOpenToggle: () => {
        i.value = !i.value;
      }
    }), e({ open: i }), Ce(), (s, a) => (v(), V(k(Re), {
      as: s.as,
      "as-child": o.asChild,
      "data-state": o.open ? "open" : "closed",
      "data-disabled": o.disabled ? "" : void 0
    }, {
      default: B(() => [
        le(s.$slots, "default", { open: k(i) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), $S = /* @__PURE__ */ H({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = M6();
    return (o, i) => {
      var r, s;
      return v(), V(k(Re), {
        type: o.as === "button" ? "button" : void 0,
        as: o.as,
        "as-child": e.asChild,
        "aria-controls": k(t).contentId,
        "aria-expanded": k(t).open.value,
        "data-state": k(t).open.value ? "open" : "closed",
        "data-disabled": (r = k(t).disabled) != null && r.value ? "" : void 0,
        disabled: (s = k(t).disabled) == null ? void 0 : s.value,
        onClick: k(t).onOpenToggle
      }, {
        default: B(() => [
          le(o.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
});
function MS(n, e) {
  const t = R({}), o = R("none"), i = n.value ? "mounted" : "unmounted", { state: r, dispatch: s } = CS(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), a = (f) => {
    var h;
    if (Go) {
      const p = new CustomEvent(f, { bubbles: !1, cancelable: !1 });
      (h = e.value) == null || h.dispatchEvent(p);
    }
  };
  Ee(
    n,
    async (f, h) => {
      var p;
      const m = h !== f;
      if (await Ve(), m) {
        const g = o.value, b = nl(e.value);
        f ? (s("MOUNT"), a("enter"), b === "none" && a("after-enter")) : b === "none" || ((p = t.value) == null ? void 0 : p.display) === "none" ? (s("UNMOUNT"), a("leave"), a("after-leave")) : h && g !== b ? (s("ANIMATION_OUT"), a("leave")) : (s("UNMOUNT"), a("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const l = (f) => {
    const h = nl(e.value), p = h.includes(
      f.animationName
    ), m = r.value === "mounted" ? "enter" : "leave";
    f.target === e.value && p && (a(`after-${m}`), s("ANIMATION_END")), f.target === e.value && h === "none" && s("ANIMATION_END");
  }, d = (f) => {
    f.target === e.value && (o.value = nl(e.value));
  }, u = Ee(
    e,
    (f, h) => {
      f ? (t.value = getComputedStyle(f), f.addEventListener("animationstart", d), f.addEventListener("animationcancel", l), f.addEventListener("animationend", l)) : (s("ANIMATION_END"), h == null || h.removeEventListener("animationstart", d), h == null || h.removeEventListener("animationcancel", l), h == null || h.removeEventListener("animationend", l));
    },
    { immediate: !0 }
  ), c = Ee(r, () => {
    const f = nl(e.value);
    o.value = r.value === "mounted" ? f : "none";
  });
  return Ei(() => {
    u(), c();
  }), {
    isPresent: L(
      () => ["mounted", "unmountSuspended"].includes(r.value)
    )
  };
}
function nl(n) {
  return n && getComputedStyle(n).animationName || "none";
}
const bs = H({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(n, { slots: e, expose: t }) {
    var o;
    const { present: i, forceMount: r } = Zn(n), s = R(), { isPresent: a } = MS(i, s);
    t({ present: a });
    let l = e.default({ present: a });
    l = T1(l || []);
    const d = qn();
    if (l && (l == null ? void 0 : l.length) > 1) {
      const u = (o = d == null ? void 0 : d.parent) != null && o.type.name ? `<${d.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${u}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((c) => `  - ${c}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => r.value || i.value || a.value ? lt(e.default({ present: a })[0], {
      ref: (u) => {
        const c = Yo(u);
        return typeof (c == null ? void 0 : c.hasAttribute) > "u" || (c != null && c.hasAttribute("data-radix-popper-content-wrapper") ? s.value = c.firstElementChild : s.value = c), c;
      }
    }) : null;
  }
}), SS = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = M6();
    t.contentId || (t.contentId = Kn(void 0, "radix-vue-collapsible-content"));
    const o = R(), { forwardRef: i, currentElement: r } = Ce(), s = R(0), a = R(0), l = L(() => t.open.value), d = R(l.value), u = R();
    return Ee(
      () => {
        var c;
        return [l.value, (c = o.value) == null ? void 0 : c.present];
      },
      async () => {
        await Ve();
        const c = r.value;
        if (!c)
          return;
        u.value = u.value || {
          transitionDuration: c.style.transitionDuration,
          animationName: c.style.animationName
        }, c.style.transitionDuration = "0s", c.style.animationName = "none";
        const f = c.getBoundingClientRect();
        a.value = f.height, s.value = f.width, d.value || (c.style.transitionDuration = u.value.transitionDuration, c.style.animationName = u.value.animationName);
      },
      {
        immediate: !0
      }
    ), We(() => {
      requestAnimationFrame(() => {
        d.value = !1;
      });
    }), (c, f) => (v(), V(k(bs), {
      ref_key: "presentRef",
      ref: o,
      present: c.forceMount || k(t).open.value,
      "force-mount": !0
    }, {
      default: B(() => {
        var h, p;
        return [
          U(k(Re), ze(c.$attrs, {
            id: k(t).contentId,
            ref: k(i),
            "as-child": e.asChild,
            as: c.as,
            "data-state": k(t).open.value ? "open" : "closed",
            "data-disabled": (h = k(t).disabled) != null && h.value ? "" : void 0,
            hidden: !((p = o.value) != null && p.present),
            style: {
              "--radix-collapsible-content-height": `${a.value}px`,
              "--radix-collapsible-content-width": `${s.value}px`
            }
          }), {
            default: B(() => {
              var m;
              return [
                (m = o.value) != null && m.present ? le(c.$slots, "default", { key: 0 }) : _("", !0)
              ];
            }),
            _: 3
          }, 16, ["id", "as-child", "as", "data-state", "data-disabled", "hidden", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
});
function S6({ type: n, defaultValue: e, modelValue: t }) {
  const o = t || e;
  if (Qu(n) && Qu(t) && Qu(e))
    throw new Error("Either the `type` or the `value` or `default-value` prop must be defined.");
  if (t !== void 0 && e !== void 0 && typeof t != typeof e)
    throw new Error(
      `Invalid prop \`value\` of value \`${t}\` supplied, should be the same type as the \`defaultValue\` prop, which is \`${e}\`. The \`value\` prop must be:
  ${n === "single" ? "- a string" : n === "multiple" ? "- an array of strings" : `- a string
- an array of strings`}
  - \`undefined\``
    );
  const i = t !== void 0 || e !== void 0;
  if (n && i) {
    const r = Array.isArray(t) || Array.isArray(e), s = t !== void 0 ? "modelValue" : "defaultValue", a = s === "modelValue" ? typeof t : typeof e;
    if (n === "single" && r)
      return console.error(`Invalid prop \`${s}\` of type ${a} supplied with type \`single\`. The \`modelValue\` prop must be a string or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${s} prop.`), "multiple";
    if (n === "multiple" && !r)
      return console.error(`Invalid prop \`${s}\` of type ${a} supplied with type \`multiple\`. The \`modelValue\` prop must be an array of strings or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${s} prop.`), "single";
  }
  return i ? Array.isArray(o) ? "multiple" : "single" : n;
}
function _S({ type: n, defaultValue: e, modelValue: t }) {
  return n || S6({ type: n, defaultValue: e, modelValue: t });
}
function ES({ type: n, defaultValue: e }) {
  return e !== void 0 ? e : n === "single" ? void 0 : [];
}
function OS(n, e) {
  const t = R(_S(n)), o = Hn(n, "modelValue", e, {
    defaultValue: ES(n),
    passive: n.modelValue === void 0,
    deep: !0
  });
  Ee(
    () => [n.type, n.modelValue, n.defaultValue],
    () => {
      const s = S6(n);
      t.value !== s && (t.value = s);
    },
    { immediate: !0 }
  );
  function i(s) {
    if (t.value === "single")
      o.value = s === o.value ? void 0 : s;
    else {
      const a = [...o.value || []];
      if (a.includes(s)) {
        const l = a.findIndex((d) => d === s);
        a.splice(l, 1);
      } else
        a.push(s);
      o.value = a;
    }
  }
  const r = L(() => t.value === "single");
  return {
    modelValue: o,
    type: t,
    changeModelValue: i,
    isSingle: r
  };
}
const [bu, TS] = Rt("AccordionRoot"), AS = /* @__PURE__ */ H({
  __name: "AccordionRoot",
  props: {
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = e, { dir: i, disabled: r } = Zn(t), s = I1(i), { modelValue: a, changeModelValue: l, isSingle: d } = OS(t, o), { forwardRef: u, currentElement: c } = Ce();
    return TS({
      disabled: r,
      direction: s,
      orientation: t.orientation,
      parentElement: c,
      isSingle: d,
      collapsible: t.collapsible,
      modelValue: a,
      changeModelValue: l
    }), (f, h) => (v(), V(k(Re), {
      ref: k(u),
      "as-child": f.asChild,
      as: f.as
    }, {
      default: B(() => [
        le(f.$slots, "default", { modelValue: k(a) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [P1, IS] = Rt("AccordionItem"), DS = /* @__PURE__ */ H({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n, { expose: e }) {
    const t = n, o = bu(), i = L(
      () => o.isSingle.value ? t.value === o.modelValue.value : Array.isArray(o.modelValue.value) && o.modelValue.value.includes(t.value)
    ), r = L(() => o.disabled.value || t.disabled || o.isSingle.value && i.value && !o.collapsible), s = L(() => r.value ? "" : void 0), a = L(
      () => i.value ? "open" : "closed"
      /* Closed */
    );
    e({ open: i, dataDisabled: s });
    const { currentRef: l, currentElement: d } = Ce();
    IS({
      open: i,
      dataState: a,
      disabled: r,
      dataDisabled: s,
      triggerId: "",
      currentRef: l,
      currentElement: d,
      value: L(() => t.value)
    });
    function u(c) {
      x6(
        c,
        d.value,
        o.parentElement.value,
        {
          arrowKeyOptions: o.orientation,
          dir: o.direction.value,
          focus: !0
        }
      );
    }
    return (c, f) => (v(), V(k(kS), {
      "data-orientation": k(o).orientation,
      "data-disabled": s.value,
      "data-state": a.value,
      disabled: r.value,
      open: i.value,
      as: t.as,
      "as-child": t.asChild,
      onKeydown: Zt(u, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: B(() => [
        le(c.$slots, "default", { open: i.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as", "as-child"]));
  }
}), NS = /* @__PURE__ */ H({
  __name: "AccordionContent",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = bu(), o = P1();
    return Ce(), (i, r) => (v(), V(k(SS), {
      role: "region",
      hidden: !k(o).open.value,
      "as-child": e.asChild,
      "aria-labelledby": k(o).triggerId,
      "data-state": k(o).dataState.value,
      "data-disabled": k(o).dataDisabled.value,
      "data-orientation": k(t).orientation,
      style: { "--radix-accordion-content-width": "var(--radix-collapsible-content-width)", "--radix-accordion-content-height": "var(--radix-collapsible-content-height)" }
    }, {
      default: B(() => [
        le(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["hidden", "as-child", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), PS = /* @__PURE__ */ H({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "h3" }
  },
  setup(n) {
    const e = n, t = bu(), o = P1();
    return Ce(), (i, r) => (v(), V(k(Re), {
      as: e.as,
      "as-child": e.asChild,
      "data-orientation": k(t).orientation,
      "data-state": k(o).dataState.value,
      "data-disabled": k(o).dataDisabled.value
    }, {
      default: B(() => [
        le(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), LS = /* @__PURE__ */ H({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = bu(), o = P1();
    o.triggerId || (o.triggerId = Kn(void 0, "radix-vue-accordion-trigger"));
    function i() {
      o.disabled.value || t.changeModelValue(o.value.value);
    }
    return (r, s) => (v(), V(k($S), {
      id: k(o).triggerId,
      ref: k(o).currentRef,
      "data-radix-vue-collection-item": "",
      as: e.as,
      "as-child": e.asChild,
      "aria-disabled": k(o).disabled.value || void 0,
      "aria-expanded": k(o).open.value || !1,
      "data-disabled": k(o).dataDisabled.value,
      "data-orientation": k(t).orientation,
      "data-state": k(o).dataState.value,
      disabled: k(o).disabled.value,
      onClick: i
    }, {
      default: B(() => [
        le(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), [wo, RS] = Rt("DialogRoot"), FS = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, o = Hn(t, "open", e, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), i = R(), r = R(), { modal: s } = Zn(t);
    return RS({
      open: o,
      modal: s,
      openModal: () => {
        o.value = !0;
      },
      onOpenChange: (a) => {
        o.value = a;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      contentId: "",
      titleId: "",
      descriptionId: "",
      triggerElement: i,
      contentElement: r
    }), (a, l) => le(a.$slots, "default", { open: k(o) });
  }
}), BS = /* @__PURE__ */ H({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = wo(), { forwardRef: o, currentElement: i } = Ce();
    return t.contentId || (t.contentId = Kn(void 0, "radix-vue-dialog-content")), We(() => {
      t.triggerElement.value = i.value;
    }), (r, s) => (v(), V(k(Re), ze(e, {
      ref: k(o),
      type: r.as === "button" ? "button" : void 0,
      "aria-haspopup": "dialog",
      "aria-expanded": k(t).open.value || !1,
      "aria-controls": k(t).open.value ? k(t).contentId : void 0,
      "data-state": k(t).open.value ? "open" : "closed",
      onClick: k(t).onOpenToggle
    }), {
      default: B(() => [
        le(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "onClick"]));
  }
}), L1 = /* @__PURE__ */ H({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = b6();
    return (t, o) => k(e) || t.forceMount ? (v(), V(S2, {
      key: 0,
      to: t.to,
      disabled: t.disabled
    }, [
      le(t.$slots, "default")
    ], 8, ["to", "disabled"])) : _("", !0);
  }
}), VS = /* @__PURE__ */ H({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, o) => (v(), V(k(L1), Ra(su(e)), {
      default: B(() => [
        le(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), zS = "dismissableLayer.pointerDownOutside", HS = "dismissableLayer.focusOutside";
function _6(n, e) {
  const t = e.closest(
    "[data-dismissable-layer]"
  ), o = n.dataset.dismissableLayer === "" ? n : n.querySelector(
    "[data-dismissable-layer]"
  ), i = Array.from(
    n.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(t && o === t || i.indexOf(o) < i.indexOf(t));
}
function jS(n, e) {
  var t;
  const o = ((t = e == null ? void 0 : e.value) == null ? void 0 : t.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), i = R(!1), r = R(() => {
  });
  return dt((s) => {
    if (!Go)
      return;
    const a = async (d) => {
      const u = d.target;
      if (e != null && e.value) {
        if (_6(e.value, u)) {
          i.value = !1;
          return;
        }
        if (d.target && !i.value) {
          let c = function() {
            O1(
              zS,
              n,
              f
            );
          };
          const f = { originalEvent: d };
          d.pointerType === "touch" ? (o.removeEventListener("click", r.value), r.value = c, o.addEventListener("click", r.value, {
            once: !0
          })) : c();
        } else
          o.removeEventListener("click", r.value);
        i.value = !1;
      }
    }, l = window.setTimeout(() => {
      o.addEventListener("pointerdown", a);
    }, 0);
    s(() => {
      window.clearTimeout(l), o.removeEventListener("pointerdown", a), o.removeEventListener("click", r.value);
    });
  }), {
    onPointerDownCapture: () => i.value = !0
  };
}
function WS(n, e) {
  var t;
  const o = ((t = e == null ? void 0 : e.value) == null ? void 0 : t.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), i = R(!1);
  return dt((r) => {
    if (!Go)
      return;
    const s = async (a) => {
      e != null && e.value && (await Ve(), !(!e.value || _6(e.value, a.target)) && a.target && !i.value && O1(
        HS,
        n,
        { originalEvent: a }
      ));
    };
    o.addEventListener("focusin", s), r(() => o.removeEventListener("focusin", s));
  }), {
    onFocusCapture: () => i.value = !0,
    onBlurCapture: () => i.value = !1
  };
}
const ko = Zr({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), yu = /* @__PURE__ */ H({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(n, { emit: e }) {
    const t = n, o = e, { forwardRef: i, currentElement: r } = Ce(), s = L(
      () => {
        var p;
        return ((p = r.value) == null ? void 0 : p.ownerDocument) ?? globalThis.document;
      }
    ), a = L(() => ko.layersRoot), l = L(() => r.value ? Array.from(a.value).indexOf(r.value) : -1), d = L(() => ko.layersWithOutsidePointerEventsDisabled.size > 0), u = L(() => {
      const p = Array.from(a.value), [m] = [...ko.layersWithOutsidePointerEventsDisabled].slice(-1), g = p.indexOf(m);
      return l.value >= g;
    }), c = jS(async (p) => {
      const m = [...ko.branches].some(
        (g) => g == null ? void 0 : g.contains(p.target)
      );
      !u.value || m || (o("pointerDownOutside", p), o("interactOutside", p), await Ve(), p.defaultPrevented || o("dismiss"));
    }, r), f = WS((p) => {
      [...ko.branches].some(
        (m) => m == null ? void 0 : m.contains(p.target)
      ) || (o("focusOutside", p), o("interactOutside", p), p.defaultPrevented || o("dismiss"));
    }, r);
    ZM("Escape", (p) => {
      l.value === a.value.size - 1 && (o("escapeKeyDown", p), p.defaultPrevented || o("dismiss"));
    });
    let h;
    return dt((p) => {
      r.value && (t.disableOutsidePointerEvents && (ko.layersWithOutsidePointerEventsDisabled.size === 0 && (h = s.value.body.style.pointerEvents, s.value.body.style.pointerEvents = "none"), ko.layersWithOutsidePointerEventsDisabled.add(r.value)), a.value.add(r.value), p(() => {
        t.disableOutsidePointerEvents && ko.layersWithOutsidePointerEventsDisabled.size === 1 && (s.value.body.style.pointerEvents = h);
      }));
    }), dt((p) => {
      p(() => {
        r.value && (a.value.delete(r.value), ko.layersWithOutsidePointerEventsDisabled.delete(r.value));
      });
    }), (p, m) => (v(), V(k(Re), {
      ref: k(i),
      "as-child": p.asChild,
      as: p.as,
      "data-dismissable-layer": "",
      style: He({
        pointerEvents: d.value ? u.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: k(f).onFocusCapture,
      onBlurCapture: k(f).onBlurCapture,
      onPointerdownCapture: k(c).onPointerDownCapture
    }, {
      default: B(() => [
        le(p.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), oc = "focusScope.autoFocusOnMount", ic = "focusScope.autoFocusOnUnmount", Z0 = { bubbles: !1, cancelable: !0 };
function US(n, { select: e = !1 } = {}) {
  const t = document.activeElement;
  for (const o of n)
    if (ni(o, { select: e }), document.activeElement !== t)
      return !0;
}
function KS(n) {
  const e = E6(n), t = J0(e, n), o = J0(e.reverse(), n);
  return [t, o];
}
function E6(n) {
  const e = [], t = document.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const i = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || i ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) e.push(t.currentNode);
  return e;
}
function J0(n, e) {
  for (const t of n)
    if (!GS(t, { upTo: e }))
      return t;
}
function GS(n, { upTo: e }) {
  if (getComputedStyle(n).visibility === "hidden")
    return !0;
  for (; n; ) {
    if (e !== void 0 && n === e)
      return !1;
    if (getComputedStyle(n).display === "none")
      return !0;
    n = n.parentElement;
  }
  return !1;
}
function YS(n) {
  return n instanceof HTMLInputElement && "select" in n;
}
function ni(n, { select: e = !1 } = {}) {
  if (n && n.focus) {
    const t = document.activeElement;
    n.focus({ preventScroll: !0 }), n !== t && YS(n) && e && n.select();
  }
}
const qS = FM(() => R([]));
function ZS() {
  const n = qS();
  return {
    add(e) {
      const t = n.value[0];
      e !== t && (t == null || t.pause()), n.value = X0(n.value, e), n.value.unshift(e);
    },
    remove(e) {
      var t;
      n.value = X0(n.value, e), (t = n.value[0]) == null || t.resume();
    }
  };
}
function X0(n, e) {
  const t = [...n], o = t.indexOf(e);
  return o !== -1 && t.splice(o, 1), t;
}
function JS(n) {
  return n.filter((e) => e.tagName !== "A");
}
const O6 = /* @__PURE__ */ H({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, { currentRef: i, currentElement: r } = Ce(), s = R(null), a = ZS(), l = Zr({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    dt((u) => {
      if (!Go)
        return;
      const c = r.value;
      if (!t.trapped)
        return;
      function f(g) {
        if (l.paused || !c)
          return;
        const b = g.target;
        c.contains(b) ? s.value = b : ni(s.value, { select: !0 });
      }
      function h(g) {
        if (l.paused || !c)
          return;
        const b = g.relatedTarget;
        b !== null && (c.contains(b) || ni(s.value, { select: !0 }));
      }
      function p(g) {
        c.contains(s.value) || ni(c);
      }
      document.addEventListener("focusin", f), document.addEventListener("focusout", h);
      const m = new MutationObserver(p);
      c && m.observe(c, { childList: !0, subtree: !0 }), u(() => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", h), m.disconnect();
      });
    }), dt(async (u) => {
      const c = r.value;
      if (await Ve(), !c)
        return;
      a.add(l);
      const f = document.activeElement;
      if (!c.contains(f)) {
        const h = new CustomEvent(oc, Z0);
        c.addEventListener(oc, (p) => o("mountAutoFocus", p)), c.dispatchEvent(h), h.defaultPrevented || (US(JS(E6(c)), {
          select: !0
        }), document.activeElement === f && ni(c));
      }
      u(() => {
        c.removeEventListener(oc, (m) => o("mountAutoFocus", m));
        const h = new CustomEvent(ic, Z0), p = (m) => {
          o("unmountAutoFocus", m);
        };
        c.addEventListener(ic, p), c.dispatchEvent(h), setTimeout(() => {
          h.defaultPrevented || ni(f ?? document.body, { select: !0 }), c.removeEventListener(ic, p), a.remove(l);
        }, 0);
      });
    });
    function d(u) {
      if (!t.loop && !t.trapped || l.paused)
        return;
      const c = u.key === "Tab" && !u.altKey && !u.ctrlKey && !u.metaKey, f = document.activeElement;
      if (c && f) {
        const h = u.currentTarget, [p, m] = KS(h);
        p && m ? !u.shiftKey && f === m ? (u.preventDefault(), t.loop && ni(p, { select: !0 })) : u.shiftKey && f === p && (u.preventDefault(), t.loop && ni(m, { select: !0 })) : f === h && u.preventDefault();
      }
    }
    return (u, c) => (v(), V(k(Re), {
      ref_key: "currentRef",
      ref: i,
      tabindex: "-1",
      "as-child": u.asChild,
      as: u.as,
      onKeydown: d
    }, {
      default: B(() => [
        le(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
});
function XS(n) {
  return n ? "open" : "closed";
}
const QS = "DialogTitle", e_ = "DialogContent";
function t_({
  titleName: n = QS,
  contentName: e = e_,
  componentLink: t = "dialog.html#title",
  titleId: o,
  descriptionId: i,
  contentElement: r
}) {
  const s = `Warning: \`${e}\` requires a \`${n}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.radix-vue.com/components/${t}`, a = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${e}.`;
  We(() => {
    var l;
    document.getElementById(o) || console.warn(s);
    const d = (l = r.value) == null ? void 0 : l.getAttribute("aria-describedby");
    i && d && (document.getElementById(i) || console.warn(a));
  });
}
const T6 = /* @__PURE__ */ H({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = wo(), { forwardRef: r, currentElement: s } = Ce();
    return i.titleId || (i.titleId = Kn(void 0, "radix-vue-dialog-title")), i.descriptionId || (i.descriptionId = Kn(void 0, "radix-vue-dialog-description")), We(() => {
      i.contentElement = s, document.activeElement !== document.body && (i.triggerElement.value = document.activeElement);
    }), process.env.NODE_ENV !== "production" && t_({
      titleName: "DialogTitle",
      contentName: "DialogContent",
      componentLink: "dialog.html#title",
      titleId: i.titleId,
      descriptionId: i.descriptionId,
      contentElement: s
    }), (a, l) => (v(), V(k(O6), {
      "as-child": "",
      loop: "",
      trapped: t.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (d) => o("openAutoFocus", d)),
      onUnmountAutoFocus: l[6] || (l[6] = (d) => o("closeAutoFocus", d))
    }, {
      default: B(() => [
        U(k(yu), ze({
          id: k(i).contentId,
          ref: k(r),
          as: a.as,
          "as-child": a.asChild,
          "disable-outside-pointer-events": a.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": k(i).descriptionId,
          "aria-labelledby": k(i).titleId,
          "data-state": k(XS)(k(i).open.value)
        }, a.$attrs, {
          onDismiss: l[0] || (l[0] = (d) => k(i).onOpenChange(!1)),
          onEscapeKeyDown: l[1] || (l[1] = (d) => o("escapeKeyDown", d)),
          onFocusOutside: l[2] || (l[2] = (d) => o("focusOutside", d)),
          onInteractOutside: l[3] || (l[3] = (d) => o("interactOutside", d)),
          onPointerDownOutside: l[4] || (l[4] = (d) => o("pointerDownOutside", d))
        }), {
          default: B(() => [
            le(a.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), n_ = /* @__PURE__ */ H({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = wo(), r = gu(o), { forwardRef: s, currentElement: a } = Ce();
    return D1(a), (l, d) => (v(), V(T6, ze({ ...t, ...k(r) }, {
      ref: k(s),
      "trap-focus": k(i).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: d[0] || (d[0] = (u) => {
        var c;
        u.defaultPrevented || (u.preventDefault(), (c = k(i).triggerElement.value) == null || c.focus());
      }),
      onPointerDownOutside: d[1] || (d[1] = (u) => {
        const c = u.detail.originalEvent, f = c.button === 0 && c.ctrlKey === !0;
        (c.button === 2 || f) && u.preventDefault();
      }),
      onFocusOutside: d[2] || (d[2] = (u) => {
        u.preventDefault();
      })
    }), {
      default: B(() => [
        le(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), o_ = /* @__PURE__ */ H({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = gu(e);
    Ce();
    const i = wo(), r = R(!1), s = R(!1);
    return (a, l) => (v(), V(T6, ze({ ...t, ...k(o) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: l[0] || (l[0] = (d) => {
        var u;
        d.defaultPrevented || (r.value || (u = k(i).triggerElement.value) == null || u.focus(), d.preventDefault()), r.value = !1, s.value = !1;
      }),
      onInteractOutside: l[1] || (l[1] = (d) => {
        var u;
        d.defaultPrevented || (r.value = !0, d.detail.originalEvent.type === "pointerdown" && (s.value = !0));
        const c = d.target;
        (u = k(i).triggerElement.value) != null && u.contains(c) && d.preventDefault(), d.detail.originalEvent.type === "focusin" && s.value && d.preventDefault();
      })
    }), {
      default: B(() => [
        le(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), i_ = /* @__PURE__ */ H({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = wo(), r = gu(o), { forwardRef: s } = Ce();
    return (a, l) => (v(), V(k(bs), {
      present: a.forceMount || k(i).open.value
    }, {
      default: B(() => [
        k(i).modal.value ? (v(), V(n_, ze({
          key: 0,
          ref: k(s)
        }, { ...t, ...k(r), ...a.$attrs }), {
          default: B(() => [
            le(a.$slots, "default")
          ]),
          _: 3
        }, 16)) : (v(), V(o_, ze({
          key: 1,
          ref: k(s)
        }, { ...t, ...k(r), ...a.$attrs }), {
          default: B(() => [
            le(a.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), r_ = /* @__PURE__ */ H({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = wo();
    return A1(!0), Ce(), (t, o) => (v(), V(k(Re), {
      as: t.as,
      "as-child": t.asChild,
      "data-state": k(e).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: B(() => [
        le(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), s_ = /* @__PURE__ */ H({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = wo(), { forwardRef: t } = Ce();
    return (o, i) => {
      var r;
      return (r = k(e)) != null && r.modal.value ? (v(), V(k(bs), {
        key: 0,
        present: o.forceMount || k(e).open.value
      }, {
        default: B(() => [
          U(r_, ze(o.$attrs, {
            ref: k(t),
            as: o.as,
            "as-child": o.asChild
          }), {
            default: B(() => [
              le(o.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : _("", !0);
    };
  }
}), a_ = /* @__PURE__ */ H({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = wo();
    return (o, i) => (v(), V(k(Re), ze(e, {
      type: o.as === "button" ? "button" : void 0,
      onClick: i[0] || (i[0] = (r) => k(t).onOpenChange(!1))
    }), {
      default: B(() => [
        le(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), l_ = /* @__PURE__ */ H({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { default: "h2" }
  },
  setup(n) {
    const e = n, t = wo();
    return Ce(), (o, i) => (v(), V(k(Re), ze(e, {
      id: k(t).titleId
    }), {
      default: B(() => [
        le(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), d_ = /* @__PURE__ */ H({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { default: "p" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = wo();
    return (o, i) => (v(), V(k(Re), ze(e, {
      id: k(t).descriptionId
    }), {
      default: B(() => [
        le(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [A6, u_] = Rt("PopperRoot"), R1 = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(n) {
    const e = R();
    return u_({
      anchor: e,
      onAnchorChange: (t) => e.value = t
    }), (t, o) => le(t.$slots, "default");
  }
}), F1 = /* @__PURE__ */ H({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { forwardRef: t, currentElement: o } = Ce(), i = A6();
    return dt(() => {
      i.onAnchorChange(e.element ?? o.value);
    }), (r, s) => (v(), V(k(Re), {
      ref: k(t),
      as: r.as,
      "as-child": r.asChild
    }, {
      default: B(() => [
        le(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function c_(n) {
  return n !== null;
}
function f_(n) {
  return {
    name: "transformOrigin",
    options: n,
    fn(e) {
      var t, o, i;
      const { placement: r, rects: s, middlewareData: a } = e, l = ((t = a.arrow) == null ? void 0 : t.centerOffset) !== 0, d = l ? 0 : n.arrowWidth, u = l ? 0 : n.arrowHeight, [c, f] = pf(r), h = { start: "0%", center: "50%", end: "100%" }[f], p = (((o = a.arrow) == null ? void 0 : o.x) ?? 0) + d / 2, m = (((i = a.arrow) == null ? void 0 : i.y) ?? 0) + u / 2;
      let g = "", b = "";
      return c === "bottom" ? (g = l ? h : `${p}px`, b = `${-u}px`) : c === "top" ? (g = l ? h : `${p}px`, b = `${s.floating.height + u}px`) : c === "right" ? (g = `${-u}px`, b = l ? h : `${m}px`) : c === "left" && (g = `${s.floating.width + u}px`, b = l ? h : `${m}px`), { data: { x: g, y: b } };
    }
  };
}
function pf(n) {
  const [e, t = "center"] = n.split("-");
  return [e, t];
}
const h_ = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [tY, p_] = Rt("PopperContent"), ed = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ cv({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...h_
  }),
  emits: ["placed"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = A6(), { forwardRef: r, currentElement: s } = Ce(), a = R(), l = R(), { width: d, height: u } = xS(l), c = L(
      () => t.side + (t.align !== "center" ? `-${t.align}` : "")
    ), f = L(() => typeof t.collisionPadding == "number" ? t.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...t.collisionPadding }), h = L(() => Array.isArray(t.collisionBoundary) ? t.collisionBoundary : [t.collisionBoundary]), p = L(() => ({
      padding: f.value,
      boundary: h.value.filter(c_),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: h.value.length > 0
    })), m = LM(() => [
      $M({
        mainAxis: t.sideOffset + u.value,
        alignmentAxis: t.alignOffset
      }),
      t.prioritizePosition && t.avoidCollisions && K0({
        ...p.value
      }),
      t.avoidCollisions && MM({
        mainAxis: !0,
        crossAxis: !!t.prioritizePosition,
        limiter: t.sticky === "partial" ? OM() : void 0,
        ...p.value
      }),
      !t.prioritizePosition && t.avoidCollisions && K0({
        ...p.value
      }),
      SM({
        ...p.value,
        apply: ({ elements: I, rects: z, availableWidth: F, availableHeight: Y }) => {
          const { width: ie, height: W } = z.reference, te = I.floating.style;
          te.setProperty(
            "--radix-popper-available-width",
            `${F}px`
          ), te.setProperty(
            "--radix-popper-available-height",
            `${Y}px`
          ), te.setProperty(
            "--radix-popper-anchor-width",
            `${ie}px`
          ), te.setProperty(
            "--radix-popper-anchor-height",
            `${W}px`
          );
        }
      }),
      l.value && IM({ element: l.value, padding: t.arrowPadding }),
      f_({
        arrowWidth: d.value,
        arrowHeight: u.value
      }),
      t.hideWhenDetached && _M({ strategy: "referenceHidden", ...p.value })
    ]), { floatingStyles: g, placement: b, isPositioned: x, middlewareData: w } = DM(
      i.anchor,
      a,
      {
        strategy: "fixed",
        placement: c,
        whileElementsMounted: (...I) => kM(...I, {
          animationFrame: t.updatePositionStrategy === "always"
        }),
        middleware: m
      }
    ), M = L(
      () => pf(b.value)[0]
    ), $ = L(
      () => pf(b.value)[1]
    );
    fv(() => {
      x.value && o("placed");
    });
    const T = L(
      () => {
        var I;
        return ((I = w.value.arrow) == null ? void 0 : I.centerOffset) !== 0;
      }
    ), E = R("");
    dt(() => {
      s.value && (E.value = window.getComputedStyle(s.value).zIndex);
    });
    const S = L(() => {
      var I;
      return ((I = w.value.arrow) == null ? void 0 : I.x) ?? 0;
    }), D = L(() => {
      var I;
      return ((I = w.value.arrow) == null ? void 0 : I.y) ?? 0;
    });
    return p_({
      placedSide: M,
      onArrowChange: (I) => l.value = I,
      arrowX: S,
      arrowY: D,
      shouldHideArrow: T
    }), (I, z) => {
      var F, Y, ie;
      return v(), C("div", {
        ref_key: "floatingRef",
        ref: a,
        "data-radix-popper-content-wrapper": "",
        style: He({
          ...k(g),
          transform: k(x) ? k(g).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: E.value,
          "--radix-popper-transform-origin": [
            (F = k(w).transformOrigin) == null ? void 0 : F.x,
            (Y = k(w).transformOrigin) == null ? void 0 : Y.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ie = k(w).hide) == null ? void 0 : ie.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        U(k(Re), ze({ ref: k(r) }, I.$attrs, {
          "as-child": t.asChild,
          as: I.as,
          "data-side": M.value,
          "data-align": $.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: k(x) ? void 0 : "none"
          }
        }), {
          default: B(() => [
            le(I.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), I6 = /* @__PURE__ */ H({
  __name: "VisuallyHidden",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    return Ce(), (e, t) => (v(), V(k(Re), {
      as: e.as,
      "as-child": e.asChild,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        display: "inline-block",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, {
      default: B(() => [
        le(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), D6 = /* @__PURE__ */ H({
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(n) {
    const e = n, t = L(() => typeof e.value == "string" || typeof e.value == "number" || typeof e.value == "boolean" ? [{ name: e.name, value: e.value }] : typeof e.value == "object" && Array.isArray(e.value) ? e.value.flatMap((o, i) => typeof o == "object" ? Object.entries(o).map(([r, s]) => ({ name: `[${i}][${e.name}][${r}]`, value: s })) : { name: `[${e.name}][${i}]`, value: o }) : e.value !== null && typeof e.value == "object" && !Array.isArray(e.value) ? Object.entries(e.value).map(([o, i]) => ({ name: `[${e.name}][${o}]`, value: i })) : []);
    return (o, i) => (v(!0), C(re, null, De(t.value, (r) => (v(), V(I6, {
      key: r.name,
      as: "input",
      type: "hidden",
      hidden: "",
      readonly: "",
      name: r.name,
      value: r.value,
      required: o.required,
      disabled: o.disabled
    }, null, 8, ["name", "value", "required", "disabled"]))), 128));
  }
}), m_ = "data-radix-vue-collection-item", [B1, g_] = Rt("CollectionProvider");
function N6(n = m_) {
  const e = R(/* @__PURE__ */ new Map()), t = R(), o = g_({
    collectionRef: t,
    itemMap: e,
    attrName: n
  }), { getItems: i } = v_(o), r = L(() => Array.from(o.itemMap.value.values())), s = L(() => o.itemMap.value.size);
  return { getItems: i, reactiveItems: r, itemMapSize: s };
}
const P6 = H({
  name: "CollectionSlot",
  setup(n, { slots: e }) {
    const t = B1(), { primitiveElement: o, currentElement: i } = $6();
    return Ee(i, () => {
      t.collectionRef.value = i.value;
    }), () => lt(N1, { ref: o }, e);
  }
}), L6 = H({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(n, { slots: e, attrs: t }) {
    const o = B1(), { primitiveElement: i, currentElement: r } = $6();
    return dt((s) => {
      if (r.value) {
        const a = O2(r.value);
        o.itemMap.value.set(a, { ref: r.value, value: n.value }), s(() => o.itemMap.value.delete(a));
      }
    }), () => lt(N1, { ...t, [o.attrName]: "", ref: i }, e);
  }
});
function v_(n) {
  const e = n ?? B1();
  return { getItems: () => {
    const t = e.collectionRef.value;
    if (!t)
      return [];
    const o = Array.from(t.querySelectorAll(`[${e.attrName}]`));
    return Array.from(e.itemMap.value.values()).sort(
      (i, r) => o.indexOf(i.ref) - o.indexOf(r.ref)
    );
  } };
}
const [vr, b_] = Rt("ComboboxRoot"), y_ = /* @__PURE__ */ H({
  __name: "ComboboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(n, { emit: e }) {
    const t = n, o = e, { multiple: i, disabled: r, dir: s } = Zn(t), a = I1(s), l = Hn(t, "searchTerm", o, {
      // @ts-expect-error ignore the type error here
      defaultValue: "",
      passive: t.searchTerm === void 0
    }), d = Hn(t, "modelValue", o, {
      // @ts-expect-error ignore the type error here
      defaultValue: t.defaultValue ?? i.value ? [] : void 0,
      passive: t.modelValue === void 0,
      deep: !0
    }), u = Hn(t, "open", o, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), c = Hn(t, "selectedValue", o, {
      defaultValue: void 0,
      passive: t.selectedValue === void 0
    });
    async function f(W) {
      var te, ce;
      u.value = W, await Ve(), W ? (d.value && (Array.isArray(d.value) && i.value ? c.value = (te = w().find((we) => {
        var ke, rt;
        return ((rt = (ke = we.ref) == null ? void 0 : ke.dataset) == null ? void 0 : rt.state) === "checked";
      })) == null ? void 0 : te.value : c.value = d.value), await Ve(), (ce = m.value) == null || ce.focus(), Y()) : (p.value = !1, t.resetSearchTermOnBlur && S());
    }
    function h(W) {
      if (Array.isArray(d.value) && i.value) {
        const te = d.value.findIndex((we) => Gi(we, W)), ce = [...d.value];
        te === -1 ? ce.push(W) : ce.splice(te, 1), d.value = ce;
      } else
        d.value = W, f(!1);
    }
    const p = R(!1), m = R(), g = R(), { forwardRef: b, currentElement: x } = Ce(), { getItems: w, reactiveItems: M, itemMapSize: $ } = N6("data-radix-vue-combobox-item"), T = R([]);
    Ee(() => $.value, () => {
      T.value = w().map((W) => W.value);
    }, {
      immediate: !0,
      flush: "post"
    });
    const E = L(() => {
      if (p.value) {
        if (t.filterFunction)
          return t.filterFunction(T.value, l.value);
        const W = T.value.filter((te) => typeof te == "string");
        if (W.length)
          return W.filter((te) => {
            var ce;
            return te.toLowerCase().includes((ce = l.value) == null ? void 0 : ce.toLowerCase());
          });
      }
      return T.value;
    });
    function S() {
      !i.value && d.value && !Array.isArray(d.value) ? t.displayValue ? l.value = t.displayValue(d.value) : typeof d.value != "object" ? l.value = d.value.toString() : l.value = "" : l.value = "";
    }
    const D = L(() => E.value.findIndex((W) => Gi(W, c.value))), I = L(() => {
      var W;
      return (W = M.value.find((te) => Gi(te.value, c.value))) == null ? void 0 : W.ref;
    }), z = L(() => JSON.stringify(d.value));
    Ee(z, async () => {
      await Ve(), await Ve(), S();
    }, {
      // If searchTerm is provided with value during initialization, we don't reset it immediately
      immediate: !t.searchTerm
    }), Ee(() => [E.value.length, l.value.length], async ([W, te], [ce, we]) => {
      await Ve(), await Ve(), W && (we > te || D.value === -1) && (c.value = E.value[0]);
    });
    const F = w6(x);
    function Y() {
      var W;
      I.value instanceof Element && ((W = I.value) == null || W.scrollIntoView({ block: "nearest" }));
    }
    function ie() {
      I.value instanceof Element && I.value.focus && I.value.focus();
    }
    return b_({
      searchTerm: l,
      modelValue: d,
      // @ts-expect-error ignoring
      onValueChange: h,
      isUserInputted: p,
      multiple: i,
      disabled: r,
      open: u,
      onOpenChange: f,
      filteredOptions: E,
      contentId: "",
      inputElement: m,
      selectedElement: I,
      onInputElementChange: (W) => m.value = W,
      onInputNavigation: async (W) => {
        const te = D.value;
        te === 0 && W === "up" || te === E.value.length - 1 && W === "down" || (te === -1 && E.value.length || W === "home" ? c.value = E.value[0] : W === "end" ? c.value = E.value[E.value.length - 1] : c.value = E.value[W === "up" ? te - 1 : te + 1], await Ve(), Y(), ie(), Ve(() => {
          var ce;
          return (ce = m.value) == null ? void 0 : ce.focus({ preventScroll: !0 });
        }));
      },
      onInputEnter: async (W) => {
        var te;
        E.value.length && c.value && I.value instanceof Element && (W.preventDefault(), W.stopPropagation(), (te = I.value) == null || te.click());
      },
      selectedValue: c,
      onSelectedValueChange: (W) => c.value = W,
      parentElement: x,
      contentElement: g,
      onContentElementChange: (W) => g.value = W
    }), (W, te) => (v(), V(k(R1), null, {
      default: B(() => [
        U(k(Re), ze({
          ref: k(b),
          style: {
            pointerEvents: k(u) ? "auto" : void 0
          },
          as: W.as,
          "as-child": W.asChild,
          dir: k(a)
        }, W.$attrs), {
          default: B(() => [
            le(W.$slots, "default", {
              open: k(u),
              modelValue: k(d)
            }),
            k(F) && t.name ? (v(), V(k(D6), {
              key: 0,
              name: t.name,
              value: k(d)
            }, null, 8, ["name", "value"])) : _("", !0)
          ]),
          _: 3
        }, 16, ["style", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), x_ = /* @__PURE__ */ H({
  __name: "ComboboxInput",
  props: {
    type: { default: "text" },
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(n) {
    const e = n, t = vr(), { forwardRef: o, currentElement: i } = Ce();
    We(() => {
      const u = i.value.nodeName === "INPUT" ? i.value : i.value.querySelector("input");
      u && (t.onInputElementChange(u), setTimeout(() => {
        e.autoFocus && (u == null || u.focus());
      }, 1));
    });
    const r = L(() => e.disabled || t.disabled.value || !1), s = R();
    lv(() => {
      var u;
      return s.value = (u = t.selectedElement.value) == null ? void 0 : u.id;
    });
    function a(u) {
      t.open.value ? t.onInputNavigation(u.key === "ArrowUp" ? "up" : "down") : t.onOpenChange(!0);
    }
    function l(u) {
      t.open.value && t.onInputNavigation(u.key === "Home" ? "home" : "end");
    }
    function d(u) {
      var c;
      t.searchTerm.value = (c = u.target) == null ? void 0 : c.value, t.open.value || t.onOpenChange(!0), t.isUserInputted.value = !0;
    }
    return (u, c) => (v(), V(k(Re), {
      ref: k(o),
      as: u.as,
      "as-child": u.asChild,
      type: u.type,
      disabled: r.value,
      value: k(t).searchTerm.value,
      "aria-expanded": k(t).open.value,
      "aria-controls": k(t).contentId,
      "aria-disabled": r.value ?? void 0,
      "aria-activedescendant": s.value,
      "aria-autocomplete": "list",
      role: "combobox",
      autocomplete: "false",
      onInput: d,
      onKeydown: [
        Zt(It(a, ["prevent"]), ["down", "up"]),
        Zt(k(t).onInputEnter, ["enter"]),
        Zt(It(l, ["prevent"]), ["home", "end"])
      ]
    }, {
      default: B(() => [
        le(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "disabled", "value", "aria-expanded", "aria-controls", "aria-disabled", "aria-activedescendant", "onKeydown"]));
  }
}), C_ = /* @__PURE__ */ H({
  __name: "ComboboxAnchor",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const { forwardRef: e } = Ce();
    return (t, o) => (v(), V(k(F1), { "as-child": "" }, {
      default: B(() => [
        U(k(Re), ze({
          ref: k(e),
          "as-child": t.asChild,
          as: t.as
        }, t.$attrs), {
          default: B(() => [
            le(t.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as"])
      ]),
      _: 3
    }));
  }
}), w_ = /* @__PURE__ */ H({
  __name: "ComboboxTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = vr(), o = L(() => e.disabled || t.disabled.value || !1);
    return (i, r) => (v(), V(k(Re), ze(e, {
      type: i.as === "button" ? "button" : void 0,
      tabindex: "-1",
      "aria-label": "Show popup",
      "aria-haspopup": "listbox",
      "aria-expanded": k(t).open.value,
      "aria-controls": k(t).contentId,
      "data-state": k(t).open.value ? "open" : "closed",
      disabled: o.value,
      "data-disabled": o.value ? "" : void 0,
      "aria-disabled": o.value ?? void 0,
      onClick: r[0] || (r[0] = (s) => k(t).onOpenChange(!k(t).open.value))
    }), {
      default: B(() => [
        le(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "disabled", "data-disabled", "aria-disabled"]));
  }
}), [k_, $_] = Rt("ComboboxGroup"), M_ = /* @__PURE__ */ H({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { currentRef: t, currentElement: o } = Ce(), i = Kn(void 0, "radix-vue-combobox-group"), r = vr(), s = R(!1);
    function a() {
      if (!o.value)
        return;
      const l = o.value.querySelectorAll("[data-radix-vue-combobox-item]:not([data-hidden])");
      s.value = !!l.length;
    }
    return y6(o, () => {
      Ve(() => {
        a();
      });
    }, { childList: !0 }), Ee(() => r.searchTerm.value, () => {
      Ve(() => {
        a();
      });
    }, { immediate: !0 }), $_({
      id: i
    }), (l, d) => vo((v(), V(k(Re), ze(e, {
      ref_key: "currentRef",
      ref: t,
      role: "group",
      "aria-labelledby": k(i)
    }), {
      default: B(() => [
        le(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"])), [
      [E2, s.value]
    ]);
  }
}), [nY, S_] = Rt("ComboboxContent"), __ = /* @__PURE__ */ H({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = n, o = e, { position: i } = Zn(t), r = vr();
    A1(t.bodyLock);
    const { forwardRef: s, currentElement: a } = Ce();
    D1(r.parentElement);
    const l = L(() => t.position === "popper" ? t : {}), d = vu(l.value);
    function u(f) {
      r.onSelectedValueChange("");
    }
    We(() => {
      r.onContentElementChange(a.value);
    });
    const c = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-combobox-content-available-width": "var(--radix-popper-available-width)",
      "--radix-combobox-content-available-height": "var(--radix-popper-available-height)",
      "--radix-combobox-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-combobox-trigger-height": "var(--radix-popper-anchor-height)"
    };
    return S_({ position: i }), (f, h) => (v(), V(k(P6), null, {
      default: B(() => [
        f.dismissable ? (v(), V(k(yu), {
          key: 0,
          "as-child": "",
          "disable-outside-pointer-events": f.disableOutsidePointerEvents,
          onDismiss: h[0] || (h[0] = (p) => k(r).onOpenChange(!1)),
          onFocusOutside: h[1] || (h[1] = (p) => {
            var m;
            (m = k(r).parentElement.value) != null && m.contains(p.target) && p.preventDefault(), o("focusOutside", p);
          }),
          onInteractOutside: h[2] || (h[2] = (p) => o("interactOutside", p)),
          onEscapeKeyDown: h[3] || (h[3] = (p) => o("escapeKeyDown", p)),
          onPointerDownOutside: h[4] || (h[4] = (p) => {
            var m;
            (m = k(r).parentElement.value) != null && m.contains(p.target) && p.preventDefault(), o("pointerDownOutside", p);
          })
        }, {
          default: B(() => [
            (v(), V(qr(k(i) === "popper" ? k(ed) : k(Re)), ze({ ...f.$attrs, ...k(d) }, {
              id: k(r).contentId,
              ref: k(s),
              role: "listbox",
              "data-state": k(r).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...k(i) === "popper" ? c : {}
              },
              onPointerleave: u
            }), {
              default: B(() => [
                le(f.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])) : (v(), V(qr(k(i) === "popper" ? k(ed) : k(Re)), ze({ key: 1 }, { ...f.$attrs, ...l.value }, {
          id: k(r).contentId,
          ref: k(s),
          role: "listbox",
          "data-state": k(r).open.value ? "open" : "closed",
          style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...k(i) === "popper" ? c : {}
          },
          onPointerleave: u
        }), {
          default: B(() => [
            le(f.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "data-state", "style"]))
      ]),
      _: 3
    }));
  }
}), E_ = /* @__PURE__ */ H({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = Ba(n, e), { forwardRef: o } = Ce(), i = vr();
    return i.contentId || (i.contentId = Kn(void 0, "radix-vue-combobox-content")), (r, s) => (v(), V(k(bs), {
      present: r.forceMount || k(i).open.value
    }, {
      default: B(() => [
        U(__, ze({ ...k(t), ...r.$attrs }, { ref: k(o) }), {
          default: B(() => [
            le(r.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), O_ = /* @__PURE__ */ H({
  __name: "ComboboxEmpty",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    Ce();
    const t = vr(), o = L(() => t.filteredOptions.value.length === 0);
    return (i, r) => o.value ? (v(), V(k(Re), Ra(ze({ key: 0 }, e)), {
      default: B(() => [
        le(i.$slots, "default", {}, () => [
          Se("No options")
        ])
      ]),
      _: 3
    }, 16)) : _("", !0);
  }
});
function T_(n) {
  const e = mu({
    nonce: R()
  });
  return L(() => {
    var t;
    return (n == null ? void 0 : n.value) || ((t = e.nonce) == null ? void 0 : t.value);
  });
}
const A_ = /* @__PURE__ */ H({
  __name: "ComboboxViewport",
  props: {
    nonce: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { forwardRef: t } = Ce(), { nonce: o } = Zn(e), i = T_(o);
    return (r, s) => (v(), C(re, null, [
      U(k(Re), ze({ ...r.$attrs, ...e }, {
        ref: k(t),
        "data-radix-combobox-viewport": "",
        role: "presentation",
        style: {
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: 1,
          overflow: "auto"
        }
      }), {
        default: B(() => [
          le(r.$slots, "default")
        ]),
        _: 3
      }, 16),
      U(k(Re), {
        as: "style",
        nonce: k(i)
      }, {
        default: B(() => [
          Se(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-radix-combobox-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-radix-combobox-viewport]::-webkit-scrollbar { display: none; } ")
        ]),
        _: 1
      }, 8, ["nonce"])
    ], 64));
  }
}), [oY, I_] = Rt("ComboboxItem"), D_ = "combobox.select", Q0 = /* @__PURE__ */ H({
  __name: "ComboboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, o = e, { disabled: i } = Zn(t), r = vr();
    k_({ id: "", options: R([]) });
    const { forwardRef: s } = Ce(), a = L(
      () => {
        var m, g;
        return r.multiple.value && Array.isArray(r.modelValue.value) ? (m = r.modelValue.value) == null ? void 0 : m.some((b) => Gi(b, t.value)) : Gi((g = r.modelValue) == null ? void 0 : g.value, t.value);
      }
    ), l = L(() => Gi(r.selectedValue.value, t.value)), d = Kn(void 0, "radix-vue-combobox-item"), u = Kn(void 0, "radix-vue-combobox-option"), c = L(() => r.isUserInputted.value ? r.searchTerm.value === "" || !!r.filteredOptions.value.find((m) => Gi(m, t.value)) : !0);
    async function f(m) {
      o("select", m), !(m != null && m.defaultPrevented) && !i.value && m && r.onValueChange(t.value);
    }
    function h(m) {
      if (!m)
        return;
      const g = { originalEvent: m, value: t.value };
      O1(D_, f, g);
    }
    async function p(m) {
      await Ve(), !m.defaultPrevented && r.onSelectedValueChange(t.value);
    }
    if (t.value === "")
      throw new Error(
        "A <ComboboxItem /> must have a value prop that is not an empty string. This is because the Combobox value can be set to an empty string to clear the selection and show the placeholder."
      );
    return I_({
      isSelected: a
    }), (m, g) => (v(), V(k(L6), { value: m.value }, {
      default: B(() => [
        vo(U(k(Re), {
          id: k(u),
          ref: k(s),
          role: "option",
          tabindex: "-1",
          "aria-labelledby": k(d),
          "data-highlighted": l.value ? "" : void 0,
          "aria-selected": a.value,
          "data-state": a.value ? "checked" : "unchecked",
          "aria-disabled": k(i) || void 0,
          "data-disabled": k(i) ? "" : void 0,
          as: m.as,
          "as-child": m.asChild,
          "data-hidden": c.value ? void 0 : !0,
          onClick: h,
          onPointermove: p
        }, {
          default: B(() => [
            le(m.$slots, "default", {}, () => [
              Se(j(m.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["id", "aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "as", "as-child", "data-hidden"]), [
          [E2, c.value]
        ])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), [xu, N_] = Rt("PaginationRoot"), P_ = /* @__PURE__ */ H({
  __name: "PaginationRoot",
  props: {
    page: {},
    defaultPage: { default: 1 },
    itemsPerPage: { default: 10 },
    total: { default: 0 },
    siblingCount: { default: 2 },
    disabled: { type: Boolean },
    showEdges: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "nav" }
  },
  emits: ["update:page"],
  setup(n, { emit: e }) {
    const t = n, o = e, { siblingCount: i, disabled: r, showEdges: s } = Zn(t);
    Ce();
    const a = Hn(t, "page", o, {
      defaultValue: t.defaultPage,
      passive: t.page === void 0
    }), l = L(() => Math.max(1, Math.ceil(t.total / t.itemsPerPage)));
    return N_({
      page: a,
      onPageChange(d) {
        a.value = d;
      },
      pageCount: l,
      siblingCount: i,
      disabled: r,
      showEdges: s
    }), (d, u) => (v(), V(k(Re), {
      as: d.as,
      "as-child": d.asChild
    }, {
      default: B(() => [
        le(d.$slots, "default", {
          page: k(a),
          pageCount: l.value
        })
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), L_ = /* @__PURE__ */ H({
  __name: "PaginationEllipsis",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return Ce(), (t, o) => (v(), V(k(Re), ze(e, { "data-type": "ellipsis" }), {
      default: B(() => [
        le(t.$slots, "default", {}, () => [
          Se("…")
        ])
      ]),
      _: 3
    }, 16));
  }
});
function Qo(n, e) {
  const t = e - n + 1;
  return Array.from({ length: t }, (o, i) => i + n);
}
function R_(n) {
  return n.map((e) => typeof e == "number" ? { type: "page", value: e } : { type: "ellipsis" });
}
const ol = "ellipsis";
function F_(n, e, t, o) {
  const i = e, r = Math.max(n - t, 1), s = Math.min(n + t, i);
  if (o) {
    const a = Math.min(2 * t + 5, e) - 2, l = r > 3 && Math.abs(i - a - 1 + 1) > 2 && Math.abs(r - 1) > 2, d = s < i - 2 && Math.abs(i - a) > 2 && Math.abs(i - s) > 2;
    if (!l && d)
      return [...Qo(1, a), ol, i];
    if (l && !d) {
      const u = Qo(i - a + 1, i);
      return [1, ol, ...u];
    }
    if (l && d) {
      const u = Qo(r, s);
      return [1, ol, ...u, ol, i];
    }
    return Qo(1, i);
  } else {
    const a = t * 2 + 1;
    return e < a ? Qo(1, i) : n <= t + 1 ? Qo(1, a) : e - n <= t ? Qo(e - a + 1, i) : Qo(r, s);
  }
}
const B_ = /* @__PURE__ */ H({
  __name: "PaginationList",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    Ce();
    const t = xu(), o = L(() => R_(
      F_(
        t.page.value,
        t.pageCount.value,
        t.siblingCount.value,
        t.showEdges.value
      )
    ));
    return (i, r) => (v(), V(k(Re), Ra(su(e)), {
      default: B(() => [
        le(i.$slots, "default", { items: o.value })
      ]),
      _: 3
    }, 16));
  }
}), V_ = /* @__PURE__ */ H({
  __name: "PaginationListItem",
  props: {
    value: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = xu(), o = L(() => t.page.value === e.value);
    return (i, r) => (v(), V(k(Re), ze(e, {
      "data-type": "page",
      "aria-label": `Page ${i.value}`,
      "aria-current": o.value ? "page" : void 0,
      "data-selected": o.value ? "true" : void 0,
      disabled: k(t).disabled.value,
      type: i.as === "button" ? "button" : void 0,
      onClick: r[0] || (r[0] = (s) => k(t).onPageChange(i.value))
    }), {
      default: B(() => [
        le(i.$slots, "default", {}, () => [
          Se(j(i.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-current", "data-selected", "disabled", "type"]));
  }
}), z_ = /* @__PURE__ */ H({
  __name: "PaginationNext",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = xu();
    return (o, i) => (v(), V(k(Re), ze(e, {
      "aria-label": "Next Page",
      type: o.as === "button" ? "button" : void 0,
      disabled: k(t).page.value === k(t).pageCount.value || k(t).disabled.value,
      onClick: i[0] || (i[0] = (r) => k(t).onPageChange(k(t).page.value + 1))
    }), {
      default: B(() => [
        le(o.$slots, "default", {}, () => [
          Se("Next page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), H_ = /* @__PURE__ */ H({
  __name: "PaginationPrev",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = xu();
    return (o, i) => {
      var r;
      return v(), V(k(Re), ze(e, {
        "aria-label": "Previous Page",
        type: o.as === "button" ? "button" : void 0,
        disabled: k(t).page.value === 1 || ((r = k(t).disabled) == null ? void 0 : r.value),
        onClick: i[0] || (i[0] = (s) => k(t).onPageChange(k(t).page.value - 1))
      }), {
        default: B(() => [
          le(o.$slots, "default", {}, () => [
            Se("Prev page")
          ])
        ]),
        _: 3
      }, 16, ["type", "disabled"]);
    };
  }
}), [Va, j_] = Rt("PopoverRoot"), es = /* @__PURE__ */ H({
  __name: "PopoverRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    modal: { type: Boolean, default: !1 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, o = e, { modal: i } = Zn(t), r = Hn(t, "open", o, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), s = R(), a = R(!1);
    return j_({
      contentId: "",
      modal: i,
      open: r,
      onOpenChange: (l) => {
        r.value = l;
      },
      onOpenToggle: () => {
        r.value = !r.value;
      },
      triggerElement: s,
      hasCustomAnchor: a
    }), (l, d) => (v(), V(k(R1), null, {
      default: B(() => [
        le(l.$slots, "default", { open: k(r) })
      ]),
      _: 3
    }));
  }
}), ts = /* @__PURE__ */ H({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = Va(), { forwardRef: o, currentElement: i } = Ce();
    return We(() => {
      t.triggerElement.value = i.value;
    }), (r, s) => (v(), V(qr(k(t).hasCustomAnchor.value ? k(Re) : k(F1)), { "as-child": "" }, {
      default: B(() => [
        U(k(Re), {
          ref: k(o),
          type: r.as === "button" ? "button" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": k(t).open.value,
          "aria-controls": k(t).contentId,
          "data-state": k(t).open.value ? "open" : "closed",
          as: r.as,
          "as-child": e.asChild,
          onClick: k(t).onOpenToggle
        }, {
          default: B(() => [
            le(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["type", "aria-expanded", "aria-controls", "data-state", "as", "as-child", "onClick"])
      ]),
      _: 3
    }));
  }
}), ns = /* @__PURE__ */ H({
  __name: "PopoverPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, o) => (v(), V(k(L1), Ra(su(e)), {
      default: B(() => [
        le(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), R6 = /* @__PURE__ */ H({
  __name: "PopoverContentImpl",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = vu(t), { forwardRef: r } = Ce(), s = Va();
    return aS(), (a, l) => (v(), V(k(O6), {
      "as-child": "",
      loop: "",
      trapped: a.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (d) => o("openAutoFocus", d)),
      onUnmountAutoFocus: l[6] || (l[6] = (d) => o("closeAutoFocus", d))
    }, {
      default: B(() => [
        U(k(yu), {
          "as-child": "",
          "disable-outside-pointer-events": a.disableOutsidePointerEvents,
          onPointerDownOutside: l[0] || (l[0] = (d) => o("pointerDownOutside", d)),
          onInteractOutside: l[1] || (l[1] = (d) => o("interactOutside", d)),
          onEscapeKeyDown: l[2] || (l[2] = (d) => o("escapeKeyDown", d)),
          onFocusOutside: l[3] || (l[3] = (d) => o("focusOutside", d)),
          onDismiss: l[4] || (l[4] = (d) => k(s).onOpenChange(!1))
        }, {
          default: B(() => [
            U(k(ed), ze(k(i), {
              id: k(s).contentId,
              ref: k(r),
              "data-state": k(s).open.value ? "open" : "closed",
              role: "dialog",
              style: {
                "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
              }
            }), {
              default: B(() => [
                le(a.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), W_ = /* @__PURE__ */ H({
  __name: "PopoverContentModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = Va(), r = R(!1);
    A1(!0);
    const s = Ba(t, o), { forwardRef: a, currentElement: l } = Ce();
    return D1(l), (d, u) => (v(), V(R6, ze(k(s), {
      ref: k(a),
      "trap-focus": k(i).open.value,
      "disable-outside-pointer-events": "",
      onCloseAutoFocus: u[0] || (u[0] = It(
        (c) => {
          var f;
          o("closeAutoFocus", c), r.value || (f = k(i).triggerElement.value) == null || f.focus();
        },
        ["prevent"]
      )),
      onPointerDownOutside: u[1] || (u[1] = (c) => {
        o("pointerDownOutside", c);
        const f = c.detail.originalEvent, h = f.button === 0 && f.ctrlKey === !0, p = f.button === 2 || h;
        r.value = p;
      }),
      onFocusOutside: u[2] || (u[2] = It(() => {
      }, ["prevent"]))
    }), {
      default: B(() => [
        le(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), U_ = /* @__PURE__ */ H({
  __name: "PopoverContentNonModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = Va(), r = R(!1), s = R(!1), a = Ba(t, o);
    return (l, d) => (v(), V(R6, ze(k(a), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: d[0] || (d[0] = (u) => {
        var c;
        o("closeAutoFocus", u), u.defaultPrevented || (r.value || (c = k(i).triggerElement.value) == null || c.focus(), u.preventDefault()), r.value = !1, s.value = !1;
      }),
      onInteractOutside: d[1] || (d[1] = async (u) => {
        var c;
        o("interactOutside", u), u.defaultPrevented || (r.value = !0, u.detail.originalEvent.type === "pointerdown" && (s.value = !0));
        const f = u.target;
        (c = k(i).triggerElement.value) != null && c.contains(f) && u.preventDefault(), u.detail.originalEvent.type === "focusin" && s.value && u.preventDefault();
      })
    }), {
      default: B(() => [
        le(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), is = /* @__PURE__ */ H({
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = Va(), r = Ba(t, o), { forwardRef: s } = Ce();
    return i.contentId || (i.contentId = Kn(void 0, "radix-vue-popover-content")), (a, l) => (v(), V(k(bs), {
      present: a.forceMount || k(i).open.value
    }, {
      default: B(() => [
        k(i).modal.value ? (v(), V(W_, ze({ key: 0 }, k(r), { ref: k(s) }), {
          default: B(() => [
            le(a.$slots, "default")
          ]),
          _: 3
        }, 16)) : (v(), V(U_, ze({ key: 1 }, k(r), { ref: k(s) }), {
          default: B(() => [
            le(a.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
});
function K_() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
K_();
const [V1, G_] = Rt("TagsInputRoot"), Y_ = /* @__PURE__ */ H({
  __name: "TagsInputRoot",
  props: {
    modelValue: {},
    defaultValue: { default: () => [] },
    addOnPaste: { type: Boolean },
    addOnTab: { type: Boolean },
    addOnBlur: { type: Boolean },
    duplicate: { type: Boolean },
    disabled: { type: Boolean },
    delimiter: { default: "," },
    dir: {},
    max: { default: 0 },
    required: { type: Boolean },
    name: {},
    id: {},
    convertValue: {},
    displayValue: { type: Function, default: (n) => n.toString() },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "invalid"],
  setup(n, { emit: e }) {
    const t = n, o = e, { addOnPaste: i, disabled: r, delimiter: s, max: a, id: l, dir: d, addOnBlur: u, addOnTab: c } = Zn(t), f = I1(d), h = Hn(t, "modelValue", o, {
      defaultValue: t.defaultValue,
      passive: !0,
      deep: !0
    }), { forwardRef: p, currentElement: m } = Ce(), { focused: g } = eS(m), b = w6(m), { getItems: x } = N6(), w = R(), M = R(!1);
    return G_({
      modelValue: h,
      onAddValue: ($) => {
        const T = h.value.length > 0 && typeof h.value[0] == "object", E = h.value.length > 0 && typeof t.defaultValue[0] == "object";
        if ((T || E) && typeof t.convertValue != "function")
          throw new Error("You must provide a `convertValue` function when using objects as values.");
        const S = t.convertValue ? t.convertValue($) : $;
        if (h.value.length >= a.value && a.value)
          return o("invalid", S), !1;
        if (t.duplicate)
          return h.value.push(S), !0;
        if (h.value.includes(S))
          M.value = !0;
        else
          return h.value.push(S), !0;
        return o("invalid", S), !1;
      },
      onRemoveValue: ($) => {
        $ !== -1 && h.value.splice($, 1);
      },
      onInputKeydown: ($) => {
        const T = $.target, E = x().map((D) => D.ref).filter((D) => D.dataset.disabled !== "");
        if (!E.length)
          return;
        const S = E.at(-1);
        switch ($.key) {
          case "Delete":
          case "Backspace": {
            if (T.selectionStart !== 0 || T.selectionEnd !== 0)
              break;
            if (w.value) {
              const D = E.findIndex((I) => I === w.value);
              h.value.splice(D, 1), w.value = w.value === S ? E.at(D - 1) : E.at(D + 1), $.preventDefault();
            } else $.key === "Backspace" && (w.value = S, $.preventDefault());
            break;
          }
          case "Home":
          case "End":
          case "ArrowRight":
          case "ArrowLeft": {
            const D = $.key === "ArrowRight" && f.value === "ltr" || $.key === "ArrowLeft" && f.value === "rtl", I = !D;
            if (T.selectionStart !== 0 || T.selectionEnd !== 0)
              break;
            if (I && !w.value)
              w.value = S, $.preventDefault();
            else if (D && S && w.value === S)
              w.value = void 0, $.preventDefault();
            else if (w.value) {
              const z = x6($, w.value, void 0, {
                itemsArray: E,
                loop: !1,
                dir: f.value
              });
              z && (w.value = z), $.preventDefault();
            }
            break;
          }
          case "ArrowUp":
          case "ArrowDown": {
            w.value && $.preventDefault();
            break;
          }
          default:
            w.value = void 0;
        }
      },
      selectedElement: w,
      isInvalidInput: M,
      addOnPaste: i,
      addOnBlur: u,
      addOnTab: c,
      dir: f,
      disabled: r,
      delimiter: s,
      max: a,
      id: l,
      displayValue: t.displayValue
    }), ($, T) => (v(), V(k(P6), null, {
      default: B(() => [
        U(k(Re), {
          ref: k(p),
          dir: k(f),
          as: $.as,
          "as-child": $.asChild,
          "data-invalid": M.value ? "" : void 0,
          "data-disabled": k(r) ? "" : void 0,
          "data-focused": k(g) ? "" : void 0
        }, {
          default: B(() => [
            le($.$slots, "default", { modelValue: k(h) }),
            k(b) && $.name ? (v(), V(k(D6), {
              key: 0,
              name: $.name,
              value: k(h),
              required: $.required,
              disabled: k(r)
            }, null, 8, ["name", "value", "required", "disabled"])) : _("", !0)
          ]),
          _: 3
        }, 8, ["dir", "as", "as-child", "data-invalid", "data-disabled", "data-focused"])
      ]),
      _: 3
    }));
  }
}), q_ = /* @__PURE__ */ H({
  __name: "TagsInputInput",
  props: {
    placeholder: {},
    autoFocus: { type: Boolean },
    maxLength: {},
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(n) {
    const e = n, t = V1(), { forwardRef: o, currentElement: i } = Ce();
    function r(u) {
      if (!t.addOnBlur.value)
        return;
      const c = u.target;
      c.value && t.onAddValue(c.value) && (c.value = "");
    }
    function s(u) {
      t.addOnTab.value && a(u);
    }
    async function a(u) {
      if (await Ve(), u.defaultPrevented)
        return;
      const c = u.target;
      c.value && (t.onAddValue(c.value) && (c.value = ""), u.preventDefault());
    }
    function l(u) {
      t.isInvalidInput.value = !1;
      const c = t.delimiter.value;
      if (c === u.data) {
        const f = u.target;
        f.value = f.value.replaceAll(c, ""), t.onAddValue(f.value) && (f.value = "");
      }
    }
    function d(u) {
      if (t.addOnPaste.value) {
        u.preventDefault();
        const c = u.clipboardData;
        if (!c)
          return;
        const f = c.getData("text");
        t.delimiter.value ? f.split(t.delimiter.value).forEach((h) => {
          t.onAddValue(h);
        }) : t.onAddValue(f);
      }
    }
    return We(() => {
      const u = i.value.nodeName === "INPUT" ? i.value : i.value.querySelector("input");
      u && setTimeout(() => {
        e.autoFocus && (u == null || u.focus());
      }, 1);
    }), (u, c) => {
      var f;
      return v(), V(k(Re), {
        id: (f = k(t).id) == null ? void 0 : f.value,
        ref: k(o),
        type: "text",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        as: u.as,
        "as-child": u.asChild,
        maxlength: u.maxLength,
        placeholder: u.placeholder,
        disabled: k(t).disabled.value,
        "data-invalid": k(t).isInvalidInput.value ? "" : void 0,
        onInput: l,
        onKeydown: [
          Zt(a, ["enter"]),
          Zt(s, ["tab"]),
          k(t).onInputKeydown
        ],
        onBlur: r,
        onPaste: d
      }, {
        default: B(() => [
          le(u.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "as", "as-child", "maxlength", "placeholder", "disabled", "data-invalid", "onKeydown"]);
    };
  }
}), [F6, Z_] = Rt("TagsInputItem"), J_ = /* @__PURE__ */ H({
  __name: "TagsInputItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { value: t } = Zn(e), o = V1(), { forwardRef: i, currentElement: r } = Ce(), s = L(() => o.selectedElement.value === r.value), a = L(() => e.disabled || o.disabled.value), l = Z_({
      value: t,
      isSelected: s,
      disabled: a,
      textId: "",
      displayValue: L(() => o.displayValue(t.value))
    });
    return (d, u) => (v(), V(k(L6), null, {
      default: B(() => [
        U(k(Re), {
          ref: k(i),
          as: d.as,
          "as-child": d.asChild,
          "aria-labelledby": k(l).textId,
          "aria-current": s.value,
          "data-disabled": a.value ? "" : void 0,
          "data-state": s.value ? "active" : "inactive"
        }, {
          default: B(() => [
            le(d.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child", "aria-labelledby", "aria-current", "data-disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), X_ = /* @__PURE__ */ H({
  __name: "TagsInputItemText",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = n, t = F6();
    return Ce(), t.textId || (t.textId = Kn(void 0, "radix-vue-tags-input-item-text")), (o, i) => (v(), V(k(Re), ze(e, {
      id: k(t).textId
    }), {
      default: B(() => [
        le(o.$slots, "default", {}, () => [
          Se(j(k(t).displayValue.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), Q_ = /* @__PURE__ */ H({
  __name: "TagsInputItemDelete",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    Ce();
    const t = V1(), o = F6(), i = L(() => {
      var s;
      return ((s = o.disabled) == null ? void 0 : s.value) || t.disabled.value;
    });
    function r() {
      if (i.value)
        return;
      const s = t.modelValue.value.findIndex((a) => a === o.value.value);
      t.onRemoveValue(s);
    }
    return (s, a) => (v(), V(k(Re), ze({ tabindex: "-1" }, e, {
      "aria-labelledby": k(o).textId,
      "aria-current": k(o).isSelected.value,
      "data-state": k(o).isSelected.value ? "active" : "inactive",
      "data-disabled": i.value ? "" : void 0,
      type: s.as === "button" ? "button" : void 0,
      onClick: r
    }), {
      default: B(() => [
        le(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby", "aria-current", "data-state", "data-disabled", "type"]));
  }
}), B6 = "tooltip.open", [z1, eE] = Rt("TooltipProvider"), tE = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "TooltipProvider",
  props: {
    delayDuration: { default: 700 },
    skipDelayDuration: { default: 300 },
    disableHoverableContent: { type: Boolean, default: !1 },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, { delayDuration: t, skipDelayDuration: o, disableHoverableContent: i, disableClosingTrigger: r, ignoreNonKeyboardFocus: s, disabled: a } = Zn(e);
    Ce();
    const l = R(!0), d = R(!1), { start: u, stop: c } = v6(() => {
      l.value = !0;
    }, o, { immediate: !1 });
    return eE({
      isOpenDelayed: l,
      delayDuration: t,
      onOpen() {
        c(), l.value = !1;
      },
      onClose() {
        u();
      },
      isPointerInTransitRef: d,
      disableHoverableContent: i,
      disableClosingTrigger: r,
      disabled: a,
      ignoreNonKeyboardFocus: s
    }), (f, h) => le(f.$slots, "default");
  }
}), [Cu, nE] = Rt("TooltipRoot"), oE = /* @__PURE__ */ H({
  __name: "TooltipRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    delayDuration: { default: void 0 },
    disableHoverableContent: { type: Boolean, default: void 0 },
    disableClosingTrigger: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    ignoreNonKeyboardFocus: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, o = e;
    Ce();
    const i = z1(), r = L(() => t.disableHoverableContent ?? i.disableHoverableContent.value), s = L(() => t.disableClosingTrigger ?? i.disableClosingTrigger.value), a = L(() => t.disabled ?? i.disabled.value), l = L(() => t.delayDuration ?? i.delayDuration.value), d = L(() => t.ignoreNonKeyboardFocus ?? i.ignoreNonKeyboardFocus.value), u = Hn(t, "open", o, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    });
    Ee(u, (w) => {
      i.onClose && (w ? (i.onOpen(), document.dispatchEvent(new CustomEvent(B6))) : i.onClose());
    });
    const c = R(!1), f = R(), h = L(() => u.value ? c.value ? "delayed-open" : "instant-open" : "closed"), { start: p, stop: m } = v6(() => {
      c.value = !0, u.value = !0;
    }, l, { immediate: !1 });
    function g() {
      m(), c.value = !1, u.value = !0;
    }
    function b() {
      m(), u.value = !1;
    }
    function x() {
      p();
    }
    return nE({
      contentId: "",
      open: u,
      stateAttribute: h,
      trigger: f,
      onTriggerChange(w) {
        f.value = w;
      },
      onTriggerEnter() {
        i.isOpenDelayed.value ? x() : g();
      },
      onTriggerLeave() {
        r.value ? b() : m();
      },
      onOpen: g,
      onClose: b,
      disableHoverableContent: r,
      disableClosingTrigger: s,
      disabled: a,
      ignoreNonKeyboardFocus: d
    }), (w, M) => (v(), V(k(R1), null, {
      default: B(() => [
        le(w.$slots, "default", { open: k(u) })
      ]),
      _: 3
    }));
  }
}), iE = /* @__PURE__ */ H({
  __name: "TooltipTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = Cu(), o = z1();
    t.contentId || (t.contentId = Kn(void 0, "radix-vue-tooltip-content"));
    const { forwardRef: i, currentElement: r } = Ce(), s = R(!1), a = R(!1), l = L(() => t.disabled.value ? {} : {
      click: m,
      focus: h,
      pointermove: c,
      pointerleave: f,
      pointerdown: u,
      blur: p
    });
    We(() => {
      t.onTriggerChange(r.value);
    });
    function d() {
      setTimeout(() => {
        s.value = !1;
      }, 1);
    }
    function u() {
      s.value = !0, document.addEventListener("pointerup", d, { once: !0 });
    }
    function c(g) {
      g.pointerType !== "touch" && !a.value && !o.isPointerInTransitRef.value && (t.onTriggerEnter(), a.value = !0);
    }
    function f() {
      t.onTriggerLeave(), a.value = !1;
    }
    function h(g) {
      var b, x;
      s.value || t.ignoreNonKeyboardFocus.value && !((x = (b = g.target).matches) != null && x.call(b, ":focus-visible")) || t.onOpen();
    }
    function p() {
      t.onClose();
    }
    function m() {
      t.disableClosingTrigger.value || t.onClose();
    }
    return (g, b) => (v(), V(k(F1), { "as-child": "" }, {
      default: B(() => [
        U(k(Re), ze({
          ref: k(i),
          "aria-describedby": k(t).open.value ? k(t).contentId : void 0,
          "data-state": k(t).stateAttribute.value,
          as: g.as,
          "as-child": e.asChild,
          "data-grace-area-trigger": ""
        }, hv(l.value)), {
          default: B(() => [
            le(g.$slots, "default")
          ]),
          _: 3
        }, 16, ["aria-describedby", "data-state", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), V6 = /* @__PURE__ */ H({
  __name: "TooltipContentImpl",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: { default: 0 },
    align: { default: "center" },
    alignOffset: {},
    avoidCollisions: { type: Boolean, default: !0 },
    collisionBoundary: { default: () => [] },
    collisionPadding: { default: 0 },
    arrowPadding: { default: 0 },
    sticky: { default: "partial" },
    hideWhenDetached: { type: Boolean, default: !1 }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = Cu(), { forwardRef: r } = Ce(), s = pv(), a = L(() => {
      var u;
      return (u = s.default) == null ? void 0 : u.call(s);
    }), l = L(() => {
      var u;
      if (t.ariaLabel)
        return t.ariaLabel;
      let c = "";
      function f(h) {
        typeof h.children == "string" && h.type !== T2 ? c += h.children : Array.isArray(h.children) && h.children.forEach((p) => f(p));
      }
      return (u = a.value) == null || u.forEach((h) => f(h)), c;
    }), d = L(() => {
      const { ariaLabel: u, ...c } = t;
      return c;
    });
    return We(() => {
      Qr(window, "scroll", (u) => {
        const c = u.target;
        c != null && c.contains(i.trigger.value) && i.onClose();
      }), Qr(window, B6, i.onClose);
    }), (u, c) => (v(), V(k(yu), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: c[0] || (c[0] = (f) => o("escapeKeyDown", f)),
      onPointerDownOutside: c[1] || (c[1] = (f) => {
        var h;
        k(i).disableClosingTrigger.value && (h = k(i).trigger.value) != null && h.contains(f.target) && f.preventDefault(), o("pointerDownOutside", f);
      }),
      onFocusOutside: c[2] || (c[2] = It(() => {
      }, ["prevent"])),
      onDismiss: c[3] || (c[3] = (f) => k(i).onClose())
    }, {
      default: B(() => [
        U(k(ed), ze({
          ref: k(r),
          "data-state": k(i).stateAttribute.value
        }, { ...u.$attrs, ...d.value }, { style: {
          "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
          "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
          "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        } }), {
          default: B(() => [
            le(u.$slots, "default"),
            U(k(I6), {
              id: k(i).contentId,
              role: "tooltip"
            }, {
              default: B(() => [
                Se(j(l.value), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 3
        }, 16, ["data-state"])
      ]),
      _: 3
    }));
  }
}), rE = /* @__PURE__ */ H({
  __name: "TooltipContentHoverable",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  setup(n) {
    const e = vu(n), { forwardRef: t, currentElement: o } = Ce(), { trigger: i, onClose: r } = Cu(), s = z1(), { isPointerInTransit: a, onPointerExit: l } = lS(i, o);
    return s.isPointerInTransitRef = a, l(() => {
      r();
    }), (d, u) => (v(), V(V6, ze({ ref: k(t) }, k(e)), {
      default: B(() => [
        le(d.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), sE = /* @__PURE__ */ H({
  __name: "TooltipContent",
  props: {
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = Cu(), r = Ba(t, o), { forwardRef: s } = Ce();
    return (a, l) => (v(), V(k(bs), {
      present: a.forceMount || k(i).open.value
    }, {
      default: B(() => [
        (v(), V(qr(k(i).disableHoverableContent.value ? V6 : rE), ze({ ref: k(s) }, k(r)), {
          default: B(() => [
            le(a.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), aE = /* @__PURE__ */ H({
  __name: "TooltipPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, o) => (v(), V(k(L1), Ra(su(e)), {
      default: B(() => [
        le(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), lE = { class: "w-full" }, dE = {
  key: 0,
  class: "mb-1.5"
}, uE = {
  key: 0,
  class: "flex items-start"
}, cE = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, fE = { class: "relative w-full" }, hE = ["disabled", "aria-label"], pE = ["id", "value", "aria-label", "required", "disabled", "placeholder", "aria-invalid"], mE = { class: "time-picker-heading" }, gE = ["aria-label"], vE = ["aria-pressed", "aria-label", "onClick"], bE = {
  class: "time-picker-minutes",
  role: "group",
  "aria-label": "Minutes"
}, yE = ["aria-pressed", "aria-label", "onClick"], iY = /* @__PURE__ */ H({
  __name: "FieldTimePicker",
  props: {
    modelValue: { default: null },
    locale: { default: "en" },
    id: { default: null },
    label: { default: null },
    description: { default: null },
    placeholder: { default: null },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = R(!1), r = R(!1), s = Array.from({ length: 24 }, (h, p) => String(p).padStart(2, "0")), a = ["00", "15", "30", "45"], l = L(() => /^([01]\d|2[0-3]):([0-5]\d)$/.exec(t.modelValue || "")), d = L(() => t.locale === "fr" ? "Heures" : "Hours"), u = (h) => {
      var p;
      return o("update:modelValue", `${h}:${((p = l.value) == null ? void 0 : p[2]) || "00"}`);
    }, c = (h) => {
      var p;
      o("update:modelValue", `${((p = l.value) == null ? void 0 : p[1]) || "10"}:${h}`), i.value = !1;
    }, f = (h) => o("update:modelValue", h.target.value);
    return (h, p) => {
      var m, g;
      return v(), C("div", lE, [
        n.label || n.description ? (v(), C("div", dE, [
          n.label ? (v(), C("div", uE, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", cE, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        U(k(es), {
          open: i.value,
          "onUpdate:open": p[5] || (p[5] = (b) => i.value = b)
        }, {
          default: B(() => {
            var b, x, w, M;
            return [
              y("div", fE, [
                U(k(ts), { "as-child": "" }, {
                  default: B(() => [
                    y("button", {
                      type: "button",
                      disabled: n.disabled,
                      "aria-label": n.label || d.value,
                      onClick: p[0] || (p[0] = ($) => r.value = !0),
                      class: "absolute inset-y-0 left-0 flex w-9 items-center justify-center rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#444ce7]"
                    }, [
                      U(ye, {
                        icon: "clock",
                        color: "var(--color-foreground-default)"
                      })
                    ], 8, hE)
                  ]),
                  _: 1
                }),
                y("input", {
                  id: `${n.id}`,
                  value: n.modelValue || "",
                  "aria-label": n.label || void 0,
                  required: n.required,
                  disabled: n.disabled,
                  placeholder: n.placeholder || "HH:mm",
                  "aria-invalid": (x = (b = n.validation) == null ? void 0 : b.$errors) != null && x.length ? !0 : void 0,
                  maxlength: "5",
                  inputmode: "numeric",
                  autocomplete: "off",
                  class: J([
                    "box-border block w-full rounded-[4.16px] border bg-white py-2.5 pl-9 pr-3 text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle focus:ring-2 disabled:opacity-50",
                    (M = (w = n.validation) == null ? void 0 : w.$errors) != null && M.length ? "border-border-danger-emphasis focus:ring-border-danger-emphasis" : "border-border-default focus:border-border-brand-emphasis focus:ring-border-brand-default"
                  ]),
                  onInput: f,
                  onClick: p[1] || (p[1] = ($) => {
                    r.value = !1, i.value = !0;
                  }),
                  onKeydown: [
                    p[2] || (p[2] = Zt(It(($) => {
                      r.value = !0, i.value = !0;
                    }, ["prevent"]), ["down"])),
                    p[3] || (p[3] = Zt(($) => i.value = !1, ["esc"]))
                  ]
                }, null, 42, pE)
              ]),
              U(k(ns), null, {
                default: B(() => [
                  U(k(is), {
                    side: "bottom",
                    align: "start",
                    "side-offset": 6,
                    "collision-padding": 12,
                    class: "magma-time-picker",
                    "aria-label": n.label || d.value,
                    onOpenAutoFocus: p[4] || (p[4] = ($) => {
                      r.value || $.preventDefault();
                    })
                  }, {
                    default: B(() => [
                      y("div", mE, j(d.value), 1),
                      y("div", {
                        class: "time-picker-hours",
                        role: "group",
                        "aria-label": d.value
                      }, [
                        (v(!0), C(re, null, De(k(s), ($) => {
                          var T;
                          return v(), C("button", {
                            key: $,
                            type: "button",
                            class: "time-picker-choice",
                            "aria-pressed": ((T = l.value) == null ? void 0 : T[1]) === $,
                            "aria-label": `${d.value} ${$}`,
                            onClick: (E) => u($)
                          }, j($), 9, vE);
                        }), 128))
                      ], 8, gE),
                      p[6] || (p[6] = y("div", { class: "time-picker-heading time-picker-minutes-heading" }, "Minutes", -1)),
                      y("div", bE, [
                        (v(), C(re, null, De(a, ($) => {
                          var T;
                          return y("button", {
                            key: $,
                            type: "button",
                            class: "time-picker-choice",
                            "aria-pressed": ((T = l.value) == null ? void 0 : T[2]) === $,
                            "aria-label": `Minutes ${$}`,
                            onClick: (E) => c($)
                          }, j($), 9, yE);
                        }), 64))
                      ])
                    ]),
                    _: 1
                  }, 8, ["aria-label"])
                ]),
                _: 1
              })
            ];
          }),
          _: 1
        }, 8, ["open"]),
        n.validation && ((m = n.validation.$errors) != null && m.length) ? (v(), V(_e, {
          key: 1,
          class: "mt-[3px]",
          label: (g = n.validation.$errors[0]) == null ? void 0 : g.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ]);
    };
  }
});
function Bt(n) {
  this.content = n;
}
Bt.prototype = {
  constructor: Bt,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var o = t && t != n ? this.remove(t) : this, i = o.find(n), r = o.content.slice();
    return i == -1 ? r.push(t || n, e) : (r[i + 1] = e, t && (r[i] = t)), new Bt(r);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Bt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Bt([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Bt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var o = this.remove(e), i = o.content.slice(), r = o.find(n);
    return i.splice(r == -1 ? i.length : r, 0, e, t), new Bt(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Bt.from(n), n.size ? new Bt(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Bt.from(n), n.size ? new Bt(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Bt.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Bt.from = function(n) {
  if (n instanceof Bt) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Bt(e);
};
function z6(n, e, t) {
  for (let o = 0; ; o++) {
    if (o == n.childCount || o == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let i = n.child(o), r = e.child(o);
    if (i == r) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(r))
      return t;
    if (i.isText && i.text != r.text) {
      for (let s = 0; i.text[s] == r.text[s]; s++)
        t++;
      return t;
    }
    if (i.content.size || r.content.size) {
      let s = z6(i.content, r.content, t + 1);
      if (s != null)
        return s;
    }
    t += i.nodeSize;
  }
}
function H6(n, e, t, o) {
  for (let i = n.childCount, r = e.childCount; ; ) {
    if (i == 0 || r == 0)
      return i == r ? null : { a: t, b: o };
    let s = n.child(--i), a = e.child(--r), l = s.nodeSize;
    if (s == a) {
      t -= l, o -= l;
      continue;
    }
    if (!s.sameMarkup(a))
      return { a: t, b: o };
    if (s.isText && s.text != a.text) {
      let d = 0, u = Math.min(s.text.length, a.text.length);
      for (; d < u && s.text[s.text.length - d - 1] == a.text[a.text.length - d - 1]; )
        d++, t--, o--;
      return { a: t, b: o };
    }
    if (s.content.size || a.content.size) {
      let d = H6(s.content, a.content, t - 1, o - 1);
      if (d)
        return d;
    }
    t -= l, o -= l;
  }
}
class Q {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let o = 0; o < e.length; o++)
        this.size += e[o].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, o, i = 0, r) {
    for (let s = 0, a = 0; a < t; s++) {
      let l = this.content[s], d = a + l.nodeSize;
      if (d > e && o(l, i + a, r || null, s) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), o, i + u);
      }
      a = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, o, i) {
    let r = "", s = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let d = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && d || a.isTextblock) && o && (s ? s = !1 : r += o), r += d;
    }, 0), r;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, o = e.firstChild, i = this.content.slice(), r = 0;
    for (t.isText && t.sameMarkup(o) && (i[i.length - 1] = t.withText(t.text + o.text), r = 1); r < e.content.length; r++)
      i.push(e.content[r]);
    return new Q(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let o = [], i = 0;
    if (t > e)
      for (let r = 0, s = 0; s < t; r++) {
        let a = this.content[r], l = s + a.nodeSize;
        l > e && ((s < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - s), Math.min(a.text.length, t - s)) : a = a.cut(Math.max(0, e - s - 1), Math.min(a.content.size, t - s - 1))), o.push(a), i += a.nodeSize), s = l;
      }
    return new Q(o, i);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? Q.empty : e == 0 && t == this.content.length ? this : new Q(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let o = this.content[e];
    if (o == t)
      return this;
    let i = this.content.slice(), r = this.size + t.nodeSize - o.nodeSize;
    return i[e] = t, new Q(i, r);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new Q([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new Q(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, o = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, o, t), o += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return z6(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, o = e.size) {
    return H6(this, e, t, o);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return il(0, e);
    if (e == this.size)
      return il(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, o = 0; ; t++) {
      let i = this.child(t), r = o + i.nodeSize;
      if (r >= e)
        return r == e ? il(t + 1, r) : il(t, o);
      o = r;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Q.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Q(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return Q.empty;
    let t, o = 0;
    for (let i = 0; i < e.length; i++) {
      let r = e[i];
      o += r.nodeSize, i && r.isText && e[i - 1].sameMarkup(r) ? (t || (t = e.slice(0, i)), t[t.length - 1] = r.withText(t[t.length - 1].text + r.text)) : t && t.push(r);
    }
    return new Q(t || e, o);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return Q.empty;
    if (e instanceof Q)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new Q([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Q.empty = new Q([], 0);
const rc = { index: 0, offset: 0 };
function il(n, e) {
  return rc.index = n, rc.offset = e, rc;
}
function td(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let o = 0; o < n.length; o++)
      if (!td(n[o], e[o]))
        return !1;
  } else {
    for (let o in n)
      if (!(o in e) || !td(n[o], e[o]))
        return !1;
    for (let o in e)
      if (!(o in n))
        return !1;
  }
  return !0;
}
let ot = class mf {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, o = !1;
    for (let i = 0; i < e.length; i++) {
      let r = e[i];
      if (this.eq(r))
        return e;
      if (this.type.excludes(r.type))
        t || (t = e.slice(0, i));
      else {
        if (r.type.excludes(this.type))
          return e;
        !o && r.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), o = !0), t && t.push(r);
      }
    }
    return t || (t = e.slice()), o || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && td(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let o = e.marks[t.type];
    if (!o)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let i = o.create(t.attrs);
    return o.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let o = 0; o < e.length; o++)
      if (!e[o].eq(t[o]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return mf.none;
    if (e instanceof mf)
      return [e];
    let t = e.slice();
    return t.sort((o, i) => o.type.rank - i.type.rank), t;
  }
};
ot.none = [];
class nd extends Error {
}
class he {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, o) {
    this.content = e, this.openStart = t, this.openEnd = o;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let o = W6(this.content, e + this.openStart, t);
    return o && new he(o, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new he(j6(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return he.empty;
    let o = t.openStart || 0, i = t.openEnd || 0;
    if (typeof o != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new he(Q.fromJSON(e, t.content), o, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let o = 0, i = 0;
    for (let r = e.firstChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.firstChild)
      o++;
    for (let r = e.lastChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.lastChild)
      i++;
    return new he(e, o, i);
  }
}
he.empty = new he(Q.empty, 0, 0);
function j6(n, e, t) {
  let { index: o, offset: i } = n.findIndex(e), r = n.maybeChild(o), { index: s, offset: a } = n.findIndex(t);
  if (i == e || r.isText) {
    if (a != t && !n.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (o != s)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(o, r.copy(j6(r.content, e - i - 1, t - i - 1)));
}
function W6(n, e, t, o) {
  let { index: i, offset: r } = n.findIndex(e), s = n.maybeChild(i);
  if (r == e || s.isText)
    return o && !o.canReplace(i, i, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = W6(s.content, e - r - 1, t, s);
  return a && n.replaceChild(i, s.copy(a));
}
function xE(n, e, t) {
  if (t.openStart > n.depth)
    throw new nd("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new nd("Inconsistent open depths");
  return U6(n, e, t, 0);
}
function U6(n, e, t, o) {
  let i = n.index(o), r = n.node(o);
  if (i == e.index(o) && o < n.depth - t.openStart) {
    let s = U6(n, e, t, o + 1);
    return r.copy(r.content.replaceChild(i, s));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == o && e.depth == o) {
      let s = n.parent, a = s.content;
      return er(s, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: s, end: a } = CE(t, n);
      return er(r, G6(n, s, a, e, o));
    }
  else return er(r, od(n, e, o));
}
function K6(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new nd("Cannot join " + e.type.name + " onto " + n.type.name);
}
function gf(n, e, t) {
  let o = n.node(t);
  return K6(o, e.node(t)), o;
}
function Qi(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function Ys(n, e, t, o) {
  let i = (e || n).node(t), r = 0, s = e ? e.index(t) : i.childCount;
  n && (r = n.index(t), n.depth > t ? r++ : n.textOffset && (Qi(n.nodeAfter, o), r++));
  for (let a = r; a < s; a++)
    Qi(i.child(a), o);
  e && e.depth == t && e.textOffset && Qi(e.nodeBefore, o);
}
function er(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function G6(n, e, t, o, i) {
  let r = n.depth > i && gf(n, e, i + 1), s = o.depth > i && gf(t, o, i + 1), a = [];
  return Ys(null, n, i, a), r && s && e.index(i) == t.index(i) ? (K6(r, s), Qi(er(r, G6(n, e, t, o, i + 1)), a)) : (r && Qi(er(r, od(n, e, i + 1)), a), Ys(e, t, i, a), s && Qi(er(s, od(t, o, i + 1)), a)), Ys(o, null, i, a), new Q(a);
}
function od(n, e, t) {
  let o = [];
  if (Ys(null, n, t, o), n.depth > t) {
    let i = gf(n, e, t + 1);
    Qi(er(i, od(n, e, t + 1)), o);
  }
  return Ys(e, null, t, o), new Q(o);
}
function CE(n, e) {
  let t = e.depth - n.openStart, i = e.node(t).copy(n.content);
  for (let r = t - 1; r >= 0; r--)
    i = e.node(r).copy(Q.from(i));
  return {
    start: i.resolveNoCache(n.openStart + t),
    end: i.resolveNoCache(i.content.size - n.openEnd - t)
  };
}
class va {
  /**
  @internal
  */
  constructor(e, t, o) {
    this.pos = e, this.path = t, this.parentOffset = o, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let o = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return o ? e.child(t).cut(o) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let o = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let r = 0; r < e; r++)
      i += o.child(r).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return ot.none;
    if (this.textOffset)
      return e.child(t).marks;
    let o = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!o) {
      let a = o;
      o = i, i = a;
    }
    let r = o.marks;
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let o = t.marks, i = e.parent.maybeChild(e.index());
    for (var r = 0; r < o.length; r++)
      o[r].type.spec.inclusive === !1 && (!i || !o[r].isInSet(i.marks)) && (o = o[r--].removeFromSet(o));
    return o;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let o = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); o >= 0; o--)
      if (e.pos <= this.end(o) && (!t || t(this.node(o))))
        return new id(this, e, o);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let o = [], i = 0, r = t;
    for (let s = e; ; ) {
      let { index: a, offset: l } = s.content.findIndex(r), d = r - l;
      if (o.push(s, a, i + l), !d || (s = s.child(a), s.isText))
        break;
      r = d - 1, i += l + 1;
    }
    return new va(t, o, r);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let o = e3.get(e);
    if (o)
      for (let r = 0; r < o.elts.length; r++) {
        let s = o.elts[r];
        if (s.pos == t)
          return s;
      }
    else
      e3.set(e, o = new wE());
    let i = o.elts[o.i] = va.resolve(e, t);
    return o.i = (o.i + 1) % kE, i;
  }
}
class wE {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const kE = 12, e3 = /* @__PURE__ */ new WeakMap();
class id {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, o) {
    this.$from = e, this.$to = t, this.depth = o;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const $E = /* @__PURE__ */ Object.create(null);
let gi = class vf {
  /**
  @internal
  */
  constructor(e, t, o, i = ot.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = o || Q.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, o, i = 0) {
    this.content.nodesBetween(e, t, o, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, o, i) {
    return this.content.textBetween(e, t, o, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, o) {
    return this.type == e && td(this.attrs, t || e.defaultAttrs || $E) && ot.sameSet(this.marks, o || ot.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new vf(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new vf(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, o = !1) {
    if (e == t)
      return he.empty;
    let i = this.resolve(e), r = this.resolve(t), s = o ? 0 : i.sharedDepth(t), a = i.start(s), d = i.node(s).content.cut(i.pos - a, r.pos - a);
    return new he(d, i.depth - s, r.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, o) {
    return xE(this.resolve(e), this.resolve(t), o);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: o, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(o), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: o } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: o };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: o } = this.content.findIndex(e);
    if (o < e)
      return { node: this.content.child(t), index: t, offset: o };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: o - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return va.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return va.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, o) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (r) => (o.isInSet(r.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Y6(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, o = Q.empty, i = 0, r = o.childCount) {
    let s = this.contentMatchAt(e).matchFragment(o, i, r), a = s && s.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = i; l < r; l++)
      if (!this.type.allowsMarks(o.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, o, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let r = this.contentMatchAt(e).matchType(o), s = r && r.matchFragment(this.content, t);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = ot.none;
    for (let t = 0; t < this.marks.length; t++) {
      let o = this.marks[t];
      o.type.checkAttrs(o.attrs), e = o.addToSet(e);
    }
    if (!ot.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let o;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      o = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, o);
    }
    let i = Q.fromJSON(e, t.content), r = e.nodeType(t.type).create(t.attrs, i, o);
    return r.type.checkAttrs(r.attrs), r;
  }
};
gi.prototype.text = void 0;
class rd extends gi {
  /**
  @internal
  */
  constructor(e, t, o, i) {
    if (super(e, t, null, i), !o)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = o;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Y6(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new rd(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new rd(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Y6(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class lr {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let o = new ME(e, t);
    if (o.next == null)
      return lr.empty;
    let i = q6(o);
    o.next && o.err("Unexpected trailing text");
    let r = IE(AE(i));
    return DE(r, o), r;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, o = e.childCount) {
    let i = this;
    for (let r = t; i && r < o; r++)
      i = i.matchType(e.child(r).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let o = 0; o < e.next.length; o++)
        if (this.next[t].type == e.next[o].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, o = 0) {
    let i = [this];
    function r(s, a) {
      let l = s.matchFragment(e, o);
      if (l && (!t || l.validEnd))
        return Q.from(a.map((d) => d.createAndFill()));
      for (let d = 0; d < s.next.length; d++) {
        let { type: u, next: c } = s.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(c) == -1) {
          i.push(c);
          let f = r(c, a.concat(u));
          if (f)
            return f;
        }
      }
      return null;
    }
    return r(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let o = 0; o < this.wrapCache.length; o += 2)
      if (this.wrapCache[o] == e)
        return this.wrapCache[o + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), o = [{ match: this, type: null, via: null }];
    for (; o.length; ) {
      let i = o.shift(), r = i.match;
      if (r.matchType(e)) {
        let s = [];
        for (let a = i; a.type; a = a.via)
          s.push(a.type);
        return s.reverse();
      }
      for (let s = 0; s < r.next.length; s++) {
        let { type: a, next: l } = r.next[s];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!i.type || l.validEnd) && (o.push({ match: a.contentMatch, type: a, via: i }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(o) {
      e.push(o);
      for (let i = 0; i < o.next.length; i++)
        e.indexOf(o.next[i].next) == -1 && t(o.next[i].next);
    }
    return t(this), e.map((o, i) => {
      let r = i + (o.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < o.next.length; s++)
        r += (s ? ", " : "") + o.next[s].type.name + "->" + e.indexOf(o.next[s].next);
      return r;
    }).join(`
`);
  }
}
lr.empty = new lr(!0);
class ME {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function q6(n) {
  let e = [];
  do
    e.push(SE(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function SE(n) {
  let e = [];
  do
    e.push(_E(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function _E(n) {
  let e = TE(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = EE(n, e);
    else
      break;
  return e;
}
function t3(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function EE(n, e) {
  let t = t3(n), o = t;
  return n.eat(",") && (n.next != "}" ? o = t3(n) : o = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: o, expr: e };
}
function OE(n, e) {
  let t = n.nodeTypes, o = t[e];
  if (o)
    return [o];
  let i = [];
  for (let r in t) {
    let s = t[r];
    s.isInGroup(e) && i.push(s);
  }
  return i.length == 0 && n.err("No node type or group '" + e + "' found"), i;
}
function TE(n) {
  if (n.eat("(")) {
    let e = q6(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = OE(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function AE(n) {
  let e = [[]];
  return i(r(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function o(s, a, l) {
    let d = { term: l, to: a };
    return e[s].push(d), d;
  }
  function i(s, a) {
    s.forEach((l) => l.to = a);
  }
  function r(s, a) {
    if (s.type == "choice")
      return s.exprs.reduce((l, d) => l.concat(r(d, a)), []);
    if (s.type == "seq")
      for (let l = 0; ; l++) {
        let d = r(s.exprs[l], a);
        if (l == s.exprs.length - 1)
          return d;
        i(d, a = t());
      }
    else if (s.type == "star") {
      let l = t();
      return o(a, l), i(r(s.expr, l), l), [o(l)];
    } else if (s.type == "plus") {
      let l = t();
      return i(r(s.expr, a), l), i(r(s.expr, l), l), [o(l)];
    } else {
      if (s.type == "opt")
        return [o(a)].concat(r(s.expr, a));
      if (s.type == "range") {
        let l = a;
        for (let d = 0; d < s.min; d++) {
          let u = t();
          i(r(s.expr, l), u), l = u;
        }
        if (s.max == -1)
          i(r(s.expr, l), l);
        else
          for (let d = s.min; d < s.max; d++) {
            let u = t();
            o(l, u), i(r(s.expr, l), u), l = u;
          }
        return [o(l)];
      } else {
        if (s.type == "name")
          return [o(a, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Z6(n, e) {
  return e - n;
}
function n3(n, e) {
  let t = [];
  return o(e), t.sort(Z6);
  function o(i) {
    let r = n[i];
    if (r.length == 1 && !r[0].term)
      return o(r[0].to);
    t.push(i);
    for (let s = 0; s < r.length; s++) {
      let { term: a, to: l } = r[s];
      !a && t.indexOf(l) == -1 && o(l);
    }
  }
}
function IE(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(n3(n, 0));
  function t(o) {
    let i = [];
    o.forEach((s) => {
      n[s].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let d;
        for (let u = 0; u < i.length; u++)
          i[u][0] == a && (d = i[u][1]);
        n3(n, l).forEach((u) => {
          d || i.push([a, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let r = e[o.join(",")] = new lr(o.indexOf(n.length - 1) > -1);
    for (let s = 0; s < i.length; s++) {
      let a = i[s][1].sort(Z6);
      r.next.push({ type: i[s][0], next: e[a.join(",")] || t(a) });
    }
    return r;
  }
}
function DE(n, e) {
  for (let t = 0, o = [n]; t < o.length; t++) {
    let i = o[t], r = !i.validEnd, s = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: l, next: d } = i.next[a];
      s.push(l.name), r && !(l.isText || l.hasRequiredAttrs()) && (r = !1), o.indexOf(d) == -1 && o.push(d);
    }
    r && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function J6(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let o = n[t];
    if (!o.hasDefault)
      return null;
    e[t] = o.default;
  }
  return e;
}
function X6(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let o in n) {
    let i = e && e[o];
    if (i === void 0) {
      let r = n[o];
      if (r.hasDefault)
        i = r.default;
      else
        throw new RangeError("No value supplied for attribute " + o);
    }
    t[o] = i;
  }
  return t;
}
function Q6(n, e, t, o) {
  for (let i in e)
    if (!(i in n))
      throw new RangeError(`Unsupported attribute ${i} for ${t} of type ${i}`);
  for (let i in n) {
    let r = n[i];
    r.validate && r.validate(e[i]);
  }
}
function eg(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let o in e)
      t[o] = new PE(n, o, e[o]);
  return t;
}
let o3 = class tg {
  /**
  @internal
  */
  constructor(e, t, o) {
    this.name = e, this.schema = t, this.spec = o, this.markSet = null, this.groups = o.group ? o.group.split(" ") : [], this.attrs = eg(e, o.attrs), this.defaultAttrs = J6(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(o.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == lr.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : X6(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, o) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new gi(this, this.computeAttrs(e), Q.from(t), ot.setFrom(o));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, o) {
    return t = Q.from(t), this.checkContent(t), new gi(this, this.computeAttrs(e), t, ot.setFrom(o));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, o) {
    if (e = this.computeAttrs(e), t = Q.from(t), t.size) {
      let s = this.contentMatch.fillBefore(t);
      if (!s)
        return null;
      t = s.append(t);
    }
    let i = this.contentMatch.matchFragment(t), r = i && i.fillBefore(Q.empty, !0);
    return r ? new gi(this, e, t.append(r), ot.setFrom(o)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let o = 0; o < e.childCount; o++)
      if (!this.allowsMarks(e.child(o).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Q6(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let o = 0; o < e.length; o++)
      this.allowsMarkType(e[o].type) ? t && t.push(e[o]) : t || (t = e.slice(0, o));
    return t ? t.length ? t : ot.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let o = /* @__PURE__ */ Object.create(null);
    e.forEach((r, s) => o[r] = new tg(r, t, s));
    let i = t.spec.topNode || "doc";
    if (!o[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!o.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let r in o.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return o;
  }
};
function NE(n, e, t) {
  let o = t.split("|");
  return (i) => {
    let r = i === null ? "null" : typeof i;
    if (o.indexOf(r) < 0)
      throw new RangeError(`Expected value of type ${o} for attribute ${e} on type ${n}, got ${r}`);
  };
}
class PE {
  constructor(e, t, o) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(o, "default"), this.default = o.default, this.validate = typeof o.validate == "string" ? NE(e, t, o.validate) : o.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class wu {
  /**
  @internal
  */
  constructor(e, t, o, i) {
    this.name = e, this.rank = t, this.schema = o, this.spec = i, this.attrs = eg(e, i.attrs), this.excluded = null;
    let r = J6(this.attrs);
    this.instance = r ? new ot(this, r) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new ot(this, X6(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let o = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((r, s) => o[r] = new wu(r, i++, t, s)), o;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Q6(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class ng {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = Bt.from(e.nodes), t.marks = Bt.from(e.marks || {}), this.nodes = o3.compile(this.spec.nodes, this), this.marks = wu.compile(this.spec.marks, this);
    let o = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let r = this.nodes[i], s = r.spec.content || "", a = r.spec.marks;
      if (r.contentMatch = o[s] || (o[s] = lr.parse(s, this.nodes)), r.inlineContent = r.contentMatch.inlineContent, r.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!r.isInline || !r.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = r;
      }
      r.markSet = a == "_" ? null : a ? i3(this, a.split(" ")) : a == "" || !r.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let r = this.marks[i], s = r.spec.excludes;
      r.excluded = s == null ? [r] : s == "" ? [] : i3(this, s.split(" "));
    }
    this.nodeFromJSON = (i) => gi.fromJSON(this, i), this.markFromJSON = (i) => ot.fromJSON(this, i), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, o, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof o3) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, o, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let o = this.nodes.text;
    return new rd(o, o.defaultAttrs, e, ot.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function i3(n, e) {
  let t = [];
  for (let o = 0; o < e.length; o++) {
    let i = e[o], r = n.marks[i], s = r;
    if (r)
      t.push(r);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && t.push(s = l);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[o] + "'");
  }
  return t;
}
function LE(n) {
  return n.tag != null;
}
function RE(n) {
  return n.style != null;
}
class vi {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let o = this.matchedStyles = [];
    t.forEach((i) => {
      if (LE(i))
        this.tags.push(i);
      else if (RE(i)) {
        let r = /[^=]*/.exec(i.style)[0];
        o.indexOf(r) < 0 && o.push(r), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let r = e.nodes[i.node];
      return r.contentMatch.matchType(r);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let o = new s3(this, t, !1);
    return o.addAll(e, ot.none, t.from, t.to), o.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let o = new s3(this, t, !0);
    return o.addAll(e, ot.none, t.from, t.to), he.maxOpen(o.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, o) {
    for (let i = o ? this.tags.indexOf(o) + 1 : 0; i < this.tags.length; i++) {
      let r = this.tags[i];
      if (VE(e, r.tag) && (r.namespace === void 0 || e.namespaceURI == r.namespace) && (!r.context || t.matchesContext(r.context))) {
        if (r.getAttrs) {
          let s = r.getAttrs(e);
          if (s === !1)
            continue;
          r.attrs = s || void 0;
        }
        return r;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, o, i) {
    for (let r = i ? this.styles.indexOf(i) + 1 : 0; r < this.styles.length; r++) {
      let s = this.styles[r], a = s.style;
      if (!(a.indexOf(e) != 0 || s.context && !o.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (s.getAttrs) {
          let l = s.getAttrs(t);
          if (l === !1)
            continue;
          s.attrs = l || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function o(i) {
      let r = i.priority == null ? 50 : i.priority, s = 0;
      for (; s < t.length; s++) {
        let a = t[s];
        if ((a.priority == null ? 50 : a.priority) < r)
          break;
      }
      t.splice(s, 0, i);
    }
    for (let i in e.marks) {
      let r = e.marks[i].spec.parseDOM;
      r && r.forEach((s) => {
        o(s = a3(s)), s.mark || s.ignore || s.clearMark || (s.mark = i);
      });
    }
    for (let i in e.nodes) {
      let r = e.nodes[i].spec.parseDOM;
      r && r.forEach((s) => {
        o(s = a3(s)), s.node || s.ignore || s.mark || (s.node = i);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new vi(e, vi.schemaRules(e)));
  }
}
const og = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, FE = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, ig = { ol: !0, ul: !0 }, ba = 1, bf = 2, qs = 4;
function r3(n, e, t) {
  return e != null ? (e ? ba : 0) | (e === "full" ? bf : 0) : n && n.whitespace == "pre" ? ba | bf : t & ~qs;
}
class rl {
  constructor(e, t, o, i, r, s) {
    this.type = e, this.attrs = t, this.marks = o, this.solid = i, this.options = s, this.content = [], this.activeMarks = ot.none, this.match = r || (s & qs ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Q.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let o = this.type.contentMatch, i;
        return (i = o.findWrapping(e.type)) ? (this.match = o, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ba)) {
      let o = this.content[this.content.length - 1], i;
      if (o && o.isText && (i = /[ \t\r\n\u000c]+$/.exec(o.text))) {
        let r = o;
        o.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = r.withText(r.text.slice(0, r.text.length - i[0].length));
      }
    }
    let t = Q.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(Q.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !og.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class s3 {
  constructor(e, t, o) {
    this.parser = e, this.options = t, this.isOpen = o, this.open = 0, this.localPreserveWS = !1;
    let i = t.topNode, r, s = r3(null, t.preserveWhitespace, 0) | (o ? qs : 0);
    i ? r = new rl(i.type, i.attrs, ot.none, !0, t.topMatch || i.type.contentMatch, s) : o ? r = new rl(null, null, ot.none, !0, null, s) : r = new rl(e.schema.topNodeType, null, ot.none, !0, null, s), this.nodes = [r], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let o = e.nodeValue, i = this.top, r = i.options & bf ? "full" : this.localPreserveWS || (i.options & ba) > 0, { schema: s } = this.parser;
    if (r === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(o)) {
      if (r)
        if (r === "full")
          o = o.replace(/\r\n?/g, `
`);
        else if (s.linebreakReplacement && /[\r\n]/.test(o) && this.top.findWrapping(s.linebreakReplacement.create())) {
          let a = o.split(/\r?\n|\r/);
          for (let l = 0; l < a.length; l++)
            l && this.insertNode(s.linebreakReplacement.create(), t, !0), a[l] && this.insertNode(s.text(a[l]), t, !/\S/.test(a[l]));
          o = "";
        } else
          o = o.replace(/\r?\n|\r/g, " ");
      else if (o = o.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(o) && this.open == this.nodes.length - 1) {
        let a = i.content[i.content.length - 1], l = e.previousSibling;
        (!a || l && l.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (o = o.slice(1));
      }
      o && this.insertNode(s.text(o), t, !/\S/.test(o)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, o) {
    let i = this.localPreserveWS, r = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = e.nodeName.toLowerCase(), a;
    ig.hasOwnProperty(s) && this.parser.normalizeLists && BE(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, o));
    e: if (l ? l.ignore : FE.hasOwnProperty(s))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let d, u = this.needsBlock;
      if (og.hasOwnProperty(s))
        r.content.length && r.content[0].isInline && this.open && (this.open--, r = this.top), d = !0, r.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let c = l && l.skip ? t : this.readStyles(e, t);
      c && this.addAll(e, c), d && this.sync(r), this.needsBlock = u;
    } else {
      let d = this.readStyles(e, t);
      d && this.addElementByRule(e, l, d, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let o = e.style;
    if (o && o.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let r = this.parser.matchedStyles[i], s = o.getPropertyValue(r);
        if (s)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(r, s, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((d) => !l.clearMark(d)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, o, i) {
    let r, s;
    if (t.node)
      if (s = this.parser.schema.nodes[t.node], s.isLeaf)
        this.insertNode(s.create(t.attrs), o, e.nodeName == "BR") || this.leafFallback(e, o);
      else {
        let l = this.enter(s, t.attrs || null, o, t.preserveWhitespace);
        l && (r = !0, o = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      o = o.concat(l.create(t.attrs));
    }
    let a = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, o, i);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, o, !1));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, o), this.findAround(e, l, !1);
    }
    r && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, o, i) {
    let r = o || 0;
    for (let s = o ? e.childNodes[o] : e.firstChild, a = i == null ? null : e.childNodes[i]; s != a; s = s.nextSibling, ++r)
      this.findAtPoint(e, r), this.addDOM(s, t);
    this.findAtPoint(e, r);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, o) {
    let i, r;
    for (let s = this.open, a = 0; s >= 0; s--) {
      let l = this.nodes[s], d = l.findWrapping(e);
      if (d && (!i || i.length > d.length + a) && (i = d, r = l, !d.length))
        break;
      if (l.solid) {
        if (o)
          break;
        a += 2;
      }
    }
    if (!i)
      return null;
    this.sync(r);
    for (let s = 0; s < i.length; s++)
      t = this.enterInner(i[s], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, o) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (t = this.enterInner(r, null, t));
    }
    let i = this.findPlace(e, t, o);
    if (i) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(e.type));
      let s = ot.none;
      for (let a of i.concat(e.marks))
        (r.type ? r.type.allowsMarkType(a.type) : l3(a.type, e.type)) && (s = a.addToSet(s));
      return r.content.push(e.mark(s)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, o, i) {
    let r = this.findPlace(e.create(t), o, !1);
    return r && (r = this.enterInner(e, t, o, !0, i)), r;
  }
  // Open a node of the given type
  enterInner(e, t, o, i = !1, r) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let a = r3(e, r, s.options);
    s.options & qs && s.content.length == 0 && (a |= qs);
    let l = ot.none;
    return o = o.filter((d) => (s.type ? s.type.allowsMarkType(d.type) : l3(d.type, e)) ? (l = d.addToSet(l), !1) : !0), this.nodes.push(new rl(e, t, l, i, null, a)), this.open++, o;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= ba);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let o = this.nodes[t].content;
      for (let i = o.length - 1; i >= 0; i--)
        e += o[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].node == e && this.find[o].offset == t && (this.find[o].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, o) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (o ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), o = this.options.context, i = !this.isOpen && (!o || o.parent.type == this.nodes[0].type), r = -(o ? o.depth + 1 : 0) + (i ? 0 : 1), s = (a, l) => {
      for (; a >= 0; a--) {
        let d = t[a];
        if (d == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= r; l--)
            if (s(a - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && i ? this.nodes[l].type : o && l >= r ? o.node(l - r).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return s(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let o = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (o && o.isTextblock && o.defaultAttrs)
          return o;
      }
    for (let t in this.parser.schema.nodes) {
      let o = this.parser.schema.nodes[t];
      if (o.isTextblock && o.defaultAttrs)
        return o;
    }
  }
}
function BE(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let o = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    o && ig.hasOwnProperty(o) && t ? (t.appendChild(e), e = t) : o == "li" ? t = e : o && (t = null);
  }
}
function VE(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function a3(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function l3(n, e) {
  let t = e.schema.nodes;
  for (let o in t) {
    let i = t[o];
    if (!i.allowsMarkType(n))
      continue;
    let r = [], s = (a) => {
      r.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: d, next: u } = a.edge(l);
        if (d == e || r.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(i.contentMatch))
      return !0;
  }
}
class br {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, o) {
    o || (o = sc(t).createDocumentFragment());
    let i = o, r = [];
    return e.forEach((s) => {
      if (r.length || s.marks.length) {
        let a = 0, l = 0;
        for (; a < r.length && l < s.marks.length; ) {
          let d = s.marks[l];
          if (!this.marks[d.type.name]) {
            l++;
            continue;
          }
          if (!d.eq(r[a][0]) || d.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < r.length; )
          i = r.pop()[1];
        for (; l < s.marks.length; ) {
          let d = s.marks[l++], u = this.serializeMark(d, s.isInline, t);
          u && (r.push([d, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(s, t));
    }), o;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: o, contentDOM: i } = Dl(sc(t), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return o;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let o = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let r = this.serializeMark(e.marks[i], e.isInline, t);
      r && ((r.contentDOM || r.dom).appendChild(o), o = r.dom);
    }
    return o;
  }
  /**
  @internal
  */
  serializeMark(e, t, o = {}) {
    let i = this.marks[e.type.name];
    return i && Dl(sc(o), i(e, t), null, e.attrs);
  }
  static renderSpec(e, t, o = null, i) {
    return Dl(e, t, o, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new br(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = d3(e.nodes);
    return t.text || (t.text = (o) => o.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return d3(e.marks);
  }
}
function d3(n) {
  let e = {};
  for (let t in n) {
    let o = n[t].spec.toDOM;
    o && (e[t] = o);
  }
  return e;
}
function sc(n) {
  return n.document || window.document;
}
const u3 = /* @__PURE__ */ new WeakMap();
function zE(n) {
  let e = u3.get(n);
  return e === void 0 && u3.set(n, e = HE(n)), e;
}
function HE(n) {
  let e = null;
  function t(o) {
    if (o && typeof o == "object")
      if (Array.isArray(o))
        if (typeof o[0] == "string")
          e || (e = []), e.push(o);
        else
          for (let i = 0; i < o.length; i++)
            t(o[i]);
      else
        for (let i in o)
          t(o[i]);
  }
  return t(n), e;
}
function Dl(n, e, t, o) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], r;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (o && (r = zE(o)) && r.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = i.indexOf(" ");
  s > 0 && (t = i.slice(0, s), i = i.slice(s + 1));
  let a, l = t ? n.createElementNS(t, i) : n.createElement(i), d = e[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let c in d)
      if (d[c] != null) {
        let f = c.indexOf(" ");
        f > 0 ? l.setAttributeNS(c.slice(0, f), c.slice(f + 1), d[c]) : c == "style" && l.style ? l.style.cssText = d[c] : l.setAttribute(c, d[c]);
      }
  }
  for (let c = u; c < e.length; c++) {
    let f = e[c];
    if (f === 0) {
      if (c < e.length - 1 || c > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: p } = Dl(n, f, t, o);
      if (l.appendChild(h), p) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = p;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const rg = 65535, sg = Math.pow(2, 16);
function jE(n, e) {
  return n + e * sg;
}
function c3(n) {
  return n & rg;
}
function WE(n) {
  return (n - (n & rg)) / sg;
}
const ag = 1, lg = 2, Nl = 4, dg = 8;
class yf {
  /**
  @internal
  */
  constructor(e, t, o) {
    this.pos = e, this.delInfo = t, this.recover = o;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & dg) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (ag | Nl)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (lg | Nl)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Nl) > 0;
  }
}
class Sn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && Sn.empty)
      return Sn.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, o = c3(e);
    if (!this.inverted)
      for (let i = 0; i < o; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[o * 3] + t + WE(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, o) {
    let i = 0, r = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let d = this.ranges[a + r], u = this.ranges[a + s], c = l + d;
      if (e <= c) {
        let f = d ? e == l ? -1 : e == c ? 1 : t : t, h = l + i + (f < 0 ? 0 : u);
        if (o)
          return h;
        let p = e == (t < 0 ? l : c) ? null : jE(a / 3, e - l), m = e == l ? lg : e == c ? ag : Nl;
        return (t < 0 ? e != l : e != c) && (m |= dg), new yf(h, m, p);
      }
      i += u - d;
    }
    return o ? e + i : new yf(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let o = 0, i = c3(t), r = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? o : 0);
      if (l > e)
        break;
      let d = this.ranges[a + r], u = l + d;
      if (e <= u && a == i * 3)
        return !0;
      o += this.ranges[a + s] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0, r = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i], a = s - (this.inverted ? r : 0), l = s + (this.inverted ? 0 : r), d = this.ranges[i + t], u = this.ranges[i + o];
      e(a, a + d, l, l + u), r += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Sn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Sn.empty : new Sn(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Sn.empty = new Sn([]);
class ya {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, o = 0, i = e ? e.length : 0) {
    this.mirror = t, this.from = o, this.to = i, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new ya(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, o = this._maps.length; t < e._maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t], i != null && i < t ? o + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, o = this._maps.length + e._maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), i != null && i > t ? o - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new ya();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let o = this.from; o < this.to; o++)
      e = this._maps[o].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, o) {
    let i = 0;
    for (let r = this.from; r < this.to; r++) {
      let s = this._maps[r], a = s.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(r);
        if (l != null && l > r && l < this.to) {
          r = l, e = this._maps[l].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return o ? e : new yf(e, i, null);
  }
}
const ac = /* @__PURE__ */ Object.create(null);
class en {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Sn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let o = ac[t.stepType];
    if (!o)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return o.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in ac)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return ac[e] = t, t.prototype.jsonID = e, t;
  }
}
class Mt {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Mt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Mt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, o, i) {
    try {
      return Mt.ok(e.replace(t, o, i));
    } catch (r) {
      if (r instanceof nd)
        return Mt.fail(r.message);
      throw r;
    }
  }
}
function H1(n, e, t) {
  let o = [];
  for (let i = 0; i < n.childCount; i++) {
    let r = n.child(i);
    r.content.size && (r = r.copy(H1(r.content, e, r))), r.isInline && (r = e(r, t, i)), o.push(r);
  }
  return Q.fromArray(o);
}
class di extends en {
  /**
  Create a mark step.
  */
  constructor(e, t, o) {
    super(), this.from = e, this.to = t, this.mark = o;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), o = e.resolve(this.from), i = o.node(o.sharedDepth(this.to)), r = new he(H1(t.content, (s, a) => !s.isAtom || !a.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), i), t.openStart, t.openEnd);
    return Mt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Qn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), o = e.mapResult(this.to, -1);
    return t.deleted && o.deleted || t.pos >= o.pos ? null : new di(t.pos, o.pos, this.mark);
  }
  merge(e) {
    return e instanceof di && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new di(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new di(t.from, t.to, e.markFromJSON(t.mark));
  }
}
en.jsonID("addMark", di);
class Qn extends en {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, o) {
    super(), this.from = e, this.to = t, this.mark = o;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), o = new he(H1(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return Mt.fromReplace(e, this.from, this.to, o);
  }
  invert() {
    return new di(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), o = e.mapResult(this.to, -1);
    return t.deleted && o.deleted || t.pos >= o.pos ? null : new Qn(t.pos, o.pos, this.mark);
  }
  merge(e) {
    return e instanceof Qn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Qn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Qn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
en.jsonID("removeMark", Qn);
class ui extends en {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Mt.fail("No node at mark step's position");
    let o = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Mt.fromReplace(e, this.pos, this.pos + 1, new he(Q.from(o), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let o = this.mark.addToSet(t.marks);
      if (o.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(o))
            return new ui(this.pos, t.marks[i]);
        return new ui(this.pos, this.mark);
      }
    }
    return new dr(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ui(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new ui(t.pos, e.markFromJSON(t.mark));
  }
}
en.jsonID("addNodeMark", ui);
class dr extends en {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Mt.fail("No node at mark step's position");
    let o = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Mt.fromReplace(e, this.pos, this.pos + 1, new he(Q.from(o), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new ui(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new dr(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new dr(t.pos, e.markFromJSON(t.mark));
  }
}
en.jsonID("removeNodeMark", dr);
class Dt extends en {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, o, i = !1) {
    super(), this.from = e, this.to = t, this.slice = o, this.structure = i;
  }
  apply(e) {
    return this.structure && xf(e, this.from, this.to) ? Mt.fail("Structure replace would overwrite content") : Mt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Sn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Dt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), o = e.mapResult(this.to, -1);
    return t.deletedAcross && o.deletedAcross ? null : new Dt(t.pos, Math.max(t.pos, o.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof Dt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? he.empty : new he(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Dt(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? he.empty : new he(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Dt(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Dt(t.from, t.to, he.fromJSON(e, t.slice), !!t.structure);
  }
}
en.jsonID("replace", Dt);
class Pt extends en {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, o, i, r, s, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = o, this.gapTo = i, this.slice = r, this.insert = s, this.structure = a;
  }
  apply(e) {
    if (this.structure && (xf(e, this.from, this.gapFrom) || xf(e, this.gapTo, this.to)))
      return Mt.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Mt.fail("Gap is not a flat range");
    let o = this.slice.insertAt(this.insert, t.content);
    return o ? Mt.fromReplace(e, this.from, this.to, o) : Mt.fail("Content does not fit in gap");
  }
  getMap() {
    return new Sn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new Pt(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), o = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), r = this.to == this.gapTo ? o.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && o.deletedAcross || i < t.pos || r > o.pos ? null : new Pt(t.pos, o.pos, i, r, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Pt(t.from, t.to, t.gapFrom, t.gapTo, he.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
en.jsonID("replaceAround", Pt);
function xf(n, e, t) {
  let o = n.resolve(e), i = t - e, r = o.depth;
  for (; i > 0 && r > 0 && o.indexAfter(r) == o.node(r).childCount; )
    r--, i--;
  if (i > 0) {
    let s = o.node(r).maybeChild(o.indexAfter(r));
    for (; i > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, i--;
    }
  }
  return !1;
}
function UE(n, e, t, o) {
  let i = [], r = [], s, a;
  n.doc.nodesBetween(e, t, (l, d, u) => {
    if (!l.isInline)
      return;
    let c = l.marks;
    if (!o.isInSet(c) && u.type.allowsMarkType(o.type)) {
      let f = Math.max(d, e), h = Math.min(d + l.nodeSize, t), p = o.addToSet(c);
      for (let m = 0; m < c.length; m++)
        c[m].isInSet(p) || (s && s.to == f && s.mark.eq(c[m]) ? s.to = h : i.push(s = new Qn(f, h, c[m])));
      a && a.to == f ? a.to = h : r.push(a = new di(f, h, o));
    }
  }), i.forEach((l) => n.step(l)), r.forEach((l) => n.step(l));
}
function KE(n, e, t, o) {
  let i = [], r = 0;
  n.doc.nodesBetween(e, t, (s, a) => {
    if (!s.isInline)
      return;
    r++;
    let l = null;
    if (o instanceof wu) {
      let d = s.marks, u;
      for (; u = o.isInSet(d); )
        (l || (l = [])).push(u), d = u.removeFromSet(d);
    } else o ? o.isInSet(s.marks) && (l = [o]) : l = s.marks;
    if (l && l.length) {
      let d = Math.min(a + s.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let c = l[u], f;
        for (let h = 0; h < i.length; h++) {
          let p = i[h];
          p.step == r - 1 && c.eq(i[h].style) && (f = p);
        }
        f ? (f.to = d, f.step = r) : i.push({ style: c, from: Math.max(a, e), to: d, step: r });
      }
    }
  }), i.forEach((s) => n.step(new Qn(s.from, s.to, s.style)));
}
function j1(n, e, t, o = t.contentMatch, i = !0) {
  let r = n.doc.nodeAt(e), s = [], a = e + 1;
  for (let l = 0; l < r.childCount; l++) {
    let d = r.child(l), u = a + d.nodeSize, c = o.matchType(d.type);
    if (!c)
      s.push(new Dt(a, u, he.empty));
    else {
      o = c;
      for (let f = 0; f < d.marks.length; f++)
        t.allowsMarkType(d.marks[f].type) || n.step(new Qn(a, u, d.marks[f]));
      if (i && d.isText && t.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, p;
        for (; f = h.exec(d.text); )
          p || (p = new he(Q.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), s.push(new Dt(a + f.index, a + f.index + f[0].length, p));
      }
    }
    a = u;
  }
  if (!o.validEnd) {
    let l = o.fillBefore(Q.empty, !0);
    n.replace(a, a, new he(l, 0, 0));
  }
  for (let l = s.length - 1; l >= 0; l--)
    n.step(s[l]);
}
function GE(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function ys(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let o = n.depth, i = 0, r = 0; ; --o) {
    let s = n.$from.node(o), a = n.$from.index(o) + i, l = n.$to.indexAfter(o) - r;
    if (o < n.depth && s.canReplace(a, l, t))
      return o;
    if (o == 0 || s.type.spec.isolating || !GE(s, a, l))
      break;
    a && (i = 1), l < s.childCount && (r = 1);
  }
  return null;
}
function YE(n, e, t) {
  let { $from: o, $to: i, depth: r } = e, s = o.before(r + 1), a = i.after(r + 1), l = s, d = a, u = Q.empty, c = 0;
  for (let p = r, m = !1; p > t; p--)
    m || o.index(p) > 0 ? (m = !0, u = Q.from(o.node(p).copy(u)), c++) : l--;
  let f = Q.empty, h = 0;
  for (let p = r, m = !1; p > t; p--)
    m || i.after(p + 1) < i.end(p) ? (m = !0, f = Q.from(i.node(p).copy(f)), h++) : d++;
  n.step(new Pt(l, d, s, a, new he(u.append(f), c, h), u.size - c, !0));
}
function W1(n, e, t = null, o = n) {
  let i = qE(n, e), r = i && ZE(o, e);
  return r ? i.map(f3).concat({ type: e, attrs: t }).concat(r.map(f3)) : null;
}
function f3(n) {
  return { type: n, attrs: null };
}
function qE(n, e) {
  let { parent: t, startIndex: o, endIndex: i } = n, r = t.contentMatchAt(o).findWrapping(e);
  if (!r)
    return null;
  let s = r.length ? r[0] : e;
  return t.canReplaceWith(o, i, s) ? r : null;
}
function ZE(n, e) {
  let { parent: t, startIndex: o, endIndex: i } = n, r = t.child(o), s = e.contentMatch.findWrapping(r.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let d = o; l && d < i; d++)
    l = l.matchType(t.child(d).type);
  return !l || !l.validEnd ? null : s;
}
function JE(n, e, t) {
  let o = Q.empty;
  for (let s = t.length - 1; s >= 0; s--) {
    if (o.size) {
      let a = t[s].type.contentMatch.matchFragment(o);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    o = Q.from(t[s].type.create(t[s].attrs, o));
  }
  let i = e.start, r = e.end;
  n.step(new Pt(i, r, i, r, new he(o, 0, 0), t.length, !0));
}
function XE(n, e, t, o, i) {
  if (!o.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let r = n.steps.length;
  n.doc.nodesBetween(e, t, (s, a) => {
    let l = typeof i == "function" ? i(s) : i;
    if (s.isTextblock && !s.hasMarkup(o, l) && QE(n.doc, n.mapping.slice(r).map(a), o)) {
      let d = null;
      if (o.schema.linebreakReplacement) {
        let h = o.whitespace == "pre", p = !!o.contentMatch.matchType(o.schema.linebreakReplacement);
        h && !p ? d = !1 : !h && p && (d = !0);
      }
      d === !1 && cg(n, s, a, r), j1(n, n.mapping.slice(r).map(a, 1), o, void 0, d === null);
      let u = n.mapping.slice(r), c = u.map(a, 1), f = u.map(a + s.nodeSize, 1);
      return n.step(new Pt(c, f, c + 1, f - 1, new he(Q.from(o.create(l, null, s.marks)), 0, 0), 1, !0)), d === !0 && ug(n, s, a, r), !1;
    }
  });
}
function ug(n, e, t, o) {
  e.forEach((i, r) => {
    if (i.isText) {
      let s, a = /\r?\n|\r/g;
      for (; s = a.exec(i.text); ) {
        let l = n.mapping.slice(o).map(t + 1 + r + s.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function cg(n, e, t, o) {
  e.forEach((i, r) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let s = n.mapping.slice(o).map(t + 1 + r);
      n.replaceWith(s, s + 1, e.type.schema.text(`
`));
    }
  });
}
function QE(n, e, t) {
  let o = n.resolve(e), i = o.index();
  return o.parent.canReplaceWith(i, i + 1, t);
}
function eO(n, e, t, o, i) {
  let r = n.doc.nodeAt(e);
  if (!r)
    throw new RangeError("No node at given position");
  t || (t = r.type);
  let s = t.create(o, null, i || r.marks);
  if (r.isLeaf)
    return n.replaceWith(e, e + r.nodeSize, s);
  if (!t.validContent(r.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new Pt(e, e + r.nodeSize, e + 1, e + r.nodeSize - 1, new he(Q.from(s), 0, 0), 1, !0));
}
function Fo(n, e, t = 1, o) {
  let i = n.resolve(e), r = i.depth - t, s = o && o[o.length - 1] || i.parent;
  if (r < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !s.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let d = i.depth - 1, u = t - 2; d > r; d--, u--) {
    let c = i.node(d), f = i.index(d);
    if (c.type.spec.isolating)
      return !1;
    let h = c.content.cutByIndex(f, c.childCount), p = o && o[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let m = o && o[u] || c;
    if (!c.canReplace(f + 1, c.childCount) || !m.type.validContent(h))
      return !1;
  }
  let a = i.indexAfter(r), l = o && o[0];
  return i.node(r).canReplaceWith(a, a, l ? l.type : i.node(r + 1).type);
}
function tO(n, e, t = 1, o) {
  let i = n.doc.resolve(e), r = Q.empty, s = Q.empty;
  for (let a = i.depth, l = i.depth - t, d = t - 1; a > l; a--, d--) {
    r = Q.from(i.node(a).copy(r));
    let u = o && o[d];
    s = Q.from(u ? u.type.create(u.attrs, s) : i.node(a).copy(s));
  }
  n.step(new Dt(e, e, new he(r.append(s), t, t), !0));
}
function Ii(n, e) {
  let t = n.resolve(e), o = t.index();
  return fg(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(o, o + 1);
}
function nO(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: o } = n.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let r = e.child(i), s = r.type == o ? n.type.schema.nodes.text : r.type;
    if (t = t.matchType(s), !t || !n.type.allowsMarks(r.marks))
      return !1;
  }
  return t.validEnd;
}
function fg(n, e) {
  return !!(n && e && !n.isLeaf && nO(n, e));
}
function ku(n, e, t = -1) {
  let o = n.resolve(e);
  for (let i = o.depth; ; i--) {
    let r, s, a = o.index(i);
    if (i == o.depth ? (r = o.nodeBefore, s = o.nodeAfter) : t > 0 ? (r = o.node(i + 1), a++, s = o.node(i).maybeChild(a)) : (r = o.node(i).maybeChild(a - 1), s = o.node(i + 1)), r && !r.isTextblock && fg(r, s) && o.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = t < 0 ? o.before(i) : o.after(i);
  }
}
function oO(n, e, t) {
  let o = null, { linebreakReplacement: i } = n.doc.type.schema, r = n.doc.resolve(e - t), s = r.node().type;
  if (i && s.inlineContent) {
    let u = s.whitespace == "pre", c = !!s.contentMatch.matchType(i);
    u && !c ? o = !1 : !u && c && (o = !0);
  }
  let a = n.steps.length;
  if (o === !1) {
    let u = n.doc.resolve(e + t);
    cg(n, u.node(), u.before(), a);
  }
  s.inlineContent && j1(n, e + t - 1, s, r.node().contentMatchAt(r.index()), o == null);
  let l = n.mapping.slice(a), d = l.map(e - t);
  if (n.step(new Dt(d, l.map(e + t, -1), he.empty, !0)), o === !0) {
    let u = n.doc.resolve(d);
    ug(n, u.node(), u.before(), n.steps.length);
  }
  return n;
}
function iO(n, e, t) {
  let o = n.resolve(e);
  if (o.parent.canReplaceWith(o.index(), o.index(), t))
    return e;
  if (o.parentOffset == 0)
    for (let i = o.depth - 1; i >= 0; i--) {
      let r = o.index(i);
      if (o.node(i).canReplaceWith(r, r, t))
        return o.before(i + 1);
      if (r > 0)
        return null;
    }
  if (o.parentOffset == o.parent.content.size)
    for (let i = o.depth - 1; i >= 0; i--) {
      let r = o.indexAfter(i);
      if (o.node(i).canReplaceWith(r, r, t))
        return o.after(i + 1);
      if (r < o.node(i).childCount)
        return null;
    }
  return null;
}
function hg(n, e, t) {
  let o = n.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let r = 0; r < t.openStart; r++)
    i = i.firstChild.content;
  for (let r = 1; r <= (t.openStart == 0 && t.size ? 2 : 1); r++)
    for (let s = o.depth; s >= 0; s--) {
      let a = s == o.depth ? 0 : o.pos <= (o.start(s + 1) + o.end(s + 1)) / 2 ? -1 : 1, l = o.index(s) + (a > 0 ? 1 : 0), d = o.node(s), u = !1;
      if (r == 1)
        u = d.canReplace(l, l, i);
      else {
        let c = d.contentMatchAt(l).findWrapping(i.firstChild.type);
        u = c && d.canReplaceWith(l, l, c[0]);
      }
      if (u)
        return a == 0 ? o.pos : a < 0 ? o.before(s + 1) : o.after(s + 1);
    }
  return null;
}
function $u(n, e, t = e, o = he.empty) {
  if (e == t && !o.size)
    return null;
  let i = n.resolve(e), r = n.resolve(t);
  return pg(i, r, o) ? new Dt(e, t, o) : new rO(i, r, o).fit();
}
function pg(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class rO {
  constructor(e, t, o) {
    this.$from = e, this.$to = t, this.unplaced = o, this.frontier = [], this.placed = Q.empty;
    for (let i = 0; i <= e.depth; i++) {
      let r = e.node(i);
      this.frontier.push({
        type: r.type,
        match: r.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = Q.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, o = this.$from, i = this.close(e < 0 ? this.$to : o.doc.resolve(e));
    if (!i)
      return null;
    let r = this.placed, s = o.depth, a = i.depth;
    for (; s && a && r.childCount == 1; )
      r = r.firstChild.content, s--, a--;
    let l = new he(r, s, a);
    return e > -1 ? new Pt(o.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || o.pos != this.$to.pos ? new Dt(o.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, o = 0, i = this.unplaced.openEnd; o < e; o++) {
      let r = t.firstChild;
      if (t.childCount > 1 && (i = 0), r.type.spec.isolating && i <= o) {
        e = o;
        break;
      }
      t = r.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let o = t == 1 ? e : this.unplaced.openStart; o >= 0; o--) {
        let i, r = null;
        o ? (r = lc(this.unplaced.content, o - 1).firstChild, i = r.content) : i = this.unplaced.content;
        let s = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: d } = this.frontier[a], u, c = null;
          if (t == 1 && (s ? d.matchType(s.type) || (c = d.fillBefore(Q.from(s), !1)) : r && l.compatibleContent(r.type)))
            return { sliceDepth: o, frontierDepth: a, parent: r, inject: c };
          if (t == 2 && s && (u = d.findWrapping(s.type)))
            return { sliceDepth: o, frontierDepth: a, parent: r, wrap: u };
          if (r && d.matchType(r.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: o } = this.unplaced, i = lc(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new he(e, t + 1, Math.max(o, i.size + t >= e.size - o ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: o } = this.unplaced, i = lc(e, t);
    if (i.childCount <= 1 && t > 0) {
      let r = e.size - t <= t + i.size;
      this.unplaced = new he(Ps(e, t - 1, 1), t - 1, r ? t - 1 : o);
    } else
      this.unplaced = new he(Ps(e, t, 1), t, o);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: o, inject: i, wrap: r }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (r)
      for (let m = 0; m < r.length; m++)
        this.openFrontierNode(r[m]);
    let s = this.unplaced, a = o ? o.content : s.content, l = s.openStart - e, d = 0, u = [], { match: c, type: f } = this.frontier[t];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        u.push(i.child(m));
      c = c.matchFragment(i);
    }
    let h = a.size + e - (s.content.size - s.openEnd);
    for (; d < a.childCount; ) {
      let m = a.child(d), g = c.matchType(m.type);
      if (!g)
        break;
      d++, (d > 1 || l == 0 || m.content.size) && (c = g, u.push(mg(m.mark(f.allowedMarks(m.marks)), d == 1 ? l : 0, d == a.childCount ? h : -1)));
    }
    let p = d == a.childCount;
    p || (h = -1), this.placed = Ls(this.placed, t, Q.from(u)), this.frontier[t].match = c, p && h < 0 && o && o.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, g = a; m < h; m++) {
      let b = g.lastChild;
      this.frontier.push({ type: b.type, match: b.contentMatchAt(b.childCount) }), g = b.content;
    }
    this.unplaced = p ? e == 0 ? he.empty : new he(Ps(s.content, e - 1, 1), e - 1, h < 0 ? s.openEnd : e - 1) : new he(Ps(s.content, e, d), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !dc(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: o } = this.$to, i = this.$to.after(o);
    for (; o > 1 && i == this.$to.end(--o); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: o, type: i } = this.frontier[t], r = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), s = dc(e, t, i, o, r);
      if (s) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: l, type: d } = this.frontier[a], u = dc(e, a, d, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: s, move: r ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Ls(this.placed, t.depth, t.fit)), e = t.move;
    for (let o = t.depth + 1; o <= e.depth; o++) {
      let i = e.node(o), r = i.type.contentMatch.fillBefore(i.content, !0, e.index(o));
      this.openFrontierNode(i.type, i.attrs, r);
    }
    return e;
  }
  openFrontierNode(e, t = null, o) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Ls(this.placed, this.depth, Q.from(e.create(t, o))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Q.empty, !0);
    t.childCount && (this.placed = Ls(this.placed, this.frontier.length, t));
  }
}
function Ps(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Ps(n.firstChild.content, e - 1, t)));
}
function Ls(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Ls(n.lastChild.content, e - 1, t)));
}
function lc(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function mg(n, e, t) {
  if (e <= 0)
    return n;
  let o = n.content;
  return e > 1 && (o = o.replaceChild(0, mg(o.firstChild, e - 1, o.childCount == 1 ? t - 1 : 0))), e > 0 && (o = n.type.contentMatch.fillBefore(o).append(o), t <= 0 && (o = o.append(n.type.contentMatch.matchFragment(o).fillBefore(Q.empty, !0)))), n.copy(o);
}
function dc(n, e, t, o, i) {
  let r = n.node(e), s = i ? n.indexAfter(e) : n.index(e);
  if (s == r.childCount && !t.compatibleContent(r.type))
    return null;
  let a = o.fillBefore(r.content, !0, s);
  return a && !sO(t, r.content, s) ? a : null;
}
function sO(n, e, t) {
  for (let o = t; o < e.childCount; o++)
    if (!n.allowsMarks(e.child(o).marks))
      return !0;
  return !1;
}
function aO(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function lO(n, e, t, o) {
  if (!o.size)
    return n.deleteRange(e, t);
  let i = n.doc.resolve(e), r = n.doc.resolve(t);
  if (pg(i, r, o))
    return n.step(new Dt(e, t, o));
  let s = vg(i, r);
  s[s.length - 1] == 0 && s.pop();
  let a = -(i.depth + 1);
  s.unshift(a);
  for (let f = i.depth, h = i.pos - 1; f > 0; f--, h--) {
    let p = i.node(f).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    s.indexOf(f) > -1 ? a = f : i.before(f) == h && s.splice(1, 0, -f);
  }
  let l = s.indexOf(a), d = [], u = o.openStart;
  for (let f = o.content, h = 0; ; h++) {
    let p = f.firstChild;
    if (d.push(p), h == o.openStart)
      break;
    f = p.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let h = d[f], p = aO(h.type);
    if (p && !h.sameMarkup(i.node(Math.abs(a) - 1)))
      u = f;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let f = o.openStart; f >= 0; f--) {
    let h = (f + u + 1) % (o.openStart + 1), p = d[h];
    if (p)
      for (let m = 0; m < s.length; m++) {
        let g = s[(m + l) % s.length], b = !0;
        g < 0 && (b = !1, g = -g);
        let x = i.node(g - 1), w = i.index(g - 1);
        if (x.canReplaceWith(w, w, p.type, p.marks))
          return n.replace(i.before(g), b ? r.after(g) : t, new he(gg(o.content, 0, o.openStart, h), h, o.openEnd));
      }
  }
  let c = n.steps.length;
  for (let f = s.length - 1; f >= 0 && (n.replace(e, t, o), !(n.steps.length > c)); f--) {
    let h = s[f];
    h < 0 || (e = i.before(h), t = r.after(h));
  }
}
function gg(n, e, t, o, i) {
  if (e < t) {
    let r = n.firstChild;
    n = n.replaceChild(0, r.copy(gg(r.content, e + 1, t, o, r)));
  }
  if (e > o) {
    let r = i.contentMatchAt(0), s = r.fillBefore(n).append(n);
    n = s.append(r.matchFragment(s).fillBefore(Q.empty, !0));
  }
  return n;
}
function dO(n, e, t, o) {
  if (!o.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let i = iO(n.doc, e, o.type);
    i != null && (e = t = i);
  }
  n.replaceRange(e, t, new he(Q.from(o), 0, 0));
}
function uO(n, e, t) {
  let o = n.doc.resolve(e), i = n.doc.resolve(t), r = vg(o, i);
  for (let s = 0; s < r.length; s++) {
    let a = r[s], l = s == r.length - 1;
    if (l && a == 0 || o.node(a).type.contentMatch.validEnd)
      return n.delete(o.start(a), i.end(a));
    if (a > 0 && (l || o.node(a - 1).canReplace(o.index(a - 1), i.indexAfter(a - 1))))
      return n.delete(o.before(a), i.after(a));
  }
  for (let s = 1; s <= o.depth && s <= i.depth; s++)
    if (e - o.start(s) == o.depth - s && t > o.end(s) && i.end(s) - t != i.depth - s && o.start(s - 1) == i.start(s - 1) && o.node(s - 1).canReplace(o.index(s - 1), i.index(s - 1)))
      return n.delete(o.before(s), t);
  n.delete(e, t);
}
function vg(n, e) {
  let t = [], o = Math.min(n.depth, e.depth);
  for (let i = o; i >= 0; i--) {
    let r = n.start(i);
    if (r < n.pos - (n.depth - i) || e.end(i) > e.pos + (e.depth - i) || n.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (r == e.start(i) || i == n.depth && i == e.depth && n.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == r - 1) && t.push(i);
  }
  return t;
}
class Wr extends en {
  /**
  Construct an attribute step.
  */
  constructor(e, t, o) {
    super(), this.pos = e, this.attr = t, this.value = o;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Mt.fail("No node at attribute step's position");
    let o = /* @__PURE__ */ Object.create(null);
    for (let r in t.attrs)
      o[r] = t.attrs[r];
    o[this.attr] = this.value;
    let i = t.type.create(o, null, t.marks);
    return Mt.fromReplace(e, this.pos, this.pos + 1, new he(Q.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return Sn.empty;
  }
  invert(e) {
    return new Wr(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Wr(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Wr(t.pos, t.attr, t.value);
  }
}
en.jsonID("attr", Wr);
class xa extends en {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      t[i] = e.attrs[i];
    t[this.attr] = this.value;
    let o = e.type.create(t, e.content, e.marks);
    return Mt.ok(o);
  }
  getMap() {
    return Sn.empty;
  }
  invert(e) {
    return new xa(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new xa(t.attr, t.value);
  }
}
en.jsonID("docAttr", xa);
let rs = class extends Error {
};
rs = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
rs.prototype = Object.create(Error.prototype);
rs.prototype.constructor = rs;
rs.prototype.name = "TransformError";
class bg {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new ya();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new rs(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let e = 1e9, t = -1e9;
    for (let o = 0; o < this.mapping.maps.length; o++) {
      let i = this.mapping.maps[o];
      o && (e = i.map(e, 1), t = i.map(t, -1)), i.forEach((r, s, a, l) => {
        e = Math.min(e, a), t = Math.max(t, l);
      });
    }
    return e == 1e9 ? null : { from: e, to: t };
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, o = he.empty) {
    let i = $u(this.doc, e, t, o);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, o) {
    return this.replace(e, t, new he(Q.from(o), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, he.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, o) {
    return lO(this, e, t, o), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, o) {
    return dO(this, e, t, o), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return uO(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return YE(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return oO(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return JE(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, o, i = null) {
    return XE(this, e, t, o, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, o = null, i) {
    return eO(this, e, t, o, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, o) {
    return this.step(new Wr(e, t, o)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new xa(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new ui(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let o = this.doc.nodeAt(e);
    if (!o)
      throw new RangeError("No node at position " + e);
    if (t instanceof ot)
      t.isInSet(o.marks) && this.step(new dr(e, t));
    else {
      let i = o.marks, r, s = [];
      for (; r = t.isInSet(i); )
        s.push(new dr(e, r)), i = r.removeFromSet(i);
      for (let a = s.length - 1; a >= 0; a--)
        this.step(s[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, o) {
    return tO(this, e, t, o), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, o) {
    return UE(this, e, t, o), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, o) {
    return KE(this, e, t, o), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, o) {
    return j1(this, e, t, o), this;
  }
}
const uc = /* @__PURE__ */ Object.create(null);
class Le {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, o) {
    this.$anchor = e, this.$head = t, this.ranges = o || [new cO(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = he.empty) {
    let o = t.content.lastChild, i = null;
    for (let a = 0; a < t.openEnd; a++)
      i = o, o = o.lastChild;
    let r = e.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: l, $to: d } = s[a], u = e.mapping.slice(r);
      e.replaceRange(u.map(l.pos), u.map(d.pos), a ? he.empty : t), a == 0 && m3(e, r, (o ? o.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let o = e.steps.length, i = this.ranges;
    for (let r = 0; r < i.length; r++) {
      let { $from: s, $to: a } = i[r], l = e.mapping.slice(o), d = l.map(s.pos), u = l.map(a.pos);
      r ? e.deleteRange(d, u) : (e.replaceRangeWith(d, u, t), m3(e, o, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, o = !1) {
    let i = e.parent.inlineContent ? new Te(e) : Lr(e.node(0), e.parent, e.pos, e.index(), t, o);
    if (i)
      return i;
    for (let r = e.depth - 1; r >= 0; r--) {
      let s = t < 0 ? Lr(e.node(0), e.node(r), e.before(r + 1), e.index(r), t, o) : Lr(e.node(0), e.node(r), e.after(r + 1), e.index(r) + 1, t, o);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new On(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Lr(e, e, 0, 0, 1) || new On(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Lr(e, e, e.content.size, e.childCount, -1) || new On(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let o = uc[t.type];
    if (!o)
      throw new RangeError(`No selection type ${t.type} defined`);
    return o.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in uc)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return uc[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Te.between(this.$anchor, this.$head).getBookmark();
  }
}
Le.prototype.visible = !0;
class cO {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let h3 = !1;
function p3(n) {
  !h3 && !n.parent.inlineContent && (h3 = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Te extends Le {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    p3(e), p3(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let o = e.resolve(t.map(this.head));
    if (!o.parent.inlineContent)
      return Le.near(o);
    let i = e.resolve(t.map(this.anchor));
    return new Te(i.parent.inlineContent ? i : o, o);
  }
  replace(e, t = he.empty) {
    if (super.replace(e, t), t == he.empty) {
      let o = this.$from.marksAcross(this.$to);
      o && e.ensureMarks(o);
    }
  }
  eq(e) {
    return e instanceof Te && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Mu(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Te(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, o = t) {
    let i = e.resolve(t);
    return new this(i, o == t ? i : e.resolve(o));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, o) {
    let i = e.pos - t.pos;
    if ((!o || i) && (o = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let r = Le.findFrom(t, o, !0) || Le.findFrom(t, -o, !0);
      if (r)
        t = r.$head;
      else
        return Le.near(t, o);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (Le.findFrom(e, -o, !0) || Le.findFrom(e, o, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new Te(e, t);
  }
}
Le.jsonID("text", Te);
class Mu {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Mu(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Te.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class xe extends Le {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, o = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, o), this.node = t;
  }
  map(e, t) {
    let { deleted: o, pos: i } = t.mapResult(this.anchor), r = e.resolve(i);
    return o ? Le.near(r) : new xe(r);
  }
  content() {
    return new he(Q.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof xe && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new U1(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new xe(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new xe(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
xe.prototype.visible = !1;
Le.jsonID("node", xe);
class U1 {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: o } = e.mapResult(this.anchor);
    return t ? new Mu(o, o) : new U1(o);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), o = t.nodeAfter;
    return o && xe.isSelectable(o) ? new xe(t) : Le.near(t);
  }
}
class On extends Le {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = he.empty) {
    if (t == he.empty) {
      e.delete(0, e.doc.content.size);
      let o = Le.atStart(e.doc);
      o.eq(e.selection) || e.setSelection(o);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new On(e);
  }
  map(e) {
    return new On(e);
  }
  eq(e) {
    return e instanceof On;
  }
  getBookmark() {
    return fO;
  }
}
Le.jsonID("all", On);
const fO = {
  map() {
    return this;
  },
  resolve(n) {
    return new On(n);
  }
};
function Lr(n, e, t, o, i, r = !1) {
  if (e.inlineContent)
    return Te.create(n, t);
  for (let s = o - (i > 0 ? 0 : 1); i > 0 ? s < e.childCount : s >= 0; s += i) {
    let a = e.child(s);
    if (a.isAtom) {
      if (!r && xe.isSelectable(a))
        return xe.create(n, t - (i < 0 ? a.nodeSize : 0));
    } else {
      let l = Lr(n, a, t + i, i < 0 ? a.childCount : 0, i, r);
      if (l)
        return l;
    }
    t += a.nodeSize * i;
  }
  return null;
}
function m3(n, e, t) {
  let o = n.steps.length - 1;
  if (o < e)
    return;
  let i = n.steps[o];
  if (!(i instanceof Dt || i instanceof Pt))
    return;
  let r = n.mapping.maps[o], s;
  r.forEach((a, l, d, u) => {
    s == null && (s = u);
  }), n.setSelection(Le.near(n.doc.resolve(s), t));
}
const g3 = 1, sl = 2, v3 = 4;
class hO extends bg {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | g3) & ~sl, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & g3) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= sl, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return ot.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & sl) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~sl, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let o = this.selection;
    return t && (e = e.mark(this.storedMarks || (o.empty ? o.$from.marks() : o.$from.marksAcross(o.$to) || ot.none))), o.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, o) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (o == null && (o = t), !e)
        return this.deleteRange(t, o);
      let r = this.storedMarks;
      if (!r) {
        let s = this.doc.resolve(t);
        r = o == t ? s.marks() : s.marksAcross(this.doc.resolve(o));
      }
      return this.replaceRangeWith(t, o, i.text(e, r)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(Le.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= v3, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & v3) > 0;
  }
}
function b3(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Rs {
  constructor(e, t, o) {
    this.name = e, this.init = b3(t.init, o), this.apply = b3(t.apply, o);
  }
}
const pO = [
  new Rs("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Rs("selection", {
    init(n, e) {
      return n.selection || Le.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Rs("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, o) {
      return o.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Rs("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class cc {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = pO.slice(), t && t.forEach((o) => {
      if (this.pluginsByKey[o.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + o.key + ")");
      this.plugins.push(o), this.pluginsByKey[o.key] = o, o.spec.state && this.fields.push(new Rs(o.key, o.spec.state, o));
    });
  }
}
class Br {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let o = 0; o < this.config.plugins.length; o++)
      if (o != t) {
        let i = this.config.plugins[o];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], o = this.applyInner(e), i = null;
    for (; ; ) {
      let r = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let a = this.config.plugins[s];
        if (a.spec.appendTransaction) {
          let l = i ? i[s].n : 0, d = i ? i[s].state : this, u = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, d, o);
          if (u && o.filterTransaction(u, s)) {
            if (u.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let c = 0; c < this.config.plugins.length; c++)
                i.push(c < s ? { state: o, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), o = o.applyInner(u), r = !0;
          }
          i && (i[s] = { state: o, n: t.length });
        }
      }
      if (!r)
        return { state: o, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Br(this.config), o = this.config.fields;
    for (let i = 0; i < o.length; i++) {
      let r = o[i];
      t[r.name] = r.apply(e, this[r.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new hO(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new cc(e.doc ? e.doc.type.schema : e.schema, e.plugins), o = new Br(t);
    for (let i = 0; i < t.fields.length; i++)
      o[t.fields[i].name] = t.fields[i].init(e, o);
    return o;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new cc(this.schema, e.plugins), o = t.fields, i = new Br(t);
    for (let r = 0; r < o.length; r++) {
      let s = o[r].name;
      i[s] = this.hasOwnProperty(s) ? this[s] : o[r].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((o) => o.toJSON())), e && typeof e == "object")
      for (let o in e) {
        if (o == "doc" || o == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[o], r = i.spec.state;
        r && r.toJSON && (t[o] = r.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, o) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new cc(e.schema, e.plugins), r = new Br(i);
    return i.fields.forEach((s) => {
      if (s.name == "doc")
        r.doc = gi.fromJSON(e.schema, t.doc);
      else if (s.name == "selection")
        r.selection = Le.fromJSON(r.doc, t.selection);
      else if (s.name == "storedMarks")
        t.storedMarks && (r.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (o)
          for (let a in o) {
            let l = o[a], d = l.spec.state;
            if (l.key == s.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              r[s.name] = d.fromJSON.call(l, e, t[a], r);
              return;
            }
          }
        r[s.name] = s.init(e, r);
      }
    }), r;
  }
}
function yg(n, e, t) {
  for (let o in n) {
    let i = n[o];
    i instanceof Function ? i = i.bind(e) : o == "handleDOMEvents" && (i = yg(i, e, {})), t[o] = i;
  }
  return t;
}
class mt {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && yg(e.props, this, this.props), this.key = e.key ? e.key.key : xg("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const fc = /* @__PURE__ */ Object.create(null);
function xg(n) {
  return n in fc ? n + "$" + ++fc[n] : (fc[n] = 0, n + "$");
}
class Tt {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = xg(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const K1 = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function Cg(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const wg = (n, e, t) => {
  let o = Cg(n, t);
  if (!o)
    return !1;
  let i = G1(o);
  if (!i) {
    let s = o.blockRange(), a = s && ys(s);
    return a == null ? !1 : (e && e(n.tr.lift(s, a).scrollIntoView()), !0);
  }
  let r = i.nodeBefore;
  if (Ag(n, i, e, -1))
    return !0;
  if (o.parent.content.size == 0 && (ss(r, "end") || xe.isSelectable(r)))
    for (let s = o.depth; ; s--) {
      let a = $u(n.doc, o.before(s), o.after(s), he.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = n.tr.step(a);
          l.setSelection(ss(r, "end") ? Le.findFrom(l.doc.resolve(l.mapping.map(i.pos, -1)), -1) : xe.create(l.doc, i.pos - r.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || o.node(s - 1).childCount > 1)
        break;
    }
  return r.isAtom && i.depth == o.depth - 1 ? (e && e(n.tr.delete(i.pos - r.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, mO = (n, e, t) => {
  let o = Cg(n, t);
  if (!o)
    return !1;
  let i = G1(o);
  return i ? kg(n, i, e) : !1;
}, gO = (n, e, t) => {
  let o = Mg(n, t);
  if (!o)
    return !1;
  let i = Y1(o);
  return i ? kg(n, i, e) : !1;
};
function kg(n, e, t) {
  let o = e.nodeBefore, i = o, r = e.pos - 1;
  for (; !i.isTextblock; r--) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.lastChild;
    if (!u)
      return !1;
    i = u;
  }
  let s = e.nodeAfter, a = s, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let d = $u(n.doc, r, l, he.empty);
  if (!d || d.from != r || d instanceof Dt && d.slice.size >= l - r)
    return !1;
  if (t) {
    let u = n.tr.step(d);
    u.setSelection(Te.create(u.doc, r)), t(u.scrollIntoView());
  }
  return !0;
}
function ss(n, e, t = !1) {
  for (let o = n; o; o = e == "start" ? o.firstChild : o.lastChild) {
    if (o.isTextblock)
      return !0;
    if (t && o.childCount != 1)
      return !1;
  }
  return !1;
}
const $g = (n, e, t) => {
  let { $head: o, empty: i } = n.selection, r = o;
  if (!i)
    return !1;
  if (o.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : o.parentOffset > 0)
      return !1;
    r = G1(o);
  }
  let s = r && r.nodeBefore;
  return !s || !xe.isSelectable(s) ? !1 : (e && e(n.tr.setSelection(xe.create(n.doc, r.pos - s.nodeSize)).scrollIntoView()), !0);
};
function G1(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Mg(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const Sg = (n, e, t) => {
  let o = Mg(n, t);
  if (!o)
    return !1;
  let i = Y1(o);
  if (!i)
    return !1;
  let r = i.nodeAfter;
  if (Ag(n, i, e, 1))
    return !0;
  if (o.parent.content.size == 0 && (ss(r, "start") || xe.isSelectable(r))) {
    let s = $u(n.doc, o.before(), o.after(), he.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let a = n.tr.step(s);
        a.setSelection(ss(r, "start") ? Le.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : xe.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return r.isAtom && i.depth == o.depth - 1 ? (e && e(n.tr.delete(i.pos, i.pos + r.nodeSize).scrollIntoView()), !0) : !1;
}, _g = (n, e, t) => {
  let { $head: o, empty: i } = n.selection, r = o;
  if (!i)
    return !1;
  if (o.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : o.parentOffset < o.parent.content.size)
      return !1;
    r = Y1(o);
  }
  let s = r && r.nodeAfter;
  return !s || !xe.isSelectable(s) ? !1 : (e && e(n.tr.setSelection(xe.create(n.doc, r.pos)).scrollIntoView()), !0);
};
function Y1(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const vO = (n, e) => {
  let t = n.selection, o = t instanceof xe, i;
  if (o) {
    if (t.node.isTextblock || !Ii(n.doc, t.from))
      return !1;
    i = t.from;
  } else if (i = ku(n.doc, t.from, -1), i == null)
    return !1;
  if (e) {
    let r = n.tr.join(i);
    o && r.setSelection(xe.create(r.doc, i - n.doc.resolve(i).nodeBefore.nodeSize)), e(r.scrollIntoView());
  }
  return !0;
}, bO = (n, e) => {
  let t = n.selection, o;
  if (t instanceof xe) {
    if (t.node.isTextblock || !Ii(n.doc, t.to))
      return !1;
    o = t.to;
  } else if (o = ku(n.doc, t.to, 1), o == null)
    return !1;
  return e && e(n.tr.join(o).scrollIntoView()), !0;
}, yO = (n, e) => {
  let { $from: t, $to: o } = n.selection, i = t.blockRange(o), r = i && ys(i);
  return r == null ? !1 : (e && e(n.tr.lift(i, r).scrollIntoView()), !0);
}, Eg = (n, e) => {
  let { $head: t, $anchor: o } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(o) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function q1(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const xO = (n, e) => {
  let { $head: t, $anchor: o } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(o))
    return !1;
  let i = t.node(-1), r = t.indexAfter(-1), s = q1(i.contentMatchAt(r));
  if (!s || !i.canReplaceWith(r, r, s))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, s.createAndFill());
    l.setSelection(Le.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, Og = (n, e) => {
  let t = n.selection, { $from: o, $to: i } = t;
  if (t instanceof On || o.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let r = q1(i.parent.contentMatchAt(i.indexAfter()));
  if (!r || !r.isTextblock)
    return !1;
  if (e) {
    let s = (!o.parentOffset && i.index() < i.parent.childCount ? o : i).pos, a = n.tr.insert(s, r.createAndFill());
    a.setSelection(Te.create(a.doc, s + 1)), e(a.scrollIntoView());
  }
  return !0;
}, Tg = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let r = t.before();
    if (Fo(n.doc, r))
      return e && e(n.tr.split(r).scrollIntoView()), !0;
  }
  let o = t.blockRange(), i = o && ys(o);
  return i == null ? !1 : (e && e(n.tr.lift(o, i).scrollIntoView()), !0);
};
function CO(n) {
  return (e, t) => {
    let { $from: o, $to: i } = e.selection;
    if (e.selection instanceof xe && e.selection.node.isBlock)
      return !o.parentOffset || !Fo(e.doc, o.pos) ? !1 : (t && t(e.tr.split(o.pos).scrollIntoView()), !0);
    if (!o.depth)
      return !1;
    let r = [], s, a, l = !1, d = !1;
    for (let h = o.depth; ; h--)
      if (o.node(h).isBlock) {
        l = o.end(h) == o.pos + (o.depth - h), d = o.start(h) == o.pos - (o.depth - h), a = q1(o.node(h - 1).contentMatchAt(o.indexAfter(h - 1))), r.unshift(l && a ? { type: a } : null), s = h;
        break;
      } else {
        if (h == 1)
          return !1;
        r.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof Te || e.selection instanceof On) && u.deleteSelection();
    let c = u.mapping.map(o.pos), f = Fo(u.doc, c, r.length, r);
    if (f || (r[0] = a ? { type: a } : null, f = Fo(u.doc, c, r.length, r)), !f)
      return !1;
    if (u.split(c, r.length, r), !l && d && o.node(s).type != a) {
      let h = u.mapping.map(o.before(s)), p = u.doc.resolve(h);
      a && o.node(s - 1).canReplaceWith(p.index(), p.index() + 1, a) && u.setNodeMarkup(u.mapping.map(o.before(s)), a);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const wO = CO(), kO = (n, e) => {
  let { $from: t, to: o } = n.selection, i, r = t.sharedDepth(o);
  return r == 0 ? !1 : (i = t.before(r), e && e(n.tr.setSelection(xe.create(n.doc, i))), !0);
};
function $O(n, e, t) {
  let o = e.nodeBefore, i = e.nodeAfter, r = e.index();
  return !o || !i || !o.type.compatibleContent(i.type) ? !1 : !o.content.size && e.parent.canReplace(r - 1, r) ? (t && t(n.tr.delete(e.pos - o.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(r, r + 1) || !(i.isTextblock || Ii(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function Ag(n, e, t, o) {
  let i = e.nodeBefore, r = e.nodeAfter, s, a, l = i.type.spec.isolating || r.type.spec.isolating;
  if (!l && $O(n, e, t))
    return !0;
  let d = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (d && (s = (a = i.contentMatchAt(i.childCount)).findWrapping(r.type)) && a.matchType(s[0] || r.type).validEnd) {
    if (t) {
      let h = e.pos + r.nodeSize, p = Q.empty;
      for (let b = s.length - 1; b >= 0; b--)
        p = Q.from(s[b].create(null, p));
      p = Q.from(i.copy(p));
      let m = n.tr.step(new Pt(e.pos - 1, h, e.pos, h, new he(p, 1, 0), s.length, !0)), g = m.doc.resolve(h + 2 * s.length);
      g.nodeAfter && g.nodeAfter.type == i.type && Ii(m.doc, g.pos) && m.join(g.pos), t(m.scrollIntoView());
    }
    return !0;
  }
  let u = r.type.spec.isolating || o > 0 && l ? null : Le.findFrom(e, 1), c = u && u.$from.blockRange(u.$to), f = c && ys(c);
  if (f != null && f >= e.depth)
    return t && t(n.tr.lift(c, f).scrollIntoView()), !0;
  if (d && ss(r, "start", !0) && ss(i, "end")) {
    let h = i, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let m = r, g = 1;
    for (; !m.isTextblock; m = m.firstChild)
      g++;
    if (h.canReplace(h.childCount, h.childCount, m.content)) {
      if (t) {
        let b = Q.empty;
        for (let w = p.length - 1; w >= 0; w--)
          b = Q.from(p[w].copy(b));
        let x = n.tr.step(new Pt(e.pos - p.length, e.pos + r.nodeSize, e.pos + g, e.pos + r.nodeSize - g, new he(b, p.length, 0), 0, !0));
        t(x.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Ig(n) {
  return function(e, t) {
    let o = e.selection, i = n < 0 ? o.$from : o.$to, r = i.depth;
    for (; i.node(r).isInline; ) {
      if (!r)
        return !1;
      r--;
    }
    return i.node(r).isTextblock ? (t && t(e.tr.setSelection(Te.create(e.doc, n < 0 ? i.start(r) : i.end(r)))), !0) : !1;
  };
}
const MO = Ig(-1), SO = Ig(1);
function _O(n, e = null) {
  return function(t, o) {
    let { $from: i, $to: r } = t.selection, s = i.blockRange(r), a = s && W1(s, n, e);
    return a ? (o && o(t.tr.wrap(s, a).scrollIntoView()), !0) : !1;
  };
}
function y3(n, e = null) {
  return function(t, o) {
    let i = !1;
    for (let r = 0; r < t.selection.ranges.length && !i; r++) {
      let { $from: { pos: s }, $to: { pos: a } } = t.selection.ranges[r];
      t.doc.nodesBetween(s, a, (l, d) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            i = !0;
          else {
            let u = t.doc.resolve(d), c = u.index();
            i = u.parent.canReplaceWith(c, c + 1, n);
          }
      });
    }
    if (!i)
      return !1;
    if (o) {
      let r = t.tr;
      for (let s = 0; s < t.selection.ranges.length; s++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[s];
        r.setBlockType(a, l, n, e);
      }
      o(r.scrollIntoView());
    }
    return !0;
  };
}
function Z1(...n) {
  return function(e, t, o) {
    for (let i = 0; i < n.length; i++)
      if (n[i](e, t, o))
        return !0;
    return !1;
  };
}
Z1(K1, wg, $g);
Z1(K1, Sg, _g);
Z1(Eg, Og, Tg, wO);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function EO(n, e = null) {
  return function(t, o) {
    let { $from: i, $to: r } = t.selection, s = i.blockRange(r);
    if (!s)
      return !1;
    let a = o ? t.tr : null;
    return OO(a, s, n, e) ? (o && o(a.scrollIntoView()), !0) : !1;
  };
}
function OO(n, e, t, o = null) {
  let i = !1, r = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    r = new id(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new id(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let a = W1(r, t, o, e);
  return a ? (n && TO(n, e, a, i, t), !0) : !1;
}
function TO(n, e, t, o, i) {
  let r = Q.empty;
  for (let u = t.length - 1; u >= 0; u--)
    r = Q.from(t[u].type.create(t[u].attrs, r));
  n.step(new Pt(e.start - (o ? 2 : 0), e.end, e.start, e.end, new he(r, 0, 0), t.length, !0));
  let s = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == i && (s = u + 1);
  let a = t.length - s, l = e.start + t.length - (o ? 2 : 0), d = e.parent;
  for (let u = e.startIndex, c = e.endIndex, f = !0; u < c; u++, f = !1)
    !f && Fo(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += d.child(u).nodeSize;
  return n;
}
function AO(n) {
  return function(e, t) {
    let { $from: o, $to: i } = e.selection, r = o.blockRange(i, (s) => s.childCount > 0 && s.firstChild.type == n);
    return r ? t ? o.node(r.depth - 1).type == n ? IO(e, t, n, r) : DO(e, t, r) : !0 : !1;
  };
}
function IO(n, e, t, o) {
  let i = n.tr, r = o.end, s = o.$to.end(o.depth);
  r < s && (i.step(new Pt(r - 1, s, r, s, new he(Q.from(t.create(null, o.parent.copy())), 1, 0), 1, !0)), o = new id(i.doc.resolve(o.$from.pos), i.doc.resolve(s), o.depth));
  const a = ys(o);
  if (a == null)
    return !1;
  i.lift(o, a);
  let l = i.doc.resolve(i.mapping.map(r, -1) - 1);
  return Ii(i.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && i.join(l.pos), e(i.scrollIntoView()), !0;
}
function DO(n, e, t) {
  let o = n.tr, i = t.parent;
  for (let h = t.end, p = t.endIndex - 1, m = t.startIndex; p > m; p--)
    h -= i.child(p).nodeSize, o.delete(h - 1, h + 1);
  let r = o.doc.resolve(t.start), s = r.nodeAfter;
  if (o.mapping.map(t.end) != t.start + r.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == i.childCount, d = r.node(-1), u = r.index(-1);
  if (!d.canReplace(u + (a ? 0 : 1), u + 1, s.content.append(l ? Q.empty : Q.from(i))))
    return !1;
  let c = r.pos, f = c + s.nodeSize;
  return o.step(new Pt(c - (a ? 1 : 0), f + (l ? 1 : 0), c + 1, f - 1, new he((a ? Q.empty : Q.from(i.copy(Q.empty))).append(l ? Q.empty : Q.from(i.copy(Q.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(o.scrollIntoView()), !0;
}
function NO(n) {
  return function(e, t) {
    let { $from: o, $to: i } = e.selection, r = o.blockRange(i, (d) => d.childCount > 0 && d.firstChild.type == n);
    if (!r)
      return !1;
    let s = r.startIndex;
    if (s == 0)
      return !1;
    let a = r.parent, l = a.child(s - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let d = l.lastChild && l.lastChild.type == a.type, u = Q.from(d ? n.create() : null), c = new he(Q.from(n.create(null, Q.from(a.type.create(null, u)))), d ? 3 : 1, 0), f = r.start, h = r.end;
      t(e.tr.step(new Pt(f - (d ? 3 : 1), h, f, h, c, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const zt = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, as = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Cf = null;
const Ao = function(n, e, t) {
  let o = Cf || (Cf = document.createRange());
  return o.setEnd(n, t ?? n.nodeValue.length), o.setStart(n, e || 0), o;
}, PO = function() {
  Cf = null;
}, ur = function(n, e, t, o) {
  return t && (x3(n, e, t, o, -1) || x3(n, e, t, o, 1));
}, LO = /^(img|br|input|textarea|hr)$/i;
function x3(n, e, t, o, i) {
  for (var r; ; ) {
    if (n == t && e == o)
      return !0;
    if (e == (i < 0 ? 0 : Vn(n))) {
      let s = n.parentNode;
      if (!s || s.nodeType != 1 || za(n) || LO.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = zt(n) + (i < 0 ? 0 : 1), n = s;
    } else if (n.nodeType == 1) {
      let s = n.childNodes[e + (i < 0 ? -1 : 0)];
      if (s.nodeType == 1 && s.contentEditable == "false")
        if (!((r = s.pmViewDesc) === null || r === void 0) && r.ignoreForSelection)
          e += i;
        else
          return !1;
      else
        n = s, e = i < 0 ? Vn(n) : 0;
    } else
      return !1;
  }
}
function Vn(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function RO(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = Vn(n);
    } else if (n.parentNode && !za(n))
      e = zt(n), n = n.parentNode;
    else
      return null;
  }
}
function FO(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !za(n))
      e = zt(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function BO(n, e, t) {
  for (let o = e == 0, i = e == Vn(n); o || i; ) {
    if (n == t)
      return !0;
    let r = zt(n);
    if (n = n.parentNode, !n)
      return !1;
    o = o && r == 0, i = i && r == Vn(n);
  }
}
function za(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const Su = function(n) {
  return n.focusNode && ur(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Ui(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function VO(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function zO(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let o = n.caretPositionFromPoint(e, t);
      if (o)
        return { node: o.offsetNode, offset: Math.min(Vn(o.offsetNode), o.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let o = n.caretRangeFromPoint(e, t);
    if (o)
      return { node: o.startContainer, offset: Math.min(Vn(o.startContainer), o.startOffset) };
  }
}
const yo = typeof navigator < "u" ? navigator : null, C3 = typeof document < "u" ? document : null, Di = yo && yo.userAgent || "", wf = /Edge\/(\d+)/.exec(Di), Dg = /MSIE \d/.exec(Di), kf = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Di), xn = !!(Dg || kf || wf), bi = Dg ? document.documentMode : kf ? +kf[1] : wf ? +wf[1] : 0, Wn = !xn && /gecko\/(\d+)/i.test(Di);
Wn && +(/Firefox\/(\d+)/.exec(Di) || [0, 0])[1];
const $f = !xn && /Chrome\/(\d+)/.exec(Di), jt = !!$f, Ng = $f ? +$f[1] : 0, Qt = !xn && !!yo && /Apple Computer/.test(yo.vendor), ls = Qt && (/Mobile\/\w+/.test(Di) || !!yo && yo.maxTouchPoints > 2), Fn = ls || (yo ? /Mac/.test(yo.platform) : !1), Pg = yo ? /Win/.test(yo.platform) : !1, Po = /Android \d/.test(Di), Ha = !!C3 && "webkitFontSmoothing" in C3.documentElement.style, HO = Ha ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function jO(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function $o(n, e) {
  return typeof n == "number" ? n : n[e];
}
function WO(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, o = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * o
  };
}
function w3(n, e, t) {
  let o = n.someProp("scrollThreshold") || 0, i = n.someProp("scrollMargin") || 5, r = n.dom.ownerDocument;
  for (let s = t || n.dom; s; ) {
    if (s.nodeType != 1) {
      s = as(s);
      continue;
    }
    let a = s, l = a == r.body, d = l ? jO(r) : WO(a), u = 0, c = 0;
    if (e.top < d.top + $o(o, "top") ? c = -(d.top - e.top + $o(i, "top")) : e.bottom > d.bottom - $o(o, "bottom") && (c = e.bottom - e.top > d.bottom - d.top ? e.top + $o(i, "top") - d.top : e.bottom - d.bottom + $o(i, "bottom")), e.left < d.left + $o(o, "left") ? u = -(d.left - e.left + $o(i, "left")) : e.right > d.right - $o(o, "right") && (u = e.right - d.right + $o(i, "right")), u || c)
      if (l)
        r.defaultView.scrollBy(u, c);
      else {
        let h = a.scrollLeft, p = a.scrollTop;
        c && (a.scrollTop += c), u && (a.scrollLeft += u);
        let m = a.scrollLeft - h, g = a.scrollTop - p;
        e = { left: e.left - m, top: e.top - g, right: e.right - m, bottom: e.bottom - g };
      }
    let f = l ? "fixed" : getComputedStyle(s).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    s = f == "absolute" ? s.offsetParent : as(s);
  }
}
function UO(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), o, i;
  for (let r = (e.left + e.right) / 2, s = t + 1; s < Math.min(innerHeight, e.bottom); s += 5) {
    let a = n.root.elementFromPoint(r, s);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      o = a, i = l.top;
      break;
    }
  }
  return { refDOM: o, refTop: i, stack: Lg(n.dom) };
}
function Lg(n) {
  let e = [], t = n.ownerDocument;
  for (let o = n; o && (e.push({ dom: o, top: o.scrollTop, left: o.scrollLeft }), n != t); o = as(o))
    ;
  return e;
}
function KO({ refDOM: n, refTop: e, stack: t }) {
  let o = n ? n.getBoundingClientRect().top : 0;
  Rg(t, o == 0 ? 0 : o - e);
}
function Rg(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: o, top: i, left: r } = n[t];
    o.scrollTop != i + e && (o.scrollTop = i + e), o.scrollLeft != r && (o.scrollLeft = r);
  }
}
let Er = null;
function GO(n) {
  if (n.setActive)
    return n.setActive();
  if (Er)
    return n.focus(Er);
  let e = Lg(n);
  n.focus(Er == null ? {
    get preventScroll() {
      return Er = { preventScroll: !0 }, !0;
    }
  } : void 0), Er || (Er = !1, Rg(e, 0));
}
function Fg(n, e) {
  let t, o = 2e8, i, r = 0, s = e.top, a = e.top, l, d;
  for (let u = n.firstChild, c = 0; u; u = u.nextSibling, c++) {
    let f;
    if (u.nodeType == 1)
      f = u.getClientRects();
    else if (u.nodeType == 3)
      f = Ao(u).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let p = f[h];
      if (p.top <= s && p.bottom >= a) {
        s = Math.max(p.bottom, s), a = Math.min(p.top, a);
        let m = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (m < o) {
          t = u, o = m, i = m && t.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && m && (r = c + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, d = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !t && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (r = c + 1);
    }
  }
  return !t && l && (t = l, i = d, o = 0), t && t.nodeType == 3 ? YO(t, i) : !t || o && t.nodeType == 1 ? { node: n, offset: r } : Fg(t, i);
}
function YO(n, e) {
  let t = n.nodeValue.length, o = document.createRange(), i;
  for (let r = 0; r < t; r++) {
    o.setEnd(n, r + 1), o.setStart(n, r);
    let s = oi(o, 1);
    if (s.top != s.bottom && J1(e, s)) {
      i = { node: n, offset: r + (e.left >= (s.left + s.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return o.detach(), i || { node: n, offset: 0 };
}
function J1(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function qO(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function ZO(n, e, t) {
  let { node: o, offset: i } = Fg(e, t), r = -1;
  if (o.nodeType == 1 && !o.firstChild) {
    let s = o.getBoundingClientRect();
    r = s.left != s.right && t.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(o, i, r);
}
function JO(n, e, t, o) {
  let i = -1;
  for (let r = e, s = !1; r != n.dom; ) {
    let a = n.docView.nearestDesc(r, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!s && l.left > o.left || l.top > o.top ? i = a.posBefore : (!s && l.right < o.left || l.bottom < o.top) && (i = a.posAfter), s = !0), !a.contentDOM && i < 0 && !a.node.isText))
      return (a.node.isBlock ? o.top < (l.top + l.bottom) / 2 : o.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    r = a.dom.parentNode;
  }
  return i > -1 ? i : n.docView.posFromDOM(e, t, -1);
}
function Bg(n, e, t) {
  let o = n.childNodes.length;
  if (o && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(o - 1, Math.floor(o * (e.top - t.top) / (t.bottom - t.top)) - 2)), r = i; ; ) {
      let s = n.childNodes[r];
      if (s.nodeType == 1) {
        let a = s.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let d = a[l];
          if (J1(e, d))
            return Bg(s, e, d);
        }
      }
      if ((r = (r + 1) % o) == i)
        break;
    }
  return n;
}
function XO(n, e) {
  let t = n.dom.ownerDocument, o, i = 0, r = zO(t, e.left, e.top);
  r && ({ node: o, offset: i } = r);
  let s = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!s || !n.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let d = n.dom.getBoundingClientRect();
    if (!J1(e, d) || (s = Bg(n.dom, e, d), !s))
      return null;
  }
  if (Qt)
    for (let d = s; o && d; d = as(d))
      d.draggable && (o = void 0);
  if (s = qO(s, e), o) {
    if (Wn && o.nodeType == 1 && (i = Math.min(i, o.childNodes.length), i < o.childNodes.length)) {
      let u = o.childNodes[i], c;
      u.nodeName == "IMG" && (c = u.getBoundingClientRect()).right <= e.left && c.bottom > e.top && i++;
    }
    let d;
    Ha && i && o.nodeType == 1 && (d = o.childNodes[i - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= e.top && i--, o == n.dom && i == o.childNodes.length - 1 && o.lastChild.nodeType == 1 && e.top > o.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (i == 0 || o.nodeType != 1 || o.childNodes[i - 1].nodeName != "BR") && (a = JO(n, o, i, e));
  }
  a == null && (a = ZO(n, s, e));
  let l = n.docView.nearestDesc(s, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function k3(n) {
  return n.top < n.bottom || n.left < n.right;
}
function oi(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let o = t[e < 0 ? 0 : t.length - 1];
    if (k3(o))
      return o;
  }
  return Array.prototype.find.call(t, k3) || n.getBoundingClientRect();
}
const QO = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Vg(n, e, t) {
  let { node: o, offset: i, atom: r } = n.docView.domFromPos(e, t < 0 ? -1 : 1), s = Ha || Wn;
  if (o.nodeType == 3)
    if (s && (QO.test(o.nodeValue) || (t < 0 ? !i : i == o.nodeValue.length))) {
      let l = oi(Ao(o, i, i), t);
      if (Wn && i && /\s/.test(o.nodeValue[i - 1]) && i < o.nodeValue.length) {
        let d = oi(Ao(o, i - 1, i - 1), -1);
        if (d.top == l.top) {
          let u = oi(Ao(o, i, i + 1), -1);
          if (u.top != l.top)
            return Ms(u, u.left < d.left);
        }
      }
      return l;
    } else {
      let l = i, d = i, u = t < 0 ? 1 : -1;
      return t < 0 && !i ? (d++, u = -1) : t >= 0 && i == o.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : d++, Ms(oi(Ao(o, l, d), u), u < 0);
    }
  if (!n.state.doc.resolve(e - (r || 0)).parent.inlineContent) {
    if (r == null && i && (t < 0 || i == Vn(o))) {
      let l = o.childNodes[i - 1];
      if (l.nodeType == 1)
        return hc(l.getBoundingClientRect(), !1);
    }
    if (r == null && i < Vn(o)) {
      let l = o.childNodes[i];
      if (l.nodeType == 1)
        return hc(l.getBoundingClientRect(), !0);
    }
    return hc(o.getBoundingClientRect(), t >= 0);
  }
  if (r == null && i && (t < 0 || i == Vn(o))) {
    let l = o.childNodes[i - 1], d = l.nodeType == 3 ? Ao(l, Vn(l) - (s ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (d)
      return Ms(oi(d, 1), !1);
  }
  if (r == null && i < Vn(o)) {
    let l = o.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let d = l ? l.nodeType == 3 ? Ao(l, 0, s ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (d)
      return Ms(oi(d, -1), !0);
  }
  return Ms(oi(o.nodeType == 3 ? Ao(o) : o, -t), t >= 0);
}
function Ms(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function hc(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function zg(n, e, t) {
  let o = n.state, i = n.root.activeElement;
  o != e && n.updateState(e), i != n.dom && n.focus();
  try {
    return t();
  } finally {
    o != e && n.updateState(o), i != n.dom && i && i.focus();
  }
}
function eT(n, e, t) {
  let o = e.selection, i = t == "up" ? o.$from : o.$to;
  return zg(n, e, () => {
    let { node: r } = n.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(r, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        r = a.contentDOM || a.dom;
        break;
      }
      r = a.dom.parentNode;
    }
    let s = Vg(n, i.pos, 1);
    for (let a = r.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = Ao(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < l.length; d++) {
        let u = l[d];
        if (u.bottom > u.top + 1 && (t == "up" ? s.top - u.top > (u.bottom - s.top) * 2 : u.bottom - s.bottom > (s.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const tT = /[\u0590-\u08ac]/;
function nT(n, e, t) {
  let { $head: o } = e.selection;
  if (!o.parent.isTextblock)
    return !1;
  let i = o.parentOffset, r = !i, s = i == o.parent.content.size, a = n.domSelection();
  return a ? !tT.test(o.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? r : s : zg(n, e, () => {
    let { focusNode: l, focusOffset: d, anchorNode: u, anchorOffset: c } = n.domSelectionRange(), f = a.caretBidiLevel;
    a.modify("move", t, "character");
    let h = o.depth ? n.docView.domAfterPos(o.before()) : n.dom, { focusNode: p, focusOffset: m } = n.domSelectionRange(), g = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && d == m;
    try {
      a.collapse(u, c), l && (l != u || d != c) && a.extend && a.extend(l, d);
    } catch {
    }
    return f != null && (a.caretBidiLevel = f), g;
  }) : o.pos == o.start() || o.pos == o.end();
}
let $3 = null, M3 = null, S3 = !1;
function oT(n, e, t) {
  return $3 == e && M3 == t ? S3 : ($3 = e, M3 = t, S3 = t == "up" || t == "down" ? eT(n, e, t) : nT(n, e, t));
}
const Un = 0, _3 = 1, Yi = 2, xo = 3;
class ja {
  constructor(e, t, o, i) {
    this.parent = e, this.children = t, this.dom = o, this.contentDOM = i, this.dirty = Un, o.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, o) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, o = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return o;
      o += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, o) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (o < 0) {
        let r, s;
        if (e == this.contentDOM)
          r = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          r = e.previousSibling;
        }
        for (; r && !((s = r.pmViewDesc) && s.parent == this); )
          r = r.previousSibling;
        return r ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let r, s;
        if (e == this.contentDOM)
          r = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          r = e.nextSibling;
        }
        for (; r && !((s = r.pmViewDesc) && s.parent == this); )
          r = r.nextSibling;
        return r ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > zt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let r = e; ; r = r.parentNode) {
          if (r == this.dom) {
            i = !1;
            break;
          }
          if (r.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let r = e; ; r = r.parentNode) {
          if (r == this.dom) {
            i = !0;
            break;
          }
          if (r.nextSibling)
            break;
        }
    }
    return i ?? o > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let o = !0, i = e; i; i = i.parentNode) {
      let r = this.getDesc(i), s;
      if (r && (!t || r.node))
        if (o && (s = r.nodeDOM) && !(s.nodeType == 1 ? s.contains(e.nodeType == 1 ? e : e.parentNode) : s == e))
          o = !1;
        else
          return r;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let o = t; o; o = o.parent)
      if (o == this)
        return t;
  }
  posFromDOM(e, t, o) {
    for (let i = e; i; i = i.parentNode) {
      let r = this.getDesc(i);
      if (r)
        return r.localPosFromDOM(e, t, o);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, o = 0; t < this.children.length; t++) {
      let i = this.children[t], r = o + i.size;
      if (o == e && r != o) {
        for (; !i.border && i.children.length; )
          for (let s = 0; s < i.children.length; s++) {
            let a = i.children[s];
            if (a.size) {
              i = a;
              break;
            }
          }
        return i;
      }
      if (e < r)
        return i.descAt(e - o - i.border);
      o = r;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let o = 0, i = 0;
    for (let r = 0; o < this.children.length; o++) {
      let s = this.children[o], a = r + s.size;
      if (a > e || s instanceof jg) {
        i = e - r;
        break;
      }
      r = a;
    }
    if (i)
      return this.children[o].domFromPos(i - this.children[o].border, t);
    for (let r; o && !(r = this.children[o - 1]).size && r instanceof Hg && r.side >= 0; o--)
      ;
    if (t <= 0) {
      let r, s = !0;
      for (; r = o ? this.children[o - 1] : null, !(!r || r.dom.parentNode == this.contentDOM); o--, s = !1)
        ;
      return r && t && s && !r.border && !r.domAtom ? r.domFromPos(r.size, t) : { node: this.contentDOM, offset: r ? zt(r.dom) + 1 : 0 };
    } else {
      let r, s = !0;
      for (; r = o < this.children.length ? this.children[o] : null, !(!r || r.dom.parentNode == this.contentDOM); o++, s = !1)
        ;
      return r && s && !r.border && !r.domAtom ? r.domFromPos(0, t) : { node: this.contentDOM, offset: r ? zt(r.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, o = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, r = -1;
    for (let s = o, a = 0; ; a++) {
      let l = this.children[a], d = s + l.size;
      if (i == -1 && e <= d) {
        let u = s + l.border;
        if (e >= u && t <= d - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = s;
        for (let c = a; c > 0; c--) {
          let f = this.children[c - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            i = zt(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (d > t || a == this.children.length - 1)) {
        t = d;
        for (let u = a + 1; u < this.children.length; u++) {
          let c = this.children[u];
          if (c.size && c.dom.parentNode == this.contentDOM && !c.emptyChildAt(-1)) {
            r = zt(c.dom);
            break;
          }
          t += c.size;
        }
        r == -1 && (r = this.contentDOM.childNodes.length);
        break;
      }
      s = d;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: r };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: o } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || o == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[o];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, o, i = !1) {
    let r = Math.min(e, t), s = Math.max(e, t);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let m = this.children[h], g = p + m.size;
      if (r > p && s < g)
        return m.setSelection(e - p - m.border, t - p - m.border, o, i);
      p = g;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), d = o.root.getSelection(), u = o.domSelectionRange(), c = !1;
    if ((Wn || Qt) && e == t) {
      let { node: h, offset: p } = a;
      if (h.nodeType == 3) {
        if (c = !!(p && h.nodeValue[p - 1] == `
`), c && p == h.nodeValue.length)
          for (let m = h, g; m; m = m.parentNode) {
            if (g = m.nextSibling) {
              g.nodeName == "BR" && (a = l = { node: g.parentNode, offset: zt(g) + 1 });
              break;
            }
            let b = m.pmViewDesc;
            if (b && b.node && b.node.isBlock)
              break;
          }
      } else {
        let m = h.childNodes[p - 1];
        c = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (Wn && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (i = !0);
    }
    if (!(i || c && Qt) && ur(a.node, a.offset, u.anchorNode, u.anchorOffset) && ur(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((d.extend || e == t) && !(c && Wn)) {
      d.collapse(a.node, a.offset);
      try {
        e != t && d.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > t) {
        let p = a;
        a = l, l = p;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(a.node, a.offset), d.removeAllRanges(), d.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let o = 0, i = 0; i < this.children.length; i++) {
      let r = this.children[i], s = o + r.size;
      if (o == s ? e <= s && t >= o : e < s && t > o) {
        let a = o + r.border, l = s - r.border;
        if (e >= a && t <= l) {
          this.dirty = e == o || t == s ? Yi : _3, e == a && t == l && (r.contentLost || r.dom.parentNode != this.contentDOM) ? r.dirty = xo : r.markDirty(e - a, t - a);
          return;
        } else
          r.dirty = r.dom == r.contentDOM && r.dom.parentNode == this.contentDOM && !r.children.length ? Yi : xo;
      }
      o = s;
    }
    this.dirty = Yi;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let o = e == 1 ? Yi : _3;
      t.dirty < o && (t.dirty = o);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class Hg extends ja {
  constructor(e, t, o, i) {
    let r, s = t.type.toDOM;
    if (typeof s == "function" && (s = s(o, () => {
      if (!r)
        return i;
      if (r.parent)
        return r.parent.posBeforeChild(r);
    })), !t.type.spec.raw) {
      if (s.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(s), s = a;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(e, [], s, null), this.widget = t, this.widget = t, r = this;
  }
  matchesWidget(e) {
    return this.dirty == Un && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class iT extends ja {
  constructor(e, t, o, i) {
    super(e, [], t, null), this.textDOM = o, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class cr extends ja {
  constructor(e, t, o, i, r) {
    super(e, [], o, i), this.mark = t, this.spec = r;
  }
  static create(e, t, o, i) {
    let r = i.nodeViews[t.type.name], s = r && r(t, i, o);
    return (!s || !s.dom) && (s = br.renderSpec(document, t.type.spec.toDOM(t, o), null, t.attrs)), new cr(e, t, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & xo || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != xo && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != Un) {
      let o = this.parent;
      for (; !o.node; )
        o = o.parent;
      o.dirty < this.dirty && (o.dirty = this.dirty), this.dirty = Un;
    }
  }
  slice(e, t, o) {
    let i = cr.create(this.parent, this.mark, !0, o), r = this.children, s = this.size;
    t < s && (r = Sf(r, t, s, o)), e > 0 && (r = Sf(r, 0, e, o));
    for (let a = 0; a < r.length; a++)
      r[a].parent = i;
    return i.children = r, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class yi extends ja {
  constructor(e, t, o, i, r, s, a, l, d) {
    super(e, [], r, s), this.node = t, this.outerDeco = o, this.innerDeco = i, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, o, i, r, s) {
    let a = r.nodeViews[t.type.name], l, d = a && a(t, r, () => {
      if (!l)
        return s;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, o, i), u = d && d.dom, c = d && d.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: c } = br.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !c && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let f = u;
    return u = Kg(u, o, t), d ? l = new rT(e, t, o, i, u, c || null, f, d, r, s + 1) : t.isText ? new _u(e, t, o, i, u, f, r) : new yi(e, t, o, i, u, c || null, f, r, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let o = this.children[t];
        if (this.dom.contains(o.dom.parentNode)) {
          e.contentElement = o.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => Q.empty);
    }
    return e;
  }
  matchesNode(e, t, o) {
    return this.dirty == Un && e.eq(this.node) && sd(t, this.outerDeco) && o.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let o = this.node.inlineContent, i = t, r = e.composing ? this.localCompositionInfo(e, t) : null, s = r && r.pos > -1 ? r : null, a = r && r.pos < 0, l = new aT(this, s && s.node, e);
    uT(this.node, this.innerDeco, (d, u, c) => {
      d.spec.marks ? l.syncToMarks(d.spec.marks, o, e, u) : d.type.side >= 0 && !c && l.syncToMarks(u == this.node.childCount ? ot.none : this.node.child(u).marks, o, e, u), l.placeWidget(d, e, i);
    }, (d, u, c, f) => {
      l.syncToMarks(d.marks, o, e, f);
      let h;
      l.findNodeMatch(d, u, c, f) || a && e.state.selection.from > i && e.state.selection.to < i + d.nodeSize && (h = l.findIndexWithChild(r.node)) > -1 && l.updateNodeAt(d, u, c, h, e) || l.updateNextNode(d, u, c, e, f, i) || l.addNode(d, u, c, e, i), i += d.nodeSize;
    }), l.syncToMarks([], o, e, 0), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Yi) && (s && this.protectLocalComposition(e, s), Wg(this.contentDOM, this.children, e), ls && cT(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: o, to: i } = e.state.selection;
    if (!(e.state.selection instanceof Te) || o < t || i > t + this.node.content.size)
      return null;
    let r = e.input.compositionNode;
    if (!r || !this.dom.contains(r.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = r.nodeValue, a = fT(this.node.content, s, o - t, i - t);
      return a < 0 ? null : { node: r, pos: a, text: s };
    } else
      return { node: r, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: o, text: i }) {
    if (this.getDesc(t))
      return;
    let r = t;
    for (; r.parentNode != this.contentDOM; r = r.parentNode) {
      for (; r.previousSibling; )
        r.parentNode.removeChild(r.previousSibling);
      for (; r.nextSibling; )
        r.parentNode.removeChild(r.nextSibling);
      r.pmViewDesc && (r.pmViewDesc = void 0);
    }
    let s = new iT(this, r, t, i);
    e.input.compositionNodes.push(s), this.children = Sf(this.children, o, o + i.length, e, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, o, i) {
    return this.dirty == xo || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, o, i), !0);
  }
  updateInner(e, t, o, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = o, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Un;
  }
  updateOuterDeco(e) {
    if (sd(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, o = this.dom;
    this.dom = Ug(this.dom, this.nodeDOM, Mf(this.outerDeco, this.node, t), Mf(e, this.node, t)), this.dom != o && (o.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function E3(n, e, t, o, i) {
  Kg(o, e, n);
  let r = new yi(void 0, n, e, t, o, o, o, i, 0);
  return r.contentDOM && r.updateChildren(i, 0), r;
}
class _u extends yi {
  constructor(e, t, o, i, r, s, a) {
    super(e, t, o, i, r, null, s, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, o, i) {
    return this.dirty == xo || this.dirty != Un && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Un || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Un, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, o) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, o);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, o) {
    let i = this.node.cut(e, t), r = document.createTextNode(i.text);
    return new _u(this.parent, i, this.outerDeco, this.innerDeco, r, r, o);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = xo);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class jg extends ja {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Un && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class rT extends yi {
  constructor(e, t, o, i, r, s, a, l, d, u) {
    super(e, t, o, i, r, s, a, d, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, o, i) {
    if (this.dirty == xo)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let r = this.spec.update(e, t, o);
      return r && this.updateInner(e, t, o, i), r;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, o, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, o, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, o.root) : super.setSelection(e, t, o, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function Wg(n, e, t) {
  let o = n.firstChild, i = !1;
  for (let r = 0; r < e.length; r++) {
    let s = e[r], a = s.dom;
    if (a.parentNode == n) {
      for (; a != o; )
        o = O3(o), i = !0;
      o = o.nextSibling;
    } else
      i = !0, n.insertBefore(a, o);
    if (s instanceof cr) {
      let l = o ? o.previousSibling : n.lastChild;
      Wg(s.contentDOM, s.children, t), o = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; o; )
    o = O3(o), i = !0;
  i && t.trackWrites == n && (t.trackWrites = null);
}
const Zs = function(n) {
  n && (this.nodeName = n);
};
Zs.prototype = /* @__PURE__ */ Object.create(null);
const qi = [new Zs()];
function Mf(n, e, t) {
  if (n.length == 0)
    return qi;
  let o = t ? qi[0] : new Zs(), i = [o];
  for (let r = 0; r < n.length; r++) {
    let s = n[r].type.attrs;
    if (s) {
      s.nodeName && i.push(o = new Zs(s.nodeName));
      for (let a in s) {
        let l = s[a];
        l != null && (t && i.length == 1 && i.push(o = new Zs(e.isInline ? "span" : "div")), a == "class" ? o.class = (o.class ? o.class + " " : "") + l : a == "style" ? o.style = (o.style ? o.style + ";" : "") + l : a != "nodeName" && (o[a] = l));
      }
    }
  }
  return i;
}
function Ug(n, e, t, o) {
  if (t == qi && o == qi)
    return e;
  let i = e;
  for (let r = 0; r < o.length; r++) {
    let s = o[r], a = t[r];
    if (r) {
      let l;
      a && a.nodeName == s.nodeName && i != n && (l = i.parentNode) && l.nodeName.toLowerCase() == s.nodeName || (l = document.createElement(s.nodeName), l.pmIsDeco = !0, l.appendChild(i), a = qi[0]), i = l;
    }
    sT(i, a || qi[0], s);
  }
  return i;
}
function sT(n, e, t) {
  for (let o in e)
    o != "class" && o != "style" && o != "nodeName" && !(o in t) && n.removeAttribute(o);
  for (let o in t)
    o != "class" && o != "style" && o != "nodeName" && t[o] != e[o] && n.setAttribute(o, t[o]);
  if (e.class != t.class) {
    let o = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let r = 0; r < o.length; r++)
      i.indexOf(o[r]) == -1 && n.classList.remove(o[r]);
    for (let r = 0; r < i.length; r++)
      o.indexOf(i[r]) == -1 && n.classList.add(i[r]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let o = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = o.exec(e.style); )
        n.style.removeProperty(i[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function Kg(n, e, t) {
  return Ug(n, n, qi, Mf(e, t, n.nodeType != 1));
}
function sd(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function O3(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class aT {
  constructor(e, t, o) {
    this.lock = t, this.view = o, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = lT(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let o = e; o < t; o++)
        this.top.children[o].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, o, i) {
    let r = 0, s = this.stack.length >> 1, a = Math.min(s, e.length);
    for (; r < a && (r == s - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && e[r].type.spec.spanning !== !1; )
      r++;
    for (; r < s; )
      this.destroyRest(), this.top.dirty = Un, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let l = -1, d = this.top.children.length;
      i < this.preMatch.index && (d = Math.min(this.index + 3, d));
      for (let u = this.index; u < d; u++) {
        let c = this.top.children[u];
        if (c.matchesMark(e[s]) && !this.isLocked(c.dom)) {
          l = u;
          break;
        }
      }
      if (l > -1)
        l > this.index && (this.changed = !0, this.destroyBetween(this.index, l)), this.top = this.top.children[this.index];
      else {
        let u = cr.create(this.top, e[s], t, o);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, o, i) {
    let r = -1, s;
    if (i >= this.preMatch.index && (s = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && s.matchesNode(e, t, o))
      r = this.top.children.indexOf(s, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let d = this.top.children[a];
        if (d.matchesNode(e, t, o) && !this.preMatch.matched.has(d)) {
          r = a;
          break;
        }
      }
    return r < 0 ? !1 : (this.destroyBetween(this.index, r), this.index++, !0);
  }
  updateNodeAt(e, t, o, i, r) {
    let s = this.top.children[i];
    return s.dirty == xo && s.dom == s.contentDOM && (s.dirty = Yi), s.update(e, t, o, r) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let o = e.pmViewDesc;
        if (o) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == o)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, o, i, r, s) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof yi) {
        let d = this.preMatch.matched.get(l);
        if (d != null && d != r)
          return !1;
        let u = l.dom, c, f = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != xo && sd(t, l.outerDeco));
        if (!f && l.update(e, t, o, i))
          return this.destroyBetween(this.index, a), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!f && (c = this.recreateWrapper(l, e, t, o, i, s)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = c, c.contentDOM && (c.dirty = Yi, c.updateChildren(i, s + 1), c.dirty = Un), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, o, i, r, s) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !sd(o, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let a = yi.create(this.top, t, o, i, r, s);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, o, i, r) {
    let s = yi.create(this.top, e, t, o, i, r);
    s.contentDOM && s.updateChildren(i, r + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(e, t, o) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let r = new Hg(this.top, e, t, o);
      this.top.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof cr; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof _u) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Qt || jt) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let o = document.createElement(e);
      e == "IMG" && (o.className = "ProseMirror-separator", o.alt = ""), e == "BR" && (o.className = "ProseMirror-trailingBreak");
      let i = new jg(this.top, [], o, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function lT(n, e) {
  let t = e, o = t.children.length, i = n.childCount, r = /* @__PURE__ */ new Map(), s = [];
  e: for (; i > 0; ) {
    let a;
    for (; ; )
      if (o) {
        let d = t.children[o - 1];
        if (d instanceof cr)
          t = d, o = d.children.length;
        else {
          a = d, o--;
          break;
        }
      } else {
        if (t == e)
          break e;
        o = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = a.node;
    if (l) {
      if (l != n.child(i - 1))
        break;
      --i, r.set(a, i), s.push(a);
    }
  }
  return { index: i, matched: r, matches: s.reverse() };
}
function dT(n, e) {
  return n.type.side - e.type.side;
}
function uT(n, e, t, o) {
  let i = e.locals(n), r = 0;
  if (i.length == 0) {
    for (let d = 0; d < n.childCount; d++) {
      let u = n.child(d);
      o(u, i, e.forChild(r, u), d), r += u.nodeSize;
    }
    return;
  }
  let s = 0, a = [], l = null;
  for (let d = 0; ; ) {
    let u, c;
    for (; s < i.length && i[s].to == r; ) {
      let g = i[s++];
      g.widget && (u ? (c || (c = [u])).push(g) : u = g);
    }
    if (u)
      if (c) {
        c.sort(dT);
        for (let g = 0; g < c.length; g++)
          t(c[g], d, !!l);
      } else
        t(u, d, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (d < n.childCount)
      h = d, f = n.child(d++);
    else
      break;
    for (let g = 0; g < a.length; g++)
      a[g].to <= r && a.splice(g--, 1);
    for (; s < i.length && i[s].from <= r && i[s].to > r; )
      a.push(i[s++]);
    let p = r + f.nodeSize;
    if (f.isText) {
      let g = p;
      s < i.length && i[s].from < g && (g = i[s].from);
      for (let b = 0; b < a.length; b++)
        a[b].to < g && (g = a[b].to);
      g < p && (l = f.cut(g - r), f = f.cut(0, g - r), p = g, h = -1);
    } else
      for (; s < i.length && i[s].to < p; )
        s++;
    let m = f.isInline && !f.isLeaf ? a.filter((g) => !g.inline) : a.slice();
    o(f, m, e.forChild(r, f), h), r = p;
  }
}
function cT(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function fT(n, e, t, o) {
  for (let i = 0, r = 0; i < n.childCount && r <= o; ) {
    let s = n.child(i++), a = r;
    if (r += s.nodeSize, !s.isText)
      continue;
    let l = s.text;
    for (; i < n.childCount; ) {
      let d = n.child(i++);
      if (r += d.nodeSize, !d.isText)
        break;
      l += d.text;
    }
    if (r >= t) {
      if (r >= o && l.slice(o - e.length - a, o - a) == e)
        return o - e.length;
      let d = a < o ? l.lastIndexOf(e, o - a - 1) : -1;
      if (d >= 0 && d + e.length + a >= t)
        return a + d;
      if (t == o && l.length >= o + e.length - a && l.slice(o - a, o - a + e.length) == e)
        return o;
    }
  }
  return -1;
}
function Sf(n, e, t, o, i) {
  let r = [];
  for (let s = 0, a = 0; s < n.length; s++) {
    let l = n[s], d = a, u = a += l.size;
    d >= t || u <= e ? r.push(l) : (d < e && r.push(l.slice(0, e - d, o)), i && (r.push(i), i = void 0), u > t && r.push(l.slice(t - d, l.size, o)));
  }
  return r;
}
function X1(n, e = null) {
  let t = n.domSelectionRange(), o = n.state.doc;
  if (!t.focusNode)
    return null;
  let i = n.docView.nearestDesc(t.focusNode), r = i && i.size == 0, s = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (s < 0)
    return null;
  let a = o.resolve(s), l, d;
  if (Su(t)) {
    for (l = s; i && !i.node; )
      i = i.parent;
    let c = i.node;
    if (i && c.isAtom && xe.isSelectable(c) && i.parent && !(c.isInline && BO(t.focusNode, t.focusOffset, i.dom))) {
      let f = i.posBefore;
      d = new xe(s == f ? a : o.resolve(f));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let c = s, f = s;
      for (let h = 0; h < t.rangeCount; h++) {
        let p = t.getRangeAt(h);
        c = Math.min(c, n.docView.posFromDOM(p.startContainer, p.startOffset, 1)), f = Math.max(f, n.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (c < 0)
        return null;
      [l, s] = f == n.state.selection.anchor ? [f, c] : [c, f], a = o.resolve(s);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = o.resolve(l);
  if (!d) {
    let c = e == "pointer" || n.state.selection.head < a.pos && !r ? 1 : -1;
    d = Q1(n, u, a, c);
  }
  return d;
}
function Gg(n) {
  return n.editable ? n.hasFocus() : qg(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function Bo(n, e = !1) {
  let t = n.state.selection;
  if (Yg(n, t), !!Gg(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && jt) {
      let o = n.domSelectionRange(), i = n.domObserver.currentSelection;
      if (o.anchorNode && i.anchorNode && ur(o.anchorNode, o.anchorOffset, i.anchorNode, i.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      pT(n);
    else {
      let { anchor: o, head: i } = t, r, s;
      T3 && !(t instanceof Te) && (t.$from.parent.inlineContent || (r = A3(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (s = A3(n, t.to))), n.docView.setSelection(o, i, n, e), T3 && (r && I3(r), s && I3(s)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && hT(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const T3 = Qt || jt && Ng < 63;
function A3(n, e) {
  let { node: t, offset: o } = n.docView.domFromPos(e, 0), i = o < t.childNodes.length ? t.childNodes[o] : null, r = o ? t.childNodes[o - 1] : null;
  if (Qt && i && i.contentEditable == "false")
    return pc(i);
  if ((!i || i.contentEditable == "false") && (!r || r.contentEditable == "false")) {
    if (i)
      return pc(i);
    if (r)
      return pc(r);
  }
}
function pc(n) {
  return n.contentEditable = "true", Qt && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function I3(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function hT(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), o = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != o || t.anchorOffset != i) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!Gg(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function pT(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, o = t.nodeName == "IMG";
  o ? e.collapse(t.parentNode, zt(t) + 1) : e.collapse(t, 0), !o && !n.state.selection.visible && xn && bi <= 11 && (t.disabled = !0, t.disabled = !1);
}
function Yg(n, e) {
  if (e instanceof xe) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (D3(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    D3(n);
}
function D3(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function Q1(n, e, t, o) {
  return n.someProp("createSelectionBetween", (i) => i(n, e, t)) || Te.between(e, t, o);
}
function N3(n) {
  return n.editable && !n.hasFocus() ? !1 : qg(n);
}
function qg(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function mT(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return ur(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function _f(n, e) {
  let { $anchor: t, $head: o } = n.selection, i = e > 0 ? t.max(o) : t.min(o), r = i.parent.inlineContent ? i.depth ? n.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return r && Le.findFrom(r, e);
}
function ii(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function P3(n, e, t) {
  let o = n.state.selection;
  if (o instanceof Te)
    if (t.indexOf("s") > -1) {
      let { $head: i } = o, r = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!r || r.isText || !r.isLeaf)
        return !1;
      let s = n.state.doc.resolve(i.pos + r.nodeSize * (e < 0 ? -1 : 1));
      return ii(n, new Te(o.$anchor, s));
    } else if (o.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = _f(n.state, e);
        return i && i instanceof xe ? ii(n, i) : !1;
      } else if (!(Fn && t.indexOf("m") > -1)) {
        let i = o.$head, r = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, s;
        if (!r || r.isText)
          return !1;
        let a = e < 0 ? i.pos - r.nodeSize : i.pos;
        return r.isAtom || (s = n.docView.descAt(a)) && !s.contentDOM ? xe.isSelectable(r) ? ii(n, new xe(e < 0 ? n.state.doc.resolve(i.pos - r.nodeSize) : i)) : Ha ? ii(n, new Te(n.state.doc.resolve(e < 0 ? a : a + r.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (o instanceof xe && o.node.isInline)
      return ii(n, new Te(e > 0 ? o.$to : o.$from));
    {
      let i = _f(n.state, e);
      return i ? ii(n, i) : !1;
    }
  }
}
function ad(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Js(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Or(n, e) {
  return e < 0 ? gT(n) : vT(n);
}
function gT(n) {
  let e = n.domSelectionRange(), t = e.focusNode, o = e.focusOffset;
  if (!t)
    return;
  let i, r, s = !1;
  for (Wn && t.nodeType == 1 && o < ad(t) && Js(t.childNodes[o], -1) && (s = !0); ; )
    if (o > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[o - 1];
        if (Js(a, -1))
          i = t, r = --o;
        else if (a.nodeType == 3)
          t = a, o = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Zg(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && Js(a, -1); )
          i = t.parentNode, r = zt(a), a = a.previousSibling;
        if (a)
          t = a, o = ad(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          o = 0;
        }
      }
    }
  s ? Ef(n, t, o) : i && Ef(n, i, r);
}
function vT(n) {
  let e = n.domSelectionRange(), t = e.focusNode, o = e.focusOffset;
  if (!t)
    return;
  let i = ad(t), r, s;
  for (; ; )
    if (o < i) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[o];
      if (Js(a, 1))
        r = t, s = ++o;
      else
        break;
    } else {
      if (Zg(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && Js(a, 1); )
          r = a.parentNode, s = zt(a) + 1, a = a.nextSibling;
        if (a)
          t = a, o = 0, i = ad(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          o = i = 0;
        }
      }
    }
  r && Ef(n, r, s);
}
function Zg(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function bT(n, e) {
  for (; n && e == n.childNodes.length && !za(n); )
    e = zt(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function yT(n, e) {
  for (; n && !e && !za(n); )
    e = zt(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Ef(n, e, t) {
  if (e.nodeType != 3) {
    let r, s;
    (s = bT(e, t)) ? (e = s, t = 0) : (r = yT(e, t)) && (e = r, t = r.nodeValue.length);
  }
  let o = n.domSelection();
  if (!o)
    return;
  if (Su(o)) {
    let r = document.createRange();
    r.setEnd(e, t), r.setStart(e, t), o.removeAllRanges(), o.addRange(r);
  } else o.extend && o.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: i } = n;
  setTimeout(() => {
    n.state == i && Bo(n);
  }, 50);
}
function L3(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(jt || Pg) && t.parent.inlineContent) {
    let i = n.coordsAtPos(e);
    if (e > t.start()) {
      let r = n.coordsAtPos(e - 1), s = (r.top + r.bottom) / 2;
      if (s > i.top && s < i.bottom && Math.abs(r.left - i.left) > 1)
        return r.left < i.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let r = n.coordsAtPos(e + 1), s = (r.top + r.bottom) / 2;
      if (s > i.top && s < i.bottom && Math.abs(r.left - i.left) > 1)
        return r.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function R3(n, e, t) {
  let o = n.state.selection;
  if (o instanceof Te && !o.empty || t.indexOf("s") > -1 || Fn && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: r } = o;
  if (!i.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = _f(n.state, e);
    if (s && s instanceof xe)
      return ii(n, s);
  }
  if (!i.parent.inlineContent) {
    let s = e < 0 ? i : r, a = o instanceof On ? Le.near(s, e) : Le.findFrom(s, e);
    return a ? ii(n, a) : !1;
  }
  return !1;
}
function F3(n, e) {
  if (!(n.state.selection instanceof Te))
    return !0;
  let { $head: t, $anchor: o, empty: i } = n.state.selection;
  if (!t.sameParent(o))
    return !0;
  if (!i)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let r = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (r && !r.isText) {
    let s = n.state.tr;
    return e < 0 ? s.delete(t.pos - r.nodeSize, t.pos) : s.delete(t.pos, t.pos + r.nodeSize), n.dispatch(s), !0;
  }
  return !1;
}
function B3(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function xT(n) {
  if (!Qt || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let o = e.firstChild;
    B3(n, o, "true"), setTimeout(() => B3(n, o, "false"), 20);
  }
  return !1;
}
function CT(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function wT(n, e) {
  let t = e.keyCode, o = CT(e);
  if (t == 8 || Fn && t == 72 && o == "c")
    return F3(n, -1) || Or(n, -1);
  if (t == 46 && !e.shiftKey || Fn && t == 68 && o == "c")
    return F3(n, 1) || Or(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || Fn && t == 66 && o == "c") {
    let i = t == 37 ? L3(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return P3(n, i, o) || Or(n, i);
  } else if (t == 39 || Fn && t == 70 && o == "c") {
    let i = t == 39 ? L3(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return P3(n, i, o) || Or(n, i);
  } else {
    if (t == 38 || Fn && t == 80 && o == "c")
      return R3(n, -1, o) || Or(n, -1);
    if (t == 40 || Fn && t == 78 && o == "c")
      return xT(n) || R3(n, 1, o) || Or(n, 1);
    if (o == (Fn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function eh(n, e) {
  n.someProp("transformCopied", (h) => {
    e = h(e, n);
  });
  let t = [], { content: o, openStart: i, openEnd: r } = e;
  for (; i > 1 && r > 1 && o.childCount == 1 && o.firstChild.childCount == 1; ) {
    i--, r--;
    let h = o.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), o = h.content;
  }
  let s = n.someProp("clipboardSerializer") || br.fromSchema(n.state.schema), a = n4(), l = a.createElement("div");
  l.appendChild(s.serializeFragment(o, { document: a }));
  let d = l.firstChild, u, c = 0;
  for (; d && d.nodeType == 1 && (u = t4[d.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = a.createElement(u[h]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), c++;
    }
    d = l.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${i} ${r}${c ? ` -${c}` : ""} ${JSON.stringify(t)}`);
  let f = n.someProp("clipboardTextSerializer", (h) => h(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function Jg(n, e, t, o, i) {
  let r = i.parent.type.spec.code, s, a;
  if (!t && !e)
    return null;
  let l = !!e && (o || r || !t);
  if (l) {
    if (n.someProp("transformPastedText", (f) => {
      e = f(e, r || o, n);
    }), r)
      return a = new he(Q.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (f) => {
        a = f(a, n, !0);
      }), a;
    let c = n.someProp("clipboardTextParser", (f) => f(e, i, o, n));
    if (c)
      a = c;
    else {
      let f = i.marks(), { schema: h } = n.state, p = br.fromSchema(h);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let g = s.appendChild(document.createElement("p"));
        m && g.appendChild(p.serializeNode(h.text(m, f)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (c) => {
      t = c(t, n);
    }), s = ST(t), Ha && _T(s);
  let d = s && s.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let c = +u[3]; c > 0; c--) {
      let f = s.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      s = f;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || vi.fromSchema(n.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(l || u),
    context: i,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !kT.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = ET(V3(a, +u[1], +u[2]), u[4]);
  else if (a = he.maxOpen($T(a.content, i), !0), a.openStart || a.openEnd) {
    let c = 0, f = 0;
    for (let h = a.content.firstChild; c < a.openStart && !h.type.spec.isolating; c++, h = h.firstChild)
      ;
    for (let h = a.content.lastChild; f < a.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    a = V3(a, c, f);
  }
  return n.someProp("transformPasted", (c) => {
    a = c(a, n, l);
  }), a;
}
const kT = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function $T(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), r, s = [];
    if (n.forEach((a) => {
      if (!s)
        return;
      let l = i.findWrapping(a.type), d;
      if (!l)
        return s = null;
      if (d = s.length && r.length && Qg(l, r, a, s[s.length - 1], 0))
        s[s.length - 1] = d;
      else {
        s.length && (s[s.length - 1] = e4(s[s.length - 1], r.length));
        let u = Xg(a, l);
        s.push(u), i = i.matchType(u.type), r = l;
      }
    }), s)
      return Q.from(s);
  }
  return n;
}
function Xg(n, e, t = 0) {
  for (let o = e.length - 1; o >= t; o--)
    n = e[o].create(null, Q.from(n));
  return n;
}
function Qg(n, e, t, o, i) {
  if (i < n.length && i < e.length && n[i] == e[i]) {
    let r = Qg(n, e, t, o.lastChild, i + 1);
    if (r)
      return o.copy(o.content.replaceChild(o.childCount - 1, r));
    if (o.contentMatchAt(o.childCount).matchType(i == n.length - 1 ? t.type : n[i + 1]))
      return o.copy(o.content.append(Q.from(Xg(t, n, i + 1))));
  }
}
function e4(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, e4(n.lastChild, e - 1)), o = n.contentMatchAt(n.childCount).fillBefore(Q.empty, !0);
  return n.copy(t.append(o));
}
function Of(n, e, t, o, i, r) {
  let s = e < 0 ? n.firstChild : n.lastChild, a = s.content;
  return n.childCount > 1 && (r = 0), i < o - 1 && (a = Of(a, e, t, o, i + 1, r)), i >= t && (a = e < 0 ? s.contentMatchAt(0).fillBefore(a, r <= i).append(a) : a.append(s.contentMatchAt(s.childCount).fillBefore(Q.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, s.copy(a));
}
function V3(n, e, t) {
  return e < n.openStart && (n = new he(Of(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new he(Of(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const t4 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let z3 = null;
function n4() {
  return z3 || (z3 = document.implementation.createHTMLDocument("title"));
}
let mc = null;
function MT(n) {
  let e = window.trustedTypes;
  return e ? (mc || (mc = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), mc.createHTML(n)) : n;
}
function ST(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = n4().createElement("div"), o = /<([a-z][^>\s]+)/i.exec(n), i;
  if ((i = o && t4[o[1].toLowerCase()]) && (n = i.map((r) => "<" + r + ">").join("") + n + i.map((r) => "</" + r + ">").reverse().join("")), t.innerHTML = MT(n), i)
    for (let r = 0; r < i.length; r++)
      t = t.querySelector(i[r]) || t;
  return t;
}
function _T(n) {
  let e = n.querySelectorAll(jt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let o = e[t];
    o.childNodes.length == 1 && o.textContent == " " && o.parentNode && o.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), o);
  }
}
function ET(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, o;
  try {
    o = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: i, openStart: r, openEnd: s } = n;
  for (let a = o.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[o[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = Q.from(l.create(o[a + 1], i)), r++, s++;
  }
  return new he(i, r, s);
}
const dn = {}, un = {}, OT = { touchstart: !0, touchmove: !0 };
class TT {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function AT(n) {
  for (let e in dn) {
    let t = dn[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (o) => {
      DT(n, o) && !th(n, o) && (n.editable || !(o.type in un)) && t(n, o);
    }, OT[e] ? { passive: !0 } : void 0);
  }
  Qt && n.dom.addEventListener("input", () => null), Tf(n);
}
function ci(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function IT(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Tf(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (o) => th(n, o));
  });
}
function th(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let o = t[e.type];
    return o ? o(n, e) || e.defaultPrevented : !1;
  });
}
function DT(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function NT(n, e) {
  !th(n, e) && dn[e.type] && (n.editable || !(e.type in un)) && dn[e.type](n, e);
}
un.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !i4(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(Po && jt && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), ls && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let o = Date.now();
      n.input.lastIOSEnter = o, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == o && (n.someProp("handleKeyDown", (i) => i(n, Ui(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (o) => o(n, t)) || wT(n, t) ? t.preventDefault() : ci(n, "key");
};
un.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
un.keypress = (n, e) => {
  let t = e;
  if (i4(n, t) || !t.charCode || t.ctrlKey && !t.altKey || Fn && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (i) => i(n, t))) {
    t.preventDefault();
    return;
  }
  let o = n.state.selection;
  if (!(o instanceof Te) || !o.$from.sameParent(o.$to)) {
    let i = String.fromCharCode(t.charCode), r = () => n.state.tr.insertText(i).scrollIntoView();
    !/[\r\n]/.test(i) && !n.someProp("handleTextInput", (s) => s(n, o.$from.pos, o.$to.pos, i, r)) && n.dispatch(r()), t.preventDefault();
  }
};
function Eu(n) {
  return { left: n.clientX, top: n.clientY };
}
function PT(n, e) {
  let t = e.x - n.clientX, o = e.y - n.clientY;
  return t * t + o * o < 100;
}
function nh(n, e, t, o, i) {
  if (o == -1)
    return !1;
  let r = n.state.doc.resolve(o);
  for (let s = r.depth + 1; s > 0; s--)
    if (n.someProp(e, (a) => s > r.depth ? a(n, t, r.nodeAfter, r.before(s), i, !0) : a(n, t, r.node(s), r.before(s), i, !1)))
      return !0;
  return !1;
}
function Ur(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let o = n.state.tr.setSelection(e);
  o.setMeta("pointer", !0), n.dispatch(o);
}
function LT(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), o = t.nodeAfter;
  return o && o.isAtom && xe.isSelectable(o) ? (Ur(n, new xe(t)), !0) : !1;
}
function RT(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, o, i;
  t instanceof xe && (o = t.node);
  let r = n.state.doc.resolve(e);
  for (let s = r.depth + 1; s > 0; s--) {
    let a = s > r.depth ? r.nodeAfter : r.node(s);
    if (xe.isSelectable(a)) {
      o && t.$from.depth > 0 && s >= t.$from.depth && r.before(t.$from.depth + 1) == t.$from.pos ? i = r.before(t.$from.depth) : i = r.before(s);
      break;
    }
  }
  return i != null ? (Ur(n, xe.create(n.state.doc, i)), !0) : !1;
}
function FT(n, e, t, o, i) {
  return nh(n, "handleClickOn", e, t, o) || n.someProp("handleClick", (r) => r(n, e, o)) || (i ? RT(n, t) : LT(n, t));
}
function BT(n, e, t, o) {
  return nh(n, "handleDoubleClickOn", e, t, o) || n.someProp("handleDoubleClick", (i) => i(n, e, o));
}
function VT(n, e, t, o) {
  return nh(n, "handleTripleClickOn", e, t, o) || n.someProp("handleTripleClick", (i) => i(n, e, o)) || zT(n, t, o);
}
function zT(n, e, t) {
  if (t.button != 0)
    return !1;
  let o = n.state.doc;
  if (e == -1)
    return o.inlineContent ? (Ur(n, Te.create(o, 0, o.content.size)), !0) : !1;
  let i = o.resolve(e);
  for (let r = i.depth + 1; r > 0; r--) {
    let s = r > i.depth ? i.nodeAfter : i.node(r), a = i.before(r);
    if (s.inlineContent)
      Ur(n, Te.create(o, a + 1, a + 1 + s.content.size));
    else if (xe.isSelectable(s))
      Ur(n, xe.create(o, a));
    else
      continue;
    return !0;
  }
}
function oh(n) {
  return ld(n);
}
const o4 = Fn ? "metaKey" : "ctrlKey";
dn.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let o = oh(n), i = Date.now(), r = "singleClick";
  i - n.input.lastClick.time < 500 && PT(t, n.input.lastClick) && !t[o4] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? r = "doubleClick" : n.input.lastClick.type == "doubleClick" && (r = "tripleClick")), n.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: r, button: t.button };
  let s = n.posAtCoords(Eu(t));
  s && (r == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new HT(n, s, t, !!o)) : (r == "doubleClick" ? BT : VT)(n, s.pos, s.inside, t) ? t.preventDefault() : ci(n, "pointer"));
};
class HT {
  constructor(e, t, o, i) {
    this.view = e, this.pos = t, this.event = o, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!o[o4], this.allowDefault = o.shiftKey;
    let r, s;
    if (t.inside > -1)
      r = e.state.doc.nodeAt(t.inside), s = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      r = u.parent, s = u.depth ? u.before() : 0;
    }
    const a = i ? null : o.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.nodeDOM.nodeType == 1 ? l.nodeDOM : null;
    let { selection: d } = e.state;
    (o.button == 0 && r.type.spec.draggable && r.type.spec.selectable !== !1 || d instanceof xe && d.from <= s && d.to > s) && (this.mightDrag = {
      node: r,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Wn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ci(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Bo(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Eu(e))), this.updateAllowDefault(e), this.allowDefault || !t ? ci(this.view, "pointer") : FT(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Qt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    jt && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Ur(this.view, Le.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : ci(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ci(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
dn.touchstart = (n) => {
  n.input.lastTouch = Date.now(), oh(n), ci(n, "pointer");
};
dn.touchmove = (n) => {
  n.input.lastTouch = Date.now(), ci(n, "pointer");
};
dn.contextmenu = (n) => oh(n);
function i4(n, e) {
  return n.composing ? !0 : Qt && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const jT = Po ? 5e3 : -1;
un.compositionstart = un.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof Te && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((o) => o.type.spec.inclusive === !1) || jt && Pg && WT(n)))
      n.markCursor = n.state.storedMarks || t.marks(), ld(n, !0), n.markCursor = null;
    else if (ld(n, !e.selection.empty), Wn && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let o = n.domSelectionRange();
      for (let i = o.focusNode, r = o.focusOffset; i && i.nodeType == 1 && r != 0; ) {
        let s = r < 0 ? i.lastChild : i.childNodes[r - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(s, s.nodeValue.length);
          break;
        } else
          i = s, r = -1;
      }
    }
    n.input.composing = !0;
  }
  r4(n, jT);
};
function WT(n) {
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (!e || e.nodeType != 1 || t >= e.childNodes.length)
    return !1;
  let o = e.childNodes[t];
  return o.nodeType == 1 && o.contentEditable == "false";
}
un.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.badSafariComposition ? n.domObserver.forceFlush() : n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, r4(n, 20));
};
function r4(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => ld(n), e));
}
function s4(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = KT()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function UT(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = RO(e.focusNode, e.focusOffset), o = FO(e.focusNode, e.focusOffset);
  if (t && o && t != o) {
    let i = o.pmViewDesc, r = n.domObserver.lastChangedTextNode;
    if (t == r || o == r)
      return r;
    if (!i || !i.isText(o.nodeValue))
      return o;
    if (n.input.compositionNode == o) {
      let s = t.pmViewDesc;
      if (!(!s || !s.isText(t.nodeValue)))
        return o;
    }
  }
  return t || o;
}
function KT() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function ld(n, e = !1) {
  if (!(Po && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), s4(n), e || n.docView && n.docView.dirty) {
      let t = X1(n), o = n.state.selection;
      return t && !t.eq(o) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !o.$from.node(o.$from.sharedDepth(o.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function GT(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let o = getSelection(), i = document.createRange();
  i.selectNodeContents(e), n.dom.blur(), o.removeAllRanges(), o.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const Ca = xn && bi < 15 || ls && HO < 604;
dn.copy = un.cut = (n, e) => {
  let t = e, o = n.state.selection, i = t.type == "cut";
  if (o.empty)
    return;
  let r = Ca ? null : t.clipboardData, s = o.content(), { dom: a, text: l } = eh(n, s);
  r ? (t.preventDefault(), r.clearData(), r.setData("text/html", a.innerHTML), r.setData("text/plain", l)) : GT(n, a), i && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function YT(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function qT(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, o = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (o.contentEditable = "true"), o.style.cssText = "position: fixed; left: -10000px; top: 10px", o.focus();
  let i = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), o.parentNode && o.parentNode.removeChild(o), t ? wa(n, o.value, null, i, e) : wa(n, o.textContent, o.innerHTML, i, e);
  }, 50);
}
function wa(n, e, t, o, i) {
  let r = Jg(n, e, t, o, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, i, r || he.empty)))
    return !0;
  if (!r)
    return !1;
  let s = YT(r), a = s ? n.state.tr.replaceSelectionWith(s, o) : n.state.tr.replaceSelection(r);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function a4(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
un.paste = (n, e) => {
  let t = e;
  if (n.composing && !Po)
    return;
  let o = Ca ? null : t.clipboardData, i = n.input.shiftKey && n.input.lastKeyCode != 45;
  o && wa(n, a4(o), o.getData("text/html"), i, t) ? t.preventDefault() : qT(n, t);
};
class l4 {
  constructor(e, t, o) {
    this.slice = e, this.move = t, this.node = o;
  }
}
const ZT = Fn ? "altKey" : "ctrlKey";
function d4(n, e) {
  let t = n.someProp("dragCopies", (o) => !o(e));
  return t ?? !e[ZT];
}
dn.dragstart = (n, e) => {
  let t = e, o = n.input.mouseDown;
  if (o && o.done(), !t.dataTransfer)
    return;
  let i = n.state.selection, r = i.empty ? null : n.posAtCoords(Eu(t)), s;
  if (!(r && r.pos >= i.from && r.pos <= (i instanceof xe ? i.to - 1 : i.to))) {
    if (o && o.mightDrag)
      s = xe.create(n.state.doc, o.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let c = n.docView.nearestDesc(t.target, !0);
      c && c.node.type.spec.draggable && c != n.docView && (s = xe.create(n.state.doc, c.posBefore));
    }
  }
  let a = (s || n.state.selection).content(), { dom: l, text: d, slice: u } = eh(n, a);
  (!t.dataTransfer.files.length || !jt || Ng > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(Ca ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Ca || t.dataTransfer.setData("text/plain", d), n.dragging = new l4(u, d4(n, t), s);
};
dn.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
un.dragover = un.dragenter = (n, e) => e.preventDefault();
un.drop = (n, e) => {
  try {
    JT(n, e, n.dragging);
  } finally {
    n.dragging = null;
  }
};
function JT(n, e, t) {
  if (!e.dataTransfer)
    return;
  let o = n.posAtCoords(Eu(e));
  if (!o)
    return;
  let i = n.state.doc.resolve(o.pos), r = t && t.slice;
  r ? n.someProp("transformPasted", (h) => {
    r = h(r, n, !1);
  }) : r = Jg(n, a4(e.dataTransfer), Ca ? null : e.dataTransfer.getData("text/html"), !1, i);
  let s = !!(t && d4(n, e));
  if (n.someProp("handleDrop", (h) => h(n, e, r || he.empty, s))) {
    e.preventDefault();
    return;
  }
  if (!r)
    return;
  e.preventDefault();
  let a = r ? hg(n.state.doc, i.pos, r) : i.pos;
  a == null && (a = i.pos);
  let l = n.state.tr;
  if (s) {
    let { node: h } = t;
    h ? h.replace(l) : l.deleteSelection();
  }
  let d = l.mapping.map(a), u = r.openStart == 0 && r.openEnd == 0 && r.content.childCount == 1, c = l.doc;
  if (u ? l.replaceRangeWith(d, d, r.content.firstChild) : l.replaceRange(d, d, r), l.doc.eq(c))
    return;
  let f = l.doc.resolve(d);
  if (u && xe.isSelectable(r.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(r.content.firstChild))
    l.setSelection(new xe(f));
  else {
    let h = l.mapping.map(a);
    l.mapping.maps[l.mapping.maps.length - 1].forEach((p, m, g, b) => h = b), l.setSelection(Q1(n, f, l.doc.resolve(h)));
  }
  n.focus(), n.dispatch(l.setMeta("uiEvent", "drop"));
}
dn.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && Bo(n);
  }, 20));
};
dn.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
dn.beforeinput = (n, e) => {
  if (jt && Po && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: o } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != o || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (r) => r(n, Ui(8, "Backspace")))))
        return;
      let { $cursor: i } = n.state.selection;
      i && i.pos > 0 && n.dispatch(n.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in un)
  dn[n] = un[n];
function ka(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class dd {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || tr, this.side = this.spec.side || 0;
  }
  map(e, t, o, i) {
    let { pos: r, deleted: s } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return s ? null : new ln(r - o, r - o, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof dd && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && ka(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class xi {
  constructor(e, t) {
    this.attrs = e, this.spec = t || tr;
  }
  map(e, t, o, i) {
    let r = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - o, s = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - o;
    return r >= s ? null : new ln(r, s, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof xi && ka(this.attrs, e.attrs) && ka(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof xi;
  }
  destroy() {
  }
}
class ih {
  constructor(e, t) {
    this.attrs = e, this.spec = t || tr;
  }
  map(e, t, o, i) {
    let r = e.mapResult(t.from + i, 1);
    if (r.deleted)
      return null;
    let s = e.mapResult(t.to + i, -1);
    return s.deleted || s.pos <= r.pos ? null : new ln(r.pos - o, s.pos - o, this);
  }
  valid(e, t) {
    let { index: o, offset: i } = e.content.findIndex(t.from), r;
    return i == t.from && !(r = e.child(o)).isText && i + r.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof ih && ka(this.attrs, e.attrs) && ka(this.spec, e.spec);
  }
  destroy() {
  }
}
class ln {
  /**
  @internal
  */
  constructor(e, t, o) {
    this.from = e, this.to = t, this.type = o;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new ln(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, o) {
    return this.type.map(e, this, t, o);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, o) {
    return new ln(e, e, new dd(t, o));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, o, i) {
    return new ln(e, t, new xi(o, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, o, i) {
    return new ln(e, t, new ih(o, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof xi;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof dd;
  }
}
const Rr = [], tr = {};
class ht {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Rr, this.children = t.length ? t : Rr;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? ud(t, e, 0, tr) : Gt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, o) {
    let i = [];
    return this.findInner(e ?? 0, t ?? 1e9, i, 0, o), i;
  }
  findInner(e, t, o, i, r) {
    for (let s = 0; s < this.local.length; s++) {
      let a = this.local[s];
      a.from <= t && a.to >= e && (!r || r(a.spec)) && o.push(a.copy(a.from + i, a.to + i));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < t && this.children[s + 1] > e) {
        let a = this.children[s] + 1;
        this.children[s + 2].findInner(e - a, t - a, o, i + a, r);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, o) {
    return this == Gt || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, o || tr);
  }
  /**
  @internal
  */
  mapInner(e, t, o, i, r) {
    let s;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, o, i);
      l && l.type.valid(t, l) ? (s || (s = [])).push(l) : r.onRemove && r.onRemove(this.local[a].spec);
    }
    return this.children.length ? XT(this.children, s || [], e, t, o, i, r) : s ? new ht(s.sort(nr), Rr) : Gt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Gt ? ht.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, o) {
    let i, r = 0;
    e.forEach((a, l) => {
      let d = l + o, u;
      if (u = c4(t, a, d)) {
        for (i || (i = this.children.slice()); r < i.length && i[r] < l; )
          r += 3;
        i[r] == l ? i[r + 2] = i[r + 2].addInner(a, u, d + 1) : i.splice(r, 0, l, l + a.nodeSize, ud(u, a, d + 1, tr)), r += 3;
      }
    });
    let s = u4(r ? f4(t) : t, -o);
    for (let a = 0; a < s.length; a++)
      s[a].type.valid(e, s[a]) || s.splice(a--, 1);
    return new ht(s.length ? this.local.concat(s).sort(nr) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Gt ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let o = this.children, i = this.local;
    for (let r = 0; r < o.length; r += 3) {
      let s, a = o[r] + t, l = o[r + 1] + t;
      for (let u = 0, c; u < e.length; u++)
        (c = e[u]) && c.from > a && c.to < l && (e[u] = null, (s || (s = [])).push(c));
      if (!s)
        continue;
      o == this.children && (o = this.children.slice());
      let d = o[r + 2].removeInner(s, a + 1);
      d != Gt ? o[r + 2] = d : (o.splice(r, 3), r -= 3);
    }
    if (i.length) {
      for (let r = 0, s; r < e.length; r++)
        if (s = e[r])
          for (let a = 0; a < i.length; a++)
            i[a].eq(s, t) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return o == this.children && i == this.local ? this : i.length || o.length ? new ht(i, o) : Gt;
  }
  forChild(e, t) {
    if (this == Gt)
      return this;
    if (t.isLeaf)
      return ht.empty;
    let o, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (o = this.children[a + 2]);
        break;
      }
    let r = e + 1, s = r + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < s && l.to > r && l.type instanceof xi) {
        let d = Math.max(r, l.from) - r, u = Math.min(s, l.to) - r;
        d < u && (i || (i = [])).push(l.copy(d, u));
      }
    }
    if (i) {
      let a = new ht(i.sort(nr), Rr);
      return o ? new ai([a, o]) : a;
    }
    return o || Gt;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof ht) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return rh(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Gt)
      return Rr;
    if (e.inlineContent || !this.local.some(xi.is))
      return this.local;
    let t = [];
    for (let o = 0; o < this.local.length; o++)
      this.local[o].type instanceof xi || t.push(this.local[o]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
ht.empty = new ht([], []);
ht.removeOverlap = rh;
const Gt = ht.empty;
class ai {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const o = this.members.map((i) => i.map(e, t, tr));
    return ai.from(o);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return ht.empty;
    let o = [];
    for (let i = 0; i < this.members.length; i++) {
      let r = this.members[i].forChild(e, t);
      r != Gt && (r instanceof ai ? o = o.concat(r.members) : o.push(r));
    }
    return ai.from(o);
  }
  eq(e) {
    if (!(e instanceof ai) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, o = !0;
    for (let i = 0; i < this.members.length; i++) {
      let r = this.members[i].localsInner(e);
      if (r.length)
        if (!t)
          t = r;
        else {
          o && (t = t.slice(), o = !1);
          for (let s = 0; s < r.length; s++)
            t.push(r[s]);
        }
    }
    return t ? rh(o ? t : t.sort(nr)) : Rr;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Gt;
      case 1:
        return e[0];
      default:
        return new ai(e.every((t) => t instanceof ht) ? e : e.reduce((t, o) => t.concat(o instanceof ht ? o : o.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function XT(n, e, t, o, i, r, s) {
  let a = n.slice();
  for (let d = 0, u = r; d < t.maps.length; d++) {
    let c = 0;
    t.maps[d].forEach((f, h, p, m) => {
      let g = m - p - (h - f);
      for (let b = 0; b < a.length; b += 3) {
        let x = a[b + 1];
        if (x < 0 || f > x + u - c)
          continue;
        let w = a[b] + u - c;
        h >= w ? a[b + 1] = f <= w ? -2 : -1 : f >= u && g && (a[b] += g, a[b + 1] += g);
      }
      c += g;
    }), u = t.maps[d].map(u, -1);
  }
  let l = !1;
  for (let d = 0; d < a.length; d += 3)
    if (a[d + 1] < 0) {
      if (a[d + 1] == -2) {
        l = !0, a[d + 1] = -1;
        continue;
      }
      let u = t.map(n[d] + r), c = u - i;
      if (c < 0 || c >= o.content.size) {
        l = !0;
        continue;
      }
      let f = t.map(n[d + 1] + r, -1), h = f - i, { index: p, offset: m } = o.content.findIndex(c), g = o.maybeChild(p);
      if (g && m == c && m + g.nodeSize == h) {
        let b = a[d + 2].mapInner(t, g, u + 1, n[d] + r + 1, s);
        b != Gt ? (a[d] = c, a[d + 1] = h, a[d + 2] = b) : (a[d + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let d = QT(a, n, e, t, i, r, s), u = ud(d, o, 0, s);
    e = u.local;
    for (let c = 0; c < a.length; c += 3)
      a[c + 1] < 0 && (a.splice(c, 3), c -= 3);
    for (let c = 0, f = 0; c < u.children.length; c += 3) {
      let h = u.children[c];
      for (; f < a.length && a[f] < h; )
        f += 3;
      a.splice(f, 0, u.children[c], u.children[c + 1], u.children[c + 2]);
    }
  }
  return new ht(e.sort(nr), a);
}
function u4(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let o = 0; o < n.length; o++) {
    let i = n[o];
    t.push(new ln(i.from + e, i.to + e, i.type));
  }
  return t;
}
function QT(n, e, t, o, i, r, s) {
  function a(l, d) {
    for (let u = 0; u < l.local.length; u++) {
      let c = l.local[u].map(o, i, d);
      c ? t.push(c) : s.onRemove && s.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      a(l.children[u + 2], l.children[u] + d + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + r + 1);
  return t;
}
function c4(n, e, t) {
  if (e.isLeaf)
    return null;
  let o = t + e.nodeSize, i = null;
  for (let r = 0, s; r < n.length; r++)
    (s = n[r]) && s.from > t && s.to < o && ((i || (i = [])).push(s), n[r] = null);
  return i;
}
function f4(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function ud(n, e, t, o) {
  let i = [], r = !1;
  e.forEach((a, l) => {
    let d = c4(n, a, l + t);
    if (d) {
      r = !0;
      let u = ud(d, a, t + l + 1, o);
      u != Gt && i.push(l, l + a.nodeSize, u);
    }
  });
  let s = u4(r ? f4(n) : n, -t).sort(nr);
  for (let a = 0; a < s.length; a++)
    s[a].type.valid(e, s[a]) || (o.onRemove && o.onRemove(s[a].spec), s.splice(a--, 1));
  return s.length || i.length ? new ht(s, i) : Gt;
}
function nr(n, e) {
  return n.from - e.from || n.to - e.to;
}
function rh(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let o = e[t];
    if (o.from != o.to)
      for (let i = t + 1; i < e.length; i++) {
        let r = e[i];
        if (r.from == o.from) {
          r.to != o.to && (e == n && (e = n.slice()), e[i] = r.copy(r.from, o.to), H3(e, i + 1, r.copy(o.to, r.to)));
          continue;
        } else {
          r.from < o.to && (e == n && (e = n.slice()), e[t] = o.copy(o.from, r.from), H3(e, i, o.copy(r.from, o.to)));
          break;
        }
      }
  }
  return e;
}
function H3(n, e, t) {
  for (; e < n.length && nr(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function gc(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let o = t(n.state);
    o && o != Gt && e.push(o);
  }), n.cursorWrapper && e.push(ht.create(n.state.doc, [n.cursorWrapper.deco])), ai.from(e);
}
const eA = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, tA = xn && bi <= 11;
class nA {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class oA {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new nA(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((o) => {
      for (let i = 0; i < o.length; i++)
        this.queue.push(o[i]);
      xn && bi <= 11 && o.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : Qt && e.composing && o.some((i) => i.type == "childList" && i.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), tA && (this.onCharData = (o) => {
      this.queue.push({ target: o.target, type: "characterData", oldValue: o.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, eA)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (N3(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Bo(this.view);
      if (xn && bi <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && ur(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), o;
    for (let r = e.focusNode; r; r = as(r))
      t.add(r);
    for (let r = e.anchorNode; r; r = as(r))
      if (t.has(r)) {
        o = r;
        break;
      }
    let i = o && this.view.docView.nearestDesc(o);
    if (i && i.ignoreMutation({
      type: "selection",
      target: o.nodeType == 3 ? o.parentNode : o
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let o = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(o) && N3(e) && !this.ignoreSelectionChange(o), r = -1, s = -1, a = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let c = this.registerMutation(t[u], l);
        c && (r = r < 0 ? c.from : Math.min(c.from, r), s = s < 0 ? c.to : Math.max(c.to, s), c.typeOver && (a = !0));
      }
    if (l.some((u) => u.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let u of l)
        if (u.nodeName == "BR" && u.parentNode) {
          let c = u.nextSibling;
          c && c.nodeType == 1 && c.contentEditable == "false" && u.parentNode.removeChild(u);
        }
    } else if (Wn && l.length) {
      let u = l.filter((c) => c.nodeName == "BR");
      if (u.length == 2) {
        let [c, f] = u;
        c.parentNode && c.parentNode.parentNode == f.parentNode ? f.remove() : c.remove();
      } else {
        let { focusNode: c } = this.currentSelection;
        for (let f of u) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!c || sA(e, c) != h) && f.remove();
        }
      }
    }
    let d = null;
    r < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Su(o) && (d = X1(e)) && d.eq(Le.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Bo(e), this.currentSelection.set(o), e.scrollToSelection()) : (r > -1 || i) && (r > -1 && (e.docView.markDirty(r, s), iA(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, aA(e, l)), this.handleDOMChange(r, s, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(o) || Bo(e), this.currentSelection.set(o));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let o = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (o == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !o || o.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let c = e.addedNodes[u];
        t.push(c), c.nodeType == 3 && (this.lastChangedTextNode = c);
      }
      if (o.contentDOM && o.contentDOM != o.dom && !o.contentDOM.contains(e.target))
        return { from: o.posBefore, to: o.posAfter };
      let i = e.previousSibling, r = e.nextSibling;
      if (xn && bi <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: c, nextSibling: f } = e.addedNodes[u];
          (!c || Array.prototype.indexOf.call(e.addedNodes, c) < 0) && (i = c), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (r = f);
        }
      let s = i && i.parentNode == e.target ? zt(i) + 1 : 0, a = o.localPosFromDOM(e.target, s, -1), l = r && r.parentNode == e.target ? zt(r) : e.target.childNodes.length, d = o.localPosFromDOM(e.target, l, 1);
      return { from: a, to: d };
    } else return e.type == "attributes" ? { from: o.posAtStart - o.border, to: o.posAtEnd + o.border } : (this.lastChangedTextNode = e.target, {
      from: o.posAtStart,
      to: o.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let j3 = /* @__PURE__ */ new WeakMap(), W3 = !1;
function iA(n) {
  if (!j3.has(n) && (j3.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = Wn, W3)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), W3 = !0;
  }
}
function U3(n, e) {
  let t = e.startContainer, o = e.startOffset, i = e.endContainer, r = e.endOffset, s = n.domAtPos(n.state.selection.anchor);
  return ur(s.node, s.offset, i, r) && ([t, o, i, r] = [i, r, t, o]), { anchorNode: t, anchorOffset: o, focusNode: i, focusOffset: r };
}
function rA(n, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(n.root)[0];
    if (i)
      return U3(n, i);
  }
  let t;
  function o(i) {
    i.preventDefault(), i.stopImmediatePropagation(), t = i.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", o, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", o, !0), t ? U3(n, t) : null;
}
function sA(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let o = n.docView.nearestDesc(t, !0);
    if (o && o.node.isBlock)
      return t;
  }
  return null;
}
function aA(n, e) {
  var t;
  let { focusNode: o, focusOffset: i } = n.domSelectionRange();
  for (let r of e)
    if (((t = r.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let s = r.nextSibling;
      for (; s && s.nodeName != "TD" && s.nodeName != "TH"; )
        s = s.nextSibling;
      if (s) {
        let a = s;
        for (; ; ) {
          let l = a.firstChild;
          if (!l || l.nodeType != 1 || l.contentEditable == "false" || /^(BR|IMG)$/.test(l.nodeName))
            break;
          a = l;
        }
        a.insertBefore(r, a.firstChild), o == r && n.domSelection().collapse(r, i);
      } else
        r.parentNode.removeChild(r);
    }
}
function lA(n, e, t) {
  let { node: o, fromOffset: i, toOffset: r, from: s, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), d, u = l.anchorNode;
  if (u && n.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: l.anchorOffset }], Su(l) || d.push({ node: l.focusNode, offset: l.focusOffset })), jt && n.input.lastKeyCode === 8)
    for (let g = r; g > i; g--) {
      let b = o.childNodes[g - 1], x = b.pmViewDesc;
      if (b.nodeName == "BR" && !x) {
        r = g;
        break;
      }
      if (!x || x.size)
        break;
    }
  let c = n.state.doc, f = n.someProp("domParser") || vi.fromSchema(n.state.schema), h = c.resolve(s), p = null, m = f.parse(o, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: i,
    to: r,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: dA,
    context: h
  });
  if (d && d[0].pos != null) {
    let g = d[0].pos, b = d[1] && d[1].pos;
    b == null && (b = g), p = { anchor: g + s, head: b + s };
  }
  return { doc: m, sel: p, from: s, to: a };
}
function dA(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (Qt && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || Qt && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const uA = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function cA(n, e, t, o, i) {
  let r = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let E = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, S = X1(n, E);
    if (S && !n.state.selection.eq(S)) {
      if (jt && Po && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (I) => I(n, Ui(13, "Enter"))))
        return;
      let D = n.state.tr.setSelection(S);
      E == "pointer" ? D.setMeta("pointer", !0) : E == "key" && D.scrollIntoView(), r && D.setMeta("composition", r), n.dispatch(D);
    }
    return;
  }
  let s = n.state.doc.resolve(e), a = s.sharedDepth(t);
  e = s.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, d = lA(n, e, t), u = n.state.doc, c = u.slice(d.from, d.to), f, h;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (f = n.state.selection.to, h = "end") : (f = n.state.selection.from, h = "start"), n.input.lastKeyCode = null;
  let p = pA(c.content, d.doc.content, d.from, f, h);
  if (p && n.input.domChangeCount++, (ls && n.input.lastIOSEnter > Date.now() - 225 || Po) && i.some((E) => E.nodeType == 1 && !uA.test(E.nodeName)) && (!p || p.endA >= p.endB) && n.someProp("handleKeyDown", (E) => E(n, Ui(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (o && l instanceof Te && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(d.sel && d.sel.anchor != d.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (d.sel) {
        let E = K3(n, n.state.doc, d.sel);
        if (E && !E.eq(n.state.selection)) {
          let S = n.state.tr.setSelection(E);
          r && S.setMeta("composition", r), n.dispatch(S);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && p.start == p.endB && n.state.selection instanceof Te && (p.start > n.state.selection.from && p.start <= n.state.selection.from + 2 && n.state.selection.from >= d.from ? p.start = n.state.selection.from : p.endA < n.state.selection.to && p.endA >= n.state.selection.to - 2 && n.state.selection.to <= d.to && (p.endB += n.state.selection.to - p.endA, p.endA = n.state.selection.to)), xn && bi <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > d.from && d.doc.textBetween(p.start - d.from - 1, p.start - d.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = d.doc.resolveNoCache(p.start - d.from), g = d.doc.resolveNoCache(p.endB - d.from), b = u.resolve(p.start), x = m.sameParent(g) && m.parent.inlineContent && b.end() >= p.endA;
  if ((ls && n.input.lastIOSEnter > Date.now() - 225 && (!x || i.some((E) => E.nodeName == "DIV" || E.nodeName == "P")) || !x && m.pos < d.doc.content.size && (!m.sameParent(g) || !m.parent.inlineContent) && m.pos < g.pos && !/\S/.test(d.doc.textBetween(m.pos, g.pos, "", ""))) && n.someProp("handleKeyDown", (E) => E(n, Ui(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > p.start && hA(u, p.start, p.endA, m, g) && n.someProp("handleKeyDown", (E) => E(n, Ui(8, "Backspace")))) {
    Po && jt && n.domObserver.suppressSelectionUpdates();
    return;
  }
  jt && p.endB == p.start && (n.input.lastChromeDelete = Date.now()), Po && !x && m.start() != g.start() && g.parentOffset == 0 && m.depth == g.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == p.endA && (p.endB -= 2, g = d.doc.resolveNoCache(p.endB - d.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(E) {
      return E(n, Ui(13, "Enter"));
    });
  }, 20));
  let w = p.start, M = p.endA, $ = (E) => {
    let S = E || n.state.tr.replace(w, M, d.doc.slice(p.start - d.from, p.endB - d.from));
    if (d.sel) {
      let D = K3(n, S.doc, d.sel);
      D && !(jt && n.composing && D.empty && (p.start != p.endB || n.input.lastChromeDelete < Date.now() - 100) && (D.head == w || D.head == S.mapping.map(M) - 1) || xn && D.empty && D.head == w) && S.setSelection(D);
    }
    return r && S.setMeta("composition", r), S.scrollIntoView();
  }, T;
  if (x)
    if (m.pos == g.pos) {
      xn && bi <= 11 && m.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => Bo(n), 20));
      let E = $(n.state.tr.delete(w, M)), S = u.resolve(p.start).marksAcross(u.resolve(p.endA));
      S && E.ensureMarks(S), n.dispatch(E);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (T = fA(m.parent.content.cut(m.parentOffset, g.parentOffset), b.parent.content.cut(b.parentOffset, p.endA - b.start())))
    ) {
      let E = $(n.state.tr);
      T.type == "add" ? E.addMark(w, M, T.mark) : E.removeMark(w, M, T.mark), n.dispatch(E);
    } else if (m.parent.child(m.index()).isText && m.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let E = m.parent.textBetween(m.parentOffset, g.parentOffset), S = () => $(n.state.tr.insertText(E, w, M));
      n.someProp("handleTextInput", (D) => D(n, w, M, E, S)) || n.dispatch(S());
    } else
      n.dispatch($());
  else
    n.dispatch($());
}
function K3(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : Q1(n, e.resolve(t.anchor), e.resolve(t.head));
}
function fA(n, e) {
  let t = n.firstChild.marks, o = e.firstChild.marks, i = t, r = o, s, a, l;
  for (let u = 0; u < o.length; u++)
    i = o[u].removeFromSet(i);
  for (let u = 0; u < t.length; u++)
    r = t[u].removeFromSet(r);
  if (i.length == 1 && r.length == 0)
    a = i[0], s = "add", l = (u) => u.mark(a.addToSet(u.marks));
  else if (i.length == 0 && r.length == 1)
    a = r[0], s = "remove", l = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < e.childCount; u++)
    d.push(l(e.child(u)));
  if (Q.from(d).eq(n))
    return { mark: a, type: s };
}
function hA(n, e, t, o, i) {
  if (
    // The content must have shrunk
    t - e <= i.pos - o.pos || // newEnd must point directly at or after the end of the block that newStart points into
    vc(o, !0, !1) < i.pos
  )
    return !1;
  let r = n.resolve(e);
  if (!o.parent.isTextblock) {
    let a = r.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (r.parentOffset < r.parent.content.size || !r.parent.isTextblock)
    return !1;
  let s = n.resolve(vc(r, !0, !0));
  return !s.parent.isTextblock || s.pos > t || vc(s, !0, !1) < t ? !1 : o.parent.content.cut(o.parentOffset).eq(s.parent.content);
}
function vc(n, e, t) {
  let o = n.depth, i = e ? n.end() : n.pos;
  for (; o > 0 && (e || n.indexAfter(o) == n.node(o).childCount); )
    o--, i++, e = !1;
  if (t) {
    let r = n.node(o).maybeChild(n.indexAfter(o));
    for (; r && !r.isLeaf; )
      r = r.firstChild, i++;
  }
  return i;
}
function pA(n, e, t, o, i) {
  let r = n.findDiffStart(e, t);
  if (r == null)
    return null;
  let { a: s, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (i == "end") {
    let l = Math.max(0, r - Math.min(s, a));
    o -= s + l - r;
  }
  if (s < r && n.size < e.size) {
    let l = o <= r && o >= s ? r - o : 0;
    r -= l, r && r < e.size && G3(e.textBetween(r - 1, r + 1)) && (r += l ? 1 : -1), a = r + (a - s), s = r;
  } else if (a < r) {
    let l = o <= r && o >= a ? r - o : 0;
    r -= l, r && r < n.size && G3(n.textBetween(r - 1, r + 1)) && (r += l ? 1 : -1), s = r + (s - a), a = r;
  }
  return { start: r, endA: s, endB: a };
}
function G3(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class h4 {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new TT(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(X3), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Z3(this), q3(this), this.nodeViews = J3(this), this.docView = E3(this.state.doc, Y3(this), gc(this), this.dom, this), this.domObserver = new oA(this, (o, i, r, s) => cA(this, o, i, r, s)), this.domObserver.start(), AT(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Tf(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(X3), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let o in this._props)
      t[o] = this._props[o];
    t.state = this.state;
    for (let o in e)
      t[o] = e[o];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var o;
    let i = this.state, r = !1, s = !1;
    e.storedMarks && this.composing && (s4(this), s = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = J3(this);
      gA(h, this.nodeViews) && (this.nodeViews = h, r = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Tf(this), this.editable = Z3(this), q3(this);
    let l = gc(this), d = Y3(this), u = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", c = r || !this.docView.matchesNode(e.doc, d, l);
    (c || !e.selection.eq(i.selection)) && (s = !0);
    let f = u == "preserve" && s && this.dom.style.overflowAnchor == null && UO(this);
    if (s) {
      this.domObserver.stop();
      let h = c && (xn || jt) && !this.composing && !i.selection.empty && !e.selection.empty && mA(i.selection, e.selection);
      if (c) {
        let p = jt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = UT(this)), (r || !this.docView.update(e.doc, d, l, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = E3(e.doc, d, l, this.dom, this)), p && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && mT(this)) ? Bo(this, h) : (Yg(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((o = this.dragging) === null || o === void 0) && o.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : f && KO(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof xe) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && w3(this, t.getBoundingClientRect(), e);
      } else
        w3(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let o = this.directPlugins[t];
        o.spec.view && this.pluginViews.push(o.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let o = this.state.plugins[t];
        o.spec.view && this.pluginViews.push(o.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let o = this.pluginViews[t];
        o.update && o.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let o = e.node, i = -1;
    if (this.state.doc.nodeAt(o.from) == o.node)
      i = o.from;
    else {
      let r = o.from + (this.state.doc.content.size - t.doc.content.size);
      (r > 0 && this.state.doc.nodeAt(r)) == o.node && (i = r);
    }
    this.dragging = new l4(e.slice, e.move, i < 0 ? void 0 : xe.create(this.state.doc, i));
  }
  someProp(e, t) {
    let o = this._props && this._props[e], i;
    if (o != null && (i = t ? t(o) : o))
      return i;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let a = this.directPlugins[s].props[e];
      if (a != null && (i = t ? t(a) : a))
        return i;
    }
    let r = this.state.plugins;
    if (r)
      for (let s = 0; s < r.length; s++) {
        let a = r[s].props[e];
        if (a != null && (i = t ? t(a) : a))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (xn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && GO(this.dom), Bo(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return XO(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return Vg(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, o = -1) {
    let i = this.docView.posFromDOM(e, t, o);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return oT(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return wa(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return wa(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return eh(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (IT(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], gc(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, PO());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return NT(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Qt && this.root.nodeType === 11 && VO(this.dom.ownerDocument) == this.dom && rA(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
h4.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function Y3(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let o in t)
        o == "class" ? e.class += " " + t[o] : o == "style" ? e.style = (e.style ? e.style + ";" : "") + t[o] : !e[o] && o != "contenteditable" && o != "nodeName" && (e[o] = String(t[o]));
  }), e.translate || (e.translate = "no"), [ln.node(0, n.state.doc.content.size, e)];
}
function q3(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: ln.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function Z3(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function mA(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function J3(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(o) {
    for (let i in o)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = o[i]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function gA(n, e) {
  let t = 0, o = 0;
  for (let i in n) {
    if (n[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    o++;
  return t != o;
}
function X3(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Mi = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, cd = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, vA = typeof navigator < "u" && /Mac/.test(navigator.platform), bA = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ht = 0; Ht < 10; Ht++) Mi[48 + Ht] = Mi[96 + Ht] = String(Ht);
for (var Ht = 1; Ht <= 24; Ht++) Mi[Ht + 111] = "F" + Ht;
for (var Ht = 65; Ht <= 90; Ht++)
  Mi[Ht] = String.fromCharCode(Ht + 32), cd[Ht] = String.fromCharCode(Ht);
for (var bc in Mi) cd.hasOwnProperty(bc) || (cd[bc] = Mi[bc]);
function yA(n) {
  var e = vA && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || bA && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? cd : Mi)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const xA = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), CA = typeof navigator < "u" && /Win/.test(navigator.platform);
function wA(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let o, i, r, s;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      o = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      r = !0;
    else if (/^mod$/i.test(l))
      xA ? s = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return o && (t = "Alt-" + t), i && (t = "Ctrl-" + t), s && (t = "Meta-" + t), r && (t = "Shift-" + t), t;
}
function kA(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[wA(t)] = n[t];
  return e;
}
function yc(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function $A(n) {
  return new mt({ props: { handleKeyDown: p4(n) } });
}
function p4(n) {
  let e = kA(n);
  return function(t, o) {
    let i = yA(o), r, s = e[yc(i, o)];
    if (s && s(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (o.shiftKey) {
        let a = e[yc(i, o, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((o.altKey || o.metaKey || o.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(CA && o.ctrlKey && o.altKey) && (r = Mi[o.keyCode]) && r != i) {
        let a = e[yc(r, o)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var MA = Object.defineProperty, sh = (n, e) => {
  for (var t in e)
    MA(n, t, { get: e[t], enumerable: !0 });
};
function Ou(n) {
  const { state: e, transaction: t } = n;
  let { selection: o } = t, { doc: i } = t, { storedMarks: r } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return r;
    },
    get selection() {
      return o;
    },
    get doc() {
      return i;
    },
    get tr() {
      return o = t.selection, i = t.doc, r = t.storedMarks, t;
    }
  };
}
var Tu = class {
  constructor(n) {
    this.editor = n.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = n.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: n, editor: e, state: t } = this, { view: o } = e, { tr: i } = t, r = this.buildProps(i);
    return Object.fromEntries(
      Object.entries(n).map(([s, a]) => [s, (...d) => {
        const u = a(...d)(r);
        return !i.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(i), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(n, e = !0) {
    const { rawCommands: t, editor: o, state: i } = this, { view: r } = o, s = [], a = !!n, l = n || i.tr, d = () => (!a && e && !l.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(l), s.every((c) => c === !0)), u = {
      ...Object.fromEntries(
        Object.entries(t).map(([c, f]) => [c, (...p) => {
          const m = this.buildProps(l, e), g = f(...p)(m);
          return s.push(g), u;
        }])
      ),
      run: d
    };
    return u;
  }
  createCan(n) {
    const { rawCommands: e, state: t } = this, o = !1, i = n || t.tr, r = this.buildProps(i, o);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([a, l]) => [a, (...d) => l(...d)({ ...r, dispatch: void 0 })])
      ),
      chain: () => this.createChain(i, o)
    };
  }
  buildProps(n, e = !0) {
    const { rawCommands: t, editor: o, state: i } = this, { view: r } = o, s = {
      tr: n,
      editor: o,
      view: r,
      state: Ou({
        state: i,
        transaction: n
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(n, e),
      can: () => this.createCan(n),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([a, l]) => [a, (...d) => l(...d)(s)])
        );
      }
    };
    return s;
  }
}, m4 = {};
sh(m4, {
  blur: () => SA,
  clearContent: () => _A,
  clearNodes: () => EA,
  command: () => OA,
  createParagraphNear: () => TA,
  cut: () => AA,
  deleteCurrentNode: () => IA,
  deleteNode: () => DA,
  deleteRange: () => NA,
  deleteSelection: () => PA,
  enter: () => LA,
  exitCode: () => RA,
  extendMarkRange: () => FA,
  first: () => BA,
  focus: () => zA,
  forEach: () => HA,
  insertContent: () => jA,
  insertContentAt: () => KA,
  joinBackward: () => qA,
  joinDown: () => YA,
  joinForward: () => ZA,
  joinItemBackward: () => JA,
  joinItemForward: () => XA,
  joinTextblockBackward: () => QA,
  joinTextblockForward: () => eI,
  joinUp: () => GA,
  keyboardShortcut: () => nI,
  lift: () => oI,
  liftEmptyBlock: () => iI,
  liftListItem: () => rI,
  newlineInCode: () => sI,
  resetAttributes: () => aI,
  scrollIntoView: () => lI,
  selectAll: () => dI,
  selectNodeBackward: () => uI,
  selectNodeForward: () => cI,
  selectParentNode: () => fI,
  selectTextblockEnd: () => hI,
  selectTextblockStart: () => pI,
  setContent: () => mI,
  setMark: () => PI,
  setMeta: () => LI,
  setNode: () => RI,
  setNodeSelection: () => FI,
  setTextDirection: () => BI,
  setTextSelection: () => VI,
  sinkListItem: () => zI,
  splitBlock: () => HI,
  splitListItem: () => jI,
  toggleList: () => WI,
  toggleMark: () => UI,
  toggleNode: () => KI,
  toggleWrap: () => GI,
  undoInputRule: () => YI,
  unsetAllMarks: () => qI,
  unsetMark: () => ZI,
  unsetTextDirection: () => JI,
  updateAttributes: () => XI,
  wrapIn: () => QI,
  wrapInList: () => eD
});
var SA = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) == null || t.removeAllRanges());
}), !0), _A = (n = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: n }), EA = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: o } = e, { ranges: i } = o;
  return t && i.forEach(({ $from: r, $to: s }) => {
    n.doc.nodesBetween(r.pos, s.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: d, mapping: u } = e, c = d.resolve(u.map(l)), f = d.resolve(u.map(l + a.nodeSize)), h = c.blockRange(f);
      if (!h)
        return;
      const p = ys(h);
      if (a.type.isTextblock) {
        const { defaultType: m } = c.parent.contentMatchAt(c.index());
        e.setNodeMarkup(h.start, m);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, OA = (n) => (e) => n(e), TA = () => ({ state: n, dispatch: e }) => Og(n, e), AA = (n, e) => ({ editor: t, tr: o }) => {
  const { state: i } = t, r = i.doc.slice(n.from, n.to);
  o.deleteRange(n.from, n.to);
  const s = o.mapping.map(e);
  return o.insert(s, r.content), o.setSelection(new Te(o.doc.resolve(Math.max(s - 1, 0)))), !0;
}, IA = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, o = t.$anchor.node();
  if (o.content.size > 0)
    return !1;
  const i = n.selection.$anchor;
  for (let r = i.depth; r > 0; r -= 1)
    if (i.node(r).type === o.type) {
      if (e) {
        const a = i.before(r), l = i.after(r);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function _t(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
var DA = (n) => ({ tr: e, state: t, dispatch: o }) => {
  const i = _t(n, t.schema), r = e.selection.$anchor;
  for (let s = r.depth; s > 0; s -= 1)
    if (r.node(s).type === i) {
      if (o) {
        const l = r.before(s), d = r.after(s);
        e.delete(l, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, NA = (n) => ({ tr: e, dispatch: t }) => {
  const { from: o, to: i } = n;
  return t && e.delete(o, i), !0;
}, PA = () => ({ state: n, dispatch: e }) => K1(n, e), LA = () => ({ commands: n }) => n.keyboardShortcut("Enter"), RA = () => ({ state: n, dispatch: e }) => xO(n, e);
function ah(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
function fd(n, e, t = { strict: !0 }) {
  const o = Object.keys(e);
  return o.length ? o.every((i) => t.strict ? e[i] === n[i] : ah(e[i]) ? e[i].test(n[i]) : e[i] === n[i]) : !0;
}
function g4(n, e, t = {}) {
  return n.find((o) => o.type === e && fd(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((i) => [i, o.attrs[i]])),
    t
  ));
}
function Q3(n, e, t = {}) {
  return !!g4(n, e, t);
}
function lh(n, e, t) {
  var o;
  if (!n || !e)
    return;
  let i = n.parent.childAfter(n.parentOffset);
  if ((!i.node || !i.node.marks.some((u) => u.type === e)) && (i = n.parent.childBefore(n.parentOffset)), !i.node || !i.node.marks.some((u) => u.type === e) || (t = t || ((o = i.node.marks[0]) == null ? void 0 : o.attrs), !g4([...i.node.marks], e, t)))
    return;
  let s = i.index, a = n.start() + i.offset, l = s + 1, d = a + i.node.nodeSize;
  for (; s > 0 && Q3([...n.parent.child(s - 1).marks], e, t); )
    s -= 1, a -= n.parent.child(s).nodeSize;
  for (; l < n.parent.childCount && Q3([...n.parent.child(l).marks], e, t); )
    d += n.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: d
  };
}
function qo(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
var FA = (n, e = {}) => ({ tr: t, state: o, dispatch: i }) => {
  const r = qo(n, o.schema), { doc: s, selection: a } = t, { $from: l, from: d, to: u } = a;
  if (i) {
    const c = lh(l, r, e);
    if (c && c.from <= d && c.to >= u) {
      const f = Te.create(s, c.from, c.to);
      t.setSelection(f);
    }
  }
  return !0;
}, BA = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let o = 0; o < t.length; o += 1)
    if (t[o](e))
      return !0;
  return !1;
};
function v4(n) {
  return n instanceof Te;
}
function Zi(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function b4(n, e = null) {
  if (!e)
    return null;
  const t = Le.atStart(n), o = Le.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return o;
  const i = t.from, r = o.to;
  return e === "all" ? Te.create(n, Zi(0, i, r), Zi(n.content.size, i, r)) : Te.create(n, Zi(e, i, r), Zi(e, i, r));
}
function ep() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function hd() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function VA() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var zA = (n = null, e = {}) => ({ editor: t, view: o, tr: i, dispatch: r }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (hd() || ep()) && o.dom.focus(), VA() && !hd() && !ep() && o.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      t.isDestroyed || (o.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  try {
    if (o.hasFocus() && n === null || n === !1)
      return !0;
  } catch {
    return !1;
  }
  if (r && n === null && !v4(t.state.selection))
    return s(), !0;
  const a = b4(i.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return r && (l || i.setSelection(a), l && i.storedMarks && i.setStoredMarks(i.storedMarks), s()), !0;
}, HA = (n, e) => (t) => n.every((o, i) => e(o, { ...t, index: i })), jA = (n, e) => ({ tr: t, commands: o }) => o.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), y4 = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const o = e[t];
    o.nodeType === 3 && o.nodeValue && /^(\n\s\s|\n)$/.test(o.nodeValue) ? n.removeChild(o) : o.nodeType === 1 && y4(o);
  }
  return n;
};
function al(n) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return y4(t);
}
function $a(n, e, t) {
  if (n instanceof gi || n instanceof Q)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const o = typeof n == "object" && n !== null, i = typeof n == "string";
  if (o)
    try {
      if (Array.isArray(n) && n.length > 0)
        return Q.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const s = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && s.check(), s;
    } catch (r) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: r });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", r), $a("", e, t);
    }
  if (i) {
    if (t.errorOnInvalidContent) {
      let s = !1, a = "";
      const l = new ng({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (s = !0, a = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? vi.fromSchema(l).parseSlice(al(n), t.parseOptions) : vi.fromSchema(l).parse(al(n), t.parseOptions), t.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${a}`)
        });
    }
    const r = vi.fromSchema(e);
    return t.slice ? r.parseSlice(al(n), t.parseOptions).content : r.parse(al(n), t.parseOptions);
  }
  return $a("", e, t);
}
function WA(n, e, t) {
  const o = n.steps.length - 1;
  if (o < e)
    return;
  const i = n.steps[o];
  if (!(i instanceof Dt || i instanceof Pt))
    return;
  const r = n.mapping.maps[o];
  let s = 0;
  r.forEach((a, l, d, u) => {
    s === 0 && (s = u);
  }), n.setSelection(Le.near(n.doc.resolve(s), t));
}
var UA = (n) => !("type" in n), KA = (n, e, t) => ({ tr: o, dispatch: i, editor: r }) => {
  var s;
  if (i) {
    t = {
      parseOptions: r.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const l = (g) => {
      r.emit("contentError", {
        editor: r,
        error: g,
        disableCollaboration: () => {
          "collaboration" in r.storage && typeof r.storage.collaboration == "object" && r.storage.collaboration && (r.storage.collaboration.isDisabled = !0);
        }
      });
    }, d = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !r.options.enableContentCheck && r.options.emitContentError)
      try {
        $a(e, r.schema, {
          parseOptions: d,
          errorOnInvalidContent: !0
        });
      } catch (g) {
        l(g);
      }
    try {
      a = $a(e, r.schema, {
        parseOptions: d,
        errorOnInvalidContent: (s = t.errorOnInvalidContent) != null ? s : r.options.enableContentCheck
      });
    } catch (g) {
      return l(g), !1;
    }
    let { from: u, to: c } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, f = !0, h = !0;
    if ((UA(a) ? a : [a]).forEach((g) => {
      g.check(), f = f ? g.isText && g.marks.length === 0 : !1, h = h ? g.isBlock : !1;
    }), u === c && h) {
      const { parent: g } = o.doc.resolve(u);
      g.isTextblock && !g.type.spec.code && !g.childCount && (u -= 1, c += 1);
    }
    let m;
    if (f) {
      if (Array.isArray(e))
        m = e.map((g) => g.text || "").join("");
      else if (e instanceof Q) {
        let g = "";
        e.forEach((b) => {
          b.text && (g += b.text);
        }), m = g;
      } else typeof e == "object" && e && e.text ? m = e.text : m = e;
      o.insertText(m, u, c);
    } else {
      m = a;
      const g = o.doc.resolve(u), b = g.node(), x = g.parentOffset === 0, w = b.isText || b.isTextblock, M = b.content.size > 0;
      x && w && M && (u = Math.max(0, u - 1)), o.replaceWith(u, c, m);
    }
    t.updateSelection && WA(o, o.steps.length - 1, -1), t.applyInputRules && o.setMeta("applyInputRules", { from: u, text: m }), t.applyPasteRules && o.setMeta("applyPasteRules", { from: u, text: m });
  }
  return !0;
}, GA = () => ({ state: n, dispatch: e }) => vO(n, e), YA = () => ({ state: n, dispatch: e }) => bO(n, e), qA = () => ({ state: n, dispatch: e }) => wg(n, e), ZA = () => ({ state: n, dispatch: e }) => Sg(n, e), JA = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const o = ku(n.doc, n.selection.$from.pos, -1);
    return o == null ? !1 : (t.join(o, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, XA = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const o = ku(n.doc, n.selection.$from.pos, 1);
    return o == null ? !1 : (t.join(o, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, QA = () => ({ state: n, dispatch: e }) => mO(n, e), eI = () => ({ state: n, dispatch: e }) => gO(n, e);
function x4() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function tI(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let o, i, r, s;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      o = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      r = !0;
    else if (/^mod$/i.test(l))
      hd() || x4() ? s = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return o && (t = `Alt-${t}`), i && (t = `Ctrl-${t}`), s && (t = `Meta-${t}`), r && (t = `Shift-${t}`), t;
}
var nI = (n) => ({ editor: e, view: t, tr: o, dispatch: i }) => {
  const r = tI(n).split(/-(?!$)/), s = r.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: r.includes("Alt"),
    ctrlKey: r.includes("Ctrl"),
    metaKey: r.includes("Meta"),
    shiftKey: r.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (d) => d(t, a));
  });
  return l == null || l.steps.forEach((d) => {
    const u = d.map(o.mapping);
    u && i && o.maybeStep(u);
  }), !0;
};
function Si(n, e, t = {}) {
  const { from: o, to: i, empty: r } = n.selection, s = e ? _t(e, n.schema) : null, a = [];
  n.doc.nodesBetween(o, i, (c, f) => {
    if (c.isText)
      return;
    const h = Math.max(o, f), p = Math.min(i, f + c.nodeSize);
    a.push({
      node: c,
      from: h,
      to: p
    });
  });
  const l = i - o, d = a.filter((c) => s ? s.name === c.node.type.name : !0).filter((c) => fd(c.node.attrs, t, { strict: !1 }));
  return r ? !!d.length : d.reduce((c, f) => c + f.to - f.from, 0) >= l;
}
var oI = (n, e = {}) => ({ state: t, dispatch: o }) => {
  const i = _t(n, t.schema);
  return Si(t, i, e) ? yO(t, o) : !1;
}, iI = () => ({ state: n, dispatch: e }) => Tg(n, e), rI = (n) => ({ state: e, dispatch: t }) => {
  const o = _t(n, e.schema);
  return AO(o)(e, t);
}, sI = () => ({ state: n, dispatch: e }) => Eg(n, e);
function Au(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function tp(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((o, i) => (t.includes(i) || (o[i] = n[i]), o), {});
}
var aI = (n, e) => ({ tr: t, state: o, dispatch: i }) => {
  let r = null, s = null;
  const a = Au(
    typeof n == "string" ? n : n.name,
    o.schema
  );
  if (!a)
    return !1;
  a === "node" && (r = _t(n, o.schema)), a === "mark" && (s = qo(n, o.schema));
  let l = !1;
  return t.selection.ranges.forEach((d) => {
    o.doc.nodesBetween(d.$from.pos, d.$to.pos, (u, c) => {
      r && r === u.type && (l = !0, i && t.setNodeMarkup(c, void 0, tp(u.attrs, e))), s && u.marks.length && u.marks.forEach((f) => {
        s === f.type && (l = !0, i && t.addMark(c, c + u.nodeSize, s.create(tp(f.attrs, e))));
      });
    });
  }), l;
}, lI = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), dI = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new On(n.doc);
    n.setSelection(t);
  }
  return !0;
}, uI = () => ({ state: n, dispatch: e }) => $g(n, e), cI = () => ({ state: n, dispatch: e }) => _g(n, e), fI = () => ({ state: n, dispatch: e }) => kO(n, e), hI = () => ({ state: n, dispatch: e }) => SO(n, e), pI = () => ({ state: n, dispatch: e }) => MO(n, e);
function Af(n, e, t = {}, o = {}) {
  return $a(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: o.errorOnInvalidContent
  });
}
var mI = (n, { errorOnInvalidContent: e, emitUpdate: t = !0, parseOptions: o = {} } = {}) => ({ editor: i, tr: r, dispatch: s, commands: a }) => {
  const { doc: l } = r;
  if (o.preserveWhitespace !== "full") {
    const d = Af(n, i.schema, o, {
      errorOnInvalidContent: e ?? i.options.enableContentCheck
    });
    return s && r.replaceWith(0, l.content.size, d).setMeta("preventUpdate", !t), !0;
  }
  return s && r.setMeta("preventUpdate", !t), a.insertContentAt({ from: 0, to: l.content.size }, n, {
    parseOptions: o,
    errorOnInvalidContent: e ?? i.options.enableContentCheck
  });
};
function C4(n, e) {
  const t = qo(e, n.schema), { from: o, to: i, empty: r } = n.selection, s = [];
  r ? (n.storedMarks && s.push(...n.storedMarks), s.push(...n.selection.$head.marks())) : n.doc.nodesBetween(o, i, (l) => {
    s.push(...l.marks);
  });
  const a = s.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function w4(n, e) {
  const t = new bg(n);
  return e.forEach((o) => {
    o.steps.forEach((i) => {
      t.step(i);
    });
  }), t;
}
function gI(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function vI(n, e, t) {
  const o = [];
  return n.nodesBetween(e.from, e.to, (i, r) => {
    t(i) && o.push({
      node: i,
      pos: r
    });
  }), o;
}
function bI(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const o = n.node(t);
    if (e(o))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: o
      };
  }
}
function Iu(n) {
  return (e) => bI(e.$from, n);
}
function be(n, e, t) {
  return n.config[e] === void 0 && n.parent ? be(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? be(n.parent, e, t) : null
  }) : n.config[e];
}
function dh(n) {
  return n.map((e) => {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    }, o = be(e, "addExtensions", t);
    return o ? [e, ...dh(o())] : e;
  }).flat(10);
}
function uh(n, e) {
  const t = br.fromSchema(e).serializeFragment(n), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(t), i.innerHTML;
}
function k4(n) {
  return typeof n == "function";
}
function Qe(n, e = void 0, ...t) {
  return k4(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function yI(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function ds(n) {
  const e = n.filter((i) => i.type === "extension"), t = n.filter((i) => i.type === "node"), o = n.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: o
  };
}
function $4(n) {
  const e = [], { nodeExtensions: t, markExtensions: o } = ds(n), i = [...t, ...o], r = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, s = t.filter((d) => d.name !== "text").map((d) => d.name), a = o.map((d) => d.name), l = [...s, ...a];
  return n.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      extensions: i
    }, c = be(
      d,
      "addGlobalAttributes",
      u
    );
    if (!c)
      return;
    c().forEach((h) => {
      let p;
      Array.isArray(h.types) ? p = h.types : h.types === "*" ? p = l : h.types === "nodes" ? p = s : h.types === "marks" ? p = a : p = [], p.forEach((m) => {
        Object.entries(h.attributes).forEach(([g, b]) => {
          e.push({
            type: m,
            name: g,
            attribute: {
              ...r,
              ...b
            }
          });
        });
      });
    });
  }), i.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage
    }, c = be(
      d,
      "addAttributes",
      u
    );
    if (!c)
      return;
    const f = c();
    Object.entries(f).forEach(([h, p]) => {
      const m = {
        ...r,
        ...p
      };
      typeof (m == null ? void 0 : m.default) == "function" && (m.default = m.default()), m != null && m.isRequired && (m == null ? void 0 : m.default) === void 0 && delete m.default, e.push({
        type: d.name,
        name: h,
        attribute: m
      });
    });
  }), e;
}
function yt(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const o = { ...e };
    return Object.entries(t).forEach(([i, r]) => {
      if (!o[i]) {
        o[i] = r;
        return;
      }
      if (i === "class") {
        const a = r ? String(r).split(" ") : [], l = o[i] ? o[i].split(" ") : [], d = a.filter((u) => !l.includes(u));
        o[i] = [...l, ...d].join(" ");
      } else if (i === "style") {
        const a = r ? r.split(";").map((u) => u.trim()).filter(Boolean) : [], l = o[i] ? o[i].split(";").map((u) => u.trim()).filter(Boolean) : [], d = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [c, f] = u.split(":").map((h) => h.trim());
          d.set(c, f);
        }), a.forEach((u) => {
          const [c, f] = u.split(":").map((h) => h.trim());
          d.set(c, f);
        }), o[i] = Array.from(d.entries()).map(([u, c]) => `${u}: ${c}`).join("; ");
      } else
        o[i] = r;
    }), o;
  }, {});
}
function Ma(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, o) => yt(t, o), {});
}
function xI(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function np(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const o = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (o === !1)
        return !1;
      const i = e.reduce((r, s) => {
        const a = s.attribute.parseHTML ? s.attribute.parseHTML(t) : xI(t.getAttribute(s.name));
        return a == null ? r : {
          ...r,
          [s.name]: a
        };
      }, {});
      return { ...o, ...i };
    }
  };
}
function op(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && yI(t) ? !1 : t != null)
  );
}
function ip(n) {
  var e, t;
  const o = {};
  return !((e = n == null ? void 0 : n.attribute) != null && e.isRequired) && "default" in ((n == null ? void 0 : n.attribute) || {}) && (o.default = n.attribute.default), ((t = n == null ? void 0 : n.attribute) == null ? void 0 : t.validate) !== void 0 && (o.validate = n.attribute.validate), [n.name, o];
}
function CI(n, e) {
  var t;
  const o = $4(n), { nodeExtensions: i, markExtensions: r } = ds(n), s = (t = i.find((d) => be(d, "topNode"))) == null ? void 0 : t.name, a = Object.fromEntries(
    i.map((d) => {
      const u = o.filter((b) => b.type === d.name), c = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: e
      }, f = n.reduce((b, x) => {
        const w = be(x, "extendNodeSchema", c);
        return {
          ...b,
          ...w ? w(d) : {}
        };
      }, {}), h = op({
        ...f,
        content: Qe(be(d, "content", c)),
        marks: Qe(be(d, "marks", c)),
        group: Qe(be(d, "group", c)),
        inline: Qe(be(d, "inline", c)),
        atom: Qe(be(d, "atom", c)),
        selectable: Qe(be(d, "selectable", c)),
        draggable: Qe(be(d, "draggable", c)),
        code: Qe(be(d, "code", c)),
        whitespace: Qe(be(d, "whitespace", c)),
        linebreakReplacement: Qe(
          be(d, "linebreakReplacement", c)
        ),
        defining: Qe(be(d, "defining", c)),
        isolating: Qe(be(d, "isolating", c)),
        attrs: Object.fromEntries(u.map(ip))
      }), p = Qe(be(d, "parseHTML", c));
      p && (h.parseDOM = p.map(
        (b) => np(b, u)
      ));
      const m = be(d, "renderHTML", c);
      m && (h.toDOM = (b) => m({
        node: b,
        HTMLAttributes: Ma(b, u)
      }));
      const g = be(d, "renderText", c);
      return g && (h.toText = g), [d.name, h];
    })
  ), l = Object.fromEntries(
    r.map((d) => {
      const u = o.filter((g) => g.type === d.name), c = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: e
      }, f = n.reduce((g, b) => {
        const x = be(b, "extendMarkSchema", c);
        return {
          ...g,
          ...x ? x(d) : {}
        };
      }, {}), h = op({
        ...f,
        inclusive: Qe(be(d, "inclusive", c)),
        excludes: Qe(be(d, "excludes", c)),
        group: Qe(be(d, "group", c)),
        spanning: Qe(be(d, "spanning", c)),
        code: Qe(be(d, "code", c)),
        attrs: Object.fromEntries(u.map(ip))
      }), p = Qe(be(d, "parseHTML", c));
      p && (h.parseDOM = p.map(
        (g) => np(g, u)
      ));
      const m = be(d, "renderHTML", c);
      return m && (h.toDOM = (g) => m({
        mark: g,
        HTMLAttributes: Ma(g, u)
      })), [d.name, h];
    })
  );
  return new ng({
    topNode: s,
    nodes: a,
    marks: l
  });
}
function wI(n) {
  const e = n.filter((t, o) => n.indexOf(t) !== o);
  return Array.from(new Set(e));
}
function Xs(n) {
  return n.sort((t, o) => {
    const i = be(t, "priority") || 100, r = be(o, "priority") || 100;
    return i > r ? -1 : i < r ? 1 : 0;
  });
}
function M4(n) {
  const e = Xs(dh(n)), t = wI(e.map((o) => o.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((o) => `'${o}'`).join(", ")}]. This can lead to issues.`
  ), e;
}
function S4(n, e, t) {
  const { from: o, to: i } = e, { blockSeparator: r = `

`, textSerializers: s = {} } = t || {};
  let a = "";
  return n.nodesBetween(o, i, (l, d, u, c) => {
    var f;
    l.isBlock && d > o && (a += r);
    const h = s == null ? void 0 : s[l.type.name];
    if (h)
      return u && (a += h({
        node: l,
        pos: d,
        parent: u,
        index: c,
        range: e
      })), !1;
    l.isText && (a += (f = l == null ? void 0 : l.text) == null ? void 0 : f.slice(Math.max(o, d) - d, i - d));
  }), a;
}
function kI(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return S4(n, t, e);
}
function _4(n) {
  return Object.fromEntries(
    Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText])
  );
}
function $I(n, e) {
  const t = _t(e, n.schema), { from: o, to: i } = n.selection, r = [];
  n.doc.nodesBetween(o, i, (a) => {
    r.push(a);
  });
  const s = r.reverse().find((a) => a.type.name === t.name);
  return s ? { ...s.attrs } : {};
}
function E4(n, e) {
  const t = Au(
    typeof e == "string" ? e : e.name,
    n.schema
  );
  return t === "node" ? $I(n, e) : t === "mark" ? C4(n, e) : {};
}
function MI(n, e = JSON.stringify) {
  const t = {};
  return n.filter((o) => {
    const i = e(o);
    return Object.prototype.hasOwnProperty.call(t, i) ? !1 : t[i] = !0;
  });
}
function SI(n) {
  const e = MI(n);
  return e.length === 1 ? e : e.filter((t, o) => !e.filter((r, s) => s !== o).some((r) => t.oldRange.from >= r.oldRange.from && t.oldRange.to <= r.oldRange.to && t.newRange.from >= r.newRange.from && t.newRange.to <= r.newRange.to));
}
function O4(n) {
  const { mapping: e, steps: t } = n, o = [];
  return e.maps.forEach((i, r) => {
    const s = [];
    if (i.ranges.length)
      i.forEach((a, l) => {
        s.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[r];
      if (a === void 0 || l === void 0)
        return;
      s.push({ from: a, to: l });
    }
    s.forEach(({ from: a, to: l }) => {
      const d = e.slice(r).map(a, -1), u = e.slice(r).map(l), c = e.invert().map(d, -1), f = e.invert().map(u);
      o.push({
        oldRange: {
          from: c,
          to: f
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), SI(o);
}
function ch(n, e, t) {
  const o = [];
  return n === e ? t.resolve(n).marks().forEach((i) => {
    const r = t.resolve(n), s = lh(r, i.type);
    s && o.push({
      mark: i,
      ...s
    });
  }) : t.nodesBetween(n, e, (i, r) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || o.push(
      ...i.marks.map((s) => ({
        from: r,
        to: r + i.nodeSize,
        mark: s
      }))
    );
  }), o;
}
var _I = (n, e, t, o = 20) => {
  const i = n.doc.resolve(t);
  let r = o, s = null;
  for (; r > 0 && s === null; ) {
    const a = i.node(r);
    (a == null ? void 0 : a.type.name) === e ? s = a : r -= 1;
  }
  return [s, r];
};
function Ss(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Pl(n, e, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([o]) => {
      const i = n.find((r) => r.type === e && r.name === o);
      return i ? i.attribute.keepOnSplit : !1;
    })
  );
}
var EI = (n, e = 500) => {
  let t = "";
  const o = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, o - e), o, (i, r, s, a) => {
    var l, d;
    const u = ((d = (l = i.type.spec).toText) == null ? void 0 : d.call(l, {
      node: i,
      pos: r,
      parent: s,
      index: a
    })) || i.textContent || "%leaf%";
    t += i.isAtom && !i.isText ? u : u.slice(0, Math.max(0, o - r));
  }), t;
};
function If(n, e, t = {}) {
  const { empty: o, ranges: i } = n.selection, r = e ? qo(e, n.schema) : null;
  if (o)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((c) => r ? r.name === c.type.name : !0).find((c) => fd(c.attrs, t, { strict: !1 }));
  let s = 0;
  const a = [];
  if (i.forEach(({ $from: c, $to: f }) => {
    const h = c.pos, p = f.pos;
    n.doc.nodesBetween(h, p, (m, g) => {
      if (r && m.inlineContent && !m.type.allowsMarkType(r))
        return !1;
      if (!m.isText && !m.marks.length)
        return;
      const b = Math.max(h, g), x = Math.min(p, g + m.nodeSize), w = x - b;
      s += w, a.push(
        ...m.marks.map((M) => ({
          mark: M,
          from: b,
          to: x
        }))
      );
    });
  }), s === 0)
    return !1;
  const l = a.filter((c) => r ? r.name === c.mark.type.name : !0).filter((c) => fd(c.mark.attrs, t, { strict: !1 })).reduce((c, f) => c + f.to - f.from, 0), d = a.filter((c) => r ? c.mark.type !== r && c.mark.type.excludes(r) : !0).reduce((c, f) => c + f.to - f.from, 0);
  return (l > 0 ? l + d : l) >= s;
}
function OI(n, e, t = {}) {
  if (!e)
    return Si(n, null, t) || If(n, null, t);
  const o = Au(e, n.schema);
  return o === "node" ? Si(n, e, t) : o === "mark" ? If(n, e, t) : !1;
}
var TI = (n, e) => {
  const { $from: t, $to: o, $anchor: i } = n.selection;
  if (e) {
    const r = Iu((a) => a.type.name === e)(n.selection);
    if (!r)
      return !1;
    const s = n.doc.resolve(r.pos + 1);
    return i.pos + 1 === s.end();
  }
  return !(o.parentOffset < o.parent.nodeSize - 2 || t.pos !== o.pos);
}, AI = (n) => {
  const { $from: e, $to: t } = n.selection;
  return !(e.parentOffset > 0 || e.pos !== t.pos);
};
function rp(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function sp(n, e) {
  const { nodeExtensions: t } = ds(e), o = t.find((s) => s.name === n);
  if (!o)
    return !1;
  const i = {
    name: o.name,
    options: o.options,
    storage: o.storage
  }, r = Qe(be(o, "group", i));
  return typeof r != "string" ? !1 : r.split(" ").includes("list");
}
function Du(n, {
  checkChildren: e = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var o;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((o = n.text) != null ? o : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return n.content.forEach((r) => {
      i !== !1 && (Du(r, { ignoreWhitespace: t, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function T4(n) {
  return n instanceof xe;
}
var A4 = class I4 {
  constructor(e) {
    this.position = e;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(e) {
    return new I4(e.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function II(n, e) {
  const t = e.mapping.mapResult(n.position);
  return {
    position: new A4(t.pos),
    mapResult: t
  };
}
function DI(n) {
  return new A4(n);
}
function NI(n, e, t) {
  var o;
  const { selection: i } = e;
  let r = null;
  if (v4(i) && (r = i.$cursor), r) {
    const a = (o = n.storedMarks) != null ? o : r.marks();
    return r.parent.type.allowsMarkType(t) && (!!t.isInSet(a) || !a.some((d) => d.type.excludes(t)));
  }
  const { ranges: s } = i;
  return s.some(({ $from: a, $to: l }) => {
    let d = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (u, c, f) => {
      if (d)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(t), p = !!t.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(t));
        d = h && p;
      }
      return !d;
    }), d;
  });
}
var PI = (n, e = {}) => ({ tr: t, state: o, dispatch: i }) => {
  const { selection: r } = t, { empty: s, ranges: a } = r, l = qo(n, o.schema);
  if (i)
    if (s) {
      const d = C4(o, l);
      t.addStoredMark(
        l.create({
          ...d,
          ...e
        })
      );
    } else
      a.forEach((d) => {
        const u = d.$from.pos, c = d.$to.pos;
        o.doc.nodesBetween(u, c, (f, h) => {
          const p = Math.max(h, u), m = Math.min(h + f.nodeSize, c);
          f.marks.find((b) => b.type === l) ? f.marks.forEach((b) => {
            l === b.type && t.addMark(
              p,
              m,
              l.create({
                ...b.attrs,
                ...e
              })
            );
          }) : t.addMark(p, m, l.create(e));
        });
      });
  return NI(o, t, l);
}, LI = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), RI = (n, e = {}) => ({ state: t, dispatch: o, chain: i }) => {
  const r = _t(n, t.schema);
  let s;
  return t.selection.$anchor.sameParent(t.selection.$head) && (s = t.selection.$anchor.parent.attrs), r.isTextblock ? i().command(({ commands: a }) => y3(r, { ...s, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => y3(r, { ...s, ...e })(a, o)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, FI = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: o } = e, i = Zi(n, 0, o.content.size), r = xe.create(o, i);
    e.setSelection(r);
  }
  return !0;
}, BI = (n, e) => ({ tr: t, state: o, dispatch: i }) => {
  const { selection: r } = o;
  let s, a;
  return typeof e == "number" ? (s = e, a = e) : e && "from" in e && "to" in e ? (s = e.from, a = e.to) : (s = r.from, a = r.to), i && t.doc.nodesBetween(s, a, (l, d) => {
    l.isText || t.setNodeMarkup(d, void 0, {
      ...l.attrs,
      dir: n
    });
  }), !0;
}, VI = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: o } = e, { from: i, to: r } = typeof n == "number" ? { from: n, to: n } : n, s = Te.atStart(o).from, a = Te.atEnd(o).to, l = Zi(i, s, a), d = Zi(r, s, a), u = Te.create(o, l, d);
    e.setSelection(u);
  }
  return !0;
}, zI = (n) => ({ state: e, dispatch: t }) => {
  const o = _t(n, e.schema);
  return NO(o)(e, t);
};
function ap(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const o = t.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    n.tr.ensureMarks(o);
  }
}
var HI = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: o, editor: i }) => {
  const { selection: r, doc: s } = e, { $from: a, $to: l } = r, d = i.extensionManager.attributes, u = Pl(d, a.node().type.name, a.node().attrs);
  if (r instanceof xe && r.node.isBlock)
    return !a.parentOffset || !Fo(s, a.pos) ? !1 : (o && (n && ap(t, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const c = l.parentOffset === l.parent.content.size, f = a.depth === 0 ? void 0 : gI(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let h = c && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, p = Fo(e.doc, e.mapping.map(a.pos), 1, h);
  if (!h && !p && Fo(e.doc, e.mapping.map(a.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), o) {
    if (p && (r instanceof Te && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, h), f && !c && !a.parentOffset && a.parent.type !== f)) {
      const m = e.mapping.map(a.before()), g = e.doc.resolve(m);
      a.node(-1).canReplaceWith(g.index(), g.index() + 1, f) && e.setNodeMarkup(e.mapping.map(a.before()), f);
    }
    n && ap(t, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, jI = (n, e = {}) => ({ tr: t, state: o, dispatch: i, editor: r }) => {
  var s;
  const a = _t(n, o.schema), { $from: l, $to: d } = o.selection, u = o.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(d))
    return !1;
  const c = l.node(-1);
  if (c.type !== a)
    return !1;
  const f = r.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let b = Q.empty;
      const x = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let S = l.depth - x; S >= l.depth - 3; S -= 1)
        b = Q.from(l.node(S).copy(b));
      const w = (
        // eslint-disable-next-line no-nested-ternary
        l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3
      ), M = {
        ...Pl(f, l.node().type.name, l.node().attrs),
        ...e
      }, $ = ((s = a.contentMatch.defaultType) == null ? void 0 : s.createAndFill(M)) || void 0;
      b = b.append(Q.from(a.createAndFill(null, $) || void 0));
      const T = l.before(l.depth - (x - 1));
      t.replace(T, l.after(-w), new he(b, 4 - x, 0));
      let E = -1;
      t.doc.nodesBetween(T, t.doc.content.size, (S, D) => {
        if (E > -1)
          return !1;
        S.isTextblock && S.content.size === 0 && (E = D + 1);
      }), E > -1 && t.setSelection(Te.near(t.doc.resolve(E))), t.scrollIntoView();
    }
    return !0;
  }
  const h = d.pos === l.end() ? c.contentMatchAt(0).defaultType : null, p = {
    ...Pl(f, c.type.name, c.attrs),
    ...e
  }, m = {
    ...Pl(f, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, d.pos);
  const g = h ? [
    { type: a, attrs: p },
    { type: h, attrs: m }
  ] : [{ type: a, attrs: p }];
  if (!Fo(t.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: b, storedMarks: x } = o, { splittableMarks: w } = r.extensionManager, M = x || b.$to.parentOffset && b.$from.marks();
    if (t.split(l.pos, 2, g).scrollIntoView(), !M || !i)
      return !0;
    const $ = M.filter((T) => w.includes(T.type.name));
    t.ensureMarks($);
  }
  return !0;
}, xc = (n, e) => {
  const t = Iu((s) => s.type === e)(n.selection);
  if (!t)
    return !0;
  const o = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (o === void 0)
    return !0;
  const i = n.doc.nodeAt(o);
  return t.node.type === (i == null ? void 0 : i.type) && Ii(n.doc, t.pos) && n.join(t.pos), !0;
}, Cc = (n, e) => {
  const t = Iu((s) => s.type === e)(n.selection);
  if (!t)
    return !0;
  const o = n.doc.resolve(t.start).after(t.depth);
  if (o === void 0)
    return !0;
  const i = n.doc.nodeAt(o);
  return t.node.type === (i == null ? void 0 : i.type) && Ii(n.doc, o) && n.join(o), !0;
}, WI = (n, e, t, o = {}) => ({ editor: i, tr: r, state: s, dispatch: a, chain: l, commands: d, can: u }) => {
  const { extensions: c, splittableMarks: f } = i.extensionManager, h = _t(n, s.schema), p = _t(e, s.schema), { selection: m, storedMarks: g } = s, { $from: b, $to: x } = m, w = b.blockRange(x), M = g || m.$to.parentOffset && m.$from.marks();
  if (!w)
    return !1;
  const $ = Iu((T) => sp(T.type.name, c))(m);
  if (w.depth >= 1 && $ && w.depth - $.depth <= 1) {
    if ($.node.type === h)
      return d.liftListItem(p);
    if (sp($.node.type.name, c) && h.validContent($.node.content) && a)
      return l().command(() => (r.setNodeMarkup($.pos, h), !0)).command(() => xc(r, h)).command(() => Cc(r, h)).run();
  }
  return !t || !M || !a ? l().command(() => u().wrapInList(h, o) ? !0 : d.clearNodes()).wrapInList(h, o).command(() => xc(r, h)).command(() => Cc(r, h)).run() : l().command(() => {
    const T = u().wrapInList(h, o), E = M.filter((S) => f.includes(S.type.name));
    return r.ensureMarks(E), T ? !0 : d.clearNodes();
  }).wrapInList(h, o).command(() => xc(r, h)).command(() => Cc(r, h)).run();
}, UI = (n, e = {}, t = {}) => ({ state: o, commands: i }) => {
  const { extendEmptyMarkRange: r = !1 } = t, s = qo(n, o.schema);
  return If(o, s, e) ? i.unsetMark(s, { extendEmptyMarkRange: r }) : i.setMark(s, e);
}, KI = (n, e, t = {}) => ({ state: o, commands: i }) => {
  const r = _t(n, o.schema), s = _t(e, o.schema), a = Si(o, r, t);
  let l;
  return o.selection.$anchor.sameParent(o.selection.$head) && (l = o.selection.$anchor.parent.attrs), a ? i.setNode(s, l) : i.setNode(r, { ...l, ...t });
}, GI = (n, e = {}) => ({ state: t, commands: o }) => {
  const i = _t(n, t.schema);
  return Si(t, i, e) ? o.lift(i) : o.wrapIn(i, e);
}, YI = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let o = 0; o < t.length; o += 1) {
    const i = t[o];
    let r;
    if (i.spec.isInputRules && (r = i.getState(n))) {
      if (e) {
        const s = n.tr, a = r.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          s.step(a.steps[l].invert(a.docs[l]));
        if (r.text) {
          const l = s.doc.resolve(r.from).marks();
          s.replaceWith(r.from, r.to, n.schema.text(r.text, l));
        } else
          s.delete(r.from, r.to);
      }
      return !0;
    }
  }
  return !1;
}, qI = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: o, ranges: i } = t;
  return o || e && i.forEach((r) => {
    n.removeMark(r.$from.pos, r.$to.pos);
  }), !0;
}, ZI = (n, e = {}) => ({ tr: t, state: o, dispatch: i }) => {
  var r;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: a } = t, l = qo(n, o.schema), { $from: d, empty: u, ranges: c } = a;
  if (!i)
    return !0;
  if (u && s) {
    let { from: f, to: h } = a;
    const p = (r = d.marks().find((g) => g.type === l)) == null ? void 0 : r.attrs, m = lh(d, l, p);
    m && (f = m.from, h = m.to), t.removeMark(f, h, l);
  } else
    c.forEach((f) => {
      t.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, JI = (n) => ({ tr: e, state: t, dispatch: o }) => {
  const { selection: i } = t;
  let r, s;
  return typeof n == "number" ? (r = n, s = n) : n && "from" in n && "to" in n ? (r = n.from, s = n.to) : (r = i.from, s = i.to), o && e.doc.nodesBetween(r, s, (a, l) => {
    if (a.isText)
      return;
    const d = { ...a.attrs };
    delete d.dir, e.setNodeMarkup(l, void 0, d);
  }), !0;
}, XI = (n, e = {}) => ({ tr: t, state: o, dispatch: i }) => {
  let r = null, s = null;
  const a = Au(
    typeof n == "string" ? n : n.name,
    o.schema
  );
  if (!a)
    return !1;
  a === "node" && (r = _t(n, o.schema)), a === "mark" && (s = qo(n, o.schema));
  let l = !1;
  return t.selection.ranges.forEach((d) => {
    const u = d.$from.pos, c = d.$to.pos;
    let f, h, p, m;
    t.selection.empty ? o.doc.nodesBetween(u, c, (g, b) => {
      r && r === g.type && (l = !0, p = Math.max(b, u), m = Math.min(b + g.nodeSize, c), f = b, h = g);
    }) : o.doc.nodesBetween(u, c, (g, b) => {
      b < u && r && r === g.type && (l = !0, p = Math.max(b, u), m = Math.min(b + g.nodeSize, c), f = b, h = g), b >= u && b <= c && (r && r === g.type && (l = !0, i && t.setNodeMarkup(b, void 0, {
        ...g.attrs,
        ...e
      })), s && g.marks.length && g.marks.forEach((x) => {
        if (s === x.type && (l = !0, i)) {
          const w = Math.max(b, u), M = Math.min(b + g.nodeSize, c);
          t.addMark(
            w,
            M,
            s.create({
              ...x.attrs,
              ...e
            })
          );
        }
      }));
    }), h && (f !== void 0 && i && t.setNodeMarkup(f, void 0, {
      ...h.attrs,
      ...e
    }), s && h.marks.length && h.marks.forEach((g) => {
      s === g.type && i && t.addMark(
        p,
        m,
        s.create({
          ...g.attrs,
          ...e
        })
      );
    }));
  }), l;
}, QI = (n, e = {}) => ({ state: t, dispatch: o }) => {
  const i = _t(n, t.schema);
  return _O(i, e)(t, o);
}, eD = (n, e = {}) => ({ state: t, dispatch: o }) => {
  const i = _t(n, t.schema);
  return EO(i, e)(t, o);
}, tD = class {
  constructor() {
    this.callbacks = {};
  }
  on(n, e) {
    return this.callbacks[n] || (this.callbacks[n] = []), this.callbacks[n].push(e), this;
  }
  emit(n, ...e) {
    const t = this.callbacks[n];
    return t && t.forEach((o) => o.apply(this, e)), this;
  }
  off(n, e) {
    const t = this.callbacks[n];
    return t && (e ? this.callbacks[n] = t.filter((o) => o !== e) : delete this.callbacks[n]), this;
  }
  once(n, e) {
    const t = (...o) => {
      this.off(n, t), e.apply(this, o);
    };
    return this.on(n, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, Nu = class {
  constructor(n) {
    var e;
    this.find = n.find, this.handler = n.handler, this.undoable = (e = n.undoable) != null ? e : !0;
  }
}, nD = (n, e) => {
  if (ah(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const o = [t.text];
  return o.index = t.index, o.input = n, o.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), o.push(t.replaceWith)), o;
};
function ll(n) {
  var e;
  const { editor: t, from: o, to: i, text: r, rules: s, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const d = l.state.doc.resolve(o);
  if (
    // check for code node
    d.parent.type.spec.code || (e = d.nodeBefore || d.nodeAfter) != null && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let u = !1;
  const c = EI(d) + r;
  return s.forEach((f) => {
    if (u)
      return;
    const h = nD(c, f.find);
    if (!h)
      return;
    const p = l.state.tr, m = Ou({
      state: l.state,
      transaction: p
    }), g = {
      from: o - (h[0].length - r.length),
      to: i
    }, { commands: b, chain: x, can: w } = new Tu({
      editor: t,
      state: m
    });
    f.handler({
      state: m,
      range: g,
      match: h,
      commands: b,
      chain: x,
      can: w
    }) === null || !p.steps.length || (f.undoable && p.setMeta(a, {
      transform: p,
      from: o,
      to: i,
      text: r
    }), l.dispatch(p), u = !0);
  }), u;
}
function oD(n) {
  const { editor: e, rules: t } = n, o = new mt({
    state: {
      init() {
        return null;
      },
      apply(i, r, s) {
        const a = i.getMeta(o);
        if (a)
          return a;
        const l = i.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = uh(Q.from(u), s.schema);
          const { from: c } = l, f = c + u.length;
          ll({
            editor: e,
            from: c,
            to: f,
            text: u,
            rules: t,
            plugin: o
          });
        }), i.selectionSet || i.docChanged ? null : r;
      }
    },
    props: {
      handleTextInput(i, r, s, a) {
        return ll({
          editor: e,
          from: r,
          to: s,
          text: a,
          rules: t,
          plugin: o
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: r } = i.state.selection;
          r && ll({
            editor: e,
            from: r.pos,
            to: r.pos,
            text: "",
            rules: t,
            plugin: o
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, r) {
        if (r.key !== "Enter")
          return !1;
        const { $cursor: s } = i.state.selection;
        return s ? ll({
          editor: e,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: t,
          plugin: o
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return o;
}
function iD(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function dl(n) {
  return iD(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function D4(n, e) {
  const t = { ...n };
  return dl(n) && dl(e) && Object.keys(e).forEach((o) => {
    dl(e[o]) && dl(n[o]) ? t[o] = D4(n[o], e[o]) : t[o] = e[o];
  }), t;
}
var fh = class {
  constructor(n = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...n
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Qe(
        be(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Qe(
        be(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(n = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => D4(this.options, n)
    });
    return e.name = this.name, e.parent = this.parent, e;
  }
  extend(n = {}) {
    const e = new this.constructor({ ...this.config, ...n });
    return e.parent = this, this.child = e, e.name = "name" in n ? n.name : e.parent.name, e;
  }
}, yr = class N4 extends fh {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new N4(t);
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: o } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const s = i.marks();
      if (!!!s.find((d) => (d == null ? void 0 : d.type.name) === t.name))
        return !1;
      const l = s.find((d) => (d == null ? void 0 : d.type.name) === t.name);
      return l && o.removeStoredMark(l), o.insertText(" ", i.pos), e.view.dispatch(o), !0;
    }
    return !1;
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
};
function rD(n) {
  return typeof n == "number";
}
var sD = class {
  constructor(n) {
    this.find = n.find, this.handler = n.handler;
  }
}, aD = (n, e, t) => {
  if (ah(e))
    return [...n.matchAll(e)];
  const o = e(n, t);
  return o ? o.map((i) => {
    const r = [i.text];
    return r.index = i.index, r.input = n, r.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), r.push(i.replaceWith)), r;
  }) : [];
};
function lD(n) {
  const { editor: e, state: t, from: o, to: i, rule: r, pasteEvent: s, dropEvent: a } = n, { commands: l, chain: d, can: u } = new Tu({
    editor: e,
    state: t
  }), c = [];
  return t.doc.nodesBetween(o, i, (h, p) => {
    var m, g, b, x, w;
    if ((g = (m = h.type) == null ? void 0 : m.spec) != null && g.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const M = (w = (x = (b = h.content) == null ? void 0 : b.size) != null ? x : h.nodeSize) != null ? w : 0, $ = Math.max(o, p), T = Math.min(i, p + M);
    if ($ >= T)
      return;
    const E = h.isText ? h.text || "" : h.textBetween($ - p, T - p, void 0, "￼");
    aD(E, r.find, s).forEach((D) => {
      if (D.index === void 0)
        return;
      const I = $ + D.index + 1, z = I + D[0].length, F = {
        from: t.tr.mapping.map(I),
        to: t.tr.mapping.map(z)
      }, Y = r.handler({
        state: t,
        range: F,
        match: D,
        commands: l,
        chain: d,
        can: u,
        pasteEvent: s,
        dropEvent: a
      });
      c.push(Y);
    });
  }), c.every((h) => h !== null);
}
var ul = null, dD = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) == null || e.setData("text/html", n), t;
};
function uD(n) {
  const { editor: e, rules: t } = n;
  let o = null, i = !1, r = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({
    state: u,
    from: c,
    to: f,
    rule: h,
    pasteEvt: p
  }) => {
    const m = u.tr, g = Ou({
      state: u,
      transaction: m
    });
    if (!(!lD({
      editor: e,
      state: g,
      from: Math.max(c - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: a
    }) || !m.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
    }
  };
  return t.map((u) => new mt({
    // we register a global drag handler to track the current drag source element
    view(c) {
      const f = (p) => {
        var m;
        o = (m = c.dom.parentElement) != null && m.contains(p.target) ? c.dom.parentElement : null, o && (ul = e);
      }, h = () => {
        ul && (ul = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (c, f) => {
          if (r = o === c.dom.parentElement, a = f, !r) {
            const h = ul;
            h != null && h.isEditable && setTimeout(() => {
              const p = h.state.selection;
              p && h.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (c, f) => {
          var h;
          const p = (h = f.clipboardData) == null ? void 0 : h.getData("text/html");
          return s = f, i = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (c, f, h) => {
      const p = c[0], m = p.getMeta("uiEvent") === "paste" && !i, g = p.getMeta("uiEvent") === "drop" && !r, b = p.getMeta("applyPasteRules"), x = !!b;
      if (!m && !g && !x)
        return;
      if (x) {
        let { text: $ } = b;
        typeof $ == "string" ? $ = $ : $ = uh(Q.from($), h.schema);
        const { from: T } = b, E = T + $.length, S = dD($);
        return l({
          rule: u,
          state: h,
          from: T,
          to: { b: E },
          pasteEvt: S
        });
      }
      const w = f.doc.content.findDiffStart(h.doc.content), M = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!rD(w) || !M || w === M.b))
        return l({
          rule: u,
          state: h,
          from: w,
          to: M,
          pasteEvt: s
        });
    }
  }));
}
var Pu = class {
  constructor(n, e) {
    this.splittableMarks = [], this.editor = e, this.baseExtensions = n, this.extensions = M4(n), this.schema = CI(this.extensions, e), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((n, e) => {
      const t = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: Ss(e.name, this.schema)
      }, o = be(e, "addCommands", t);
      return o ? {
        ...n,
        ...o()
      } : n;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: n } = this;
    return Xs([...this.extensions].reverse()).flatMap((o) => {
      const i = {
        name: o.name,
        options: o.options,
        storage: this.editor.extensionStorage[o.name],
        editor: n,
        type: Ss(o.name, this.schema)
      }, r = [], s = be(
        o,
        "addKeyboardShortcuts",
        i
      );
      let a = {};
      if (o.type === "mark" && be(o, "exitable", i) && (a.ArrowRight = () => yr.handleExit({ editor: n, mark: o })), s) {
        const f = Object.fromEntries(
          Object.entries(s()).map(([h, p]) => [h, () => p({ editor: n })])
        );
        a = { ...a, ...f };
      }
      const l = $A(a);
      r.push(l);
      const d = be(o, "addInputRules", i);
      if (rp(o, n.options.enableInputRules) && d) {
        const f = d();
        if (f && f.length) {
          const h = oD({
            editor: n,
            rules: f
          }), p = Array.isArray(h) ? h : [h];
          r.push(...p);
        }
      }
      const u = be(o, "addPasteRules", i);
      if (rp(o, n.options.enablePasteRules) && u) {
        const f = u();
        if (f && f.length) {
          const h = uD({ editor: n, rules: f });
          r.push(...h);
        }
      }
      const c = be(
        o,
        "addProseMirrorPlugins",
        i
      );
      if (c) {
        const f = c();
        r.push(...f);
      }
      return r;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return $4(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: n } = this, { nodeExtensions: e } = ds(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!be(t, "addNodeView")).map((t) => {
        const o = this.attributes.filter((l) => l.type === t.name), i = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: _t(t.name, this.schema)
        }, r = be(t, "addNodeView", i);
        if (!r)
          return [];
        const s = r();
        if (!s)
          return [];
        const a = (l, d, u, c, f) => {
          const h = Ma(l, o);
          return s({
            // pass-through
            node: l,
            view: d,
            getPos: u,
            decorations: c,
            innerDecorations: f,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: h
          });
        };
        return [t.name, a];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(n) {
    const { editor: e } = this;
    return Xs([...this.extensions].reverse()).reduceRight((o, i) => {
      const r = {
        name: i.name,
        options: i.options,
        storage: this.editor.extensionStorage[i.name],
        editor: e,
        type: Ss(i.name, this.schema)
      }, s = be(
        i,
        "dispatchTransaction",
        r
      );
      return s ? (a) => {
        s.call(r, { transaction: a, next: o });
      } : o;
    }, n);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(n) {
    const { editor: e } = this;
    return Xs([...this.extensions]).reduce(
      (o, i) => {
        const r = {
          name: i.name,
          options: i.options,
          storage: this.editor.extensionStorage[i.name],
          editor: e,
          type: Ss(i.name, this.schema)
        }, s = be(
          i,
          "transformPastedHTML",
          r
        );
        return s ? (a, l) => {
          const d = o(a, l);
          return s.call(r, d);
        } : o;
      },
      n || ((o) => o)
    );
  }
  get markViews() {
    const { editor: n } = this, { markExtensions: e } = ds(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!be(t, "addMarkView")).map((t) => {
        const o = this.attributes.filter((a) => a.type === t.name), i = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: qo(t.name, this.schema)
        }, r = be(t, "addMarkView", i);
        if (!r)
          return [];
        const s = (a, l, d) => {
          const u = Ma(a, o);
          return r()({
            // pass-through
            mark: a,
            view: l,
            inline: d,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: u,
            updateAttributes: (c) => {
              MD(a, n, c);
            }
          });
        };
        return [t.name, s];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const n = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      n.map((e) => [e.name, e.storage])
    ), n.forEach((e) => {
      var t;
      const o = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: Ss(e.name, this.schema)
      };
      e.type === "mark" && ((t = Qe(be(e, "keepOnSplit", o))) == null || t) && this.splittableMarks.push(e.name);
      const i = be(e, "onBeforeCreate", o), r = be(e, "onCreate", o), s = be(e, "onUpdate", o), a = be(
        e,
        "onSelectionUpdate",
        o
      ), l = be(e, "onTransaction", o), d = be(e, "onFocus", o), u = be(e, "onBlur", o), c = be(e, "onDestroy", o);
      i && this.editor.on("beforeCreate", i), r && this.editor.on("create", r), s && this.editor.on("update", s), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), d && this.editor.on("focus", d), u && this.editor.on("blur", u), c && this.editor.on("destroy", c);
    });
  }
};
Pu.resolve = M4;
Pu.sort = Xs;
Pu.flatten = dh;
var cD = {};
sh(cD, {
  ClipboardTextSerializer: () => L4,
  Commands: () => R4,
  Delete: () => F4,
  Drop: () => B4,
  Editable: () => V4,
  FocusEvents: () => H4,
  Keymap: () => j4,
  Paste: () => W4,
  Tabindex: () => U4,
  TextDirection: () => K4,
  focusEventsPluginKey: () => z4
});
var xt = class P4 extends fh {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new P4(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
}, L4 = xt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: o, selection: i } = e, { ranges: r } = i, s = Math.min(...r.map((u) => u.$from.pos)), a = Math.max(...r.map((u) => u.$to.pos)), l = _4(t);
            return S4(o, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), R4 = xt.create({
  name: "commands",
  addCommands() {
    return {
      ...m4
    };
  }
}), F4 = xt.create({
  name: "delete",
  onUpdate({ transaction: n, appendedTransactions: e }) {
    var t, o, i;
    const r = () => {
      var s, a, l, d;
      if ((d = (l = (a = (s = this.editor.options.coreExtensionOptions) == null ? void 0 : s.delete) == null ? void 0 : a.filterTransaction) == null ? void 0 : l.call(a, n)) != null ? d : n.getMeta("y-sync$"))
        return;
      const u = w4(n.before, [n, ...e]);
      O4(u).forEach((h) => {
        u.mapping.mapResult(h.oldRange.from).deletedAfter && u.mapping.mapResult(h.oldRange.to).deletedBefore && u.before.nodesBetween(h.oldRange.from, h.oldRange.to, (p, m) => {
          const g = m + p.nodeSize - 2, b = h.oldRange.from <= m && g <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: m,
            to: g,
            newFrom: u.mapping.map(m),
            newTo: u.mapping.map(g),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !b,
            editor: this.editor,
            transaction: n,
            combinedTransform: u
          });
        });
      });
      const f = u.mapping;
      u.steps.forEach((h, p) => {
        var m, g;
        if (h instanceof Qn) {
          const b = f.slice(p).map(h.from, -1), x = f.slice(p).map(h.to), w = f.invert().map(b, -1), M = f.invert().map(x), $ = (m = u.doc.nodeAt(b - 1)) == null ? void 0 : m.marks.some((E) => E.eq(h.mark)), T = (g = u.doc.nodeAt(x)) == null ? void 0 : g.marks.some((E) => E.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: w,
              to: M
            },
            newRange: {
              from: b,
              to: x
            },
            partial: !!(T || $),
            editor: this.editor,
            transaction: n,
            combinedTransform: u
          });
        }
      });
    };
    (i = (o = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : o.async) == null || i ? setTimeout(r, 0) : r();
  }
}), B4 = xt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, o) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: o
            });
          }
        }
      })
    ];
  }
}), V4 = xt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), z4 = new Tt("focusEvents"), H4 = xt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new mt({
        key: z4,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const o = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(o), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const o = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(o), !1;
            }
          }
        }
      })
    ];
  }
}), j4 = xt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: l, doc: d } = a, { empty: u, $anchor: c } = l, { pos: f, parent: h } = c, p = c.parent.isTextblock && f > 0 ? a.doc.resolve(f - 1) : c, m = p.parent.type.spec.isolating, g = c.pos - c.parentOffset, b = m && p.parent.childCount === 1 ? g === c.pos : Le.atStart(d).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !b || b && c.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), o = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...o
    }, r = {
      ...o,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return hd() || x4() ? r : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new mt({
        key: new Tt("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((m) => m.getMeta("composition")))
            return;
          const o = n.some((m) => m.docChanged) && !e.doc.eq(t.doc), i = n.some((m) => m.getMeta("preventClearDocument"));
          if (!o || i)
            return;
          const { empty: r, from: s, to: a } = e.selection, l = Le.atStart(e.doc).from, d = Le.atEnd(e.doc).to;
          if (r || !(s === l && a === d) || !Du(t.doc))
            return;
          const f = t.tr, h = Ou({
            state: t,
            transaction: f
          }), { commands: p } = new Tu({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), W4 = xt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), U4 = xt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), K4 = xt.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: n } = ds(this.extensions);
    return [
      {
        types: n.filter((e) => e.name !== "text").map((e) => e.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (e) => {
              const t = e.getAttribute("dir");
              return t && (t === "ltr" || t === "rtl" || t === "auto") ? t : this.options.direction;
            },
            renderHTML: (e) => e.dir ? {
              dir: e.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("textDirection"),
        props: {
          attributes: () => {
            const n = this.options.direction;
            return n ? {
              dir: n
            } : {};
          }
        }
      })
    ];
  }
}), fD = class Fs {
  constructor(e, t, o = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = o, this.resolvedPos = e, this.editor = t, this.currentNode = i;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) != null ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, o = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, o = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: o }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Fs(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Fs(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Fs(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, o) => {
      const i = t.isBlock && !t.isTextblock, r = t.isAtom && !t.isText, s = t.isInline, a = this.pos + o + (r ? 0 : 1);
      if (a < 0 || a > this.resolvedPos.doc.nodeSize - 2)
        return;
      const l = this.resolvedPos.doc.resolve(a);
      if (!i && !s && l.depth <= this.depth)
        return;
      const d = new Fs(l, this.editor, i, i || s ? t : null);
      i && (d.actualDepth = this.depth + 1), e.push(d);
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let o = null, i = this.parent;
    for (; i && !o; ) {
      if (i.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const r = i.node.attrs, s = Object.keys(t);
          for (let a = 0; a < s.length; a += 1) {
            const l = s[a];
            if (r[l] !== t[l])
              break;
          }
        } else
          o = i;
      i = i.parent;
    }
    return o;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, o = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const r = Object.keys(t);
    return this.children.forEach((s) => {
      o && i.length > 0 || (s.node.type.name === e && r.every((l) => t[l] === s.node.attrs[l]) && i.push(s), !(o && i.length > 0) && (i = i.concat(s.querySelectorAll(e, t, o))));
    }), i;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}, hD = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function pD(n, e, t) {
  const o = document.querySelector("style[data-tiptap-style]");
  if (o !== null)
    return o;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(i), i;
}
var mD = class extends tD {
  constructor(e = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: i }) => {
        throw i;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: II,
      createMappablePosition: DI
    }, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: i, slice: r, moved: s }) => this.options.onDrop(i, r, s)), this.on("paste", ({ event: i, slice: r }) => this.options.onPaste(i, r)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), o = b4(t, this.options.autofocus);
    this.editorState = Br.create({
      doc: t,
      schema: this.schema,
      selection: o || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(e) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(e), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const e = this.editorView.dom;
      e != null && e.editor && delete e.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (e) {
        console.warn("Failed to remove CSS element:", e);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = pD(hD, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (e) => {
          this.editorState = e;
        },
        dispatch: (e) => {
          this.dispatchTransaction(e);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (e, t) => {
          if (this.editorView)
            return this.editorView[t];
          if (t === "state")
            return this.editorState;
          if (t in e)
            return Reflect.get(e, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const o = k4(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: o });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let o = t;
    if ([].concat(e).forEach((r) => {
      const s = typeof r == "string" ? `${r}$` : r.key;
      o = o.filter((a) => !a.key.startsWith(s));
    }), t.length === o.length)
      return;
    const i = this.state.reconfigure({
      plugins: o
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const i = [...this.options.enableCoreExtensions ? [
      V4,
      L4.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) == null ? void 0 : e.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      R4,
      H4,
      j4,
      U4,
      B4,
      W4,
      F4,
      K4.configure({
        direction: this.options.textDirection
      })
    ].filter((r) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[r.name] !== !1 : !0) : [], ...this.options.extensions].filter((r) => ["extension", "node", "mark"].includes(r == null ? void 0 : r.type));
    this.extensionManager = new Pu(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Tu({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let e;
    try {
      e = Af(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((o) => o.name !== "collaboration"), this.createExtensionManager();
        }
      }), e = Af(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return e;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(e) {
    const { editorProps: t, enableExtensionDispatchTransaction: o } = this.options, i = t.dispatchTransaction || this.dispatchTransaction.bind(this), r = o ? this.extensionManager.dispatchTransaction(i) : i, s = t.transformPastedHTML, a = this.extensionManager.transformPastedHTML(s);
    this.editorView = new h4(e, {
      ...t,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...t == null ? void 0 : t.attributes
      },
      dispatchTransaction: r,
      transformPastedHTML: a,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const l = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(l), this.prependClass(), this.injectCSS();
    const d = this.view.dom;
    d.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((u) => {
        var c;
        return (c = this.capturedTransaction) == null ? void 0 : c.step(u);
      });
      return;
    }
    const { state: t, transactions: o } = this.state.applyTransaction(e), i = !this.state.selection.eq(t.selection), r = o.includes(e), s = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), !r)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e,
      appendedTransactions: o.slice(1)
    }), i && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const a = o.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), l = a == null ? void 0 : a.getMeta("focus"), d = a == null ? void 0 : a.getMeta("blur");
    l && this.emit("focus", {
      editor: this,
      event: l.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: a
    }), d && this.emit("blur", {
      editor: this,
      event: d.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: a
    }), !(e.getMeta("preventUpdate") || !o.some((u) => u.docChanged) || s.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: e,
      appendedTransactions: o.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return E4(this.state, e);
  }
  isActive(e, t) {
    const o = typeof e == "string" ? e : null, i = typeof e == "string" ? t : e;
    return OI(this.state, o, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return uh(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: o = {} } = e || {};
    return kI(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ..._4(this.schema),
        ...o
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Du(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.unmount(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e, t;
    return (t = (e = this.editorView) == null ? void 0 : e.isDestroyed) != null ? t : !0;
  }
  $node(e, t) {
    var o;
    return ((o = this.$doc) == null ? void 0 : o.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var o;
    return ((o = this.$doc) == null ? void 0 : o.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new fD(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function us(n) {
  return new Nu({
    find: n.find,
    handler: ({ state: e, range: t, match: o }) => {
      const i = Qe(n.getAttributes, void 0, o);
      if (i === !1 || i === null)
        return null;
      const { tr: r } = e, s = o[o.length - 1], a = o[0];
      if (s) {
        const l = a.search(/\S/), d = t.from + a.indexOf(s), u = d + s.length;
        if (ch(t.from, t.to, e.doc).filter((h) => h.mark.type.excluded.find((m) => m === n.type && m !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        u < t.to && r.delete(u, t.to), d > t.from && r.delete(t.from + l, d);
        const f = t.from + l + s.length;
        r.addMark(t.from + l, f, n.type.create(i || {})), r.removeStoredMark(n.type);
      }
    },
    undoable: n.undoable
  });
}
function G4(n) {
  return new Nu({
    find: n.find,
    handler: ({ state: e, range: t, match: o }) => {
      const i = Qe(n.getAttributes, void 0, o) || {}, { tr: r } = e, s = t.from;
      let a = t.to;
      const l = n.type.create(i);
      if (o[1]) {
        const d = o[0].lastIndexOf(o[1]);
        let u = s + d;
        u > a ? u = a : a = u + o[1].length;
        const c = o[0][o[0].length - 1];
        r.insertText(c, s + o[0].length - 1), r.replaceWith(u, a, l);
      } else if (o[0]) {
        const d = n.type.isInline ? s : s - 1;
        r.insert(d, n.type.create(i)).delete(r.mapping.map(s), r.mapping.map(a));
      }
      r.scrollIntoView();
    },
    undoable: n.undoable
  });
}
function Df(n) {
  return new Nu({
    find: n.find,
    handler: ({ state: e, range: t, match: o }) => {
      const i = e.doc.resolve(t.from), r = Qe(n.getAttributes, void 0, o) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, r);
    },
    undoable: n.undoable
  });
}
function cs(n) {
  return new Nu({
    find: n.find,
    handler: ({ state: e, range: t, match: o, chain: i }) => {
      const r = Qe(n.getAttributes, void 0, o) || {}, s = e.tr.delete(t.from, t.to), l = s.doc.resolve(t.from).blockRange(), d = l && W1(l, n.type, r);
      if (!d)
        return null;
      if (s.wrap(l, d), n.keepMarks && n.editor) {
        const { selection: c, storedMarks: f } = e, { splittableMarks: h } = n.editor.extensionManager, p = f || c.$to.parentOffset && c.$from.marks();
        if (p) {
          const m = p.filter((g) => h.includes(g.type.name));
          s.ensureMarks(m);
        }
      }
      if (n.keepAttributes) {
        const c = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(c, r).run();
      }
      const u = s.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === n.type && Ii(s.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(o, u)) && s.join(t.from - 1);
    },
    undoable: n.undoable
  });
}
var gD = (n) => "touches" in n, vD = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(n) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (a) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const l = a.clientX - this.startX, d = a.clientY - this.startY;
      this.handleResize(l, d);
    }, this.handleTouchMove = (a) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const l = a.touches[0];
      if (!l)
        return;
      const d = l.clientX - this.startX, u = l.clientY - this.startY;
      this.handleResize(d, u);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const a = this.element.offsetWidth, l = this.element.offsetHeight;
      this.onCommit(a, l), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (a) => {
      a.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (a) => {
      a.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var e, t, o, i, r, s;
    this.node = n.node, this.editor = n.editor, this.element = n.element, this.contentElement = n.contentElement, this.getPos = n.getPos, this.onResize = n.onResize, this.onCommit = n.onCommit, this.onUpdate = n.onUpdate, (e = n.options) != null && e.min && (this.minSize = {
      ...this.minSize,
      ...n.options.min
    }), (t = n.options) != null && t.max && (this.maxSize = n.options.max), (o = n == null ? void 0 : n.options) != null && o.directions && (this.directions = n.options.directions), (i = n.options) != null && i.preserveAspectRatio && (this.preserveAspectRatio = n.options.preserveAspectRatio), (r = n.options) != null && r.className && (this.classNames = {
      container: n.options.className.container || "",
      wrapper: n.options.className.wrapper || "",
      handle: n.options.className.handle || "",
      resizing: n.options.className.resizing || ""
    }), (s = n.options) != null && s.createCustomHandle && (this.createCustomHandle = n.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var n;
    return (n = this.contentElement) != null ? n : null;
  }
  handleEditorUpdate() {
    const n = this.editor.isEditable;
    n !== this.lastEditableState && (this.lastEditableState = n, n ? n && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(n, e, t) {
    return n.type !== this.node.type ? !1 : (this.node = n, this.onUpdate ? this.onUpdate(n, e, t) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const n = document.createElement("div");
    return n.dataset.resizeContainer = "", n.dataset.node = this.node.type.name, n.style.display = "flex", this.classNames.container && (n.className = this.classNames.container), n.appendChild(this.wrapper), n;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const n = document.createElement("div");
    return n.style.position = "relative", n.style.display = "block", n.dataset.resizeWrapper = "", this.classNames.wrapper && (n.className = this.classNames.wrapper), n.appendChild(this.element), n;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(n) {
    const e = document.createElement("div");
    return e.dataset.resizeHandle = n, e.style.position = "absolute", this.classNames.handle && (e.className = this.classNames.handle), e;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(n, e) {
    const t = e.includes("top"), o = e.includes("bottom"), i = e.includes("left"), r = e.includes("right");
    t && (n.style.top = "0"), o && (n.style.bottom = "0"), i && (n.style.left = "0"), r && (n.style.right = "0"), (e === "top" || e === "bottom") && (n.style.left = "0", n.style.right = "0"), (e === "left" || e === "right") && (n.style.top = "0", n.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((n) => {
      let e;
      this.createCustomHandle ? e = this.createCustomHandle(n) : e = this.createHandle(n), e instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${n}") did not return an HTMLElement. Falling back to default handle.`
      ), e = this.createHandle(n)), this.createCustomHandle || this.positionHandle(e, n), e.addEventListener("mousedown", (t) => this.handleResizeStart(t, n)), e.addEventListener("touchstart", (t) => this.handleResizeStart(t, n)), this.handleMap.set(n, e), this.wrapper.appendChild(e);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((n) => n.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const n = this.node.attrs.width, e = this.node.attrs.height;
    n ? (this.element.style.width = `${n}px`, this.initialWidth = n) : this.initialWidth = this.element.offsetWidth, e ? (this.element.style.height = `${e}px`, this.initialHeight = e) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(n, e) {
    n.preventDefault(), n.stopPropagation(), this.isResizing = !0, this.activeHandle = e, gD(n) ? (this.startX = n.touches[0].clientX, this.startY = n.touches[0].clientY) : (this.startX = n.clientX, this.startY = n.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(n, e) {
    if (!this.activeHandle)
      return;
    const t = this.preserveAspectRatio || this.isShiftKeyPressed, { width: o, height: i } = this.calculateNewDimensions(this.activeHandle, n, e), r = this.applyConstraints(o, i, t);
    this.element.style.width = `${r.width}px`, this.element.style.height = `${r.height}px`, this.onResize && this.onResize(r.width, r.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(n, e, t) {
    let o = this.startWidth, i = this.startHeight;
    const r = n.includes("right"), s = n.includes("left"), a = n.includes("bottom"), l = n.includes("top");
    return r ? o = this.startWidth + e : s && (o = this.startWidth - e), a ? i = this.startHeight + t : l && (i = this.startHeight - t), (n === "right" || n === "left") && (o = this.startWidth + (r ? e : -e)), (n === "top" || n === "bottom") && (i = this.startHeight + (a ? t : -t)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(o, i, n) : { width: o, height: i };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(n, e, t) {
    var o, i, r, s;
    if (!t) {
      let d = Math.max(this.minSize.width, n), u = Math.max(this.minSize.height, e);
      return (o = this.maxSize) != null && o.width && (d = Math.min(this.maxSize.width, d)), (i = this.maxSize) != null && i.height && (u = Math.min(this.maxSize.height, u)), { width: d, height: u };
    }
    let a = n, l = e;
    return a < this.minSize.width && (a = this.minSize.width, l = a / this.aspectRatio), l < this.minSize.height && (l = this.minSize.height, a = l * this.aspectRatio), (r = this.maxSize) != null && r.width && a > this.maxSize.width && (a = this.maxSize.width, l = a / this.aspectRatio), (s = this.maxSize) != null && s.height && l > this.maxSize.height && (l = this.maxSize.height, a = l * this.aspectRatio), { width: a, height: l };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(n, e, t) {
    const o = t === "left" || t === "right", i = t === "top" || t === "bottom";
    return o ? {
      width: n,
      height: n / this.aspectRatio
    } : i ? {
      width: e * this.aspectRatio,
      height: e
    } : {
      width: n,
      height: n / this.aspectRatio
    };
  }
};
function bD(n, e) {
  const { selection: t } = n, { $from: o } = t;
  if (t instanceof xe) {
    const r = o.index();
    return o.parent.canReplaceWith(r, r + 1, e);
  }
  let i = o.depth;
  for (; i >= 0; ) {
    const r = o.index(i);
    if (o.node(i).contentMatchAt(r).matchType(e))
      return !0;
    i -= 1;
  }
  return !1;
}
var yD = {};
sh(yD, {
  createAtomBlockMarkdownSpec: () => xD,
  createBlockMarkdownSpec: () => CD,
  createInlineMarkdownSpec: () => $D,
  parseAttributes: () => hh,
  parseIndentedBlocks: () => Nf,
  renderNestedMarkdownContent: () => mh,
  serializeAttributes: () => ph
});
function hh(n) {
  if (!(n != null && n.trim()))
    return {};
  const e = {}, t = [], o = n.replace(/["']([^"']*)["']/g, (d) => (t.push(d), `__QUOTED_${t.length - 1}__`)), i = o.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (i) {
    const d = i.map((u) => u.trim().slice(1));
    e.class = d.join(" ");
  }
  const r = o.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  r && (e.id = r[1]);
  const s = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(o.matchAll(s)).forEach(([, d, u]) => {
    var c;
    const f = parseInt(((c = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : c[1]) || "0", 10), h = t[f];
    h && (e[d] = h.slice(1, -1));
  });
  const l = o.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return l && l.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (e[u] = !0);
  }), e;
}
function ph(n) {
  if (!n || Object.keys(n).length === 0)
    return "";
  const e = [];
  return n.class && String(n.class).split(/\s+/).filter(Boolean).forEach((o) => e.push(`.${o}`)), n.id && e.push(`#${n.id}`), Object.entries(n).forEach(([t, o]) => {
    t === "class" || t === "id" || (o === !0 ? e.push(t) : o !== !1 && o != null && e.push(`${t}="${String(o)}"`));
  }), e.join(" ");
}
function xD(n) {
  const {
    nodeName: e,
    name: t,
    parseAttributes: o = hh,
    serializeAttributes: i = ph,
    defaultAttributes: r = {},
    requiredAttributes: s = [],
    allowedAttributes: a
  } = n, l = t || e, d = (u) => {
    if (!a)
      return u;
    const c = {};
    return a.forEach((f) => {
      f in u && (c[f] = u[f]);
    }), c;
  };
  return {
    parseMarkdown: (u, c) => {
      const f = { ...r, ...u.attributes };
      return c.createNode(e, f, []);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(u) {
        var c;
        const f = new RegExp(`^:::${l}(?:\\s|$)`, "m"), h = (c = u.match(f)) == null ? void 0 : c.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(u, c, f) {
        const h = new RegExp(`^:::${l}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), p = u.match(h);
        if (!p)
          return;
        const m = p[1] || "", g = o(m);
        if (!s.find((x) => !(x in g)))
          return {
            type: e,
            raw: p[0],
            attributes: g
          };
      }
    },
    renderMarkdown: (u) => {
      const c = d(u.attrs || {}), f = i(c), h = f ? ` {${f}}` : "";
      return `:::${l}${h} :::`;
    }
  };
}
function CD(n) {
  const {
    nodeName: e,
    name: t,
    getContent: o,
    parseAttributes: i = hh,
    serializeAttributes: r = ph,
    defaultAttributes: s = {},
    content: a = "block",
    allowedAttributes: l
  } = n, d = t || e, u = (c) => {
    if (!l)
      return c;
    const f = {};
    return l.forEach((h) => {
      h in c && (f[h] = c[h]);
    }), f;
  };
  return {
    parseMarkdown: (c, f) => {
      let h;
      if (o) {
        const m = o(c);
        h = typeof m == "string" ? [{ type: "text", text: m }] : m;
      } else a === "block" ? h = f.parseChildren(c.tokens || []) : h = f.parseInline(c.tokens || []);
      const p = { ...s, ...c.attributes };
      return f.createNode(e, p, h);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(c) {
        var f;
        const h = new RegExp(`^:::${d}`, "m"), p = (f = c.match(h)) == null ? void 0 : f.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(c, f, h) {
        var p;
        const m = new RegExp(`^:::${d}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), g = c.match(m);
        if (!g)
          return;
        const [b, x = ""] = g, w = i(x);
        let M = 1;
        const $ = b.length;
        let T = "";
        const E = /^:::([\w-]*)(\s.*)?/gm, S = c.slice($);
        for (E.lastIndex = 0; ; ) {
          const D = E.exec(S);
          if (D === null)
            break;
          const I = D.index, z = D[1];
          if (!((p = D[2]) != null && p.endsWith(":::"))) {
            if (z)
              M += 1;
            else if (M -= 1, M === 0) {
              const F = S.slice(0, I);
              T = F.trim();
              const Y = c.slice(0, $ + I + D[0].length);
              let ie = [];
              if (T)
                if (a === "block")
                  for (ie = h.blockTokens(F), ie.forEach((W) => {
                    W.text && (!W.tokens || W.tokens.length === 0) && (W.tokens = h.inlineTokens(W.text));
                  }); ie.length > 0; ) {
                    const W = ie[ie.length - 1];
                    if (W.type === "paragraph" && (!W.text || W.text.trim() === ""))
                      ie.pop();
                    else
                      break;
                  }
                else
                  ie = h.inlineTokens(T);
              return {
                type: e,
                raw: Y,
                attributes: w,
                content: T,
                tokens: ie
              };
            }
          }
        }
      }
    },
    renderMarkdown: (c, f) => {
      const h = u(c.attrs || {}), p = r(h), m = p ? ` {${p}}` : "", g = f.renderChildren(c.content || [], `

`);
      return `:::${d}${m}

${g}

:::`;
    }
  };
}
function wD(n) {
  if (!n.trim())
    return {};
  const e = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let o = t.exec(n);
  for (; o !== null; ) {
    const [, i, r, s] = o;
    e[i] = r || s, o = t.exec(n);
  }
  return e;
}
function kD(n) {
  return Object.entries(n).filter(([, e]) => e != null).map(([e, t]) => `${e}="${t}"`).join(" ");
}
function $D(n) {
  const {
    nodeName: e,
    name: t,
    getContent: o,
    parseAttributes: i = wD,
    serializeAttributes: r = kD,
    defaultAttributes: s = {},
    selfClosing: a = !1,
    allowedAttributes: l
  } = n, d = t || e, u = (f) => {
    if (!l)
      return f;
    const h = {};
    return l.forEach((p) => {
      const m = typeof p == "string" ? p : p.name, g = typeof p == "string" ? void 0 : p.skipIfDefault;
      if (m in f) {
        const b = f[m];
        if (g !== void 0 && b === g)
          return;
        h[m] = b;
      }
    }), h;
  }, c = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (f, h) => {
      const p = { ...s, ...f.attributes };
      if (a)
        return h.createNode(e, p);
      const m = o ? o(f) : f.content || "";
      return m ? h.createNode(e, p, [h.createTextNode(m)]) : h.createNode(e, p, []);
    },
    markdownTokenizer: {
      name: e,
      level: "inline",
      start(f) {
        const h = a ? new RegExp(`\\[${c}\\s*[^\\]]*\\]`) : new RegExp(`\\[${c}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${c}\\]`), p = f.match(h), m = p == null ? void 0 : p.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(f, h, p) {
        const m = a ? new RegExp(`^\\[${c}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${c}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${c}\\]`), g = f.match(m);
        if (!g)
          return;
        let b = "", x = "";
        if (a) {
          const [, M] = g;
          x = M;
        } else {
          const [, M, $] = g;
          x = M, b = $ || "";
        }
        const w = i(x.trim());
        return {
          type: e,
          raw: g[0],
          content: b.trim(),
          attributes: w
        };
      }
    },
    renderMarkdown: (f) => {
      let h = "";
      o ? h = o(f) : f.content && f.content.length > 0 && (h = f.content.filter((b) => b.type === "text").map((b) => b.text).join(""));
      const p = u(f.attrs || {}), m = r(p), g = m ? ` ${m}` : "";
      return a ? `[${d}${g}]` : `[${d}${g}]${h}[/${d}]`;
    }
  };
}
function Nf(n, e, t) {
  var o, i, r, s;
  const a = n.split(`
`), l = [];
  let d = "", u = 0;
  const c = e.baseIndentSize || 2;
  for (; u < a.length; ) {
    const f = a[u], h = f.match(e.itemPattern);
    if (!h) {
      if (l.length > 0)
        break;
      if (f.trim() === "") {
        u += 1, d = `${d}${f}
`;
        continue;
      } else
        return;
    }
    const p = e.extractItemData(h), { indentLevel: m, mainContent: g } = p;
    d = `${d}${f}
`;
    const b = [g];
    for (u += 1; u < a.length; ) {
      const $ = a[u];
      if ($.trim() === "") {
        const E = a.slice(u + 1).findIndex((I) => I.trim() !== "");
        if (E === -1)
          break;
        if ((((i = (o = a[u + 1 + E].match(/^(\s*)/)) == null ? void 0 : o[1]) == null ? void 0 : i.length) || 0) > m) {
          b.push($), d = `${d}${$}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((s = (r = $.match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : s.length) || 0) > m)
        b.push($), d = `${d}${$}
`, u += 1;
      else
        break;
    }
    let x;
    const w = b.slice(1);
    if (w.length > 0) {
      const $ = w.map((T) => T.slice(m + c)).join(`
`);
      $.trim() && (e.customNestedParser ? x = e.customNestedParser($) : x = t.blockTokens($));
    }
    const M = e.createToken(p, x);
    l.push(M);
  }
  if (l.length !== 0)
    return {
      items: l,
      raw: d
    };
}
function mh(n, e, t, o) {
  if (!n || !Array.isArray(n.content))
    return "";
  const i = typeof t == "function" ? t(o) : t, [r, ...s] = n.content, a = e.renderChildren([r]), l = [`${i}${a}`];
  return s && s.length > 0 && s.forEach((d) => {
    const u = e.renderChildren([d]);
    if (u) {
      const c = u.split(`
`).map((f) => f ? e.indent(f) : "").join(`
`);
      l.push(c);
    }
  }), l.join(`
`);
}
function MD(n, e, t = {}) {
  const { state: o } = e, { doc: i, tr: r } = o, s = n;
  i.descendants((a, l) => {
    const d = r.mapping.map(l), u = r.mapping.map(l) + a.nodeSize;
    let c = null;
    if (a.marks.forEach((h) => {
      if (h !== s)
        return !1;
      c = h;
    }), !c)
      return;
    let f = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== c.attrs[h] && (f = !0);
    }), f) {
      const h = n.type.create({
        ...n.attrs,
        ...t
      });
      r.removeMark(d, u, n.type), r.addMark(d, u, h);
    }
  }), r.docChanged && e.view.dispatch(r);
}
var cn = class Y4 extends fh {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new Y4(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
};
function fr(n) {
  return new sD({
    find: n.find,
    handler: ({ state: e, range: t, match: o, pasteEvent: i }) => {
      const r = Qe(n.getAttributes, void 0, o, i);
      if (r === !1 || r === null)
        return null;
      const { tr: s } = e, a = o[o.length - 1], l = o[0];
      let d = t.to;
      if (a) {
        const u = l.search(/\S/), c = t.from + l.indexOf(a), f = c + a.length;
        if (ch(t.from, t.to, e.doc).filter((p) => p.mark.type.excluded.find((g) => g === n.type && g !== p.mark.type)).filter((p) => p.to > c).length)
          return null;
        f < t.to && s.delete(f, t.to), c > t.from && s.delete(t.from + u, c), d = t.from + u + a.length, s.addMark(t.from + u, d, n.type.create(r || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
function lp(n) {
  return N2((e, t) => ({
    get() {
      return e(), n;
    },
    set(o) {
      n = o, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
var SD = class extends mD {
  constructor(n = {}) {
    return super(n), this.contentComponent = null, this.appContext = null, this.reactiveState = lp(this.view.state), this.reactiveExtensionStorage = lp(this.extensionStorage), this.on("beforeTransaction", ({ nextState: e }) => {
      this.reactiveState.value = e, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), O2(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(n, e) {
    const t = super.registerPlugin(n, e);
    return this.reactiveState && (this.reactiveState.value = t), t;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(n) {
    const e = super.unregisterPlugin(n);
    return this.reactiveState && e && (this.reactiveState.value = e), e;
  }
}, _D = H({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(n) {
    const e = R(), t = qn();
    return dt(() => {
      const o = n.editor;
      o && o.options.element && e.value && Ve(() => {
        var i;
        if (!e.value || !((i = o.view.dom) != null && i.parentNode))
          return;
        const r = k(e.value);
        e.value.append(...o.view.dom.parentNode.childNodes), o.contentComponent = t.ctx._, t && (o.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), o.setOptions({
          element: r
        }), o.createNodeViews();
      });
    }), ps(() => {
      const o = n.editor;
      o && (o.contentComponent = null, o.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return lt("div", {
      ref: (n) => {
        this.rootEl = n;
      }
    });
  }
});
H({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return lt(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
H({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var n, e;
    return lt(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (e = (n = this.$slots).default) == null ? void 0 : e.call(n)
    );
  }
});
var ED = (n = {}) => {
  const e = mr();
  return We(() => {
    e.value = new SD(n);
  }), ps(() => {
    var t, o, i, r;
    const s = (o = (t = e.value) == null ? void 0 : t.view.dom) == null ? void 0 : o.parentNode, a = s == null ? void 0 : s.cloneNode(!0);
    (i = s == null ? void 0 : s.parentNode) == null || i.replaceChild(a, s), (r = e.value) == null || r.destroy();
  }), e;
};
H({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return lt(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var pd = (n, e) => {
  if (n === "slot")
    return 0;
  if (n instanceof Function)
    return n(e);
  const { children: t, ...o } = e ?? {};
  if (n === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [n, o, t];
}, OD = /^\s*>\s$/, TD = cn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ pd("blockquote", { ...yt(this.options.HTMLAttributes, n), children: /* @__PURE__ */ pd("slot", {}) });
  },
  parseMarkdown: (n, e) => e.createNode("blockquote", void 0, e.parseChildren(n.tokens || [])),
  renderMarkdown: (n, e) => {
    if (!n.content)
      return "";
    const t = ">", o = [];
    return n.content.forEach((i) => {
      const a = e.renderChildren([i]).split(`
`).map((l) => l.trim() === "" ? t : `${t} ${l}`);
      o.push(a.join(`
`));
    }), o.join(`
${t}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      cs({
        find: OD,
        type: this.type
      })
    ];
  }
}), AD = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, ID = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, DD = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, ND = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, PD = yr.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ pd("strong", { ...yt(this.options.HTMLAttributes, n), children: /* @__PURE__ */ pd("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (n, e) => e.applyMark("bold", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `**${e.renderChildren(n)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      us({
        find: AD,
        type: this.type
      }),
      us({
        find: DD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fr({
        find: ID,
        type: this.type
      }),
      fr({
        find: ND,
        type: this.type
      })
    ];
  }
}), LD = /(^|[^`])`([^`]+)`(?!`)$/, RD = /(^|[^`])`([^`]+)`(?!`)/g, FD = yr.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", yt(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (n, e) => e.applyMark("code", [{ type: "text", text: n.text || "" }]),
  renderMarkdown: (n, e) => n.content ? `\`${e.renderChildren(n.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      us({
        find: LD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fr({
        find: RD,
        type: this.type
      })
    ];
  }
}), wc = 4, BD = /^```([a-z]+)?[\s\n]$/, VD = /^~~~([a-z]+)?[\s\n]$/, zD = cn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: wc,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options;
          if (!t)
            return null;
          const r = [...((e = n.firstElementChild) == null ? void 0 : e.classList) || []].filter((s) => s.startsWith(t)).map((s) => s.replace(t, ""))[0];
          return r || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      yt(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (n, e) => {
    var t;
    return ((t = n.raw) == null ? void 0 : t.startsWith("```")) === !1 && n.codeBlockStyle !== "indented" ? [] : e.createNode(
      "codeBlock",
      { language: n.lang || null },
      n.text ? [e.createTextNode(n.text)] : []
    );
  },
  renderMarkdown: (n, e) => {
    var t;
    let o = "";
    const i = ((t = n.attrs) == null ? void 0 : t.language) || "";
    return n.content ? o = [`\`\`\`${i}`, e.renderChildren(n.content), "```"].join(`
`) : o = `\`\`\`${i}

\`\`\``, o;
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: n }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (e = this.options.tabSize) != null ? e : wc, { state: o } = n, { selection: i } = o, { $from: r, empty: s } = i;
        if (r.parent.type !== this.type)
          return !1;
        const a = " ".repeat(t);
        return s ? n.commands.insertContent(a) : n.commands.command(({ tr: l }) => {
          const { from: d, to: u } = i, h = o.doc.textBetween(d, u, `
`, `
`).split(`
`).map((p) => a + p).join(`
`);
          return l.replaceWith(d, u, o.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: n }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (e = this.options.tabSize) != null ? e : wc, { state: o } = n, { selection: i } = o, { $from: r, empty: s } = i;
        return r.parent.type !== this.type ? !1 : s ? n.commands.command(({ tr: a }) => {
          var l;
          const { pos: d } = r, u = r.start(), c = r.end(), h = o.doc.textBetween(u, c, `
`, `
`).split(`
`);
          let p = 0, m = 0;
          const g = d - u;
          for (let T = 0; T < h.length; T += 1) {
            if (m + h[T].length >= g) {
              p = T;
              break;
            }
            m += h[T].length + 1;
          }
          const x = ((l = h[p].match(/^ */)) == null ? void 0 : l[0]) || "", w = Math.min(x.length, t);
          if (w === 0)
            return !0;
          let M = u;
          for (let T = 0; T < p; T += 1)
            M += h[T].length + 1;
          return a.delete(M, M + w), d - M <= w && a.setSelection(Te.create(a.doc, M)), !0;
        }) : n.commands.command(({ tr: a }) => {
          const { from: l, to: d } = i, f = o.doc.textBetween(l, d, `
`, `
`).split(`
`).map((h) => {
            var p;
            const m = ((p = h.match(/^ */)) == null ? void 0 : p[0]) || "", g = Math.min(m.length, t);
            return h.slice(g);
          }).join(`
`);
          return a.replaceWith(l, d, o.schema.text(f)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: o, empty: i } = t;
        if (!i || o.parent.type !== this.type)
          return !1;
        const r = o.parentOffset === o.parent.nodeSize - 2, s = o.parent.textContent.endsWith(`

`);
        return !r || !s ? !1 : n.chain().command(({ tr: a }) => (a.delete(o.pos - 2, o.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: o } = e, { $from: i, empty: r } = t;
        if (!r || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 ? !1 : o.nodeAt(a) ? n.commands.command(({ tr: d }) => (d.setSelection(Le.near(o.resolve(a))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Df({
        find: BD,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      Df({
        find: VD,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new mt({
        key: new Tt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), o = e.clipboardData.getData("vscode-editor-data"), i = o ? JSON.parse(o) : void 0, r = i == null ? void 0 : i.mode;
            if (!t || !r)
              return !1;
            const { tr: s, schema: a } = n.state, l = a.text(t.replace(/\r\n?/g, `
`));
            return s.replaceSelectionWith(this.type.create({ language: r }, l)), s.selection.$from.parent.type !== this.type && s.setSelection(Te.near(s.doc.resolve(Math.max(0, s.selection.from - 2)))), s.setMeta("paste", !0), n.dispatch(s), !0;
          }
        }
      })
    ];
  }
}), HD = cn.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `

`) : ""
}), jD = cn.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", yt(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: o }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: i, storedMarks: r } = t;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: a } = o.extensionManager, l = r || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && l && s) {
              const c = l.filter((f) => a.includes(f.type.name));
              d.ensureMarks(c);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), WD = cn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, yt(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (n, e) => e.createNode("heading", { level: n.depth || 1 }, e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => {
    var t;
    const o = (t = n.attrs) != null && t.level ? parseInt(n.attrs.level, 10) : 1, i = "#".repeat(o);
    return n.content ? `${i} ${e.renderChildren(n.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (n, e) => ({
        ...n,
        [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((n) => Df({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
}), UD = cn.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", yt(this.options.HTMLAttributes, n)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (n, e) => e.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        if (!bD(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: t } = e, { $to: o } = t, i = n();
        return T4(t) ? i.insertContentAt(o.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ state: r, tr: s, dispatch: a }) => {
          if (a) {
            const { $to: l } = s.selection, d = l.end();
            if (l.nodeAfter)
              l.nodeAfter.isTextblock ? s.setSelection(Te.create(s.doc, l.pos + 1)) : l.nodeAfter.isBlock ? s.setSelection(xe.create(s.doc, l.pos)) : s.setSelection(Te.create(s.doc, l.pos));
            else {
              const u = r.schema.nodes[this.options.nextNodeType] || l.parent.type.contentMatch.defaultType, c = u == null ? void 0 : u.create();
              c && (s.insert(d, c), s.setSelection(Te.create(s.doc, d + 1)));
            }
            s.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      G4({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), KD = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, GD = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, YD = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, qD = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, ZD = yr.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (n, e) => e.applyMark("italic", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `*${e.renderChildren(n)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      us({
        find: KD,
        type: this.type
      }),
      us({
        find: YD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fr({
        find: GD,
        type: this.type
      }),
      fr({
        find: qD,
        type: this.type
      })
    ];
  }
});
const JD = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", XD = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Pf = "numeric", Lf = "ascii", Rf = "alpha", Qs = "asciinumeric", Bs = "alphanumeric", Ff = "domain", q4 = "emoji", QD = "scheme", eN = "slashscheme", kc = "whitespace";
function tN(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Ji(n, e, t) {
  e[Pf] && (e[Qs] = !0, e[Bs] = !0), e[Lf] && (e[Qs] = !0, e[Rf] = !0), e[Qs] && (e[Bs] = !0), e[Rf] && (e[Bs] = !0), e[Bs] && (e[Ff] = !0), e[q4] && (e[Ff] = !0);
  for (const o in e) {
    const i = tN(o, t);
    i.indexOf(n) < 0 && i.push(n);
  }
}
function nN(n, e) {
  const t = {};
  for (const o in e)
    e[o].indexOf(n) >= 0 && (t[o] = !0);
  return t;
}
function vn(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
vn.groups = {};
vn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let o = 0; o < e.jr.length; o++) {
      const i = e.jr[o][0], r = e.jr[o][1];
      if (r && i.test(n))
        return r;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, o) {
    for (let i = 0; i < n.length; i++)
      this.tt(n[i], e, t, o);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, o) {
    o = o || vn.groups;
    let i;
    return e && e.j ? i = e : (i = new vn(e), t && o && Ji(e, t, o)), this.jr.push([n, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, o) {
    let i = this;
    const r = n.length;
    if (!r)
      return i;
    for (let s = 0; s < r - 1; s++)
      i = i.tt(n[s]);
    return i.tt(n[r - 1], e, t, o);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, o) {
    o = o || vn.groups;
    const i = this;
    if (e && e.j)
      return i.j[n] = e, e;
    const r = e;
    let s, a = i.go(n);
    if (a ? (s = new vn(), Object.assign(s.j, a.j), s.jr.push.apply(s.jr, a.jr), s.jd = a.jd, s.t = a.t) : s = new vn(), r) {
      if (o)
        if (s.t && typeof s.t == "string") {
          const l = Object.assign(nN(s.t, o), t);
          Ji(r, l, o);
        } else t && Ji(r, t, o);
      s.t = r;
    }
    return i.j[n] = s, s;
  }
};
const Pe = (n, e, t, o, i) => n.ta(e, t, o, i), gt = (n, e, t, o, i) => n.tr(e, t, o, i), dp = (n, e, t, o, i) => n.ts(e, t, o, i), oe = (n, e, t, o, i) => n.tt(e, t, o, i), Eo = "WORD", Bf = "UWORD", Z4 = "ASCIINUMERICAL", J4 = "ALPHANUMERICAL", Sa = "LOCALHOST", Vf = "TLD", zf = "UTLD", Ll = "SCHEME", Fr = "SLASH_SCHEME", gh = "NUM", Hf = "WS", vh = "NL", ea = "OPENBRACE", ta = "CLOSEBRACE", md = "OPENBRACKET", gd = "CLOSEBRACKET", vd = "OPENPAREN", bd = "CLOSEPAREN", yd = "OPENANGLEBRACKET", xd = "CLOSEANGLEBRACKET", Cd = "FULLWIDTHLEFTPAREN", wd = "FULLWIDTHRIGHTPAREN", kd = "LEFTCORNERBRACKET", $d = "RIGHTCORNERBRACKET", Md = "LEFTWHITECORNERBRACKET", Sd = "RIGHTWHITECORNERBRACKET", _d = "FULLWIDTHLESSTHAN", Ed = "FULLWIDTHGREATERTHAN", Od = "AMPERSAND", Td = "APOSTROPHE", Ad = "ASTERISK", ri = "AT", Id = "BACKSLASH", Dd = "BACKTICK", Nd = "CARET", li = "COLON", bh = "COMMA", Pd = "DOLLAR", uo = "DOT", Ld = "EQUALS", yh = "EXCLAMATION", Ln = "HYPHEN", na = "PERCENT", Rd = "PIPE", Fd = "PLUS", Bd = "POUND", oa = "QUERY", xh = "QUOTE", X4 = "FULLWIDTHMIDDLEDOT", Ch = "SEMI", co = "SLASH", ia = "TILDE", Vd = "UNDERSCORE", Q4 = "EMOJI", zd = "SYM";
var e5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: J4,
  AMPERSAND: Od,
  APOSTROPHE: Td,
  ASCIINUMERICAL: Z4,
  ASTERISK: Ad,
  AT: ri,
  BACKSLASH: Id,
  BACKTICK: Dd,
  CARET: Nd,
  CLOSEANGLEBRACKET: xd,
  CLOSEBRACE: ta,
  CLOSEBRACKET: gd,
  CLOSEPAREN: bd,
  COLON: li,
  COMMA: bh,
  DOLLAR: Pd,
  DOT: uo,
  EMOJI: Q4,
  EQUALS: Ld,
  EXCLAMATION: yh,
  FULLWIDTHGREATERTHAN: Ed,
  FULLWIDTHLEFTPAREN: Cd,
  FULLWIDTHLESSTHAN: _d,
  FULLWIDTHMIDDLEDOT: X4,
  FULLWIDTHRIGHTPAREN: wd,
  HYPHEN: Ln,
  LEFTCORNERBRACKET: kd,
  LEFTWHITECORNERBRACKET: Md,
  LOCALHOST: Sa,
  NL: vh,
  NUM: gh,
  OPENANGLEBRACKET: yd,
  OPENBRACE: ea,
  OPENBRACKET: md,
  OPENPAREN: vd,
  PERCENT: na,
  PIPE: Rd,
  PLUS: Fd,
  POUND: Bd,
  QUERY: oa,
  QUOTE: xh,
  RIGHTCORNERBRACKET: $d,
  RIGHTWHITECORNERBRACKET: Sd,
  SCHEME: Ll,
  SEMI: Ch,
  SLASH: co,
  SLASH_SCHEME: Fr,
  SYM: zd,
  TILDE: ia,
  TLD: Vf,
  UNDERSCORE: Vd,
  UTLD: zf,
  UWORD: Bf,
  WORD: Eo,
  WS: Hf
});
const Mo = /[a-z]/, _s = new RegExp("\\p{L}", "u"), $c = new RegExp("\\p{Emoji}", "u"), So = /\d/, Mc = /\s/, up = "\r", Sc = `
`, oN = "️", iN = "‍", _c = "￼";
let cl = null, fl = null;
function rN(n = []) {
  const e = {};
  vn.groups = e;
  const t = new vn();
  cl == null && (cl = cp(JD)), fl == null && (fl = cp(XD)), oe(t, "'", Td), oe(t, "{", ea), oe(t, "}", ta), oe(t, "[", md), oe(t, "]", gd), oe(t, "(", vd), oe(t, ")", bd), oe(t, "<", yd), oe(t, ">", xd), oe(t, "（", Cd), oe(t, "）", wd), oe(t, "「", kd), oe(t, "」", $d), oe(t, "『", Md), oe(t, "』", Sd), oe(t, "＜", _d), oe(t, "＞", Ed), oe(t, "&", Od), oe(t, "*", Ad), oe(t, "@", ri), oe(t, "`", Dd), oe(t, "^", Nd), oe(t, ":", li), oe(t, ",", bh), oe(t, "$", Pd), oe(t, ".", uo), oe(t, "=", Ld), oe(t, "!", yh), oe(t, "-", Ln), oe(t, "%", na), oe(t, "|", Rd), oe(t, "+", Fd), oe(t, "#", Bd), oe(t, "?", oa), oe(t, '"', xh), oe(t, "/", co), oe(t, ";", Ch), oe(t, "~", ia), oe(t, "_", Vd), oe(t, "\\", Id), oe(t, "・", X4);
  const o = gt(t, So, gh, {
    [Pf]: !0
  });
  gt(o, So, o);
  const i = gt(o, Mo, Z4, {
    [Qs]: !0
  }), r = gt(o, _s, J4, {
    [Bs]: !0
  }), s = gt(t, Mo, Eo, {
    [Lf]: !0
  });
  gt(s, So, i), gt(s, Mo, s), gt(i, So, i), gt(i, Mo, i);
  const a = gt(t, _s, Bf, {
    [Rf]: !0
  });
  gt(a, Mo), gt(a, So, r), gt(a, _s, a), gt(r, So, r), gt(r, Mo), gt(r, _s, r);
  const l = oe(t, Sc, vh, {
    [kc]: !0
  }), d = oe(t, up, Hf, {
    [kc]: !0
  }), u = gt(t, Mc, Hf, {
    [kc]: !0
  });
  oe(t, _c, u), oe(d, Sc, l), oe(d, _c, u), gt(d, Mc, u), oe(u, up), oe(u, Sc), gt(u, Mc, u), oe(u, _c, u);
  const c = gt(t, $c, Q4, {
    [q4]: !0
  });
  oe(c, "#"), gt(c, $c, c), oe(c, oN, c);
  const f = oe(c, iN);
  oe(f, "#"), gt(f, $c, c);
  const h = [[Mo, s], [So, i]], p = [[Mo, null], [_s, a], [So, r]];
  for (let m = 0; m < cl.length; m++)
    ei(t, cl[m], Vf, Eo, h);
  for (let m = 0; m < fl.length; m++)
    ei(t, fl[m], zf, Bf, p);
  Ji(Vf, {
    tld: !0,
    ascii: !0
  }, e), Ji(zf, {
    utld: !0,
    alpha: !0
  }, e), ei(t, "file", Ll, Eo, h), ei(t, "mailto", Ll, Eo, h), ei(t, "http", Fr, Eo, h), ei(t, "https", Fr, Eo, h), ei(t, "ftp", Fr, Eo, h), ei(t, "ftps", Fr, Eo, h), Ji(Ll, {
    scheme: !0,
    ascii: !0
  }, e), Ji(Fr, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((m, g) => m[0] > g[0] ? 1 : -1);
  for (let m = 0; m < n.length; m++) {
    const g = n[m][0], x = n[m][1] ? {
      [QD]: !0
    } : {
      [eN]: !0
    };
    g.indexOf("-") >= 0 ? x[Ff] = !0 : Mo.test(g) ? So.test(g) ? x[Qs] = !0 : x[Lf] = !0 : x[Pf] = !0, dp(t, g, g, x);
  }
  return dp(t, "localhost", Sa, {
    ascii: !0
  }), t.jd = new vn(zd), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, e5)
  };
}
function t5(n, e) {
  const t = sN(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), o = t.length, i = [];
  let r = 0, s = 0;
  for (; s < o; ) {
    let a = n, l = null, d = 0, u = null, c = -1, f = -1;
    for (; s < o && (l = a.go(t[s])); )
      a = l, a.accepts() ? (c = 0, f = 0, u = a) : c >= 0 && (c += t[s].length, f++), d += t[s].length, r += t[s].length, s++;
    r -= c, s -= f, d -= c, i.push({
      t: u.t,
      // token type/name
      v: e.slice(r - d, r),
      // string value
      s: r - d,
      // start index
      e: r
      // end index (excluding)
    });
  }
  return i;
}
function sN(n) {
  const e = [], t = n.length;
  let o = 0;
  for (; o < t; ) {
    let i = n.charCodeAt(o), r, s = i < 55296 || i > 56319 || o + 1 === t || (r = n.charCodeAt(o + 1)) < 56320 || r > 57343 ? n[o] : n.slice(o, o + 2);
    e.push(s), o += s.length;
  }
  return e;
}
function ei(n, e, t, o, i) {
  let r;
  const s = e.length;
  for (let a = 0; a < s - 1; a++) {
    const l = e[a];
    n.j[l] ? r = n.j[l] : (r = new vn(o), r.jr = i.slice(), n.j[l] = r), n = r;
  }
  return r = new vn(t), r.jr = i.slice(), n.j[e[s - 1]] = r, r;
}
function cp(n) {
  const e = [], t = [];
  let o = 0, i = "0123456789";
  for (; o < n.length; ) {
    let r = 0;
    for (; i.indexOf(n[o + r]) >= 0; )
      r++;
    if (r > 0) {
      e.push(t.join(""));
      for (let s = parseInt(n.substring(o, o + r), 10); s > 0; s--)
        t.pop();
      o += r;
    } else
      t.push(n[o]), o++;
  }
  return e;
}
const _a = {
  defaultProtocol: "http",
  events: null,
  format: fp,
  formatHref: fp,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function wh(n, e = null) {
  let t = Object.assign({}, _a);
  n && (t = Object.assign(t, n instanceof wh ? n.o : n));
  const o = t.ignoreTags, i = [];
  for (let r = 0; r < o.length; r++)
    i.push(o[r].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
wh.prototype = {
  o: _a,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const o = e != null;
    let i = this.o[n];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : _a[n], typeof i == "function" && o && (i = i(e, t))) : typeof i == "function" && o && (i = i(e, t.t, t)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let o = this.o[n];
    return typeof o == "function" && e != null && (o = o(e, t.t, t)), o;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function fp(n) {
  return n;
}
function n5(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
n5.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), o = n.get("format", e, this);
    return t && o.length > t ? o.substring(0, t) + "…" : o;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = _a.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), o = n.get("formatHref", t, this), i = n.get("tagName", t, e), r = this.toFormattedString(n), s = {}, a = n.get("className", t, e), l = n.get("target", t, e), d = n.get("rel", t, e), u = n.getObj("attributes", t, e), c = n.getObj("events", t, e);
    return s.href = o, a && (s.class = a), l && (s.target = l), d && (s.rel = d), u && Object.assign(s, u), {
      tagName: i,
      attributes: s,
      content: r,
      eventListeners: c
    };
  }
};
function Lu(n, e) {
  class t extends n5 {
    constructor(i, r) {
      super(i, r), this.t = n;
    }
  }
  for (const o in e)
    t.prototype[o] = e[o];
  return t.t = n, t;
}
const hp = Lu("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), pp = Lu("text"), aN = Lu("nl"), hl = Lu("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = _a.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Sa && n[1].t === li;
  }
}), Dn = (n) => new vn(n);
function lN({
  groups: n
}) {
  const e = n.domain.concat([Od, Ad, ri, Id, Dd, Nd, Pd, Ld, Ln, gh, na, Rd, Fd, Bd, co, zd, ia, Vd]), t = [Td, li, bh, uo, yh, na, oa, xh, Ch, yd, xd, ea, ta, gd, md, vd, bd, Cd, wd, kd, $d, Md, Sd, _d, Ed], o = [Od, Td, Ad, Id, Dd, Nd, Pd, Ld, Ln, ea, ta, na, Rd, Fd, Bd, oa, co, zd, ia, Vd], i = Dn(), r = oe(i, ia);
  Pe(r, o, r), Pe(r, n.domain, r);
  const s = Dn(), a = Dn(), l = Dn();
  Pe(i, n.domain, s), Pe(i, n.scheme, a), Pe(i, n.slashscheme, l), Pe(s, o, r), Pe(s, n.domain, s);
  const d = oe(s, ri);
  oe(r, ri, d), oe(a, ri, d), oe(l, ri, d);
  const u = oe(r, uo);
  Pe(u, o, r), Pe(u, n.domain, r);
  const c = Dn();
  Pe(d, n.domain, c), Pe(c, n.domain, c);
  const f = oe(c, uo);
  Pe(f, n.domain, c);
  const h = Dn(hp);
  Pe(f, n.tld, h), Pe(f, n.utld, h), oe(d, Sa, h);
  const p = oe(c, Ln);
  oe(p, Ln, p), Pe(p, n.domain, c), Pe(h, n.domain, c), oe(h, uo, f), oe(h, Ln, p);
  const m = oe(h, li);
  Pe(m, n.numeric, hp);
  const g = oe(s, Ln), b = oe(s, uo);
  oe(g, Ln, g), Pe(g, n.domain, s), Pe(b, o, r), Pe(b, n.domain, s);
  const x = Dn(hl);
  Pe(b, n.tld, x), Pe(b, n.utld, x), Pe(x, n.domain, s), Pe(x, o, r), oe(x, uo, b), oe(x, Ln, g), oe(x, ri, d);
  const w = oe(x, li), M = Dn(hl);
  Pe(w, n.numeric, M);
  const $ = Dn(hl), T = Dn();
  Pe($, e, $), Pe($, t, T), Pe(T, e, $), Pe(T, t, T), oe(x, co, $), oe(M, co, $);
  const E = oe(a, li), S = oe(l, li), D = oe(S, co), I = oe(D, co);
  Pe(a, n.domain, s), oe(a, uo, b), oe(a, Ln, g), Pe(l, n.domain, s), oe(l, uo, b), oe(l, Ln, g), Pe(E, n.domain, $), oe(E, co, $), oe(E, oa, $), Pe(I, n.domain, $), Pe(I, e, $), oe(I, co, $);
  const z = [
    [ea, ta],
    // {}
    [md, gd],
    // []
    [vd, bd],
    // ()
    [yd, xd],
    // <>
    [Cd, wd],
    // （）
    [kd, $d],
    // 「」
    [Md, Sd],
    // 『』
    [_d, Ed]
    // ＜＞
  ];
  for (let F = 0; F < z.length; F++) {
    const [Y, ie] = z[F], W = oe($, Y);
    oe(T, Y, W), oe(W, ie, $);
    const te = Dn(hl);
    Pe(W, e, te);
    const ce = Dn();
    Pe(W, t), Pe(te, e, te), Pe(te, t, ce), Pe(ce, e, te), Pe(ce, t, ce), oe(te, ie, $), oe(ce, ie, $);
  }
  return oe(i, Sa, x), oe(i, vh, aN), {
    start: i,
    tokens: e5
  };
}
function dN(n, e, t) {
  let o = t.length, i = 0, r = [], s = [];
  for (; i < o; ) {
    let a = n, l = null, d = null, u = 0, c = null, f = -1;
    for (; i < o && !(l = a.go(t[i].t)); )
      s.push(t[i++]);
    for (; i < o && (d = l || a.go(t[i].t)); )
      l = null, a = d, a.accepts() ? (f = 0, c = a) : f >= 0 && f++, i++, u++;
    if (f < 0)
      i -= u, i < o && (s.push(t[i]), i++);
    else {
      s.length > 0 && (r.push(Ec(pp, e, s)), s = []), i -= f, u -= f;
      const h = c.t, p = t.slice(i - u, i);
      r.push(Ec(h, e, p));
    }
  }
  return s.length > 0 && r.push(Ec(pp, e, s)), r;
}
function Ec(n, e, t) {
  const o = t[0].s, i = t[t.length - 1].e, r = e.slice(o, i);
  return new n(r, t);
}
const uN = typeof console < "u" && console && console.warn || (() => {
}), cN = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", st = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function fN() {
  return vn.groups = {}, st.scanner = null, st.parser = null, st.tokenQueue = [], st.pluginQueue = [], st.customSchemes = [], st.initialized = !1, st;
}
function mp(n, e = !1) {
  if (st.initialized && uN(`linkifyjs: already initialized - will not register custom scheme "${n}" ${cN}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  st.customSchemes.push([n, e]);
}
function hN() {
  st.scanner = rN(st.customSchemes);
  for (let n = 0; n < st.tokenQueue.length; n++)
    st.tokenQueue[n][1]({
      scanner: st.scanner
    });
  st.parser = lN(st.scanner.tokens);
  for (let n = 0; n < st.pluginQueue.length; n++)
    st.pluginQueue[n][1]({
      scanner: st.scanner,
      parser: st.parser
    });
  return st.initialized = !0, st;
}
function kh(n) {
  return st.initialized || hN(), dN(st.parser.start, n, t5(st.scanner.start, n));
}
kh.scan = t5;
function o5(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const o = new wh(t), i = kh(n), r = [];
  for (let s = 0; s < i.length; s++) {
    const a = i[s];
    a.isLink && (!e || a.t === e) && o.check(a) && r.push(a.toFormattedObject(o));
  }
  return r;
}
var $h = "[\0-   ᠎ -\u2029 　]", pN = new RegExp($h), mN = new RegExp(`${$h}$`), gN = new RegExp($h, "g");
function vN(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function bN(n) {
  return new mt({
    key: new Tt("autolink"),
    appendTransaction: (e, t, o) => {
      const i = e.some((d) => d.docChanged) && !t.doc.eq(o.doc), r = e.some((d) => d.getMeta("preventAutolink"));
      if (!i || r)
        return;
      const { tr: s } = o, a = w4(t.doc, [...e]);
      if (O4(a).forEach(({ newRange: d }) => {
        const u = vI(o.doc, d, (h) => h.isTextblock);
        let c, f;
        if (u.length > 1)
          c = u[0], f = o.doc.textBetween(
            c.pos,
            c.pos + c.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const h = o.doc.textBetween(d.from, d.to, " ", " ");
          if (!mN.test(h))
            return;
          c = u[0], f = o.doc.textBetween(c.pos, d.to, void 0, " ");
        }
        if (c && f) {
          const h = f.split(pN).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], m = c.pos + f.lastIndexOf(p);
          if (!p)
            return !1;
          const g = kh(p).map((b) => b.toObject(n.defaultProtocol));
          if (!vN(g))
            return !1;
          g.filter((b) => b.isLink).map((b) => ({
            ...b,
            from: m + b.start + 1,
            to: m + b.end + 1
          })).filter((b) => o.schema.marks.code ? !o.doc.rangeHasMark(b.from, b.to, o.schema.marks.code) : !0).filter((b) => n.validate(b.value)).filter((b) => n.shouldAutoLink(b.value)).forEach((b) => {
            ch(b.from, b.to, o.doc).some((x) => x.mark.type === n.type) || s.addMark(
              b.from,
              b.to,
              n.type.create({
                href: b.href
              })
            );
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function yN(n) {
  return new mt({
    key: new Tt("handleClickLink"),
    props: {
      handleClick: (e, t, o) => {
        var i, r;
        if (o.button !== 0 || !e.editable)
          return !1;
        let s = null;
        if (o.target instanceof HTMLAnchorElement)
          s = o.target;
        else {
          const l = o.target;
          if (!l)
            return !1;
          const d = n.editor.view.dom;
          s = l.closest("a"), s && !d.contains(s) && (s = null);
        }
        if (!s)
          return !1;
        let a = !1;
        if (n.enableClickSelection && (a = n.editor.commands.extendMarkRange(n.type.name)), n.openOnClick) {
          const l = E4(e.state, n.type.name), d = (i = s.href) != null ? i : l.href, u = (r = s.target) != null ? r : l.target;
          d && (window.open(d, u), a = !0);
        }
        return a;
      }
    }
  });
}
function xN(n) {
  return new mt({
    key: new Tt("handlePasteLink"),
    props: {
      handlePaste: (e, t, o) => {
        const { shouldAutoLink: i } = n, { state: r } = e, { selection: s } = r, { empty: a } = s;
        if (a)
          return !1;
        let l = "";
        o.content.forEach((u) => {
          l += u.textContent;
        });
        const d = o5(l, { defaultProtocol: n.defaultProtocol }).find(
          (u) => u.isLink && u.value === l
        );
        return !l || !d || i !== void 0 && !i(d.value) ? !1 : n.editor.commands.setMark(n.type, {
          href: d.href
        });
      }
    }
  });
}
function Bi(n, e) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((o) => {
    const i = typeof o == "string" ? o : o.scheme;
    i && t.push(i);
  }), !n || n.replace(gN, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var i5 = yr.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        mp(n);
        return;
      }
      mp(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    fN();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!Bi(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => {
        const e = /^[a-z][a-z0-9+.-]*:\/\//i.test(n), t = /^[a-z][a-z0-9+.-]*:/i.test(n);
        if (e || t && !n.includes("@"))
          return !0;
        const i = (n.includes("@") ? n.split("@").pop() : n).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(i) || !/\./.test(i));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!Bi(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!Bi(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", yt(this.options.HTMLAttributes, n), 0] : ["a", yt(this.options.HTMLAttributes, { ...n, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (n, e) => e.applyMark("link", e.parseInline(n.tokens || []), {
    href: n.href,
    title: n.title || null
  }),
  renderMarkdown: (n, e) => {
    var t, o, i, r;
    const s = (o = (t = n.attrs) == null ? void 0 : t.href) != null ? o : "", a = (r = (i = n.attrs) == null ? void 0 : i.title) != null ? r : "", l = e.renderChildren(n);
    return a ? `[${l}](${s} "${a}")` : `[${l}](${s})`;
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (o) => !!Bi(o, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (o) => !!Bi(o, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      fr({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: o } = this.options, i = o5(n).filter(
              (r) => r.isLink && this.options.isAllowedUri(r.value, {
                defaultValidate: (s) => !!Bi(s, t),
                protocols: t,
                defaultProtocol: o
              })
            );
            i.length && i.forEach((r) => {
              this.options.shouldAutoLink(r.value) && e.push({
                text: r.value,
                data: {
                  href: r.href
                },
                index: r.start
              });
            });
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) == null ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(
      bN({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (o) => this.options.isAllowedUri(o, {
          defaultValidate: (i) => !!Bi(i, e),
          protocols: e,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), n.push(
      yN({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && n.push(
      xN({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), n;
  }
}), CN = i5, wN = Object.defineProperty, kN = (n, e) => {
  for (var t in e)
    wN(n, t, { get: e[t], enumerable: !0 });
}, $N = "listItem", gp = "textStyle", vp = /^\s*([-+*])\s$/, r5 = cn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", yt(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (n, e) => n.type !== "list" || n.ordered ? [] : {
    type: "bulletList",
    content: n.items ? e.parseChildren(n.items) : []
  },
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($N, this.editor.getAttributes(gp)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = cs({
      find: vp,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = cs({
      find: vp,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(gp),
      editor: this.editor
    })), [n];
  }
}), s5 = cn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", yt(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (n, e) => {
    if (n.type !== "list_item")
      return [];
    let t = [];
    if (n.tokens && n.tokens.length > 0)
      if (n.tokens.some((i) => i.type === "paragraph"))
        t = e.parseChildren(n.tokens);
      else {
        const i = n.tokens[0];
        if (i && i.type === "text" && i.tokens && i.tokens.length > 0) {
          if (t = [
            {
              type: "paragraph",
              content: e.parseInline(i.tokens)
            }
          ], n.tokens.length > 1) {
            const s = n.tokens.slice(1), a = e.parseChildren(s);
            t.push(...a);
          }
        } else
          t = e.parseChildren(n.tokens);
      }
    return t.length === 0 && (t = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: t
    };
  },
  renderMarkdown: (n, e, t) => mh(
    n,
    e,
    (o) => {
      var i, r;
      return o.parentType === "bulletList" ? "- " : o.parentType === "orderedList" ? `${(((r = (i = o.meta) == null ? void 0 : i.parentAttrs) == null ? void 0 : r.start) || 1) + o.index}. ` : "- ";
    },
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), MN = {};
kN(MN, {
  findListItemPos: () => Wa,
  getNextListDepth: () => Mh,
  handleBackspace: () => jf,
  handleDelete: () => Wf,
  hasListBefore: () => a5,
  hasListItemAfter: () => SN,
  hasListItemBefore: () => l5,
  listItemHasSubList: () => d5,
  nextListIsDeeper: () => u5,
  nextListIsHigher: () => c5
});
var Wa = (n, e) => {
  const { $from: t } = e.selection, o = _t(n, e.schema);
  let i = null, r = t.depth, s = t.pos, a = null;
  for (; r > 0 && a === null; )
    i = t.node(r), i.type === o ? a = r : (r -= 1, s -= 1);
  return a === null ? null : { $pos: e.doc.resolve(s), depth: a };
}, Mh = (n, e) => {
  const t = Wa(n, e);
  if (!t)
    return !1;
  const [, o] = _I(e, n, t.$pos.pos + 4);
  return o;
}, a5 = (n, e, t) => {
  const { $anchor: o } = n.selection, i = Math.max(0, o.pos - 2), r = n.doc.resolve(i).node();
  return !(!r || !t.includes(r.type.name));
}, l5 = (n, e) => {
  var t;
  const { $anchor: o } = e.selection, i = e.doc.resolve(o.pos - 2);
  return !(i.index() === 0 || ((t = i.nodeBefore) == null ? void 0 : t.type.name) !== n);
}, d5 = (n, e, t) => {
  if (!t)
    return !1;
  const o = _t(n, e.schema);
  let i = !1;
  return t.descendants((r) => {
    r.type === o && (i = !0);
  }), i;
}, jf = (n, e, t) => {
  if (n.commands.undoInputRule())
    return !0;
  if (n.state.selection.from !== n.state.selection.to)
    return !1;
  if (!Si(n.state, e) && a5(n.state, e, t)) {
    const { $anchor: a } = n.state.selection, l = n.state.doc.resolve(a.before() - 1), d = [];
    l.node().descendants((f, h) => {
      f.type.name === e && d.push({ node: f, pos: h });
    });
    const u = d.at(-1);
    if (!u)
      return !1;
    const c = n.state.doc.resolve(l.start() + u.pos + 1);
    return n.chain().cut({ from: a.start() - 1, to: a.end() + 1 }, c.end()).joinForward().run();
  }
  if (!Si(n.state, e) || !AI(n.state))
    return !1;
  const o = Wa(e, n.state);
  if (!o)
    return !1;
  const r = n.state.doc.resolve(o.$pos.pos - 2).node(o.depth), s = d5(e, n.state, r);
  return l5(e, n.state) && !s ? n.commands.joinItemBackward() : n.chain().liftListItem(e).run();
}, u5 = (n, e) => {
  const t = Mh(n, e), o = Wa(n, e);
  return !o || !t ? !1 : t > o.depth;
}, c5 = (n, e) => {
  const t = Mh(n, e), o = Wa(n, e);
  return !o || !t ? !1 : t < o.depth;
}, Wf = (n, e) => {
  if (!Si(n.state, e) || !TI(n.state, e))
    return !1;
  const { selection: t } = n.state, { $from: o, $to: i } = t;
  return !t.empty && o.sameParent(i) ? !1 : u5(e, n.state) ? n.chain().focus(n.state.selection.from + 4).lift(e).joinBackward().run() : c5(e, n.state) ? n.chain().joinForward().joinBackward().run() : n.commands.joinItemForward();
}, SN = (n, e) => {
  var t;
  const { $anchor: o } = e.selection, i = e.doc.resolve(o.pos - o.parentOffset - 2);
  return !(i.index() === i.parent.childCount - 1 || ((t = i.nodeAfter) == null ? void 0 : t.type.name) !== n);
}, f5 = xt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && Wf(n, t) && (e = !0);
        }), e;
      },
      "Mod-Delete": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && Wf(n, t) && (e = !0);
        }), e;
      },
      Backspace: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: o }) => {
          n.state.schema.nodes[t] !== void 0 && jf(n, t, o) && (e = !0);
        }), e;
      },
      "Mod-Backspace": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: o }) => {
          n.state.schema.nodes[t] !== void 0 && jf(n, t, o) && (e = !0);
        }), e;
      }
    };
  }
}), bp = /^(\s*)(\d+)\.\s+(.*)$/, _N = /^\s/;
function EN(n) {
  const e = [];
  let t = 0, o = 0;
  for (; t < n.length; ) {
    const i = n[t], r = i.match(bp);
    if (!r)
      break;
    const [, s, a, l] = r, d = s.length;
    let u = l, c = t + 1;
    const f = [i];
    for (; c < n.length; ) {
      const h = n[c];
      if (h.match(bp))
        break;
      if (h.trim() === "")
        f.push(h), u += `
`, c += 1;
      else if (h.match(_N))
        f.push(h), u += `
${h.slice(d + 2)}`, c += 1;
      else
        break;
    }
    e.push({
      indent: d,
      number: parseInt(a, 10),
      content: u.trim(),
      raw: f.join(`
`)
    }), o = c, t = c;
  }
  return [e, o];
}
function h5(n, e, t) {
  var o;
  const i = [];
  let r = 0;
  for (; r < n.length; ) {
    const s = n[r];
    if (s.indent === e) {
      const a = s.content.split(`
`), l = ((o = a[0]) == null ? void 0 : o.trim()) || "", d = [];
      l && d.push({
        type: "paragraph",
        raw: l,
        tokens: t.inlineTokens(l)
      });
      const u = a.slice(1).join(`
`).trim();
      if (u) {
        const h = t.blockTokens(u);
        d.push(...h);
      }
      let c = r + 1;
      const f = [];
      for (; c < n.length && n[c].indent > e; )
        f.push(n[c]), c += 1;
      if (f.length > 0) {
        const h = Math.min(...f.map((m) => m.indent)), p = h5(f, h, t);
        d.push({
          type: "list",
          ordered: !0,
          start: f[0].number,
          items: p,
          raw: f.map((m) => m.raw).join(`
`)
        });
      }
      i.push({
        type: "list_item",
        raw: s.raw,
        tokens: d
      }), r = c;
    } else
      r += 1;
  }
  return i;
}
function ON(n, e) {
  return n.map((t) => {
    if (t.type !== "list_item")
      return e.parseChildren([t])[0];
    const o = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((i) => {
      if (i.type === "paragraph" || i.type === "list" || i.type === "blockquote" || i.type === "code")
        o.push(...e.parseChildren([i]));
      else if (i.type === "text" && i.tokens) {
        const r = e.parseChildren([i]);
        o.push({
          type: "paragraph",
          content: r
        });
      } else {
        const r = e.parseChildren([i]);
        r.length > 0 && o.push(...r);
      }
    }), {
      type: "listItem",
      content: o
    };
  });
}
var TN = "listItem", yp = "textStyle", xp = /^(\d+)\.\s$/, p5 = cn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", yt(this.options.HTMLAttributes, t), 0] : ["ol", yt(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (n, e) => {
    if (n.type !== "list" || !n.ordered)
      return [];
    const t = n.start || 1, o = n.items ? ON(n.items, e) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: o
    } : {
      type: "orderedList",
      content: o
    };
  },
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (n) => {
      const e = n.match(/^(\s*)(\d+)\.\s+/), t = e == null ? void 0 : e.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (n, e, t) => {
      var o;
      const i = n.split(`
`), [r, s] = EN(i);
      if (r.length === 0)
        return;
      const a = h5(r, 0, t);
      return a.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((o = r[0]) == null ? void 0 : o.number) || 1,
        items: a,
        raw: i.slice(0, s).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(TN, this.editor.getAttributes(yp)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = cs({
      find: xp,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = cs({
      find: xp,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(yp) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [n];
  }
}), AN = /^\s*(\[([( |x])?\])\s$/, IN = cn.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (n) => {
          const e = n.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (n) => ({
          "data-checked": n.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "li",
      yt(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: n.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (n, e) => {
    const t = [];
    if (n.tokens && n.tokens.length > 0 ? t.push(e.createNode("paragraph", {}, e.parseInline(n.tokens))) : n.text ? t.push(e.createNode("paragraph", {}, [e.createNode("text", { text: n.text })])) : t.push(e.createNode("paragraph", {}, [])), n.nestedTokens && n.nestedTokens.length > 0) {
      const o = e.parseChildren(n.nestedTokens);
      t.push(...o);
    }
    return e.createNode("taskItem", { checked: n.checked || !1 }, t);
  },
  renderMarkdown: (n, e) => {
    var t;
    const i = `- [${(t = n.attrs) != null && t.checked ? "x" : " "}] `;
    return mh(n, e, i);
  },
  addKeyboardShortcuts() {
    const n = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...n,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : n;
  },
  addNodeView() {
    return ({ node: n, HTMLAttributes: e, getPos: t, editor: o }) => {
      const i = document.createElement("li"), r = document.createElement("label"), s = document.createElement("span"), a = document.createElement("input"), l = document.createElement("div"), d = (c) => {
        var f, h;
        a.ariaLabel = ((h = (f = this.options.a11y) == null ? void 0 : f.checkboxLabel) == null ? void 0 : h.call(f, c, a.checked)) || `Task item checkbox for ${c.textContent || "empty task item"}`;
      };
      d(n), r.contentEditable = "false", a.type = "checkbox", a.addEventListener("mousedown", (c) => c.preventDefault()), a.addEventListener("change", (c) => {
        if (!o.isEditable && !this.options.onReadOnlyChecked) {
          a.checked = !a.checked;
          return;
        }
        const { checked: f } = c.target;
        o.isEditable && typeof t == "function" && o.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const p = t();
          if (typeof p != "number")
            return !1;
          const m = h.doc.nodeAt(p);
          return h.setNodeMarkup(p, void 0, {
            ...m == null ? void 0 : m.attrs,
            checked: f
          }), !0;
        }).run(), !o.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(n, f) || (a.checked = !a.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([c, f]) => {
        i.setAttribute(c, f);
      }), i.dataset.checked = n.attrs.checked, a.checked = n.attrs.checked, r.append(a, s), i.append(r, l), Object.entries(e).forEach(([c, f]) => {
        i.setAttribute(c, f);
      });
      let u = new Set(Object.keys(e));
      return {
        dom: i,
        contentDOM: l,
        update: (c) => {
          if (c.type !== this.type)
            return !1;
          i.dataset.checked = c.attrs.checked, a.checked = c.attrs.checked, d(c);
          const f = o.extensionManager.attributes, h = Ma(c, f), p = new Set(Object.keys(h)), m = this.options.HTMLAttributes;
          return u.forEach((g) => {
            p.has(g) || (g in m ? i.setAttribute(g, m[g]) : i.removeAttribute(g));
          }), Object.entries(h).forEach(([g, b]) => {
            b == null ? g in m ? i.setAttribute(g, m[g]) : i.removeAttribute(g) : i.setAttribute(g, b);
          }), u = p, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      cs({
        find: AN,
        type: this.type,
        getAttributes: (n) => ({
          checked: n[n.length - 1] === "x"
        })
      })
    ];
  }
}), DN = cn.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", yt(this.options.HTMLAttributes, n, { "data-type": this.name }), 0];
  },
  parseMarkdown: (n, e) => e.createNode("taskList", {}, e.parseChildren(n.items || [])),
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(n) {
      var e;
      const t = (e = n.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : e.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(n, e, t) {
      const o = (r) => {
        const s = Nf(
          r,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (a) => ({
              indentLevel: a[1].length,
              mainContent: a[4],
              checked: a[3].toLowerCase() === "x"
            }),
            createToken: (a, l) => ({
              type: "taskItem",
              raw: "",
              mainContent: a.mainContent,
              indentLevel: a.indentLevel,
              checked: a.checked,
              text: a.mainContent,
              tokens: t.inlineTokens(a.mainContent),
              nestedTokens: l
            }),
            // Allow recursive nesting
            customNestedParser: o
          },
          t
        );
        return s ? [
          {
            type: "taskList",
            raw: s.raw,
            items: s.items
          }
        ] : t.blockTokens(r);
      }, i = Nf(
        n,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (r) => ({
            indentLevel: r[1].length,
            mainContent: r[4],
            checked: r[3].toLowerCase() === "x"
          }),
          createToken: (r, s) => ({
            type: "taskItem",
            raw: "",
            mainContent: r.mainContent,
            indentLevel: r.indentLevel,
            checked: r.checked,
            text: r.mainContent,
            tokens: t.inlineTokens(r.mainContent),
            nestedTokens: s
          }),
          // Use the recursive parser for nested content
          customNestedParser: o
        },
        t
      );
      if (i)
        return {
          type: "taskList",
          raw: i.raw,
          items: i.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: n }) => n.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
xt.create({
  name: "listKit",
  addExtensions() {
    const n = [];
    return this.options.bulletList !== !1 && n.push(r5.configure(this.options.bulletList)), this.options.listItem !== !1 && n.push(s5.configure(this.options.listItem)), this.options.listKeymap !== !1 && n.push(f5.configure(this.options.listKeymap)), this.options.orderedList !== !1 && n.push(p5.configure(this.options.orderedList)), this.options.taskItem !== !1 && n.push(IN.configure(this.options.taskItem)), this.options.taskList !== !1 && n.push(DN.configure(this.options.taskList)), n;
  }
});
var Cp = "&nbsp;", NN = " ", PN = cn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", yt(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown: (n, e) => {
    const t = n.tokens || [];
    if (t.length === 1 && t[0].type === "image")
      return e.parseChildren([t[0]]);
    const o = e.parseInline(t);
    return o.length === 1 && o[0].type === "text" && (o[0].text === Cp || o[0].text === NN) ? e.createNode("paragraph", void 0, []) : e.createNode("paragraph", void 0, o);
  },
  renderMarkdown: (n, e) => {
    if (!n)
      return "";
    const t = Array.isArray(n.content) ? n.content : [];
    return t.length === 0 ? Cp : e.renderChildren(t);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), LN = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, RN = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, FN = yr.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", yt(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (n, e) => e.applyMark("strike", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `~~${e.renderChildren(n)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      us({
        find: LN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fr({
        find: RN,
        type: this.type
      })
    ];
  }
}), BN = cn.create({
  name: "text",
  group: "inline",
  parseMarkdown: (n) => ({
    type: "text",
    text: n.text || ""
  }),
  renderMarkdown: (n) => n.text || ""
}), VN = yr.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", yt(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown(n, e) {
    return e.applyMark(this.name || "underline", e.parseInline(n.tokens || []));
  },
  renderMarkdown(n, e) {
    return `++${e.renderChildren(n)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(n) {
      return n.indexOf("++");
    },
    tokenize(n, e, t) {
      const i = /^(\+\+)([\s\S]+?)(\+\+)/.exec(n);
      if (!i)
        return;
      const r = i[2].trim();
      return {
        type: "underline",
        raw: i[0],
        text: r,
        tokens: t.inlineTokens(r)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function zN(n = {}) {
  return new mt({
    view(e) {
      return new HN(e, n);
    }
  });
}
class HN {
  constructor(e, t) {
    var o;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (o = t.width) !== null && o !== void 0 ? o : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let r = (s) => {
        this[i](s);
      };
      return e.dom.addEventListener(i, r), { name: i, handler: r };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, o, i = this.editorView.dom, r = i.getBoundingClientRect(), s = r.width / i.offsetWidth, a = r.height / i.offsetHeight;
    if (t) {
      let c = e.nodeBefore, f = e.nodeAfter;
      if (c || f) {
        let h = this.editorView.nodeDOM(this.cursorPos - (c ? c.nodeSize : 0));
        if (h) {
          let p = h.getBoundingClientRect(), m = c ? p.bottom : p.top;
          c && f && (m = (m + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let g = this.width / 2 * a;
          o = { left: p.left, right: p.right, top: m - g, bottom: m + g };
        }
      }
    }
    if (!o) {
      let c = this.editorView.coordsAtPos(this.cursorPos), f = this.width / 2 * s;
      o = { left: c.left - f, right: c.left + f, top: c.top, bottom: c.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let d, u;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      d = -pageXOffset, u = -pageYOffset;
    else {
      let c = l.getBoundingClientRect(), f = c.width / l.offsetWidth, h = c.height / l.offsetHeight;
      d = c.left - l.scrollLeft * f, u = c.top - l.scrollTop * h;
    }
    this.element.style.left = (o.left - d) / s + "px", this.element.style.top = (o.top - u) / a + "px", this.element.style.width = (o.right - o.left) / s + "px", this.element.style.height = (o.bottom - o.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), o = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = o && o.type.spec.disableDropCursor, r = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !r) {
      let s = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = hg(this.editorView.state.doc, s, this.editorView.dragging.slice);
        a != null && (s = a);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
class bt extends Le {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let o = e.resolve(t.map(this.head));
    return bt.valid(o) ? new bt(o) : Le.near(o);
  }
  content() {
    return he.empty;
  }
  eq(e) {
    return e instanceof bt && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new bt(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Sh(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !jN(e) || !WN(e))
      return !1;
    let o = t.type.spec.allowGapCursor;
    if (o != null)
      return o;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, o = !1) {
    e: for (; ; ) {
      if (!o && bt.valid(e))
        return e;
      let i = e.pos, r = null;
      for (let s = e.depth; ; s--) {
        let a = e.node(s);
        if (t > 0 ? e.indexAfter(s) < a.childCount : e.index(s) > 0) {
          r = a.child(t > 0 ? e.indexAfter(s) : e.index(s) - 1);
          break;
        } else if (s == 0)
          return null;
        i += t;
        let l = e.doc.resolve(i);
        if (bt.valid(l))
          return l;
      }
      for (; ; ) {
        let s = t > 0 ? r.firstChild : r.lastChild;
        if (!s) {
          if (r.isAtom && !r.isText && !xe.isSelectable(r)) {
            e = e.doc.resolve(i + r.nodeSize * t), o = !1;
            continue e;
          }
          break;
        }
        r = s, i += t;
        let a = e.doc.resolve(i);
        if (bt.valid(a))
          return a;
      }
      return null;
    }
  }
}
bt.prototype.visible = !1;
bt.findFrom = bt.findGapCursorFrom;
Le.jsonID("gapcursor", bt);
class Sh {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Sh(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return bt.valid(t) ? new bt(t) : Le.near(t);
  }
}
function m5(n) {
  return n.isAtom || n.spec.isolating || n.spec.createGapCursor;
}
function jN(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), o = n.node(e);
    if (t == 0) {
      if (o.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = o.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || m5(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function WN(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), o = n.node(e);
    if (t == o.childCount) {
      if (o.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = o.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || m5(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function UN() {
  return new mt({
    props: {
      decorations: qN,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && bt.valid(t) ? new bt(t) : null;
      },
      handleClick: GN,
      handleKeyDown: KN,
      handleDOMEvents: { beforeinput: YN }
    }
  });
}
const KN = p4({
  ArrowLeft: pl("horiz", -1),
  ArrowRight: pl("horiz", 1),
  ArrowUp: pl("vert", -1),
  ArrowDown: pl("vert", 1)
});
function pl(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(o, i, r) {
    let s = o.selection, a = e > 0 ? s.$to : s.$from, l = s.empty;
    if (s instanceof Te) {
      if (!r.endOfTextblock(t) || a.depth == 0)
        return !1;
      l = !1, a = o.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let d = bt.findGapCursorFrom(a, e, l);
    return d ? (i && i(o.tr.setSelection(new bt(d))), !0) : !1;
  };
}
function GN(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let o = n.state.doc.resolve(e);
  if (!bt.valid(o))
    return !1;
  let i = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && xe.isSelectable(n.state.doc.nodeAt(i.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new bt(o))), !0);
}
function YN(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof bt))
    return !1;
  let { $from: t } = n.state.selection, o = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!o)
    return !1;
  let i = Q.empty;
  for (let s = o.length - 1; s >= 0; s--)
    i = Q.from(o[s].createAndFill(null, i));
  let r = n.state.tr.replace(t.pos, t.pos, new he(i, 0, 0));
  return r.setSelection(Te.near(r.doc.resolve(t.pos + 1))), n.dispatch(r), !1;
}
function qN(n) {
  if (!(n.selection instanceof bt))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", ht.create(n.doc, [ln.widget(n.selection.head, e, { key: "gapcursor" })]);
}
var Hd = 200, Lt = function() {
};
Lt.prototype.append = function(e) {
  return e.length ? (e = Lt.from(e), !this.length && e || e.length < Hd && this.leafAppend(e) || this.length < Hd && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Lt.prototype.prepend = function(e) {
  return e.length ? Lt.from(e).append(this) : this;
};
Lt.prototype.appendInner = function(e) {
  return new ZN(this, e);
};
Lt.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Lt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Lt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Lt.prototype.forEach = function(e, t, o) {
  t === void 0 && (t = 0), o === void 0 && (o = this.length), t <= o ? this.forEachInner(e, t, o, 0) : this.forEachInvertedInner(e, t, o, 0);
};
Lt.prototype.map = function(e, t, o) {
  t === void 0 && (t = 0), o === void 0 && (o = this.length);
  var i = [];
  return this.forEach(function(r, s) {
    return i.push(e(r, s));
  }, t, o), i;
};
Lt.from = function(e) {
  return e instanceof Lt ? e : e && e.length ? new g5(e) : Lt.empty;
};
var g5 = /* @__PURE__ */ (function(n) {
  function e(o) {
    n.call(this), this.values = o;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, r) {
    return i == 0 && r == this.length ? this : new e(this.values.slice(i, r));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, r, s, a) {
    for (var l = r; l < s; l++)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, r, s, a) {
    for (var l = r - 1; l >= s; l--)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Hd)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Hd)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
})(Lt);
Lt.empty = new g5([]);
var ZN = /* @__PURE__ */ (function(n) {
  function e(t, o) {
    n.call(this), this.left = t, this.right = o, this.length = t.length + o.length, this.depth = Math.max(t.depth, o.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(o) {
    return o < this.left.length ? this.left.get(o) : this.right.get(o - this.left.length);
  }, e.prototype.forEachInner = function(o, i, r, s) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(o, i, Math.min(r, a), s) === !1 || r > a && this.right.forEachInner(o, Math.max(i - a, 0), Math.min(this.length, r) - a, s + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(o, i, r, s) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(o, i - a, Math.max(r, a) - a, s + a) === !1 || r < a && this.left.forEachInvertedInner(o, Math.min(i, a), r, s) === !1)
      return !1;
  }, e.prototype.sliceInner = function(o, i) {
    if (o == 0 && i == this.length)
      return this;
    var r = this.left.length;
    return i <= r ? this.left.slice(o, i) : o >= r ? this.right.slice(o - r, i - r) : this.left.slice(o, r).append(this.right.slice(0, i - r));
  }, e.prototype.leafAppend = function(o) {
    var i = this.right.leafAppend(o);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(o) {
    var i = this.left.leafPrepend(o);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(o) {
    return this.left.depth >= Math.max(this.right.depth, o.depth) + 1 ? new e(this.left, new e(this.right, o)) : new e(this, o);
  }, e;
})(Lt);
const JN = 500;
class Xn {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let o = this.items.length;
    for (; ; o--)
      if (this.items.get(o - 1).selection) {
        --o;
        break;
      }
    let i, r;
    t && (i = this.remapping(o, this.items.length), r = i.maps.length);
    let s = e.tr, a, l, d = [], u = [];
    return this.items.forEach((c, f) => {
      if (!c.step) {
        i || (i = this.remapping(o, f + 1), r = i.maps.length), r--, u.push(c);
        return;
      }
      if (i) {
        u.push(new fo(c.map));
        let h = c.step.map(i.slice(r)), p;
        h && s.maybeStep(h).doc && (p = s.mapping.maps[s.mapping.maps.length - 1], d.push(new fo(p, void 0, void 0, d.length + u.length))), r--, p && i.appendMap(p, r);
      } else
        s.maybeStep(c.step);
      if (c.selection)
        return a = i ? c.selection.map(i.slice(r)) : c.selection, l = new Xn(this.items.slice(0, o).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: s, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, o, i) {
    let r = [], s = this.eventCount, a = this.items, l = !i && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let c = e.steps[u].invert(e.docs[u]), f = new fo(e.mapping.maps[u], c, t), h;
      (h = l && l.merge(f)) && (f = h, u ? r.pop() : a = a.slice(0, a.length - 1)), r.push(f), t && (s++, t = void 0), i || (l = f);
    }
    let d = s - o.depth;
    return d > QN && (a = XN(a, d), s -= d), new Xn(a.append(r), s);
  }
  remapping(e, t) {
    let o = new ya();
    return this.items.forEach((i, r) => {
      let s = i.mirrorOffset != null && r - i.mirrorOffset >= e ? o.maps.length - i.mirrorOffset : void 0;
      o.appendMap(i.map, s);
    }, e, t), o;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Xn(this.items.append(e.map((t) => new fo(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let o = [], i = Math.max(0, this.items.length - t), r = e.mapping, s = e.steps.length, a = this.eventCount;
    this.items.forEach((f) => {
      f.selection && a--;
    }, i);
    let l = t;
    this.items.forEach((f) => {
      let h = r.getMirror(--l);
      if (h == null)
        return;
      s = Math.min(s, h);
      let p = r.maps[h];
      if (f.step) {
        let m = e.steps[h].invert(e.docs[h]), g = f.selection && f.selection.map(r.slice(l + 1, h));
        g && a++, o.push(new fo(p, m, g));
      } else
        o.push(new fo(p));
    }, i);
    let d = [];
    for (let f = t; f < s; f++)
      d.push(new fo(r.maps[f]));
    let u = this.items.slice(0, i).append(d).append(o), c = new Xn(u, a);
    return c.emptyItemCount() > JN && (c = c.compress(this.items.length - o.length)), c;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), o = t.maps.length, i = [], r = 0;
    return this.items.forEach((s, a) => {
      if (a >= e)
        i.push(s), s.selection && r++;
      else if (s.step) {
        let l = s.step.map(t.slice(o)), d = l && l.getMap();
        if (o--, d && t.appendMap(d, o), l) {
          let u = s.selection && s.selection.map(t.slice(o));
          u && r++;
          let c = new fo(d.invert(), l, u), f, h = i.length - 1;
          (f = i.length && i[h].merge(c)) ? i[h] = f : i.push(c);
        }
      } else s.map && o--;
    }, this.items.length, 0), new Xn(Lt.from(i.reverse()), r);
  }
}
Xn.empty = new Xn(Lt.empty, 0);
function XN(n, e) {
  let t;
  return n.forEach((o, i) => {
    if (o.selection && e-- == 0)
      return t = i, !1;
  }), n.slice(t);
}
class fo {
  constructor(e, t, o, i) {
    this.map = e, this.step = t, this.selection = o, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new fo(t.getMap().invert(), t, this.selection);
    }
  }
}
class si {
  constructor(e, t, o, i, r) {
    this.done = e, this.undone = t, this.prevRanges = o, this.prevTime = i, this.prevComposition = r;
  }
}
const QN = 20;
function eP(n, e, t, o) {
  let i = t.getMeta(or), r;
  if (i)
    return i.historyState;
  t.getMeta(oP) && (n = new si(n.done, n.undone, null, 0, -1));
  let s = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (s && s.getMeta(or))
    return s.getMeta(or).redo ? new si(n.done.addTransform(t, void 0, o, Rl(e)), n.undone, wp(t.mapping.maps), n.prevTime, n.prevComposition) : new si(n.done, n.undone.addTransform(t, void 0, o, Rl(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !s && n.prevComposition != a && (n.prevTime < (t.time || 0) - o.newGroupDelay || !tP(t, n.prevRanges)), d = s ? Oc(n.prevRanges, t.mapping) : wp(t.mapping.maps);
    return new si(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, o, Rl(e)), Xn.empty, d, t.time, a ?? n.prevComposition);
  } else return (r = t.getMeta("rebased")) ? new si(n.done.rebased(t, r), n.undone.rebased(t, r), Oc(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new si(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Oc(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function tP(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((o, i) => {
    for (let r = 0; r < e.length; r += 2)
      o <= e[r + 1] && i >= e[r] && (t = !0);
  }), t;
}
function wp(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((o, i, r, s) => e.push(r, s));
  return e;
}
function Oc(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let o = 0; o < n.length; o += 2) {
    let i = e.map(n[o], 1), r = e.map(n[o + 1], -1);
    i <= r && t.push(i, r);
  }
  return t;
}
function nP(n, e, t) {
  let o = Rl(e), i = or.get(e).spec.config, r = (t ? n.undone : n.done).popEvent(e, o);
  if (!r)
    return null;
  let s = r.selection.resolve(r.transform.doc), a = (t ? n.done : n.undone).addTransform(r.transform, e.selection.getBookmark(), i, o), l = new si(t ? a : r.remaining, t ? r.remaining : a, null, 0, -1);
  return r.transform.setSelection(s).setMeta(or, { redo: t, historyState: l });
}
let Tc = !1, kp = null;
function Rl(n) {
  let e = n.plugins;
  if (kp != e) {
    Tc = !1, kp = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        Tc = !0;
        break;
      }
  }
  return Tc;
}
const or = new Tt("history"), oP = new Tt("closeHistory");
function iP(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new mt({
    key: or,
    state: {
      init() {
        return new si(Xn.empty, Xn.empty, null, 0, -1);
      },
      apply(e, t, o) {
        return eP(t, o, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let o = t.inputType, i = o == "historyUndo" ? b5 : o == "historyRedo" ? y5 : null;
          return !i || !e.editable ? !1 : (t.preventDefault(), i(e.state, e.dispatch));
        }
      }
    }
  });
}
function v5(n, e) {
  return (t, o) => {
    let i = or.getState(t);
    if (!i || (n ? i.undone : i.done).eventCount == 0)
      return !1;
    if (o) {
      let r = nP(i, t, n);
      r && o(e ? r.scrollIntoView() : r);
    }
    return !0;
  };
}
const b5 = v5(!1, !0), y5 = v5(!0, !0);
xt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (n) => n.length,
      wordCounter: (n) => n.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc;
      if (((n == null ? void 0 : n.mode) || this.options.mode) === "textSize") {
        const o = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(o);
      }
      return e.nodeSize;
    }, this.storage.words = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc, t = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let n = !1;
    return [
      new mt({
        key: new Tt("characterCount"),
        appendTransaction: (e, t, o) => {
          if (n)
            return;
          const i = this.options.limit;
          if (i == null || i === 0) {
            n = !0;
            return;
          }
          const r = this.storage.characters({ node: o.doc });
          if (r > i) {
            const s = r - i, a = 0, l = s;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${i} characters. Content was automatically trimmed.`
            );
            const d = o.tr.deleteRange(a, l);
            return n = !0, d;
          }
          n = !0;
        },
        filterTransaction: (e, t) => {
          const o = this.options.limit;
          if (!e.docChanged || o === 0 || o === null || o === void 0)
            return !0;
          const i = this.storage.characters({ node: t.doc }), r = this.storage.characters({ node: e.doc });
          if (r <= o || i > o && r > o && r <= i)
            return !0;
          if (i > o && r > o && r > i || !e.getMeta("paste"))
            return !1;
          const a = e.selection.$head.pos, l = r - o, d = a - l, u = a;
          return e.deleteRange(d, u), !(this.storage.characters({ node: e.doc }) > o);
        }
      })
    ];
  }
});
var rP = xt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [zN(this.options)];
  }
});
xt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new mt({
        key: new Tt("focus"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const { isEditable: t, isFocused: o } = this.editor, { anchor: i } = e, r = [];
            if (!t || !o)
              return ht.create(n, []);
            let s = 0;
            this.options.mode === "deepest" && n.descendants((l, d) => {
              if (l.isText)
                return;
              if (!(i >= d && i <= d + l.nodeSize - 1))
                return !1;
              s += 1;
            });
            let a = 0;
            return n.descendants((l, d) => {
              if (l.isText || !(i >= d && i <= d + l.nodeSize - 1))
                return !1;
              if (a += 1, this.options.mode === "deepest" && s - a > 0 || this.options.mode === "shallowest" && a > 1)
                return this.options.mode === "deepest";
              r.push(
                ln.node(d, d + l.nodeSize, {
                  class: this.options.className
                })
              );
            }), ht.create(n, r);
          }
        }
      })
    ];
  }
});
var sP = xt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [UN()];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = Qe(be(n, "allowGapCursor", t))) != null ? e : null
    };
  }
}), $p = "placeholder";
function aP(n) {
  return n.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var lP = xt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: $p,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const n = this.options.dataAttribute ? `data-${aP(this.options.dataAttribute)}` : `data-${$p}`;
    return [
      new mt({
        key: new Tt("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const o = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: i } = t, r = [];
            if (!o)
              return null;
            const s = this.editor.isEmpty;
            return e.descendants((a, l) => {
              const d = i >= l && i <= l + a.nodeSize, u = !a.isLeaf && Du(a);
              if ((d || !this.options.showOnlyCurrent) && u) {
                const c = [this.options.emptyNodeClass];
                s && c.push(this.options.emptyEditorClass);
                const f = ln.node(l, l + a.nodeSize, {
                  class: c.join(" "),
                  [n]: typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: a,
                    pos: l,
                    hasAnchor: d
                  }) : this.options.placeholder
                });
                r.push(f);
              }
              return this.options.includeChildren;
            }), ht.create(e, r);
          }
        }
      })
    ];
  }
});
xt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: n, options: e } = this;
    return [
      new mt({
        key: new Tt("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || n.isFocused || !n.isEditable || T4(t.selection) || n.view.dragging ? null : ht.create(t.doc, [
              ln.inline(t.selection.from, t.selection.to, {
                class: e.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function Mp({ types: n, node: e }) {
  return e && Array.isArray(n) && n.includes(e.type) || (e == null ? void 0 : e.type) === n;
}
var dP = xt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var n;
    const e = new Tt(this.name), t = this.options.node || ((n = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : n.name) || "paragraph", o = Object.entries(this.editor.schema.nodes).map(([, i]) => i).filter((i) => (this.options.notAfter || []).concat(t).includes(i.name));
    return [
      new mt({
        key: e,
        appendTransaction: (i, r, s) => {
          const { doc: a, tr: l, schema: d } = s, u = e.getState(s), c = a.content.size, f = d.nodes[t];
          if (u)
            return l.insert(c, f.create());
        },
        state: {
          init: (i, r) => {
            const s = r.tr.doc.lastChild;
            return !Mp({ node: s, types: o });
          },
          apply: (i, r) => {
            if (!i.docChanged || i.getMeta("__uniqueIDTransaction"))
              return r;
            const s = i.doc.lastChild;
            return !Mp({ node: s, types: o });
          }
        }
      })
    ];
  }
}), uP = xt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => b5(n, e),
      redo: () => ({ state: n, dispatch: e }) => y5(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [iP(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), cP = xt.create({
  name: "starterKit",
  addExtensions() {
    var n, e, t, o;
    const i = [];
    return this.options.bold !== !1 && i.push(PD.configure(this.options.bold)), this.options.blockquote !== !1 && i.push(TD.configure(this.options.blockquote)), this.options.bulletList !== !1 && i.push(r5.configure(this.options.bulletList)), this.options.code !== !1 && i.push(FD.configure(this.options.code)), this.options.codeBlock !== !1 && i.push(zD.configure(this.options.codeBlock)), this.options.document !== !1 && i.push(HD.configure(this.options.document)), this.options.dropcursor !== !1 && i.push(rP.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && i.push(sP.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && i.push(jD.configure(this.options.hardBreak)), this.options.heading !== !1 && i.push(WD.configure(this.options.heading)), this.options.undoRedo !== !1 && i.push(uP.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && i.push(UD.configure(this.options.horizontalRule)), this.options.italic !== !1 && i.push(ZD.configure(this.options.italic)), this.options.listItem !== !1 && i.push(s5.configure(this.options.listItem)), this.options.listKeymap !== !1 && i.push(f5.configure((n = this.options) == null ? void 0 : n.listKeymap)), this.options.link !== !1 && i.push(i5.configure((e = this.options) == null ? void 0 : e.link)), this.options.orderedList !== !1 && i.push(p5.configure(this.options.orderedList)), this.options.paragraph !== !1 && i.push(PN.configure(this.options.paragraph)), this.options.strike !== !1 && i.push(FN.configure(this.options.strike)), this.options.text !== !1 && i.push(BN.configure(this.options.text)), this.options.underline !== !1 && i.push(VN.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && i.push(dP.configure((o = this.options) == null ? void 0 : o.trailingNode)), i;
  }
}), fP = cP, hP = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, pP = cn.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", yt(this.options.HTMLAttributes, n)];
  },
  parseMarkdown: (n, e) => e.createNode("image", {
    src: n.href,
    title: n.title,
    alt: n.text
  }),
  renderMarkdown: (n) => {
    var e, t, o, i, r, s;
    const a = (t = (e = n.attrs) == null ? void 0 : e.src) != null ? t : "", l = (i = (o = n.attrs) == null ? void 0 : o.alt) != null ? i : "", d = (s = (r = n.attrs) == null ? void 0 : r.title) != null ? s : "";
    return d ? `![${l}](${a} "${d}")` : `![${l}](${a})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: n, minWidth: e, minHeight: t, alwaysPreserveAspectRatio: o } = this.options.resize;
    return ({ node: i, getPos: r, HTMLAttributes: s, editor: a }) => {
      const l = document.createElement("img");
      Object.entries(s).forEach(([c, f]) => {
        if (f != null)
          switch (c) {
            case "width":
            case "height":
              break;
            default:
              l.setAttribute(c, f);
              break;
          }
      }), l.src = s.src;
      const d = new vD({
        element: l,
        editor: a,
        node: i,
        getPos: r,
        onResize: (c, f) => {
          l.style.width = `${c}px`, l.style.height = `${f}px`;
        },
        onCommit: (c, f) => {
          const h = r();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: c,
            height: f
          }).run();
        },
        onUpdate: (c, f, h) => c.type === i.type,
        options: {
          directions: n,
          min: {
            width: e,
            height: t
          },
          preserveAspectRatio: o === !0
        }
      }), u = d.dom;
      return u.style.visibility = "hidden", u.style.pointerEvents = "none", l.onload = () => {
        u.style.visibility = "", u.style.pointerEvents = "";
      }, d;
    };
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  addInputRules() {
    return [
      G4({
        find: hP,
        type: this.type,
        getAttributes: (n) => {
          const [, , e, t, o] = n;
          return { src: t, alt: e, title: o };
        }
      })
    ];
  }
}), mP = pP, gP = lP;
const vP = { class: "flex min-h-[256px] flex-1 flex-col" }, bP = {
  key: 0,
  class: "mb-2"
}, yP = {
  key: 0,
  class: "flex items-start"
}, xP = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, CP = {
  key: 0,
  class: "field-editor__toolbar flex flex-wrap items-center gap-1 px-2 py-2"
}, wP = ["disabled"], kP = ["disabled"], $P = {
  key: 1,
  class: "mt-2 flex w-full flex-wrap items-center gap-2 border-t border-border-subtle pt-2"
}, MP = ["placeholder"], Ac = "<p><br></p>", SP = 8, sY = /* @__PURE__ */ H({
  __name: "FieldEditor",
  props: {
    modelValue: { default: "" },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    id: { default: null },
    locale: { default: "en" },
    label: { default: null },
    description: { default: null },
    placeholder: { default: "" },
    basic: { type: Boolean, default: !1 },
    none: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "upload-image"],
  setup(n, { emit: e }) {
    const t = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/gif",
      "image/webp"
    ], o = (X) => {
      const Z = X.match(/<iframe[^>]*\bsrc=(['"])([^'"]+)\1[^>]*>/i);
      return (Z == null ? void 0 : Z[2]) ?? null;
    }, i = (X) => {
      let Z = X.trim();
      if (!Z)
        return null;
      const N = o(Z);
      N && (Z = N);
      let q;
      try {
        q = new URL(Z);
      } catch {
        return null;
      }
      return ["http:", "https:"].includes(q.protocol) ? q : null;
    }, r = (X) => {
      const Z = X.hostname.toLowerCase().replace(/^www\./, ""), N = X.pathname.split("/").filter(Boolean);
      return Z === "youtu.be" ? N[0] ?? null : Z.endsWith("youtube.com") ? X.pathname === "/watch" ? X.searchParams.get("v") : N[0] === "embed" || N[0] === "shorts" || N[0] === "live" ? N[1] ?? null : null : null;
    }, s = (X) => X.hostname.toLowerCase().replace(/^www\./, "").endsWith("vimeo.com") ? X.pathname.split("/").filter(Boolean).find((de) => /^\d+$/.test(de)) ?? null : null, a = (X) => {
      const Z = i(X);
      if (!Z)
        return null;
      const N = r(Z);
      if (N)
        return `https://www.youtube.com/embed/${N}?showinfo=0`;
      const q = s(Z);
      return q ? `https://player.vimeo.com/video/${q}` : Z.toString();
    }, l = (X) => Math.min(SP, Math.max(0, X)), d = xt.create({
      name: "indentation",
      addGlobalAttributes() {
        return [
          {
            types: ["paragraph", "heading"],
            attributes: {
              indent: {
                default: 0,
                parseHTML: (X) => {
                  const Z = Number(X.getAttribute("data-indent"));
                  return Number.isFinite(Z) ? l(Z) : 0;
                },
                renderHTML: (X) => {
                  const Z = Number(X.indent ?? 0);
                  return Z < 1 ? {} : {
                    "data-indent": String(Z),
                    style: `margin-left: ${Z * 1.5}rem;`
                  };
                }
              }
            }
          }
        ];
      },
      addCommands() {
        const X = (Z) => ({ state: N, dispatch: q }) => {
          const de = /* @__PURE__ */ new Set();
          if (N.selection.empty) {
            const { $from: ve } = N.selection;
            for (let ae = ve.depth; ae > 0; ae -= 1) {
              const Ne = ve.node(ae);
              if (Ne.type.name === "paragraph" || Ne.type.name === "heading") {
                de.add(ve.before(ae));
                break;
              }
            }
          } else
            N.doc.nodesBetween(
              N.selection.from,
              N.selection.to,
              (ve, ae) => {
                (ve.type.name === "paragraph" || ve.type.name === "heading") && de.add(ae);
              }
            );
          if (de.size === 0)
            return !1;
          let fe = !1;
          const Be = N.tr;
          return de.forEach((ve) => {
            const ae = Be.doc.nodeAt(ve);
            if (!ae)
              return;
            const Ne = Number(ae.attrs.indent ?? 0), ne = l(Ne + Z);
            ne !== Ne && (fe = !0, q && Be.setNodeMarkup(ve, void 0, {
              ...ae.attrs,
              indent: ne
            }));
          }), q && fe && q(Be), fe;
        };
        return {
          indent: () => X(1),
          outdent: () => X(-1)
        };
      }
    }), u = cn.create({
      name: "videoEmbed",
      group: "block",
      atom: !0,
      selectable: !0,
      draggable: !0,
      parseHTML() {
        return [
          {
            tag: "iframe[src]",
            getAttrs: (X) => {
              if (!(X instanceof HTMLElement))
                return !1;
              const Z = a(
                X.getAttribute("src") ?? ""
              );
              return Z ? {
                src: Z,
                class: X.getAttribute("class") ?? "ql-video",
                frameborder: X.getAttribute("frameborder") ?? "0",
                allowfullscreen: X.getAttribute("allowfullscreen") ?? "true"
              } : !1;
            }
          }
        ];
      },
      addAttributes() {
        return {
          src: {
            default: null
          },
          class: {
            default: "ql-video"
          },
          frameborder: {
            default: "0"
          },
          allowfullscreen: {
            default: "true"
          }
        };
      },
      renderHTML({ HTMLAttributes: X }) {
        const Z = typeof X.src == "string" ? a(X.src) : null;
        return [
          "iframe",
          yt(
            {
              class: "ql-video",
              frameborder: "0",
              allowfullscreen: "true"
            },
            X,
            {
              src: Z ?? ""
            }
          )
        ];
      },
      addCommands() {
        return {
          setVideoEmbed: (X) => ({ commands: Z }) => {
            const N = a(X.src);
            return N ? Z.insertContent({
              type: this.name,
              attrs: {
                src: N,
                class: "ql-video",
                frameborder: "0",
                allowfullscreen: "true"
              }
            }) : !1;
          }
        };
      }
    }), c = n, f = R(void 0), h = R(null), p = R(null), m = R(0), g = R(null), b = R(""), x = R(null), w = qn(), M = e, $ = (X) => {
      const Z = (X ?? "").trim();
      return !Z || Z === "<p></p>" || Z === Ac ? Ac : Z;
    }, T = (X) => {
      const Z = $(X);
      return Z === Ac ? "" : Z;
    }, E = L(
      () => c.locale === "fr" ? "Seuls les jpg, jpeg, png, gif ou webp sont autorisées" : "Only jpg, jpeg, png, gif or webp are allowed"
    ), S = L(
      () => c.locale === "fr" ? "L'URL vidéo est invalide" : "Invalid video URL"
    ), D = (X) => new Promise((Z, N) => {
      const q = new FileReader();
      q.onload = () => {
        if (typeof q.result == "string") {
          Z(q.result);
          return;
        }
        N(new Error("Image upload failed"));
      }, q.onerror = () => {
        N(new Error("Image upload failed"));
      }, q.readAsDataURL(X);
    }), I = () => {
      const X = w == null ? void 0 : w.vnode.props, Z = X == null ? void 0 : X.onUploadImage;
      return typeof Z == "function" || Array.isArray(Z) && Z.length > 0;
    }, z = async (X) => {
      if (!t.includes(X.type))
        throw new Error(E.value);
      return I() ? new Promise((Z, N) => {
        M("upload-image", X, (q, de) => {
          if (q) {
            Z(q);
            return;
          }
          if (de) {
            N(new Error(de));
            return;
          }
          N(new Error("Image upload failed"));
        });
      }) : D(X);
    }, F = ED({
      content: T(c.modelValue),
      extensions: [
        fP.configure({
          heading: {
            levels: [1, 2]
          }
        }),
        CN.configure({
          openOnClick: !1,
          HTMLAttributes: {
            class: "quill-link"
          }
        }),
        u,
        d,
        mP.configure({
          allowBase64: !0
        }),
        gP.configure({
          placeholder: c.placeholder
        })
      ],
      editorProps: {
        attributes: {
          class: "tiptap ql-editor"
        }
      },
      onUpdate: ({ editor: X }) => {
        m.value += 1, M("update:modelValue", $(X.getHTML()));
      },
      onSelectionUpdate: () => {
        m.value += 1;
      }
    }), Y = L(() => F.value);
    Ee(
      () => c.modelValue,
      (X) => {
        if (!F.value)
          return;
        const Z = $(F.value.getHTML()), N = $(X);
        Z !== N && F.value.commands.setContent(T(X), {
          emitUpdate: !1
        });
      }
    );
    const ie = L(
      () => {
        var X, Z;
        return (((Z = (X = c.validation) == null ? void 0 : X.$errors) == null ? void 0 : Z.length) ?? 0) > 0;
      }
    ), W = L(() => {
      var Z, N, q;
      const X = (q = (N = (Z = c.validation) == null ? void 0 : Z.$errors) == null ? void 0 : N[0]) == null ? void 0 : q.$message;
      if (typeof X == "string")
        return X;
      if (typeof X == "object" && X !== null && "value" in X && typeof X.value == "string")
        return X.value;
    }), te = () => {
      var X, Z, N;
      return !!((X = F.value) != null && X.isActive("listItem") || (Z = F.value) != null && Z.isActive("orderedList") || (N = F.value) != null && N.isActive("bulletList"));
    }, ce = L(
      () => !F.value || m.value < 0 ? !1 : te() ? F.value.can().chain().focus().sinkListItem("listItem").run() : F.value.can().chain().focus().indent().run()
    ), we = L(
      () => !F.value || m.value < 0 ? !1 : te() ? F.value.can().chain().focus().liftListItem("listItem").run() : F.value.can().chain().focus().outdent().run()
    ), ke = (X = !1) => [
      "inline-flex h-8 min-w-8 items-center justify-center rounded px-2 text-mgm-txt-sm font-medium transition-colors duration-150",
      X ? "bg-background-subtle text-foreground-emphasis" : "text-foreground-default hover:bg-background-subtle-hover"
    ], rt = (X = !1) => [
      "inline-flex h-8 w-8 items-center justify-center rounded transition-colors duration-150",
      X ? "bg-background-subtle text-foreground-emphasis" : "text-foreground-default hover:bg-background-subtle-hover"
    ], ut = L(() => g.value === "video" ? c.locale === "fr" ? "Collez l'URL de la video" : "Paste video URL" : c.locale === "fr" ? "Collez l'URL du lien" : "Paste link URL"), it = L(
      () => c.locale === "fr" ? "Valider" : "Apply"
    ), Ut = L(
      () => c.locale === "fr" ? "Annuler" : "Cancel"
    ), nn = () => {
      if (!F.value || !x.value)
        return;
      const { from: X, to: Z } = x.value;
      F.value.chain().focus().setTextSelection({ from: X, to: Z }).run();
    }, ct = () => {
      g.value = null, b.value = "", x.value = null;
    }, At = (X) => {
      if (!F.value)
        return;
      f.value = void 0;
      const { from: Z, to: N } = F.value.state.selection;
      if (x.value = { from: Z, to: N }, g.value = X, X === "link") {
        const q = F.value.getAttributes("link").href;
        b.value = q ?? "https://";
      } else
        b.value = "https://";
      Ve(() => {
        var q, de;
        (q = p.value) == null || q.focus(), (de = p.value) == null || de.select();
      });
    }, oo = () => {
      if (!F.value || !g.value)
        return;
      const X = b.value.trim(), Z = g.value;
      if (nn(), Z === "link") {
        if (!X) {
          F.value.chain().focus().extendMarkRange("link").unsetLink().run(), ct();
          return;
        }
        F.value.chain().focus().extendMarkRange("link").setLink({ href: X }).run(), ct();
        return;
      }
      if (!X) {
        ct();
        return;
      }
      const N = a(X);
      if (!N) {
        f.value = S.value;
        return;
      }
      f.value = void 0, F.value.chain().focus().setVideoEmbed({ src: N }).run(), ct();
    }, Cn = (X) => {
      var Z;
      if (X.key === "Enter") {
        X.preventDefault(), oo();
        return;
      }
      X.key === "Escape" && (X.preventDefault(), ct(), (Z = F.value) == null || Z.chain().focus().run());
    }, io = () => {
      At("link");
    }, Ni = () => {
      var X;
      ct(), (X = h.value) == null || X.click();
    }, Zo = async (X) => {
      var q;
      const Z = X.target, N = (q = Z.files) == null ? void 0 : q[0];
      if (!(!N || !F.value))
        try {
          f.value = void 0;
          const de = await z(N);
          F.value.chain().focus().setImage({ src: de, alt: N.name }).run();
        } catch (de) {
          f.value = de instanceof Error ? de.message : "Image upload failed";
        } finally {
          Z.value = "";
        }
    }, ro = () => {
      At("video");
    }, Pi = () => {
      if (F.value) {
        if (te()) {
          F.value.chain().focus().sinkListItem("listItem").run();
          return;
        }
        F.value.chain().focus().indent().run();
      }
    }, Li = () => {
      if (F.value) {
        if (te()) {
          F.value.chain().focus().liftListItem("listItem").run();
          return;
        }
        F.value.chain().focus().outdent().run();
      }
    };
    return ps(() => {
      var X;
      (X = F.value) == null || X.destroy();
    }), (X, Z) => {
      var N, q, de, fe, Be, ve, ae;
      return v(), C("div", vP, [
        n.label || n.description ? (v(), C("div", bP, [
          n.label ? (v(), C("div", yP, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", xP, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", {
          class: J([
            `js-field-editor-${n.id}`,
            "field-editor flex min-h-[220px] flex-1 flex-col overflow-hidden rounded-[5px] border bg-background-default",
            f.value || ie.value ? "border-border-danger-emphasis" : "border-border-subtle focus-within:border-border-brand-emphasis focus-within:ring-2 focus-within:ring-border-brand-default"
          ])
        }, [
          !n.none && Y.value ? (v(), C("div", CP, [
            y("button", {
              type: "button",
              class: J(ke((N = Y.value) == null ? void 0 : N.isActive("bold"))),
              "aria-label": "Bold",
              onClick: Z[0] || (Z[0] = (Ne) => {
                var ne;
                return (ne = Y.value) == null ? void 0 : ne.chain().focus().toggleBold().run();
              })
            }, [...Z[7] || (Z[7] = [
              y("strong", null, "B", -1)
            ])], 2),
            y("button", {
              type: "button",
              class: J(ke((q = Y.value) == null ? void 0 : q.isActive("italic"))),
              "aria-label": "Italic",
              onClick: Z[1] || (Z[1] = (Ne) => {
                var ne;
                return (ne = Y.value) == null ? void 0 : ne.chain().focus().toggleItalic().run();
              })
            }, [...Z[8] || (Z[8] = [
              y("em", null, "I", -1)
            ])], 2),
            y("button", {
              type: "button",
              class: J(ke((de = Y.value) == null ? void 0 : de.isActive("heading", { level: 1 }))),
              "aria-label": "Heading 1",
              onClick: Z[2] || (Z[2] = (Ne) => {
                var ne;
                return (ne = Y.value) == null ? void 0 : ne.chain().focus().toggleHeading({ level: 1 }).run();
              })
            }, " H1 ", 2),
            y("button", {
              type: "button",
              class: J(ke((fe = Y.value) == null ? void 0 : fe.isActive("heading", { level: 2 }))),
              "aria-label": "Heading 2",
              onClick: Z[3] || (Z[3] = (Ne) => {
                var ne;
                return (ne = Y.value) == null ? void 0 : ne.chain().focus().toggleHeading({ level: 2 }).run();
              })
            }, " H2 ", 2),
            y("button", {
              type: "button",
              class: J(ke((Be = Y.value) == null ? void 0 : Be.isActive("orderedList"))),
              "aria-label": "Ordered list",
              title: "Ordered list",
              onClick: Z[4] || (Z[4] = (Ne) => {
                var ne;
                return (ne = Y.value) == null ? void 0 : ne.chain().focus().toggleOrderedList().run();
              })
            }, [...Z[9] || (Z[9] = [
              mi('<svg class="field-editor__toolbar-icon" viewBox="0 0 16 16"><path d="M6 3H14M6 8H14M6 13H14"></path><text x="1" y="4.4">1</text><text x="1" y="9.2">2</text><text x="1" y="14">3</text></svg>', 1)
            ])], 2),
            y("button", {
              type: "button",
              class: J(ke((ve = Y.value) == null ? void 0 : ve.isActive("bulletList"))),
              "aria-label": "Bullet list",
              title: "Bullet list",
              onClick: Z[5] || (Z[5] = (Ne) => {
                var ne;
                return (ne = Y.value) == null ? void 0 : ne.chain().focus().toggleBulletList().run();
              })
            }, [...Z[10] || (Z[10] = [
              mi('<svg class="field-editor__toolbar-icon" viewBox="0 0 16 16"><path d="M6 3H14M6 8H14M6 13H14"></path><circle cx="2.5" cy="3" r="1"></circle><circle cx="2.5" cy="8" r="1"></circle><circle cx="2.5" cy="13" r="1"></circle></svg>', 1)
            ])], 2),
            y("button", {
              type: "button",
              disabled: !we.value,
              class: J([
                ...ke(!1),
                we.value ? "" : "cursor-not-allowed opacity-50 hover:bg-transparent"
              ]),
              "aria-label": "Decrease indent",
              title: "Decrease indent",
              onClick: Li
            }, [...Z[11] || (Z[11] = [
              y("svg", {
                class: "field-editor__toolbar-icon",
                viewBox: "0 0 16 16"
              }, [
                y("path", { d: "M6 3H14M9 8H14M6 13H14" }),
                y("path", { d: "M2.5 8H6" }),
                y("path", { d: "M4.5 6.2L2.5 8L4.5 9.8" })
              ], -1)
            ])], 10, wP),
            y("button", {
              type: "button",
              disabled: !ce.value,
              class: J([
                ...ke(!1),
                ce.value ? "" : "cursor-not-allowed opacity-50 hover:bg-transparent"
              ]),
              "aria-label": "Increase indent",
              title: "Increase indent",
              onClick: Pi
            }, [...Z[12] || (Z[12] = [
              y("svg", {
                class: "field-editor__toolbar-icon",
                viewBox: "0 0 16 16"
              }, [
                y("path", { d: "M2 3H10M2 8H7M2 13H10" }),
                y("path", { d: "M8.5 8H12.5" }),
                y("path", { d: "M10.5 6.2L12.5 8L10.5 9.8" })
              ], -1)
            ])], 10, kP),
            n.basic ? _("", !0) : (v(), C(re, { key: 0 }, [
              y("button", {
                type: "button",
                class: J(
                  rt(((ae = Y.value) == null ? void 0 : ae.isActive("link")) || g.value === "link")
                ),
                "aria-label": "Insert link",
                onClick: io
              }, [
                U(ye, { icon: "link" })
              ], 2),
              y("button", {
                type: "button",
                class: J(rt(!1)),
                "aria-label": "Insert image",
                onClick: Ni
              }, [
                U(ye, { icon: "image" })
              ], 2),
              y("button", {
                type: "button",
                class: J(rt(!1)),
                "aria-label": "Insert video link",
                onClick: ro
              }, [
                U(ye, { icon: "monitor" })
              ], 2)
            ], 64)),
            g.value ? (v(), C("div", $P, [
              vo(y("input", {
                ref_key: "inlineUrlInput",
                ref: p,
                "onUpdate:modelValue": Z[6] || (Z[6] = (Ne) => b.value = Ne),
                type: "url",
                class: "h-8 min-w-[220px] flex-1 rounded border border-border-default bg-background-default px-2 text-mgm-txt-sm text-foreground-emphasis outline-none focus:border-border-brand-emphasis focus:ring-2 focus:ring-border-brand-default",
                placeholder: ut.value,
                onKeydown: Cn
              }, null, 40, MP), [
                [m1, b.value]
              ]),
              y("button", {
                type: "button",
                class: "inline-flex h-8 items-center justify-center rounded border border-border-subtle px-3 text-mgm-txt-sm font-medium text-foreground-default transition-colors duration-150 hover:bg-background-subtle-hover",
                onClick: oo
              }, j(it.value), 1),
              y("button", {
                type: "button",
                class: "inline-flex h-8 items-center justify-center rounded border border-border-subtle px-3 text-mgm-txt-sm font-medium text-foreground-default transition-colors duration-150 hover:bg-background-subtle-hover",
                onClick: ct
              }, j(Ut.value), 1)
            ])) : _("", !0)
          ])) : _("", !0),
          U(k(_D), {
            editor: Y.value,
            class: "field-editor__content w-full flex-1 overflow-y-auto"
          }, null, 8, ["editor"])
        ], 2),
        y("input", {
          ref_key: "imageInput",
          ref: h,
          class: "hidden",
          type: "file",
          accept: "image/jpeg,image/png,image/jpg,image/gif,image/webp",
          onChange: Zo
        }, null, 544),
        f.value || ie.value ? (v(), V(_e, {
          key: 1,
          class: "mt-1",
          label: f.value ? f.value : W.value || "",
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ]);
    };
  }
}), _P = {
  key: 0,
  class: "mb-2"
}, EP = {
  key: 0,
  class: "flex items-start"
}, OP = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, TP = ["id", "aria-label", "accept"], AP = ["for"], IP = ["src"], DP = { class: "mx-auto h-full w-[269px] rounded-[21px] border-2 border-border-on-emphasis p-[5px]" }, NP = { class: "h-full rounded-[21px] bg-background-default" }, PP = { class: "relative flex items-center px-4 py-2.5" }, LP = { class: "h-8 w-8 overflow-hidden rounded-full border-2 border-border-on-emphasis" }, RP = ["alt", "src"], FP = {
  key: 1,
  class: "flex h-full w-full items-center justify-center bg-background-subtle"
}, BP = { class: "text-mgm-txt-xs font-semibold uppercase text-foreground-default" }, VP = { class: "ml-1.5 max-w-[50%] truncate text-mgm-txt-xs font-medium" }, zP = ["src"], HP = { class: "px-4 pt-6" }, jP = { class: "block text-mgm-txt-md font-semibold text-foreground-subtle" }, WP = { class: "block text-mgm-txt-md font-semibold text-foreground-emphasis" }, UP = { class: "mt-4 block text-mgm-txt-sm font-medium text-foreground-emphasis" }, KP = { class: "mx-auto mt-4 block text-center text-mgm-txt-sm font-normal text-foreground-default" }, GP = { class: "font-medium text-foreground-brand-default" }, YP = ["src"], qP = {
  key: 2,
  class: "ml-3 max-w-[50%] text-mgm-txt-xs font-normal text-foreground-default"
}, ZP = { class: "block truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, JP = 1e3 * 1e3, x5 = /* @__PURE__ */ H({
  __name: "FieldFileUploader",
  props: {
    accept: { default: "*" },
    description: { default: null },
    id: {},
    label: { default: null },
    locale: { default: "en" },
    modelValue: { default: null },
    organizationDetails: { default: null },
    previewCustom: { type: Boolean, default: !1 },
    previewFull: { type: Boolean, default: !1 },
    previewUrl: { default: void 0 },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    viewOnly: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, { t: o } = Tn({ useScope: "global" }), i = R(0), r = R(!1), s = R(null), a = R(t.previewUrl), l = R(null), d = e, u = () => {
      l.value && (URL.revokeObjectURL(l.value), l.value = null);
    }, c = () => {
      i.value += 1, r.value = !0;
    }, f = () => {
      i.value -= 1, i.value === 0 && (r.value = !1);
    }, h = (x) => {
      x.preventDefault();
    }, p = (x) => {
      var w;
      x.preventDefault(), r.value = !1, (w = x.dataTransfer) != null && w.files && b(x.dataTransfer.files);
    }, m = (x) => {
      const w = x.target;
      w != null && w.files && (b(w.files), w.value = "");
    }, g = (x, w) => {
      w.preventDefault(), w.stopPropagation(), d("update:modelValue", void 0), s.value && (s.value.value = ""), u(), a.value = "";
    }, b = (x) => {
      const w = x[0] || null;
      if (u(), w && w.type.startsWith("image/")) {
        const M = URL.createObjectURL(w);
        l.value = M, a.value = M;
      } else
        a.value = "";
      d("update:modelValue", w), d("change", w);
    };
    return ps(() => {
      u();
    }), (x, w) => {
      var M, $, T, E, S, D, I, z, F, Y, ie, W, te, ce;
      return v(), C("div", null, [
        n.label || n.description ? (v(), C("div", _P, [
          n.label ? (v(), C("div", EP, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", OP, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        !a.value && !n.viewOnly ? (v(), C("div", {
          key: 1,
          class: J([
            "border-box relative flex cursor-pointer flex-col items-center justify-center rounded-[5px] px-6 py-10",
            "hover:border-border-default hover:bg-background-subtle-hover",
            (n.previewFull || n.previewCustom) && (n.modelValue || n.previewUrl) ? "h-[412px]" : "h-40",
            r.value ? "border border-solid border-border-brand-emphasis bg-background-brand-default-hover" : "border-2 border-dashed border-border-subtle bg-background-default"
          ]),
          onDragenter: c,
          onDragleave: f,
          onDragover: h,
          onDrop: p
        }, [
          y("input", {
            id: n.id,
            ref_key: "fileInputRef",
            ref: s,
            "aria-label": n.label || void 0,
            accept: n.accept,
            class: "absolute -z-10 max-w-[1px]",
            type: "file",
            title: "",
            onChange: m
          }, null, 40, TP),
          y("label", {
            class: "h-full w-full cursor-pointer",
            for: n.id,
            onClick: w[0] || (w[0] = It(() => {
            }, ["stop"]))
          }, [
            (n.previewFull || n.previewCustom) && (n.previewUrl || a.value) ? (v(), C("div", {
              key: 0,
              class: J([
                "h-[304px] w-full rounded-[5px] overflow-hidden",
                { "relative bg-background-subtle pt-6": n.previewCustom }
              ])
            }, [
              n.previewFull ? (v(), C("img", {
                key: 0,
                class: "h-full w-full rounded-[5px] object-cover",
                src: a.value || n.previewUrl
              }, null, 8, IP)) : n.previewCustom ? (v(), C(re, { key: 1 }, [
                y("div", DP, [
                  y("div", NP, [
                    y("div", PP, [
                      y("div", LP, [
                        (M = n.organizationDetails) != null && M.logo ? (v(), C("img", {
                          key: 0,
                          class: "h-full w-full object-cover",
                          alt: "logo " + (($ = n.organizationDetails) == null ? void 0 : $.name),
                          src: (T = n.organizationDetails) == null ? void 0 : T.logo
                        }, null, 8, RP)) : (E = n.organizationDetails) != null && E.name ? (v(), C("div", FP, [
                          y("span", BP, j((D = (S = n.organizationDetails) == null ? void 0 : S.name) == null ? void 0 : D.charAt(0)), 1)
                        ])) : _("", !0)
                      ]),
                      y("span", VP, j((I = n.organizationDetails) == null ? void 0 : I.name), 1),
                      n.viewOnly ? _("", !0) : (v(), V(ye, {
                        key: 0,
                        class: "absolute bottom-0 right-6 top-0",
                        color: "var(--color-foreground-default)",
                        icon: "close"
                      }))
                    ]),
                    a.value || n.previewUrl ? (v(), C("img", {
                      key: 0,
                      class: "h-28 w-full object-cover",
                      src: a.value || n.previewUrl
                    }, null, 8, zP)) : _("", !0),
                    y("div", HP, [
                      y("span", jP, j(k(o)("previewCustom.title")), 1),
                      y("span", WP, j(k(o)("previewCustom.subtitle")), 1),
                      y("span", UP, j(k(o)("previewCustom.text")), 1)
                    ])
                  ])
                ]),
                w[2] || (w[2] = y("div", { class: "gradient__preview absolute bottom-0 left-0 right-0 h-[40%]" }, null, -1))
              ], 64)) : _("", !0)
            ], 2)) : (v(), V(ye, {
              key: 1,
              class: "mx-auto w-fit rounded-full border-[6px] border-background-brand-default-hover",
              size: 20,
              "bg-color": "var(--color-background-brand-default-hover)",
              color: "var(--color-foreground-brand-default)",
              icon: "file-upload"
            })),
            y("span", KP, [
              y("span", GP, j(k(o)("browse")), 1),
              Se(" " + j(k(o)("drag")), 1)
            ])
          ], 8, AP)
        ], 34)) : _("", !0),
        !(n.previewFull || n.previewCustom || !a.value) || n.viewOnly ? (v(), C(re, { key: 2 }, [
          n.modelValue || n.previewUrl ? (v(), C("div", {
            key: 0,
            class: J([
              "border-box relative mt-2 flex w-full items-center rounded-[5px] border p-4",
              n.viewOnly ? "opacity-80 bg-background-subtle" : "",
              n.validation && ((z = n.validation.$errors) != null && z.length) ? "border-border-danger-emphasis bg-background-danger-subtle" : "border-border-subtle bg-background-default"
            ])
          }, [
            a.value || n.previewUrl ? (v(), C("img", {
              key: 0,
              class: "h-10 w-10 rounded-[5px] object-cover",
              src: a.value || n.previewUrl
            }, null, 8, YP)) : (v(), C("div", {
              key: 1,
              class: J([
                "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[5px] ",
                n.validation && ((F = n.validation.$errors) != null && F.length) ? "bg-background-danger-subtle" : "bg-background-subtle-hover"
              ])
            }, [
              U(ye, {
                color: n.validation && ((Y = n.validation.$errors) != null && Y.length) ? "var(--color-foreground-danger-default)" : "var(--color-foreground-default)",
                icon: "file-check"
              }, null, 8, ["color"])
            ], 2)),
            n.modelValue ? (v(), C("p", qP, [
              y("span", ZP, j((ie = n.modelValue) == null ? void 0 : ie.name), 1),
              y("span", null, j(`${(((W = n.modelValue) == null ? void 0 : W.size) / JP).toFixed(2)} MB`), 1)
            ])) : _("", !0),
            n.viewOnly ? _("", !0) : (v(), V(ye, {
              key: 3,
              class: "absolute bottom-0 right-4 top-0 cursor-pointer",
              color: "var(--color-foreground-default)",
              icon: "trash",
              onClick: w[1] || (w[1] = (we) => g(0, we))
            }))
          ], 2)) : _("", !0)
        ], 64)) : _("", !0),
        n.validation && ((te = n.validation.$errors) != null && te.length) ? (v(), V(_e, {
          key: 3,
          class: "mt-1",
          label: (ce = n.validation.$errors[0]) == null ? void 0 : ce.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ]);
    };
  }
});
function Sp(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Browse"]);
        },
        drag: (t) => {
          const { normalize: o } = t;
          return o(["or drag a file here"]);
        },
        previewCustom: {
          title: (t) => {
            const { normalize: o } = t;
            return o(["Any question?"]);
          },
          subtitle: (t) => {
            const { normalize: o } = t;
            return o(["Meet our ambassadors"]);
          },
          text: (t) => {
            const { normalize: o } = t;
            return o(["What is your email address? *"]);
          }
        }
      },
      fr: {
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Parcourez"]);
        },
        drag: (t) => {
          const { normalize: o } = t;
          return o(["ou faites glisser un fichier ici"]);
        },
        previewCustom: {
          title: (t) => {
            const { normalize: o } = t;
            return o(["Des questions ?"]);
          },
          subtitle: (t) => {
            const { normalize: o } = t;
            return o(["Rencontrez l’un de nos ambassadeurs"]);
          },
          text: (t) => {
            const { normalize: o } = t;
            return o(["Quelle est votre adresse e-mail ? *"]);
          }
        }
      }
    }
  });
}
typeof Sp == "function" && Sp(x5);
const aY = /* @__PURE__ */ Ai(x5, [["__scopeId", "data-v-df80f3d5"]]), XP = {
  key: 0,
  class: "mb-2"
}, QP = {
  key: 0,
  class: "flex items-start"
}, eL = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, tL = ["id", "aria-label", "accept"], nL = ["for"], oL = { class: "mt-4 block text-center text-mgm-txt-sm font-normal text-foreground-default" }, iL = { class: "font-medium text-foreground-brand-default" }, rL = {
  key: 2,
  class: "mt-1 text-mgm-txt-xs font-medium text-foreground-brand-default"
}, sL = {
  key: 3,
  class: "mt-1 text-mgm-txt-xs font-medium text-foreground-danger-default"
}, aL = {
  key: 4,
  class: "mt-1 text-mgm-txt-xs font-medium text-foreground-brand-default"
}, lL = {
  key: 5,
  class: "mt-1 text-mgm-txt-xs font-medium text-foreground-danger-default"
}, dL = {
  key: 6,
  class: "mt-2"
}, uL = {
  key: 0,
  class: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[5px] bg-background-subtle-hover"
}, cL = ["aria-valuenow"], fL = ["stroke-dasharray", "stroke-dashoffset"], hL = {
  key: 0,
  class: "absolute text-[9px] font-medium text-foreground-brand-default"
}, pL = ["src", "alt"], mL = { class: "ml-3 min-w-0 flex-1" }, gL = ["onKeydown"], vL = {
  key: 1,
  class: "flex min-w-0 items-center gap-2"
}, bL = ["title"], yL = ["aria-label", "title", "onClick"], xL = { class: "block text-mgm-txt-xs font-normal text-foreground-default" }, CL = {
  key: 0,
  class: "text-foreground-default"
}, wL = {
  key: 1,
  class: "text-foreground-brand-default"
}, kL = {
  key: 2,
  class: "text-foreground-danger-default"
}, $L = {
  key: 4,
  class: "ml-4 flex flex-shrink-0 items-center gap-3"
}, ML = ["aria-label", "title", "onClick"], SL = ["aria-label", "title", "onClick"], _p = 5e3, _L = /* @__PURE__ */ H({
  __name: "FieldMultiFileUploader",
  props: {
    accept: { default: "*" },
    description: { default: null },
    id: {},
    label: { default: null },
    locale: { default: "en" },
    maxFileSize: { default: null },
    maxFiles: { default: null },
    modelValue: { default: () => [] },
    readonlyFiles: { default: () => [] },
    required: { type: Boolean, default: !1 },
    uploadStates: { default: () => [] },
    validation: { default: null },
    viewOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "file-remove", "file-retry", "file-rename"],
  setup(n, { emit: e }) {
    const t = n, o = e, { t: i } = Tn(), l = {
      "image/": [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".webp",
        ".bmp",
        ".svg",
        ".tiff",
        ".avif"
      ],
      "video/": [".mp4", ".webm", ".ogg", ".ogv", ".mov", ".avi", ".mkv"],
      "audio/": [".mp3", ".wav", ".ogg", ".flac", ".aac", ".m4a"]
    }, d = {
      "image/avif": [".avif"],
      "image/gif": [".gif"],
      "image/heic": [".heic"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/jpg": [".jpg"],
      "image/png": [".png"],
      "image/webp": [".webp"],
      "video/mp4": [".mp4"],
      "video/quicktime": [".mov"],
      "video/webm": [".webm"],
      "video/x-m4v": [".m4v"],
      "video/x-matroska": [".mkv"]
    }, u = R(0), c = R(!1), f = R(null), h = R({}), p = R({}), m = R({}), g = R({}), b = R({}), x = R(null), w = R(""), M = R(0), $ = R(0), T = R(0), E = (N, q) => {
      const de = N.toLowerCase();
      return q.some((fe) => de.endsWith(fe));
    }, S = (N, q) => {
      const de = N.type.trim().toLowerCase();
      if (de)
        return de.startsWith(q);
      const fe = l[q];
      return fe ? E(N.name, fe) : !1;
    }, D = (N, q) => {
      const de = q.trim();
      if (!de || de === "*")
        return !0;
      const fe = N.type.trim().toLowerCase();
      return de.split(",").map((ve) => ve.trim().toLowerCase()).filter(Boolean).some((ve) => ve.endsWith("/*") ? S(N, ve.replace("/*", "/")) : ve.startsWith(".") ? N.name.toLowerCase().endsWith(ve) : fe ? fe === ve : !1);
    }, I = (N) => N.endsWith("/*") ? l[N.replace("/*", "/")] || [] : N.startsWith(".") ? [N] : d[N] || [N], z = L(() => {
      const N = t.accept.trim();
      if (!N || N === "*")
        return null;
      const q = Array.from(new Set(
        N.split(",").map((de) => de.trim().toLowerCase()).filter(Boolean).flatMap(I).map((de) => de.replace(/^\./, "").toUpperCase())
      ));
      return q.length ? i("acceptedFormats", { formats: q.join(", ") }) : null;
    }), F = (N) => N < 1e3 ? `${N} B` : N < 1e6 ? `${(N / 1e3).toFixed(2)} KB` : N < 1e9 ? `${(N / 1e6).toFixed(2)} MB` : `${(N / 1e9).toFixed(2)} GB`, Y = L(() => t.maxFileSize ? i("maxFileSize", {
      size: F(t.maxFileSize)
    }) : null), ie = L(() => t.viewOnly && t.readonlyFiles.length ? t.readonlyFiles.map((N, q) => ({
      key: String(N.id ?? `${N.url}-${N.filename}-${q}`),
      filename: N.filename,
      mimeType: N.mimeType || "",
      size: Number(N.size) || 0,
      url: N.url,
      downloadUrl: N.downloadUrl || N.url,
      downloadFilename: N.downloadFilename || N.filename
    })) : t.modelValue.map((N, q) => ({
      key: `${N.name}-${N.size}-${N.lastModified}-${q}`,
      filename: N.name,
      mimeType: N.type,
      size: N.size
    }))), W = (N, q) => N.url && N.mimeType.startsWith("image/") ? N.url : N.url && N.mimeType.startsWith("video/") ? m.value[q] || null : h.value[q] || null, te = (N, q) => `${N.id ?? q}-${N.url}-${N.filename}`, ce = async (N, q) => {
      var Be;
      if (!((Be = N.mimeType) != null && Be.startsWith("video/")) || !N.url)
        return;
      const de = te(N, q);
      g.value[q] = de;
      const fe = document.createElement("video");
      fe.crossOrigin = "anonymous", fe.preload = "metadata", fe.muted = !0, fe.playsInline = !0, fe.src = N.url, await new Promise((ve) => {
        let ae = !1, Ne = !1;
        const ne = window.setTimeout(() => {
          K();
        }, _p), K = () => {
          ae || (ae = !0, window.clearTimeout(ne), fe.removeAttribute("src"), fe.load(), ve());
        }, ee = () => {
          if (g.value[q] !== de || !fe.videoWidth || !fe.videoHeight) {
            K();
            return;
          }
          try {
            const $e = document.createElement("canvas");
            $e.width = 160, $e.height = 160;
            const Ze = $e.getContext("2d");
            if (!Ze) {
              K();
              return;
            }
            const on = Math.max(
              $e.width / fe.videoWidth,
              $e.height / fe.videoHeight
            ), An = fe.videoWidth * on, rn = fe.videoHeight * on, hn = ($e.width - An) / 2, Jo = ($e.height - rn) / 2;
            Ze.drawImage(fe, hn, Jo, An, rn), m.value[q] = $e.toDataURL("image/jpeg", 0.72);
          } catch {
          }
          K();
        };
        fe.addEventListener("loadedmetadata", () => {
          const $e = Number.isFinite(fe.duration) && fe.duration > 1 ? Math.min(0.5, fe.duration / 2) : 0;
          if ($e > 0) {
            Ne = !0, fe.currentTime = $e;
            return;
          }
          ee();
        }), fe.addEventListener("loadeddata", () => {
          Ne || ee();
        }), fe.addEventListener("seeked", ee), fe.addEventListener("error", K);
      });
    }, we = () => {
      m.value = {}, g.value = {}, t.viewOnly && t.readonlyFiles.forEach((N, q) => {
        ce(N, q);
      });
    }, ke = async (N, q) => {
      if (p.value[q] = N, S(N, "image/")) {
        h.value[q] = URL.createObjectURL(N);
        return;
      }
      if (!S(N, "video/"))
        return;
      const de = URL.createObjectURL(N), fe = document.createElement("video");
      fe.preload = "metadata", fe.muted = !0, fe.src = de, await new Promise((Be) => {
        let ve = !1;
        const ae = () => {
          ve || (ve = !0, URL.revokeObjectURL(de), Be());
        }, Ne = window.setTimeout(() => {
          ae();
        }, _p);
        fe.addEventListener("loadedmetadata", () => {
          fe.currentTime = 0.5;
        }), fe.addEventListener("seeked", () => {
          if (ve)
            return;
          if (p.value[q] !== N) {
            window.clearTimeout(Ne), ae();
            return;
          }
          window.clearTimeout(Ne);
          const ne = document.createElement("canvas");
          ne.width = fe.videoWidth, ne.height = fe.videoHeight;
          const K = ne.getContext("2d");
          K && (K.drawImage(fe, 0, 0, ne.width, ne.height), h.value[q] = ne.toDataURL("image/jpeg", 0.7)), ae();
        }), fe.addEventListener("error", () => {
          ve || (window.clearTimeout(Ne), ae());
        });
      });
    }, rt = (N) => {
      const q = Array.from(N), de = [];
      let fe = 0, Be = 0;
      for (const ne of q) {
        if (!D(ne, t.accept)) {
          fe += 1;
          continue;
        }
        if (t.maxFileSize !== null && t.maxFileSize !== void 0 && ne.size > t.maxFileSize) {
          Be += 1;
          continue;
        }
        de.push(ne);
      }
      M.value = fe, $.value = Be;
      const ve = t.modelValue.length, ae = [...t.modelValue, ...de];
      let Ne = 0;
      t.maxFiles !== null && t.maxFiles !== void 0 && ae.length > t.maxFiles && (Ne = ae.length - t.maxFiles, ae.splice(t.maxFiles)), T.value = Ne;
      for (let ne = ve; ne < ae.length; ne += 1)
        ke(ae[ne], ne);
      o("update:modelValue", ae), o("change", ae);
    }, ut = (N) => {
      N != null && N.startsWith("blob:") && URL.revokeObjectURL(N);
    }, it = () => {
      h.value = {}, p.value = {};
    }, Ut = (N, q = []) => {
      const de = /* @__PURE__ */ new Map();
      q.forEach((Be, ve) => {
        const ae = b.value[ve];
        ae && de.set(Be, ae);
      });
      const fe = {};
      N.forEach((Be, ve) => {
        fe[ve] = de.get(Be) ?? Be.name;
      }), b.value = fe;
    }, nn = () => {
      for (const N of Object.values(h.value))
        ut(N);
      it();
    }, ct = (N) => {
      const q = /* @__PURE__ */ new Map(), de = [];
      for (const [ae, Ne] of Object.entries(p.value)) {
        const ne = h.value[Number(ae)];
        ne && q.set(Ne, ne);
      }
      const fe = {}, Be = {}, ve = /* @__PURE__ */ new Set();
      N.forEach((ae, Ne) => {
        const ne = q.get(ae);
        if (ne) {
          fe[Ne] = ne, Be[Ne] = ae, ve.add(ne);
          return;
        }
        de.push({ file: ae, index: Ne });
      });
      for (const ae of Object.values(h.value))
        ve.has(ae) || ut(ae);
      h.value = fe, p.value = Be;
      for (const { file: ae, index: Ne } of de)
        ke(ae, Ne);
    }, At = () => {
      u.value += 1, c.value = !0;
    }, oo = () => {
      u.value -= 1, u.value === 0 && (c.value = !1);
    }, Cn = (N) => {
      N.preventDefault();
    }, io = (N) => {
      var q;
      N.preventDefault(), c.value = !1, u.value = 0, (q = N.dataTransfer) != null && q.files && rt(N.dataTransfer.files);
    }, Ni = (N) => {
      const q = N.target;
      q != null && q.files && (rt(q.files), q.value = "");
    }, Zo = (N, q) => {
      var Ne;
      q.preventDefault(), q.stopPropagation(), o("file-remove", N), (Ne = h.value[N]) != null && Ne.startsWith("blob:") && URL.revokeObjectURL(h.value[N]);
      const de = {}, fe = {}, Be = {}, ve = t.modelValue;
      for (let ne = 0; ne < ve.length; ne += 1)
        ne < N && h.value[ne] ? (de[ne] = h.value[ne], fe[ne] = ve[ne]) : ne > N && h.value[ne] && (de[ne - 1] = h.value[ne], fe[ne - 1] = ve[ne]), ne < N ? Be[ne] = b.value[ne] ?? ve[ne].name : ne > N && (Be[ne - 1] = b.value[ne] ?? ve[ne].name);
      h.value = de, p.value = fe, b.value = Be;
      const ae = [
        ...ve.slice(0, N),
        ...ve.slice(N + 1)
      ];
      x.value === N ? (x.value = null, w.value = "") : x.value !== null && x.value > N && (x.value -= 1), o("update:modelValue", ae), o("change", ae);
    }, ro = (N) => {
      N.url && window.open(N.url, "_blank", "noopener,noreferrer");
    }, Pi = (N) => {
      const q = N.downloadUrl || N.url;
      if (!q)
        return;
      const de = document.createElement("a");
      de.href = q, de.rel = "noopener noreferrer", N.downloadFilename ? de.download = N.downloadFilename : N.filename && (de.download = N.filename), document.body.appendChild(de), de.click(), document.body.removeChild(de);
    }, Li = (N) => {
      var q, de;
      t.viewOnly || ((q = t.uploadStates[N]) == null ? void 0 : q.status) !== "uploading" && (x.value = N, w.value = b.value[N] ?? ((de = t.modelValue[N]) == null ? void 0 : de.name) ?? "");
    }, X = () => {
      if (x.value === null)
        return;
      const N = w.value.trim(), de = t.modelValue[x.value];
      if (!de) {
        x.value = null, w.value = "";
        return;
      }
      const fe = x.value, Be = N || de.name;
      b.value[fe] = Be, o("file-rename", {
        index: fe,
        filename: Be
      }), x.value = null, w.value = "";
    }, Z = () => {
      x.value = null, w.value = "";
    };
    return Ee(
      () => t.modelValue.slice(),
      (N, q) => {
        ct(N), Ut(N, q);
      },
      { immediate: !0 }
    ), Ee(
      () => [
        t.viewOnly,
        t.readonlyFiles.map((N, q) => te(N, q)).join("|")
      ],
      we,
      { immediate: !0 }
    ), ps(() => {
      nn();
    }), (N, q) => {
      var de, fe, Be;
      return v(), C("div", null, [
        n.label || n.description || z.value || Y.value ? (v(), C("div", XP, [
          n.label ? (v(), C("div", QP, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", eL, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0),
          z.value ? (v(), V(_e, {
            key: 2,
            label: z.value,
            description: ""
          }, null, 8, ["label"])) : _("", !0),
          Y.value ? (v(), V(_e, {
            key: 3,
            label: Y.value,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        n.viewOnly ? _("", !0) : (v(), C("div", {
          key: 1,
          class: J([
            "border-box relative flex h-40 cursor-pointer flex-col items-center justify-center rounded-[5px] px-6 py-10",
            "hover:border-border-default hover:bg-background-subtle-hover",
            c.value ? "border border-solid border-border-brand-emphasis bg-background-brand-default-hover" : "border-2 border-dashed border-border-subtle bg-background-default"
          ]),
          onDragenter: At,
          onDragleave: oo,
          onDragover: Cn,
          onDrop: io
        }, [
          y("input", {
            id: n.id,
            ref_key: "fileInputRef",
            ref: f,
            "aria-label": n.label || void 0,
            accept: n.accept,
            multiple: "",
            class: "absolute -z-10 max-w-[1px]",
            type: "file",
            title: "",
            onChange: Ni
          }, null, 40, tL),
          y("label", {
            class: "flex h-full w-full cursor-pointer flex-col items-center justify-center",
            for: n.id,
            onClick: q[0] || (q[0] = It(() => {
            }, ["stop"]))
          }, [
            U(ye, {
              class: "w-fit rounded-full border-[6px] border-background-brand-default-hover",
              size: 20,
              "bg-color": "var(--color-background-brand-default-hover)",
              color: "var(--color-foreground-brand-default)",
              icon: "file-upload"
            }),
            y("span", oL, [
              y("span", iL, j(k(i)("browse")), 1),
              Se(" " + j(k(i)("drag")), 1)
            ])
          ], 8, nL)
        ], 34)),
        n.maxFiles !== null && n.maxFiles !== void 0 && (((de = n.modelValue) == null ? void 0 : de.length) ?? 0) >= n.maxFiles ? (v(), C("p", rL, j(k(i)("maxFilesReached", { max: n.maxFiles })), 1)) : _("", !0),
        M.value > 0 ? (v(), C("p", sL, j(k(i)("filesRejected", { count: M.value })), 1)) : _("", !0),
        T.value > 0 ? (v(), C("p", aL, j(k(i)("filesTruncated", { count: T.value, max: n.maxFiles })), 1)) : _("", !0),
        $.value > 0 && n.maxFileSize ? (v(), C("p", lL, j(k(i)("filesTooLarge", {
          count: $.value,
          size: F(n.maxFileSize)
        })), 1)) : _("", !0),
        ie.value.length > 0 ? (v(), C("div", dL, [
          (v(!0), C(re, null, De(ie.value, (ve, ae) => {
            var Ne, ne, K, ee, $e, Ze, on, An, rn, hn, Jo, Xe, wr, kr, Ga, Ri, $r, In, Ya, qa, O, A, P, G, se, ue, Ie;
            return v(), C("div", {
              key: ve.key,
              class: J([
                "border-box relative mt-2 first:mt-0 flex w-full items-center rounded-[5px] border p-4",
                n.viewOnly ? "bg-background-default" : "",
                n.validation && ((Ne = n.validation.$errors) != null && Ne.length) || ((K = (ne = n.uploadStates) == null ? void 0 : ne[ae]) == null ? void 0 : K.status) === "error" ? "border-border-danger-emphasis bg-background-danger-subtle" : "border-border-subtle bg-background-default"
              ])
            }, [
              (($e = (ee = n.uploadStates) == null ? void 0 : ee[ae]) == null ? void 0 : $e.status) === "pending" ? (v(), C("div", uL, [
                U(ye, {
                  size: 20,
                  color: "var(--color-foreground-default)",
                  icon: "clock"
                })
              ])) : ((on = (Ze = n.uploadStates) == null ? void 0 : Ze[ae]) == null ? void 0 : on.status) === "uploading" ? (v(), C("div", {
                key: 1,
                class: "relative flex h-10 w-10 flex-shrink-0 items-center justify-center",
                role: "progressbar",
                "aria-valuenow": n.uploadStates[ae].progress ?? void 0,
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                (v(), C("svg", {
                  viewBox: "0 0 40 40",
                  class: J(["h-10 w-10", { "animate-spin": n.uploadStates[ae].progress === void 0 }])
                }, [
                  q[2] || (q[2] = y("circle", {
                    cx: "20",
                    cy: "20",
                    r: "16",
                    fill: "none",
                    stroke: "var(--color-border-subtle)",
                    "stroke-width": "3"
                  }, null, -1)),
                  y("circle", {
                    cx: "20",
                    cy: "20",
                    r: "16",
                    fill: "none",
                    stroke: "var(--color-foreground-brand-default)",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-dasharray": `${2 * Math.PI * 16}`,
                    "stroke-dashoffset": `${2 * Math.PI * 16 * (1 - (n.uploadStates[ae].progress ?? 25) / 100)}`,
                    style: { transform: "rotate(-90deg)", "transform-origin": "center" }
                  }, null, 8, fL)
                ], 2)),
                n.uploadStates[ae].progress !== void 0 ? (v(), C("span", hL, j(n.uploadStates[ae].progress) + "% ", 1)) : _("", !0)
              ], 8, cL)) : W(ve, ae) ? (v(), C("img", {
                key: 2,
                class: "h-10 w-10 flex-shrink-0 rounded-[5px] object-cover",
                src: W(ve, ae) || void 0,
                alt: ve.filename
              }, null, 8, pL)) : (v(), C("div", {
                key: 3,
                class: J([
                  "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[5px]",
                  n.validation && ((An = n.validation.$errors) != null && An.length) || ((hn = (rn = n.uploadStates) == null ? void 0 : rn[ae]) == null ? void 0 : hn.status) === "error" ? "bg-background-danger-subtle" : "bg-background-subtle-hover"
                ])
              }, [
                U(ye, {
                  color: n.validation && ((Jo = n.validation.$errors) != null && Jo.length) || ((wr = (Xe = n.uploadStates) == null ? void 0 : Xe[ae]) == null ? void 0 : wr.status) === "error" ? "var(--color-foreground-danger-default)" : "var(--color-foreground-default)",
                  icon: "file-check"
                }, null, 8, ["color"])
              ], 2)),
              y("div", mL, [
                x.value === ae ? vo((v(), C("input", {
                  key: 0,
                  "onUpdate:modelValue": q[1] || (q[1] = (pe) => w.value = pe),
                  class: "block w-full truncate rounded border border-border-brand-emphasis bg-background-default px-1 text-mgm-txt-sm font-medium text-foreground-emphasis focus:outline-none",
                  type: "text",
                  onBlur: X,
                  onKeydown: [
                    Zt(It(X, ["prevent"]), ["enter"]),
                    Zt(It(Z, ["prevent"]), ["escape"])
                  ]
                }, null, 40, gL)), [
                  [m1, w.value]
                ]) : (v(), C("div", vL, [
                  y("span", {
                    class: "block min-w-0 truncate text-mgm-txt-sm font-medium text-foreground-emphasis",
                    title: b.value[ae] ?? ve.filename
                  }, j(b.value[ae] ?? ve.filename), 9, bL),
                  !n.viewOnly && ((Ga = (kr = n.uploadStates) == null ? void 0 : kr[ae]) == null ? void 0 : Ga.status) !== "uploading" ? (v(), C("button", {
                    key: 0,
                    type: "button",
                    class: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded hover:bg-background-subtle-hover focus:outline-none focus:ring-2 focus:ring-border-brand-emphasis",
                    "aria-label": k(i)("renameFile"),
                    title: k(i)("renameFile"),
                    onClick: It((pe) => Li(ae), ["stop"])
                  }, [
                    U(ye, {
                      size: 16,
                      color: "var(--color-foreground-default)",
                      "hover-color": "var(--color-foreground-brand-default)",
                      "hover-state": "",
                      icon: "edit-02"
                    })
                  ], 8, yL)) : _("", !0)
                ])),
                y("span", xL, [
                  (($r = (Ri = n.uploadStates) == null ? void 0 : Ri[ae]) == null ? void 0 : $r.status) === "pending" ? (v(), C("span", CL, j(k(i)("queued")), 1)) : ((Ya = (In = n.uploadStates) == null ? void 0 : In[ae]) == null ? void 0 : Ya.status) === "uploading" ? (v(), C("span", wL, j(n.uploadStates[ae].progress !== void 0 ? k(i)("uploadingProgress", {
                    progress: n.uploadStates[ae].progress
                  }) : k(i)("uploading")), 1)) : ((O = (qa = n.uploadStates) == null ? void 0 : qa[ae]) == null ? void 0 : O.status) === "error" ? (v(), C("span", kL, j(n.uploadStates[ae].error ?? k(i)("uploadError")), 1)) : (v(), C(re, { key: 3 }, [
                    Se(j(F(ve.size)), 1)
                  ], 64))
                ])
              ]),
              n.viewOnly && ve.url ? (v(), C("div", $L, [
                y("button", {
                  type: "button",
                  class: "cursor-pointer",
                  "aria-label": k(i)("viewFile"),
                  title: k(i)("viewFile"),
                  onClick: It((pe) => ro(ve), ["stop"])
                }, [
                  U(ye, {
                    icon: "eye",
                    color: "var(--color-foreground-default)"
                  })
                ], 8, ML),
                y("button", {
                  type: "button",
                  class: "cursor-pointer",
                  "aria-label": k(i)("downloadFile"),
                  title: k(i)("downloadFile"),
                  onClick: It((pe) => Pi(ve), ["stop"])
                }, [
                  U(ye, {
                    icon: "download",
                    color: "var(--color-foreground-default)"
                  })
                ], 8, SL)
              ])) : _("", !0),
              !n.viewOnly && ((P = (A = n.uploadStates) == null ? void 0 : A[ae]) == null ? void 0 : P.status) === "error" && ((se = (G = n.uploadStates) == null ? void 0 : G[ae]) == null ? void 0 : se.retryable) !== !1 && (((Ie = (ue = n.uploadStates) == null ? void 0 : ue[ae]) == null ? void 0 : Ie.retryCount) ?? 0) < 3 ? (v(), V(ye, {
                key: 5,
                class: "ml-4 flex-shrink-0 cursor-pointer",
                color: "var(--color-foreground-brand-default)",
                icon: "rotate-ccw",
                title: k(i)("retry"),
                onClick: It((pe) => o("file-retry", ae), ["stop"])
              }, null, 8, ["title", "onClick"])) : _("", !0),
              n.viewOnly ? _("", !0) : (v(), V(ye, {
                key: 6,
                class: "ml-4 flex-shrink-0 cursor-pointer",
                color: "var(--color-foreground-default)",
                icon: "trash",
                onClick: (pe) => Zo(ae, pe)
              }, null, 8, ["onClick"]))
            ], 2);
          }), 128))
        ])) : _("", !0),
        n.validation && ((fe = n.validation.$errors) != null && fe.length) ? (v(), V(_e, {
          key: 7,
          class: "mt-1",
          label: (Be = n.validation.$errors[0]) == null ? void 0 : Be.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ]);
    };
  }
});
function Ep(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Browse"]);
        },
        drag: (t) => {
          const { normalize: o } = t;
          return o(["or drag files here"]);
        },
        acceptedFormats: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Accepted formats: ", i(r("formats"))]);
        },
        maxFileSize: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Max size per file: ", i(r("size"))]);
        },
        maxFilesReached: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Maximum of ", i(r("max")), " files reached."]);
        },
        filesRejected: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o([i(r("count")), " file(s) were rejected (unsupported format)."]);
        },
        filesTooLarge: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o([i(r("count")), " file(s) were rejected (max size: ", i(r("size")), ")."]);
        },
        filesTruncated: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o([i(r("count")), " file(s) were not added — the ", i(r("max")), "-file limit was reached."]);
        },
        queued: (t) => {
          const { normalize: o } = t;
          return o(["Queued…"]);
        },
        renameFile: (t) => {
          const { normalize: o } = t;
          return o(["Rename file"]);
        },
        retry: (t) => {
          const { normalize: o } = t;
          return o(["Retry"]);
        },
        viewFile: (t) => {
          const { normalize: o } = t;
          return o(["View file"]);
        },
        downloadFile: (t) => {
          const { normalize: o } = t;
          return o(["Download file"]);
        },
        uploading: (t) => {
          const { normalize: o } = t;
          return o(["Uploading…"]);
        },
        uploadingProgress: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Uploading… ", i(r("progress")), "%"]);
        },
        uploadError: (t) => {
          const { normalize: o } = t;
          return o(["Upload failed"]);
        }
      },
      fr: {
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Parcourez"]);
        },
        drag: (t) => {
          const { normalize: o } = t;
          return o(["ou faites glisser des fichiers ici"]);
        },
        acceptedFormats: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Formats acceptés : ", i(r("formats"))]);
        },
        maxFileSize: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Taille maximale par fichier : ", i(r("size"))]);
        },
        maxFilesReached: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Maximum de ", i(r("max")), " fichiers atteint."]);
        },
        filesRejected: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o([i(r("count")), " fichier(s) rejeté(s) (format non supporté)."]);
        },
        filesTooLarge: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o([i(r("count")), " fichier(s) rejeté(s) (taille max : ", i(r("size")), ")."]);
        },
        filesTruncated: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o([i(r("count")), " fichier(s) non ajouté(s) — la limite de ", i(r("max")), " fichiers est atteinte."]);
        },
        queued: (t) => {
          const { normalize: o } = t;
          return o(["En attente…"]);
        },
        renameFile: (t) => {
          const { normalize: o } = t;
          return o(["Renommer le fichier"]);
        },
        retry: (t) => {
          const { normalize: o } = t;
          return o(["Réessayer"]);
        },
        viewFile: (t) => {
          const { normalize: o } = t;
          return o(["Voir le fichier"]);
        },
        downloadFile: (t) => {
          const { normalize: o } = t;
          return o(["Télécharger le fichier"]);
        },
        uploading: (t) => {
          const { normalize: o } = t;
          return o(["Envoi en cours…"]);
        },
        uploadingProgress: (t) => {
          const { normalize: o, interpolate: i, named: r } = t;
          return o(["Envoi en cours… ", i(r("progress")), "%"]);
        },
        uploadError: (t) => {
          const { normalize: o } = t;
          return o(["Échec de l'envoi"]);
        }
      }
    }
  });
}
typeof Ep == "function" && Ep(_L);
const EL = {
  key: 0,
  class: "mb-1.5"
}, OL = {
  key: 0,
  class: "flex items-start"
}, TL = {
  key: 0,
  class: "inline-flex items-center rounded-l-[4.16px] border border-r-0 border-border-default bg-background-subtle-hover px-3 text-foreground-default shadow-sm sm:text-mgm-txt-sm"
}, AL = {
  key: 2,
  class: "absolute bottom-0 left-0 top-0 flex h-full items-center"
}, IL = ["src"], DL = ["src"], NL = ["id", "autocomplete", "disabled", "name", "placeholder", "required", "type"], PL = {
  key: 5,
  class: "inline-flex items-center rounded-r-[4.16px] border border-l-0 border-border-default bg-background-subtle-hover px-3 text-foreground-default shadow-sm sm:text-mgm-txt-sm"
}, LL = ["for"], RL = { class: "inline-flex w-80 items-center justify-center rounded-r-[4.16px] border border-l-0 border-border-default bg-background-subtle-hover px-3 text-mgm-txt-sm text-foreground-default shadow-sm hover:bg-background-subtle focus:border-border-default focus:outline-none focus:ring-1 focus:ring-border-default" }, C5 = /* @__PURE__ */ H({
  __name: "FieldInput",
  props: {
    modelValue: { default: "" },
    role: { default: "default" },
    type: { default: "text" },
    id: { default: null },
    locale: { default: "en" },
    label: { default: null },
    description: { default: null },
    placeholder: { default: null },
    autocomplete: { default: null },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    validationDisabled: { type: Boolean, default: !1 },
    errorMessage: { default: null },
    customColor: { default: null },
    customRgbColor: { default: null },
    icon: { default: null },
    customIcon: { default: null },
    suffix: { default: null },
    prefix: { default: null },
    noRoundedBottom: { type: Boolean, default: !1 }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(n, { emit: e }) {
    const t = n, { t: o } = Tn(), i = R(), r = R(!1), s = e;
    We(() => f()), Ee(
      () => t.modelValue,
      () => {
        f();
      }
    );
    const a = (h) => {
      const p = h.target;
      r.value = !1, s("blur", p.value, t.id);
    }, l = (h) => {
      const p = h.target;
      r.value = !0, s("focus", p.value, t.id);
    }, d = (h) => {
      const p = h.target;
      let m = p.value;
      t.role === "email" && (m = m.replace(/\s/g, ""), p.value = m), s("change", m, t.id), s("update:modelValue", m, t.id);
    }, u = (h) => {
      h.code == "Enter" && s("submit", t.id);
    }, c = () => {
      s("update:modelValue", "", t.id);
    }, f = () => {
      if (i.value) {
        const h = i.value.querySelector("input");
        h && (t.role === "link" ? h.value = t.modelValue.replace("https://", "") : h.value = t.modelValue);
      }
    };
    return (h, p) => {
      var m, g, b, x, w, M, $, T, E, S, D, I, z, F;
      return v(), C("div", {
        ref_key: "root",
        ref: i
      }, [
        n.label || n.description ? (v(), C("div", EL, [
          n.label ? (v(), C("div", OL, [
            U(_e, {
              id: `${n.id}`,
              label: n.label
            }, null, 8, ["id", "label"]),
            n.required ? (v(), C("span", {
              key: 0,
              class: J([
                "ml-1 text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !n.customColor }
              ]),
              style: He({ color: n.customColor || void 0 })
            }, " * ", 6)) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", {
          class: J({
            relative: n.role === "search" || n.customIcon || n.icon,
            "relative flex rounded-[4.16px] shadow-sm": n.suffix || n.prefix || ["color-picker", "link"].includes(n.role)
          })
        }, [
          n.role === "link" ? (v(), C("span", TL, " https:// ")) : _("", !0),
          n.icon || n.role === "search" ? (v(), V(ye, {
            key: 1,
            class: "absolute bottom-0 left-4 top-0",
            icon: n.icon ? n.icon : "search",
            color: "var(--color-foreground-default)"
          }, null, 8, ["icon"])) : _("", !0),
          n.customIcon && !n.prefix ? (v(), C("div", AL, [
            y("img", {
              class: "ml-3 h-5 w-5",
              src: n.customIcon
            }, null, 8, IL)
          ])) : _("", !0),
          n.prefix ? (v(), C("div", {
            key: 3,
            class: J(`inline-flex items-center rounded-l-[4.16px] border !border-r-0 border-border-default bg-background-subtle-hover pl-3 text-foreground-default shadow-sm text-mgm-txt-sm gap-2 ${n.customIcon ? "pr-8" : "pr-3"}`)
          }, [
            n.customIcon ? (v(), C("img", {
              key: 0,
              class: "h-auto w-5 shrink-0 block",
              src: n.customIcon
            }, null, 8, DL)) : _("", !0),
            y("span", null, j(n.prefix), 1)
          ], 2)) : _("", !0),
          y("input", {
            id: `${n.id}`,
            class: J([
              "box-border block w-full rounded-[4.16px] py-[9px] text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle",
              (g = (m = n.validation) == null ? void 0 : m.$errors) != null && g.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default",
              n.customIcon && !n.prefix || n.icon && !n.prefix ? "px-10" : "px-2.5",
              n.customIcon && !n.prefix || n.role === "search" || n.icon && !n.prefix ? "pl-10" : "pl-2.5",
              n.customIcon && !n.prefix || n.icon && !n.prefix ? "py-2 pr-10" : "py-2 pr-2.5",
              {
                "focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": !n.customColor && !((x = (b = n.validation) == null ? void 0 : b.$errors) != null && x.length),
                "!rounded-l-none": n.role === "link",
                "!rounded-r-none": n.suffix,
                "!rounded-b-none": n.noRoundedBottom,
                invisible: n.role === "color-picker"
              },
              {
                "!rounded-l-none": n.prefix
              }
            ]),
            style: He({
              borderColor: n.customColor && r.value && !((M = (w = n.validation) == null ? void 0 : w.$errors) != null && M.length) ? n.customColor : void 0,
              boxShadow: n.customColor && r.value && !((T = ($ = n.validation) == null ? void 0 : $.$errors) != null && T.length) ? `0px 1px 2px rgba(${n.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${n.customRgbColor}, 0.2)` : void 0
            }),
            autocomplete: n.autocomplete || void 0,
            disabled: n.disabled,
            name: `${n.id}`,
            placeholder: n.placeholder || void 0,
            required: n.required,
            type: n.type,
            onBlur: a,
            onFocus: l,
            onInput: d,
            onKeypress: u
          }, null, 46, NL),
          n.role === "search" && ((E = n.modelValue) == null ? void 0 : E.length) > 0 ? (v(), V(ye, {
            key: 4,
            class: "absolute bottom-0 right-4 top-0 cursor-pointer",
            color: "var(--color-foreground-brand-default)",
            icon: "close",
            onMousedown: p[0] || (p[0] = It((Y) => c(), ["prevent"])),
            onClick: p[1] || (p[1] = It((Y) => c(), ["prevent"]))
          })) : _("", !0),
          n.suffix ? (v(), C("span", PL, j(n.suffix), 1)) : _("", !0),
          n.role === "color-picker" ? (v(), C("label", {
            key: 6,
            for: `${n.id}`,
            class: "absolute flex min-h-[28px] h-full w-full"
          }, [
            y("div", {
              class: "z-10 block w-full rounded-[4.16px] rounded-r-none border border-border-default bg-background-subtle-hover px-0 py-0 shadow-sm outline-border-brand-emphasis focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default",
              style: He({ backgroundColor: t.modelValue })
            }, null, 4),
            y("div", RL, [
              U(ye, {
                class: "pr-2",
                icon: "tag",
                color: "var(--color-foreground-default)",
                "aria-hidden": "true"
              }),
              Se(" " + j(k(o)("color")), 1)
            ])
          ], 8, LL)) : _("", !0)
        ], 2),
        ((((D = (S = n.validation) == null ? void 0 : S.$errors) == null ? void 0 : D.length) ?? 0) > 0 || n.errorMessage) && !n.validationDisabled ? (v(), V(_e, {
          key: 1,
          class: "mt-[3px]",
          label: ((F = (z = (I = n.validation) == null ? void 0 : I.$errors) == null ? void 0 : z[0]) == null ? void 0 : F.$message) || n.errorMessage,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ], 512);
    };
  }
});
function Op(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Pick a color"]);
        }
      },
      fr: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Choisir une couleur"]);
        }
      }
    }
  });
}
typeof Op == "function" && Op(C5);
const FL = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function BL(n, e) {
  var t = Array.prototype.slice.call(e);
  return t.push(FL), n.apply(this, t);
}
function Uf(n) {
  "@babel/helpers - typeof";
  return Uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Uf(n);
}
function VL(n, e, t) {
  return Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function zL(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function HL(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && Ea(n, e);
}
function jL(n) {
  var e = k5();
  return function() {
    var o = Oa(n), i;
    if (e) {
      var r = Oa(this).constructor;
      i = Reflect.construct(o, arguments, r);
    } else
      i = o.apply(this, arguments);
    return WL(this, i);
  };
}
function WL(n, e) {
  if (e && (Uf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return w5(n);
}
function w5(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Kf(n) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Kf = function(o) {
    if (o === null || !UL(o)) return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(o)) return e.get(o);
      e.set(o, i);
    }
    function i() {
      return Fl(o, arguments, Oa(this).constructor);
    }
    return i.prototype = Object.create(o.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Ea(i, o);
  }, Kf(n);
}
function Fl(n, e, t) {
  return k5() ? Fl = Reflect.construct : Fl = function(i, r, s) {
    var a = [null];
    a.push.apply(a, r);
    var l = Function.bind.apply(i, a), d = new l();
    return s && Ea(d, s.prototype), d;
  }, Fl.apply(null, arguments);
}
function k5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function UL(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function Ea(n, e) {
  return Ea = Object.setPrototypeOf || function(o, i) {
    return o.__proto__ = i, o;
  }, Ea(n, e);
}
function Oa(n) {
  return Oa = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Oa(n);
}
var Io = /* @__PURE__ */ (function(n) {
  HL(t, n);
  var e = jL(t);
  function t(o) {
    var i;
    return zL(this, t), i = e.call(this, o), Object.setPrototypeOf(w5(i), t.prototype), i.name = i.constructor.name, i;
  }
  return VL(t);
})(/* @__PURE__ */ Kf(Error)), _h = 2, KL = 17, GL = 3, no = "0-9０-９٠-٩۰-۹", YL = "-‐-―−ー－", qL = "／/", ZL = "．.", JL = "  ­​⁠　", XL = "()（）［］\\[\\]", QL = "~⁓∼～", jd = "".concat(YL).concat(qL).concat(ZL).concat(JL).concat(XL).concat(QL), Eh = "+＋";
function Tp(n, e) {
  n = n.split("-"), e = e.split("-");
  for (var t = n[0].split("."), o = e[0].split("."), i = 0; i < 3; i++) {
    var r = Number(t[i]), s = Number(o[i]);
    if (r > s) return 1;
    if (s > r) return -1;
    if (!isNaN(r) && isNaN(s)) return 1;
    if (isNaN(r) && !isNaN(s)) return -1;
  }
  return n[1] && e[1] ? n[1] > e[1] ? 1 : n[1] < e[1] ? -1 : 0 : !n[1] && e[1] ? 1 : n[1] && !e[1] ? -1 : 0;
}
var eR = {}.constructor;
function Bl(n) {
  return n != null && n.constructor === eR;
}
function Gf(n) {
  "@babel/helpers - typeof";
  return Gf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gf(n);
}
function Ru(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tR(n, e) {
  for (var t = 0; t < e.length; t++) {
    var o = e[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(n, o.key, o);
  }
}
function Fu(n, e, t) {
  return e && tR(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var nR = "1.2.0", oR = "1.7.35", Ap = " ext. ", iR = /^\d+$/, fn = /* @__PURE__ */ (function() {
  function n(e) {
    Ru(this, n), lR(e), this.metadata = e, $5.call(this, e);
  }
  return Fu(n, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var o = this.countryCallingCodes()[t];
        if (o && o.length === 1 && o[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, o) {
      if (t && iR.test(t) && (o = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new Ip(this.getCountryMetadata(t), this);
      } else if (o) {
        if (!this.hasCallingCode(o))
          throw new Error("Unknown calling code: ".concat(o));
        this.numberingPlan = new Ip(this.getNumberingPlanMetadata(o), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var o = this.countryCallingCodes()[t];
      if (o)
        return o.length === 1 && o[0].length === 3 ? void 0 : o;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var o = this.getCountryCodesForCallingCode(t);
      if (o)
        return o[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var o = this.getCountryCodeForCallingCode(t);
      if (o)
        return this.getCountryMetadata(o);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[t];
        if (i)
          return i;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), n;
})(), Ip = /* @__PURE__ */ (function() {
  function n(e, t) {
    Ru(this, n), this.globalMetadataObject = t, this.metadata = e, $5.call(this, t.metadata);
  }
  return Fu(n, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, o = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return o.map(function(i) {
        return new rR(i, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Dp(this.types(), t))
        return new aR(Dp(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Ap : this.metadata[13] || Ap;
    }
  }]), n;
})(), rR = /* @__PURE__ */ (function() {
  function n(e, t) {
    Ru(this, n), this._format = e, this.metadata = t;
  }
  return Fu(n, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !sR.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), n;
})(), sR = /^\(?\$1\)?$/, aR = /* @__PURE__ */ (function() {
  function n(e, t) {
    Ru(this, n), this.type = e, this.metadata = t;
  }
  return Fu(n, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), n;
})();
function Dp(n, e) {
  switch (e) {
    case "FIXED_LINE":
      return n[0];
    case "MOBILE":
      return n[1];
    case "TOLL_FREE":
      return n[2];
    case "PREMIUM_RATE":
      return n[3];
    case "PERSONAL_NUMBER":
      return n[4];
    case "VOICEMAIL":
      return n[5];
    case "UAN":
      return n[6];
    case "PAGER":
      return n[7];
    case "VOIP":
      return n[8];
    case "SHARED_COST":
      return n[9];
  }
}
function lR(n) {
  if (!n)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Bl(n) || !Bl(n.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Bl(n) ? "an object of shape: { " + Object.keys(n).join(", ") + " }" : "a " + dR(n) + ": " + n, "."));
}
var dR = function(e) {
  return Gf(e);
};
function Oh(n, e) {
  if (e = new fn(e), e.hasCountry(n))
    return e.country(n).countryCallingCode();
  throw new Error("Unknown country: ".concat(n));
}
function uR(n, e) {
  return e.countries.hasOwnProperty(n);
}
function $5(n) {
  var e = n.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? Tp(e, nR) === -1 ? this.v2 = !0 : Tp(e, oR) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var cR = ";ext=", Tr = function(e) {
  return "([".concat(no, "]{1,").concat(e, "})");
};
function M5(n) {
  var e = "20", t = "15", o = "9", i = "6", r = "[  \\t,]*", s = "[:\\.．]?[  \\t,-]*", a = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", c = "[  \\t]*", f = "(?:,{2}|;)", h = cR + Tr(e), p = r + l + s + Tr(e) + a, m = r + d + s + Tr(o) + a, g = u + Tr(i) + "#", b = c + f + s + Tr(t) + a, x = c + "(?:,)+" + s + Tr(o) + a;
  return h + "|" + p + "|" + m + "|" + g + "|" + b + "|" + x;
}
var fR = "[" + no + "]{" + _h + "}", hR = "[" + Eh + "]{0,1}(?:[" + jd + "]*[" + no + "]){3,}[" + jd + no + "]*", pR = new RegExp("^[" + Eh + "]{0,1}(?:[" + jd + "]*[" + no + "]){1,2}$", "i"), mR = hR + // Phone number extensions
"(?:" + M5() + ")?", gR = new RegExp(
  // Either a short two-digit-only phone number
  "^" + fR + "$|^" + mR + "$",
  "i"
);
function vR(n) {
  return n.length >= _h && gR.test(n);
}
function bR(n) {
  return pR.test(n);
}
var Np = new RegExp("(?:" + M5() + ")$", "i");
function yR(n) {
  var e = n.search(Np);
  if (e < 0)
    return {};
  for (var t = n.slice(0, e), o = n.match(Np), i = 1; i < o.length; ) {
    if (o[i])
      return {
        number: t,
        ext: o[i]
      };
    i++;
  }
}
var xR = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function CR(n) {
  return xR[n];
}
function wR(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = kR(n)) || e) {
    t && (n = t);
    var o = 0;
    return function() {
      return o >= n.length ? { done: !0 } : { done: !1, value: n[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kR(n, e) {
  if (n) {
    if (typeof n == "string") return Pp(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Pp(n, e);
  }
}
function Pp(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, o = new Array(e); t < e; t++)
    o[t] = n[t];
  return o;
}
function Lp(n) {
  for (var e = "", t = wR(n.split("")), o; !(o = t()).done; ) {
    var i = o.value;
    e += $R(i, e) || "";
  }
  return e;
}
function $R(n, e, t) {
  return n === "+" ? e ? void 0 : "+" : CR(n);
}
function Th(n, e) {
  return MR(n, void 0, e);
}
function MR(n, e, t) {
  var o = t.type(e), i = o && o.possibleLengths() || t.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  var r = n.length, s = i[0];
  return s === r ? "IS_POSSIBLE" : s > r ? "TOO_SHORT" : i[i.length - 1] < r ? "TOO_LONG" : i.indexOf(r, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function SR(n, e, t) {
  if (e === void 0 && (e = {}), t = new fn(t), e.v2) {
    if (!n.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(n.countryCallingCode);
  } else {
    if (!n.phone)
      return !1;
    if (n.country) {
      if (!t.hasCountry(n.country))
        throw new Error("Unknown country: ".concat(n.country));
      t.country(n.country);
    } else {
      if (!n.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(n.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return S5(n.phone || n.nationalNumber, t);
  if (n.countryCallingCode && t.isNonGeographicCallingCode(n.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function S5(n, e) {
  switch (Th(n, e)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function jo(n, e) {
  return n = n || "", new RegExp("^(?:" + e + ")$").test(n);
}
function _R(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = ER(n)) || e) {
    t && (n = t);
    var o = 0;
    return function() {
      return o >= n.length ? { done: !0 } : { done: !1, value: n[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ER(n, e) {
  if (n) {
    if (typeof n == "string") return Rp(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Rp(n, e);
  }
}
function Rp(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, o = new Array(e); t < e; t++)
    o[t] = n[t];
  return o;
}
var OR = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Ah(n, e, t) {
  if (e = e || {}, !(!n.country && !n.countryCallingCode)) {
    t = new fn(t), t.selectNumberingPlan(n.country, n.countryCallingCode);
    var o = e.v2 ? n.nationalNumber : n.phone;
    if (jo(o, t.nationalNumberPattern())) {
      if (Ic(o, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || Ic(o, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = _R(OR), r; !(r = i()).done; ) {
        var s = r.value;
        if (Ic(o, s, t))
          return s;
      }
    }
  }
}
function Ic(n, e, t) {
  return e = t.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(n.length) < 0 ? !1 : jo(n, e.pattern());
}
function TR(n, e, t) {
  if (e = e || {}, t = new fn(t), t.selectNumberingPlan(n.country, n.countryCallingCode), t.hasTypes())
    return Ah(n, e, t.metadata) !== void 0;
  var o = e.v2 ? n.nationalNumber : n.phone;
  return jo(o, t.nationalNumberPattern());
}
function AR(n, e, t) {
  var o = new fn(t), i = o.getCountryCodesForCallingCode(n);
  return i ? i.filter(function(r) {
    return IR(e, r, t);
  }) : [];
}
function IR(n, e, t) {
  var o = new fn(t);
  return o.selectNumberingPlan(e), o.numberingPlan.possibleLengths().indexOf(n.length) >= 0;
}
function DR(n) {
  return n.replace(new RegExp("[".concat(jd, "]+"), "g"), " ").trim();
}
var NR = /(\$\d)/;
function PR(n, e, t) {
  var o = t.useInternationalFormat, i = t.withNationalPrefix, r = n.replace(new RegExp(e.pattern()), o ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && e.nationalPrefixFormattingRule() ? e.format().replace(NR, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return o ? DR(r) : r;
}
var LR = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function RR(n, e, t) {
  var o = new fn(t);
  if (o.selectNumberingPlan(n, e), o.defaultIDDPrefix())
    return o.defaultIDDPrefix();
  if (LR.test(o.IDDPrefix()))
    return o.IDDPrefix();
}
function FR(n) {
  var e = n.number, t = n.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(t ? ";ext=" + t : "");
}
function BR(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = VR(n)) || e) {
    t && (n = t);
    var o = 0;
    return function() {
      return o >= n.length ? { done: !0 } : { done: !1, value: n[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VR(n, e) {
  if (n) {
    if (typeof n == "string") return Fp(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Fp(n, e);
  }
}
function Fp(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, o = new Array(e); t < e; t++)
    o[t] = n[t];
  return o;
}
function Bp(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function Vp(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bp(Object(t), !0).forEach(function(o) {
      zR(n, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Bp(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return n;
}
function zR(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
var zp = {
  formatExtension: function(e, t, o) {
    return "".concat(e).concat(o.ext()).concat(t);
  }
};
function HR(n, e, t, o) {
  if (t ? t = Vp(Vp({}, zp), t) : t = zp, o = new fn(o), n.country && n.country !== "001") {
    if (!o.hasCountry(n.country))
      throw new Error("Unknown country: ".concat(n.country));
    o.country(n.country);
  } else if (n.countryCallingCode)
    o.selectNumberingPlan(n.countryCallingCode);
  else return n.phone || "";
  var i = o.countryCallingCode(), r = t.v2 ? n.nationalNumber : n.phone, s;
  switch (e) {
    case "NATIONAL":
      return r ? (s = Wd(r, n.carrierCode, "NATIONAL", o, t), Dc(s, n.ext, o, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return r ? (s = Wd(r, null, "INTERNATIONAL", o, t), s = "+".concat(i, " ").concat(s), Dc(s, n.ext, o, t.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(r);
    case "RFC3966":
      return FR({
        number: "+".concat(i).concat(r),
        ext: n.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!t.fromCountry)
        return;
      var a = WR(r, n.carrierCode, i, t.fromCountry, o);
      return Dc(a, n.ext, o, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function Wd(n, e, t, o, i) {
  var r = jR(o.formats(), n);
  return r ? PR(n, r, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1)
  }) : n;
}
function jR(n, e) {
  for (var t = BR(n), o; !(o = t()).done; ) {
    var i = o.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var r = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (e.search(r) !== 0)
        continue;
    }
    if (jo(e, i.pattern()))
      return i;
  }
}
function Dc(n, e, t, o) {
  return e ? o(n, e, t) : n;
}
function WR(n, e, t, o, i) {
  var r = Oh(o, i.metadata);
  if (r === t) {
    var s = Wd(n, e, "NATIONAL", i);
    return t === "1" ? t + " " + s : s;
  }
  var a = RR(o, void 0, i.metadata);
  if (a)
    return "".concat(a, " ").concat(t, " ").concat(Wd(n, null, "INTERNATIONAL", i));
}
function Hp(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function jp(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hp(Object(t), !0).forEach(function(o) {
      UR(n, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Hp(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return n;
}
function UR(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function KR(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function GR(n, e) {
  for (var t = 0; t < e.length; t++) {
    var o = e[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(n, o.key, o);
  }
}
function YR(n, e, t) {
  return e && GR(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var qR = /* @__PURE__ */ (function() {
  function n(e, t, o) {
    if (KR(this, n), !e)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!t)
      throw new TypeError("`nationalNumber` not passed");
    if (!o)
      throw new TypeError("`metadata` not passed");
    var i = JR(e, o), r = i.country, s = i.countryCallingCode;
    this.country = r, this.countryCallingCode = s, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return o;
    };
  }
  return YR(n, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : AR(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return SR(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return TR(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new fn(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Ah(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, o) {
      return HR(this, t, o ? jp(jp({}, o), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), n;
})(), ZR = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function JR(n, e) {
  var t, o, i = new fn(e);
  return ZR(n) ? (t = n, i.selectNumberingPlan(t), o = i.countryCallingCode()) : o = n, {
    country: t,
    countryCallingCode: o
  };
}
var XR = new RegExp("([" + no + "])");
function QR(n, e, t, o) {
  if (e) {
    var i = new fn(o);
    i.selectNumberingPlan(e, t);
    var r = new RegExp(i.IDDPrefix());
    if (n.search(r) === 0) {
      n = n.slice(n.match(r)[0].length);
      var s = n.match(XR);
      if (!(s && s[1] != null && s[1].length > 0 && s[1] === "0"))
        return n;
    }
  }
}
function eF(n, e) {
  if (n && e.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), o = t.exec(n);
    if (o) {
      var i, r, s = o.length - 1, a = s > 0 && o[s];
      if (e.nationalPrefixTransformRule() && a)
        i = n.replace(t, e.nationalPrefixTransformRule()), s > 1 && (r = o[1]);
      else {
        var l = o[0];
        i = n.slice(l.length), a && (r = o[1]);
      }
      var d;
      if (a) {
        var u = n.indexOf(o[1]), c = n.slice(0, u);
        c === e.numberingPlan.nationalPrefix() && (d = e.numberingPlan.nationalPrefix());
      } else
        d = o[0];
      return {
        nationalNumber: i,
        nationalPrefix: d,
        carrierCode: r
      };
    }
  }
  return {
    nationalNumber: n
  };
}
function Yf(n, e) {
  var t = eF(n, e), o = t.carrierCode, i = t.nationalNumber;
  if (i !== n) {
    if (!tF(n, i, e))
      return {
        nationalNumber: n
      };
    if (e.possibleLengths() && !nF(i, e))
      return {
        nationalNumber: n
      };
  }
  return {
    nationalNumber: i,
    carrierCode: o
  };
}
function tF(n, e, t) {
  return !(jo(n, t.nationalNumberPattern()) && !jo(e, t.nationalNumberPattern()));
}
function nF(n, e) {
  switch (Th(n, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function oF(n, e, t, o) {
  var i = e ? Oh(e, o) : t;
  if (n.indexOf(i) === 0) {
    o = new fn(o), o.selectNumberingPlan(e, t);
    var r = n.slice(i.length), s = Yf(r, o), a = s.nationalNumber, l = Yf(n, o), d = l.nationalNumber;
    if (!jo(d, o.nationalNumberPattern()) && jo(a, o.nationalNumberPattern()) || Th(d, o) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: r
      };
  }
  return {
    number: n
  };
}
function iF(n, e, t, o) {
  if (!n)
    return {};
  var i;
  if (n[0] !== "+") {
    var r = QR(n, e, t, o);
    if (r && r !== n)
      i = !0, n = "+" + r;
    else {
      if (e || t) {
        var s = oF(n, e, t, o), a = s.countryCallingCode, l = s.number;
        if (a)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: a,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: n
      };
    }
  }
  if (n[1] === "0")
    return {};
  o = new fn(o);
  for (var d = 2; d - 1 <= GL && d <= n.length; ) {
    var u = n.slice(1, d);
    if (o.hasCallingCode(u))
      return o.selectNumberingPlan(u), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: n.slice(d)
      };
    d++;
  }
  return {};
}
function rF(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = sF(n)) || e) {
    t && (n = t);
    var o = 0;
    return function() {
      return o >= n.length ? { done: !0 } : { done: !1, value: n[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sF(n, e) {
  if (n) {
    if (typeof n == "string") return Wp(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Wp(n, e);
  }
}
function Wp(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, o = new Array(e); t < e; t++)
    o[t] = n[t];
  return o;
}
function aF(n, e) {
  var t = e.countries, o = e.defaultCountry, i = e.metadata;
  i = new fn(i);
  for (var r = [], s = rF(t), a; !(a = s()).done; ) {
    var l = a.value;
    if (i.country(l), i.leadingDigits()) {
      if (n && n.search(i.leadingDigits()) === 0)
        return l;
    } else if (Ah({
      phone: n,
      country: l
    }, void 0, i.metadata))
      if (o) {
        if (l === o)
          return l;
        r.push(l);
      } else
        return l;
  }
  if (r.length > 0)
    return r[0];
}
function lF(n, e) {
  var t = e.nationalNumber, o = e.defaultCountry, i = e.metadata, r = i.getCountryCodesForCallingCode(n);
  if (r)
    return r.length === 1 ? r[0] : aF(t, {
      countries: r,
      defaultCountry: o,
      metadata: i.metadata
    });
}
var _5 = "+", dF = "[\\-\\.\\(\\)]?", Up = "([" + no + "]|" + dF + ")", uF = "^\\" + _5 + Up + "*[" + no + "]" + Up + "*$", cF = new RegExp(uF, "g"), qf = no, fF = "[" + qf + "]+((\\-)*[" + qf + "])*", hF = "a-zA-Z", pF = "[" + hF + "]+((\\-)*[" + qf + "])*", mF = "^(" + fF + "\\.)*" + pF + "\\.?$", gF = new RegExp(mF, "g"), Kp = "tel:", Zf = ";phone-context=", vF = ";isub=";
function bF(n) {
  var e = n.indexOf(Zf);
  if (e < 0)
    return null;
  var t = e + Zf.length;
  if (t >= n.length)
    return "";
  var o = n.indexOf(";", t);
  return o >= 0 ? n.substring(t, o) : n.substring(t);
}
function yF(n) {
  return n === null ? !0 : n.length === 0 ? !1 : cF.test(n) || gF.test(n);
}
function xF(n, e) {
  var t = e.extractFormattedPhoneNumber, o = bF(n);
  if (!yF(o))
    throw new Io("NOT_A_NUMBER");
  var i;
  if (o === null)
    i = t(n) || "";
  else {
    i = "", o.charAt(0) === _5 && (i += o);
    var r = n.indexOf(Kp), s;
    r >= 0 ? s = r + Kp.length : s = 0;
    var a = n.indexOf(Zf);
    i += n.substring(s, a);
  }
  var l = i.indexOf(vF);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var CF = 250, wF = new RegExp("[" + Eh + no + "]"), kF = new RegExp("[^" + no + "#]+$");
function $F(n, e, t) {
  if (e = e || {}, t = new fn(t), e.defaultCountry && !t.hasCountry(e.defaultCountry))
    throw e.v2 ? new Io("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var o = SF(n, e.v2, e.extract), i = o.number, r = o.ext, s = o.error;
  if (!i) {
    if (e.v2)
      throw s === "TOO_SHORT" ? new Io("TOO_SHORT") : new Io("NOT_A_NUMBER");
    return {};
  }
  var a = EF(i, e.defaultCountry, e.defaultCallingCode, t), l = a.country, d = a.nationalNumber, u = a.countryCallingCode, c = a.countryCallingCodeSource, f = a.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new Io("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < _h) {
    if (e.v2)
      throw new Io("TOO_SHORT");
    return {};
  }
  if (d.length > KL) {
    if (e.v2)
      throw new Io("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var h = new qR(u, d, t.metadata);
    return l && (h.country = l), f && (h.carrierCode = f), r && (h.ext = r), h.__countryCallingCodeSource = c, h;
  }
  var p = (e.extended ? t.hasSelectedNumberingPlan() : l) ? jo(d, t.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: f,
    valid: p,
    possible: p ? !0 : !!(e.extended === !0 && t.possibleLengths() && S5(d, t)),
    phone: d,
    ext: r
  } : p ? _F(l, d, r) : {};
}
function MF(n, e, t) {
  if (n) {
    if (n.length > CF) {
      if (t)
        throw new Io("TOO_LONG");
      return;
    }
    if (e === !1)
      return n;
    var o = n.search(wF);
    if (!(o < 0))
      return n.slice(o).replace(kF, "");
  }
}
function SF(n, e, t) {
  var o = xF(n, {
    extractFormattedPhoneNumber: function(s) {
      return MF(s, t, e);
    }
  });
  if (!o)
    return {};
  if (!vR(o))
    return bR(o) ? {
      error: "TOO_SHORT"
    } : {};
  var i = yR(o);
  return i.ext ? i : {
    number: o
  };
}
function _F(n, e, t) {
  var o = {
    country: n,
    phone: e
  };
  return t && (o.ext = t), o;
}
function EF(n, e, t, o) {
  var i = iF(Lp(n), e, t, o.metadata), r = i.countryCallingCodeSource, s = i.countryCallingCode, a = i.number, l;
  if (s)
    o.selectNumberingPlan(s);
  else if (a && (e || t))
    o.selectNumberingPlan(e, t), e && (l = e), s = t || Oh(e, o.metadata);
  else return {};
  if (!a)
    return {
      countryCallingCodeSource: r,
      countryCallingCode: s
    };
  var d = Yf(Lp(a), o), u = d.nationalNumber, c = d.carrierCode, f = lF(s, {
    nationalNumber: u,
    defaultCountry: e,
    metadata: o
  });
  return f && (l = f, f === "001" || o.country(l)), {
    country: l,
    countryCallingCode: s,
    countryCallingCodeSource: r,
    nationalNumber: u,
    carrierCode: c
  };
}
function Gp(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function Yp(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gp(Object(t), !0).forEach(function(o) {
      OF(n, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Gp(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return n;
}
function OF(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function TF(n, e, t) {
  return $F(n, Yp(Yp({}, e), {}, {
    v2: !0
  }), t);
}
function qp(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function AF(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qp(Object(t), !0).forEach(function(o) {
      IF(n, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : qp(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return n;
}
function IF(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function DF(n, e) {
  return RF(n) || LF(n, e) || PF(n, e) || NF();
}
function NF() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PF(n, e) {
  if (n) {
    if (typeof n == "string") return Zp(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Zp(n, e);
  }
}
function Zp(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, o = new Array(e); t < e; t++)
    o[t] = n[t];
  return o;
}
function LF(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var o = [], i = !0, r = !1, s, a;
    try {
      for (t = t.call(n); !(i = (s = t.next()).done) && (o.push(s.value), !(e && o.length === e)); i = !0)
        ;
    } catch (l) {
      r = !0, a = l;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (r) throw a;
      }
    }
    return o;
  }
}
function RF(n) {
  if (Array.isArray(n)) return n;
}
function FF(n) {
  var e = Array.prototype.slice.call(n), t = DF(e, 4), o = t[0], i = t[1], r = t[2], s = t[3], a, l, d;
  if (typeof o == "string")
    a = o;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    s ? (l = r, d = s) : (l = void 0, d = r), i && (l = AF({
      defaultCountry: i
    }, l));
  else if (Bl(i))
    r ? (l = i, d = r) : d = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: a,
    options: l,
    metadata: d
  };
}
function Jp(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function Xp(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Jp(Object(t), !0).forEach(function(o) {
      BF(n, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Jp(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return n;
}
function BF(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function VF(n, e, t) {
  e && e.defaultCountry && !uR(e.defaultCountry, t) && (e = Xp(Xp({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return TF(n, e, t);
  } catch (o) {
    if (!(o instanceof Io)) throw o;
  }
}
function zF() {
  var n = FF(arguments), e = n.text, t = n.options, o = n.metadata;
  return VF(e, t, o);
}
function ml() {
  return BL(zF, arguments);
}
function HF(n) {
  return h1() ? (ru(n), !0) : !1;
}
function E5(n) {
  return typeof n == "function" ? n() : k(n);
}
const O5 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const jF = Object.prototype.toString, WF = (n) => jF.call(n) === "[object Object]", Vl = () => {
}, UF = /* @__PURE__ */ KF();
function KF() {
  var n, e;
  return O5 && ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Vs(n) {
  var e;
  const t = E5(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const T5 = O5 ? window : void 0;
function Nc(...n) {
  let e, t, o, i;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([t, o, i] = n, e = T5) : [e, t, o, i] = n, !e)
    return Vl;
  Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
  const r = [], s = () => {
    r.forEach((u) => u()), r.length = 0;
  }, a = (u, c, f, h) => (u.addEventListener(c, f, h), () => u.removeEventListener(c, f, h)), l = Ee(
    () => [Vs(e), E5(i)],
    ([u, c]) => {
      if (s(), !u)
        return;
      const f = WF(c) ? { ...c } : c;
      r.push(
        ...t.flatMap((h) => o.map((p) => a(u, h, p, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), s();
  };
  return HF(d), d;
}
let Qp = !1;
function A5(n, e, t = {}) {
  const { window: o = T5, ignore: i = [], capture: r = !0, detectIframe: s = !1 } = t;
  if (!o)
    return Vl;
  UF && !Qp && (Qp = !0, Array.from(o.document.body.children).forEach((f) => f.addEventListener("click", Vl)), o.document.documentElement.addEventListener("click", Vl));
  let a = !0;
  const l = (f) => i.some((h) => {
    if (typeof h == "string")
      return Array.from(o.document.querySelectorAll(h)).some((p) => p === f.target || f.composedPath().includes(p));
    {
      const p = Vs(h);
      return p && (f.target === p || f.composedPath().includes(p));
    }
  }), u = [
    Nc(o, "click", (f) => {
      const h = Vs(n);
      if (!(!h || h === f.target || f.composedPath().includes(h))) {
        if (f.detail === 0 && (a = !l(f)), !a) {
          a = !0;
          return;
        }
        e(f);
      }
    }, { passive: !0, capture: r }),
    Nc(o, "pointerdown", (f) => {
      const h = Vs(n);
      a = !l(f) && !!(h && !f.composedPath().includes(h));
    }, { passive: !0 }),
    s && Nc(o, "blur", (f) => {
      setTimeout(() => {
        var h;
        const p = Vs(n);
        ((h = o.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(p != null && p.contains(o.document.activeElement)) && e(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
const Pc = [
  {
    name: "Afghanistan",
    dialCode: "93",
    flagIcon: "🇦🇫",
    code: "AF"
  },
  {
    name: "Aland Islands",
    dialCode: "358",
    flagIcon: "🇦🇽",
    code: "AX"
  },
  {
    name: "Albania",
    dialCode: "355",
    flagIcon: "🇦🇱",
    code: "AL"
  },
  {
    name: "Algeria",
    dialCode: "213",
    flagIcon: "🇩🇿",
    code: "DZ"
  },
  {
    name: "AmericanSamoa",
    dialCode: "1684",
    flagIcon: "🇦🇸",
    code: "AS"
  },
  {
    name: "Andorra",
    dialCode: "376",
    flagIcon: "🇦🇩",
    code: "AD"
  },
  {
    name: "Angola",
    dialCode: "244",
    flagIcon: "🇦🇴",
    code: "AO"
  },
  {
    name: "Anguilla",
    dialCode: "1264",
    flagIcon: "🇦🇮",
    code: "AI"
  },
  {
    name: "Antarctica",
    dialCode: "672",
    flagIcon: "🇦🇶",
    code: "AQ"
  },
  {
    name: "Antigua and Barbuda",
    dialCode: "1268",
    flagIcon: "🇦🇬",
    code: "AG"
  },
  {
    name: "Argentina",
    dialCode: "54",
    flagIcon: "🇦🇷",
    code: "AR"
  },
  {
    name: "Armenia",
    dialCode: "374",
    flagIcon: "🇦🇲",
    code: "AM"
  },
  {
    name: "Aruba",
    dialCode: "297",
    flagIcon: "🇦🇼",
    code: "AW"
  },
  {
    name: "Australia",
    dialCode: "61",
    flagIcon: "🇦🇺",
    code: "AU"
  },
  {
    name: "Austria",
    dialCode: "43",
    flagIcon: "🇦🇹",
    code: "AT"
  },
  {
    name: "Azerbaijan",
    dialCode: "994",
    flagIcon: "🇦🇿",
    code: "AZ"
  },
  {
    name: "Bahamas",
    dialCode: "1242",
    flagIcon: "🇧🇸",
    code: "BS"
  },
  {
    name: "Bahrain",
    dialCode: "973",
    flagIcon: "🇧🇭",
    code: "BH"
  },
  {
    name: "Bangladesh",
    dialCode: "880",
    flagIcon: "🇧🇩",
    code: "BD"
  },
  {
    name: "Barbados",
    dialCode: "1246",
    flagIcon: "🇧🇧",
    code: "BB"
  },
  {
    name: "Belarus",
    dialCode: "375",
    flagIcon: "🇧🇾",
    code: "BY"
  },
  {
    name: "Belgium",
    dialCode: "32",
    flagIcon: "🇧🇪",
    code: "BE"
  },
  {
    name: "Belize",
    dialCode: "501",
    flagIcon: "🇧🇿",
    code: "BZ"
  },
  {
    name: "Benin",
    dialCode: "229",
    flagIcon: "🇧🇯",
    code: "BJ"
  },
  {
    name: "Bermuda",
    dialCode: "1441",
    flagIcon: "🇧🇲",
    code: "BM"
  },
  {
    name: "Bhutan",
    dialCode: "975",
    flagIcon: "🇧🇹",
    code: "BT"
  },
  {
    name: "Bolivia, Plurinational State of",
    dialCode: "591",
    flagIcon: "🇧🇴",
    code: "BO"
  },
  {
    name: "Bosnia and Herzegovina",
    dialCode: "387",
    flagIcon: "🇧🇦",
    code: "BA"
  },
  {
    name: "Botswana",
    dialCode: "267",
    flagIcon: "🇧🇼",
    code: "BW"
  },
  {
    name: "Brazil",
    dialCode: "55",
    flagIcon: "🇧🇷",
    code: "BR"
  },
  {
    name: "British Indian Ocean Territory",
    dialCode: "246",
    flagIcon: "🇮🇴",
    code: "IO"
  },
  {
    name: "Brunei Darussalam",
    dialCode: "673",
    flagIcon: "🇧🇳",
    code: "BN"
  },
  {
    name: "Bulgaria",
    dialCode: "359",
    flagIcon: "🇧🇬",
    code: "BG"
  },
  {
    name: "Burkina Faso",
    dialCode: "226",
    flagIcon: "🇧🇫",
    code: "BF"
  },
  {
    name: "Burundi",
    dialCode: "257",
    flagIcon: "🇧🇮",
    code: "BI"
  },
  {
    name: "Cambodia",
    dialCode: "855",
    flagIcon: "🇰🇭",
    code: "KH"
  },
  {
    name: "Cameroon",
    dialCode: "237",
    flagIcon: "🇨🇲",
    code: "CM"
  },
  {
    name: "Canada",
    dialCode: "1",
    flagIcon: "🇨🇦",
    code: "CA"
  },
  {
    name: "Cape Verde",
    dialCode: "238",
    flagIcon: "🇨🇻",
    code: "CV"
  },
  {
    name: "Cayman Islands",
    dialCode: " 345",
    flagIcon: "🇰🇾",
    code: "KY"
  },
  {
    name: "Central African Republic",
    dialCode: "236",
    flagIcon: "🇨🇫",
    code: "CF"
  },
  {
    name: "Chad",
    dialCode: "235",
    flagIcon: "🇹🇩",
    code: "TD"
  },
  {
    name: "Chile",
    dialCode: "56",
    flagIcon: "🇨🇱",
    code: "CL"
  },
  {
    name: "China",
    dialCode: "86",
    flagIcon: "🇨🇳",
    code: "CN"
  },
  {
    name: "Christmas Island",
    dialCode: "61",
    flagIcon: "🇨🇽",
    code: "CX"
  },
  {
    name: "Cocos (Keeling) Islands",
    dialCode: "61",
    flagIcon: "🇨🇨",
    code: "CC"
  },
  {
    name: "Colombia",
    dialCode: "57",
    flagIcon: "🇨🇴",
    code: "CO"
  },
  {
    name: "Comoros",
    dialCode: "269",
    flagIcon: "🇰🇲",
    code: "KM"
  },
  {
    name: "Congo",
    dialCode: "242",
    flagIcon: "🇨🇬",
    code: "CG"
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dialCode: "243",
    flagIcon: "🇨🇩",
    code: "CD"
  },
  {
    name: "Cook Islands",
    dialCode: "682",
    flagIcon: "🇨🇰",
    code: "CK"
  },
  {
    name: "Costa Rica",
    dialCode: "506",
    flagIcon: "🇨🇷",
    code: "CR"
  },
  {
    name: "Cote d'Ivoire",
    dialCode: "225",
    flagIcon: "🇨🇮",
    code: "CI"
  },
  {
    name: "Croatia",
    dialCode: "385",
    flagIcon: "🇭🇷",
    code: "HR"
  },
  {
    name: "Cuba",
    dialCode: "53",
    flagIcon: "🇨🇺",
    code: "CU"
  },
  {
    name: "Cyprus",
    dialCode: "357",
    flagIcon: "🇨🇾",
    code: "CY"
  },
  {
    name: "Czech Republic",
    dialCode: "420",
    flagIcon: "🇨🇿",
    code: "CZ"
  },
  {
    name: "Denmark",
    dialCode: "45",
    flagIcon: "🇩🇰",
    code: "DK"
  },
  {
    name: "Djibouti",
    dialCode: "253",
    flagIcon: "🇩🇯",
    code: "DJ"
  },
  {
    name: "Dominica",
    dialCode: "1767",
    flagIcon: "🇩🇲",
    code: "DM"
  },
  {
    name: "Dominican Republic",
    dialCode: "1849",
    flagIcon: "🇩🇴",
    code: "DO"
  },
  {
    name: "Ecuador",
    dialCode: "593",
    flagIcon: "🇪🇨",
    code: "EC"
  },
  {
    name: "Egypt",
    dialCode: "20",
    flagIcon: "🇪🇬",
    code: "EG"
  },
  {
    name: "El Salvador",
    dialCode: "503",
    flagIcon: "🇸🇻",
    code: "SV"
  },
  {
    name: "Equatorial Guinea",
    dialCode: "240",
    flagIcon: "🇬🇶",
    code: "GQ"
  },
  {
    name: "Eritrea",
    dialCode: "291",
    flagIcon: "🇪🇷",
    code: "ER"
  },
  {
    name: "Estonia",
    dialCode: "372",
    flagIcon: "🇪🇪",
    code: "EE"
  },
  {
    name: "Ethiopia",
    dialCode: "251",
    flagIcon: "🇪🇹",
    code: "ET"
  },
  {
    name: "Falkland Islands (Malvinas)",
    dialCode: "500",
    flagIcon: "🇫🇰",
    code: "FK"
  },
  {
    name: "Faroe Islands",
    dialCode: "298",
    flagIcon: "🇫🇴",
    code: "FO"
  },
  {
    name: "Fiji",
    dialCode: "679",
    flagIcon: "🇫🇯",
    code: "FJ"
  },
  {
    name: "Finland",
    dialCode: "358",
    flagIcon: "🇫🇮",
    code: "FI"
  },
  {
    name: "France",
    dialCode: "33",
    flagIcon: "🇫🇷",
    code: "FR"
  },
  {
    name: "French Guiana",
    dialCode: "594",
    flagIcon: "🇬🇫",
    code: "GF"
  },
  {
    name: "French Polynesia",
    dialCode: "689",
    flagIcon: "🇵🇫",
    code: "PF"
  },
  {
    name: "Gabon",
    dialCode: "241",
    flagIcon: "🇬🇦",
    code: "GA"
  },
  {
    name: "Gambia",
    dialCode: "220",
    flagIcon: "🇬🇲",
    code: "GM"
  },
  {
    name: "Georgia",
    dialCode: "995",
    flagIcon: "🇬🇪",
    code: "GE"
  },
  {
    name: "Germany",
    dialCode: "49",
    flagIcon: "🇩🇪",
    code: "DE"
  },
  {
    name: "Ghana",
    dialCode: "233",
    flagIcon: "🇬🇭",
    code: "GH"
  },
  {
    name: "Gibraltar",
    dialCode: "350",
    flagIcon: "🇬🇮",
    code: "GI"
  },
  {
    name: "Greece",
    dialCode: "30",
    flagIcon: "🇬🇷",
    code: "GR"
  },
  {
    name: "Greenland",
    dialCode: "299",
    flagIcon: "🇬🇱",
    code: "GL"
  },
  {
    name: "Grenada",
    dialCode: "1473",
    flagIcon: "🇬🇩",
    code: "GD"
  },
  {
    name: "Guadeloupe",
    dialCode: "590",
    flagIcon: "🇬🇵",
    code: "GP"
  },
  {
    name: "Guam",
    dialCode: "1671",
    flagIcon: "🇬🇺",
    code: "GU"
  },
  {
    name: "Guatemala",
    dialCode: "502",
    flagIcon: "🇬🇹",
    code: "GT"
  },
  {
    name: "Guernsey",
    dialCode: "44",
    flagIcon: "🇬🇬",
    code: "GG"
  },
  {
    name: "Guinea",
    dialCode: "224",
    flagIcon: "🇬🇳",
    code: "GN"
  },
  {
    name: "Guinea-Bissau",
    dialCode: "245",
    flagIcon: "🇬🇼",
    code: "GW"
  },
  {
    name: "Guyana",
    dialCode: "595",
    flagIcon: "🇬🇾",
    code: "GY"
  },
  {
    name: "Haiti",
    dialCode: "509",
    flagIcon: "🇭🇹",
    code: "HT"
  },
  {
    name: "Holy See (Vatican City State)",
    dialCode: "379",
    flagIcon: "🇻🇦",
    code: "VA"
  },
  {
    name: "Honduras",
    dialCode: "504",
    flagIcon: "🇭🇳",
    code: "HN"
  },
  {
    name: "Hong Kong",
    dialCode: "852",
    flagIcon: "🇭🇰",
    code: "HK"
  },
  {
    name: "Hungary",
    dialCode: "36",
    flagIcon: "🇭🇺",
    code: "HU"
  },
  {
    name: "Iceland",
    dialCode: "354",
    flagIcon: "🇮🇸",
    code: "IS"
  },
  {
    name: "India",
    dialCode: "91",
    flagIcon: "🇮🇳",
    code: "IN"
  },
  {
    name: "Indonesia",
    dialCode: "62",
    flagIcon: "🇮🇩",
    code: "ID"
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dialCode: "98",
    flagIcon: "🇮🇷",
    code: "IR"
  },
  {
    name: "Iraq",
    dialCode: "964",
    flagIcon: "🇮🇶",
    code: "IQ"
  },
  {
    name: "Ireland",
    dialCode: "353",
    flagIcon: "🇮🇪",
    code: "IE"
  },
  {
    name: "Isle of Man",
    dialCode: "44",
    flagIcon: "🇮🇲",
    code: "IM"
  },
  {
    name: "Israel",
    dialCode: "972",
    flagIcon: "🇮🇱",
    code: "IL"
  },
  {
    name: "Italy",
    dialCode: "39",
    flagIcon: "🇮🇹",
    code: "IT"
  },
  {
    name: "Jamaica",
    dialCode: "1876",
    flagIcon: "🇯🇲",
    code: "JM"
  },
  {
    name: "Japan",
    dialCode: "81",
    flagIcon: "🇯🇵",
    code: "JP"
  },
  {
    name: "Jersey",
    dialCode: "44",
    flagIcon: "🇯🇪",
    code: "JE"
  },
  {
    name: "Jordan",
    dialCode: "962",
    flagIcon: "🇯🇴",
    code: "JO"
  },
  {
    name: "Kazakhstan",
    dialCode: "77",
    flagIcon: "🇰🇿",
    code: "KZ"
  },
  {
    name: "Kenya",
    dialCode: "254",
    flagIcon: "🇰🇪",
    code: "KE"
  },
  {
    name: "Kiribati",
    dialCode: "686",
    flagIcon: "🇰🇮",
    code: "KI"
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialCode: "850",
    flagIcon: "🇰🇵",
    code: "KP"
  },
  {
    name: "Korea, Republic of South Korea",
    dialCode: "82",
    flagIcon: "🇰🇷",
    code: "KR"
  },
  {
    name: "Kuwait",
    dialCode: "965",
    flagIcon: "🇰🇼",
    code: "KW"
  },
  {
    name: "Kyrgyzstan",
    dialCode: "996",
    flagIcon: "🇰🇬",
    code: "KG"
  },
  {
    name: "Laos",
    dialCode: "856",
    flagIcon: "🇱🇦",
    code: "LA"
  },
  {
    name: "Latvia",
    dialCode: "371",
    flagIcon: "🇱🇻",
    code: "LV"
  },
  {
    name: "Lebanon",
    dialCode: "961",
    flagIcon: "🇱🇧",
    code: "LB"
  },
  {
    name: "Lesotho",
    dialCode: "266",
    flagIcon: "🇱🇸",
    code: "LS"
  },
  {
    name: "Liberia",
    dialCode: "231",
    flagIcon: "🇱🇷",
    code: "LR"
  },
  {
    name: "Libyan Arab Jamahiriya",
    dialCode: "218",
    flagIcon: "🇱🇾",
    code: "LY"
  },
  {
    name: "Liechtenstein",
    dialCode: "423",
    flagIcon: "🇱🇮",
    code: "LI"
  },
  {
    name: "Lithuania",
    dialCode: "370",
    flagIcon: "🇱🇹",
    code: "LT"
  },
  {
    name: "Luxembourg",
    dialCode: "352",
    flagIcon: "🇱🇺",
    code: "LU"
  },
  {
    name: "Macao",
    dialCode: "853",
    flagIcon: "🇲🇴",
    code: "MO"
  },
  {
    name: "Macedonia",
    dialCode: "389",
    flagIcon: "🇲🇰",
    code: "MK"
  },
  {
    name: "Madagascar",
    dialCode: "261",
    flagIcon: "🇲🇬",
    code: "MG"
  },
  {
    name: "Malawi",
    dialCode: "265",
    flagIcon: "🇲🇼",
    code: "MW"
  },
  {
    name: "Malaysia",
    dialCode: "60",
    flagIcon: "🇲🇾",
    code: "MY"
  },
  {
    name: "Maldives",
    dialCode: "960",
    flagIcon: "🇲🇻",
    code: "MV"
  },
  {
    name: "Mali",
    dialCode: "223",
    flagIcon: "🇲🇱",
    code: "ML"
  },
  {
    name: "Malta",
    dialCode: "356",
    flagIcon: "🇲🇹",
    code: "MT"
  },
  {
    name: "Marshall Islands",
    dialCode: "692",
    flagIcon: "🇲🇭",
    code: "MH"
  },
  {
    name: "Martinique",
    dialCode: "596",
    flagIcon: "🇲🇶",
    code: "MQ"
  },
  {
    name: "Mauritania",
    dialCode: "222",
    flagIcon: "🇲🇷",
    code: "MR"
  },
  {
    name: "Mauritius",
    dialCode: "230",
    flagIcon: "🇲🇺",
    code: "MU"
  },
  {
    name: "Mayotte",
    dialCode: "262",
    flagIcon: "🇾🇹",
    code: "YT"
  },
  {
    name: "Mexico",
    dialCode: "52",
    flagIcon: "🇲🇽",
    code: "MX"
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dialCode: "691",
    flagIcon: "🇫🇲",
    code: "FM"
  },
  {
    name: "Moldova",
    dialCode: "373",
    flagIcon: "🇲🇩",
    code: "MD"
  },
  {
    name: "Monaco",
    dialCode: "377",
    flagIcon: "🇲🇨",
    code: "MC"
  },
  {
    name: "Mongolia",
    dialCode: "976",
    flagIcon: "🇲🇳",
    code: "MN"
  },
  {
    name: "Montenegro",
    dialCode: "382",
    flagIcon: "🇲🇪",
    code: "ME"
  },
  {
    name: "Montserrat",
    dialCode: "1664",
    flagIcon: "🇲🇸",
    code: "MS"
  },
  {
    name: "Morocco",
    dialCode: "212",
    flagIcon: "🇲🇦",
    code: "MA"
  },
  {
    name: "Mozambique",
    dialCode: "258",
    flagIcon: "🇲🇿",
    code: "MZ"
  },
  {
    name: "Myanmar",
    dialCode: "95",
    flagIcon: "🇲🇲",
    code: "MM"
  },
  {
    name: "Namibia",
    dialCode: "264",
    flagIcon: "🇳🇦",
    code: "NA"
  },
  {
    name: "Nauru",
    dialCode: "674",
    flagIcon: "🇳🇷",
    code: "NR"
  },
  {
    name: "Nepal",
    dialCode: "977",
    flagIcon: "🇳🇵",
    code: "NP"
  },
  {
    name: "Netherlands",
    dialCode: "31",
    flagIcon: "🇳🇱",
    code: "NL"
  },
  {
    name: "Netherlands Antilles",
    dialCode: "599",
    flagIcon: "🇦🇳",
    code: "AN"
  },
  {
    name: "New Caledonia",
    dialCode: "687",
    flagIcon: "🇳🇨",
    code: "NC"
  },
  {
    name: "New Zealand",
    dialCode: "64",
    flagIcon: "🇳🇿",
    code: "NZ"
  },
  {
    name: "Nicaragua",
    dialCode: "505",
    flagIcon: "🇳🇮",
    code: "NI"
  },
  {
    name: "Niger",
    dialCode: "227",
    flagIcon: "🇳🇪",
    code: "NE"
  },
  {
    name: "Nigeria",
    dialCode: "234",
    flagIcon: "🇳🇬",
    code: "NG"
  },
  {
    name: "Niue",
    dialCode: "683",
    flagIcon: "🇳🇺",
    code: "NU"
  },
  {
    name: "Norfolk Island",
    dialCode: "672",
    flagIcon: "🇳🇫",
    code: "NF"
  },
  {
    name: "Northern Mariana Islands",
    dialCode: "1670",
    flagIcon: "🇲🇵",
    code: "MP"
  },
  {
    name: "Norway",
    dialCode: "47",
    flagIcon: "🇳🇴",
    code: "NO"
  },
  {
    name: "Oman",
    dialCode: "968",
    flagIcon: "🇴🇲",
    code: "OM"
  },
  {
    name: "Pakistan",
    dialCode: "92",
    flagIcon: "🇵🇰",
    code: "PK"
  },
  {
    name: "Palau",
    dialCode: "680",
    flagIcon: "🇵🇼",
    code: "PW"
  },
  {
    name: "Palestinian Territory, Occupied",
    dialCode: "970",
    flagIcon: "🇵🇸",
    code: "PS"
  },
  {
    name: "Panama",
    dialCode: "507",
    flagIcon: "🇵🇦",
    code: "PA"
  },
  {
    name: "Papua New Guinea",
    dialCode: "675",
    flagIcon: "🇵🇬",
    code: "PG"
  },
  {
    name: "Paraguay",
    dialCode: "595",
    flagIcon: "🇵🇾",
    code: "PY"
  },
  {
    name: "Peru",
    dialCode: "51",
    flagIcon: "🇵🇪",
    code: "PE"
  },
  {
    name: "Philippines",
    dialCode: "63",
    flagIcon: "🇵🇭",
    code: "PH"
  },
  {
    name: "Pitcairn",
    dialCode: "872",
    flagIcon: "🇵🇳",
    code: "PN"
  },
  {
    name: "Poland",
    dialCode: "48",
    flagIcon: "🇵🇱",
    code: "PL"
  },
  {
    name: "Portugal",
    dialCode: "351",
    flagIcon: "🇵🇹",
    code: "PT"
  },
  {
    name: "Puerto Rico",
    dialCode: "1939",
    flagIcon: "🇵🇷",
    code: "PR"
  },
  {
    name: "Qatar",
    dialCode: "974",
    flagIcon: "🇶🇦",
    code: "QA"
  },
  {
    name: "Romania",
    dialCode: "40",
    flagIcon: "🇷🇴",
    code: "RO"
  },
  {
    name: "Russia",
    dialCode: "7",
    flagIcon: "🇷🇺",
    code: "RU"
  },
  {
    name: "Rwanda",
    dialCode: "250",
    flagIcon: "🇷🇼",
    code: "RW"
  },
  {
    name: "Reunion",
    dialCode: "262",
    flagIcon: "🇷🇪",
    code: "RE"
  },
  {
    name: "Saint Barthelemy",
    dialCode: "590",
    flagIcon: "🇧🇱",
    code: "BL"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dialCode: "290",
    flagIcon: "🇸🇭",
    code: "SH"
  },
  {
    name: "Saint Kitts and Nevis",
    dialCode: "1869",
    flagIcon: "🇰🇳",
    code: "KN"
  },
  {
    name: "Saint Lucia",
    dialCode: "1758",
    flagIcon: "🇱🇨",
    code: "LC"
  },
  {
    name: "Saint Martin",
    dialCode: "590",
    flagIcon: "🇲🇫",
    code: "MF"
  },
  {
    name: "Saint Pierre and Miquelon",
    dialCode: "508",
    flagIcon: "🇵🇲",
    code: "PM"
  },
  {
    name: "Saint Vincent and the Grenadines",
    dialCode: "1784",
    flagIcon: "🇻🇨",
    code: "VC"
  },
  {
    name: "Samoa",
    dialCode: "685",
    flagIcon: "🇼🇸",
    code: "WS"
  },
  {
    name: "San Marino",
    dialCode: "378",
    flagIcon: "🇸🇲",
    code: "SM"
  },
  {
    name: "Sao Tome and Principe",
    dialCode: "239",
    flagIcon: "🇸🇹",
    code: "ST"
  },
  {
    name: "Saudi Arabia",
    dialCode: "966",
    flagIcon: "🇸🇦",
    code: "SA"
  },
  {
    name: "Senegal",
    dialCode: "221",
    flagIcon: "🇸🇳",
    code: "SN"
  },
  {
    name: "Serbia",
    dialCode: "381",
    flagIcon: "🇷🇸",
    code: "RS"
  },
  {
    name: "Seychelles",
    dialCode: "248",
    flagIcon: "🇸🇨",
    code: "SC"
  },
  {
    name: "Sierra Leone",
    dialCode: "232",
    flagIcon: "🇸🇱",
    code: "SL"
  },
  {
    name: "Singapore",
    dialCode: "65",
    flagIcon: "🇸🇬",
    code: "SG"
  },
  {
    name: "Slovakia",
    dialCode: "421",
    flagIcon: "🇸🇰",
    code: "SK"
  },
  {
    name: "Slovenia",
    dialCode: "386",
    flagIcon: "🇸🇮",
    code: "SI"
  },
  {
    name: "Solomon Islands",
    dialCode: "677",
    flagIcon: "🇸🇧",
    code: "SB"
  },
  {
    name: "Somalia",
    dialCode: "252",
    flagIcon: "🇸🇴",
    code: "SO"
  },
  {
    name: "South Africa",
    dialCode: "27",
    flagIcon: "🇿🇦",
    code: "ZA"
  },
  {
    name: "South Sudan",
    dialCode: "211",
    flagIcon: "🇸🇸",
    code: "SS"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dialCode: "500",
    flagIcon: "🇬🇸",
    code: "GS"
  },
  {
    name: "Spain",
    dialCode: "34",
    flagIcon: "🇪🇸",
    code: "ES"
  },
  {
    name: "Sri Lanka",
    dialCode: "94",
    flagIcon: "🇱🇰",
    code: "LK"
  },
  {
    name: "Sudan",
    dialCode: "249",
    flagIcon: "🇸🇩",
    code: "SD"
  },
  {
    name: "Suriname",
    dialCode: "597",
    flagIcon: "🇸🇷",
    code: "SR"
  },
  {
    name: "Svalbard and Jan Mayen",
    dialCode: "47",
    flagIcon: "🇸🇯",
    code: "SJ"
  },
  {
    name: "Swaziland",
    dialCode: "268",
    flagIcon: "🇸🇿",
    code: "SZ"
  },
  {
    name: "Sweden",
    dialCode: "46",
    flagIcon: "🇸🇪",
    code: "SE"
  },
  {
    name: "Switzerland",
    dialCode: "41",
    flagIcon: "🇨🇭",
    code: "CH"
  },
  {
    name: "Syrian Arab Republic",
    dialCode: "963",
    flagIcon: "🇸🇾",
    code: "SY"
  },
  {
    name: "Taiwan",
    dialCode: "886",
    flagIcon: "🇹🇼",
    code: "TW"
  },
  {
    name: "Tajikistan",
    dialCode: "992",
    flagIcon: "🇹🇯",
    code: "TJ"
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dialCode: "255",
    flagIcon: "🇹🇿",
    code: "TZ"
  },
  {
    name: "Thailand",
    dialCode: "66",
    flagIcon: "🇹🇭",
    code: "TH"
  },
  {
    name: "Timor-Leste",
    dialCode: "670",
    flagIcon: "🇹🇱",
    code: "TL"
  },
  {
    name: "Togo",
    dialCode: "228",
    flagIcon: "🇹🇬",
    code: "TG"
  },
  {
    name: "Tokelau",
    dialCode: "690",
    flagIcon: "🇹🇰",
    code: "TK"
  },
  {
    name: "Tonga",
    dialCode: "676",
    flagIcon: "🇹🇴",
    code: "TO"
  },
  {
    name: "Trinidad and Tobago",
    dialCode: "1868",
    flagIcon: "🇹🇹",
    code: "TT"
  },
  {
    name: "Tunisia",
    dialCode: "216",
    flagIcon: "🇹🇳",
    code: "TN"
  },
  {
    name: "Turkey",
    dialCode: "90",
    flagIcon: "🇹🇷",
    code: "TR"
  },
  {
    name: "Turkmenistan",
    dialCode: "993",
    flagIcon: "🇹🇲",
    code: "TM"
  },
  {
    name: "Turks and Caicos Islands",
    dialCode: "1649",
    flagIcon: "🇹🇨",
    code: "TC"
  },
  {
    name: "Tuvalu",
    dialCode: "688",
    flagIcon: "🇹🇻",
    code: "TV"
  },
  {
    name: "Uganda",
    dialCode: "256",
    flagIcon: "🇺🇬",
    code: "UG"
  },
  {
    name: "Ukraine",
    dialCode: "380",
    flagIcon: "🇺🇦",
    code: "UA"
  },
  {
    name: "United Arab Emirates",
    dialCode: "971",
    flagIcon: "🇦🇪",
    code: "AE"
  },
  {
    name: "United Kingdom",
    dialCode: "44",
    flagIcon: "🇬🇧",
    code: "GB"
  },
  {
    name: "United States",
    dialCode: "1",
    flagIcon: "🇺🇸",
    code: "US"
  },
  {
    name: "Uruguay",
    dialCode: "598",
    flagIcon: "🇺🇾",
    code: "UY"
  },
  {
    name: "Uzbekistan",
    dialCode: "998",
    flagIcon: "🇺🇿",
    code: "UZ"
  },
  {
    name: "Vanuatu",
    dialCode: "678",
    flagIcon: "🇻🇺",
    code: "VU"
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dialCode: "58",
    flagIcon: "🇻🇪",
    code: "VE"
  },
  {
    name: "Vietnam",
    dialCode: "84",
    flagIcon: "🇻🇳",
    code: "VN"
  },
  {
    name: "Virgin Islands, British",
    dialCode: "1284",
    flagIcon: "🇻🇬",
    code: "VG"
  },
  {
    name: "Virgin Islands, U.S.",
    dialCode: "1340",
    flagIcon: "🇻🇮",
    code: "VI"
  },
  {
    name: "Wallis and Futuna",
    dialCode: "681",
    flagIcon: "🇼🇫",
    code: "WF"
  },
  {
    name: "Yemen",
    dialCode: "967",
    flagIcon: "🇾🇪",
    code: "YE"
  },
  {
    name: "Zambia",
    dialCode: "260",
    flagIcon: "🇿🇲",
    code: "ZM"
  },
  {
    name: "Zimbabwe",
    dialCode: "263",
    flagIcon: "🇿🇼",
    code: "ZW"
  }
], GF = {
  key: 0,
  class: "mb-1.5"
}, YF = {
  key: 0,
  class: "flex items-start"
}, qF = { class: "relative rounded-[4.16px] shadow-[0px_1px_2px_rgba(28,31,39,0.05)]" }, ZF = { class: "w-4" }, JF = ["onClick", "onMouseenter", "onMouseleave"], XF = ["id", "value", "disabled", "name", "placeholder", "required"], QF = /* @__PURE__ */ H({
  __name: "FieldPhoneNumber",
  props: {
    modelValue: { default: "" },
    id: { default: null },
    locale: { default: "en" },
    label: { default: null },
    description: { default: null },
    placeholder: { default: null },
    autocomplete: { default: null },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    validationDisabled: { type: Boolean, default: !1 },
    errorMessage: { default: null },
    customColor: { default: null },
    customRgbColor: { default: null }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(n, { emit: e }) {
    const t = n, { t: o } = Tn(), i = R(), r = R(null), s = Zr(/* @__PURE__ */ new Map()), a = R(!1), l = Pc.find(
      (E) => E.code === "FR"
    ), d = Zr({
      code: (l == null ? void 0 : l.code) || "",
      flagIcon: (l == null ? void 0 : l.flagIcon) || "",
      name: (l == null ? void 0 : l.name) || "",
      dialCode: (l == null ? void 0 : l.dialCode) || ""
    }), u = R(!1), c = L(() => d), f = L(() => {
      if (t.modelValue) {
        const E = ml(t.modelValue);
        return (E == null ? void 0 : E.formatNational()) || t.modelValue;
      }
      return t.modelValue || "";
    }), h = e;
    We(() => T()), Ee(
      () => t.modelValue,
      (E) => {
        if (E) {
          const S = ml(E);
          if (S && S.country) {
            const D = Pc.find(
              (I) => I.code === S.country
            );
            D && (d.code = D.code, d.flagIcon = D.flagIcon, d.name = D.name, d.dialCode = D.dialCode);
          }
        }
      },
      { immediate: !0 }
    );
    const p = (E) => {
      s.set(E, !0);
    }, m = (E) => {
      s.set(E, !1);
    }, g = (E) => {
      var D;
      const S = E.target;
      ((D = t.modelValue) == null ? void 0 : D.length) === 0 && (a.value = !1), h("blur", S.value, t.id);
    }, b = (E) => {
      const S = E.target;
      a.value = !0, h("focus", S.value, t.id);
    }, x = (E) => {
      let D = E.target.value;
      const I = ml(
        D,
        d.code
      );
      I && (D = I.number), h("change", D, t.id), h(
        "update:modelValue",
        (I == null ? void 0 : I.formatInternational()) || D,
        t.id
      );
    }, w = (E) => {
      ["+", "-", "e", "E"].includes(E.key) && E.preventDefault(), E.code == "Enter" && h("submit", t.id);
    }, M = () => {
      u.value = !u.value;
    }, $ = (E) => {
      d.code = E.code, d.flagIcon = E.flagIcon, d.name = E.name, d.dialCode = E.dialCode, u.value = !1, T();
    }, T = () => {
      if (i.value) {
        const E = i.value.querySelector("input");
        if (E)
          if (d.code) {
            const S = ml(
              E.value,
              d.code
            );
            h("update:modelValue", S == null ? void 0 : S.number, t.id), E.value = (S == null ? void 0 : S.formatNational()) || E.value;
          } else
            E.value = t.modelValue || "";
      }
    };
    return A5(r, (E) => {
      E.stopPropagation(), u.value && (u.value = !1);
    }), (E, S) => {
      var D, I, z, F, Y, ie, W, te, ce, we, ke, rt, ut;
      return v(), C("div", {
        ref_key: "root",
        ref: i
      }, [
        n.label || n.description ? (v(), C("div", GF, [
          n.label ? (v(), C("div", YF, [
            U(_e, {
              id: `${n.id}`,
              label: n.label
            }, null, 8, ["id", "label"]),
            n.required ? (v(), C("span", {
              key: 0,
              class: J([
                "ml-1 text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !n.customColor }
              ]),
              style: He({ color: n.customColor || void 0 })
            }, " * ", 6)) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", qF, [
          y("div", {
            class: "flex items-center justify-center absolute top-0 bottom-0 px-3 left-0 font-normal text-mgm-txt-sm text-foreground-subtle",
            onClick: M
          }, [
            y("div", ZF, j(c.value.flagIcon), 1),
            U(ye, {
              class: "ml-1 mr-2.5",
              icon: u.value ? "chevron-up" : "chevron-down",
              color: "var(--color-foreground-default)"
            }, null, 8, ["icon"]),
            Se(" " + j(`+${c.value.dialCode}`), 1)
          ]),
          u.value ? (v(), C("div", {
            key: 0,
            ref_key: "dropdownRef",
            ref: r,
            class: "absolute z-10 rounded-b-[4.16px] py-1 right-0 left-0 h-48 overflow-auto mt-8 border-[0.83px] border-border-default bg-background-default text-mgm-txt-sm text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0"
          }, [
            (v(!0), C(re, null, De(k(Pc), (it) => (v(), C("li", {
              class: J([
                "truncate  cursor-pointer select-none list-none py-1 pl-3 pr-9",
                s.get(it.code) ? "text-foreground-on-emphasis" : "text-foreground-emphasis",
                ,
                s.get(it.code) && !n.customColor ? "bg-background-brand-emphasis" : "bg-background-default"
              ]),
              style: He({
                backgroundColor: s.get(it.code) && n.customColor ? n.customColor : void 0
              }),
              key: it.code,
              onClick: (Ut) => $(it),
              onMouseenter: (Ut) => p(it.code),
              onMouseleave: (Ut) => m(it.code)
            }, j(`${it.flagIcon} ${it.name} +${it.dialCode}`), 47, JF))), 128))
          ], 512)) : _("", !0),
          y("input", {
            id: `${n.id}`,
            class: J([
              "box-border block w-full pr-2.5 py-2 pl-[100px]  rounded-[4.16px] text-mgm-txt-sm font-normal text-foreground-emphasis outline-0 placeholder:text-foreground-subtle",
              (I = (D = n.validation) == null ? void 0 : D.$errors) != null && I.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default",
              {
                "focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": !n.customColor && !((F = (z = n.validation) == null ? void 0 : z.$errors) != null && F.length)
              }
            ]),
            style: He({
              borderColor: n.customColor && a.value && !((ie = (Y = n.validation) == null ? void 0 : Y.$errors) != null && ie.length) ? n.customColor : void 0,
              boxShadow: n.customColor && a.value && !((te = (W = n.validation) == null ? void 0 : W.$errors) != null && te.length) ? `0px 1px 2px rgba(${n.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${n.customRgbColor}, 0.2)` : void 0
            }),
            value: f.value,
            autocomplete: "tel-national",
            disabled: n.disabled,
            name: `${n.id}`,
            placeholder: n.placeholder || void 0,
            required: n.required,
            type: "tel-national",
            onBlur: g,
            onFocus: b,
            onInput: x,
            onKeypress: w
          }, null, 46, XF)
        ]),
        ((((we = (ce = n.validation) == null ? void 0 : ce.$errors) == null ? void 0 : we.length) ?? 0) > 0 || n.errorMessage) && !n.validationDisabled ? (v(), V(_e, {
          key: 1,
          class: "mt-[3px]",
          label: ((ut = (rt = (ke = n.validation) == null ? void 0 : ke.$errors) == null ? void 0 : rt[0]) == null ? void 0 : ut.$message) || n.errorMessage,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ], 512);
    };
  }
});
function em(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        country: (t) => {
          const { normalize: o } = t;
          return o(["Country"]);
        },
        color: (t) => {
          const { normalize: o } = t;
          return o(["Pick a color"]);
        }
      },
      fr: {
        country: (t) => {
          const { normalize: o } = t;
          return o(["Pays"]);
        },
        color: (t) => {
          const { normalize: o } = t;
          return o(["Choisir une couleur"]);
        }
      }
    }
  });
}
typeof em == "function" && em(QF);
const eB = ["onClick", "onKeyup"], tB = ["for"], nB = ["for"], oB = ["innerHTML"], iB = ["id", "checked", "disabled", "name", "required", "onInput"], rB = ["onClick", "onKeyup"], sB = ["id", "checked", "disabled", "name", "required", "onInput"], aB = ["for"], lB = ["for"], dB = ["innerHTML"], lY = /* @__PURE__ */ H({
  __name: "FieldRadio",
  props: {
    modelValue: { default: null },
    id: {},
    options: {},
    type: { default: "default" },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    disabled: { type: Boolean, default: !1 },
    direction: { default: "flex-col" },
    gap: { default: "gap-0" },
    reverse: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = (r) => {
      o("update:modelValue", r);
    };
    return (r, s) => {
      var l, d;
      const a = f1("tooltip");
      return v(), C(re, null, [
        y("div", {
          class: J(["flex", [t.direction, t.gap]])
        }, [
          n.reverse ? (v(!0), C(re, { key: 0 }, De(n.options, (u) => (v(), C("div", {
            key: u.value,
            tabindex: "0",
            class: J([
              "flex justify-between cursor-pointer w-full",
              n.type !== "default" && n.modelValue === u.value ? "border-border-brand-emphasis bg-background-brand-default" : "border-border-default bg-background-default",
              {
                "rounded-[5px] border-[1px] px-4 focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": n.type !== "default",
                "py-2": n.type === "simple",
                "py-3": n.type === "expanded",
                "mb-2": n.type === "default",
                "items-center": !u.description
              }
            ]),
            onClick: (c) => i(u.value),
            onKeyup: [
              Zt((c) => i(u.value), ["enter"]),
              Zt((c) => i(u.value), ["space"])
            ]
          }, [
            u.label || u.description ? (v(), C("label", {
              key: 0,
              for: u.value,
              class: J([
                "cursor-pointer",
                u.inlineDescription ? "flex gap-2" : ""
              ])
            }, [
              u.label ? (v(), C("span", {
                key: 0,
                for: n.id,
                class: "flex text-mgm-txt-sm font-medium text-foreground-emphasis"
              }, [
                Se(j(u.label) + " ", 1),
                u.tooltip ? vo((v(), V(ye, {
                  key: 0,
                  class: "ml-2",
                  color: "var(--color-foreground-default)",
                  icon: "help-circle"
                }, null, 512)), [
                  [a, u.tooltip]
                ]) : _("", !0)
              ], 8, nB)) : _("", !0),
              u.description ? (v(), C("span", {
                key: 1,
                class: "block text-mgm-txt-sm font-normal text-foreground-default",
                innerHTML: u.description
              }, null, 8, oB)) : _("", !0)
            ], 10, tB)) : _("", !0),
            y("input", {
              id: u.value,
              tabindex: "-1",
              class: J([
                "h-4 w-4 shrink-0 cursor-pointer rounded border-border-subtle text-foreground-brand-default accent-background-brand-emphasis",
                { "mt-0.5": u.description },
                { "mt-1": n.type === "default" }
              ]),
              checked: n.modelValue === u.value,
              disabled: n.disabled,
              name: u.value,
              required: n.required,
              type: "radio",
              onInput: (c) => i(u.value)
            }, null, 42, iB)
          ], 42, eB))), 128)) : (v(!0), C(re, { key: 1 }, De(n.options, (u) => (v(), C("div", {
            key: u.value,
            tabindex: "0",
            class: J([
              "flex cursor-pointer w-full",
              n.type !== "default" && n.modelValue === u.value ? "border-border-brand-emphasis bg-background-brand-default" : "border-border-default bg-background-default",
              {
                "rounded-[5px] border-[1px] px-4 focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": n.type !== "default",
                "py-2": n.type === "simple",
                "py-3": n.type === "expanded",
                "mb-2": n.type === "default",
                "items-center": !u.description
              }
            ]),
            onClick: (c) => i(u.value),
            onKeyup: [
              Zt((c) => i(u.value), ["enter"]),
              Zt((c) => i(u.value), ["space"])
            ]
          }, [
            y("input", {
              id: u.value,
              tabindex: "-1",
              class: J([
                "h-4 w-4 shrink-0 cursor-pointer rounded border-border-subtle text-foreground-brand-default accent-background-brand-emphasis",
                { "mt-0.5": u.description },
                { "mt-1": n.type === "default" }
              ]),
              checked: n.modelValue === u.value,
              disabled: n.disabled,
              name: u.value,
              required: n.required,
              type: "radio",
              onInput: (c) => i(u.value)
            }, null, 42, sB),
            u.label || u.description ? (v(), C("label", {
              key: 0,
              for: u.value,
              class: J([
                "cursor-pointer ml-3",
                n.type === "expanded" ? "ml-3" : "ml-2",
                u.inlineDescription ? "flex gap-2" : ""
              ])
            }, [
              u.label ? (v(), C("span", {
                key: 0,
                for: n.id,
                class: "flex text-mgm-txt-sm font-medium text-foreground-emphasis"
              }, [
                Se(j(u.label) + " ", 1),
                u.tooltip ? vo((v(), V(ye, {
                  key: 0,
                  class: "ml-2",
                  color: "var(--color-foreground-default)",
                  icon: "help-circle"
                }, null, 512)), [
                  [a, u.tooltip]
                ]) : _("", !0)
              ], 8, lB)) : _("", !0),
              u.description ? (v(), C("span", {
                key: 1,
                class: "block text-mgm-txt-sm font-normal text-foreground-default",
                innerHTML: u.description
              }, null, 8, dB)) : _("", !0)
            ], 10, aB)) : _("", !0)
          ], 42, rB))), 128))
        ], 2),
        n.validation && ((l = n.validation.$errors) != null && l.length) ? (v(), V(_e, {
          key: 0,
          class: "mt-[3px]",
          label: (d = n.validation.$errors[0]) == null ? void 0 : d.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ], 64);
    };
  }
}), uB = {
  key: 0,
  class: "mb-1.5"
}, cB = {
  key: 0,
  class: "flex items-start"
}, fB = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, hB = { class: "grid grid-cols-2 gap-2" }, pB = ["onClick"], mB = { class: "text-mgm-dspl-md" }, dY = /* @__PURE__ */ H({
  __name: "FieldRating",
  props: {
    modelValue: { default: null },
    id: { default: null },
    ratings: { default: () => [] },
    label: { default: null },
    description: { default: null },
    required: { type: Boolean, default: !1 },
    validation: { default: null }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const { t } = Tn(), o = e, i = (r) => {
      o("update:modelValue", r);
    };
    return (r, s) => {
      var a, l;
      return v(), C("div", null, [
        n.label || n.description ? (v(), C("div", uB, [
          n.label ? (v(), C("div", cB, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", fB, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", hB, [
          (v(!0), C(re, null, De(n.ratings, (d) => (v(), C("div", {
            key: d.value,
            class: J([{
              "border-border-brand-emphasis bg-background-brand-default-hover ": n.modelValue == d.value,
              "border-border-default ": n.modelValue != d.value
            }, "flex flex-1 cursor-pointer flex-col content-center items-center justify-center rounded-[5px] border py-2 text-mgm-txt-sm"]),
            "data-cy": "btn-rate",
            onClick: (u) => i(d.value)
          }, [
            y("span", mB, j(d.emoji), 1),
            Se(" " + j(k(t)(d.label)), 1)
          ], 10, pB))), 128))
        ]),
        n.validation && ((a = n.validation.$errors) != null && a.length) ? (v(), V(_e, {
          key: 1,
          class: "mt-[3px]",
          label: (l = n.validation.$errors[0]) == null ? void 0 : l.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ]);
    };
  }
});
function Ar(n, e, t) {
  let o = t.initialDeps ?? [], i, r = !0;
  function s() {
    var a, l, d;
    let u;
    t.key && ((a = t.debug) != null && a.call(t)) && (u = Date.now());
    const c = n();
    if (!(c.length !== o.length || c.some((p, m) => o[m] !== p)))
      return i;
    o = c;
    let h;
    if (t.key && ((l = t.debug) != null && l.call(t)) && (h = Date.now()), i = e(...c), t.key && ((d = t.debug) != null && d.call(t))) {
      const p = Math.round((Date.now() - u) * 100) / 100, m = Math.round((Date.now() - h) * 100) / 100, g = m / 16, b = (x, w) => {
        for (x = String(x); x.length < w; )
          x = " " + x;
        return x;
      };
      console.info(
        `%c⏱ ${b(m, 5)} /${b(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(r && t.skipInitialOnChange) && t.onChange(i), r = !1, i;
  }
  return s.updateDeps = (a) => {
    o = a;
  }, s;
}
function tm(n, e) {
  if (n === void 0)
    throw new Error("Unexpected undefined");
  return n;
}
const gB = (n, e) => Math.abs(n - e) < 1.01, vB = (n, e, t) => {
  let o;
  return function(...i) {
    n.clearTimeout(o), o = n.setTimeout(() => e.apply(this, i), t);
  };
}, nm = (n) => {
  const { offsetWidth: e, offsetHeight: t } = n;
  return { width: e, height: t };
}, bB = (n) => n, yB = (n) => {
  const e = Math.max(n.startIndex - n.overscan, 0), t = Math.min(n.endIndex + n.overscan, n.count - 1), o = [];
  for (let i = e; i <= t; i++)
    o.push(i);
  return o;
}, xB = (n, e) => {
  const t = n.scrollElement;
  if (!t)
    return;
  const o = n.targetWindow;
  if (!o)
    return;
  const i = (s) => {
    const { width: a, height: l } = s;
    e({ width: Math.round(a), height: Math.round(l) });
  };
  if (i(nm(t)), !o.ResizeObserver)
    return () => {
    };
  const r = new o.ResizeObserver((s) => {
    const a = () => {
      const l = s[0];
      if (l != null && l.borderBoxSize) {
        const d = l.borderBoxSize[0];
        if (d) {
          i({ width: d.inlineSize, height: d.blockSize });
          return;
        }
      }
      i(nm(t));
    };
    n.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
  });
  return r.observe(t, { box: "border-box" }), () => {
    r.unobserve(t);
  };
}, om = {
  passive: !0
}, im = typeof window > "u" ? !0 : "onscrollend" in window, CB = (n, e) => {
  const t = n.scrollElement;
  if (!t)
    return;
  const o = n.targetWindow;
  if (!o)
    return;
  let i = 0;
  const r = n.options.useScrollendEvent && im ? () => {
  } : vB(
    o,
    () => {
      e(i, !1);
    },
    n.options.isScrollingResetDelay
  ), s = (u) => () => {
    const { horizontal: c, isRtl: f } = n.options;
    i = c ? t.scrollLeft * (f && -1 || 1) : t.scrollTop, r(), e(i, u);
  }, a = s(!0), l = s(!1);
  l(), t.addEventListener("scroll", a, om);
  const d = n.options.useScrollendEvent && im;
  return d && t.addEventListener("scrollend", l, om), () => {
    t.removeEventListener("scroll", a), d && t.removeEventListener("scrollend", l);
  };
}, wB = (n, e, t) => {
  if (e != null && e.borderBoxSize) {
    const o = e.borderBoxSize[0];
    if (o)
      return Math.round(
        o[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return n[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, kB = (n, {
  adjustments: e = 0,
  behavior: t
}, o) => {
  var i, r;
  const s = n + e;
  (r = (i = o.scrollElement) == null ? void 0 : i.scrollTo) == null || r.call(i, {
    [o.options.horizontal ? "left" : "top"]: s,
    behavior: t
  });
};
class $B {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const o = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((r) => {
          const s = () => {
            this._measureElement(r.target, r);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = o()) == null || i.disconnect(), t = null;
        },
        observe: (i) => {
          var r;
          return (r = o()) == null ? void 0 : r.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var r;
          return (r = o()) == null ? void 0 : r.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([o, i]) => {
        typeof i > "u" && delete t[o];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: bB,
        rangeExtractor: yB,
        onChange: () => {
        },
        measureElement: wB,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var o, i;
      (i = (o = this.options).onChange) == null || i.call(o, this, t);
    }, this.maybeNotify = Ar(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const o = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== o) {
        if (this.cleanup(), !o) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = o, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, r) => {
            this.scrollAdjustments = 0, this.scrollDirection = r ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = r, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, o) => {
      const i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
      for (let s = o - 1; s >= 0; s--) {
        const a = t[s];
        if (i.has(a.lane))
          continue;
        const l = r.get(
          a.lane
        );
        if (l == null || a.end > l.end ? r.set(a.lane, a) : a.end < l.end && i.set(a.lane, !0), i.size === this.options.lanes)
          break;
      }
      return r.size === this.options.lanes ? Array.from(r.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Ar(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, o, i, r, s, a) => (this.prevLanes !== void 0 && this.prevLanes !== a && (this.lanesChangedFlag = !0), this.prevLanes = a, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: o,
        scrollMargin: i,
        getItemKey: r,
        enabled: s,
        lanes: a
      }),
      {
        key: !1,
        skipInitialOnChange: !0,
        onChange: () => {
          this.notify(this.isScrolling);
        }
      }
    ), this.getMeasurements = Ar(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: o, scrollMargin: i, getItemKey: r, enabled: s, lanes: a }, l) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const f of this.laneAssignments.keys())
            f >= t && this.laneAssignments.delete(f);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((f) => {
          this.itemSizeCache.set(f.key, f.size);
        }));
        const d = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const u = this.measurementsCache.slice(0, d), c = new Array(a).fill(
          void 0
        );
        for (let f = 0; f < d; f++) {
          const h = u[f];
          h && (c[h.lane] = f);
        }
        for (let f = d; f < t; f++) {
          const h = r(f), p = this.laneAssignments.get(f);
          let m, g;
          if (p !== void 0 && this.options.lanes > 1) {
            m = p;
            const M = c[m], $ = M !== void 0 ? u[M] : void 0;
            g = $ ? $.end + this.options.gap : o + i;
          } else {
            const M = this.options.lanes === 1 ? u[f - 1] : this.getFurthestMeasurement(u, f);
            g = M ? M.end + this.options.gap : o + i, m = M ? M.lane : f % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(f, m);
          }
          const b = l.get(h), x = typeof b == "number" ? b : this.options.estimateSize(f), w = g + x;
          u[f] = {
            index: f,
            start: g,
            size: x,
            end: w,
            key: h,
            lane: m
          }, c[m] = f;
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Ar(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, o, i, r) => this.range = t.length > 0 && o > 0 ? MB({
        measurements: t,
        outerSize: o,
        scrollOffset: i,
        lanes: r
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Ar(
      () => {
        let t = null, o = null;
        const i = this.calculateRange();
        return i && (t = i.startIndex, o = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, o]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          o
        ];
      },
      (t, o, i, r, s) => r === null || s === null ? [] : t({
        startIndex: r,
        endIndex: s,
        overscan: o,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const o = this.options.indexAttribute, i = t.getAttribute(o);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${o}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, o) => {
      const i = this.indexFromElement(t), r = this.measurementsCache[i];
      if (!r)
        return;
      const s = r.key, a = this.elementsCache.get(s);
      a !== t && (a && this.observer.unobserve(a), this.observer.observe(t), this.elementsCache.set(s, t)), t.isConnected && this.resizeItem(i, this.options.measureElement(t, o, this));
    }, this.resizeItem = (t, o) => {
      const i = this.measurementsCache[t];
      if (!i)
        return;
      const r = this.itemSizeCache.get(i.key) ?? i.size, s = o - r;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(i, s, this) : i.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(i.index), this.itemSizeCache = new Map(this.itemSizeCache.set(i.key, o)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((o, i) => {
          o.isConnected || (this.observer.unobserve(o), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = Ar(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, o) => {
        const i = [];
        for (let r = 0, s = t.length; r < s; r++) {
          const a = t[r], l = o[a];
          i.push(l);
        }
        return i;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const o = this.getMeasurements();
      if (o.length !== 0)
        return tm(
          o[I5(
            0,
            o.length - 1,
            (i) => tm(o[i]).start,
            t
          )]
        );
    }, this.getOffsetForAlignment = (t, o, i = 0) => {
      const r = this.getSize(), s = this.getScrollOffset();
      o === "auto" && (o = t >= s + r ? "end" : "start"), o === "center" ? t += (i - r) / 2 : o === "end" && (t -= r);
      const a = this.getTotalSize() + this.options.scrollMargin - r;
      return Math.max(Math.min(a, t), 0);
    }, this.getOffsetForIndex = (t, o = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const i = this.measurementsCache[t];
      if (!i)
        return;
      const r = this.getSize(), s = this.getScrollOffset();
      if (o === "auto")
        if (i.end >= s + r - this.options.scrollPaddingEnd)
          o = "end";
        else if (i.start <= s + this.options.scrollPaddingStart)
          o = "start";
        else
          return [s, o];
      const a = o === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(a, o, i.size),
        o
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: o = "start", behavior: i } = {}) => {
      i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, o), {
        adjustments: void 0,
        behavior: i
      });
    }, this.scrollToIndex = (t, { align: o = "auto", behavior: i } = {}) => {
      i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1));
      let r = 0;
      const s = 10, a = (d) => {
        if (!this.targetWindow) return;
        const u = this.getOffsetForIndex(t, d);
        if (!u) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [c, f] = u;
        this._scrollToOffset(c, { adjustments: void 0, behavior: i }), this.targetWindow.requestAnimationFrame(() => {
          const h = this.getScrollOffset(), p = this.getOffsetForIndex(t, f);
          if (!p) {
            console.warn("Failed to get offset for index:", t);
            return;
          }
          gB(p[0], h) || l(f);
        });
      }, l = (d) => {
        this.targetWindow && (r++, r < s ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", r, s), this.targetWindow.requestAnimationFrame(() => a(d))) : console.warn(
          `Failed to scroll to index ${t} after ${s} attempts.`
        ));
      };
      a(o);
    }, this.scrollBy = (t, { behavior: o } = {}) => {
      o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: o
      });
    }, this.getTotalSize = () => {
      var t;
      const o = this.getMeasurements();
      let i;
      if (o.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((t = o[o.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const r = Array(this.options.lanes).fill(null);
        let s = o.length - 1;
        for (; s >= 0 && r.some((a) => a === null); ) {
          const a = o[s];
          r[a.lane] === null && (r[a.lane] = a.end), s--;
        }
        i = Math.max(...r.filter((a) => a !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: o,
      behavior: i
    }) => {
      this.options.scrollToFn(t, { behavior: i, adjustments: o }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const I5 = (n, e, t, o) => {
  for (; n <= e; ) {
    const i = (n + e) / 2 | 0, r = t(i);
    if (r < o)
      n = i + 1;
    else if (r > o)
      e = i - 1;
    else
      return i;
  }
  return n > 0 ? n - 1 : 0;
};
function MB({
  measurements: n,
  outerSize: e,
  scrollOffset: t,
  lanes: o
}) {
  const i = n.length - 1, r = (l) => n[l].start;
  if (n.length <= o)
    return {
      startIndex: 0,
      endIndex: i
    };
  let s = I5(
    0,
    i,
    r,
    t
  ), a = s;
  if (o === 1)
    for (; a < i && n[a].end < t + e; )
      a++;
  else if (o > 1) {
    const l = Array(o).fill(0);
    for (; a < i && l.some((u) => u < t + e); ) {
      const u = n[a];
      l[u.lane] = u.end, a++;
    }
    const d = Array(o).fill(t + e);
    for (; s >= 0 && d.some((u) => u >= t); ) {
      const u = n[s];
      d[u.lane] = u.start, s--;
    }
    s = Math.max(0, s - s % o), a = Math.min(i, a + (o - 1 - a % o));
  }
  return { startIndex: s, endIndex: a };
}
function SB(n) {
  const e = new $B(k(n)), t = mr(e), o = e._didMount();
  return Ee(
    () => k(n).getScrollElement(),
    (i) => {
      i && e._willUpdate();
    },
    {
      immediate: !0
    }
  ), Ee(
    () => k(n),
    (i) => {
      e.setOptions({
        ...i,
        onChange: (r, s) => {
          var a;
          r0(t), (a = i.onChange) == null || a.call(i, r, s);
        }
      }), e._willUpdate(), r0(t);
    },
    {
      immediate: !0
    }
  ), ru(o), t;
}
function _B(n) {
  return SB(
    L(() => ({
      observeElementRect: xB,
      observeElementOffset: CB,
      scrollToFn: kB,
      ...k(n)
    }))
  );
}
function Ih(n, e, t) {
  let o = R(t == null ? void 0 : t.value), i = L(() => n.value !== void 0);
  return [L(() => i.value ? n.value : o.value), function(r) {
    return i.value || (o.value = r), e == null ? void 0 : e(r);
  }];
}
let EB = 0;
function OB() {
  return ++EB;
}
function Jn() {
  return OB();
}
function Me(n) {
  var e;
  if (n == null || n.value == null) return null;
  let t = (e = n.value.$el) != null ? e : n.value;
  return t instanceof Node ? t : null;
}
function Wt(n, e, ...t) {
  if (n in e) {
    let i = e[n];
    return typeof i == "function" ? i(...t) : i;
  }
  let o = new Error(`Tried to handle "${n}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(o, Wt), o;
}
var TB = Object.defineProperty, AB = (n, e, t) => e in n ? TB(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, rm = (n, e, t) => (AB(n, typeof e != "symbol" ? e + "" : e, t), t);
let IB = class {
  constructor() {
    rm(this, "current", this.detect()), rm(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Dh = new IB();
function Nh(n) {
  if (Dh.isServer) return null;
  if (n instanceof Node) return n.ownerDocument;
  if (n != null && n.hasOwnProperty("value")) {
    let e = Me(n);
    if (e) return e.ownerDocument;
  }
  return document;
}
let sm = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((n) => `${n}:not([tabindex='-1'])`).join(",");
var DB = ((n) => (n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))(DB || {}), NB = ((n) => (n[n.Error = 0] = "Error", n[n.Overflow = 1] = "Overflow", n[n.Success = 2] = "Success", n[n.Underflow = 3] = "Underflow", n))(NB || {}), PB = ((n) => (n[n.Previous = -1] = "Previous", n[n.Next = 1] = "Next", n))(PB || {}), Ph = ((n) => (n[n.Strict = 0] = "Strict", n[n.Loose = 1] = "Loose", n))(Ph || {});
function D5(n, e = 0) {
  var t;
  return n === ((t = Nh(n)) == null ? void 0 : t.body) ? !1 : Wt(e, { 0() {
    return n.matches(sm);
  }, 1() {
    let o = n;
    for (; o !== null; ) {
      if (o.matches(sm)) return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
var LB = ((n) => (n[n.Keyboard = 0] = "Keyboard", n[n.Mouse = 1] = "Mouse", n))(LB || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (n) => {
  n.metaKey || n.altKey || n.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (n) => {
  n.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : n.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function N5(n, e = (t) => t) {
  return n.slice().sort((t, o) => {
    let i = e(t), r = e(o);
    if (i === null || r === null) return 0;
    let s = i.compareDocumentPosition(r);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function RB() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function FB() {
  return /Android/gi.test(window.navigator.userAgent);
}
function P5() {
  return RB() || FB();
}
function gl(n, e, t) {
  Dh.isServer || dt((o) => {
    document.addEventListener(n, e, t), o(() => document.removeEventListener(n, e, t));
  });
}
function BB(n, e, t) {
  Dh.isServer || dt((o) => {
    window.addEventListener(n, e, t), o(() => window.removeEventListener(n, e, t));
  });
}
function L5(n, e, t = L(() => !0)) {
  function o(r, s) {
    if (!t.value || r.defaultPrevented) return;
    let a = s(r);
    if (a === null || !a.getRootNode().contains(a)) return;
    let l = (function d(u) {
      return typeof u == "function" ? d(u()) : Array.isArray(u) || u instanceof Set ? u : [u];
    })(n);
    for (let d of l) {
      if (d === null) continue;
      let u = d instanceof HTMLElement ? d : Me(d);
      if (u != null && u.contains(a) || r.composed && r.composedPath().includes(u)) return;
    }
    return !D5(a, Ph.Loose) && a.tabIndex !== -1 && r.preventDefault(), e(r, a);
  }
  let i = R(null);
  gl("pointerdown", (r) => {
    var s, a;
    t.value && (i.value = ((a = (s = r.composedPath) == null ? void 0 : s.call(r)) == null ? void 0 : a[0]) || r.target);
  }, !0), gl("mousedown", (r) => {
    var s, a;
    t.value && (i.value = ((a = (s = r.composedPath) == null ? void 0 : s.call(r)) == null ? void 0 : a[0]) || r.target);
  }, !0), gl("click", (r) => {
    P5() || i.value && (o(r, () => i.value), i.value = null);
  }, !0), gl("touchend", (r) => o(r, () => r.target instanceof HTMLElement ? r.target : null), !0), BB("blur", (r) => o(r, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function am(n, e) {
  if (n) return n;
  let t = e ?? "button";
  if (typeof t == "string" && t.toLowerCase() === "button") return "button";
}
function Lh(n, e) {
  let t = R(am(n.value.type, n.value.as));
  return We(() => {
    t.value = am(n.value.type, n.value.as);
  }), dt(() => {
    var o;
    t.value || Me(e) && Me(e) instanceof HTMLButtonElement && !((o = Me(e)) != null && o.hasAttribute("type")) && (t.value = "button");
  }), t;
}
function lm(n) {
  return [n.screenX, n.screenY];
}
function R5() {
  let n = R([-1, -1]);
  return { wasMoved(e) {
    let t = lm(e);
    return n.value[0] === t[0] && n.value[1] === t[1] ? !1 : (n.value = t, !0);
  }, update(e) {
    n.value = lm(e);
  } };
}
function VB({ container: n, accept: e, walk: t, enabled: o }) {
  dt(() => {
    let i = n.value;
    if (!i || o !== void 0 && !o.value) return;
    let r = Nh(n);
    if (!r) return;
    let s = Object.assign((l) => e(l), { acceptNode: e }), a = r.createTreeWalker(i, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; a.nextNode(); ) t(a.currentNode);
  });
}
var hr = ((n) => (n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))(hr || {}), zB = ((n) => (n[n.Unmount = 0] = "Unmount", n[n.Hidden = 1] = "Hidden", n))(zB || {});
function tn({ visible: n = !0, features: e = 0, ourProps: t, theirProps: o, ...i }) {
  var r;
  let s = B5(o, t), a = Object.assign(i, { props: s });
  if (n || e & 2 && s.static) return Lc(a);
  if (e & 1) {
    let l = (r = s.unmount) == null || r ? 0 : 1;
    return Wt(l, { 0() {
      return null;
    }, 1() {
      return Lc({ ...i, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Lc(a);
}
function Lc({ props: n, attrs: e, slots: t, slot: o, name: i }) {
  var r, s;
  let { as: a, ...l } = xs(n, ["unmount", "static"]), d = (r = t.default) == null ? void 0 : r.call(t, o), u = {};
  if (o) {
    let c = !1, f = [];
    for (let [h, p] of Object.entries(o)) typeof p == "boolean" && (c = !0), p === !0 && f.push(h);
    c && (u["data-headlessui-state"] = f.join(" "));
  }
  if (a === "template") {
    if (d = F5(d ?? []), Object.keys(l).length > 0 || Object.keys(e).length > 0) {
      let [c, ...f] = d ?? [];
      if (!HB(c) || f.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(e)).map((m) => m.trim()).filter((m, g, b) => b.indexOf(m) === g).sort((m, g) => m.localeCompare(g)).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
      let h = B5((s = c.props) != null ? s : {}, l, u), p = p1(c, h, !0);
      for (let m in h) m.startsWith("on") && (p.props || (p.props = {}), p.props[m] = h[m]);
      return p;
    }
    return Array.isArray(d) && d.length === 1 ? d[0] : d;
  }
  return lt(a, Object.assign({}, l, u), { default: () => d });
}
function F5(n) {
  return n.flatMap((e) => e.type === re ? F5(e.children) : [e]);
}
function B5(...n) {
  if (n.length === 0) return {};
  if (n.length === 1) return n[0];
  let e = {}, t = {};
  for (let o of n) for (let i in o) i.startsWith("on") && typeof o[i] == "function" ? (t[i] != null || (t[i] = []), t[i].push(o[i])) : e[i] = o[i];
  if (e.disabled || e["aria-disabled"]) return Object.assign(e, Object.fromEntries(Object.keys(t).map((o) => [o, void 0])));
  for (let o in t) Object.assign(e, { [o](i, ...r) {
    let s = t[o];
    for (let a of s) {
      if (i instanceof Event && i.defaultPrevented) return;
      a(i, ...r);
    }
  } });
  return e;
}
function Rh(n) {
  let e = Object.assign({}, n);
  for (let t in e) e[t] === void 0 && delete e[t];
  return e;
}
function xs(n, e = []) {
  let t = Object.assign({}, n);
  for (let o of e) o in t && delete t[o];
  return t;
}
function HB(n) {
  return n == null ? !1 : typeof n.type == "string" || typeof n.type == "object" || typeof n.type == "function";
}
var Bu = ((n) => (n[n.None = 1] = "None", n[n.Focusable = 2] = "Focusable", n[n.Hidden = 4] = "Hidden", n))(Bu || {});
let Fh = H({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(n, { slots: e, attrs: t }) {
  return () => {
    var o;
    let { features: i, ...r } = n, s = { "aria-hidden": (i & 2) === 2 ? !0 : (o = r["aria-hidden"]) != null ? o : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return tn({ ourProps: s, theirProps: r, slot: {}, attrs: t, slots: e, name: "Hidden" });
  };
} }), V5 = Symbol("Context");
var Wo = ((n) => (n[n.Open = 1] = "Open", n[n.Closed = 2] = "Closed", n[n.Closing = 4] = "Closing", n[n.Opening = 8] = "Opening", n))(Wo || {});
function z5() {
  return Uo(V5, null);
}
function H5(n) {
  Oi(V5, n);
}
var Ue = ((n) => (n.Space = " ", n.Enter = "Enter", n.Escape = "Escape", n.Backspace = "Backspace", n.Delete = "Delete", n.ArrowLeft = "ArrowLeft", n.ArrowUp = "ArrowUp", n.ArrowRight = "ArrowRight", n.ArrowDown = "ArrowDown", n.Home = "Home", n.End = "End", n.PageUp = "PageUp", n.PageDown = "PageDown", n.Tab = "Tab", n))(Ue || {});
function jB(n) {
  function e() {
    document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}
let Ki = [];
jB(() => {
  function n(e) {
    e.target instanceof HTMLElement && e.target !== document.body && Ki[0] !== e.target && (Ki.unshift(e.target), Ki = Ki.filter((t) => t != null && t.isConnected), Ki.splice(10));
  }
  window.addEventListener("click", n, { capture: !0 }), window.addEventListener("mousedown", n, { capture: !0 }), window.addEventListener("focus", n, { capture: !0 }), document.body.addEventListener("click", n, { capture: !0 }), document.body.addEventListener("mousedown", n, { capture: !0 }), document.body.addEventListener("focus", n, { capture: !0 });
});
function WB(n) {
  throw new Error("Unexpected object: " + n);
}
var Ye = ((n) => (n[n.First = 0] = "First", n[n.Previous = 1] = "Previous", n[n.Next = 2] = "Next", n[n.Last = 3] = "Last", n[n.Specific = 4] = "Specific", n[n.Nothing = 5] = "Nothing", n))(Ye || {});
function Jf(n, e) {
  let t = e.resolveItems();
  if (t.length <= 0) return null;
  let o = e.resolveActiveIndex(), i = o ?? -1;
  switch (n.focus) {
    case 0: {
      for (let r = 0; r < t.length; ++r) if (!e.resolveDisabled(t[r], r, t)) return r;
      return o;
    }
    case 1: {
      i === -1 && (i = t.length);
      for (let r = i - 1; r >= 0; --r) if (!e.resolveDisabled(t[r], r, t)) return r;
      return o;
    }
    case 2: {
      for (let r = i + 1; r < t.length; ++r) if (!e.resolveDisabled(t[r], r, t)) return r;
      return o;
    }
    case 3: {
      for (let r = t.length - 1; r >= 0; --r) if (!e.resolveDisabled(t[r], r, t)) return r;
      return o;
    }
    case 4: {
      for (let r = 0; r < t.length; ++r) if (e.resolveId(t[r], r, t) === n.id) return r;
      return o;
    }
    case 5:
      return null;
    default:
      WB(n);
  }
}
function UB(n) {
  typeof queueMicrotask == "function" ? queueMicrotask(n) : Promise.resolve().then(n).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function Xf() {
  let n = [], e = { addEventListener(t, o, i, r) {
    return t.addEventListener(o, i, r), e.add(() => t.removeEventListener(o, i, r));
  }, requestAnimationFrame(...t) {
    let o = requestAnimationFrame(...t);
    e.add(() => cancelAnimationFrame(o));
  }, nextFrame(...t) {
    e.requestAnimationFrame(() => {
      e.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let o = setTimeout(...t);
    e.add(() => clearTimeout(o));
  }, microTask(...t) {
    let o = { current: !0 };
    return UB(() => {
      o.current && t[0]();
    }), e.add(() => {
      o.current = !1;
    });
  }, style(t, o, i) {
    let r = t.style.getPropertyValue(o);
    return Object.assign(t.style, { [o]: i }), this.add(() => {
      Object.assign(t.style, { [o]: r });
    });
  }, group(t) {
    let o = Xf();
    return t(o), this.add(() => o.dispose());
  }, add(t) {
    return n.push(t), () => {
      let o = n.indexOf(t);
      if (o >= 0) for (let i of n.splice(o, 1)) i();
    };
  }, dispose() {
    for (let t of n.splice(0)) t();
  } };
  return e;
}
function Bh(n = {}, e = null, t = []) {
  for (let [o, i] of Object.entries(n)) W5(t, j5(e, o), i);
  return t;
}
function j5(n, e) {
  return n ? n + "[" + e + "]" : e;
}
function W5(n, e, t) {
  if (Array.isArray(t)) for (let [o, i] of t.entries()) W5(n, j5(e, o.toString()), i);
  else t instanceof Date ? n.push([e, t.toISOString()]) : typeof t == "boolean" ? n.push([e, t ? "1" : "0"]) : typeof t == "string" ? n.push([e, t]) : typeof t == "number" ? n.push([e, `${t}`]) : t == null ? n.push([e, ""]) : Bh(t, e, n);
}
function KB(n) {
  var e, t;
  let o = (e = n == null ? void 0 : n.form) != null ? e : n.closest("form");
  if (o) {
    for (let i of o.elements) if (i !== n && (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image")) {
      i.click();
      return;
    }
    (t = o.requestSubmit) == null || t.call(o);
  }
}
function GB(n, e) {
  return n === e;
}
var YB = ((n) => (n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))(YB || {}), qB = ((n) => (n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))(qB || {}), ZB = ((n) => (n[n.Pointer = 0] = "Pointer", n[n.Focus = 1] = "Focus", n[n.Other = 2] = "Other", n))(ZB || {});
let U5 = Symbol("ComboboxContext");
function xr(n) {
  let e = Uo(U5, null);
  if (e === null) {
    let t = new Error(`<${n} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, xr), t;
  }
  return e;
}
let K5 = Symbol("VirtualContext"), JB = H({ name: "VirtualProvider", setup(n, { slots: e }) {
  let t = xr("VirtualProvider"), o = L(() => {
    let a = Me(t.optionsRef);
    if (!a) return { start: 0, end: 0 };
    let l = window.getComputedStyle(a);
    return { start: parseFloat(l.paddingBlockStart || l.paddingTop), end: parseFloat(l.paddingBlockEnd || l.paddingBottom) };
  }), i = _B(L(() => ({ scrollPaddingStart: o.value.start, scrollPaddingEnd: o.value.end, count: t.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return Me(t.optionsRef);
  }, overscan: 12 }))), r = L(() => {
    var a;
    return (a = t.virtual.value) == null ? void 0 : a.options;
  }), s = R(0);
  return Ee([r], () => {
    s.value += 1;
  }), Oi(K5, t.virtual.value ? i : null), () => [lt("div", { style: { position: "relative", width: "100%", height: `${i.value.getTotalSize()}px` }, ref: (a) => {
    if (a) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || t.activationTrigger.value === 0) return;
      t.activeOptionIndex.value !== null && t.virtual.value.options.length > t.activeOptionIndex.value && i.value.scrollToIndex(t.activeOptionIndex.value);
    }
  } }, i.value.getVirtualItems().map((a) => p1(e.default({ option: t.virtual.value.options[a.index], open: t.comboboxState.value === 0 })[0], { key: `${s.value}-${a.index}`, "data-index": a.index, "aria-setsize": t.virtual.value.options.length, "aria-posinset": a.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${a.start}px)`, overflowAnchor: "none" } })))];
} }), XB = H({ name: "Combobox", emits: { "update:modelValue": (n) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(n, { slots: e, attrs: t, emit: o }) {
  let i = R(1), r = R(null), s = R(null), a = R(null), l = R(null), d = R({ static: !1, hold: !1 }), u = R([]), c = R(null), f = R(2), h = R(!1);
  function p(I = (z) => z) {
    let z = c.value !== null ? u.value[c.value] : null, F = I(u.value.slice()), Y = F.length > 0 && F[0].dataRef.order.value !== null ? F.sort((W, te) => W.dataRef.order.value - te.dataRef.order.value) : N5(F, (W) => Me(W.dataRef.domRef)), ie = z ? Y.indexOf(z) : null;
    return ie === -1 && (ie = null), { options: Y, activeOptionIndex: ie };
  }
  let m = L(() => n.multiple ? 1 : 0), g = L(() => n.nullable), [b, x] = Ih(L(() => n.modelValue), (I) => o("update:modelValue", I), L(() => n.defaultValue)), w = L(() => b.value === void 0 ? Wt(m.value, { 1: [], 0: void 0 }) : b.value), M = null, $ = null;
  function T(I) {
    return Wt(m.value, { 0() {
      return x == null ? void 0 : x(I);
    }, 1: () => {
      let z = vt(S.value.value).slice(), F = vt(I), Y = z.findIndex((ie) => S.compare(F, vt(ie)));
      return Y === -1 ? z.push(F) : z.splice(Y, 1), x == null ? void 0 : x(z);
    } });
  }
  let E = L(() => {
  });
  Ee([E], ([I], [z]) => {
    if (S.virtual.value && I && z && c.value !== null) {
      let F = I.indexOf(z[c.value]);
      F !== -1 ? c.value = F : c.value = null;
    }
  });
  let S = { comboboxState: i, value: w, mode: m, compare(I, z) {
    if (typeof n.by == "string") {
      let F = n.by;
      return (I == null ? void 0 : I[F]) === (z == null ? void 0 : z[F]);
    }
    return n.by === null ? GB(I, z) : n.by(I, z);
  }, calculateIndex(I) {
    return S.virtual.value ? n.by === null ? S.virtual.value.options.indexOf(I) : S.virtual.value.options.findIndex((z) => S.compare(z, I)) : u.value.findIndex((z) => S.compare(z.dataRef.value, I));
  }, defaultValue: L(() => n.defaultValue), nullable: g, immediate: L(() => !1), virtual: L(() => null), inputRef: s, labelRef: r, buttonRef: a, optionsRef: l, disabled: L(() => n.disabled), options: u, change(I) {
    x(I);
  }, activeOptionIndex: L(() => {
    if (h.value && c.value === null && (S.virtual.value ? S.virtual.value.options.length > 0 : u.value.length > 0)) {
      if (S.virtual.value) {
        let z = S.virtual.value.options.findIndex((F) => {
          var Y;
          return !((Y = S.virtual.value) != null && Y.disabled(F));
        });
        if (z !== -1) return z;
      }
      let I = u.value.findIndex((z) => !z.dataRef.disabled);
      if (I !== -1) return I;
    }
    return c.value;
  }), activationTrigger: f, optionsPropsRef: d, closeCombobox() {
    h.value = !1, !n.disabled && i.value !== 1 && (i.value = 1, c.value = null);
  }, openCombobox() {
    if (h.value = !0, !n.disabled && i.value !== 0) {
      if (S.value.value) {
        let I = S.calculateIndex(S.value.value);
        I !== -1 && (c.value = I);
      }
      i.value = 0;
    }
  }, setActivationTrigger(I) {
    f.value = I;
  }, goToOption(I, z, F) {
    h.value = !1, M !== null && cancelAnimationFrame(M), M = requestAnimationFrame(() => {
      if (n.disabled || l.value && !d.value.static && i.value === 1) return;
      if (S.virtual.value) {
        c.value = I === Ye.Specific ? z : Jf({ focus: I }, { resolveItems: () => S.virtual.value.options, resolveActiveIndex: () => {
          var W, te;
          return (te = (W = S.activeOptionIndex.value) != null ? W : S.virtual.value.options.findIndex((ce) => {
            var we;
            return !((we = S.virtual.value) != null && we.disabled(ce));
          })) != null ? te : null;
        }, resolveDisabled: (W) => S.virtual.value.disabled(W), resolveId() {
          throw new Error("Function not implemented.");
        } }), f.value = F ?? 2;
        return;
      }
      let Y = p();
      if (Y.activeOptionIndex === null) {
        let W = Y.options.findIndex((te) => !te.dataRef.disabled);
        W !== -1 && (Y.activeOptionIndex = W);
      }
      let ie = I === Ye.Specific ? z : Jf({ focus: I }, { resolveItems: () => Y.options, resolveActiveIndex: () => Y.activeOptionIndex, resolveId: (W) => W.id, resolveDisabled: (W) => W.dataRef.disabled });
      c.value = ie, f.value = F ?? 2, u.value = Y.options;
    });
  }, selectOption(I) {
    let z = u.value.find((Y) => Y.id === I);
    if (!z) return;
    let { dataRef: F } = z;
    T(F.value);
  }, selectActiveOption() {
    if (S.activeOptionIndex.value !== null) {
      if (S.virtual.value) T(S.virtual.value.options[S.activeOptionIndex.value]);
      else {
        let { dataRef: I } = u.value[S.activeOptionIndex.value];
        T(I.value);
      }
      S.goToOption(Ye.Specific, S.activeOptionIndex.value);
    }
  }, registerOption(I, z) {
    let F = Zr({ id: I, dataRef: z });
    if (S.virtual.value) {
      u.value.push(F);
      return;
    }
    $ && cancelAnimationFrame($);
    let Y = p((ie) => (ie.push(F), ie));
    c.value === null && S.isSelected(z.value.value) && (Y.activeOptionIndex = Y.options.indexOf(F)), u.value = Y.options, c.value = Y.activeOptionIndex, f.value = 2, Y.options.some((ie) => !Me(ie.dataRef.domRef)) && ($ = requestAnimationFrame(() => {
      let ie = p();
      u.value = ie.options, c.value = ie.activeOptionIndex;
    }));
  }, unregisterOption(I, z) {
    if (M !== null && cancelAnimationFrame(M), z && (h.value = !0), S.virtual.value) {
      u.value = u.value.filter((Y) => Y.id !== I);
      return;
    }
    let F = p((Y) => {
      let ie = Y.findIndex((W) => W.id === I);
      return ie !== -1 && Y.splice(ie, 1), Y;
    });
    u.value = F.options, c.value = F.activeOptionIndex, f.value = 2;
  }, isSelected(I) {
    return Wt(m.value, { 0: () => S.compare(vt(S.value.value), vt(I)), 1: () => vt(S.value.value).some((z) => S.compare(vt(z), vt(I))) });
  }, isActive(I) {
    return c.value === S.calculateIndex(I);
  } };
  L5([s, a, l], () => S.closeCombobox(), L(() => i.value === 0)), Oi(U5, S), H5(L(() => Wt(i.value, { 0: Wo.Open, 1: Wo.Closed })));
  let D = L(() => {
    var I;
    return (I = Me(s)) == null ? void 0 : I.closest("form");
  });
  return We(() => {
    Ee([D], () => {
      if (!D.value || n.defaultValue === void 0) return;
      function I() {
        S.change(n.defaultValue);
      }
      return D.value.addEventListener("reset", I), () => {
        var z;
        (z = D.value) == null || z.removeEventListener("reset", I);
      };
    }, { immediate: !0 });
  }), () => {
    var I, z, F;
    let { name: Y, disabled: ie, form: W, ...te } = n, ce = { open: i.value === 0, disabled: ie, activeIndex: S.activeOptionIndex.value, activeOption: S.activeOptionIndex.value === null ? null : S.virtual.value ? S.virtual.value.options[(I = S.activeOptionIndex.value) != null ? I : 0] : (F = (z = S.options.value[S.activeOptionIndex.value]) == null ? void 0 : z.dataRef.value.value) != null ? F : null, value: w.value };
    return lt(re, [...Y != null && w.value != null ? Bh({ [Y]: w.value }).map(([we, ke]) => lt(Fh, Rh({ features: Bu.Hidden, key: we, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: W, name: we, value: ke }))) : [], tn({ theirProps: { ...t, ...xs(te, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: ce, slots: e, attrs: t, name: "Combobox" })]);
  };
} });
H({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-combobox-label-${Jn()}` } }, setup(n, { attrs: e, slots: t }) {
  let o = xr("ComboboxLabel");
  function i() {
    var r;
    (r = Me(o.inputRef)) == null || r.focus({ preventScroll: !0 });
  }
  return () => {
    let r = { open: o.comboboxState.value === 0, disabled: o.disabled.value }, { id: s, ...a } = n, l = { id: s, ref: o.labelRef, onClick: i };
    return tn({ ourProps: l, theirProps: a, slot: r, attrs: e, slots: t, name: "ComboboxLabel" });
  };
} });
let QB = H({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-combobox-button-${Jn()}` } }, setup(n, { attrs: e, slots: t, expose: o }) {
  let i = xr("ComboboxButton");
  o({ el: i.buttonRef, $el: i.buttonRef });
  function r(l) {
    i.disabled.value || (i.comboboxState.value === 0 ? i.closeCombobox() : (l.preventDefault(), i.openCombobox()), Ve(() => {
      var d;
      return (d = Me(i.inputRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    }));
  }
  function s(l) {
    switch (l.key) {
      case Ue.ArrowDown:
        l.preventDefault(), l.stopPropagation(), i.comboboxState.value === 1 && i.openCombobox(), Ve(() => {
          var d;
          return (d = i.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
      case Ue.ArrowUp:
        l.preventDefault(), l.stopPropagation(), i.comboboxState.value === 1 && (i.openCombobox(), Ve(() => {
          i.value.value || i.goToOption(Ye.Last);
        })), Ve(() => {
          var d;
          return (d = i.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
      case Ue.Escape:
        if (i.comboboxState.value !== 0) return;
        l.preventDefault(), i.optionsRef.value && !i.optionsPropsRef.value.static && l.stopPropagation(), i.closeCombobox(), Ve(() => {
          var d;
          return (d = i.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let a = Lh(L(() => ({ as: n.as, type: e.type })), i.buttonRef);
  return () => {
    var l, d;
    let u = { open: i.comboboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { id: c, ...f } = n, h = { ref: i.buttonRef, id: c, type: a.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (l = Me(i.optionsRef)) == null ? void 0 : l.id, "aria-expanded": i.comboboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(d = Me(i.labelRef)) == null ? void 0 : d.id, c].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: s, onClick: r };
    return tn({ ourProps: h, theirProps: f, slot: u, attrs: e, slots: t, name: "ComboboxButton" });
  };
} }), eV = H({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: () => `headlessui-combobox-input-${Jn()}` } }, emits: { change: (n) => !0 }, setup(n, { emit: e, attrs: t, slots: o, expose: i }) {
  let r = xr("ComboboxInput"), s = L(() => Nh(Me(r.inputRef))), a = { value: !1 };
  i({ el: r.inputRef, $el: r.inputRef });
  function l() {
    r.change(null);
    let x = Me(r.optionsRef);
    x && (x.scrollTop = 0), r.goToOption(Ye.Nothing);
  }
  let d = L(() => {
    var x;
    let w = r.value.value;
    return Me(r.inputRef) ? typeof n.displayValue < "u" && w !== void 0 ? (x = n.displayValue(w)) != null ? x : "" : typeof w == "string" ? w : "" : "";
  });
  We(() => {
    Ee([d, r.comboboxState, s], ([x, w], [M, $]) => {
      if (a.value) return;
      let T = Me(r.inputRef);
      T && (($ === 0 && w === 1 || x !== M) && (T.value = x), requestAnimationFrame(() => {
        var E;
        if (a.value || !T || ((E = s.value) == null ? void 0 : E.activeElement) !== T) return;
        let { selectionStart: S, selectionEnd: D } = T;
        Math.abs((D ?? 0) - (S ?? 0)) === 0 && S === 0 && T.setSelectionRange(T.value.length, T.value.length);
      }));
    }, { immediate: !0 }), Ee([r.comboboxState], ([x], [w]) => {
      if (x === 0 && w === 1) {
        if (a.value) return;
        let M = Me(r.inputRef);
        if (!M) return;
        let $ = M.value, { selectionStart: T, selectionEnd: E, selectionDirection: S } = M;
        M.value = "", M.value = $, S !== null ? M.setSelectionRange(T, E, S) : M.setSelectionRange(T, E);
      }
    });
  });
  let u = R(!1);
  function c() {
    u.value = !0;
  }
  function f() {
    Xf().nextFrame(() => {
      u.value = !1;
    });
  }
  function h(x) {
    switch (a.value = !0, x.key) {
      case Ue.Enter:
        if (a.value = !1, r.comboboxState.value !== 0 || u.value) return;
        if (x.preventDefault(), x.stopPropagation(), r.activeOptionIndex.value === null) {
          r.closeCombobox();
          return;
        }
        r.selectActiveOption(), r.mode.value === 0 && r.closeCombobox();
        break;
      case Ue.ArrowDown:
        return a.value = !1, x.preventDefault(), x.stopPropagation(), Wt(r.comboboxState.value, { 0: () => r.goToOption(Ye.Next), 1: () => r.openCombobox() });
      case Ue.ArrowUp:
        return a.value = !1, x.preventDefault(), x.stopPropagation(), Wt(r.comboboxState.value, { 0: () => r.goToOption(Ye.Previous), 1: () => {
          r.openCombobox(), Ve(() => {
            r.value.value || r.goToOption(Ye.Last);
          });
        } });
      case Ue.Home:
        if (x.shiftKey) break;
        return a.value = !1, x.preventDefault(), x.stopPropagation(), r.goToOption(Ye.First);
      case Ue.PageUp:
        return a.value = !1, x.preventDefault(), x.stopPropagation(), r.goToOption(Ye.First);
      case Ue.End:
        if (x.shiftKey) break;
        return a.value = !1, x.preventDefault(), x.stopPropagation(), r.goToOption(Ye.Last);
      case Ue.PageDown:
        return a.value = !1, x.preventDefault(), x.stopPropagation(), r.goToOption(Ye.Last);
      case Ue.Escape:
        if (a.value = !1, r.comboboxState.value !== 0) return;
        x.preventDefault(), r.optionsRef.value && !r.optionsPropsRef.value.static && x.stopPropagation(), r.nullable.value && r.mode.value === 0 && r.value.value === null && l(), r.closeCombobox();
        break;
      case Ue.Tab:
        if (a.value = !1, r.comboboxState.value !== 0) return;
        r.mode.value === 0 && r.activationTrigger.value !== 1 && r.selectActiveOption(), r.closeCombobox();
        break;
    }
  }
  function p(x) {
    e("change", x), r.nullable.value && r.mode.value === 0 && x.target.value === "" && l(), r.openCombobox();
  }
  function m(x) {
    var w, M, $;
    let T = (w = x.relatedTarget) != null ? w : Ki.find((E) => E !== x.currentTarget);
    if (a.value = !1, !((M = Me(r.optionsRef)) != null && M.contains(T)) && !(($ = Me(r.buttonRef)) != null && $.contains(T)) && r.comboboxState.value === 0) return x.preventDefault(), r.mode.value === 0 && (r.nullable.value && r.value.value === null ? l() : r.activationTrigger.value !== 1 && r.selectActiveOption()), r.closeCombobox();
  }
  function g(x) {
    var w, M, $;
    let T = (w = x.relatedTarget) != null ? w : Ki.find((E) => E !== x.currentTarget);
    (M = Me(r.buttonRef)) != null && M.contains(T) || ($ = Me(r.optionsRef)) != null && $.contains(T) || r.disabled.value || r.immediate.value && r.comboboxState.value !== 0 && (r.openCombobox(), Xf().nextFrame(() => {
      r.setActivationTrigger(1);
    }));
  }
  let b = L(() => {
    var x, w, M, $;
    return ($ = (M = (w = n.defaultValue) != null ? w : r.defaultValue.value !== void 0 ? (x = n.displayValue) == null ? void 0 : x.call(n, r.defaultValue.value) : null) != null ? M : r.defaultValue.value) != null ? $ : "";
  });
  return () => {
    var x, w, M, $, T, E, S;
    let D = { open: r.comboboxState.value === 0 }, { id: I, displayValue: z, onChange: F, ...Y } = n, ie = { "aria-controls": (x = r.optionsRef.value) == null ? void 0 : x.id, "aria-expanded": r.comboboxState.value === 0, "aria-activedescendant": r.activeOptionIndex.value === null ? void 0 : r.virtual.value ? (w = r.options.value.find((W) => !r.virtual.value.disabled(W.dataRef.value) && r.compare(W.dataRef.value, r.virtual.value.options[r.activeOptionIndex.value]))) == null ? void 0 : w.id : (M = r.options.value[r.activeOptionIndex.value]) == null ? void 0 : M.id, "aria-labelledby": (E = ($ = Me(r.labelRef)) == null ? void 0 : $.id) != null ? E : (T = Me(r.buttonRef)) == null ? void 0 : T.id, "aria-autocomplete": "list", id: I, onCompositionstart: c, onCompositionend: f, onKeydown: h, onInput: p, onFocus: g, onBlur: m, role: "combobox", type: (S = t.type) != null ? S : "text", tabIndex: 0, ref: r.inputRef, defaultValue: b.value, disabled: r.disabled.value === !0 ? !0 : void 0 };
    return tn({ ourProps: ie, theirProps: Y, slot: D, attrs: t, slots: o, features: hr.RenderStrategy | hr.Static, name: "ComboboxInput" });
  };
} }), tV = H({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(n, { attrs: e, slots: t, expose: o }) {
  let i = xr("ComboboxOptions"), r = `headlessui-combobox-options-${Jn()}`;
  o({ el: i.optionsRef, $el: i.optionsRef }), dt(() => {
    i.optionsPropsRef.value.static = n.static;
  }), dt(() => {
    i.optionsPropsRef.value.hold = n.hold;
  });
  let s = z5(), a = L(() => s !== null ? (s.value & Wo.Open) === Wo.Open : i.comboboxState.value === 0);
  return VB({ container: L(() => Me(i.optionsRef)), enabled: L(() => i.comboboxState.value === 0), accept(l) {
    return l.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : l.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(l) {
    l.setAttribute("role", "none");
  } }), () => {
    var l, d, u;
    let c = { open: i.comboboxState.value === 0 }, f = { "aria-labelledby": (u = (l = Me(i.labelRef)) == null ? void 0 : l.id) != null ? u : (d = Me(i.buttonRef)) == null ? void 0 : d.id, id: r, ref: i.optionsRef, role: "listbox", "aria-multiselectable": i.mode.value === 1 ? !0 : void 0 }, h = xs(n, ["hold"]);
    return tn({ ourProps: f, theirProps: h, slot: c, attrs: e, slots: i.virtual.value && i.comboboxState.value === 0 ? { ...t, default: () => [lt(JB, {}, t.default)] } : t, features: hr.RenderStrategy | hr.Static, visible: a.value, name: "ComboboxOptions" });
  };
} }), nV = H({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(n, { slots: e, attrs: t, expose: o }) {
  let i = xr("ComboboxOption"), r = `headlessui-combobox-option-${Jn()}`, s = R(null);
  o({ el: s, $el: s });
  let a = L(() => {
    var b;
    return i.virtual.value ? i.activeOptionIndex.value === i.calculateIndex(n.value) : i.activeOptionIndex.value === null ? !1 : ((b = i.options.value[i.activeOptionIndex.value]) == null ? void 0 : b.id) === r;
  }), l = L(() => i.isSelected(n.value)), d = Uo(K5, null), u = L(() => ({ disabled: n.disabled, value: n.value, domRef: s, order: L(() => n.order) }));
  We(() => i.registerOption(r, u)), Ei(() => i.unregisterOption(r, a.value)), dt(() => {
    let b = Me(s);
    b && (d == null || d.value.measureElement(b));
  }), dt(() => {
    i.comboboxState.value === 0 && a.value && (i.virtual.value || i.activationTrigger.value !== 0 && Ve(() => {
      var b, x;
      return (x = (b = Me(s)) == null ? void 0 : b.scrollIntoView) == null ? void 0 : x.call(b, { block: "nearest" });
    }));
  });
  function c(b) {
    var x;
    if (n.disabled || (x = i.virtual.value) != null && x.disabled(n.value)) return b.preventDefault();
    i.selectOption(r), P5() || requestAnimationFrame(() => {
      var w;
      return (w = Me(i.inputRef)) == null ? void 0 : w.focus({ preventScroll: !0 });
    }), i.mode.value === 0 && requestAnimationFrame(() => i.closeCombobox());
  }
  function f() {
    var b;
    if (n.disabled || (b = i.virtual.value) != null && b.disabled(n.value)) return i.goToOption(Ye.Nothing);
    let x = i.calculateIndex(n.value);
    i.goToOption(Ye.Specific, x);
  }
  let h = R5();
  function p(b) {
    h.update(b);
  }
  function m(b) {
    var x;
    if (!h.wasMoved(b) || n.disabled || (x = i.virtual.value) != null && x.disabled(n.value) || a.value) return;
    let w = i.calculateIndex(n.value);
    i.goToOption(Ye.Specific, w, 0);
  }
  function g(b) {
    var x;
    h.wasMoved(b) && (n.disabled || (x = i.virtual.value) != null && x.disabled(n.value) || a.value && (i.optionsPropsRef.value.hold || i.goToOption(Ye.Nothing)));
  }
  return () => {
    let { disabled: b } = n, x = { active: a.value, selected: l.value, disabled: b }, w = { id: r, ref: s, role: "option", tabIndex: b === !0 ? void 0 : -1, "aria-disabled": b === !0 ? !0 : void 0, "aria-selected": l.value, disabled: void 0, onClick: c, onFocus: f, onPointerenter: p, onMouseenter: p, onPointermove: m, onMousemove: m, onPointerleave: g, onMouseleave: g }, M = xs(n, ["order", "value"]);
    return tn({ ourProps: w, theirProps: M, slot: x, attrs: t, slots: e, name: "ComboboxOption" });
  };
} }), G5 = Symbol("DescriptionContext");
function oV() {
  let n = Uo(G5, null);
  if (n === null) throw new Error("Missing parent");
  return n;
}
function iV({ slot: n = R({}), name: e = "Description", props: t = {} } = {}) {
  let o = R([]);
  function i(r) {
    return o.value.push(r), () => {
      let s = o.value.indexOf(r);
      s !== -1 && o.value.splice(s, 1);
    };
  }
  return Oi(G5, { register: i, slot: n, name: e, props: t }), L(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
H({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${Jn()}` } }, setup(n, { attrs: e, slots: t }) {
  let o = oV();
  return We(() => Ei(o.register(n.id))), () => {
    let { name: i = "Description", slot: r = R({}), props: s = {} } = o, { id: a, ...l } = n, d = { ...Object.entries(s).reduce((u, [c, f]) => Object.assign(u, { [c]: k(f) }), {}), id: a };
    return tn({ ourProps: d, theirProps: l, slot: r.value, attrs: e, slots: t, name: i });
  };
} });
let dm = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function um(n) {
  var e, t;
  let o = (e = n.innerText) != null ? e : "", i = n.cloneNode(!0);
  if (!(i instanceof HTMLElement)) return o;
  let r = !1;
  for (let a of i.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) a.remove(), r = !0;
  let s = r ? (t = i.innerText) != null ? t : "" : o;
  return dm.test(s) && (s = s.replace(dm, "")), s;
}
function rV(n) {
  let e = n.getAttribute("aria-label");
  if (typeof e == "string") return e.trim();
  let t = n.getAttribute("aria-labelledby");
  if (t) {
    let o = t.split(" ").map((i) => {
      let r = document.getElementById(i);
      if (r) {
        let s = r.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : um(r).trim();
      }
      return null;
    }).filter(Boolean);
    if (o.length > 0) return o.join(", ");
  }
  return um(n).trim();
}
function sV(n) {
  let e = R(""), t = R("");
  return () => {
    let o = Me(n);
    if (!o) return "";
    let i = o.innerText;
    if (e.value === i) return t.value;
    let r = rV(o).trim().toLowerCase();
    return e.value = i, t.value = r, r;
  };
}
function aV(n, e) {
  return n === e;
}
var lV = ((n) => (n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))(lV || {}), dV = ((n) => (n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))(dV || {}), uV = ((n) => (n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))(uV || {});
function cV(n) {
  requestAnimationFrame(() => requestAnimationFrame(n));
}
let Y5 = Symbol("ListboxContext");
function Ua(n) {
  let e = Uo(Y5, null);
  if (e === null) {
    let t = new Error(`<${n} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Ua), t;
  }
  return e;
}
let fV = H({ name: "Listbox", emits: { "update:modelValue": (n) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => aV }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(n, { slots: e, attrs: t, emit: o }) {
  let i = R(1), r = R(null), s = R(null), a = R(null), l = R([]), d = R(""), u = R(null), c = R(1);
  function f(w = (M) => M) {
    let M = u.value !== null ? l.value[u.value] : null, $ = N5(w(l.value.slice()), (E) => Me(E.dataRef.domRef)), T = M ? $.indexOf(M) : null;
    return T === -1 && (T = null), { options: $, activeOptionIndex: T };
  }
  let h = L(() => n.multiple ? 1 : 0), [p, m] = Ih(L(() => n.modelValue), (w) => o("update:modelValue", w), L(() => n.defaultValue)), g = L(() => p.value === void 0 ? Wt(h.value, { 1: [], 0: void 0 }) : p.value), b = { listboxState: i, value: g, mode: h, compare(w, M) {
    if (typeof n.by == "string") {
      let $ = n.by;
      return (w == null ? void 0 : w[$]) === (M == null ? void 0 : M[$]);
    }
    return n.by(w, M);
  }, orientation: L(() => n.horizontal ? "horizontal" : "vertical"), labelRef: r, buttonRef: s, optionsRef: a, disabled: L(() => n.disabled), options: l, searchQuery: d, activeOptionIndex: u, activationTrigger: c, closeListbox() {
    n.disabled || i.value !== 1 && (i.value = 1, u.value = null);
  }, openListbox() {
    n.disabled || i.value !== 0 && (i.value = 0);
  }, goToOption(w, M, $) {
    if (n.disabled || i.value === 1) return;
    let T = f(), E = Jf(w === Ye.Specific ? { focus: Ye.Specific, id: M } : { focus: w }, { resolveItems: () => T.options, resolveActiveIndex: () => T.activeOptionIndex, resolveId: (S) => S.id, resolveDisabled: (S) => S.dataRef.disabled });
    d.value = "", u.value = E, c.value = $ ?? 1, l.value = T.options;
  }, search(w) {
    if (n.disabled || i.value === 1) return;
    let M = d.value !== "" ? 0 : 1;
    d.value += w.toLowerCase();
    let $ = (u.value !== null ? l.value.slice(u.value + M).concat(l.value.slice(0, u.value + M)) : l.value).find((E) => E.dataRef.textValue.startsWith(d.value) && !E.dataRef.disabled), T = $ ? l.value.indexOf($) : -1;
    T === -1 || T === u.value || (u.value = T, c.value = 1);
  }, clearSearch() {
    n.disabled || i.value !== 1 && d.value !== "" && (d.value = "");
  }, registerOption(w, M) {
    let $ = f((T) => [...T, { id: w, dataRef: M }]);
    l.value = $.options, u.value = $.activeOptionIndex;
  }, unregisterOption(w) {
    let M = f(($) => {
      let T = $.findIndex((E) => E.id === w);
      return T !== -1 && $.splice(T, 1), $;
    });
    l.value = M.options, u.value = M.activeOptionIndex, c.value = 1;
  }, theirOnChange(w) {
    n.disabled || m(w);
  }, select(w) {
    n.disabled || m(Wt(h.value, { 0: () => w, 1: () => {
      let M = vt(b.value.value).slice(), $ = vt(w), T = M.findIndex((E) => b.compare($, vt(E)));
      return T === -1 ? M.push($) : M.splice(T, 1), M;
    } }));
  } };
  L5([s, a], (w, M) => {
    var $;
    b.closeListbox(), D5(M, Ph.Loose) || (w.preventDefault(), ($ = Me(s)) == null || $.focus());
  }, L(() => i.value === 0)), Oi(Y5, b), H5(L(() => Wt(i.value, { 0: Wo.Open, 1: Wo.Closed })));
  let x = L(() => {
    var w;
    return (w = Me(s)) == null ? void 0 : w.closest("form");
  });
  return We(() => {
    Ee([x], () => {
      if (!x.value || n.defaultValue === void 0) return;
      function w() {
        b.theirOnChange(n.defaultValue);
      }
      return x.value.addEventListener("reset", w), () => {
        var M;
        (M = x.value) == null || M.removeEventListener("reset", w);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: w, modelValue: M, disabled: $, form: T, ...E } = n, S = { open: i.value === 0, disabled: $, value: g.value };
    return lt(re, [...w != null && g.value != null ? Bh({ [w]: g.value }).map(([D, I]) => lt(Fh, Rh({ features: Bu.Hidden, key: D, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: T, name: D, value: I }))) : [], tn({ ourProps: {}, theirProps: { ...t, ...xs(E, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: S, slots: e, attrs: t, name: "Listbox" })]);
  };
} });
H({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${Jn()}` } }, setup(n, { attrs: e, slots: t }) {
  let o = Ua("ListboxLabel");
  function i() {
    var r;
    (r = Me(o.buttonRef)) == null || r.focus({ preventScroll: !0 });
  }
  return () => {
    let r = { open: o.listboxState.value === 0, disabled: o.disabled.value }, { id: s, ...a } = n, l = { id: s, ref: o.labelRef, onClick: i };
    return tn({ ourProps: l, theirProps: a, slot: r, attrs: e, slots: t, name: "ListboxLabel" });
  };
} });
let hV = H({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${Jn()}` } }, setup(n, { attrs: e, slots: t, expose: o }) {
  let i = Ua("ListboxButton");
  o({ el: i.buttonRef, $el: i.buttonRef });
  function r(d) {
    switch (d.key) {
      case Ue.Space:
      case Ue.Enter:
      case Ue.ArrowDown:
        d.preventDefault(), i.openListbox(), Ve(() => {
          var u;
          (u = Me(i.optionsRef)) == null || u.focus({ preventScroll: !0 }), i.value.value || i.goToOption(Ye.First);
        });
        break;
      case Ue.ArrowUp:
        d.preventDefault(), i.openListbox(), Ve(() => {
          var u;
          (u = Me(i.optionsRef)) == null || u.focus({ preventScroll: !0 }), i.value.value || i.goToOption(Ye.Last);
        });
        break;
    }
  }
  function s(d) {
    switch (d.key) {
      case Ue.Space:
        d.preventDefault();
        break;
    }
  }
  function a(d) {
    i.disabled.value || (i.listboxState.value === 0 ? (i.closeListbox(), Ve(() => {
      var u;
      return (u = Me(i.buttonRef)) == null ? void 0 : u.focus({ preventScroll: !0 });
    })) : (d.preventDefault(), i.openListbox(), cV(() => {
      var u;
      return (u = Me(i.optionsRef)) == null ? void 0 : u.focus({ preventScroll: !0 });
    })));
  }
  let l = Lh(L(() => ({ as: n.as, type: e.type })), i.buttonRef);
  return () => {
    var d, u;
    let c = { open: i.listboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { id: f, ...h } = n, p = { ref: i.buttonRef, id: f, type: l.value, "aria-haspopup": "listbox", "aria-controls": (d = Me(i.optionsRef)) == null ? void 0 : d.id, "aria-expanded": i.listboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(u = Me(i.labelRef)) == null ? void 0 : u.id, f].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: r, onKeyup: s, onClick: a };
    return tn({ ourProps: p, theirProps: h, slot: c, attrs: e, slots: t, name: "ListboxButton" });
  };
} }), pV = H({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${Jn()}` } }, setup(n, { attrs: e, slots: t, expose: o }) {
  let i = Ua("ListboxOptions"), r = R(null);
  o({ el: i.optionsRef, $el: i.optionsRef });
  function s(d) {
    switch (r.value && clearTimeout(r.value), d.key) {
      case Ue.Space:
        if (i.searchQuery.value !== "") return d.preventDefault(), d.stopPropagation(), i.search(d.key);
      case Ue.Enter:
        if (d.preventDefault(), d.stopPropagation(), i.activeOptionIndex.value !== null) {
          let u = i.options.value[i.activeOptionIndex.value];
          i.select(u.dataRef.value);
        }
        i.mode.value === 0 && (i.closeListbox(), Ve(() => {
          var u;
          return (u = Me(i.buttonRef)) == null ? void 0 : u.focus({ preventScroll: !0 });
        }));
        break;
      case Wt(i.orientation.value, { vertical: Ue.ArrowDown, horizontal: Ue.ArrowRight }):
        return d.preventDefault(), d.stopPropagation(), i.goToOption(Ye.Next);
      case Wt(i.orientation.value, { vertical: Ue.ArrowUp, horizontal: Ue.ArrowLeft }):
        return d.preventDefault(), d.stopPropagation(), i.goToOption(Ye.Previous);
      case Ue.Home:
      case Ue.PageUp:
        return d.preventDefault(), d.stopPropagation(), i.goToOption(Ye.First);
      case Ue.End:
      case Ue.PageDown:
        return d.preventDefault(), d.stopPropagation(), i.goToOption(Ye.Last);
      case Ue.Escape:
        d.preventDefault(), d.stopPropagation(), i.closeListbox(), Ve(() => {
          var u;
          return (u = Me(i.buttonRef)) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        break;
      case Ue.Tab:
        d.preventDefault(), d.stopPropagation();
        break;
      default:
        d.key.length === 1 && (i.search(d.key), r.value = setTimeout(() => i.clearSearch(), 350));
        break;
    }
  }
  let a = z5(), l = L(() => a !== null ? (a.value & Wo.Open) === Wo.Open : i.listboxState.value === 0);
  return () => {
    var d, u;
    let c = { open: i.listboxState.value === 0 }, { id: f, ...h } = n, p = { "aria-activedescendant": i.activeOptionIndex.value === null || (d = i.options.value[i.activeOptionIndex.value]) == null ? void 0 : d.id, "aria-multiselectable": i.mode.value === 1 ? !0 : void 0, "aria-labelledby": (u = Me(i.buttonRef)) == null ? void 0 : u.id, "aria-orientation": i.orientation.value, id: f, onKeydown: s, role: "listbox", tabIndex: 0, ref: i.optionsRef };
    return tn({ ourProps: p, theirProps: h, slot: c, attrs: e, slots: t, features: hr.RenderStrategy | hr.Static, visible: l.value, name: "ListboxOptions" });
  };
} }), mV = H({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${Jn()}` } }, setup(n, { slots: e, attrs: t, expose: o }) {
  let i = Ua("ListboxOption"), r = R(null);
  o({ el: r, $el: r });
  let s = L(() => i.activeOptionIndex.value !== null ? i.options.value[i.activeOptionIndex.value].id === n.id : !1), a = L(() => Wt(i.mode.value, { 0: () => i.compare(vt(i.value.value), vt(n.value)), 1: () => vt(i.value.value).some((b) => i.compare(vt(b), vt(n.value))) })), l = L(() => Wt(i.mode.value, { 1: () => {
    var b;
    let x = vt(i.value.value);
    return ((b = i.options.value.find((w) => x.some((M) => i.compare(vt(M), vt(w.dataRef.value))))) == null ? void 0 : b.id) === n.id;
  }, 0: () => a.value })), d = sV(r), u = L(() => ({ disabled: n.disabled, value: n.value, get textValue() {
    return d();
  }, domRef: r }));
  We(() => i.registerOption(n.id, u)), Ei(() => i.unregisterOption(n.id)), We(() => {
    Ee([i.listboxState, a], () => {
      i.listboxState.value === 0 && a.value && Wt(i.mode.value, { 1: () => {
        l.value && i.goToOption(Ye.Specific, n.id);
      }, 0: () => {
        i.goToOption(Ye.Specific, n.id);
      } });
    }, { immediate: !0 });
  }), dt(() => {
    i.listboxState.value === 0 && s.value && i.activationTrigger.value !== 0 && Ve(() => {
      var b, x;
      return (x = (b = Me(r)) == null ? void 0 : b.scrollIntoView) == null ? void 0 : x.call(b, { block: "nearest" });
    });
  });
  function c(b) {
    if (n.disabled) return b.preventDefault();
    i.select(n.value), i.mode.value === 0 && (i.closeListbox(), Ve(() => {
      var x;
      return (x = Me(i.buttonRef)) == null ? void 0 : x.focus({ preventScroll: !0 });
    }));
  }
  function f() {
    if (n.disabled) return i.goToOption(Ye.Nothing);
    i.goToOption(Ye.Specific, n.id);
  }
  let h = R5();
  function p(b) {
    h.update(b);
  }
  function m(b) {
    h.wasMoved(b) && (n.disabled || s.value || i.goToOption(Ye.Specific, n.id, 0));
  }
  function g(b) {
    h.wasMoved(b) && (n.disabled || s.value && i.goToOption(Ye.Nothing));
  }
  return () => {
    let { disabled: b } = n, x = { active: s.value, selected: a.value, disabled: b }, { id: w, value: M, disabled: $, ...T } = n, E = { id: w, ref: r, role: "option", tabIndex: b === !0 ? void 0 : -1, "aria-disabled": b === !0 ? !0 : void 0, "aria-selected": a.value, disabled: void 0, onClick: c, onFocus: f, onPointerenter: p, onMouseenter: p, onPointermove: m, onMousemove: m, onPointerleave: g, onMouseleave: g };
    return tn({ ourProps: E, theirProps: T, slot: x, attrs: t, slots: e, name: "ListboxOption" });
  };
} }), q5 = Symbol("LabelContext");
function Z5() {
  let n = Uo(q5, null);
  if (n === null) {
    let e = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, Z5), e;
  }
  return n;
}
function gV({ slot: n = {}, name: e = "Label", props: t = {} } = {}) {
  let o = R([]);
  function i(r) {
    return o.value.push(r), () => {
      let s = o.value.indexOf(r);
      s !== -1 && o.value.splice(s, 1);
    };
  }
  return Oi(q5, { register: i, slot: n, name: e, props: t }), L(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
H({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${Jn()}` } }, setup(n, { slots: e, attrs: t }) {
  let o = Z5();
  return We(() => Ei(o.register(n.id))), () => {
    let { name: i = "Label", slot: r = {}, props: s = {} } = o, { id: a, passive: l, ...d } = n, u = { ...Object.entries(s).reduce((c, [f, h]) => Object.assign(c, { [f]: k(h) }), {}), id: a };
    return l && (delete u.onClick, delete u.htmlFor, delete d.onClick), tn({ ourProps: u, theirProps: d, slot: r, attrs: t, slots: e, name: i });
  };
} });
let J5 = Symbol("GroupContext"), vV = H({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(n, { slots: e, attrs: t }) {
  let o = R(null), i = gV({ name: "SwitchLabel", props: { htmlFor: L(() => {
    var s;
    return (s = o.value) == null ? void 0 : s.id;
  }), onClick(s) {
    o.value && (s.currentTarget.tagName === "LABEL" && s.preventDefault(), o.value.click(), o.value.focus({ preventScroll: !0 }));
  } } }), r = iV({ name: "SwitchDescription" });
  return Oi(J5, { switchRef: o, labelledby: i, describedby: r }), () => tn({ theirProps: n, ourProps: {}, slot: {}, slots: e, attrs: t, name: "SwitchGroup" });
} }), bV = H({ name: "Switch", emits: { "update:modelValue": (n) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-switch-${Jn()}` } }, inheritAttrs: !1, setup(n, { emit: e, attrs: t, slots: o, expose: i }) {
  let r = Uo(J5, null), [s, a] = Ih(L(() => n.modelValue), (g) => e("update:modelValue", g), L(() => n.defaultChecked));
  function l() {
    a(!s.value);
  }
  let d = R(null), u = r === null ? d : r.switchRef, c = Lh(L(() => ({ as: n.as, type: t.type })), u);
  i({ el: u, $el: u });
  function f(g) {
    g.preventDefault(), l();
  }
  function h(g) {
    g.key === Ue.Space ? (g.preventDefault(), l()) : g.key === Ue.Enter && KB(g.currentTarget);
  }
  function p(g) {
    g.preventDefault();
  }
  let m = L(() => {
    var g, b;
    return (b = (g = Me(u)) == null ? void 0 : g.closest) == null ? void 0 : b.call(g, "form");
  });
  return We(() => {
    Ee([m], () => {
      if (!m.value || n.defaultChecked === void 0) return;
      function g() {
        a(n.defaultChecked);
      }
      return m.value.addEventListener("reset", g), () => {
        var b;
        (b = m.value) == null || b.removeEventListener("reset", g);
      };
    }, { immediate: !0 });
  }), () => {
    let { id: g, name: b, value: x, form: w, ...M } = n, $ = { checked: s.value }, T = { id: g, ref: u, role: "switch", type: c.value, tabIndex: 0, "aria-checked": s.value, "aria-labelledby": r == null ? void 0 : r.labelledby.value, "aria-describedby": r == null ? void 0 : r.describedby.value, onClick: f, onKeyup: h, onKeypress: p };
    return lt(re, [b != null && s.value != null ? lt(Fh, Rh({ features: Bu.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: s.value, form: w, name: b, value: x })) : null, tn({ ourProps: T, theirProps: { ...t, ...xs(M, ["modelValue", "defaultChecked"]) }, slot: $, attrs: t, slots: o, name: "Switch" })]);
  };
} });
const yV = {
  key: 0,
  class: "mb-3"
}, xV = {
  key: 0,
  class: "flex items-start"
}, CV = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, wV = {
  key: 1,
  class: "flex items-center"
}, kV = { class: "relative mt-1" }, $V = ["onClick"], MV = ["src"], SV = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, _V = { class: "items-center px-3 py-2 sm:flex sm:justify-between" }, EV = { class: "flex items-center" }, OV = ["src"], TV = { class: "block text-mgm-txt-sm font-medium text-foreground-emphasis" }, AV = /* @__PURE__ */ H({
  __name: "FieldSearch",
  props: {
    id: {},
    modelValue: { default: null },
    multiple: { type: Boolean, default: !0 },
    options: {},
    createOption: { type: Boolean, default: !1 },
    label: { default: null },
    description: { default: null },
    selectionDisplayType: { default: "top-badge" },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    locale: { default: "en" },
    deleteTextButton: { default: "generic.delete" }
  },
  emits: ["create-option", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, { t: o } = Tn({ useScope: "global" }), i = R(""), r = L(() => {
      const h = Array.isArray(t.modelValue) ? t.modelValue : [t.modelValue];
      return t.options.filter((p) => p.value !== void 0 && h.includes(p.value));
    }), s = L({
      get() {
        return t.multiple ? r.value : r.value[0] ?? null;
      },
      set(h) {
        const p = (Array.isArray(h) ? h : h ? [h] : []).map((m) => m.value);
        l("update:modelValue", t.multiple ? p : p[0] ?? null), t.multiple || (i.value = "");
      }
    }), a = L(
      () => i.value ? [
        ...t.options.filter((h) => {
          if (h.label)
            return h.label.toLowerCase().includes(i.value.toLowerCase());
        }),
        ...!t.options.find(
          (h) => h.label && h.label.toLowerCase() === i.value.toLowerCase()
        ) && t.createOption ? [
          {
            label: `${o("create")} "${i.value}"`,
            value: i.value
          }
        ] : []
      ] : t.options
    ), l = e, d = (h) => {
      t.options.find((p) => p.value === (h == null ? void 0 : h.value)) || (l("create-option", h.value), l("update:modelValue", t.multiple ? [...Array.isArray(t.modelValue) ? t.modelValue : [], h.value] : h.value));
    }, u = (h) => typeof h == "object" && h !== null && "label" in h, c = (h) => u(h) ? h.label ?? "" : "", f = (h) => {
      const p = (Array.isArray(t.modelValue) ? t.modelValue : []).filter((m) => m !== h.value);
      l("update:modelValue", p);
    };
    return (h, p) => {
      var m, g;
      return v(), C("div", null, [
        n.label || n.description ? (v(), C("div", yV, [
          n.label ? (v(), C("div", xV, [
            U(_e, {
              for: n.id,
              label: n.label
            }, null, 8, ["for", "label"]),
            n.required ? (v(), C("span", CV, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        n.multiple && n.selectionDisplayType === "top-badge" ? (v(), C("div", wV, [
          (v(!0), C(re, null, De(r.value, (b) => (v(), V(Jc, {
            key: b.value,
            "data-cy": "selected-option",
            class: "mr-3 mt-1 flex-row-reverse",
            text: b.label,
            "icon-type": "custom"
          }, {
            icon: B(() => [
              U(ye, {
                class: "ml-1 cursor-pointer",
                size: 12,
                color: "var(--color-foreground-brand-default)",
                icon: "close",
                onClick: (x) => f(b)
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["text"]))), 128))
        ])) : _("", !0),
        U(k(XB), {
          modelValue: s.value,
          "onUpdate:modelValue": p[1] || (p[1] = (b) => s.value = b),
          multiple: n.multiple,
          as: "div"
        }, {
          default: B(() => {
            var b;
            return [
              y("div", kV, [
                U(ye, {
                  class: "absolute inset-y-0 left-0 flex h-10 w-10 items-center rounded-r-md focus:outline-none",
                  color: "var(--color-border-subtle)",
                  icon: "search"
                }),
                U(k(eV), {
                  id: n.id,
                  class: "w-full rounded-md border border-border-subtle bg-background-default py-2 pl-10 pr-10 shadow-sm focus:border-border-default focus:outline-none focus:ring-1 focus:ring-border-default sm:text-mgm-txt-sm",
                  "display-value": c,
                  onChange: p[0] || (p[0] = (x) => i.value = x.target.value)
                }, null, 8, ["id"]),
                U(k(QB), {
                  class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
                  "data-cy": "btn-select"
                }, {
                  default: B(() => [
                    U(ye, {
                      icon: "chevron-selector-vertical",
                      color: "var(--color-border-subtle)",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }),
                ((b = a.value) == null ? void 0 : b.length) > 0 ? (v(), V(k(tV), {
                  key: 0,
                  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-background-default py-1 text-base shadow-lg ring-1 ring-foreground-emphasis ring-opacity-5 focus:outline-none sm:text-mgm-txt-sm"
                }, {
                  default: B(() => [
                    (v(!0), C(re, null, De(a.value, (x) => (v(), V(k(nV), {
                      key: `${x.value}`,
                      value: x,
                      as: "template"
                    }, {
                      default: B(({ active: w, selected: M }) => [
                        y("li", {
                          class: J([
                            "relative cursor-default select-none py-2 pl-3 pr-9",
                            { "flex capitalize": x.icon },
                            w ? "bg-background-brand-emphasis text-foreground-on-emphasis" : "text-foreground-emphasis"
                          ]),
                          onClick: ($) => d(x)
                        }, [
                          x.icon ? (v(), C("img", {
                            key: 0,
                            class: "mr-3 h-6 w-6",
                            src: x.icon
                          }, null, 8, MV)) : _("", !0),
                          y("span", {
                            class: J(["block truncate", M && "font-semibold"])
                          }, j(x.label), 3),
                          M ? (v(), C("span", SV, [
                            U(ye, {
                              "aria-hidden": "true",
                              icon: "check",
                              color: w ? "var(--color-foreground-on-emphasis)" : "var(--color-foreground-brand-default)"
                            }, null, 8, ["color"])
                          ])) : _("", !0)
                        ], 10, $V)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                })) : _("", !0)
              ])
            ];
          }),
          _: 1
        }, 8, ["modelValue", "multiple"]),
        n.validation && ((m = n.validation.$errors) != null && m.length) ? (v(), V(_e, {
          key: 2,
          class: "mt-1",
          label: (g = n.validation.$errors[0]) == null ? void 0 : g.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0),
        n.multiple && n.selectionDisplayType === "bottom-card" ? (v(!0), C(re, { key: 3 }, De(r.value, (b) => (v(), C("div", {
          key: b.value,
          class: "relative mt-4 flex justify-between rounded-md bg-background-subtle-hover capitalize",
          "data-cy": "input-selected"
        }, [
          y("div", _V, [
            y("div", EV, [
              y("img", {
                class: "mr-3 h-6 w-6",
                src: b.icon
              }, null, 8, OV),
              y("span", TV, j(b.label), 1)
            ]),
            b.label != "phone" ? (v(), V(Ul, {
              key: 0,
              class: "absolute right-0 top-0 bottom-0",
              state: "trtr",
              text: k(o)(n.deleteTextButton),
              "data-cy": "btn-remove-selected",
              danger: "",
              onClick: (x) => f(b)
            }, null, 8, ["text", "onClick"])) : _("", !0)
          ])
        ]))), 128)) : _("", !0)
      ]);
    };
  }
});
function cm(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        create: (t) => {
          const { normalize: o } = t;
          return o(["Create"]);
        },
        delete: (t) => {
          const { normalize: o } = t;
          return o(["Delete"]);
        }
      },
      fr: {
        create: (t) => {
          const { normalize: o } = t;
          return o(["Créer"]);
        },
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Supprimer"]);
        }
      }
    }
  });
}
typeof cm == "function" && cm(AV);
const IV = {
  key: 0,
  class: "mb-1.5"
}, DV = {
  key: 0,
  class: "flex items-start"
}, NV = { class: "relative" }, PV = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, cY = /* @__PURE__ */ H({
  __name: "FieldSelect",
  props: {
    id: { default: null },
    modelValue: { type: [String, Boolean, Number, Array, null], default: null },
    options: {},
    multiple: { type: Boolean, default: !1 },
    label: { default: "" },
    description: { default: null },
    placeholder: { default: null },
    maxHeight: { default: "" },
    customColor: { default: null },
    customRgbColor: { default: null },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    darkMode: { type: Boolean, default: !1 },
    dropdownPlacement: { default: "bottom" }
  },
  emits: ["blur", "change", "focus", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = R(!1), i = t.multiple ? R(t.modelValue || []) : R(
      t.modelValue || void 0
    ), r = R(""), s = (f) => f.label !== void 0 && f.label !== null ? f.label.toString() : f.key !== void 0 && f.key !== null ? f.key.toString() : f.value.toString(), a = (f, h) => f === h ? !0 : f == null || h == null ? !1 : f.toString() === h.toString(), l = e;
    Ee(
      i,
      async (f) => {
        var h, p;
        if (Array.isArray(f))
          r.value = ((h = t.options) == null ? void 0 : h.filter(
            (m) => f.some((g) => a(m == null ? void 0 : m.value, g))
          ).map((m) => s(m)).join(", ")) ?? "";
        else {
          const m = (p = t.options) == null ? void 0 : p.find((g) => a(g.value, f));
          m && (r.value = s(m));
        }
        l("update:modelValue", f ?? void 0);
      },
      { immediate: !0 }
    ), Ee(i, (f, h) => {
      f !== h && l("change", t.id, f);
    }), Ee(
      () => t.modelValue,
      (f) => {
        i.value = f ?? void 0, f == null && (r.value = "");
      }
    );
    const d = (f) => {
      const h = f.target;
      o.value = !1, l("blur", h.value, t.id);
    }, u = (f) => {
      const h = f.target;
      o.value = !0, l("focus", h.value, t.id);
    }, c = () => {
      l("change", t.id, i.value);
    };
    return We(() => {
      var f, h;
      if (t.modelValue === null || t.modelValue === void 0)
        i.value = void 0, r.value = "";
      else if (t.multiple)
        r.value = (h = t.modelValue) == null ? void 0 : h.map((p) => {
          var g;
          const m = (g = t.options) == null ? void 0 : g.find(
            (b) => a(b.value, p)
          );
          return m ? s(m) : void 0;
        }).filter(
          (p) => p != null && p !== ""
        ).join(", ");
      else {
        i.value = t.modelValue;
        const p = (f = t.options) == null ? void 0 : f.find(
          (m) => a(m.value, t.modelValue)
        );
        r.value = p ? s(p) : "";
      }
    }), (f, h) => (v(), V(k(fV), {
      modelValue: k(i),
      "onUpdate:modelValue": h[0] || (h[0] = (p) => mv(i) ? i.value = p : null),
      multiple: n.multiple,
      as: "div"
    }, {
      default: B(() => {
        var p, m, g, b, x, w, M;
        return [
          n.label || n.description ? (v(), C("div", IV, [
            n.label ? (v(), C("div", DV, [
              U(_e, {
                id: `${n.id}`,
                label: n.label
              }, null, 8, ["id", "label"]),
              n.required ? (v(), C("span", {
                key: 0,
                class: J([
                  "ml-1 text-mgm-txt-sm font-medium",
                  { "text-foreground-brand-default": !n.customColor }
                ]),
                style: He({ color: n.customColor || void 0 })
              }, " * ", 6)) : _("", !0)
            ])) : _("", !0),
            n.description ? (v(), V(_e, {
              key: 1,
              label: n.description,
              description: ""
            }, null, 8, ["label"])) : _("", !0)
          ])) : _("", !0),
          y("div", NV, [
            U(k(hV), {
              "data-cy": "btn-select",
              class: J([
                "relative min-h-[38px] w-full text-mgm-txt-sm font-normal cursor-pointer rounded-md border bg-background-default py-2 pl-3 pr-10 text-left text-foreground-emphasis shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
                {
                  "border-border-subtle focus:border-border-default focus:ring-border-default": !n.customColor,
                  "border-border-danger-emphasis focus:border-border-danger-emphasis focus:ring-border-danger-emphasis": (((m = (p = n.validation) == null ? void 0 : p.$errors) == null ? void 0 : m.length) ?? 0) > 0
                },
                {
                  "!bg-white/10 !border-white/20 !text-white": n.darkMode
                }
              ]),
              style: He({
                borderColor: n.customColor && o.value ? n.customColor : void 0,
                boxShadow: n.customColor && o.value ? `0px 1px 2px rgba(${n.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${n.customRgbColor}, 0.2)` : void 0
              }),
              onBlur: d,
              onFocus: u
            }, {
              default: B(() => [
                y("span", {
                  "data-cy": "input-selected",
                  class: J([
                    "block",
                    {
                      truncate: !n.multiple,
                      "text-foreground-subtle": !r.value && n.placeholder
                    }
                  ])
                }, j(r.value || n.placeholder), 3),
                U(ye, {
                  class: "pointer-events-none absolute inset-y-0 right-2 flex items-center",
                  icon: "chevron-selector-vertical",
                  color: "var(--color-border-subtle)",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["class", "style"]),
            U(gv, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: B(() => [
                U(k(pV), {
                  class: J([
                    "absolute z-10 w-full overflow-auto rounded-md bg-background-default py-1 text-base shadow-lg ring-1 ring-foreground-emphasis ring-opacity-5 focus:outline-none sm:text-sm",
                    n.maxHeight ? n.maxHeight : "max-h-60",
                    n.dropdownPlacement === "top" ? "bottom-full mb-1" : "mt-1"
                  ])
                }, {
                  default: B(() => [
                    (v(!0), C(re, null, De(n.options, ($, T) => (v(), V(k(mV), {
                      key: T,
                      as: "template",
                      value: $.value,
                      onSelect: c
                    }, {
                      default: B(({ active: E, selected: S }) => [
                        y("li", {
                          class: J([
                            E ? "text-foreground-on-emphasis" : "text-foreground-emphasis",
                            "relative cursor-pointer select-none list-none py-2 pl-3 pr-9",
                            {
                              "bg-background-brand-emphasis": E && !n.customColor
                            }
                          ]),
                          style: He({
                            backgroundColor: E && n.customColor ? n.customColor : void 0
                          })
                        }, [
                          y("span", {
                            class: J([
                              "block truncate textforeground-emphasis text-mgm-txt-sm",
                              S ? "font-semibold" : "font-normal"
                            ])
                          }, j(s($)), 3),
                          S ? (v(), C("span", PV, [
                            U(ye, {
                              "aria-hidden": "true",
                              icon: "check",
                              color: E ? "var(--color-foreground-on-emphasis)" : n.customColor ? n.customColor : "var(--color-foreground-brand-default)"
                            }, null, 8, ["color"])
                          ])) : _("", !0)
                        ], 6)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          (((b = (g = n.validation) == null ? void 0 : g.$errors) == null ? void 0 : b.length) ?? 0) > 0 ? (v(), V(_e, {
            key: 1,
            class: "mt-[3px]",
            label: (M = (w = (x = n.validation) == null ? void 0 : x.$errors) == null ? void 0 : w[0]) == null ? void 0 : M.$message,
            error: ""
          }, null, 8, ["label"])) : _("", !0)
        ];
      }),
      _: 1
    }, 8, ["modelValue", "multiple"]));
  }
}), LV = { class: "sm:col-span-8" }, RV = { class: "relative mt-2 flex items-center rounded-[5px] bg-background-subtle px-4 py-[18px] text-mgm-txt-sm font-normal text-foreground-default" }, FV = { class: "block w-[416px] truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, BV = {
  key: 0,
  class: "border-x border-border-default px-3 py-[9px]"
}, VV = { class: "block w-[416px] truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, zV = /* @__PURE__ */ H({
  __name: "FieldSelector",
  props: {
    modelValue: { default: null },
    items: {},
    type: { default: "challenge" },
    title: { default: "" },
    description: { default: "" },
    locale: { default: "en" },
    icon: { default: "" },
    hasAllItemsSelector: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "" },
    selectedPlaceholder: { default: "" },
    allItemsSelectorPlaceholder: { default: "" },
    selectedPlaceholderAll: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, { t: o, locale: i } = Tn(), r = R(!0), s = R(null), a = R(!1), l = R(""), d = L(() => t.items.filter((g) => g.type === "checkbox")), u = L(() => l.value ? t.items.filter((g) => g.name.toLowerCase().includes(l.value.toLowerCase()) && g.type !== "heading") : t.items), c = L(() => {
      var g, b;
      return ((g = t.modelValue) == null ? void 0 : g.length) === ((b = d.value) == null ? void 0 : b.length) && t.hasAllItemsSelector;
    });
    We(() => {
      c.value || (r.value = !1);
    });
    const f = e, h = async (g) => {
      g ? (f(
        "update:modelValue",
        d.value.map((b) => b.id)
      ), r.value = !0) : (f("update:modelValue", []), r.value = !1);
    }, p = async (g, b) => {
      g && r.value ? (f("update:modelValue", [b]), r.value = !1) : g ? f("update:modelValue", [...t.modelValue ?? [], b]) : f(
        "update:modelValue",
        (t.modelValue ?? []).filter((x) => x !== b)
      );
    }, m = () => {
      a.value = !a.value;
    };
    return A5(s, (g) => {
      g.stopPropagation(), a.value && (a.value = !1);
    }), (g, b) => {
      var x, w, M;
      return v(), C("div", LV, [
        n.title ? (v(), V(_e, {
          key: 0,
          class: "mb-px",
          label: n.title
        }, null, 8, ["label"])) : _("", !0),
        n.description ? (v(), V(_e, {
          key: 1,
          label: n.description,
          class: "mb-1.5",
          description: ""
        }, null, 8, ["label"])) : _("", !0),
        y("div", RV, [
          n.icon ? (v(), V(ye, {
            key: 0,
            class: "mr-2",
            color: "var(--color-foreground-default)",
            icon: n.icon
          }, null, 8, ["icon"])) : _("", !0),
          Se(" " + j(k(o)("from")) + " ", 1),
          y("button", {
            type: "button",
            class: "mx-2 flex min-w-fit items-center font-medium text-foreground-emphasis",
            onClick: m
          }, [
            Se(j(c.value ? n.selectedPlaceholderAll : `${(x = n.modelValue) == null ? void 0 : x.length} ${k(o)(
              `${n.selectedPlaceholder}.${((w = n.modelValue) == null ? void 0 : w.length) !== 1 ? "plural" : "singular"}`
            )}`) + " ", 1),
            U(ye, {
              class: "ml-1",
              icon: a.value ? "chevron-up" : "chevron-down"
            }, null, 8, ["icon"])
          ]),
          a.value ? (v(), C("div", {
            key: 1,
            ref_key: "menuRef",
            ref: s,
            class: "absolute bottom-10 left-0 z-10 w-[480px] rounded-b-[4.16px] border-border-default bg-background-default shadow-[0px_4px_6px_-2px_rgba(28,31,39,0.03),0px_12px_16px_-4px_rgba(28,31,39,0.08)]"
          }, [
            U(C5, {
              modelValue: l.value,
              "onUpdate:modelValue": b[0] || (b[0] = ($) => l.value = $),
              role: "search",
              locale: k(i),
              placeholder: `${k(o)("search")} ${n.searchPlaceholder}...`,
              "no-rounded-bottom": ""
            }, null, 8, ["modelValue", "locale", "placeholder"]),
            !((M = l.value) != null && M.length) && n.hasAllItemsSelector ? (v(), V(ha, {
              key: 0,
              id: "allItems",
              class: "border-x border-border-default px-3 py-[9px]",
              "model-value": c.value && r.value,
              "onUpdate:modelValue": h
            }, {
              default: B(() => [
                y("span", FV, j(n.allItemsSelectorPlaceholder), 1)
              ]),
              _: 1
            }, 8, ["model-value"])) : _("", !0),
            (v(!0), C(re, null, De(u.value, ($) => (v(), C(re, {
              key: $.id
            }, [
              $.type === "heading" ? (v(), C("div", BV, j($.name), 1)) : $.type === "checkbox" ? (v(), V(ha, {
                key: 1,
                id: $.id,
                class: "border-x border-border-default px-3 py-[9px] last-of-type:rounded-b-[4.16px]",
                "model-value": (n.modelValue || []).includes($.id) && !r.value,
                onChange: p
              }, {
                default: B(() => [
                  y("span", VV, j($.name), 1)
                ]),
                _: 2
              }, 1032, ["id", "model-value"])) : _("", !0)
            ], 64))), 128))
          ], 512)) : _("", !0),
          Se(" " + j(k(o)(`access.${n.type}`)), 1)
        ])
      ]);
    };
  }
});
function fm(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        access: {
          challenge: (t) => {
            const { normalize: o } = t;
            return o(["will have access to this challenge"]);
          },
          reward: (t) => {
            const { normalize: o } = t;
            return o(["will have access to this reward"]);
          }
        },
        from: (t) => {
          const { normalize: o } = t;
          return o(["Ambassadors from"]);
        },
        search: (t) => {
          const { normalize: o } = t;
          return o(["Search"]);
        },
        selectedCampaign: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["selected campaign"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["selected campaigns"]);
          }
        },
        selectedTag: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["selected tag"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["selected tags"]);
          }
        }
      },
      fr: {
        access: {
          challenge: (t) => {
            const { normalize: o } = t;
            return o(["auront accès à ce challenge"]);
          },
          reward: (t) => {
            const { normalize: o } = t;
            return o(["auront accès à cette récompense"]);
          }
        },
        from: (t) => {
          const { normalize: o } = t;
          return o(["Ambassadeurs de"]);
        },
        search: (t) => {
          const { normalize: o } = t;
          return o(["Recherchez"]);
        },
        selectedCampaign: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["campagne sélectionnée"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["campagnes sélectionnées"]);
          }
        },
        selectedTag: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["tag sélectionné"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["tags sélectionnés"]);
          }
        }
      }
    }
  });
}
typeof fm == "function" && fm(zV);
const HV = ["onClick"], fY = /* @__PURE__ */ H({
  __name: "FieldTabs",
  props: {
    modelValue: { default: null },
    tabs: {},
    type: { default: "button" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = e, o = (i) => {
      t("update:modelValue", i);
    };
    return (i, r) => (v(), C("div", {
      class: J([
        "flex select-none",
        {
          "items-center": n.type === "button",
          "items-start": n.type === "underline"
        }
      ])
    }, [
      (v(!0), C(re, null, De(n.tabs, (s) => (v(), C("button", {
        key: s.value,
        class: J([
          "cursor-pointer whitespace-nowrap text-mgm-txt-sm font-normal",
          {
            hidden: s.hidden,
            // default
            "text-foreground-default": n.modelValue != s.value,
            // type === 'button'
            /// default
            "flex h-8 min-w-[48px] items-center justify-center rounded-[48px] px-6": n.type === "button",
            "hover:bg-background-subtle-hover": n.type === "button" && n.modelValue != s.value,
            /// active
            "bg-background-brand-default-hover text-foreground-brand-default": n.type === "button" && n.modelValue === s.value,
            // type === 'underline'
            /// default
            "mr-4 hover:text-foreground-emphasis focus:text-foreground-emphasis": n.type === "underline",
            /// active
            "text-foreground-emphasis": n.type === "underline" && n.modelValue === s.value
          }
        ]),
        onClick: (a) => o(s.value)
      }, [
        y("span", {
          class: J({ "mb-2.5 block px-1": n.type === "underline" })
        }, j(s.label), 3),
        n.type === "underline" ? (v(), C("div", {
          key: 0,
          class: J([
            n.modelValue === s.value ? "h-[3px] w-full rounded-t-[3px] bg-background-brand-emphasis" : "hidden"
          ])
        }, null, 2)) : _("", !0)
      ], 10, HV))), 128))
    ], 2));
  }
}), jV = {
  key: 0,
  class: "mb-1.5"
}, WV = {
  key: 0,
  class: "flex items-start"
}, UV = {
  key: 0,
  class: "ml-1 text-mgm-txt-sm font-medium text-foreground-brand-default"
}, KV = ["id", "autocomplete", "disabled", "name", "maxlength", "placeholder", "required", "rows"], GV = /* @__PURE__ */ H({
  __name: "FieldTextarea",
  props: {
    modelValue: { default: "" },
    id: { default: null },
    label: { default: null },
    description: { default: null },
    placeholder: { default: null },
    rows: { default: 4 },
    maxlength: { default: void 0 },
    autocomplete: { default: null },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    validation: { default: null }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(n, { emit: e }) {
    const t = n, o = R(), i = R(!1), r = e;
    We(() => u()), Ee(
      () => t.modelValue,
      () => {
        u();
      }
    );
    const s = (c) => {
      const f = c.target;
      i.value = !0, r("focus", f.value, t.id);
    }, a = (c) => {
      const f = c.target;
      i.value = !1, r("blur", f.value, t.id);
    }, l = (c) => {
      const h = c.target.value;
      r("change", h, t.id), r("update:modelValue", h, t.id);
    }, d = (c) => {
      c.code == "Enter" && r("submit", t.id);
    }, u = () => {
      if (o.value) {
        const c = o.value.querySelector("textarea");
        c && (c.value = t.modelValue);
      }
    };
    return (c, f) => {
      var h, p, m, g;
      return v(), C("div", {
        ref_key: "root",
        ref: o
      }, [
        n.label || n.description ? (v(), C("div", jV, [
          n.label ? (v(), C("div", WV, [
            U(_e, {
              id: `${n.id}`,
              label: n.label
            }, null, 8, ["id", "label"]),
            n.required ? (v(), C("span", UV, " * ")) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("textarea", {
          id: `${n.id}`,
          class: J(["box-border block max-h-60 w-full rounded-[4.16px] px-2.5 py-[9px] text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle", [
            (p = (h = n.validation) == null ? void 0 : h.$errors) != null && p.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default"
          ]]),
          autocomplete: n.autocomplete || void 0,
          disabled: n.disabled,
          name: `${n.id}`,
          maxlength: n.maxlength,
          placeholder: n.placeholder || void 0,
          required: n.required,
          rows: n.rows,
          onBlur: a,
          onFocus: s,
          onInput: l,
          onKeypress: d
        }, null, 42, KV),
        n.validation && ((m = n.validation.$errors) != null && m.length) ? (v(), V(_e, {
          key: 1,
          class: "mt-1",
          label: (g = n.validation.$errors[0]) == null ? void 0 : g.$message,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ], 512);
    };
  }
}), YV = { key: 0 }, hY = /* @__PURE__ */ H({
  __name: "FieldToggle",
  props: {
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: { default: null },
    label: { default: "" },
    description: { default: "" }
  },
  emits: ["change", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = R(t.modelValue), i = e;
    return Ee(o, async (r) => {
      i("change", r, t.id), i("update:modelValue", r);
    }), Ee(
      () => t.modelValue,
      (r) => o.value = r
    ), (r, s) => (v(), V(k(vV), {
      as: "div",
      class: J({ "flex w-full items-start justify-between": n.label || n.description })
    }, {
      default: B(() => [
        n.label || n.description ? (v(), C("div", YV, [
          n.label ? (v(), V(_e, {
            key: 0,
            id: `${n.id}`,
            label: n.label
          }, null, 8, ["id", "label"])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        U(k(bV), {
          modelValue: o.value,
          "onUpdate:modelValue": s[0] || (s[0] = (a) => o.value = a),
          class: J([
            o.value ? "bg-background-brand-emphasis" : n.disabled ? "bg-background-subtle" : "bg-border-subtle",
            n.disabled ? "cursor-not-allowed" : "cursor-pointer",
            "relative ml-4 inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-border-default focus:ring-offset-2"
          ]),
          disabled: n.disabled
        }, {
          default: B(() => [
            y("span", {
              "aria-hidden": "true",
              class: J([
                o.value ? "translate-x-5" : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-background-default shadow ring-0 transition duration-200 ease-in-out"
              ])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "disabled"])
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function qV(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
const X5 = (n, e, t) => Math.min(Math.max(t, n), e), zn = {
  duration: 0.3,
  delay: 0,
  endDelay: 0,
  repeat: 0,
  easing: "ease"
}, Ta = (n) => typeof n == "number", Kr = (n) => Array.isArray(n) && !Ta(n[0]), ZV = (n, e, t) => {
  const o = e - n;
  return ((t - n) % o + o) % o + n;
};
function JV(n, e) {
  return Kr(n) ? n[ZV(0, n.length, e)] : n;
}
const Q5 = (n, e, t) => -t * n + t * e + n, e9 = () => {
}, Ci = (n) => n, Vh = (n, e, t) => e - n === 0 ? 1 : (t - n) / (e - n);
function t9(n, e) {
  const t = n[n.length - 1];
  for (let o = 1; o <= e; o++) {
    const i = Vh(0, e, o);
    n.push(Q5(t, 1, i));
  }
}
function XV(n) {
  const e = [0];
  return t9(e, n - 1), e;
}
function QV(n, e = XV(n.length), t = Ci) {
  const o = n.length, i = o - e.length;
  return i > 0 && t9(e, i), (r) => {
    let s = 0;
    for (; s < o - 2 && !(r < e[s + 1]); s++)
      ;
    let a = X5(0, 1, Vh(e[s], e[s + 1], r));
    return a = JV(t, s)(a), Q5(n[s], n[s + 1], a);
  };
}
const n9 = (n) => Array.isArray(n) && Ta(n[0]), Qf = (n) => typeof n == "object" && !!n.createAnimation, fs = (n) => typeof n == "function", ez = (n) => typeof n == "string", ra = {
  ms: (n) => n * 1e3,
  s: (n) => n / 1e3
}, o9 = (n, e, t) => (((1 - 3 * t + 3 * e) * n + (3 * t - 6 * e)) * n + 3 * e) * n, tz = 1e-7, nz = 12;
function oz(n, e, t, o, i) {
  let r, s, a = 0;
  do
    s = e + (t - e) / 2, r = o9(s, o, i) - n, r > 0 ? t = s : e = s;
  while (Math.abs(r) > tz && ++a < nz);
  return s;
}
function zs(n, e, t, o) {
  if (n === e && t === o)
    return Ci;
  const i = (r) => oz(r, 0, 1, n, t);
  return (r) => r === 0 || r === 1 ? r : o9(i(r), e, o);
}
const iz = (n, e = "end") => (t) => {
  t = e === "end" ? Math.min(t, 0.999) : Math.max(t, 1e-3);
  const o = t * n, i = e === "end" ? Math.floor(o) : Math.ceil(o);
  return X5(0, 1, i / n);
}, rz = {
  ease: zs(0.25, 0.1, 0.25, 1),
  "ease-in": zs(0.42, 0, 1, 1),
  "ease-in-out": zs(0.42, 0, 0.58, 1),
  "ease-out": zs(0, 0, 0.58, 1)
}, sz = /\((.*?)\)/;
function e1(n) {
  if (fs(n))
    return n;
  if (n9(n))
    return zs(...n);
  const e = rz[n];
  if (e)
    return e;
  if (n.startsWith("steps")) {
    const t = sz.exec(n);
    if (t) {
      const o = t[1].split(",");
      return iz(parseFloat(o[0]), o[1].trim());
    }
  }
  return Ci;
}
let i9 = class {
  constructor(e, t = [0, 1], { easing: o, duration: i = zn.duration, delay: r = zn.delay, endDelay: s = zn.endDelay, repeat: a = zn.repeat, offset: l, direction: d = "normal", autoplay: u = !0 } = {}) {
    if (this.startTime = null, this.rate = 1, this.t = 0, this.cancelTimestamp = null, this.easing = Ci, this.duration = 0, this.totalDuration = 0, this.repeat = 0, this.playState = "idle", this.finished = new Promise((f, h) => {
      this.resolve = f, this.reject = h;
    }), o = o || zn.easing, Qf(o)) {
      const f = o.createAnimation(t);
      o = f.easing, t = f.keyframes || t, i = f.duration || i;
    }
    this.repeat = a, this.easing = Kr(o) ? Ci : e1(o), this.updateDuration(i);
    const c = QV(t, l, Kr(o) ? o.map(e1) : Ci);
    this.tick = (f) => {
      var h;
      r = r;
      let p = 0;
      this.pauseTime !== void 0 ? p = this.pauseTime : p = (f - this.startTime) * this.rate, this.t = p, p /= 1e3, p = Math.max(p - r, 0), this.playState === "finished" && this.pauseTime === void 0 && (p = this.totalDuration);
      const m = p / this.duration;
      let g = Math.floor(m), b = m % 1;
      !b && m >= 1 && (b = 1), b === 1 && g--;
      const x = g % 2;
      (d === "reverse" || d === "alternate" && x || d === "alternate-reverse" && !x) && (b = 1 - b);
      const w = p >= this.totalDuration ? 1 : Math.min(b, 1), M = c(this.easing(w));
      e(M), this.pauseTime === void 0 && (this.playState === "finished" || p >= this.totalDuration + s) ? (this.playState = "finished", (h = this.resolve) === null || h === void 0 || h.call(this, M)) : this.playState !== "idle" && (this.frameRequestId = requestAnimationFrame(this.tick));
    }, u && this.play();
  }
  play() {
    const e = performance.now();
    this.playState = "running", this.pauseTime !== void 0 ? this.startTime = e - this.pauseTime : this.startTime || (this.startTime = e), this.cancelTimestamp = this.startTime, this.pauseTime = void 0, this.frameRequestId = requestAnimationFrame(this.tick);
  }
  pause() {
    this.playState = "paused", this.pauseTime = this.t;
  }
  finish() {
    this.playState = "finished", this.tick(0);
  }
  stop() {
    var e;
    this.playState = "idle", this.frameRequestId !== void 0 && cancelAnimationFrame(this.frameRequestId), (e = this.reject) === null || e === void 0 || e.call(this, !1);
  }
  cancel() {
    this.stop(), this.tick(this.cancelTimestamp);
  }
  reverse() {
    this.rate *= -1;
  }
  commitStyles() {
  }
  updateDuration(e) {
    this.duration = e, this.totalDuration = e * (this.repeat + 1);
  }
  get currentTime() {
    return this.t;
  }
  set currentTime(e) {
    this.pauseTime !== void 0 || this.rate === 0 ? this.pauseTime = e : this.startTime = performance.now() - e / this.rate;
  }
  get playbackRate() {
    return this.rate;
  }
  set playbackRate(e) {
    this.rate = e;
  }
};
var t1 = function() {
};
process.env.NODE_ENV !== "production" && (t1 = function(n, e) {
  if (!n)
    throw new Error(e);
});
class az {
  setAnimation(e) {
    this.animation = e, e == null || e.finished.then(() => this.clearAnimation()).catch(() => {
    });
  }
  clearAnimation() {
    this.animation = this.generator = void 0;
  }
}
const Rc = /* @__PURE__ */ new WeakMap();
function r9(n) {
  return Rc.has(n) || Rc.set(n, {
    transforms: [],
    values: /* @__PURE__ */ new Map()
  }), Rc.get(n);
}
function lz(n, e) {
  return n.has(e) || n.set(e, new az()), n.get(e);
}
const dz = ["", "X", "Y", "Z"], uz = ["translate", "scale", "rotate", "skew"], Ud = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
}, hm = {
  syntax: "<angle>",
  initialValue: "0deg",
  toDefaultUnit: (n) => n + "deg"
}, cz = {
  translate: {
    syntax: "<length-percentage>",
    initialValue: "0px",
    toDefaultUnit: (n) => n + "px"
  },
  rotate: hm,
  scale: {
    syntax: "<number>",
    initialValue: 1,
    toDefaultUnit: Ci
  },
  skew: hm
}, Aa = /* @__PURE__ */ new Map(), zh = (n) => `--motion-${n}`, Kd = ["x", "y", "z"];
uz.forEach((n) => {
  dz.forEach((e) => {
    Kd.push(n + e), Aa.set(zh(n + e), cz[n]);
  });
});
const fz = (n, e) => Kd.indexOf(n) - Kd.indexOf(e), hz = new Set(Kd), s9 = (n) => hz.has(n), pz = (n, e) => {
  Ud[e] && (e = Ud[e]);
  const { transforms: t } = r9(n);
  qV(t, e), n.style.transform = mz(t);
}, mz = (n) => n.sort(fz).reduce(gz, "").trim(), gz = (n, e) => `${n} ${e}(var(${zh(e)}))`, n1 = (n) => n.startsWith("--"), pm = /* @__PURE__ */ new Set();
function vz(n) {
  if (!pm.has(n)) {
    pm.add(n);
    try {
      const { syntax: e, initialValue: t } = Aa.has(n) ? Aa.get(n) : {};
      CSS.registerProperty({
        name: n,
        inherits: !1,
        syntax: e,
        initialValue: t
      });
    } catch {
    }
  }
}
const Fc = (n, e) => document.createElement("div").animate(n, e), mm = {
  cssRegisterProperty: () => typeof CSS < "u" && Object.hasOwnProperty.call(CSS, "registerProperty"),
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
  partialKeyframes: () => {
    try {
      Fc({ opacity: [1] });
    } catch {
      return !1;
    }
    return !0;
  },
  finished: () => !!Fc({ opacity: [0, 1] }, { duration: 1e-3 }).finished,
  linearEasing: () => {
    try {
      Fc({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
      return !1;
    }
    return !0;
  }
}, Bc = {}, Vr = {};
for (const n in mm)
  Vr[n] = () => (Bc[n] === void 0 && (Bc[n] = mm[n]()), Bc[n]);
const bz = 0.015, yz = (n, e) => {
  let t = "";
  const o = Math.round(e / bz);
  for (let i = 0; i < o; i++)
    t += n(Vh(0, o - 1, i)) + ", ";
  return t.substring(0, t.length - 2);
}, gm = (n, e) => fs(n) ? Vr.linearEasing() ? `linear(${yz(n, e)})` : zn.easing : n9(n) ? xz(n) : n, xz = ([n, e, t, o]) => `cubic-bezier(${n}, ${e}, ${t}, ${o})`;
function Cz(n, e) {
  for (let t = 0; t < n.length; t++)
    n[t] === null && (n[t] = t ? n[t - 1] : e());
  return n;
}
const wz = (n) => Array.isArray(n) ? n : [n];
function o1(n) {
  return Ud[n] && (n = Ud[n]), s9(n) ? zh(n) : n;
}
const vl = {
  get: (n, e) => {
    e = o1(e);
    let t = n1(e) ? n.style.getPropertyValue(e) : getComputedStyle(n)[e];
    if (!t && t !== 0) {
      const o = Aa.get(e);
      o && (t = o.initialValue);
    }
    return t;
  },
  set: (n, e, t) => {
    e = o1(e), n1(e) ? n.style.setProperty(e, t) : n.style[e] = t;
  }
};
function a9(n, e = !0) {
  if (!(!n || n.playState === "finished"))
    try {
      n.stop ? n.stop() : (e && n.commitStyles(), n.cancel());
    } catch {
    }
}
function kz(n, e) {
  var t;
  let o = (e == null ? void 0 : e.toDefaultUnit) || Ci;
  const i = n[n.length - 1];
  if (ez(i)) {
    const r = ((t = i.match(/(-?[\d.]+)([a-z%]*)/)) === null || t === void 0 ? void 0 : t[2]) || "";
    r && (o = (s) => s + r);
  }
  return o;
}
function $z() {
  return window.__MOTION_DEV_TOOLS_RECORD;
}
function Mz(n, e, t, o = {}, i) {
  const r = $z(), s = o.record !== !1 && r;
  let a, { duration: l = zn.duration, delay: d = zn.delay, endDelay: u = zn.endDelay, repeat: c = zn.repeat, easing: f = zn.easing, persist: h = !1, direction: p, offset: m, allowWebkitAcceleration: g = !1, autoplay: b = !0 } = o;
  const x = r9(n), w = s9(e);
  let M = Vr.waapi();
  w && pz(n, e);
  const $ = o1(e), T = lz(x.values, $), E = Aa.get($);
  return a9(T.animation, !(Qf(f) && T.generator) && o.record !== !1), () => {
    const S = () => {
      var z, F;
      return (F = (z = vl.get(n, $)) !== null && z !== void 0 ? z : E == null ? void 0 : E.initialValue) !== null && F !== void 0 ? F : 0;
    };
    let D = Cz(wz(t), S);
    const I = kz(D, E);
    if (Qf(f)) {
      const z = f.createAnimation(D, e !== "opacity", S, $, T);
      f = z.easing, D = z.keyframes || D, l = z.duration || l;
    }
    if (n1($) && (Vr.cssRegisterProperty() ? vz($) : M = !1), w && !Vr.linearEasing() && (fs(f) || Kr(f) && f.some(fs)) && (M = !1), M) {
      E && (D = D.map((Y) => Ta(Y) ? E.toDefaultUnit(Y) : Y)), D.length === 1 && (!Vr.partialKeyframes() || s) && D.unshift(S());
      const z = {
        delay: ra.ms(d),
        duration: ra.ms(l),
        endDelay: ra.ms(u),
        easing: Kr(f) ? void 0 : gm(f, l),
        direction: p,
        iterations: c + 1,
        fill: "both"
      };
      a = n.animate({
        [$]: D,
        offset: m,
        easing: Kr(f) ? f.map((Y) => gm(Y, l)) : void 0
      }, z), a.finished || (a.finished = new Promise((Y, ie) => {
        a.onfinish = Y, a.oncancel = ie;
      }));
      const F = D[D.length - 1];
      a.finished.then(() => {
        h || (vl.set(n, $, F), a.cancel());
      }).catch(e9), g || (a.playbackRate = 1.000001);
    } else if (i && w)
      D = D.map((z) => typeof z == "string" ? parseFloat(z) : z), D.length === 1 && D.unshift(parseFloat(S())), a = new i((z) => {
        vl.set(n, $, I ? I(z) : z);
      }, D, Object.assign(Object.assign({}, o), {
        duration: l,
        easing: f
      }));
    else {
      const z = D[D.length - 1];
      vl.set(n, $, E && Ta(z) ? E.toDefaultUnit(z) : z);
    }
    return s && r(n, e, D, {
      duration: l,
      delay: d,
      easing: f,
      repeat: c,
      offset: m
    }, "motion-one"), T.setAnimation(a), a && !b && a.pause(), a;
  };
}
const Sz = (n, e) => (
  /**
   * TODO: Make test for this
   * Always return a new object otherwise delay is overwritten by results of stagger
   * and this results in no stagger
   */
  n[e] ? Object.assign(Object.assign({}, n), n[e]) : Object.assign({}, n)
);
function _z(n, e) {
  return typeof n == "string" ? n = document.querySelectorAll(n) : n instanceof Element && (n = [n]), Array.from(n || []);
}
const Ez = (n) => n(), l9 = (n, e, t = zn.duration) => new Proxy({
  animations: n.map(Ez).filter(Boolean),
  duration: t,
  options: e
}, Tz), Oz = (n) => n.animations[0], Tz = {
  get: (n, e) => {
    const t = Oz(n);
    switch (e) {
      case "duration":
        return n.duration;
      case "currentTime":
        return ra.s((t == null ? void 0 : t[e]) || 0);
      case "playbackRate":
      case "playState":
        return t == null ? void 0 : t[e];
      case "finished":
        return n.finished || (n.finished = Promise.all(n.animations.map(Az)).catch(e9)), n.finished;
      case "stop":
        return () => {
          n.animations.forEach((o) => a9(o));
        };
      case "forEachNative":
        return (o) => {
          n.animations.forEach((i) => o(i, n));
        };
      default:
        return typeof (t == null ? void 0 : t[e]) > "u" ? void 0 : () => n.animations.forEach((o) => o[e]());
    }
  },
  set: (n, e, t) => {
    switch (e) {
      case "currentTime":
        t = ra.ms(t);
      // Fall-through
      case "playbackRate":
        for (let o = 0; o < n.animations.length; o++)
          n.animations[o][e] = t;
        return !0;
    }
    return !1;
  }
}, Az = (n) => n.finished;
function Iz(n = 0.1, { start: e = 0, from: t = 0, easing: o } = {}) {
  return (i, r) => {
    const s = Ta(t) ? t : Dz(t, r), a = Math.abs(s - i);
    let l = n * a;
    if (o) {
      const d = r * n;
      l = e1(o)(l / d) * d;
    }
    return e + l;
  };
}
function Dz(n, e) {
  if (n === "first")
    return 0;
  {
    const t = e - 1;
    return n === "last" ? t : t / 2;
  }
}
function Nz(n, e, t) {
  return fs(n) ? n(e, t) : n;
}
function Pz(n) {
  return function(t, o, i = {}) {
    t = _z(t);
    const r = t.length;
    t1(!!r, "No valid element provided."), t1(!!o, "No keyframes defined.");
    const s = [];
    for (let a = 0; a < r; a++) {
      const l = t[a];
      for (const d in o) {
        const u = Sz(i, d);
        u.delay = Nz(u.delay, a, r);
        const c = Mz(l, d, o[d], u, n);
        s.push(c);
      }
    }
    return l9(
      s,
      i,
      /**
       * TODO:
       * If easing is set to spring or glide, duration will be dynamically
       * generated. Ideally we would dynamically generate this from
       * animation.effect.getComputedTiming().duration but this isn't
       * supported in iOS13 or our number polyfill. Perhaps it's possible
       * to Proxy animations returned from animateStyle that has duration
       * as a getter.
       */
      i.duration
    );
  };
}
const Lz = Pz(i9);
function Rz(n, e = {}) {
  return l9([
    () => {
      const t = new i9(n, [0, 1], e);
      return t.finished.catch(() => {
      }), t;
    }
  ], e, e.duration);
}
function Fz(n, e, t) {
  return (fs(n) ? Rz : Lz)(n, e, t);
}
const Bz = { class: "flex gap-2 items-end" }, Vz = { class: "flex-1" }, zz = { class: "w-full h-full absolute top-0 left-0" }, Hz = { class: "py-3 px-4 bg-background-emphasis shadow-sm absolute rounded-lg top-[10%] left-4 text-mgm-txt-sm hidden group-hover:block z-40" }, jz = { class: "text-border-default text-mgm-txt-sm whitespace-nowrap" }, Wz = { class: "text-white text-mgm-txt-sm whitespace-nowrap" }, Uz = { class: "w-full flex items-center justify-between mt-2" }, mY = /* @__PURE__ */ H({
  __name: "BarChart",
  props: {
    class: {},
    data: {},
    height: {},
    step: {}
  },
  setup(n) {
    const e = n, t = Math.max(...e.data.map((r) => r.value)), o = (r) => r / t * 100, i = Math.ceil(t / e.step);
    return We(() => {
      Fz(
        ".bar-chart",
        {
          opacity: [0, 1],
          height: [
            0,
            (r) => r.getBoundingClientRect().height
          ]
        },
        { delay: Iz(0.1), easing: "ease-in-out", duration: 1 }
      );
    }), (r, s) => (v(), C("div", Bz, [
      y("div", {
        class: "relative h-full w-12 text-right flex flex-col-reverse justify-between bottom-0 mb-[15px]",
        style: He({
          height: `${o((k(i) - 1) * n.step) * n.height / 100 + 20}px`
        })
      }, [
        (v(!0), C(re, null, De(k(i), (a, l) => (v(), C("span", {
          key: n.step + l,
          class: "text-right text-mgm-txt-sm text-foreground-subtle",
          style: He({ bottom: `calc(${o(l * n.step)}% - 8px)` })
        }, j(l * n.step), 5))), 128))
      ], 4),
      y("div", Vz, [
        y("div", {
          class: J(["w-full border-b border-border-subtle flex justify-between items-end relative", e.class]),
          style: He({ height: `${n.height}px` })
        }, [
          y("div", zz, [
            (v(!0), C(re, null, De(k(i), (a, l) => (v(), C("div", {
              key: "stepbar" + l,
              class: "w-full h-[1px] absolute bg-border-subtle",
              style: He({ bottom: `${o(l * n.step)}%` })
            }, null, 4))), 128))
          ]),
          (v(!0), C(re, null, De(n.data, (a) => (v(), C("div", {
            key: `${a.legend}-${a.value}`,
            class: J(`w-6 ${a.value !== 0 ? "bg-background-brand-emphasis" : "bg-transparent"} rounded-t group relative bar-chart`),
            style: He({
              height: `${a.value !== 0 ? o(a.value) : 10}%`
            })
          }, [
            y("div", Hz, [
              y("p", jz, j(a.hover.title), 1),
              y("p", Wz, j(a.hover.value), 1)
            ])
          ], 6))), 128))
        ], 6),
        y("div", Uz, [
          (v(!0), C(re, null, De(n.data, (a) => (v(), C("span", {
            key: a.legend,
            class: "text-mgm-txt-xs text-foreground-subtle"
          }, j(a.legend), 1))), 128))
        ])
      ])
    ]));
  }
});
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Ka(n) {
  return n + 0.5 | 0;
}
const fi = (n, e, t) => Math.max(Math.min(n, t), e);
function Hs(n) {
  return fi(Ka(n * 2.55), 0, 255);
}
function wi(n) {
  return fi(Ka(n * 255), 0, 255);
}
function Do(n) {
  return fi(Ka(n / 2.55) / 100, 0, 1);
}
function vm(n) {
  return fi(Ka(n * 100), 0, 100);
}
const Nn = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, i1 = [..."0123456789ABCDEF"], Kz = (n) => i1[n & 15], Gz = (n) => i1[(n & 240) >> 4] + i1[n & 15], bl = (n) => (n & 240) >> 4 === (n & 15), Yz = (n) => bl(n.r) && bl(n.g) && bl(n.b) && bl(n.a);
function qz(n) {
  var e = n.length, t;
  return n[0] === "#" && (e === 4 || e === 5 ? t = {
    r: 255 & Nn[n[1]] * 17,
    g: 255 & Nn[n[2]] * 17,
    b: 255 & Nn[n[3]] * 17,
    a: e === 5 ? Nn[n[4]] * 17 : 255
  } : (e === 7 || e === 9) && (t = {
    r: Nn[n[1]] << 4 | Nn[n[2]],
    g: Nn[n[3]] << 4 | Nn[n[4]],
    b: Nn[n[5]] << 4 | Nn[n[6]],
    a: e === 9 ? Nn[n[7]] << 4 | Nn[n[8]] : 255
  })), t;
}
const Zz = (n, e) => n < 255 ? e(n) : "";
function Jz(n) {
  var e = Yz(n) ? Kz : Gz;
  return n ? "#" + e(n.r) + e(n.g) + e(n.b) + Zz(n.a, e) : void 0;
}
const Xz = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function d9(n, e, t) {
  const o = e * Math.min(t, 1 - t), i = (r, s = (r + n / 30) % 12) => t - o * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [i(0), i(8), i(4)];
}
function Qz(n, e, t) {
  const o = (i, r = (i + n / 60) % 6) => t - t * e * Math.max(Math.min(r, 4 - r, 1), 0);
  return [o(5), o(3), o(1)];
}
function eH(n, e, t) {
  const o = d9(n, 1, 0.5);
  let i;
  for (e + t > 1 && (i = 1 / (e + t), e *= i, t *= i), i = 0; i < 3; i++)
    o[i] *= 1 - e - t, o[i] += e;
  return o;
}
function tH(n, e, t, o, i) {
  return n === i ? (e - t) / o + (e < t ? 6 : 0) : e === i ? (t - n) / o + 2 : (n - e) / o + 4;
}
function Hh(n) {
  const t = n.r / 255, o = n.g / 255, i = n.b / 255, r = Math.max(t, o, i), s = Math.min(t, o, i), a = (r + s) / 2;
  let l, d, u;
  return r !== s && (u = r - s, d = a > 0.5 ? u / (2 - r - s) : u / (r + s), l = tH(t, o, i, u, r), l = l * 60 + 0.5), [l | 0, d || 0, a];
}
function jh(n, e, t, o) {
  return (Array.isArray(e) ? n(e[0], e[1], e[2]) : n(e, t, o)).map(wi);
}
function Wh(n, e, t) {
  return jh(d9, n, e, t);
}
function nH(n, e, t) {
  return jh(eH, n, e, t);
}
function oH(n, e, t) {
  return jh(Qz, n, e, t);
}
function u9(n) {
  return (n % 360 + 360) % 360;
}
function iH(n) {
  const e = Xz.exec(n);
  let t = 255, o;
  if (!e)
    return;
  e[5] !== o && (t = e[6] ? Hs(+e[5]) : wi(+e[5]));
  const i = u9(+e[2]), r = +e[3] / 100, s = +e[4] / 100;
  return e[1] === "hwb" ? o = nH(i, r, s) : e[1] === "hsv" ? o = oH(i, r, s) : o = Wh(i, r, s), {
    r: o[0],
    g: o[1],
    b: o[2],
    a: t
  };
}
function rH(n, e) {
  var t = Hh(n);
  t[0] = u9(t[0] + e), t = Wh(t), n.r = t[0], n.g = t[1], n.b = t[2];
}
function sH(n) {
  if (!n)
    return;
  const e = Hh(n), t = e[0], o = vm(e[1]), i = vm(e[2]);
  return n.a < 255 ? `hsla(${t}, ${o}%, ${i}%, ${Do(n.a)})` : `hsl(${t}, ${o}%, ${i}%)`;
}
const bm = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, ym = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function aH() {
  const n = {}, e = Object.keys(ym), t = Object.keys(bm);
  let o, i, r, s, a;
  for (o = 0; o < e.length; o++) {
    for (s = a = e[o], i = 0; i < t.length; i++)
      r = t[i], a = a.replace(r, bm[r]);
    r = parseInt(ym[s], 16), n[a] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return n;
}
let yl;
function lH(n) {
  yl || (yl = aH(), yl.transparent = [0, 0, 0, 0]);
  const e = yl[n.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const dH = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function uH(n) {
  const e = dH.exec(n);
  let t = 255, o, i, r;
  if (e) {
    if (e[7] !== o) {
      const s = +e[7];
      t = e[8] ? Hs(s) : fi(s * 255, 0, 255);
    }
    return o = +e[1], i = +e[3], r = +e[5], o = 255 & (e[2] ? Hs(o) : fi(o, 0, 255)), i = 255 & (e[4] ? Hs(i) : fi(i, 0, 255)), r = 255 & (e[6] ? Hs(r) : fi(r, 0, 255)), {
      r: o,
      g: i,
      b: r,
      a: t
    };
  }
}
function cH(n) {
  return n && (n.a < 255 ? `rgba(${n.r}, ${n.g}, ${n.b}, ${Do(n.a)})` : `rgb(${n.r}, ${n.g}, ${n.b})`);
}
const Vc = (n) => n <= 31308e-7 ? n * 12.92 : Math.pow(n, 1 / 2.4) * 1.055 - 0.055, Ir = (n) => n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
function fH(n, e, t) {
  const o = Ir(Do(n.r)), i = Ir(Do(n.g)), r = Ir(Do(n.b));
  return {
    r: wi(Vc(o + t * (Ir(Do(e.r)) - o))),
    g: wi(Vc(i + t * (Ir(Do(e.g)) - i))),
    b: wi(Vc(r + t * (Ir(Do(e.b)) - r))),
    a: n.a + t * (e.a - n.a)
  };
}
function xl(n, e, t) {
  if (n) {
    let o = Hh(n);
    o[e] = Math.max(0, Math.min(o[e] + o[e] * t, e === 0 ? 360 : 1)), o = Wh(o), n.r = o[0], n.g = o[1], n.b = o[2];
  }
}
function c9(n, e) {
  return n && Object.assign(e || {}, n);
}
function xm(n) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(n) ? n.length >= 3 && (e = { r: n[0], g: n[1], b: n[2], a: 255 }, n.length > 3 && (e.a = wi(n[3]))) : (e = c9(n, { r: 0, g: 0, b: 0, a: 1 }), e.a = wi(e.a)), e;
}
function hH(n) {
  return n.charAt(0) === "r" ? uH(n) : iH(n);
}
class Ia {
  constructor(e) {
    if (e instanceof Ia)
      return e;
    const t = typeof e;
    let o;
    t === "object" ? o = xm(e) : t === "string" && (o = qz(e) || lH(e) || hH(e)), this._rgb = o, this._valid = !!o;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = c9(this._rgb);
    return e && (e.a = Do(e.a)), e;
  }
  set rgb(e) {
    this._rgb = xm(e);
  }
  rgbString() {
    return this._valid ? cH(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Jz(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? sH(this._rgb) : void 0;
  }
  mix(e, t) {
    if (e) {
      const o = this.rgb, i = e.rgb;
      let r;
      const s = t === r ? 0.5 : t, a = 2 * s - 1, l = o.a - i.a, d = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      r = 1 - d, o.r = 255 & d * o.r + r * i.r + 0.5, o.g = 255 & d * o.g + r * i.g + 0.5, o.b = 255 & d * o.b + r * i.b + 0.5, o.a = s * o.a + (1 - s) * i.a, this.rgb = o;
    }
    return this;
  }
  interpolate(e, t) {
    return e && (this._rgb = fH(this._rgb, e._rgb, t)), this;
  }
  clone() {
    return new Ia(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = wi(e), this;
  }
  clearer(e) {
    const t = this._rgb;
    return t.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, t = Ka(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = t, this;
  }
  opaquer(e) {
    const t = this._rgb;
    return t.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return xl(this._rgb, 2, e), this;
  }
  darken(e) {
    return xl(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return xl(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return xl(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return rH(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function _o() {
}
const pH = /* @__PURE__ */ (() => {
  let n = 0;
  return () => n++;
})();
function pt(n) {
  return n == null;
}
function Nt(n) {
  if (Array.isArray && Array.isArray(n))
    return !0;
  const e = Object.prototype.toString.call(n);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function je(n) {
  return n !== null && Object.prototype.toString.call(n) === "[object Object]";
}
function Gn(n) {
  return (typeof n == "number" || n instanceof Number) && isFinite(+n);
}
function ao(n, e) {
  return Gn(n) ? n : e;
}
function Je(n, e) {
  return typeof n > "u" ? e : n;
}
const mH = (n, e) => typeof n == "string" && n.endsWith("%") ? parseFloat(n) / 100 : +n / e, f9 = (n, e) => typeof n == "string" && n.endsWith("%") ? parseFloat(n) / 100 * e : +n;
function at(n, e, t) {
  if (n && typeof n.call == "function")
    return n.apply(t, e);
}
function et(n, e, t, o) {
  let i, r, s;
  if (Nt(n))
    for (r = n.length, i = 0; i < r; i++)
      e.call(t, n[i], i);
  else if (je(n))
    for (s = Object.keys(n), r = s.length, i = 0; i < r; i++)
      e.call(t, n[s[i]], s[i]);
}
function Gd(n, e) {
  let t, o, i, r;
  if (!n || !e || n.length !== e.length)
    return !1;
  for (t = 0, o = n.length; t < o; ++t)
    if (i = n[t], r = e[t], i.datasetIndex !== r.datasetIndex || i.index !== r.index)
      return !1;
  return !0;
}
function Yd(n) {
  if (Nt(n))
    return n.map(Yd);
  if (je(n)) {
    const e = /* @__PURE__ */ Object.create(null), t = Object.keys(n), o = t.length;
    let i = 0;
    for (; i < o; ++i)
      e[t[i]] = Yd(n[t[i]]);
    return e;
  }
  return n;
}
function h9(n) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(n) === -1;
}
function gH(n, e, t, o) {
  if (!h9(n))
    return;
  const i = e[n], r = t[n];
  je(i) && je(r) ? Da(i, r, o) : e[n] = Yd(r);
}
function Da(n, e, t) {
  const o = Nt(e) ? e : [
    e
  ], i = o.length;
  if (!je(n))
    return n;
  t = t || {};
  const r = t.merger || gH;
  let s;
  for (let a = 0; a < i; ++a) {
    if (s = o[a], !je(s))
      continue;
    const l = Object.keys(s);
    for (let d = 0, u = l.length; d < u; ++d)
      r(l[d], n, s, t);
  }
  return n;
}
function sa(n, e) {
  return Da(n, e, {
    merger: vH
  });
}
function vH(n, e, t) {
  if (!h9(n))
    return;
  const o = e[n], i = t[n];
  je(o) && je(i) ? sa(o, i) : Object.prototype.hasOwnProperty.call(e, n) || (e[n] = Yd(i));
}
const Cm = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (n) => n,
  // default resolvers
  x: (n) => n.x,
  y: (n) => n.y
};
function bH(n) {
  const e = n.split("."), t = [];
  let o = "";
  for (const i of e)
    o += i, o.endsWith("\\") ? o = o.slice(0, -1) + "." : (t.push(o), o = "");
  return t;
}
function yH(n) {
  const e = bH(n);
  return (t) => {
    for (const o of e) {
      if (o === "")
        break;
      t = t && t[o];
    }
    return t;
  };
}
function Na(n, e) {
  return (Cm[e] || (Cm[e] = yH(e)))(n);
}
function Uh(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
const qd = (n) => typeof n < "u", _i = (n) => typeof n == "function", wm = (n, e) => {
  if (n.size !== e.size)
    return !1;
  for (const t of n)
    if (!e.has(t))
      return !1;
  return !0;
};
function xH(n) {
  return n.type === "mouseup" || n.type === "click" || n.type === "contextmenu";
}
const nt = Math.PI, St = 2 * nt, Zd = Number.POSITIVE_INFINITY, CH = nt / 180, Ot = nt / 2, Vi = nt / 4, km = nt * 2 / 3, p9 = Math.log10, Jd = Math.sign;
function zl(n, e, t) {
  return Math.abs(n - e) < t;
}
function $m(n) {
  const e = Math.round(n);
  n = zl(n, e, n / 1e3) ? e : n;
  const t = Math.pow(10, Math.floor(p9(n))), o = n / t;
  return (o <= 1 ? 1 : o <= 2 ? 2 : o <= 5 ? 5 : 10) * t;
}
function wH(n) {
  const e = [], t = Math.sqrt(n);
  let o;
  for (o = 1; o < t; o++)
    n % o === 0 && (e.push(o), e.push(n / o));
  return t === (t | 0) && e.push(t), e.sort((i, r) => i - r).pop(), e;
}
function kH(n) {
  return typeof n == "symbol" || typeof n == "object" && n !== null && !(Symbol.toPrimitive in n || "toString" in n || "valueOf" in n);
}
function Xd(n) {
  return !kH(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $H(n, e) {
  const t = Math.round(n);
  return t - e <= n && t + e >= n;
}
function MH(n, e, t) {
  let o, i, r;
  for (o = 0, i = n.length; o < i; o++)
    r = n[o][t], isNaN(r) || (e.min = Math.min(e.min, r), e.max = Math.max(e.max, r));
}
function Lo(n) {
  return n * (nt / 180);
}
function SH(n) {
  return n * (180 / nt);
}
function Mm(n) {
  if (!Gn(n))
    return;
  let e = 1, t = 0;
  for (; Math.round(n * e) / e !== n; )
    e *= 10, t++;
  return t;
}
function m9(n, e) {
  const t = e.x - n.x, o = e.y - n.y, i = Math.sqrt(t * t + o * o);
  let r = Math.atan2(o, t);
  return r < -0.5 * nt && (r += St), {
    angle: r,
    distance: i
  };
}
function _H(n, e) {
  return Math.sqrt(Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2));
}
function po(n) {
  return (n % St + St) % St;
}
function Qd(n, e, t, o) {
  const i = po(n), r = po(e), s = po(t), a = po(r - i), l = po(s - i), d = po(i - r), u = po(i - s);
  return i === r || i === s || o && r === s || a > l && d < u;
}
function yn(n, e, t) {
  return Math.max(e, Math.min(t, n));
}
function EH(n) {
  return yn(n, -32768, 32767);
}
function Xi(n, e, t, o = 1e-6) {
  return n >= Math.min(e, t) - o && n <= Math.max(e, t) + o;
}
function Kh(n, e, t) {
  t = t || ((s) => n[s] < e);
  let o = n.length - 1, i = 0, r;
  for (; o - i > 1; )
    r = i + o >> 1, t(r) ? i = r : o = r;
  return {
    lo: i,
    hi: o
  };
}
const r1 = (n, e, t, o) => Kh(n, t, o ? (i) => {
  const r = n[i][e];
  return r < t || r === t && n[i + 1][e] === t;
} : (i) => n[i][e] < t), OH = (n, e, t) => Kh(n, t, (o) => n[o][e] >= t);
function TH(n, e, t) {
  let o = 0, i = n.length;
  for (; o < i && n[o] < e; )
    o++;
  for (; i > o && n[i - 1] > t; )
    i--;
  return o > 0 || i < n.length ? n.slice(o, i) : n;
}
const g9 = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function AH(n, e) {
  if (n._chartjs) {
    n._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(n, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), g9.forEach((t) => {
    const o = "_onData" + Uh(t), i = n[t];
    Object.defineProperty(n, t, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const s = i.apply(this, r);
        return n._chartjs.listeners.forEach((a) => {
          typeof a[o] == "function" && a[o](...r);
        }), s;
      }
    });
  });
}
function Sm(n, e) {
  const t = n._chartjs;
  if (!t)
    return;
  const o = t.listeners, i = o.indexOf(e);
  i !== -1 && o.splice(i, 1), !(o.length > 0) && (g9.forEach((r) => {
    delete n[r];
  }), delete n._chartjs);
}
function IH(n) {
  const e = new Set(n);
  return e.size === n.length ? n : Array.from(e);
}
const v9 = (function() {
  return typeof window > "u" ? function(n) {
    return n();
  } : window.requestAnimationFrame;
})();
function b9(n, e) {
  let t = [], o = !1;
  return function(...i) {
    t = i, o || (o = !0, v9.call(window, () => {
      o = !1, n.apply(e, t);
    }));
  };
}
function DH(n, e) {
  let t;
  return function(...o) {
    return e ? (clearTimeout(t), t = setTimeout(n, e, o)) : n.apply(this, o), e;
  };
}
const Gh = (n) => n === "start" ? "left" : n === "end" ? "right" : "center", Kt = (n, e, t) => n === "start" ? e : n === "end" ? t : (e + t) / 2, NH = (n, e, t, o) => n === (o ? "left" : "right") ? t : n === "center" ? (e + t) / 2 : e, Cl = (n) => n === 0 || n === 1, _m = (n, e, t) => -(Math.pow(2, 10 * (n -= 1)) * Math.sin((n - e) * St / t)), Em = (n, e, t) => Math.pow(2, -10 * n) * Math.sin((n - e) * St / t) + 1, aa = {
  linear: (n) => n,
  easeInQuad: (n) => n * n,
  easeOutQuad: (n) => -n * (n - 2),
  easeInOutQuad: (n) => (n /= 0.5) < 1 ? 0.5 * n * n : -0.5 * (--n * (n - 2) - 1),
  easeInCubic: (n) => n * n * n,
  easeOutCubic: (n) => (n -= 1) * n * n + 1,
  easeInOutCubic: (n) => (n /= 0.5) < 1 ? 0.5 * n * n * n : 0.5 * ((n -= 2) * n * n + 2),
  easeInQuart: (n) => n * n * n * n,
  easeOutQuart: (n) => -((n -= 1) * n * n * n - 1),
  easeInOutQuart: (n) => (n /= 0.5) < 1 ? 0.5 * n * n * n * n : -0.5 * ((n -= 2) * n * n * n - 2),
  easeInQuint: (n) => n * n * n * n * n,
  easeOutQuint: (n) => (n -= 1) * n * n * n * n + 1,
  easeInOutQuint: (n) => (n /= 0.5) < 1 ? 0.5 * n * n * n * n * n : 0.5 * ((n -= 2) * n * n * n * n + 2),
  easeInSine: (n) => -Math.cos(n * Ot) + 1,
  easeOutSine: (n) => Math.sin(n * Ot),
  easeInOutSine: (n) => -0.5 * (Math.cos(nt * n) - 1),
  easeInExpo: (n) => n === 0 ? 0 : Math.pow(2, 10 * (n - 1)),
  easeOutExpo: (n) => n === 1 ? 1 : -Math.pow(2, -10 * n) + 1,
  easeInOutExpo: (n) => Cl(n) ? n : n < 0.5 ? 0.5 * Math.pow(2, 10 * (n * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (n * 2 - 1)) + 2),
  easeInCirc: (n) => n >= 1 ? n : -(Math.sqrt(1 - n * n) - 1),
  easeOutCirc: (n) => Math.sqrt(1 - (n -= 1) * n),
  easeInOutCirc: (n) => (n /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - n * n) - 1) : 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1),
  easeInElastic: (n) => Cl(n) ? n : _m(n, 0.075, 0.3),
  easeOutElastic: (n) => Cl(n) ? n : Em(n, 0.075, 0.3),
  easeInOutElastic(n) {
    return Cl(n) ? n : n < 0.5 ? 0.5 * _m(n * 2, 0.1125, 0.45) : 0.5 + 0.5 * Em(n * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(n) {
    return n * n * ((1.70158 + 1) * n - 1.70158);
  },
  easeOutBack(n) {
    return (n -= 1) * n * ((1.70158 + 1) * n + 1.70158) + 1;
  },
  easeInOutBack(n) {
    let e = 1.70158;
    return (n /= 0.5) < 1 ? 0.5 * (n * n * (((e *= 1.525) + 1) * n - e)) : 0.5 * ((n -= 2) * n * (((e *= 1.525) + 1) * n + e) + 2);
  },
  easeInBounce: (n) => 1 - aa.easeOutBounce(1 - n),
  easeOutBounce(n) {
    return n < 1 / 2.75 ? 7.5625 * n * n : n < 2 / 2.75 ? 7.5625 * (n -= 1.5 / 2.75) * n + 0.75 : n < 2.5 / 2.75 ? 7.5625 * (n -= 2.25 / 2.75) * n + 0.9375 : 7.5625 * (n -= 2.625 / 2.75) * n + 0.984375;
  },
  easeInOutBounce: (n) => n < 0.5 ? aa.easeInBounce(n * 2) * 0.5 : aa.easeOutBounce(n * 2 - 1) * 0.5 + 0.5
};
function y9(n) {
  if (n && typeof n == "object") {
    const e = n.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Om(n) {
  return y9(n) ? n : new Ia(n);
}
function zc(n) {
  return y9(n) ? n : new Ia(n).saturate(0.5).darken(0.1).hexString();
}
const PH = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], LH = [
  "color",
  "borderColor",
  "backgroundColor"
];
function RH(n) {
  n.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), n.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), n.set("animations", {
    colors: {
      type: "color",
      properties: LH
    },
    numbers: {
      type: "number",
      properties: PH
    }
  }), n.describe("animations", {
    _fallback: "animation"
  }), n.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function FH(n) {
  n.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Tm = /* @__PURE__ */ new Map();
function BH(n, e) {
  e = e || {};
  const t = n + JSON.stringify(e);
  let o = Tm.get(t);
  return o || (o = new Intl.NumberFormat(n, e), Tm.set(t, o)), o;
}
function Yh(n, e, t) {
  return BH(e, t).format(n);
}
const VH = {
  values(n) {
    return Nt(n) ? n : "" + n;
  },
  numeric(n, e, t) {
    if (n === 0)
      return "0";
    const o = this.chart.options.locale;
    let i, r = n;
    if (t.length > 1) {
      const d = Math.max(Math.abs(t[0].value), Math.abs(t[t.length - 1].value));
      (d < 1e-4 || d > 1e15) && (i = "scientific"), r = zH(n, t);
    }
    const s = p9(Math.abs(r)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = {
      notation: i,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), Yh(n, o, l);
  }
};
function zH(n, e) {
  let t = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(t) >= 1 && n !== Math.floor(n) && (t = n - Math.floor(n)), t;
}
var x9 = {
  formatters: VH
};
function HH(n) {
  n.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, t) => t.lineWidth,
      tickColor: (e, t) => t.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: x9.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), n.route("scale.ticks", "color", "", "color"), n.route("scale.grid", "color", "", "borderColor"), n.route("scale.border", "color", "", "borderColor"), n.route("scale.title", "color", "", "color"), n.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), n.describe("scales", {
    _fallback: "scale"
  }), n.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const pr = /* @__PURE__ */ Object.create(null), s1 = /* @__PURE__ */ Object.create(null);
function la(n, e) {
  if (!e)
    return n;
  const t = e.split(".");
  for (let o = 0, i = t.length; o < i; ++o) {
    const r = t[o];
    n = n[r] || (n[r] = /* @__PURE__ */ Object.create(null));
  }
  return n;
}
function Hc(n, e, t) {
  return typeof e == "string" ? Da(la(n, e), t) : Da(la(n, ""), e);
}
class jH {
  constructor(e, t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (o) => o.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (o, i) => zc(i.backgroundColor), this.hoverBorderColor = (o, i) => zc(i.borderColor), this.hoverColor = (o, i) => zc(i.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(t);
  }
  set(e, t) {
    return Hc(this, e, t);
  }
  get(e) {
    return la(this, e);
  }
  describe(e, t) {
    return Hc(s1, e, t);
  }
  override(e, t) {
    return Hc(pr, e, t);
  }
  route(e, t, o, i) {
    const r = la(this, e), s = la(this, o), a = "_" + t;
    Object.defineProperties(r, {
      [a]: {
        value: r[t],
        writable: !0
      },
      [t]: {
        enumerable: !0,
        get() {
          const l = this[a], d = s[i];
          return je(l) ? Object.assign({}, d, l) : Je(l, d);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((t) => t(this));
  }
}
var wt = /* @__PURE__ */ new jH({
  _scriptable: (n) => !n.startsWith("on"),
  _indexable: (n) => n !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  RH,
  FH,
  HH
]);
function WH(n) {
  return !n || pt(n.size) || pt(n.family) ? null : (n.style ? n.style + " " : "") + (n.weight ? n.weight + " " : "") + n.size + "px " + n.family;
}
function Am(n, e, t, o, i) {
  let r = e[i];
  return r || (r = e[i] = n.measureText(i).width, t.push(i)), r > o && (o = r), o;
}
function zi(n, e, t) {
  const o = n.currentDevicePixelRatio, i = t !== 0 ? Math.max(t / 2, 0.5) : 0;
  return Math.round((e - i) * o) / o + i;
}
function Im(n, e) {
  !e && !n || (e = e || n.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, n.width, n.height), e.restore());
}
function Dm(n, e, t, o) {
  C9(n, e, t, o, null);
}
function C9(n, e, t, o, i) {
  let r, s, a, l, d, u, c, f;
  const h = e.pointStyle, p = e.rotation, m = e.radius;
  let g = (p || 0) * CH;
  if (h && typeof h == "object" && (r = h.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    n.save(), n.translate(t, o), n.rotate(g), n.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), n.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (n.beginPath(), h) {
      // Default includes circle
      default:
        i ? n.ellipse(t, o, i / 2, m, 0, 0, St) : n.arc(t, o, m, 0, St), n.closePath();
        break;
      case "triangle":
        u = i ? i / 2 : m, n.moveTo(t + Math.sin(g) * u, o - Math.cos(g) * m), g += km, n.lineTo(t + Math.sin(g) * u, o - Math.cos(g) * m), g += km, n.lineTo(t + Math.sin(g) * u, o - Math.cos(g) * m), n.closePath();
        break;
      case "rectRounded":
        d = m * 0.516, l = m - d, s = Math.cos(g + Vi) * l, c = Math.cos(g + Vi) * (i ? i / 2 - d : l), a = Math.sin(g + Vi) * l, f = Math.sin(g + Vi) * (i ? i / 2 - d : l), n.arc(t - c, o - a, d, g - nt, g - Ot), n.arc(t + f, o - s, d, g - Ot, g), n.arc(t + c, o + a, d, g, g + Ot), n.arc(t - f, o + s, d, g + Ot, g + nt), n.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * m, u = i ? i / 2 : l, n.rect(t - u, o - l, 2 * u, 2 * l);
          break;
        }
        g += Vi;
      /* falls through */
      case "rectRot":
        c = Math.cos(g) * (i ? i / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (i ? i / 2 : m), n.moveTo(t - c, o - a), n.lineTo(t + f, o - s), n.lineTo(t + c, o + a), n.lineTo(t - f, o + s), n.closePath();
        break;
      case "crossRot":
        g += Vi;
      /* falls through */
      case "cross":
        c = Math.cos(g) * (i ? i / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (i ? i / 2 : m), n.moveTo(t - c, o - a), n.lineTo(t + c, o + a), n.moveTo(t + f, o - s), n.lineTo(t - f, o + s);
        break;
      case "star":
        c = Math.cos(g) * (i ? i / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (i ? i / 2 : m), n.moveTo(t - c, o - a), n.lineTo(t + c, o + a), n.moveTo(t + f, o - s), n.lineTo(t - f, o + s), g += Vi, c = Math.cos(g) * (i ? i / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (i ? i / 2 : m), n.moveTo(t - c, o - a), n.lineTo(t + c, o + a), n.moveTo(t + f, o - s), n.lineTo(t - f, o + s);
        break;
      case "line":
        s = i ? i / 2 : Math.cos(g) * m, a = Math.sin(g) * m, n.moveTo(t - s, o - a), n.lineTo(t + s, o + a);
        break;
      case "dash":
        n.moveTo(t, o), n.lineTo(t + Math.cos(g) * (i ? i / 2 : m), o + Math.sin(g) * m);
        break;
      case !1:
        n.closePath();
        break;
    }
    n.fill(), e.borderWidth > 0 && n.stroke();
  }
}
function w9(n, e, t) {
  return t = t || 0.5, !e || n && n.x > e.left - t && n.x < e.right + t && n.y > e.top - t && n.y < e.bottom + t;
}
function qh(n, e) {
  n.save(), n.beginPath(), n.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), n.clip();
}
function Zh(n) {
  n.restore();
}
function UH(n, e) {
  e.translation && n.translate(e.translation[0], e.translation[1]), pt(e.rotation) || n.rotate(e.rotation), e.color && (n.fillStyle = e.color), e.textAlign && (n.textAlign = e.textAlign), e.textBaseline && (n.textBaseline = e.textBaseline);
}
function KH(n, e, t, o, i) {
  if (i.strikethrough || i.underline) {
    const r = n.measureText(o), s = e - r.actualBoundingBoxLeft, a = e + r.actualBoundingBoxRight, l = t - r.actualBoundingBoxAscent, d = t + r.actualBoundingBoxDescent, u = i.strikethrough ? (l + d) / 2 : d;
    n.strokeStyle = n.fillStyle, n.beginPath(), n.lineWidth = i.decorationWidth || 2, n.moveTo(s, u), n.lineTo(a, u), n.stroke();
  }
}
function GH(n, e) {
  const t = n.fillStyle;
  n.fillStyle = e.color, n.fillRect(e.left, e.top, e.width, e.height), n.fillStyle = t;
}
function Pa(n, e, t, o, i, r = {}) {
  const s = Nt(e) ? e : [
    e
  ], a = r.strokeWidth > 0 && r.strokeColor !== "";
  let l, d;
  for (n.save(), n.font = i.string, UH(n, r), l = 0; l < s.length; ++l)
    d = s[l], r.backdrop && GH(n, r.backdrop), a && (r.strokeColor && (n.strokeStyle = r.strokeColor), pt(r.strokeWidth) || (n.lineWidth = r.strokeWidth), n.strokeText(d, t, o, r.maxWidth)), n.fillText(d, t, o, r.maxWidth), KH(n, t, o, d, r), o += Number(i.lineHeight);
  n.restore();
}
function eu(n, e) {
  const { x: t, y: o, w: i, h: r, radius: s } = e;
  n.arc(t + s.topLeft, o + s.topLeft, s.topLeft, 1.5 * nt, nt, !0), n.lineTo(t, o + r - s.bottomLeft), n.arc(t + s.bottomLeft, o + r - s.bottomLeft, s.bottomLeft, nt, Ot, !0), n.lineTo(t + i - s.bottomRight, o + r), n.arc(t + i - s.bottomRight, o + r - s.bottomRight, s.bottomRight, Ot, 0, !0), n.lineTo(t + i, o + s.topRight), n.arc(t + i - s.topRight, o + s.topRight, s.topRight, 0, -Ot, !0), n.lineTo(t + s.topLeft, o);
}
const YH = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, qH = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function ZH(n, e) {
  const t = ("" + n).match(YH);
  if (!t || t[1] === "normal")
    return e * 1.2;
  switch (n = +t[2], t[3]) {
    case "px":
      return n;
    case "%":
      n /= 100;
      break;
  }
  return e * n;
}
const JH = (n) => +n || 0;
function Jh(n, e) {
  const t = {}, o = je(e), i = o ? Object.keys(e) : e, r = je(n) ? o ? (s) => Je(n[s], n[e[s]]) : (s) => n[s] : () => n;
  for (const s of i)
    t[s] = JH(r(s));
  return t;
}
function k9(n) {
  return Jh(n, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Gr(n) {
  return Jh(n, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Yn(n) {
  const e = k9(n);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function Jt(n, e) {
  n = n || {}, e = e || wt.font;
  let t = Je(n.size, e.size);
  typeof t == "string" && (t = parseInt(t, 10));
  let o = Je(n.style, e.style);
  o && !("" + o).match(qH) && (console.warn('Invalid font style specified: "' + o + '"'), o = void 0);
  const i = {
    family: Je(n.family, e.family),
    lineHeight: ZH(Je(n.lineHeight, e.lineHeight), t),
    size: t,
    style: o,
    weight: Je(n.weight, e.weight),
    string: ""
  };
  return i.string = WH(i), i;
}
function wl(n, e, t, o) {
  let i, r, s;
  for (i = 0, r = n.length; i < r; ++i)
    if (s = n[i], s !== void 0 && s !== void 0)
      return s;
}
function XH(n, e, t) {
  const { min: o, max: i } = n, r = f9(e, (i - o) / 2), s = (a, l) => t && a === 0 ? 0 : a + l;
  return {
    min: s(o, -Math.abs(r)),
    max: s(i, r)
  };
}
function Cs(n, e) {
  return Object.assign(Object.create(n), e);
}
function Xh(n, e = [
  ""
], t, o, i = () => n[0]) {
  const r = t || n;
  typeof o > "u" && (o = _9("_fallback", n));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: n,
    _rootScopes: r,
    _fallback: o,
    _getTarget: i,
    override: (a) => Xh([
      a,
      ...n
    ], e, r, o)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete n[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return M9(a, l, () => sj(l, e, n, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(n[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return Pm(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Pm(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, d) {
      const u = a._storage || (a._storage = i());
      return a[l] = u[l] = d, delete a._keys, !0;
    }
  });
}
function hs(n, e, t, o) {
  const i = {
    _cacheable: !1,
    _proxy: n,
    _context: e,
    _subProxy: t,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: $9(n, o),
    setContext: (r) => hs(n, r, t, o),
    override: (r) => hs(n.override(r), e, t, o)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(r, s) {
      return delete r[s], delete n[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(r, s, a) {
      return M9(r, s, () => ej(r, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(r, s) {
      return r._descriptors.allKeys ? Reflect.has(n, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(n, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(n);
    },
    /**
    * A trap for the in operator.
    */
    has(r, s) {
      return Reflect.has(n, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(n);
    },
    /**
    * A trap for setting property values.
    */
    set(r, s, a) {
      return n[s] = a, delete r[s], !0;
    }
  });
}
function $9(n, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: t = e.scriptable, _indexable: o = e.indexable, _allKeys: i = e.allKeys } = n;
  return {
    allKeys: i,
    scriptable: t,
    indexable: o,
    isScriptable: _i(t) ? t : () => t,
    isIndexable: _i(o) ? o : () => o
  };
}
const QH = (n, e) => n ? n + Uh(e) : e, Qh = (n, e) => je(e) && n !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function M9(n, e, t) {
  if (Object.prototype.hasOwnProperty.call(n, e) || e === "constructor")
    return n[e];
  const o = t();
  return n[e] = o, o;
}
function ej(n, e, t) {
  const { _proxy: o, _context: i, _subProxy: r, _descriptors: s } = n;
  let a = o[e];
  return _i(a) && s.isScriptable(e) && (a = tj(e, a, n, t)), Nt(a) && a.length && (a = nj(e, a, n, s.isIndexable)), Qh(e, a) && (a = hs(a, i, r && r[e], s)), a;
}
function tj(n, e, t, o) {
  const { _proxy: i, _context: r, _subProxy: s, _stack: a } = t;
  if (a.has(n))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + n);
  a.add(n);
  let l = e(r, s || o);
  return a.delete(n), Qh(n, l) && (l = e0(i._scopes, i, n, l)), l;
}
function nj(n, e, t, o) {
  const { _proxy: i, _context: r, _subProxy: s, _descriptors: a } = t;
  if (typeof r.index < "u" && o(n))
    return e[r.index % e.length];
  if (je(e[0])) {
    const l = e, d = i._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const c = e0(d, i, n, u);
      e.push(hs(c, r, s && s[n], a));
    }
  }
  return e;
}
function S9(n, e, t) {
  return _i(n) ? n(e, t) : n;
}
const oj = (n, e) => n === !0 ? e : typeof n == "string" ? Na(e, n) : void 0;
function ij(n, e, t, o, i) {
  for (const r of e) {
    const s = oj(t, r);
    if (s) {
      n.add(s);
      const a = S9(s._fallback, t, i);
      if (typeof a < "u" && a !== t && a !== o)
        return a;
    } else if (s === !1 && typeof o < "u" && t !== o)
      return null;
  }
  return !1;
}
function e0(n, e, t, o) {
  const i = e._rootScopes, r = S9(e._fallback, t, o), s = [
    ...n,
    ...i
  ], a = /* @__PURE__ */ new Set();
  a.add(o);
  let l = Nm(a, s, t, r || t, o);
  return l === null || typeof r < "u" && r !== t && (l = Nm(a, s, r, l, o), l === null) ? !1 : Xh(Array.from(a), [
    ""
  ], i, r, () => rj(e, t, o));
}
function Nm(n, e, t, o, i) {
  for (; t; )
    t = ij(n, e, t, o, i);
  return t;
}
function rj(n, e, t) {
  const o = n._getTarget();
  e in o || (o[e] = {});
  const i = o[e];
  return Nt(i) && je(t) ? t : i || {};
}
function sj(n, e, t, o) {
  let i;
  for (const r of e)
    if (i = _9(QH(r, n), t), typeof i < "u")
      return Qh(n, i) ? e0(t, o, n, i) : i;
}
function _9(n, e) {
  for (const t of e) {
    if (!t)
      continue;
    const o = t[n];
    if (typeof o < "u")
      return o;
  }
}
function Pm(n) {
  let e = n._keys;
  return e || (e = n._keys = aj(n._scopes)), e;
}
function aj(n) {
  const e = /* @__PURE__ */ new Set();
  for (const t of n)
    for (const o of Object.keys(t).filter((i) => !i.startsWith("_")))
      e.add(o);
  return Array.from(e);
}
function t0() {
  return typeof window < "u" && typeof document < "u";
}
function n0(n) {
  let e = n.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function tu(n, e, t) {
  let o;
  return typeof n == "string" ? (o = parseInt(n, 10), n.indexOf("%") !== -1 && (o = o / 100 * e.parentNode[t])) : o = n, o;
}
const Vu = (n) => n.ownerDocument.defaultView.getComputedStyle(n, null);
function lj(n, e) {
  return Vu(n).getPropertyValue(e);
}
const dj = [
  "top",
  "right",
  "bottom",
  "left"
];
function ir(n, e, t) {
  const o = {};
  t = t ? "-" + t : "";
  for (let i = 0; i < 4; i++) {
    const r = dj[i];
    o[r] = parseFloat(n[e + "-" + r + t]) || 0;
  }
  return o.width = o.left + o.right, o.height = o.top + o.bottom, o;
}
const uj = (n, e, t) => (n > 0 || e > 0) && (!t || !t.shadowRoot);
function cj(n, e) {
  const t = n.touches, o = t && t.length ? t[0] : n, { offsetX: i, offsetY: r } = o;
  let s = !1, a, l;
  if (uj(i, r, n.target))
    a = i, l = r;
  else {
    const d = e.getBoundingClientRect();
    a = o.clientX - d.left, l = o.clientY - d.top, s = !0;
  }
  return {
    x: a,
    y: l,
    box: s
  };
}
function ji(n, e) {
  if ("native" in n)
    return n;
  const { canvas: t, currentDevicePixelRatio: o } = e, i = Vu(t), r = i.boxSizing === "border-box", s = ir(i, "padding"), a = ir(i, "border", "width"), { x: l, y: d, box: u } = cj(n, t), c = s.left + (u && a.left), f = s.top + (u && a.top);
  let { width: h, height: p } = e;
  return r && (h -= s.width + a.width, p -= s.height + a.height), {
    x: Math.round((l - c) / h * t.width / o),
    y: Math.round((d - f) / p * t.height / o)
  };
}
function fj(n, e, t) {
  let o, i;
  if (e === void 0 || t === void 0) {
    const r = n && n0(n);
    if (!r)
      e = n.clientWidth, t = n.clientHeight;
    else {
      const s = r.getBoundingClientRect(), a = Vu(r), l = ir(a, "border", "width"), d = ir(a, "padding");
      e = s.width - d.width - l.width, t = s.height - d.height - l.height, o = tu(a.maxWidth, r, "clientWidth"), i = tu(a.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: e,
    height: t,
    maxWidth: o || Zd,
    maxHeight: i || Zd
  };
}
const hi = (n) => Math.round(n * 10) / 10;
function hj(n, e, t, o) {
  const i = Vu(n), r = ir(i, "margin"), s = tu(i.maxWidth, n, "clientWidth") || Zd, a = tu(i.maxHeight, n, "clientHeight") || Zd, l = fj(n, e, t);
  let { width: d, height: u } = l;
  if (i.boxSizing === "content-box") {
    const f = ir(i, "border", "width"), h = ir(i, "padding");
    d -= h.width + f.width, u -= h.height + f.height;
  }
  return d = Math.max(0, d - r.width), u = Math.max(0, o ? d / o : u - r.height), d = hi(Math.min(d, s, l.maxWidth)), u = hi(Math.min(u, a, l.maxHeight)), d && !u && (u = hi(d / 2)), (e !== void 0 || t !== void 0) && o && l.height && u > l.height && (u = l.height, d = hi(Math.floor(u * o))), {
    width: d,
    height: u
  };
}
function Lm(n, e, t) {
  const o = e || 1, i = hi(n.height * o), r = hi(n.width * o);
  n.height = hi(n.height), n.width = hi(n.width);
  const s = n.canvas;
  return s.style && (t || !s.style.height && !s.style.width) && (s.style.height = `${n.height}px`, s.style.width = `${n.width}px`), n.currentDevicePixelRatio !== o || s.height !== i || s.width !== r ? (n.currentDevicePixelRatio = o, s.height = i, s.width = r, n.ctx.setTransform(o, 0, 0, o, 0, 0), !0) : !1;
}
const pj = (function() {
  let n = !1;
  try {
    const e = {
      get passive() {
        return n = !0, !1;
      }
    };
    t0() && (window.addEventListener("test", null, e), window.removeEventListener("test", null, e));
  } catch {
  }
  return n;
})();
function Rm(n, e) {
  const t = lj(n, e), o = t && t.match(/^(\d+)(\.\d+)?px$/);
  return o ? +o[1] : void 0;
}
const mj = function(n, e) {
  return {
    x(t) {
      return n + n + e - t;
    },
    setWidth(t) {
      e = t;
    },
    textAlign(t) {
      return t === "center" ? t : t === "right" ? "left" : "right";
    },
    xPlus(t, o) {
      return t - o;
    },
    leftForLtr(t, o) {
      return t - o;
    }
  };
}, gj = function() {
  return {
    x(n) {
      return n;
    },
    setWidth(n) {
    },
    textAlign(n) {
      return n;
    },
    xPlus(n, e) {
      return n + e;
    },
    leftForLtr(n, e) {
      return n;
    }
  };
};
function Yr(n, e, t) {
  return n ? mj(e, t) : gj();
}
function E9(n, e) {
  let t, o;
  (e === "ltr" || e === "rtl") && (t = n.canvas.style, o = [
    t.getPropertyValue("direction"),
    t.getPropertyPriority("direction")
  ], t.setProperty("direction", e, "important"), n.prevTextDirection = o);
}
function O9(n, e) {
  e !== void 0 && (delete n.prevTextDirection, n.canvas.style.setProperty("direction", e[0], e[1]));
}
function kl(n, e, t) {
  return n.options.clip ? n[t] : e[t];
}
function vj(n, e) {
  const { xScale: t, yScale: o } = n;
  return t && o ? {
    left: kl(t, e, "left"),
    right: kl(t, e, "right"),
    top: kl(o, e, "top"),
    bottom: kl(o, e, "bottom")
  } : e;
}
function bj(n, e) {
  const t = e._clip;
  if (t.disabled)
    return !1;
  const o = vj(e, n.chartArea);
  return {
    left: t.left === !1 ? 0 : o.left - (t.left === !0 ? 0 : t.left),
    right: t.right === !1 ? n.width : o.right + (t.right === !0 ? 0 : t.right),
    top: t.top === !1 ? 0 : o.top - (t.top === !0 ? 0 : t.top),
    bottom: t.bottom === !1 ? n.height : o.bottom + (t.bottom === !0 ? 0 : t.bottom)
  };
}
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class yj {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, t, o, i) {
    const r = t.listeners[i], s = t.duration;
    r.forEach((a) => a({
      chart: e,
      initial: t.initial,
      numSteps: s,
      currentStep: Math.min(o - t.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = v9.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let t = 0;
    this._charts.forEach((o, i) => {
      if (!o.running || !o.items.length)
        return;
      const r = o.items;
      let s = r.length - 1, a = !1, l;
      for (; s >= 0; --s)
        l = r[s], l._active ? (l._total > o.duration && (o.duration = l._total), l.tick(e), a = !0) : (r[s] = r[r.length - 1], r.pop());
      a && (i.draw(), this._notify(i, o, e, "progress")), r.length || (o.running = !1, this._notify(i, o, e, "complete"), o.initial = !1), t += r.length;
    }), this._lastDate = e, t === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const t = this._charts;
    let o = t.get(e);
    return o || (o = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, t.set(e, o)), o;
  }
  listen(e, t, o) {
    this._getAnims(e).listeners[t].push(o);
  }
  add(e, t) {
    !t || !t.length || this._getAnims(e).items.push(...t);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const t = this._charts.get(e);
    t && (t.running = !0, t.start = Date.now(), t.duration = t.items.reduce((o, i) => Math.max(o, i._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const t = this._charts.get(e);
    return !(!t || !t.running || !t.items.length);
  }
  stop(e) {
    const t = this._charts.get(e);
    if (!t || !t.items.length)
      return;
    const o = t.items;
    let i = o.length - 1;
    for (; i >= 0; --i)
      o[i].cancel();
    t.items = [], this._notify(e, t, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var Oo = /* @__PURE__ */ new yj();
const Fm = "transparent", xj = {
  boolean(n, e, t) {
    return t > 0.5 ? e : n;
  },
  color(n, e, t) {
    const o = Om(n || Fm), i = o.valid && Om(e || Fm);
    return i && i.valid ? i.mix(o, t).hexString() : e;
  },
  number(n, e, t) {
    return n + (e - n) * t;
  }
};
class Cj {
  constructor(e, t, o, i) {
    const r = t[o];
    i = wl([
      e.to,
      i,
      r,
      e.from
    ]);
    const s = wl([
      e.from,
      r,
      i
    ]);
    this._active = !0, this._fn = e.fn || xj[e.type || typeof s], this._easing = aa[e.easing] || aa.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = t, this._prop = o, this._from = s, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, t, o) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], r = o - this._start, s = this._duration - r;
      this._start = o, this._duration = Math.floor(Math.max(s, e.duration)), this._total += r, this._loop = !!e.loop, this._to = wl([
        e.to,
        t,
        i,
        e.from
      ]), this._from = wl([
        e.from,
        i,
        t
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const t = e - this._start, o = this._duration, i = this._prop, r = this._from, s = this._loop, a = this._to;
    let l;
    if (this._active = r !== a && (s || t < o), !this._active) {
      this._target[i] = a, this._notify(!0);
      return;
    }
    if (t < 0) {
      this._target[i] = r;
      return;
    }
    l = t / o % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[i] = this._fn(r, a, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((t, o) => {
      e.push({
        res: t,
        rej: o
      });
    });
  }
  _notify(e) {
    const t = e ? "res" : "rej", o = this._promises || [];
    for (let i = 0; i < o.length; i++)
      o[i][t]();
  }
}
class T9 {
  constructor(e, t) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(t);
  }
  configure(e) {
    if (!je(e))
      return;
    const t = Object.keys(wt.animation), o = this._properties;
    Object.getOwnPropertyNames(e).forEach((i) => {
      const r = e[i];
      if (!je(r))
        return;
      const s = {};
      for (const a of t)
        s[a] = r[a];
      (Nt(r.properties) && r.properties || [
        i
      ]).forEach((a) => {
        (a === i || !o.has(a)) && o.set(a, s);
      });
    });
  }
  _animateOptions(e, t) {
    const o = t.options, i = kj(e, o);
    if (!i)
      return [];
    const r = this._createAnimations(i, o);
    return o.$shared && wj(e.options.$animations, o).then(() => {
      e.options = o;
    }, () => {
    }), r;
  }
  _createAnimations(e, t) {
    const o = this._properties, i = [], r = e.$animations || (e.$animations = {}), s = Object.keys(t), a = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const d = s[l];
      if (d.charAt(0) === "$")
        continue;
      if (d === "options") {
        i.push(...this._animateOptions(e, t));
        continue;
      }
      const u = t[d];
      let c = r[d];
      const f = o.get(d);
      if (c)
        if (f && c.active()) {
          c.update(f, u, a);
          continue;
        } else
          c.cancel();
      if (!f || !f.duration) {
        e[d] = u;
        continue;
      }
      r[d] = c = new Cj(f, e, d, u), i.push(c);
    }
    return i;
  }
  update(e, t) {
    if (this._properties.size === 0) {
      Object.assign(e, t);
      return;
    }
    const o = this._createAnimations(e, t);
    if (o.length)
      return Oo.add(this._chart, o), !0;
  }
}
function wj(n, e) {
  const t = [], o = Object.keys(e);
  for (let i = 0; i < o.length; i++) {
    const r = n[o[i]];
    r && r.active() && t.push(r.wait());
  }
  return Promise.all(t);
}
function kj(n, e) {
  if (!e)
    return;
  let t = n.options;
  if (!t) {
    n.options = e;
    return;
  }
  return t.$shared && (n.options = t = Object.assign({}, t, {
    $shared: !1,
    $animations: {}
  })), t;
}
function Bm(n, e) {
  const t = n && n.options || {}, o = t.reverse, i = t.min === void 0 ? e : 0, r = t.max === void 0 ? e : 0;
  return {
    start: o ? r : i,
    end: o ? i : r
  };
}
function $j(n, e, t) {
  if (t === !1)
    return !1;
  const o = Bm(n, t), i = Bm(e, t);
  return {
    top: i.end,
    right: o.end,
    bottom: i.start,
    left: o.start
  };
}
function Mj(n) {
  let e, t, o, i;
  return je(n) ? (e = n.top, t = n.right, o = n.bottom, i = n.left) : e = t = o = i = n, {
    top: e,
    right: t,
    bottom: o,
    left: i,
    disabled: n === !1
  };
}
function A9(n, e) {
  const t = [], o = n._getSortedDatasetMetas(e);
  let i, r;
  for (i = 0, r = o.length; i < r; ++i)
    t.push(o[i].index);
  return t;
}
function Vm(n, e, t, o = {}) {
  const i = n.keys, r = o.mode === "single";
  let s, a, l, d;
  if (e === null)
    return;
  let u = !1;
  for (s = 0, a = i.length; s < a; ++s) {
    if (l = +i[s], l === t) {
      if (u = !0, o.all)
        continue;
      break;
    }
    d = n.values[l], Gn(d) && (r || e === 0 || Jd(e) === Jd(d)) && (e += d);
  }
  return !u && !o.all ? 0 : e;
}
function Sj(n, e) {
  const { iScale: t, vScale: o } = e, i = t.axis === "x" ? "x" : "y", r = o.axis === "x" ? "x" : "y", s = Object.keys(n), a = new Array(s.length);
  let l, d, u;
  for (l = 0, d = s.length; l < d; ++l)
    u = s[l], a[l] = {
      [i]: u,
      [r]: n[u]
    };
  return a;
}
function jc(n, e) {
  const t = n && n.options.stacked;
  return t || t === void 0 && e.stack !== void 0;
}
function _j(n, e, t) {
  return `${n.id}.${e.id}.${t.stack || t.type}`;
}
function Ej(n) {
  const { min: e, max: t, minDefined: o, maxDefined: i } = n.getUserBounds();
  return {
    min: o ? e : Number.NEGATIVE_INFINITY,
    max: i ? t : Number.POSITIVE_INFINITY
  };
}
function Oj(n, e, t) {
  const o = n[e] || (n[e] = {});
  return o[t] || (o[t] = {});
}
function zm(n, e, t, o) {
  for (const i of e.getMatchingVisibleMetas(o).reverse()) {
    const r = n[i.index];
    if (t && r > 0 || !t && r < 0)
      return i.index;
  }
  return null;
}
function Hm(n, e) {
  const { chart: t, _cachedMeta: o } = n, i = t._stacks || (t._stacks = {}), { iScale: r, vScale: s, index: a } = o, l = r.axis, d = s.axis, u = _j(r, s, o), c = e.length;
  let f;
  for (let h = 0; h < c; ++h) {
    const p = e[h], { [l]: m, [d]: g } = p, b = p._stacks || (p._stacks = {});
    f = b[d] = Oj(i, u, m), f[a] = g, f._top = zm(f, s, !0, o.type), f._bottom = zm(f, s, !1, o.type);
    const x = f._visualValues || (f._visualValues = {});
    x[a] = g;
  }
}
function Wc(n, e) {
  const t = n.scales;
  return Object.keys(t).filter((o) => t[o].axis === e).shift();
}
function Tj(n, e) {
  return Cs(n, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function Aj(n, e, t) {
  return Cs(n, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: t,
    index: e,
    mode: "default",
    type: "data"
  });
}
function Es(n, e) {
  const t = n.controller.index, o = n.vScale && n.vScale.axis;
  if (o) {
    e = e || n._parsed;
    for (const i of e) {
      const r = i._stacks;
      if (!r || r[o] === void 0 || r[o][t] === void 0)
        return;
      delete r[o][t], r[o]._visualValues !== void 0 && r[o]._visualValues[t] !== void 0 && delete r[o]._visualValues[t];
    }
  }
}
const Uc = (n) => n === "reset" || n === "none", jm = (n, e) => e ? n : Object.assign({}, n), Ij = (n, e, t) => n && !e.hidden && e._stacked && {
  keys: A9(t, !0),
  values: null
};
class da {
  constructor(e, t) {
    this.chart = e, this._ctx = e.ctx, this.index = t, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = jc(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && Es(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, t = this._cachedMeta, o = this.getDataset(), i = (c, f, h, p) => c === "x" ? f : c === "r" ? p : h, r = t.xAxisID = Je(o.xAxisID, Wc(e, "x")), s = t.yAxisID = Je(o.yAxisID, Wc(e, "y")), a = t.rAxisID = Je(o.rAxisID, Wc(e, "r")), l = t.indexAxis, d = t.iAxisID = i(l, r, s, a), u = t.vAxisID = i(l, s, r, a);
    t.xScale = this.getScaleForId(r), t.yScale = this.getScaleForId(s), t.rScale = this.getScaleForId(a), t.iScale = this.getScaleForId(d), t.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const t = this._cachedMeta;
    return e === t.iScale ? t.vScale : t.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && Sm(this._data, this), e._stacked && Es(e);
  }
  _dataCheck() {
    const e = this.getDataset(), t = e.data || (e.data = []), o = this._data;
    if (je(t)) {
      const i = this._cachedMeta;
      this._data = Sj(t, i);
    } else if (o !== t) {
      if (o) {
        Sm(o, this);
        const i = this._cachedMeta;
        Es(i), i._parsed = [];
      }
      t && Object.isExtensible(t) && AH(t, this), this._syncList = [], this._data = t;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const t = this._cachedMeta, o = this.getDataset();
    let i = !1;
    this._dataCheck();
    const r = t._stacked;
    t._stacked = jc(t.vScale, t), t.stack !== o.stack && (i = !0, Es(t), t.stack = o.stack), this._resyncElements(e), (i || r !== t._stacked) && (Hm(this, t._parsed), t._stacked = jc(t.vScale, t));
  }
  configure() {
    const e = this.chart.config, t = e.datasetScopeKeys(this._type), o = e.getOptionScopes(this.getDataset(), t, !0);
    this.options = e.createResolver(o, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, t) {
    const { _cachedMeta: o, _data: i } = this, { iScale: r, _stacked: s } = o, a = r.axis;
    let l = e === 0 && t === i.length ? !0 : o._sorted, d = e > 0 && o._parsed[e - 1], u, c, f;
    if (this._parsing === !1)
      o._parsed = i, o._sorted = !0, f = i;
    else {
      Nt(i[e]) ? f = this.parseArrayData(o, i, e, t) : je(i[e]) ? f = this.parseObjectData(o, i, e, t) : f = this.parsePrimitiveData(o, i, e, t);
      const h = () => c[a] === null || d && c[a] < d[a];
      for (u = 0; u < t; ++u)
        o._parsed[u + e] = c = f[u], l && (h() && (l = !1), d = c);
      o._sorted = l;
    }
    s && Hm(this, f);
  }
  parsePrimitiveData(e, t, o, i) {
    const { iScale: r, vScale: s } = e, a = r.axis, l = s.axis, d = r.getLabels(), u = r === s, c = new Array(i);
    let f, h, p;
    for (f = 0, h = i; f < h; ++f)
      p = f + o, c[f] = {
        [a]: u || r.parse(d[p], p),
        [l]: s.parse(t[p], p)
      };
    return c;
  }
  parseArrayData(e, t, o, i) {
    const { xScale: r, yScale: s } = e, a = new Array(i);
    let l, d, u, c;
    for (l = 0, d = i; l < d; ++l)
      u = l + o, c = t[u], a[l] = {
        x: r.parse(c[0], u),
        y: s.parse(c[1], u)
      };
    return a;
  }
  parseObjectData(e, t, o, i) {
    const { xScale: r, yScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, d = new Array(i);
    let u, c, f, h;
    for (u = 0, c = i; u < c; ++u)
      f = u + o, h = t[f], d[u] = {
        x: r.parse(Na(h, a), f),
        y: s.parse(Na(h, l), f)
      };
    return d;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, t, o) {
    const i = this.chart, r = this._cachedMeta, s = t[e.axis], a = {
      keys: A9(i, !0),
      values: t._stacks[e.axis]._visualValues
    };
    return Vm(a, s, r.index, {
      mode: o
    });
  }
  updateRangeFromParsed(e, t, o, i) {
    const r = o[t.axis];
    let s = r === null ? NaN : r;
    const a = i && o._stacks[t.axis];
    i && a && (i.values = a, s = Vm(i, r, this._cachedMeta.index)), e.min = Math.min(e.min, s), e.max = Math.max(e.max, s);
  }
  getMinMax(e, t) {
    const o = this._cachedMeta, i = o._parsed, r = o._sorted && e === o.iScale, s = i.length, a = this._getOtherScale(e), l = Ij(t, o, this.chart), d = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: c } = Ej(a);
    let f, h;
    function p() {
      h = i[f];
      const m = h[a.axis];
      return !Gn(h[e.axis]) || u > m || c < m;
    }
    for (f = 0; f < s && !(!p() && (this.updateRangeFromParsed(d, e, h, l), r)); ++f)
      ;
    if (r) {
      for (f = s - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(d, e, h, l);
          break;
        }
    }
    return d;
  }
  getAllParsedValues(e) {
    const t = this._cachedMeta._parsed, o = [];
    let i, r, s;
    for (i = 0, r = t.length; i < r; ++i)
      s = t[i][e.axis], Gn(s) && o.push(s);
    return o;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const t = this._cachedMeta, o = t.iScale, i = t.vScale, r = this.getParsed(e);
    return {
      label: o ? "" + o.getLabelForValue(r[o.axis]) : "",
      value: i ? "" + i.getLabelForValue(r[i.axis]) : ""
    };
  }
  _update(e) {
    const t = this._cachedMeta;
    this.update(e || "default"), t._clip = Mj(Je(this.options.clip, $j(t.xScale, t.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, t = this.chart, o = this._cachedMeta, i = o.data || [], r = t.chartArea, s = [], a = this._drawStart || 0, l = this._drawCount || i.length - a, d = this.options.drawActiveElementsOnTop;
    let u;
    for (o.dataset && o.dataset.draw(e, r, a, l), u = a; u < a + l; ++u) {
      const c = i[u];
      c.hidden || (c.active && d ? s.push(c) : c.draw(e, r));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(e, r);
  }
  getStyle(e, t) {
    const o = t ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(o) : this.resolveDataElementOptions(e || 0, o);
  }
  getContext(e, t, o) {
    const i = this.getDataset();
    let r;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[e];
      r = s.$context || (s.$context = Aj(this.getContext(), e, s)), r.parsed = this.getParsed(e), r.raw = i.data[e], r.index = r.dataIndex = e;
    } else
      r = this.$context || (this.$context = Tj(this.chart.getContext(), this.index)), r.dataset = i, r.index = r.datasetIndex = this.index;
    return r.active = !!t, r.mode = o, r;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, t) {
    return this._resolveElementOptions(this.dataElementType.id, t, e);
  }
  _resolveElementOptions(e, t = "default", o) {
    const i = t === "active", r = this._cachedDataOpts, s = e + "-" + t, a = r[s], l = this.enableOptionSharing && qd(o);
    if (a)
      return jm(a, l);
    const d = this.chart.config, u = d.datasetElementScopeKeys(this._type, e), c = i ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], f = d.getOptionScopes(this.getDataset(), u), h = Object.keys(wt.elements[e]), p = () => this.getContext(o, i, t), m = d.resolveNamedOptions(f, h, p, c);
    return m.$shared && (m.$shared = l, r[s] = Object.freeze(jm(m, l))), m;
  }
  _resolveAnimations(e, t, o) {
    const i = this.chart, r = this._cachedDataOpts, s = `animation-${t}`, a = r[s];
    if (a)
      return a;
    let l;
    if (i.options.animation !== !1) {
      const u = this.chart.config, c = u.datasetAnimationScopeKeys(this._type, t), f = u.getOptionScopes(this.getDataset(), c);
      l = u.createResolver(f, this.getContext(e, o, t));
    }
    const d = new T9(i, l && l.animations);
    return l && l._cacheable && (r[s] = Object.freeze(d)), d;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, t) {
    return !t || Uc(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, t) {
    const o = this.resolveDataElementOptions(e, t), i = this._sharedOptions, r = this.getSharedOptions(o), s = this.includeOptions(t, r) || r !== i;
    return this.updateSharedOptions(r, t, o), {
      sharedOptions: r,
      includeOptions: s
    };
  }
  updateElement(e, t, o, i) {
    Uc(i) ? Object.assign(e, o) : this._resolveAnimations(t, i).update(e, o);
  }
  updateSharedOptions(e, t, o) {
    e && !Uc(t) && this._resolveAnimations(void 0, t).update(e, o);
  }
  _setStyle(e, t, o, i) {
    e.active = i;
    const r = this.getStyle(t, i);
    this._resolveAnimations(t, o, i).update(e, {
      options: !i && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(e, t, o) {
    this._setStyle(e, o, "active", !1);
  }
  setHoverStyle(e, t, o) {
    this._setStyle(e, o, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const t = this._data, o = this._cachedMeta.data;
    for (const [a, l, d] of this._syncList)
      this[a](l, d);
    this._syncList = [];
    const i = o.length, r = t.length, s = Math.min(r, i);
    s && this.parse(0, s), r > i ? this._insertElements(i, r - i, e) : r < i && this._removeElements(r, i - r);
  }
  _insertElements(e, t, o = !0) {
    const i = this._cachedMeta, r = i.data, s = e + t;
    let a;
    const l = (d) => {
      for (d.length += t, a = d.length - 1; a >= s; a--)
        d[a] = d[a - t];
    };
    for (l(r), a = e; a < s; ++a)
      r[a] = new this.dataElementType();
    this._parsing && l(i._parsed), this.parse(e, t), o && this.updateElements(r, e, t, "reset");
  }
  updateElements(e, t, o, i) {
  }
  _removeElements(e, t) {
    const o = this._cachedMeta;
    if (this._parsing) {
      const i = o._parsed.splice(e, t);
      o._stacked && Es(o, i);
    }
    o.data.splice(e, t);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [t, o, i] = e;
      this[t](o, i);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, t) {
    t && this._sync([
      "_removeElements",
      e,
      t
    ]);
    const o = arguments.length - 2;
    o && this._sync([
      "_insertElements",
      e,
      o
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
Ae(da, "defaults", {}), Ae(da, "datasetElementType", null), Ae(da, "dataElementType", null);
function Dj(n, e, t) {
  let o = 1, i = 1, r = 0, s = 0;
  if (e < St) {
    const a = n, l = a + e, d = Math.cos(a), u = Math.sin(a), c = Math.cos(l), f = Math.sin(l), h = (w, M, $) => Qd(w, a, l, !0) ? 1 : Math.max(M, M * t, $, $ * t), p = (w, M, $) => Qd(w, a, l, !0) ? -1 : Math.min(M, M * t, $, $ * t), m = h(0, d, c), g = h(Ot, u, f), b = p(nt, d, c), x = p(nt + Ot, u, f);
    o = (m - b) / 2, i = (g - x) / 2, r = -(m + b) / 2, s = -(g + x) / 2;
  }
  return {
    ratioX: o,
    ratioY: i,
    offsetX: r,
    offsetY: s
  };
}
class js extends da {
  constructor(e, t) {
    super(e, t), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, t) {
    const o = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = o;
    else {
      let r = (l) => +o[l];
      if (je(o[e])) {
        const { key: l = "value" } = this._parsing;
        r = (d) => +Na(o[d], l);
      }
      let s, a;
      for (s = e, a = e + t; s < a; ++s)
        i._parsed[s] = r(s);
    }
  }
  _getRotation() {
    return Lo(this.options.rotation - 90);
  }
  _getCircumference() {
    return Lo(this.options.circumference);
  }
  _getRotationExtents() {
    let e = St, t = -St;
    for (let o = 0; o < this.chart.data.datasets.length; ++o)
      if (this.chart.isDatasetVisible(o) && this.chart.getDatasetMeta(o).type === this._type) {
        const i = this.chart.getDatasetMeta(o).controller, r = i._getRotation(), s = i._getCircumference();
        e = Math.min(e, r), t = Math.max(t, r + s);
      }
    return {
      rotation: e,
      circumference: t - e
    };
  }
  update(e) {
    const t = this.chart, { chartArea: o } = t, i = this._cachedMeta, r = i.data, s = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, a = Math.max((Math.min(o.width, o.height) - s) / 2, 0), l = Math.min(mH(this.options.cutout, a), 1), d = this._getRingWeight(this.index), { circumference: u, rotation: c } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: p, offsetY: m } = Dj(c, u, l), g = (o.width - s) / f, b = (o.height - s) / h, x = Math.max(Math.min(g, b) / 2, 0), w = f9(this.options.radius, x), M = Math.max(w * l, 0), $ = (w - M) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * w, this.offsetY = m * w, i.total = this.calculateTotal(), this.outerRadius = w - $ * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - $ * d, 0), this.updateElements(r, 0, r.length, e);
  }
  _circumference(e, t) {
    const o = this.options, i = this._cachedMeta, r = this._getCircumference();
    return t && o.animation.animateRotate || !this.chart.getDataVisibility(e) || i._parsed[e] === null || i.data[e].hidden ? 0 : this.calculateCircumference(i._parsed[e] * r / St);
  }
  updateElements(e, t, o, i) {
    const r = i === "reset", s = this.chart, a = s.chartArea, d = s.options.animation, u = (a.left + a.right) / 2, c = (a.top + a.bottom) / 2, f = r && d.animateScale, h = f ? 0 : this.innerRadius, p = f ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: g } = this._getSharedOptions(t, i);
    let b = this._getRotation(), x;
    for (x = 0; x < t; ++x)
      b += this._circumference(x, r);
    for (x = t; x < t + o; ++x) {
      const w = this._circumference(x, r), M = e[x], $ = {
        x: u + this.offsetX,
        y: c + this.offsetY,
        startAngle: b,
        endAngle: b + w,
        circumference: w,
        outerRadius: p,
        innerRadius: h
      };
      g && ($.options = m || this.resolveDataElementOptions(x, M.active ? "active" : i)), b += w, this.updateElement(M, x, $, i);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, t = e.data;
    let o = 0, i;
    for (i = 0; i < t.length; i++) {
      const r = e._parsed[i];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(i) && !t[i].hidden && (o += Math.abs(r));
    }
    return o;
  }
  calculateCircumference(e) {
    const t = this._cachedMeta.total;
    return t > 0 && !isNaN(e) ? St * (Math.abs(e) / t) : 0;
  }
  getLabelAndValue(e) {
    const t = this._cachedMeta, o = this.chart, i = o.data.labels || [], r = Yh(t._parsed[e], o.options.locale);
    return {
      label: i[e] || "",
      value: r
    };
  }
  getMaxBorderWidth(e) {
    let t = 0;
    const o = this.chart;
    let i, r, s, a, l;
    if (!e) {
      for (i = 0, r = o.data.datasets.length; i < r; ++i)
        if (o.isDatasetVisible(i)) {
          s = o.getDatasetMeta(i), e = s.data, a = s.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (i = 0, r = e.length; i < r; ++i)
      l = a.resolveDataElementOptions(i), l.borderAlign !== "inner" && (t = Math.max(t, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return t;
  }
  getMaxOffset(e) {
    let t = 0;
    for (let o = 0, i = e.length; o < i; ++o) {
      const r = this.resolveDataElementOptions(o);
      t = Math.max(t, r.offset || 0, r.hoverOffset || 0);
    }
    return t;
  }
  _getRingWeightOffset(e) {
    let t = 0;
    for (let o = 0; o < e; ++o)
      this.chart.isDatasetVisible(o) && (t += this._getRingWeight(o));
    return t;
  }
  _getRingWeight(e) {
    return Math.max(Je(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Ae(js, "id", "doughnut"), Ae(js, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), Ae(js, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), Ae(js, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data, { labels: { pointStyle: o, textAlign: i, color: r, useBorderRadius: s, borderRadius: a } } = e.legend.options;
          return t.labels.length && t.datasets.length ? t.labels.map((l, d) => {
            const c = e.getDatasetMeta(0).controller.getStyle(d);
            return {
              text: l,
              fillStyle: c.backgroundColor,
              fontColor: r,
              hidden: !e.getDataVisibility(d),
              lineDash: c.borderDash,
              lineDashOffset: c.borderDashOffset,
              lineJoin: c.borderJoinStyle,
              lineWidth: c.borderWidth,
              strokeStyle: c.borderColor,
              textAlign: i,
              pointStyle: o,
              borderRadius: s && (a || c.borderRadius),
              index: d
            };
          }) : [];
        }
      },
      onClick(e, t, o) {
        o.chart.toggleDataVisibility(t.index), o.chart.update();
      }
    }
  }
});
function Hi() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class o0 {
  constructor(e) {
    Ae(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(o0.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Hi();
  }
  parse() {
    return Hi();
  }
  format() {
    return Hi();
  }
  add() {
    return Hi();
  }
  diff() {
    return Hi();
  }
  startOf() {
    return Hi();
  }
  endOf() {
    return Hi();
  }
}
var Nj = {
  _date: o0
};
function Pj(n, e, t, o) {
  const { controller: i, data: r, _sorted: s } = n, a = i._cachedMeta.iScale, l = n.dataset && n.dataset.options ? n.dataset.options.spanGaps : null;
  if (a && e === a.axis && e !== "r" && s && r.length) {
    const d = a._reversePixels ? OH : r1;
    if (o) {
      if (i._sharedOptions) {
        const u = r[0], c = typeof u.getRange == "function" && u.getRange(e);
        if (c) {
          const f = d(r, e, t - c), h = d(r, e, t + c);
          return {
            lo: f.lo,
            hi: h.hi
          };
        }
      }
    } else {
      const u = d(r, e, t);
      if (l) {
        const { vScale: c } = i._cachedMeta, { _parsed: f } = n, h = f.slice(0, u.lo + 1).reverse().findIndex((m) => !pt(m[c.axis]));
        u.lo -= Math.max(0, h);
        const p = f.slice(u.hi).findIndex((m) => !pt(m[c.axis]));
        u.hi += Math.max(0, p);
      }
      return u;
    }
  }
  return {
    lo: 0,
    hi: r.length - 1
  };
}
function zu(n, e, t, o, i) {
  const r = n.getSortedVisibleDatasetMetas(), s = t[e];
  for (let a = 0, l = r.length; a < l; ++a) {
    const { index: d, data: u } = r[a], { lo: c, hi: f } = Pj(r[a], e, s, i);
    for (let h = c; h <= f; ++h) {
      const p = u[h];
      p.skip || o(p, d, h);
    }
  }
}
function Lj(n) {
  const e = n.indexOf("x") !== -1, t = n.indexOf("y") !== -1;
  return function(o, i) {
    const r = e ? Math.abs(o.x - i.x) : 0, s = t ? Math.abs(o.y - i.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(s, 2));
  };
}
function Kc(n, e, t, o, i) {
  const r = [];
  return !i && !n.isPointInArea(e) || zu(n, t, e, function(a, l, d) {
    !i && !w9(a, n.chartArea, 0) || a.inRange(e.x, e.y, o) && r.push({
      element: a,
      datasetIndex: l,
      index: d
    });
  }, !0), r;
}
function Rj(n, e, t, o) {
  let i = [];
  function r(s, a, l) {
    const { startAngle: d, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], o), { angle: c } = m9(s, {
      x: e.x,
      y: e.y
    });
    Qd(c, d, u) && i.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }
  return zu(n, t, e, r), i;
}
function Fj(n, e, t, o, i, r) {
  let s = [];
  const a = Lj(t);
  let l = Number.POSITIVE_INFINITY;
  function d(u, c, f) {
    const h = u.inRange(e.x, e.y, i);
    if (o && !h)
      return;
    const p = u.getCenterPoint(i);
    if (!(!!r || n.isPointInArea(p)) && !h)
      return;
    const g = a(e, p);
    g < l ? (s = [
      {
        element: u,
        datasetIndex: c,
        index: f
      }
    ], l = g) : g === l && s.push({
      element: u,
      datasetIndex: c,
      index: f
    });
  }
  return zu(n, t, e, d), s;
}
function Gc(n, e, t, o, i, r) {
  return !r && !n.isPointInArea(e) ? [] : t === "r" && !o ? Rj(n, e, t, i) : Fj(n, e, t, o, i, r);
}
function Wm(n, e, t, o, i) {
  const r = [], s = t === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return zu(n, t, e, (l, d, u) => {
    l[s] && l[s](e[t], i) && (r.push({
      element: l,
      datasetIndex: d,
      index: u
    }), a = a || l.inRange(e.x, e.y, i));
  }), o && !a ? [] : r;
}
var Bj = {
  modes: {
    index(n, e, t, o) {
      const i = ji(e, n), r = t.axis || "x", s = t.includeInvisible || !1, a = t.intersect ? Kc(n, i, r, o, s) : Gc(n, i, r, !1, o, s), l = [];
      return a.length ? (n.getSortedVisibleDatasetMetas().forEach((d) => {
        const u = a[0].index, c = d.data[u];
        c && !c.skip && l.push({
          element: c,
          datasetIndex: d.index,
          index: u
        });
      }), l) : [];
    },
    dataset(n, e, t, o) {
      const i = ji(e, n), r = t.axis || "xy", s = t.includeInvisible || !1;
      let a = t.intersect ? Kc(n, i, r, o, s) : Gc(n, i, r, !1, o, s);
      if (a.length > 0) {
        const l = a[0].datasetIndex, d = n.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < d.length; ++u)
          a.push({
            element: d[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(n, e, t, o) {
      const i = ji(e, n), r = t.axis || "xy", s = t.includeInvisible || !1;
      return Kc(n, i, r, o, s);
    },
    nearest(n, e, t, o) {
      const i = ji(e, n), r = t.axis || "xy", s = t.includeInvisible || !1;
      return Gc(n, i, r, t.intersect, o, s);
    },
    x(n, e, t, o) {
      const i = ji(e, n);
      return Wm(n, i, "x", t.intersect, o);
    },
    y(n, e, t, o) {
      const i = ji(e, n);
      return Wm(n, i, "y", t.intersect, o);
    }
  }
};
const I9 = [
  "left",
  "top",
  "right",
  "bottom"
];
function Os(n, e) {
  return n.filter((t) => t.pos === e);
}
function Um(n, e) {
  return n.filter((t) => I9.indexOf(t.pos) === -1 && t.box.axis === e);
}
function Ts(n, e) {
  return n.sort((t, o) => {
    const i = e ? o : t, r = e ? t : o;
    return i.weight === r.weight ? i.index - r.index : i.weight - r.weight;
  });
}
function Vj(n) {
  const e = [];
  let t, o, i, r, s, a;
  for (t = 0, o = (n || []).length; t < o; ++t)
    i = n[t], { position: r, options: { stack: s, stackWeight: a = 1 } } = i, e.push({
      index: t,
      box: i,
      pos: r,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: s && r + s,
      stackWeight: a
    });
  return e;
}
function zj(n) {
  const e = {};
  for (const t of n) {
    const { stack: o, pos: i, stackWeight: r } = t;
    if (!o || !I9.includes(i))
      continue;
    const s = e[o] || (e[o] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += r;
  }
  return e;
}
function Hj(n, e) {
  const t = zj(n), { vBoxMaxWidth: o, hBoxMaxHeight: i } = e;
  let r, s, a;
  for (r = 0, s = n.length; r < s; ++r) {
    a = n[r];
    const { fullSize: l } = a.box, d = t[a.stack], u = d && a.stackWeight / d.weight;
    a.horizontal ? (a.width = u ? u * o : l && e.availableWidth, a.height = i) : (a.width = o, a.height = u ? u * i : l && e.availableHeight);
  }
  return t;
}
function jj(n) {
  const e = Vj(n), t = Ts(e.filter((d) => d.box.fullSize), !0), o = Ts(Os(e, "left"), !0), i = Ts(Os(e, "right")), r = Ts(Os(e, "top"), !0), s = Ts(Os(e, "bottom")), a = Um(e, "x"), l = Um(e, "y");
  return {
    fullSize: t,
    leftAndTop: o.concat(r),
    rightAndBottom: i.concat(l).concat(s).concat(a),
    chartArea: Os(e, "chartArea"),
    vertical: o.concat(i).concat(l),
    horizontal: r.concat(s).concat(a)
  };
}
function Km(n, e, t, o) {
  return Math.max(n[t], e[t]) + Math.max(n[o], e[o]);
}
function D9(n, e) {
  n.top = Math.max(n.top, e.top), n.left = Math.max(n.left, e.left), n.bottom = Math.max(n.bottom, e.bottom), n.right = Math.max(n.right, e.right);
}
function Wj(n, e, t, o) {
  const { pos: i, box: r } = t, s = n.maxPadding;
  if (!je(i)) {
    t.size && (n[i] -= t.size);
    const c = o[t.stack] || {
      size: 0,
      count: 1
    };
    c.size = Math.max(c.size, t.horizontal ? r.height : r.width), t.size = c.size / c.count, n[i] += t.size;
  }
  r.getPadding && D9(s, r.getPadding());
  const a = Math.max(0, e.outerWidth - Km(s, n, "left", "right")), l = Math.max(0, e.outerHeight - Km(s, n, "top", "bottom")), d = a !== n.w, u = l !== n.h;
  return n.w = a, n.h = l, t.horizontal ? {
    same: d,
    other: u
  } : {
    same: u,
    other: d
  };
}
function Uj(n) {
  const e = n.maxPadding;
  function t(o) {
    const i = Math.max(e[o] - n[o], 0);
    return n[o] += i, i;
  }
  n.y += t("top"), n.x += t("left"), t("right"), t("bottom");
}
function Kj(n, e) {
  const t = e.maxPadding;
  function o(i) {
    const r = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return i.forEach((s) => {
      r[s] = Math.max(e[s], t[s]);
    }), r;
  }
  return o(n ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Ws(n, e, t, o) {
  const i = [];
  let r, s, a, l, d, u;
  for (r = 0, s = n.length, d = 0; r < s; ++r) {
    a = n[r], l = a.box, l.update(a.width || e.w, a.height || e.h, Kj(a.horizontal, e));
    const { same: c, other: f } = Wj(e, t, a, o);
    d |= c && i.length, u = u || f, l.fullSize || i.push(a);
  }
  return d && Ws(i, e, t, o) || u;
}
function $l(n, e, t, o, i) {
  n.top = t, n.left = e, n.right = e + o, n.bottom = t + i, n.width = o, n.height = i;
}
function Gm(n, e, t, o) {
  const i = t.padding;
  let { x: r, y: s } = e;
  for (const a of n) {
    const l = a.box, d = o[a.stack] || {
      placed: 0,
      weight: 1
    }, u = a.stackWeight / d.weight || 1;
    if (a.horizontal) {
      const c = e.w * u, f = d.size || l.height;
      qd(d.start) && (s = d.start), l.fullSize ? $l(l, i.left, s, t.outerWidth - i.right - i.left, f) : $l(l, e.left + d.placed, s, c, f), d.start = s, d.placed += c, s = l.bottom;
    } else {
      const c = e.h * u, f = d.size || l.width;
      qd(d.start) && (r = d.start), l.fullSize ? $l(l, r, i.top, f, t.outerHeight - i.bottom - i.top) : $l(l, r, e.top + d.placed, f, c), d.start = r, d.placed += c, r = l.right;
    }
  }
  e.x = r, e.y = s;
}
var jn = {
  addBox(n, e) {
    n.boxes || (n.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(t) {
            e.draw(t);
          }
        }
      ];
    }, n.boxes.push(e);
  },
  removeBox(n, e) {
    const t = n.boxes ? n.boxes.indexOf(e) : -1;
    t !== -1 && n.boxes.splice(t, 1);
  },
  configure(n, e, t) {
    e.fullSize = t.fullSize, e.position = t.position, e.weight = t.weight;
  },
  update(n, e, t, o) {
    if (!n)
      return;
    const i = Yn(n.options.layout.padding), r = Math.max(e - i.width, 0), s = Math.max(t - i.height, 0), a = jj(n.boxes), l = a.vertical, d = a.horizontal;
    et(n.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const u = l.reduce((m, g) => g.box.options && g.box.options.display === !1 ? m : m + 1, 0) || 1, c = Object.freeze({
      outerWidth: e,
      outerHeight: t,
      padding: i,
      availableWidth: r,
      availableHeight: s,
      vBoxMaxWidth: r / 2 / u,
      hBoxMaxHeight: s / 2
    }), f = Object.assign({}, i);
    D9(f, Yn(o));
    const h = Object.assign({
      maxPadding: f,
      w: r,
      h: s,
      x: i.left,
      y: i.top
    }, i), p = Hj(l.concat(d), c);
    Ws(a.fullSize, h, c, p), Ws(l, h, c, p), Ws(d, h, c, p) && Ws(l, h, c, p), Uj(h), Gm(a.leftAndTop, h, c, p), h.x += h.w, h.y += h.h, Gm(a.rightAndBottom, h, c, p), n.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, et(a.chartArea, (m) => {
      const g = m.box;
      Object.assign(g, n.chartArea), g.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class N9 {
  acquireContext(e, t) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, t, o) {
  }
  removeEventListener(e, t, o) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, t, o, i) {
    return t = Math.max(0, t || e.width), o = o || e.height, {
      width: t,
      height: Math.max(0, i ? Math.floor(t / i) : o)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class Gj extends N9 {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const Hl = "$chartjs", Yj = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Ym = (n) => n === null || n === "";
function qj(n, e) {
  const t = n.style, o = n.getAttribute("height"), i = n.getAttribute("width");
  if (n[Hl] = {
    initial: {
      height: o,
      width: i,
      style: {
        display: t.display,
        height: t.height,
        width: t.width
      }
    }
  }, t.display = t.display || "block", t.boxSizing = t.boxSizing || "border-box", Ym(i)) {
    const r = Rm(n, "width");
    r !== void 0 && (n.width = r);
  }
  if (Ym(o))
    if (n.style.height === "")
      n.height = n.width / (e || 2);
    else {
      const r = Rm(n, "height");
      r !== void 0 && (n.height = r);
    }
  return n;
}
const P9 = pj ? {
  passive: !0
} : !1;
function Zj(n, e, t) {
  n && n.addEventListener(e, t, P9);
}
function Jj(n, e, t) {
  n && n.canvas && n.canvas.removeEventListener(e, t, P9);
}
function Xj(n, e) {
  const t = Yj[n.type] || n.type, { x: o, y: i } = ji(n, e);
  return {
    type: t,
    chart: e,
    native: n,
    x: o !== void 0 ? o : null,
    y: i !== void 0 ? i : null
  };
}
function nu(n, e) {
  for (const t of n)
    if (t === e || t.contains(e))
      return !0;
}
function Qj(n, e, t) {
  const o = n.canvas, i = new MutationObserver((r) => {
    let s = !1;
    for (const a of r)
      s = s || nu(a.addedNodes, o), s = s && !nu(a.removedNodes, o);
    s && t();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
function eW(n, e, t) {
  const o = n.canvas, i = new MutationObserver((r) => {
    let s = !1;
    for (const a of r)
      s = s || nu(a.removedNodes, o), s = s && !nu(a.addedNodes, o);
    s && t();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
const La = /* @__PURE__ */ new Map();
let qm = 0;
function L9() {
  const n = window.devicePixelRatio;
  n !== qm && (qm = n, La.forEach((e, t) => {
    t.currentDevicePixelRatio !== n && e();
  }));
}
function tW(n, e) {
  La.size || window.addEventListener("resize", L9), La.set(n, e);
}
function nW(n) {
  La.delete(n), La.size || window.removeEventListener("resize", L9);
}
function oW(n, e, t) {
  const o = n.canvas, i = o && n0(o);
  if (!i)
    return;
  const r = b9((a, l) => {
    const d = i.clientWidth;
    t(a, l), d < i.clientWidth && t();
  }, window), s = new ResizeObserver((a) => {
    const l = a[0], d = l.contentRect.width, u = l.contentRect.height;
    d === 0 && u === 0 || r(d, u);
  });
  return s.observe(i), tW(n, r), s;
}
function Yc(n, e, t) {
  t && t.disconnect(), e === "resize" && nW(n);
}
function iW(n, e, t) {
  const o = n.canvas, i = b9((r) => {
    n.ctx !== null && t(Xj(r, n));
  }, n);
  return Zj(o, e, i), i;
}
class rW extends N9 {
  acquireContext(e, t) {
    const o = e && e.getContext && e.getContext("2d");
    return o && o.canvas === e ? (qj(e, t), o) : null;
  }
  releaseContext(e) {
    const t = e.canvas;
    if (!t[Hl])
      return !1;
    const o = t[Hl].initial;
    [
      "height",
      "width"
    ].forEach((r) => {
      const s = o[r];
      pt(s) ? t.removeAttribute(r) : t.setAttribute(r, s);
    });
    const i = o.style || {};
    return Object.keys(i).forEach((r) => {
      t.style[r] = i[r];
    }), t.width = t.width, delete t[Hl], !0;
  }
  addEventListener(e, t, o) {
    this.removeEventListener(e, t);
    const i = e.$proxies || (e.$proxies = {}), s = {
      attach: Qj,
      detach: eW,
      resize: oW
    }[t] || iW;
    i[t] = s(e, t, o);
  }
  removeEventListener(e, t) {
    const o = e.$proxies || (e.$proxies = {}), i = o[t];
    if (!i)
      return;
    ({
      attach: Yc,
      detach: Yc,
      resize: Yc
    }[t] || Jj)(e, t, i), o[t] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, t, o, i) {
    return hj(e, t, o, i);
  }
  isAttached(e) {
    const t = e && n0(e);
    return !!(t && t.isConnected);
  }
}
function sW(n) {
  return !t0() || typeof OffscreenCanvas < "u" && n instanceof OffscreenCanvas ? Gj : rW;
}
var Al;
let Cr = (Al = class {
  constructor() {
    Ae(this, "x");
    Ae(this, "y");
    Ae(this, "active", !1);
    Ae(this, "options");
    Ae(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: t, y: o } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: t,
      y: o
    };
  }
  hasValue() {
    return Xd(this.x) && Xd(this.y);
  }
  getProps(e, t) {
    const o = this.$animations;
    if (!t || !o)
      return this;
    const i = {};
    return e.forEach((r) => {
      i[r] = o[r] && o[r].active() ? o[r]._to : this[r];
    }), i;
  }
}, Ae(Al, "defaults", {}), Ae(Al, "defaultRoutes"), Al);
function aW(n, e) {
  const t = n.options.ticks, o = lW(n), i = Math.min(t.maxTicksLimit || o, o), r = t.major.enabled ? uW(e) : [], s = r.length, a = r[0], l = r[s - 1], d = [];
  if (s > i)
    return cW(e, d, r, s / i), d;
  const u = dW(r, e, i);
  if (s > 0) {
    let c, f;
    const h = s > 1 ? Math.round((l - a) / (s - 1)) : null;
    for (Ml(e, d, u, pt(h) ? 0 : a - h, a), c = 0, f = s - 1; c < f; c++)
      Ml(e, d, u, r[c], r[c + 1]);
    return Ml(e, d, u, l, pt(h) ? e.length : l + h), d;
  }
  return Ml(e, d, u), d;
}
function lW(n) {
  const e = n.options.offset, t = n._tickSize(), o = n._length / t + (e ? 0 : 1), i = n._maxLength / t;
  return Math.floor(Math.min(o, i));
}
function dW(n, e, t) {
  const o = fW(n), i = e.length / t;
  if (!o)
    return Math.max(i, 1);
  const r = wH(o);
  for (let s = 0, a = r.length - 1; s < a; s++) {
    const l = r[s];
    if (l > i)
      return l;
  }
  return Math.max(i, 1);
}
function uW(n) {
  const e = [];
  let t, o;
  for (t = 0, o = n.length; t < o; t++)
    n[t].major && e.push(t);
  return e;
}
function cW(n, e, t, o) {
  let i = 0, r = t[0], s;
  for (o = Math.ceil(o), s = 0; s < n.length; s++)
    s === r && (e.push(n[s]), i++, r = t[i * o]);
}
function Ml(n, e, t, o, i) {
  const r = Je(o, 0), s = Math.min(Je(i, n.length), n.length);
  let a = 0, l, d, u;
  for (t = Math.ceil(t), i && (l = i - o, t = l / Math.floor(l / t)), u = r; u < 0; )
    a++, u = Math.round(r + a * t);
  for (d = Math.max(r, 0); d < s; d++)
    d === u && (e.push(n[d]), a++, u = Math.round(r + a * t));
}
function fW(n) {
  const e = n.length;
  let t, o;
  if (e < 2)
    return !1;
  for (o = n[0], t = 1; t < e; ++t)
    if (n[t] - n[t - 1] !== o)
      return !1;
  return o;
}
const hW = (n) => n === "left" ? "right" : n === "right" ? "left" : n, Zm = (n, e, t) => e === "top" || e === "left" ? n[e] + t : n[e] - t, Jm = (n, e) => Math.min(e || n, n);
function Xm(n, e) {
  const t = [], o = n.length / e, i = n.length;
  let r = 0;
  for (; r < i; r += o)
    t.push(n[Math.floor(r)]);
  return t;
}
function pW(n, e, t) {
  const o = n.ticks.length, i = Math.min(e, o - 1), r = n._startPixel, s = n._endPixel, a = 1e-6;
  let l = n.getPixelForTick(i), d;
  if (!(t && (o === 1 ? d = Math.max(l - r, s - l) : e === 0 ? d = (n.getPixelForTick(1) - l) / 2 : d = (l - n.getPixelForTick(i - 1)) / 2, l += i < e ? d : -d, l < r - a || l > s + a)))
    return l;
}
function mW(n, e) {
  et(n, (t) => {
    const o = t.gc, i = o.length / 2;
    let r;
    if (i > e) {
      for (r = 0; r < i; ++r)
        delete t.data[o[r]];
      o.splice(0, i);
    }
  });
}
function As(n) {
  return n.drawTicks ? n.tickLength : 0;
}
function Qm(n, e) {
  if (!n.display)
    return 0;
  const t = Jt(n.font, e), o = Yn(n.padding);
  return (Nt(n.text) ? n.text.length : 1) * t.lineHeight + o.height;
}
function gW(n, e) {
  return Cs(n, {
    scale: e,
    type: "scale"
  });
}
function vW(n, e, t) {
  return Cs(n, {
    tick: t,
    index: e,
    type: "tick"
  });
}
function bW(n, e, t) {
  let o = Gh(n);
  return (t && e !== "right" || !t && e === "right") && (o = hW(o)), o;
}
function yW(n, e, t, o) {
  const { top: i, left: r, bottom: s, right: a, chart: l } = n, { chartArea: d, scales: u } = l;
  let c = 0, f, h, p;
  const m = s - i, g = a - r;
  if (n.isHorizontal()) {
    if (h = Kt(o, r, a), je(t)) {
      const b = Object.keys(t)[0], x = t[b];
      p = u[b].getPixelForValue(x) + m - e;
    } else t === "center" ? p = (d.bottom + d.top) / 2 + m - e : p = Zm(n, t, e);
    f = a - r;
  } else {
    if (je(t)) {
      const b = Object.keys(t)[0], x = t[b];
      h = u[b].getPixelForValue(x) - g + e;
    } else t === "center" ? h = (d.left + d.right) / 2 - g + e : h = Zm(n, t, e);
    p = Kt(o, s, i), c = t === "left" ? -Ot : Ot;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: c
  };
}
class ws extends Cr {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, t) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: t, _suggestedMin: o, _suggestedMax: i } = this;
    return e = ao(e, Number.POSITIVE_INFINITY), t = ao(t, Number.NEGATIVE_INFINITY), o = ao(o, Number.POSITIVE_INFINITY), i = ao(i, Number.NEGATIVE_INFINITY), {
      min: ao(e, o),
      max: ao(t, i),
      minDefined: Gn(e),
      maxDefined: Gn(t)
    };
  }
  getMinMax(e) {
    let { min: t, max: o, minDefined: i, maxDefined: r } = this.getUserBounds(), s;
    if (i && r)
      return {
        min: t,
        max: o
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, d = a.length; l < d; ++l)
      s = a[l].controller.getMinMax(this, e), i || (t = Math.min(t, s.min)), r || (o = Math.max(o, s.max));
    return t = r && t > o ? o : t, o = i && t > o ? t : o, {
      min: ao(t, ao(o, t)),
      max: ao(o, ao(t, o))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    at(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, t, o) {
    const { beginAtZero: i, grace: r, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = t, this._margins = o = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, o), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + o.left + o.right : this.height + o.top + o.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = XH(this, r, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? Xm(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = aW(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, t, o;
    this.isHorizontal() ? (t = this.left, o = this.right) : (t = this.top, o = this.bottom, e = !e), this._startPixel = t, this._endPixel = o, this._reversePixels = e, this._length = o - t, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    at(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    at(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    at(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), at(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    at(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const t = this.options.ticks;
    let o, i, r;
    for (o = 0, i = e.length; o < i; o++)
      r = e[o], r.label = at(t.callback, [
        r.value,
        o,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    at(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    at(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, t = e.ticks, o = Jm(this.ticks.length, e.ticks.maxTicksLimit), i = t.minRotation || 0, r = t.maxRotation;
    let s = i, a, l, d;
    if (!this._isVisible() || !t.display || i >= r || o <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const u = this._getLabelSizes(), c = u.widest.width, f = u.highest.height, h = yn(this.chart.width - c, 0, this.maxWidth);
    a = e.offset ? this.maxWidth / o : h / (o - 1), c + 6 > a && (a = h / (o - (e.offset ? 0.5 : 1)), l = this.maxHeight - As(e.grid) - t.padding - Qm(e.title, this.chart.options.font), d = Math.sqrt(c * c + f * f), s = SH(Math.min(Math.asin(yn((u.highest.height + 6) / a, -1, 1)), Math.asin(yn(l / d, -1, 1)) - Math.asin(yn(f / d, -1, 1)))), s = Math.max(i, Math.min(r, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    at(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    at(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: t, options: { ticks: o, title: i, grid: r } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const l = Qm(i, t.options.font);
      if (a ? (e.width = this.maxWidth, e.height = As(r) + l) : (e.height = this.maxHeight, e.width = As(r) + l), o.display && this.ticks.length) {
        const { first: d, last: u, widest: c, highest: f } = this._getLabelSizes(), h = o.padding * 2, p = Lo(this.labelRotation), m = Math.cos(p), g = Math.sin(p);
        if (a) {
          const b = o.mirror ? 0 : g * c.width + m * f.height;
          e.height = Math.min(this.maxHeight, e.height + b + h);
        } else {
          const b = o.mirror ? 0 : m * c.width + g * f.height;
          e.width = Math.min(this.maxWidth, e.width + b + h);
        }
        this._calculatePadding(d, u, g, m);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = t.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = t.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, t, o, i) {
    const { ticks: { align: r, padding: s }, position: a } = this.options, l = this.labelRotation !== 0, d = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, c = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? d ? (f = i * e.width, h = o * t.height) : (f = o * e.height, h = i * t.width) : r === "start" ? h = t.width : r === "end" ? f = e.width : r !== "inner" && (f = e.width / 2, h = t.width / 2), this.paddingLeft = Math.max((f - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - c + s) * this.width / (this.width - c), 0);
    } else {
      let u = t.height / 2, c = e.height / 2;
      r === "start" ? (u = 0, c = e.height) : r === "end" && (u = t.height, c = 0), this.paddingTop = u + s, this.paddingBottom = c + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    at(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: t } = this.options;
    return t === "top" || t === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let t, o;
    for (t = 0, o = e.length; t < o; t++)
      pt(e[t].label) && (e.splice(t, 1), o--, t--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const t = this.options.ticks.sampleSize;
      let o = this.ticks;
      t < o.length && (o = Xm(o, t)), this._labelSizes = e = this._computeLabelSizes(o, o.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, t, o) {
    const { ctx: i, _longestTextCache: r } = this, s = [], a = [], l = Math.floor(t / Jm(t, o));
    let d = 0, u = 0, c, f, h, p, m, g, b, x, w, M, $;
    for (c = 0; c < t; c += l) {
      if (p = e[c].label, m = this._resolveTickFontOptions(c), i.font = g = m.string, b = r[g] = r[g] || {
        data: {},
        gc: []
      }, x = m.lineHeight, w = M = 0, !pt(p) && !Nt(p))
        w = Am(i, b.data, b.gc, w, p), M = x;
      else if (Nt(p))
        for (f = 0, h = p.length; f < h; ++f)
          $ = p[f], !pt($) && !Nt($) && (w = Am(i, b.data, b.gc, w, $), M += x);
      s.push(w), a.push(M), d = Math.max(w, d), u = Math.max(M, u);
    }
    mW(r, t);
    const T = s.indexOf(d), E = a.indexOf(u), S = (D) => ({
      width: s[D] || 0,
      height: a[D] || 0
    });
    return {
      first: S(0),
      last: S(t - 1),
      widest: S(T),
      highest: S(E),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, t) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const t = this.ticks;
    return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const t = this._startPixel + e * this._length;
    return EH(this._alignToPixels ? zi(this.chart, t, 0) : t);
  }
  getDecimalForPixel(e) {
    const t = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - t : t;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: t } = this;
    return e < 0 && t < 0 ? t : e > 0 && t > 0 ? e : 0;
  }
  getContext(e) {
    const t = this.ticks || [];
    if (e >= 0 && e < t.length) {
      const o = t[e];
      return o.$context || (o.$context = vW(this.getContext(), e, o));
    }
    return this.$context || (this.$context = gW(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, t = Lo(this.labelRotation), o = Math.abs(Math.cos(t)), i = Math.abs(Math.sin(t)), r = this._getLabelSizes(), s = e.autoSkipPadding || 0, a = r ? r.widest.width + s : 0, l = r ? r.highest.height + s : 0;
    return this.isHorizontal() ? l * o > a * i ? a / o : l / i : l * i < a * o ? l / o : a / i;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const t = this.axis, o = this.chart, i = this.options, { grid: r, position: s, border: a } = i, l = r.offset, d = this.isHorizontal(), c = this.ticks.length + (l ? 1 : 0), f = As(r), h = [], p = a.setContext(this.getContext()), m = p.display ? p.width : 0, g = m / 2, b = function(te) {
      return zi(o, te, m);
    };
    let x, w, M, $, T, E, S, D, I, z, F, Y;
    if (s === "top")
      x = b(this.bottom), E = this.bottom - f, D = x - g, z = b(e.top) + g, Y = e.bottom;
    else if (s === "bottom")
      x = b(this.top), z = e.top, Y = b(e.bottom) - g, E = x + g, D = this.top + f;
    else if (s === "left")
      x = b(this.right), T = this.right - f, S = x - g, I = b(e.left) + g, F = e.right;
    else if (s === "right")
      x = b(this.left), I = e.left, F = b(e.right) - g, T = x + g, S = this.left + f;
    else if (t === "x") {
      if (s === "center")
        x = b((e.top + e.bottom) / 2 + 0.5);
      else if (je(s)) {
        const te = Object.keys(s)[0], ce = s[te];
        x = b(this.chart.scales[te].getPixelForValue(ce));
      }
      z = e.top, Y = e.bottom, E = x + g, D = E + f;
    } else if (t === "y") {
      if (s === "center")
        x = b((e.left + e.right) / 2);
      else if (je(s)) {
        const te = Object.keys(s)[0], ce = s[te];
        x = b(this.chart.scales[te].getPixelForValue(ce));
      }
      T = x - g, S = T - f, I = e.left, F = e.right;
    }
    const ie = Je(i.ticks.maxTicksLimit, c), W = Math.max(1, Math.ceil(c / ie));
    for (w = 0; w < c; w += W) {
      const te = this.getContext(w), ce = r.setContext(te), we = a.setContext(te), ke = ce.lineWidth, rt = ce.color, ut = we.dash || [], it = we.dashOffset, Ut = ce.tickWidth, nn = ce.tickColor, ct = ce.tickBorderDash || [], At = ce.tickBorderDashOffset;
      M = pW(this, w, l), M !== void 0 && ($ = zi(o, M, ke), d ? T = S = I = F = $ : E = D = z = Y = $, h.push({
        tx1: T,
        ty1: E,
        tx2: S,
        ty2: D,
        x1: I,
        y1: z,
        x2: F,
        y2: Y,
        width: ke,
        color: rt,
        borderDash: ut,
        borderDashOffset: it,
        tickWidth: Ut,
        tickColor: nn,
        tickBorderDash: ct,
        tickBorderDashOffset: At
      }));
    }
    return this._ticksLength = c, this._borderValue = x, h;
  }
  _computeLabelItems(e) {
    const t = this.axis, o = this.options, { position: i, ticks: r } = o, s = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: d, padding: u, mirror: c } = r, f = As(o.grid), h = f + u, p = c ? -u : h, m = -Lo(this.labelRotation), g = [];
    let b, x, w, M, $, T, E, S, D, I, z, F, Y = "middle";
    if (i === "top")
      T = this.bottom - p, E = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      T = this.top + p, E = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const W = this._getYAxisLabelAlignment(f);
      E = W.textAlign, $ = W.x;
    } else if (i === "right") {
      const W = this._getYAxisLabelAlignment(f);
      E = W.textAlign, $ = W.x;
    } else if (t === "x") {
      if (i === "center")
        T = (e.top + e.bottom) / 2 + h;
      else if (je(i)) {
        const W = Object.keys(i)[0], te = i[W];
        T = this.chart.scales[W].getPixelForValue(te) + h;
      }
      E = this._getXAxisLabelAlignment();
    } else if (t === "y") {
      if (i === "center")
        $ = (e.left + e.right) / 2 - h;
      else if (je(i)) {
        const W = Object.keys(i)[0], te = i[W];
        $ = this.chart.scales[W].getPixelForValue(te);
      }
      E = this._getYAxisLabelAlignment(f).textAlign;
    }
    t === "y" && (l === "start" ? Y = "top" : l === "end" && (Y = "bottom"));
    const ie = this._getLabelSizes();
    for (b = 0, x = a.length; b < x; ++b) {
      w = a[b], M = w.label;
      const W = r.setContext(this.getContext(b));
      S = this.getPixelForTick(b) + r.labelOffset, D = this._resolveTickFontOptions(b), I = D.lineHeight, z = Nt(M) ? M.length : 1;
      const te = z / 2, ce = W.color, we = W.textStrokeColor, ke = W.textStrokeWidth;
      let rt = E;
      s ? ($ = S, E === "inner" && (b === x - 1 ? rt = this.options.reverse ? "left" : "right" : b === 0 ? rt = this.options.reverse ? "right" : "left" : rt = "center"), i === "top" ? d === "near" || m !== 0 ? F = -z * I + I / 2 : d === "center" ? F = -ie.highest.height / 2 - te * I + I : F = -ie.highest.height + I / 2 : d === "near" || m !== 0 ? F = I / 2 : d === "center" ? F = ie.highest.height / 2 - te * I : F = ie.highest.height - z * I, c && (F *= -1), m !== 0 && !W.showLabelBackdrop && ($ += I / 2 * Math.sin(m))) : (T = S, F = (1 - z) * I / 2);
      let ut;
      if (W.showLabelBackdrop) {
        const it = Yn(W.backdropPadding), Ut = ie.heights[b], nn = ie.widths[b];
        let ct = F - it.top, At = 0 - it.left;
        switch (Y) {
          case "middle":
            ct -= Ut / 2;
            break;
          case "bottom":
            ct -= Ut;
            break;
        }
        switch (E) {
          case "center":
            At -= nn / 2;
            break;
          case "right":
            At -= nn;
            break;
          case "inner":
            b === x - 1 ? At -= nn : b > 0 && (At -= nn / 2);
            break;
        }
        ut = {
          left: At,
          top: ct,
          width: nn + it.width,
          height: Ut + it.height,
          color: W.backdropColor
        };
      }
      g.push({
        label: M,
        font: D,
        textOffset: F,
        options: {
          rotation: m,
          color: ce,
          strokeColor: we,
          strokeWidth: ke,
          textAlign: rt,
          textBaseline: Y,
          translation: [
            $,
            T
          ],
          backdrop: ut
        }
      });
    }
    return g;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: t } = this.options;
    if (-Lo(this.labelRotation))
      return e === "top" ? "left" : "right";
    let i = "center";
    return t.align === "start" ? i = "left" : t.align === "end" ? i = "right" : t.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(e) {
    const { position: t, ticks: { crossAlign: o, mirror: i, padding: r } } = this.options, s = this._getLabelSizes(), a = e + r, l = s.widest.width;
    let d, u;
    return t === "left" ? i ? (u = this.right + r, o === "near" ? d = "left" : o === "center" ? (d = "center", u += l / 2) : (d = "right", u += l)) : (u = this.right - a, o === "near" ? d = "right" : o === "center" ? (d = "center", u -= l / 2) : (d = "left", u = this.left)) : t === "right" ? i ? (u = this.left + r, o === "near" ? d = "right" : o === "center" ? (d = "center", u -= l / 2) : (d = "left", u -= l)) : (u = this.left + a, o === "near" ? d = "left" : o === "center" ? (d = "center", u += l / 2) : (d = "right", u = this.right)) : d = "right", {
      textAlign: d,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, t = this.options.position;
    if (t === "left" || t === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (t === "top" || t === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: t }, left: o, top: i, width: r, height: s } = this;
    t && (e.save(), e.fillStyle = t, e.fillRect(o, i, r, s), e.restore());
  }
  getLineWidthForValue(e) {
    const t = this.options.grid;
    if (!this._isVisible() || !t.display)
      return 0;
    const i = this.ticks.findIndex((r) => r.value === e);
    return i >= 0 ? t.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(e) {
    const t = this.options.grid, o = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let r, s;
    const a = (l, d, u) => {
      !u.width || !u.color || (o.save(), o.lineWidth = u.width, o.strokeStyle = u.color, o.setLineDash(u.borderDash || []), o.lineDashOffset = u.borderDashOffset, o.beginPath(), o.moveTo(l.x, l.y), o.lineTo(d.x, d.y), o.stroke(), o.restore());
    };
    if (t.display)
      for (r = 0, s = i.length; r < s; ++r) {
        const l = i[r];
        t.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), t.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: t, options: { border: o, grid: i } } = this, r = o.setContext(this.getContext()), s = o.display ? r.width : 0;
    if (!s)
      return;
    const a = i.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let d, u, c, f;
    this.isHorizontal() ? (d = zi(e, this.left, s) - s / 2, u = zi(e, this.right, a) + a / 2, c = f = l) : (c = zi(e, this.top, s) - s / 2, f = zi(e, this.bottom, a) + a / 2, d = u = l), t.save(), t.lineWidth = r.width, t.strokeStyle = r.color, t.beginPath(), t.moveTo(d, c), t.lineTo(u, f), t.stroke(), t.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const o = this.ctx, i = this._computeLabelArea();
    i && qh(o, i);
    const r = this.getLabelItems(e);
    for (const s of r) {
      const a = s.options, l = s.font, d = s.label, u = s.textOffset;
      Pa(o, d, 0, u, l, a);
    }
    i && Zh(o);
  }
  drawTitle() {
    const { ctx: e, options: { position: t, title: o, reverse: i } } = this;
    if (!o.display)
      return;
    const r = Jt(o.font), s = Yn(o.padding), a = o.align;
    let l = r.lineHeight / 2;
    t === "bottom" || t === "center" || je(t) ? (l += s.bottom, Nt(o.text) && (l += r.lineHeight * (o.text.length - 1))) : l += s.top;
    const { titleX: d, titleY: u, maxWidth: c, rotation: f } = yW(this, l, t, a);
    Pa(e, o.text, 0, 0, r, {
      color: o.color,
      maxWidth: c,
      rotation: f,
      textAlign: bW(a, t, i),
      textBaseline: "middle",
      translation: [
        d,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, t = e.ticks && e.ticks.z || 0, o = Je(e.grid && e.grid.z, -1), i = Je(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== ws.prototype.draw ? [
      {
        z: t,
        draw: (r) => {
          this.draw(r);
        }
      }
    ] : [
      {
        z: o,
        draw: (r) => {
          this.drawBackground(), this.drawGrid(r), this.drawTitle();
        }
      },
      {
        z: i,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: t,
        draw: (r) => {
          this.drawLabels(r);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const t = this.chart.getSortedVisibleDatasetMetas(), o = this.axis + "AxisID", i = [];
    let r, s;
    for (r = 0, s = t.length; r < s; ++r) {
      const a = t[r];
      a[o] === this.id && (!e || a.type === e) && i.push(a);
    }
    return i;
  }
  _resolveTickFontOptions(e) {
    const t = this.options.ticks.setContext(this.getContext(e));
    return Jt(t.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class Sl {
  constructor(e, t, o) {
    this.type = e, this.scope = t, this.override = o, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const t = Object.getPrototypeOf(e);
    let o;
    wW(t) && (o = this.register(t));
    const i = this.items, r = e.id, s = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + e);
    return r in i || (i[r] = e, xW(e, s, o), this.override && wt.override(e.id, e.overrides)), s;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const t = this.items, o = e.id, i = this.scope;
    o in t && delete t[o], i && o in wt[i] && (delete wt[i][o], this.override && delete pr[o]);
  }
}
function xW(n, e, t) {
  const o = Da(/* @__PURE__ */ Object.create(null), [
    t ? wt.get(t) : {},
    wt.get(e),
    n.defaults
  ]);
  wt.set(e, o), n.defaultRoutes && CW(e, n.defaultRoutes), n.descriptors && wt.describe(e, n.descriptors);
}
function CW(n, e) {
  Object.keys(e).forEach((t) => {
    const o = t.split("."), i = o.pop(), r = [
      n
    ].concat(o).join("."), s = e[t].split("."), a = s.pop(), l = s.join(".");
    wt.route(r, i, l, a);
  });
}
function wW(n) {
  return "id" in n && "defaults" in n;
}
class kW {
  constructor() {
    this.controllers = new Sl(da, "datasets", !0), this.elements = new Sl(Cr, "elements"), this.plugins = new Sl(Object, "plugins"), this.scales = new Sl(ws, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, t, o) {
    [
      ...t
    ].forEach((i) => {
      const r = o || this._getRegistryForType(i);
      o || r.isForType(i) || r === this.plugins && i.id ? this._exec(e, r, i) : et(i, (s) => {
        const a = o || this._getRegistryForType(s);
        this._exec(e, a, s);
      });
    });
  }
  _exec(e, t, o) {
    const i = Uh(e);
    at(o["before" + i], [], o), t[e](o), at(o["after" + i], [], o);
  }
  _getRegistryForType(e) {
    for (let t = 0; t < this._typedRegistries.length; t++) {
      const o = this._typedRegistries[t];
      if (o.isForType(e))
        return o;
    }
    return this.plugins;
  }
  _get(e, t, o) {
    const i = t.get(e);
    if (i === void 0)
      throw new Error('"' + e + '" is not a registered ' + o + ".");
    return i;
  }
}
var ho = /* @__PURE__ */ new kW();
class $W {
  constructor() {
    this._init = void 0;
  }
  notify(e, t, o, i) {
    if (t === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install")), this._init === void 0)
      return;
    const r = i ? this._descriptors(e).filter(i) : this._descriptors(e), s = this._notify(r, e, t, o);
    return t === "afterDestroy" && (this._notify(r, e, "stop"), this._notify(this._init, e, "uninstall"), this._init = void 0), s;
  }
  _notify(e, t, o, i) {
    i = i || {};
    for (const r of e) {
      const s = r.plugin, a = s[o], l = [
        t,
        i,
        r.options
      ];
      if (at(a, l, s) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    pt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const t = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), t;
  }
  _createDescriptors(e, t) {
    const o = e && e.config, i = Je(o.options && o.options.plugins, {}), r = MW(o);
    return i === !1 && !t ? [] : _W(e, r, i, t);
  }
  _notifyStateChanges(e) {
    const t = this._oldCache || [], o = this._cache, i = (r, s) => r.filter((a) => !s.some((l) => a.plugin.id === l.plugin.id));
    this._notify(i(t, o), e, "stop"), this._notify(i(o, t), e, "start");
  }
}
function MW(n) {
  const e = {}, t = [], o = Object.keys(ho.plugins.items);
  for (let r = 0; r < o.length; r++)
    t.push(ho.getPlugin(o[r]));
  const i = n.plugins || [];
  for (let r = 0; r < i.length; r++) {
    const s = i[r];
    t.indexOf(s) === -1 && (t.push(s), e[s.id] = !0);
  }
  return {
    plugins: t,
    localIds: e
  };
}
function SW(n, e) {
  return !e && n === !1 ? null : n === !0 ? {} : n;
}
function _W(n, { plugins: e, localIds: t }, o, i) {
  const r = [], s = n.getContext();
  for (const a of e) {
    const l = a.id, d = SW(o[l], i);
    d !== null && r.push({
      plugin: a,
      options: EW(n.config, {
        plugin: a,
        local: t[l]
      }, d, s)
    });
  }
  return r;
}
function EW(n, { plugin: e, local: t }, o, i) {
  const r = n.pluginScopeKeys(e), s = n.getOptionScopes(o, r);
  return t && e.defaults && s.push(e.defaults), n.createResolver(s, i, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function a1(n, e) {
  const t = wt.datasets[n] || {};
  return ((e.datasets || {})[n] || {}).indexAxis || e.indexAxis || t.indexAxis || "x";
}
function OW(n, e) {
  let t = n;
  return n === "_index_" ? t = e : n === "_value_" && (t = e === "x" ? "y" : "x"), t;
}
function TW(n, e) {
  return n === e ? "_index_" : "_value_";
}
function e2(n) {
  if (n === "x" || n === "y" || n === "r")
    return n;
}
function AW(n) {
  if (n === "top" || n === "bottom")
    return "x";
  if (n === "left" || n === "right")
    return "y";
}
function l1(n, ...e) {
  if (e2(n))
    return n;
  for (const t of e) {
    const o = t.axis || AW(t.position) || n.length > 1 && e2(n[0].toLowerCase());
    if (o)
      return o;
  }
  throw new Error(`Cannot determine type of '${n}' axis. Please provide 'axis' or 'position' option.`);
}
function t2(n, e, t) {
  if (t[e + "AxisID"] === n)
    return {
      axis: e
    };
}
function IW(n, e) {
  if (e.data && e.data.datasets) {
    const t = e.data.datasets.filter((o) => o.xAxisID === n || o.yAxisID === n);
    if (t.length)
      return t2(n, "x", t[0]) || t2(n, "y", t[0]);
  }
  return {};
}
function DW(n, e) {
  const t = pr[n.type] || {
    scales: {}
  }, o = e.scales || {}, i = a1(n.type, e), r = /* @__PURE__ */ Object.create(null);
  return Object.keys(o).forEach((s) => {
    const a = o[s];
    if (!je(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const l = l1(s, a, IW(s, n), wt.scales[a.type]), d = TW(l, i), u = t.scales || {};
    r[s] = sa(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[d]
    ]);
  }), n.data.datasets.forEach((s) => {
    const a = s.type || n.type, l = s.indexAxis || a1(a, e), u = (pr[a] || {}).scales || {};
    Object.keys(u).forEach((c) => {
      const f = OW(c, l), h = s[f + "AxisID"] || f;
      r[h] = r[h] || /* @__PURE__ */ Object.create(null), sa(r[h], [
        {
          axis: f
        },
        o[h],
        u[c]
      ]);
    });
  }), Object.keys(r).forEach((s) => {
    const a = r[s];
    sa(a, [
      wt.scales[a.type],
      wt.scale
    ]);
  }), r;
}
function R9(n) {
  const e = n.options || (n.options = {});
  e.plugins = Je(e.plugins, {}), e.scales = DW(n, e);
}
function F9(n) {
  return n = n || {}, n.datasets = n.datasets || [], n.labels = n.labels || [], n;
}
function NW(n) {
  return n = n || {}, n.data = F9(n.data), R9(n), n;
}
const n2 = /* @__PURE__ */ new Map(), B9 = /* @__PURE__ */ new Set();
function _l(n, e) {
  let t = n2.get(n);
  return t || (t = e(), n2.set(n, t), B9.add(t)), t;
}
const Is = (n, e, t) => {
  const o = Na(e, t);
  o !== void 0 && n.add(o);
};
class PW {
  constructor(e) {
    this._config = NW(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = F9(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), R9(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return _l(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, t) {
    return _l(`${e}.transition.${t}`, () => [
      [
        `datasets.${e}.transitions.${t}`,
        `transitions.${t}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, t) {
    return _l(`${e}-${t}`, () => [
      [
        `datasets.${e}.elements.${t}`,
        `datasets.${e}`,
        `elements.${t}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const t = e.id, o = this.type;
    return _l(`${o}-plugin-${t}`, () => [
      [
        `plugins.${t}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, t) {
    const o = this._scopeCache;
    let i = o.get(e);
    return (!i || t) && (i = /* @__PURE__ */ new Map(), o.set(e, i)), i;
  }
  getOptionScopes(e, t, o) {
    const { options: i, type: r } = this, s = this._cachedScopes(e, o), a = s.get(t);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    t.forEach((u) => {
      e && (l.add(e), u.forEach((c) => Is(l, e, c))), u.forEach((c) => Is(l, i, c)), u.forEach((c) => Is(l, pr[r] || {}, c)), u.forEach((c) => Is(l, wt, c)), u.forEach((c) => Is(l, s1, c));
    });
    const d = Array.from(l);
    return d.length === 0 && d.push(/* @__PURE__ */ Object.create(null)), B9.has(t) && s.set(t, d), d;
  }
  chartOptionScopes() {
    const { options: e, type: t } = this;
    return [
      e,
      pr[t] || {},
      wt.datasets[t] || {},
      {
        type: t
      },
      wt,
      s1
    ];
  }
  resolveNamedOptions(e, t, o, i = [
    ""
  ]) {
    const r = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = o2(this._resolverCache, e, i);
    let l = s;
    if (RW(s, t)) {
      r.$shared = !1, o = _i(o) ? o() : o;
      const d = this.createResolver(e, o, a);
      l = hs(s, o, d);
    }
    for (const d of t)
      r[d] = l[d];
    return r;
  }
  createResolver(e, t, o = [
    ""
  ], i) {
    const { resolver: r } = o2(this._resolverCache, e, o);
    return je(t) ? hs(r, t, void 0, i) : r;
  }
}
function o2(n, e, t) {
  let o = n.get(e);
  o || (o = /* @__PURE__ */ new Map(), n.set(e, o));
  const i = t.join();
  let r = o.get(i);
  return r || (r = {
    resolver: Xh(e, t),
    subPrefixes: t.filter((a) => !a.toLowerCase().includes("hover"))
  }, o.set(i, r)), r;
}
const LW = (n) => je(n) && Object.getOwnPropertyNames(n).some((e) => _i(n[e]));
function RW(n, e) {
  const { isScriptable: t, isIndexable: o } = $9(n);
  for (const i of e) {
    const r = t(i), s = o(i), a = (s || r) && n[i];
    if (r && (_i(a) || LW(a)) || s && Nt(a))
      return !0;
  }
  return !1;
}
var FW = "4.5.1";
const BW = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function i2(n, e) {
  return n === "top" || n === "bottom" || BW.indexOf(n) === -1 && e === "x";
}
function r2(n, e) {
  return function(t, o) {
    return t[n] === o[n] ? t[e] - o[e] : t[n] - o[n];
  };
}
function s2(n) {
  const e = n.chart, t = e.options.animation;
  e.notifyPlugins("afterRender"), at(t && t.onComplete, [
    n
  ], e);
}
function VW(n) {
  const e = n.chart, t = e.options.animation;
  at(t && t.onProgress, [
    n
  ], e);
}
function V9(n) {
  return t0() && typeof n == "string" ? n = document.getElementById(n) : n && n.length && (n = n[0]), n && n.canvas && (n = n.canvas), n;
}
const jl = {}, a2 = (n) => {
  const e = V9(n);
  return Object.values(jl).filter((t) => t.canvas === e).pop();
};
function zW(n, e, t) {
  const o = Object.keys(n);
  for (const i of o) {
    const r = +i;
    if (r >= e) {
      const s = n[i];
      delete n[i], (t > 0 || r > e) && (n[r + t] = s);
    }
  }
}
function HW(n, e, t, o) {
  return !t || n.type === "mouseout" ? null : o ? e : n;
}
var ti;
let Hu = (ti = class {
  static register(...e) {
    ho.add(...e), l2();
  }
  static unregister(...e) {
    ho.remove(...e), l2();
  }
  constructor(e, t) {
    const o = this.config = new PW(t), i = V9(e), r = a2(i);
    if (r)
      throw new Error("Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused.");
    const s = o.createResolver(o.chartOptionScopes(), this.getContext());
    this.platform = new (o.platform || sW(i))(), this.platform.updateConfig(o);
    const a = this.platform.acquireContext(i, s.aspectRatio), l = a && a.canvas, d = l && l.height, u = l && l.width;
    if (this.id = pH(), this.ctx = a, this.canvas = l, this.width = u, this.height = d, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new $W(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = DH((c) => this.update(c), s.resizeDelay || 0), this._dataChanges = [], jl[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Oo.listen(this, "complete", s2), Oo.listen(this, "progress", VW), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: t }, width: o, height: i, _aspectRatio: r } = this;
    return pt(e) ? t && r ? r : i ? o / i : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return ho;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Lm(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Im(this.canvas, this.ctx), this;
  }
  stop() {
    return Oo.stop(this), this;
  }
  resize(e, t) {
    Oo.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: t
    } : this._resize(e, t);
  }
  _resize(e, t) {
    const o = this.options, i = this.canvas, r = o.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(i, e, t, r), a = o.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, Lm(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), at(o.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    et(t, (o, i) => {
      o.id = i;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, t = e.scales, o = this.scales, i = Object.keys(o).reduce((s, a) => (s[a] = !1, s), {});
    let r = [];
    t && (r = r.concat(Object.keys(t).map((s) => {
      const a = t[s], l = l1(s, a), d = l === "r", u = l === "x";
      return {
        options: a,
        dposition: d ? "chartArea" : u ? "bottom" : "left",
        dtype: d ? "radialLinear" : u ? "category" : "linear"
      };
    }))), et(r, (s) => {
      const a = s.options, l = a.id, d = l1(l, a), u = Je(a.type, s.dtype);
      (a.position === void 0 || i2(a.position, d) !== i2(s.dposition)) && (a.position = s.dposition), i[l] = !0;
      let c = null;
      if (l in o && o[l].type === u)
        c = o[l];
      else {
        const f = ho.getScale(u);
        c = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), o[c.id] = c;
      }
      c.init(a, e);
    }), et(i, (s, a) => {
      s || delete o[a];
    }), et(o, (s) => {
      jn.configure(this, s, s.options), jn.addBox(this, s);
    });
  }
  _updateMetasets() {
    const e = this._metasets, t = this.data.datasets.length, o = e.length;
    if (e.sort((i, r) => i.index - r.index), o > t) {
      for (let i = t; i < o; ++i)
        this._destroyDatasetMeta(i);
      e.splice(t, o - t);
    }
    this._sortedMetasets = e.slice(0).sort(r2("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: t } } = this;
    e.length > t.length && delete this._stacks, e.forEach((o, i) => {
      t.filter((r) => r === o._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const e = [], t = this.data.datasets;
    let o, i;
    for (this._removeUnreferencedMetasets(), o = 0, i = t.length; o < i; o++) {
      const r = t[o];
      let s = this.getDatasetMeta(o);
      const a = r.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(o), s = this.getDatasetMeta(o)), s.type = a, s.indexAxis = r.indexAxis || a1(a, this.options), s.order = r.order || 0, s.index = o, s.label = "" + r.label, s.visible = this.isDatasetVisible(o), s.controller)
        s.controller.updateIndex(o), s.controller.linkScales();
      else {
        const l = ho.getController(a), { datasetElementType: d, dataElementType: u } = wt.datasets[a];
        Object.assign(l, {
          dataElementType: ho.getElement(u),
          datasetElementType: d && ho.getElement(d)
        }), s.controller = new l(this, o), e.push(s.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    et(this.data.datasets, (e, t) => {
      this.getDatasetMeta(t).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const t = this.config;
    t.update();
    const o = this._options = t.createResolver(t.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !o.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let d = 0, u = this.data.datasets.length; d < u; d++) {
      const { controller: c } = this.getDatasetMeta(d), f = !i && r.indexOf(c) === -1;
      c.buildOrUpdateElements(f), s = Math.max(+c.getMaxOverflow(), s);
    }
    s = this._minPadding = o.layout.autoPadding ? s : 0, this._updateLayout(s), i || et(r, (d) => {
      d.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(r2("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    et(this.scales, (e) => {
      jn.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, t = new Set(Object.keys(this._listeners)), o = new Set(e.events);
    (!wm(t, o) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, t = this._getUniformDataChanges() || [];
    for (const { method: o, start: i, count: r } of t) {
      const s = o === "_removeElements" ? -r : r;
      zW(e, i, s);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const t = this.data.datasets.length, o = (r) => new Set(e.filter((s) => s[0] === r).map((s, a) => a + "," + s.splice(1).join(","))), i = o(0);
    for (let r = 1; r < t; r++)
      if (!wm(i, o(r)))
        return;
    return Array.from(i).map((r) => r.split(",")).map((r) => ({
      method: r[1],
      start: +r[2],
      count: +r[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    jn.update(this, this.width, this.height, e);
    const t = this.chartArea, o = t.width <= 0 || t.height <= 0;
    this._layers = [], et(this.boxes, (i) => {
      o && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, r) => {
      i._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let t = 0, o = this.data.datasets.length; t < o; ++t)
        this.getDatasetMeta(t).controller.configure();
      for (let t = 0, o = this.data.datasets.length; t < o; ++t)
        this._updateDataset(t, _i(e) ? e({
          datasetIndex: t
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, t) {
    const o = this.getDatasetMeta(e), i = {
      meta: o,
      index: e,
      mode: t,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (o.controller._update(t), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Oo.has(this) ? this.attached && !Oo.running(this) && Oo.start(this) : (this.draw(), s2({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: o, height: i } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(o, i);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this._layers;
    for (e = 0; e < t.length && t[e].z <= 0; ++e)
      t[e].draw(this.chartArea);
    for (this._drawDatasets(); e < t.length; ++e)
      t[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const t = this._sortedMetasets, o = [];
    let i, r;
    for (i = 0, r = t.length; i < r; ++i) {
      const s = t[i];
      (!e || s.visible) && o.push(s);
    }
    return o;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let t = e.length - 1; t >= 0; --t)
      this._drawDataset(e[t]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const t = this.ctx, o = {
      meta: e,
      index: e.index,
      cancelable: !0
    }, i = bj(this, e);
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (i && qh(t, i), e.controller.draw(), i && Zh(t), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(e) {
    return w9(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, t, o, i) {
    const r = Bj.modes[t];
    return typeof r == "function" ? r(this, e, o, i) : [];
  }
  getDatasetMeta(e) {
    const t = this.data.datasets[e], o = this._metasets;
    let i = o.filter((r) => r && r._dataset === t).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: t && t.order || 0,
      index: e,
      _dataset: t,
      _parsed: [],
      _sorted: !1
    }, o.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Cs(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const t = this.data.datasets[e];
    if (!t)
      return !1;
    const o = this.getDatasetMeta(e);
    return typeof o.hidden == "boolean" ? !o.hidden : !t.hidden;
  }
  setDatasetVisibility(e, t) {
    const o = this.getDatasetMeta(e);
    o.hidden = !t;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, t, o) {
    const i = o ? "show" : "hide", r = this.getDatasetMeta(e), s = r.controller._resolveAnimations(void 0, i);
    qd(t) ? (r.data[t].hidden = !o, this.update()) : (this.setDatasetVisibility(e, o), s.update(r, {
      visible: o
    }), this.update((a) => a.datasetIndex === e ? i : void 0));
  }
  hide(e, t) {
    this._updateVisibility(e, t, !1);
  }
  show(e, t) {
    this._updateVisibility(e, t, !0);
  }
  _destroyDatasetMeta(e) {
    const t = this._metasets[e];
    t && t.controller && t.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, t;
    for (this.stop(), Oo.remove(this), e = 0, t = this.data.datasets.length; e < t; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: t } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), Im(e, t), this.platform.releaseContext(t), this.canvas = null, this.ctx = null), delete jl[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, t = this.platform, o = (r, s) => {
      t.addEventListener(this, r, s), e[r] = s;
    }, i = (r, s, a) => {
      r.offsetX = s, r.offsetY = a, this._eventHandler(r);
    };
    et(this.options.events, (r) => o(r, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, t = this.platform, o = (l, d) => {
      t.addEventListener(this, l, d), e[l] = d;
    }, i = (l, d) => {
      e[l] && (t.removeEventListener(this, l, d), delete e[l]);
    }, r = (l, d) => {
      this.canvas && this.resize(l, d);
    };
    let s;
    const a = () => {
      i("attach", a), this.attached = !0, this.resize(), o("resize", r), o("detach", s);
    };
    s = () => {
      this.attached = !1, i("resize", r), this._stop(), this._resize(0, 0), o("attach", a);
    }, t.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    et(this._listeners, (e, t) => {
      this.platform.removeEventListener(this, t, e);
    }), this._listeners = {}, et(this._responsiveListeners, (e, t) => {
      this.platform.removeEventListener(this, t, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, t, o) {
    const i = o ? "set" : "remove";
    let r, s, a, l;
    for (t === "dataset" && (r = this.getDatasetMeta(e[0].datasetIndex), r.controller["_" + i + "DatasetHoverStyle"]()), a = 0, l = e.length; a < l; ++a) {
      s = e[a];
      const d = s && this.getDatasetMeta(s.datasetIndex).controller;
      d && d[i + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const t = this._active || [], o = e.map(({ datasetIndex: r, index: s }) => {
      const a = this.getDatasetMeta(r);
      if (!a)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: a.data[s],
        index: s
      };
    });
    !Gd(o, t) && (this._active = o, this._lastEvent = null, this._updateHoverStyles(o, t));
  }
  notifyPlugins(e, t, o) {
    return this._plugins.notify(this, e, t, o);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((t) => t.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, t, o) {
    const i = this.options.hover, r = (l, d) => l.filter((u) => !d.some((c) => u.datasetIndex === c.datasetIndex && u.index === c.index)), s = r(t, e), a = o ? e : r(e, t);
    s.length && this.updateHoverStyle(s, i.mode, !1), a.length && i.mode && this.updateHoverStyle(a, i.mode, !0);
  }
  _eventHandler(e, t) {
    const o = {
      event: e,
      replay: t,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, i = (s) => (s.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", o, i) === !1)
      return;
    const r = this._handleEvent(e, t, o.inChartArea);
    return o.cancelable = !1, this.notifyPlugins("afterEvent", o, i), (r || o.changed) && this.render(), this;
  }
  _handleEvent(e, t, o) {
    const { _active: i = [], options: r } = this, s = t, a = this._getActiveElements(e, i, o, s), l = xH(e), d = HW(e, this._lastEvent, o, l);
    o && (this._lastEvent = null, at(r.onHover, [
      e,
      a,
      this
    ], this), l && at(r.onClick, [
      e,
      a,
      this
    ], this));
    const u = !Gd(a, i);
    return (u || t) && (this._active = a, this._updateHoverStyles(a, i, t)), this._lastEvent = d, u;
  }
  _getActiveElements(e, t, o, i) {
    if (e.type === "mouseout")
      return [];
    if (!o)
      return t;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(e, r.mode, r, i);
  }
}, Ae(ti, "defaults", wt), Ae(ti, "instances", jl), Ae(ti, "overrides", pr), Ae(ti, "registry", ho), Ae(ti, "version", FW), Ae(ti, "getChart", a2), ti);
function l2() {
  return et(Hu.instances, (n) => n._plugins.invalidate());
}
function jW(n, e, t) {
  const { startAngle: o, x: i, y: r, outerRadius: s, innerRadius: a, options: l } = e, { borderWidth: d, borderJoinStyle: u } = l, c = Math.min(d / s, po(o - t));
  if (n.beginPath(), n.arc(i, r, s - d / 2, o + c / 2, t - c / 2), a > 0) {
    const f = Math.min(d / a, po(o - t));
    n.arc(i, r, a + d / 2, t - f / 2, o + f / 2, !0);
  } else {
    const f = Math.min(d / 2, s * po(o - t));
    if (u === "round")
      n.arc(i, r, f, t - nt / 2, o + nt / 2, !0);
    else if (u === "bevel") {
      const h = 2 * f * f, p = -h * Math.cos(t + nt / 2) + i, m = -h * Math.sin(t + nt / 2) + r, g = h * Math.cos(o + nt / 2) + i, b = h * Math.sin(o + nt / 2) + r;
      n.lineTo(p, m), n.lineTo(g, b);
    }
  }
  n.closePath(), n.moveTo(0, 0), n.rect(0, 0, n.canvas.width, n.canvas.height), n.clip("evenodd");
}
function WW(n, e, t) {
  const { startAngle: o, pixelMargin: i, x: r, y: s, outerRadius: a, innerRadius: l } = e;
  let d = i / a;
  n.beginPath(), n.arc(r, s, a, o - d, t + d), l > i ? (d = i / l, n.arc(r, s, l, t + d, o - d, !0)) : n.arc(r, s, i, t + Ot, o - Ot), n.closePath(), n.clip();
}
function UW(n) {
  return Jh(n, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function KW(n, e, t, o) {
  const i = UW(n.options.borderRadius), r = (t - e) / 2, s = Math.min(r, o * e / 2), a = (l) => {
    const d = (t - Math.min(r, l)) * o / 2;
    return yn(l, 0, Math.min(r, d));
  };
  return {
    outerStart: a(i.outerStart),
    outerEnd: a(i.outerEnd),
    innerStart: yn(i.innerStart, 0, s),
    innerEnd: yn(i.innerEnd, 0, s)
  };
}
function Dr(n, e, t, o) {
  return {
    x: t + n * Math.cos(e),
    y: o + n * Math.sin(e)
  };
}
function ou(n, e, t, o, i, r) {
  const { x: s, y: a, startAngle: l, pixelMargin: d, innerRadius: u } = e, c = Math.max(e.outerRadius + o + t - d, 0), f = u > 0 ? u + o + t + d : 0;
  let h = 0;
  const p = i - l;
  if (o) {
    const W = u > 0 ? u - o : 0, te = c > 0 ? c - o : 0, ce = (W + te) / 2, we = ce !== 0 ? p * ce / (ce + o) : p;
    h = (p - we) / 2;
  }
  const m = Math.max(1e-3, p * c - t / nt) / c, g = (p - m) / 2, b = l + g + h, x = i - g - h, { outerStart: w, outerEnd: M, innerStart: $, innerEnd: T } = KW(e, f, c, x - b), E = c - w, S = c - M, D = b + w / E, I = x - M / S, z = f + $, F = f + T, Y = b + $ / z, ie = x - T / F;
  if (n.beginPath(), r) {
    const W = (D + I) / 2;
    if (n.arc(s, a, c, D, W), n.arc(s, a, c, W, I), M > 0) {
      const ke = Dr(S, I, s, a);
      n.arc(ke.x, ke.y, M, I, x + Ot);
    }
    const te = Dr(F, x, s, a);
    if (n.lineTo(te.x, te.y), T > 0) {
      const ke = Dr(F, ie, s, a);
      n.arc(ke.x, ke.y, T, x + Ot, ie + Math.PI);
    }
    const ce = (x - T / f + (b + $ / f)) / 2;
    if (n.arc(s, a, f, x - T / f, ce, !0), n.arc(s, a, f, ce, b + $ / f, !0), $ > 0) {
      const ke = Dr(z, Y, s, a);
      n.arc(ke.x, ke.y, $, Y + Math.PI, b - Ot);
    }
    const we = Dr(E, b, s, a);
    if (n.lineTo(we.x, we.y), w > 0) {
      const ke = Dr(E, D, s, a);
      n.arc(ke.x, ke.y, w, b - Ot, D);
    }
  } else {
    n.moveTo(s, a);
    const W = Math.cos(D) * c + s, te = Math.sin(D) * c + a;
    n.lineTo(W, te);
    const ce = Math.cos(I) * c + s, we = Math.sin(I) * c + a;
    n.lineTo(ce, we);
  }
  n.closePath();
}
function GW(n, e, t, o, i) {
  const { fullCircles: r, startAngle: s, circumference: a } = e;
  let l = e.endAngle;
  if (r) {
    ou(n, e, t, o, l, i);
    for (let d = 0; d < r; ++d)
      n.fill();
    isNaN(a) || (l = s + (a % St || St));
  }
  return ou(n, e, t, o, l, i), n.fill(), l;
}
function YW(n, e, t, o, i) {
  const { fullCircles: r, startAngle: s, circumference: a, options: l } = e, { borderWidth: d, borderJoinStyle: u, borderDash: c, borderDashOffset: f, borderRadius: h } = l, p = l.borderAlign === "inner";
  if (!d)
    return;
  n.setLineDash(c || []), n.lineDashOffset = f, p ? (n.lineWidth = d * 2, n.lineJoin = u || "round") : (n.lineWidth = d, n.lineJoin = u || "bevel");
  let m = e.endAngle;
  if (r) {
    ou(n, e, t, o, m, i);
    for (let g = 0; g < r; ++g)
      n.stroke();
    isNaN(a) || (m = s + (a % St || St));
  }
  p && WW(n, e, m), l.selfJoin && m - s >= nt && h === 0 && u !== "miter" && jW(n, e, m), r || (ou(n, e, t, o, m, i), n.stroke());
}
class Us extends Cr {
  constructor(t) {
    super();
    Ae(this, "circumference");
    Ae(this, "endAngle");
    Ae(this, "fullCircles");
    Ae(this, "innerRadius");
    Ae(this, "outerRadius");
    Ae(this, "pixelMargin");
    Ae(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, o, i) {
    const r = this.getProps([
      "x",
      "y"
    ], i), { angle: s, distance: a } = m9(r, {
      x: t,
      y: o
    }), { startAngle: l, endAngle: d, innerRadius: u, outerRadius: c, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], i), h = (this.options.spacing + this.options.borderWidth) / 2, p = Je(f, d - l), m = Qd(s, l, d) && l !== d, g = p >= St || m, b = Xi(a, u + h, c + h);
    return g && b;
  }
  getCenterPoint(t) {
    const { x: o, y: i, startAngle: r, endAngle: s, innerRadius: a, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], t), { offset: d, spacing: u } = this.options, c = (r + s) / 2, f = (a + l + u + d) / 2;
    return {
      x: o + Math.cos(c) * f,
      y: i + Math.sin(c) * f
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: o, circumference: i } = this, r = (o.offset || 0) / 4, s = (o.spacing || 0) / 2, a = o.circular;
    if (this.pixelMargin = o.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = i > St ? Math.floor(i / St) : 0, i === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    const l = (this.startAngle + this.endAngle) / 2;
    t.translate(Math.cos(l) * r, Math.sin(l) * r);
    const d = 1 - Math.sin(Math.min(nt, i || 0)), u = r * d;
    t.fillStyle = o.backgroundColor, t.strokeStyle = o.borderColor, GW(t, this, u, s, a), YW(t, this, u, s, a), t.restore();
  }
}
Ae(Us, "id", "arc"), Ae(Us, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0,
  selfJoin: !1
}), Ae(Us, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), Ae(Us, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash"
});
function z9(n, e) {
  const { x: t, y: o, base: i, width: r, height: s } = n.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let a, l, d, u, c;
  return n.horizontal ? (c = s / 2, a = Math.min(t, i), l = Math.max(t, i), d = o - c, u = o + c) : (c = r / 2, a = t - c, l = t + c, d = Math.min(o, i), u = Math.max(o, i)), {
    left: a,
    top: d,
    right: l,
    bottom: u
  };
}
function pi(n, e, t, o) {
  return n ? 0 : yn(e, t, o);
}
function qW(n, e, t) {
  const o = n.options.borderWidth, i = n.borderSkipped, r = k9(o);
  return {
    t: pi(i.top, r.top, 0, t),
    r: pi(i.right, r.right, 0, e),
    b: pi(i.bottom, r.bottom, 0, t),
    l: pi(i.left, r.left, 0, e)
  };
}
function ZW(n, e, t) {
  const { enableBorderRadius: o } = n.getProps([
    "enableBorderRadius"
  ]), i = n.options.borderRadius, r = Gr(i), s = Math.min(e, t), a = n.borderSkipped, l = o || je(i);
  return {
    topLeft: pi(!l || a.top || a.left, r.topLeft, 0, s),
    topRight: pi(!l || a.top || a.right, r.topRight, 0, s),
    bottomLeft: pi(!l || a.bottom || a.left, r.bottomLeft, 0, s),
    bottomRight: pi(!l || a.bottom || a.right, r.bottomRight, 0, s)
  };
}
function JW(n) {
  const e = z9(n), t = e.right - e.left, o = e.bottom - e.top, i = qW(n, t / 2, o / 2), r = ZW(n, t / 2, o / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: t,
      h: o,
      radius: r
    },
    inner: {
      x: e.left + i.l,
      y: e.top + i.t,
      w: t - i.l - i.r,
      h: o - i.t - i.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(i.t, i.l)),
        topRight: Math.max(0, r.topRight - Math.max(i.t, i.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(i.b, i.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(i.b, i.r))
      }
    }
  };
}
function qc(n, e, t, o) {
  const i = e === null, r = t === null, a = n && !(i && r) && z9(n, o);
  return a && (i || Xi(e, a.left, a.right)) && (r || Xi(t, a.top, a.bottom));
}
function XW(n) {
  return n.topLeft || n.topRight || n.bottomLeft || n.bottomRight;
}
function QW(n, e) {
  n.rect(e.x, e.y, e.w, e.h);
}
function Zc(n, e, t = {}) {
  const o = n.x !== t.x ? -e : 0, i = n.y !== t.y ? -e : 0, r = (n.x + n.w !== t.x + t.w ? e : 0) - o, s = (n.y + n.h !== t.y + t.h ? e : 0) - i;
  return {
    x: n.x + o,
    y: n.y + i,
    w: n.w + r,
    h: n.h + s,
    radius: n.radius
  };
}
class Wl extends Cr {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: t, options: { borderColor: o, backgroundColor: i } } = this, { inner: r, outer: s } = JW(this), a = XW(s.radius) ? eu : QW;
    e.save(), (s.w !== r.w || s.h !== r.h) && (e.beginPath(), a(e, Zc(s, t, r)), e.clip(), a(e, Zc(r, -t, s)), e.fillStyle = o, e.fill("evenodd")), e.beginPath(), a(e, Zc(r, t)), e.fillStyle = i, e.fill(), e.restore();
  }
  inRange(e, t, o) {
    return qc(this, e, t, o);
  }
  inXRange(e, t) {
    return qc(this, e, null, t);
  }
  inYRange(e, t) {
    return qc(this, null, e, t);
  }
  getCenterPoint(e) {
    const { x: t, y: o, base: i, horizontal: r } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: r ? (t + i) / 2 : t,
      y: r ? o : (o + i) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
Ae(Wl, "id", "bar"), Ae(Wl, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), Ae(Wl, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const d2 = (n, e) => {
  let { boxHeight: t = e, boxWidth: o = e } = n;
  return n.usePointStyle && (t = Math.min(t, e), o = n.pointStyleWidth || Math.min(o, e)), {
    boxWidth: o,
    boxHeight: t,
    itemHeight: Math.max(e, t)
  };
}, eU = (n, e) => n !== null && e !== null && n.datasetIndex === e.datasetIndex && n.index === e.index;
class u2 extends Cr {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, t, o) {
    this.maxWidth = e, this.maxHeight = t, this._margins = o, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let t = at(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (t = t.filter((o) => e.filter(o, this.chart.data))), e.sort && (t = t.sort((o, i) => e.sort(o, i, this.chart.data))), this.options.reverse && t.reverse(), this.legendItems = t;
  }
  fit() {
    const { options: e, ctx: t } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const o = e.labels, i = Jt(o.font), r = i.size, s = this._computeTitleHeight(), { boxWidth: a, itemHeight: l } = d2(o, r);
    let d, u;
    t.font = i.string, this.isHorizontal() ? (d = this.maxWidth, u = this._fitRows(s, r, a, l) + 10) : (u = this.maxHeight, d = this._fitCols(s, i, a, l) + 10), this.width = Math.min(d, e.maxWidth || this.maxWidth), this.height = Math.min(u, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, t, o, i) {
    const { ctx: r, maxWidth: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], d = this.lineWidths = [
      0
    ], u = i + a;
    let c = e;
    r.textAlign = "left", r.textBaseline = "middle";
    let f = -1, h = -u;
    return this.legendItems.forEach((p, m) => {
      const g = o + t / 2 + r.measureText(p.text).width;
      (m === 0 || d[d.length - 1] + g + 2 * a > s) && (c += u, d[d.length - (m > 0 ? 0 : 1)] = 0, h += u, f++), l[m] = {
        left: 0,
        top: h,
        row: f,
        width: g,
        height: i
      }, d[d.length - 1] += g + a;
    }), c;
  }
  _fitCols(e, t, o, i) {
    const { ctx: r, maxHeight: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], d = this.columnSizes = [], u = s - e;
    let c = a, f = 0, h = 0, p = 0, m = 0;
    return this.legendItems.forEach((g, b) => {
      const { itemWidth: x, itemHeight: w } = tU(o, t, r, g, i);
      b > 0 && h + w + 2 * a > u && (c += f + a, d.push({
        width: f,
        height: h
      }), p += f + a, m++, f = h = 0), l[b] = {
        left: p,
        top: h,
        col: m,
        width: x,
        height: w
      }, f = Math.max(f, x), h += w + a;
    }), c += f, d.push({
      width: f,
      height: h
    }), c;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: t, options: { align: o, labels: { padding: i }, rtl: r } } = this, s = Yr(r, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, l = Kt(o, this.left + i, this.right - this.lineWidths[a]);
      for (const d of t)
        a !== d.row && (a = d.row, l = Kt(o, this.left + i, this.right - this.lineWidths[a])), d.top += this.top + e + i, d.left = s.leftForLtr(s.x(l), d.width), l += d.width + i;
    } else {
      let a = 0, l = Kt(o, this.top + e + i, this.bottom - this.columnSizes[a].height);
      for (const d of t)
        d.col !== a && (a = d.col, l = Kt(o, this.top + e + i, this.bottom - this.columnSizes[a].height)), d.top = l, d.left += this.left + i, d.left = s.leftForLtr(s.x(d.left), d.width), l += d.height + i;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      qh(e, this), this._draw(), Zh(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: t, lineWidths: o, ctx: i } = this, { align: r, labels: s } = e, a = wt.color, l = Yr(e.rtl, this.left, this.width), d = Jt(s.font), { padding: u } = s, c = d.size, f = c / 2;
    let h;
    this.drawTitle(), i.textAlign = l.textAlign("left"), i.textBaseline = "middle", i.lineWidth = 0.5, i.font = d.string;
    const { boxWidth: p, boxHeight: m, itemHeight: g } = d2(s, c), b = function(T, E, S) {
      if (isNaN(p) || p <= 0 || isNaN(m) || m < 0)
        return;
      i.save();
      const D = Je(S.lineWidth, 1);
      if (i.fillStyle = Je(S.fillStyle, a), i.lineCap = Je(S.lineCap, "butt"), i.lineDashOffset = Je(S.lineDashOffset, 0), i.lineJoin = Je(S.lineJoin, "miter"), i.lineWidth = D, i.strokeStyle = Je(S.strokeStyle, a), i.setLineDash(Je(S.lineDash, [])), s.usePointStyle) {
        const I = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: S.pointStyle,
          rotation: S.rotation,
          borderWidth: D
        }, z = l.xPlus(T, p / 2), F = E + f;
        C9(i, I, z, F, s.pointStyleWidth && p);
      } else {
        const I = E + Math.max((c - m) / 2, 0), z = l.leftForLtr(T, p), F = Gr(S.borderRadius);
        i.beginPath(), Object.values(F).some((Y) => Y !== 0) ? eu(i, {
          x: z,
          y: I,
          w: p,
          h: m,
          radius: F
        }) : i.rect(z, I, p, m), i.fill(), D !== 0 && i.stroke();
      }
      i.restore();
    }, x = function(T, E, S) {
      Pa(i, S.text, T, E + g / 2, d, {
        strikethrough: S.hidden,
        textAlign: l.textAlign(S.textAlign)
      });
    }, w = this.isHorizontal(), M = this._computeTitleHeight();
    w ? h = {
      x: Kt(r, this.left + u, this.right - o[0]),
      y: this.top + u + M,
      line: 0
    } : h = {
      x: this.left + u,
      y: Kt(r, this.top + M + u, this.bottom - t[0].height),
      line: 0
    }, E9(this.ctx, e.textDirection);
    const $ = g + u;
    this.legendItems.forEach((T, E) => {
      i.strokeStyle = T.fontColor, i.fillStyle = T.fontColor;
      const S = i.measureText(T.text).width, D = l.textAlign(T.textAlign || (T.textAlign = s.textAlign)), I = p + f + S;
      let z = h.x, F = h.y;
      l.setWidth(this.width), w ? E > 0 && z + I + u > this.right && (F = h.y += $, h.line++, z = h.x = Kt(r, this.left + u, this.right - o[h.line])) : E > 0 && F + $ > this.bottom && (z = h.x = z + t[h.line].width + u, h.line++, F = h.y = Kt(r, this.top + M + u, this.bottom - t[h.line].height));
      const Y = l.x(z);
      if (b(Y, F, T), z = NH(D, z + p + f, w ? z + I : this.right, e.rtl), x(l.x(z), F, T), w)
        h.x += I + u;
      else if (typeof T.text != "string") {
        const ie = d.lineHeight;
        h.y += H9(T, ie) + u;
      } else
        h.y += $;
    }), O9(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, t = e.title, o = Jt(t.font), i = Yn(t.padding);
    if (!t.display)
      return;
    const r = Yr(e.rtl, this.left, this.width), s = this.ctx, a = t.position, l = o.size / 2, d = i.top + l;
    let u, c = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), u = this.top + d, c = Kt(e.align, c, this.right - f);
    else {
      const p = this.columnSizes.reduce((m, g) => Math.max(m, g.height), 0);
      u = d + Kt(e.align, this.top, this.bottom - p - e.labels.padding - this._computeTitleHeight());
    }
    const h = Kt(a, c, c + f);
    s.textAlign = r.textAlign(Gh(a)), s.textBaseline = "middle", s.strokeStyle = t.color, s.fillStyle = t.color, s.font = o.string, Pa(s, t.text, h, u, o);
  }
  _computeTitleHeight() {
    const e = this.options.title, t = Jt(e.font), o = Yn(e.padding);
    return e.display ? t.lineHeight + o.height : 0;
  }
  _getLegendItemAt(e, t) {
    let o, i, r;
    if (Xi(e, this.left, this.right) && Xi(t, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, o = 0; o < r.length; ++o)
        if (i = r[o], Xi(e, i.left, i.left + i.width) && Xi(t, i.top, i.top + i.height))
          return this.legendItems[o];
    }
    return null;
  }
  handleEvent(e) {
    const t = this.options;
    if (!iU(e.type, t))
      return;
    const o = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const i = this._hoveredItem, r = eU(i, o);
      i && !r && at(t.onLeave, [
        e,
        i,
        this
      ], this), this._hoveredItem = o, o && !r && at(t.onHover, [
        e,
        o,
        this
      ], this);
    } else o && at(t.onClick, [
      e,
      o,
      this
    ], this);
  }
}
function tU(n, e, t, o, i) {
  const r = nU(o, n, e, t), s = oU(i, o, e.lineHeight);
  return {
    itemWidth: r,
    itemHeight: s
  };
}
function nU(n, e, t, o) {
  let i = n.text;
  return i && typeof i != "string" && (i = i.reduce((r, s) => r.length > s.length ? r : s)), e + t.size / 2 + o.measureText(i).width;
}
function oU(n, e, t) {
  let o = n;
  return typeof e.text != "string" && (o = H9(e, t)), o;
}
function H9(n, e) {
  const t = n.text ? n.text.length : 0;
  return e * t;
}
function iU(n, e) {
  return !!((n === "mousemove" || n === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (n === "click" || n === "mouseup"));
}
var rU = {
  id: "legend",
  _element: u2,
  start(n, e, t) {
    const o = n.legend = new u2({
      ctx: n.ctx,
      options: t,
      chart: n
    });
    jn.configure(n, o, t), jn.addBox(n, o);
  },
  stop(n) {
    jn.removeBox(n, n.legend), delete n.legend;
  },
  beforeUpdate(n, e, t) {
    const o = n.legend;
    jn.configure(n, o, t), o.options = t;
  },
  afterUpdate(n) {
    const e = n.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(n, e) {
    e.replay || n.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(n, e, t) {
      const o = e.datasetIndex, i = t.chart;
      i.isDatasetVisible(o) ? (i.hide(o), e.hidden = !0) : (i.show(o), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (n) => n.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(n) {
        const e = n.data.datasets, { labels: { usePointStyle: t, pointStyle: o, textAlign: i, color: r, useBorderRadius: s, borderRadius: a } } = n.legend.options;
        return n._getSortedDatasetMetas().map((l) => {
          const d = l.controller.getStyle(t ? 0 : void 0), u = Yn(d.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: d.backgroundColor,
            fontColor: r,
            hidden: !l.visible,
            lineCap: d.borderCapStyle,
            lineDash: d.borderDash,
            lineDashOffset: d.borderDashOffset,
            lineJoin: d.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: d.borderColor,
            pointStyle: o || d.pointStyle,
            rotation: d.rotation,
            textAlign: i || d.textAlign,
            borderRadius: s && (a || d.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (n) => n.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (n) => !n.startsWith("on"),
    labels: {
      _scriptable: (n) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(n)
    }
  }
};
class j9 extends Cr {
  constructor(e) {
    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, t) {
    const o = this.options;
    if (this.left = 0, this.top = 0, !o.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = e, this.height = this.bottom = t;
    const i = Nt(o.text) ? o.text.length : 1;
    this._padding = Yn(o.padding);
    const r = i * Jt(o.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const e = this.options.position;
    return e === "top" || e === "bottom";
  }
  _drawArgs(e) {
    const { top: t, left: o, bottom: i, right: r, options: s } = this, a = s.align;
    let l = 0, d, u, c;
    return this.isHorizontal() ? (u = Kt(a, o, r), c = t + e, d = r - o) : (s.position === "left" ? (u = o + e, c = Kt(a, i, t), l = nt * -0.5) : (u = r - e, c = Kt(a, t, i), l = nt * 0.5), d = i - t), {
      titleX: u,
      titleY: c,
      maxWidth: d,
      rotation: l
    };
  }
  draw() {
    const e = this.ctx, t = this.options;
    if (!t.display)
      return;
    const o = Jt(t.font), r = o.lineHeight / 2 + this._padding.top, { titleX: s, titleY: a, maxWidth: l, rotation: d } = this._drawArgs(r);
    Pa(e, t.text, 0, 0, o, {
      color: t.color,
      maxWidth: l,
      rotation: d,
      textAlign: Gh(t.align),
      textBaseline: "middle",
      translation: [
        s,
        a
      ]
    });
  }
}
function sU(n, e) {
  const t = new j9({
    ctx: n.ctx,
    options: e,
    chart: n
  });
  jn.configure(n, t, e), jn.addBox(n, t), n.titleBlock = t;
}
var aU = {
  id: "title",
  _element: j9,
  start(n, e, t) {
    sU(n, t);
  },
  stop(n) {
    const e = n.titleBlock;
    jn.removeBox(n, e), delete n.titleBlock;
  },
  beforeUpdate(n, e, t) {
    const o = n.titleBlock;
    jn.configure(n, o, t), o.options = t;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Ks = {
  average(n) {
    if (!n.length)
      return !1;
    let e, t, o = /* @__PURE__ */ new Set(), i = 0, r = 0;
    for (e = 0, t = n.length; e < t; ++e) {
      const a = n[e].element;
      if (a && a.hasValue()) {
        const l = a.tooltipPosition();
        o.add(l.x), i += l.y, ++r;
      }
    }
    return r === 0 || o.size === 0 ? !1 : {
      x: [
        ...o
      ].reduce((a, l) => a + l) / o.size,
      y: i / r
    };
  },
  nearest(n, e) {
    if (!n.length)
      return !1;
    let t = e.x, o = e.y, i = Number.POSITIVE_INFINITY, r, s, a;
    for (r = 0, s = n.length; r < s; ++r) {
      const l = n[r].element;
      if (l && l.hasValue()) {
        const d = l.getCenterPoint(), u = _H(e, d);
        u < i && (i = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      t = l.x, o = l.y;
    }
    return {
      x: t,
      y: o
    };
  }
};
function lo(n, e) {
  return e && (Nt(e) ? Array.prototype.push.apply(n, e) : n.push(e)), n;
}
function To(n) {
  return (typeof n == "string" || n instanceof String) && n.indexOf(`
`) > -1 ? n.split(`
`) : n;
}
function lU(n, e) {
  const { element: t, datasetIndex: o, index: i } = e, r = n.getDatasetMeta(o).controller, { label: s, value: a } = r.getLabelAndValue(i);
  return {
    chart: n,
    label: s,
    parsed: r.getParsed(i),
    raw: n.data.datasets[o].data[i],
    formattedValue: a,
    dataset: r.getDataset(),
    dataIndex: i,
    datasetIndex: o,
    element: t
  };
}
function c2(n, e) {
  const t = n.chart.ctx, { body: o, footer: i, title: r } = n, { boxWidth: s, boxHeight: a } = e, l = Jt(e.bodyFont), d = Jt(e.titleFont), u = Jt(e.footerFont), c = r.length, f = i.length, h = o.length, p = Yn(e.padding);
  let m = p.height, g = 0, b = o.reduce((M, $) => M + $.before.length + $.lines.length + $.after.length, 0);
  if (b += n.beforeBody.length + n.afterBody.length, c && (m += c * d.lineHeight + (c - 1) * e.titleSpacing + e.titleMarginBottom), b) {
    const M = e.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    m += h * M + (b - h) * l.lineHeight + (b - 1) * e.bodySpacing;
  }
  f && (m += e.footerMarginTop + f * u.lineHeight + (f - 1) * e.footerSpacing);
  let x = 0;
  const w = function(M) {
    g = Math.max(g, t.measureText(M).width + x);
  };
  return t.save(), t.font = d.string, et(n.title, w), t.font = l.string, et(n.beforeBody.concat(n.afterBody), w), x = e.displayColors ? s + 2 + e.boxPadding : 0, et(o, (M) => {
    et(M.before, w), et(M.lines, w), et(M.after, w);
  }), x = 0, t.font = u.string, et(n.footer, w), t.restore(), g += p.width, {
    width: g,
    height: m
  };
}
function dU(n, e) {
  const { y: t, height: o } = e;
  return t < o / 2 ? "top" : t > n.height - o / 2 ? "bottom" : "center";
}
function uU(n, e, t, o) {
  const { x: i, width: r } = o, s = t.caretSize + t.caretPadding;
  if (n === "left" && i + r + s > e.width || n === "right" && i - r - s < 0)
    return !0;
}
function cU(n, e, t, o) {
  const { x: i, width: r } = t, { width: s, chartArea: { left: a, right: l } } = n;
  let d = "center";
  return o === "center" ? d = i <= (a + l) / 2 ? "left" : "right" : i <= r / 2 ? d = "left" : i >= s - r / 2 && (d = "right"), uU(d, n, e, t) && (d = "center"), d;
}
function f2(n, e, t) {
  const o = t.yAlign || e.yAlign || dU(n, t);
  return {
    xAlign: t.xAlign || e.xAlign || cU(n, e, t, o),
    yAlign: o
  };
}
function fU(n, e) {
  let { x: t, width: o } = n;
  return e === "right" ? t -= o : e === "center" && (t -= o / 2), t;
}
function hU(n, e, t) {
  let { y: o, height: i } = n;
  return e === "top" ? o += t : e === "bottom" ? o -= i + t : o -= i / 2, o;
}
function h2(n, e, t, o) {
  const { caretSize: i, caretPadding: r, cornerRadius: s } = n, { xAlign: a, yAlign: l } = t, d = i + r, { topLeft: u, topRight: c, bottomLeft: f, bottomRight: h } = Gr(s);
  let p = fU(e, a);
  const m = hU(e, l, d);
  return l === "center" ? a === "left" ? p += d : a === "right" && (p -= d) : a === "left" ? p -= Math.max(u, f) + i : a === "right" && (p += Math.max(c, h) + i), {
    x: yn(p, 0, o.width - e.width),
    y: yn(m, 0, o.height - e.height)
  };
}
function El(n, e, t) {
  const o = Yn(t.padding);
  return e === "center" ? n.x + n.width / 2 : e === "right" ? n.x + n.width - o.right : n.x + o.left;
}
function p2(n) {
  return lo([], To(n));
}
function pU(n, e, t) {
  return Cs(n, {
    tooltip: e,
    tooltipItems: t,
    type: "tooltip"
  });
}
function m2(n, e) {
  const t = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return t ? n.override(t) : n;
}
const W9 = {
  beforeTitle: _o,
  title(n) {
    if (n.length > 0) {
      const e = n[0], t = e.chart.data.labels, o = t ? t.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (o > 0 && e.dataIndex < o)
        return t[e.dataIndex];
    }
    return "";
  },
  afterTitle: _o,
  beforeBody: _o,
  beforeLabel: _o,
  label(n) {
    if (this && this.options && this.options.mode === "dataset")
      return n.label + ": " + n.formattedValue || n.formattedValue;
    let e = n.dataset.label || "";
    e && (e += ": ");
    const t = n.formattedValue;
    return pt(t) || (e += t), e;
  },
  labelColor(n) {
    const t = n.chart.getDatasetMeta(n.datasetIndex).controller.getStyle(n.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(n) {
    const t = n.chart.getDatasetMeta(n.datasetIndex).controller.getStyle(n.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: _o,
  afterBody: _o,
  beforeFooter: _o,
  footer: _o,
  afterFooter: _o
};
function mn(n, e, t, o) {
  const i = n[e].call(t, o);
  return typeof i > "u" ? W9[e].call(t, o) : i;
}
class d1 extends Cr {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const t = this.chart, o = this.options.setContext(this.getContext()), i = o.enabled && t.options.animation && o.animations, r = new T9(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = pU(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, t) {
    const { callbacks: o } = t, i = mn(o, "beforeTitle", this, e), r = mn(o, "title", this, e), s = mn(o, "afterTitle", this, e);
    let a = [];
    return a = lo(a, To(i)), a = lo(a, To(r)), a = lo(a, To(s)), a;
  }
  getBeforeBody(e, t) {
    return p2(mn(t.callbacks, "beforeBody", this, e));
  }
  getBody(e, t) {
    const { callbacks: o } = t, i = [];
    return et(e, (r) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = m2(o, r);
      lo(s.before, To(mn(a, "beforeLabel", this, r))), lo(s.lines, mn(a, "label", this, r)), lo(s.after, To(mn(a, "afterLabel", this, r))), i.push(s);
    }), i;
  }
  getAfterBody(e, t) {
    return p2(mn(t.callbacks, "afterBody", this, e));
  }
  getFooter(e, t) {
    const { callbacks: o } = t, i = mn(o, "beforeFooter", this, e), r = mn(o, "footer", this, e), s = mn(o, "afterFooter", this, e);
    let a = [];
    return a = lo(a, To(i)), a = lo(a, To(r)), a = lo(a, To(s)), a;
  }
  _createItems(e) {
    const t = this._active, o = this.chart.data, i = [], r = [], s = [];
    let a = [], l, d;
    for (l = 0, d = t.length; l < d; ++l)
      a.push(lU(this.chart, t[l]));
    return e.filter && (a = a.filter((u, c, f) => e.filter(u, c, f, o))), e.itemSort && (a = a.sort((u, c) => e.itemSort(u, c, o))), et(a, (u) => {
      const c = m2(e.callbacks, u);
      i.push(mn(c, "labelColor", this, u)), r.push(mn(c, "labelPointStyle", this, u)), s.push(mn(c, "labelTextColor", this, u));
    }), this.labelColors = i, this.labelPointStyles = r, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(e, t) {
    const o = this.options.setContext(this.getContext()), i = this._active;
    let r, s = [];
    if (!i.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const a = Ks[o.position].call(this, i, this._eventPosition);
      s = this._createItems(o), this.title = this.getTitle(s, o), this.beforeBody = this.getBeforeBody(s, o), this.body = this.getBody(s, o), this.afterBody = this.getAfterBody(s, o), this.footer = this.getFooter(s, o);
      const l = this._size = c2(this, o), d = Object.assign({}, a, l), u = f2(this.chart, o, d), c = h2(o, d, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, r = {
        opacity: 1,
        x: c.x,
        y: c.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, r && this._resolveAnimations().update(this, r), e && o.external && o.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: t
    });
  }
  drawCaret(e, t, o, i) {
    const r = this.getCaretPosition(e, o, i);
    t.lineTo(r.x1, r.y1), t.lineTo(r.x2, r.y2), t.lineTo(r.x3, r.y3);
  }
  getCaretPosition(e, t, o) {
    const { xAlign: i, yAlign: r } = this, { caretSize: s, cornerRadius: a } = o, { topLeft: l, topRight: d, bottomLeft: u, bottomRight: c } = Gr(a), { x: f, y: h } = e, { width: p, height: m } = t;
    let g, b, x, w, M, $;
    return r === "center" ? (M = h + m / 2, i === "left" ? (g = f, b = g - s, w = M + s, $ = M - s) : (g = f + p, b = g + s, w = M - s, $ = M + s), x = g) : (i === "left" ? b = f + Math.max(l, u) + s : i === "right" ? b = f + p - Math.max(d, c) - s : b = this.caretX, r === "top" ? (w = h, M = w - s, g = b - s, x = b + s) : (w = h + m, M = w + s, g = b + s, x = b - s), $ = w), {
      x1: g,
      x2: b,
      x3: x,
      y1: w,
      y2: M,
      y3: $
    };
  }
  drawTitle(e, t, o) {
    const i = this.title, r = i.length;
    let s, a, l;
    if (r) {
      const d = Yr(o.rtl, this.x, this.width);
      for (e.x = El(this, o.titleAlign, o), t.textAlign = d.textAlign(o.titleAlign), t.textBaseline = "middle", s = Jt(o.titleFont), a = o.titleSpacing, t.fillStyle = o.titleColor, t.font = s.string, l = 0; l < r; ++l)
        t.fillText(i[l], d.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + a, l + 1 === r && (e.y += o.titleMarginBottom - a);
    }
  }
  _drawColorBox(e, t, o, i, r) {
    const s = this.labelColors[o], a = this.labelPointStyles[o], { boxHeight: l, boxWidth: d } = r, u = Jt(r.bodyFont), c = El(this, "left", r), f = i.x(c), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = t.y + h;
    if (r.usePointStyle) {
      const m = {
        radius: Math.min(d, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, g = i.leftForLtr(f, d) + d / 2, b = p + l / 2;
      e.strokeStyle = r.multiKeyBackground, e.fillStyle = r.multiKeyBackground, Dm(e, m, g, b), e.strokeStyle = s.borderColor, e.fillStyle = s.backgroundColor, Dm(e, m, g, b);
    } else {
      e.lineWidth = je(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, e.strokeStyle = s.borderColor, e.setLineDash(s.borderDash || []), e.lineDashOffset = s.borderDashOffset || 0;
      const m = i.leftForLtr(f, d), g = i.leftForLtr(i.xPlus(f, 1), d - 2), b = Gr(s.borderRadius);
      Object.values(b).some((x) => x !== 0) ? (e.beginPath(), e.fillStyle = r.multiKeyBackground, eu(e, {
        x: m,
        y: p,
        w: d,
        h: l,
        radius: b
      }), e.fill(), e.stroke(), e.fillStyle = s.backgroundColor, e.beginPath(), eu(e, {
        x: g,
        y: p + 1,
        w: d - 2,
        h: l - 2,
        radius: b
      }), e.fill()) : (e.fillStyle = r.multiKeyBackground, e.fillRect(m, p, d, l), e.strokeRect(m, p, d, l), e.fillStyle = s.backgroundColor, e.fillRect(g, p + 1, d - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[o];
  }
  drawBody(e, t, o) {
    const { body: i } = this, { bodySpacing: r, bodyAlign: s, displayColors: a, boxHeight: l, boxWidth: d, boxPadding: u } = o, c = Jt(o.bodyFont);
    let f = c.lineHeight, h = 0;
    const p = Yr(o.rtl, this.x, this.width), m = function(S) {
      t.fillText(S, p.x(e.x + h), e.y + f / 2), e.y += f + r;
    }, g = p.textAlign(s);
    let b, x, w, M, $, T, E;
    for (t.textAlign = s, t.textBaseline = "middle", t.font = c.string, e.x = El(this, g, o), t.fillStyle = o.bodyColor, et(this.beforeBody, m), h = a && g !== "right" ? s === "center" ? d / 2 + u : d + 2 + u : 0, M = 0, T = i.length; M < T; ++M) {
      for (b = i[M], x = this.labelTextColors[M], t.fillStyle = x, et(b.before, m), w = b.lines, a && w.length && (this._drawColorBox(t, e, M, p, o), f = Math.max(c.lineHeight, l)), $ = 0, E = w.length; $ < E; ++$)
        m(w[$]), f = c.lineHeight;
      et(b.after, m);
    }
    h = 0, f = c.lineHeight, et(this.afterBody, m), e.y -= r;
  }
  drawFooter(e, t, o) {
    const i = this.footer, r = i.length;
    let s, a;
    if (r) {
      const l = Yr(o.rtl, this.x, this.width);
      for (e.x = El(this, o.footerAlign, o), e.y += o.footerMarginTop, t.textAlign = l.textAlign(o.footerAlign), t.textBaseline = "middle", s = Jt(o.footerFont), t.fillStyle = o.footerColor, t.font = s.string, a = 0; a < r; ++a)
        t.fillText(i[a], l.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + o.footerSpacing;
    }
  }
  drawBackground(e, t, o, i) {
    const { xAlign: r, yAlign: s } = this, { x: a, y: l } = e, { width: d, height: u } = o, { topLeft: c, topRight: f, bottomLeft: h, bottomRight: p } = Gr(i.cornerRadius);
    t.fillStyle = i.backgroundColor, t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.beginPath(), t.moveTo(a + c, l), s === "top" && this.drawCaret(e, t, o, i), t.lineTo(a + d - f, l), t.quadraticCurveTo(a + d, l, a + d, l + f), s === "center" && r === "right" && this.drawCaret(e, t, o, i), t.lineTo(a + d, l + u - p), t.quadraticCurveTo(a + d, l + u, a + d - p, l + u), s === "bottom" && this.drawCaret(e, t, o, i), t.lineTo(a + h, l + u), t.quadraticCurveTo(a, l + u, a, l + u - h), s === "center" && r === "left" && this.drawCaret(e, t, o, i), t.lineTo(a, l + c), t.quadraticCurveTo(a, l, a + c, l), t.closePath(), t.fill(), i.borderWidth > 0 && t.stroke();
  }
  _updateAnimationTarget(e) {
    const t = this.chart, o = this.$animations, i = o && o.x, r = o && o.y;
    if (i || r) {
      const s = Ks[e.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = c2(this, e), l = Object.assign({}, s, this._size), d = f2(t, e, l), u = h2(e, l, d, t);
      (i._to !== u.x || r._to !== u.y) && (this.xAlign = d.xAlign, this.yAlign = d.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const t = this.options.setContext(this.getContext());
    let o = this.opacity;
    if (!o)
      return;
    this._updateAnimationTarget(t);
    const i = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    o = Math.abs(o) < 1e-3 ? 0 : o;
    const s = Yn(t.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    t.enabled && a && (e.save(), e.globalAlpha = o, this.drawBackground(r, e, i, t), E9(e, t.textDirection), r.y += s.top, this.drawTitle(r, e, t), this.drawBody(r, e, t), this.drawFooter(r, e, t), O9(e, t.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, t) {
    const o = this._active, i = e.map(({ datasetIndex: a, index: l }) => {
      const d = this.chart.getDatasetMeta(a);
      if (!d)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: d.data[l],
        index: l
      };
    }), r = !Gd(o, i), s = this._positionChanged(i, t);
    (r || s) && (this._active = i, this._eventPosition = t, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, t, o = !0) {
    if (t && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, r = this._active || [], s = this._getActiveElements(e, r, t, o), a = this._positionChanged(s, e), l = t || !Gd(s, r) || a;
    return l && (this._active = s, (i.enabled || i.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, t))), l;
  }
  _getActiveElements(e, t, o, i) {
    const r = this.options;
    if (e.type === "mouseout")
      return [];
    if (!i)
      return t.filter((a) => this.chart.data.datasets[a.datasetIndex] && this.chart.getDatasetMeta(a.datasetIndex).controller.getParsed(a.index) !== void 0);
    const s = this.chart.getElementsAtEventForMode(e, r.mode, r, o);
    return r.reverse && s.reverse(), s;
  }
  _positionChanged(e, t) {
    const { caretX: o, caretY: i, options: r } = this, s = Ks[r.position].call(this, e, t);
    return s !== !1 && (o !== s.x || i !== s.y);
  }
}
Ae(d1, "positioners", Ks);
var mU = {
  id: "tooltip",
  _element: d1,
  positioners: Ks,
  afterInit(n, e, t) {
    t && (n.tooltip = new d1({
      chart: n,
      options: t
    }));
  },
  beforeUpdate(n, e, t) {
    n.tooltip && n.tooltip.initialize(t);
  },
  reset(n, e, t) {
    n.tooltip && n.tooltip.initialize(t);
  },
  afterDraw(n) {
    const e = n.tooltip;
    if (e && e._willRender()) {
      const t = {
        tooltip: e
      };
      if (n.notifyPlugins("beforeTooltipDraw", {
        ...t,
        cancelable: !0
      }) === !1)
        return;
      e.draw(n.ctx), n.notifyPlugins("afterTooltipDraw", t);
    }
  },
  afterEvent(n, e) {
    if (n.tooltip) {
      const t = e.replay;
      n.tooltip.handleEvent(e.event, t, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (n, e) => e.bodyFont.size,
    boxWidth: (n, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: W9
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (n) => n !== "filter" && n !== "itemSort" && n !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const gU = (n, e, t, o) => (typeof e == "string" ? (t = n.push(e) - 1, o.unshift({
  index: t,
  label: e
})) : isNaN(e) && (t = null), t);
function vU(n, e, t, o) {
  const i = n.indexOf(e);
  if (i === -1)
    return gU(n, e, t, o);
  const r = n.lastIndexOf(e);
  return i !== r ? t : i;
}
const bU = (n, e) => n === null ? null : yn(Math.round(n), 0, e);
function g2(n) {
  const e = this.getLabels();
  return n >= 0 && n < e.length ? e[n] : n;
}
class u1 extends ws {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const t = this._addedLabels;
    if (t.length) {
      const o = this.getLabels();
      for (const { index: i, label: r } of t)
        o[i] === r && o.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, t) {
    if (pt(e))
      return null;
    const o = this.getLabels();
    return t = isFinite(t) && o[t] === e ? t : vU(o, e, Je(t, e), this._addedLabels), bU(t, o.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: t } = this.getUserBounds();
    let { min: o, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (o = 0), t || (i = this.getLabels().length - 1)), this.min = o, this.max = i;
  }
  buildTicks() {
    const e = this.min, t = this.max, o = this.options.offset, i = [];
    let r = this.getLabels();
    r = e === 0 && t === r.length - 1 ? r : r.slice(e, t + 1), this._valueRange = Math.max(r.length - (o ? 0 : 1), 1), this._startValue = this.min - (o ? 0.5 : 0);
    for (let s = e; s <= t; s++)
      i.push({
        value: s
      });
    return i;
  }
  getLabelForValue(e) {
    return g2.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const t = this.ticks;
    return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Ae(u1, "id", "category"), Ae(u1, "defaults", {
  ticks: {
    callback: g2
  }
});
function yU(n, e) {
  const t = [], { bounds: i, step: r, min: s, max: a, precision: l, count: d, maxTicks: u, maxDigits: c, includeBounds: f } = n, h = r || 1, p = u - 1, { min: m, max: g } = e, b = !pt(s), x = !pt(a), w = !pt(d), M = (g - m) / (c + 1);
  let $ = $m((g - m) / p / h) * h, T, E, S, D;
  if ($ < 1e-14 && !b && !x)
    return [
      {
        value: m
      },
      {
        value: g
      }
    ];
  D = Math.ceil(g / $) - Math.floor(m / $), D > p && ($ = $m(D * $ / p / h) * h), pt(l) || (T = Math.pow(10, l), $ = Math.ceil($ * T) / T), i === "ticks" ? (E = Math.floor(m / $) * $, S = Math.ceil(g / $) * $) : (E = m, S = g), b && x && r && $H((a - s) / r, $ / 1e3) ? (D = Math.round(Math.min((a - s) / $, u)), $ = (a - s) / D, E = s, S = a) : w ? (E = b ? s : E, S = x ? a : S, D = d - 1, $ = (S - E) / D) : (D = (S - E) / $, zl(D, Math.round(D), $ / 1e3) ? D = Math.round(D) : D = Math.ceil(D));
  const I = Math.max(Mm($), Mm(E));
  T = Math.pow(10, pt(l) ? I : l), E = Math.round(E * T) / T, S = Math.round(S * T) / T;
  let z = 0;
  for (b && (f && E !== s ? (t.push({
    value: s
  }), E < s && z++, zl(Math.round((E + z * $) * T) / T, s, v2(s, M, n)) && z++) : E < s && z++); z < D; ++z) {
    const F = Math.round((E + z * $) * T) / T;
    if (x && F > a)
      break;
    t.push({
      value: F
    });
  }
  return x && f && S !== a ? t.length && zl(t[t.length - 1].value, a, v2(a, M, n)) ? t[t.length - 1].value = a : t.push({
    value: a
  }) : (!x || S === a) && t.push({
    value: S
  }), t;
}
function v2(n, e, { horizontal: t, minRotation: o }) {
  const i = Lo(o), r = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, s = 0.75 * e * ("" + n).length;
  return Math.min(e / r, s);
}
class xU extends ws {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, t) {
    return pt(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: t, maxDefined: o } = this.getUserBounds();
    let { min: i, max: r } = this;
    const s = (l) => i = t ? i : l, a = (l) => r = o ? r : l;
    if (e) {
      const l = Jd(i), d = Jd(r);
      l < 0 && d < 0 ? a(0) : l > 0 && d > 0 && s(0);
    }
    if (i === r) {
      let l = r === 0 ? 1 : Math.abs(r * 0.05);
      a(r + l), e || s(i - l);
    }
    this.min = i, this.max = r;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: t, stepSize: o } = e, i;
    return o ? (i = Math.ceil(this.max / o) - Math.floor(this.min / o) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${o} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), t = t || 11), t && (i = Math.min(t, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, t = e.ticks;
    let o = this.getTickLimit();
    o = Math.max(2, o);
    const i = {
      maxTicks: o,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: t.precision,
      step: t.stepSize,
      count: t.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: t.minRotation || 0,
      includeBounds: t.includeBounds !== !1
    }, r = this._range || this, s = yU(i, r);
    return e.bounds === "ticks" && MH(s, this, "value"), e.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const e = this.ticks;
    let t = this.min, o = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const i = (o - t) / Math.max(e.length - 1, 1) / 2;
      t -= i, o += i;
    }
    this._startValue = t, this._endValue = o, this._valueRange = o - t;
  }
  getLabelForValue(e) {
    return Yh(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class c1 extends xU {
  determineDataLimits() {
    const { min: e, max: t } = this.getMinMax(!0);
    this.min = Gn(e) ? e : 0, this.max = Gn(t) ? t : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), t = e ? this.width : this.height, o = Lo(this.options.ticks.minRotation), i = (e ? Math.sin(o) : Math.cos(o)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(t / Math.min(40, r.lineHeight / i));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
Ae(c1, "id", "linear"), Ae(c1, "defaults", {
  ticks: {
    callback: x9.formatters.numeric
  }
});
const ju = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, bn = /* @__PURE__ */ Object.keys(ju);
function b2(n, e) {
  return n - e;
}
function y2(n, e) {
  if (pt(e))
    return null;
  const t = n._adapter, { parser: o, round: i, isoWeekday: r } = n._parseOpts;
  let s = e;
  return typeof o == "function" && (s = o(s)), Gn(s) || (s = typeof o == "string" ? t.parse(s, o) : t.parse(s)), s === null ? null : (i && (s = i === "week" && (Xd(r) || r === !0) ? t.startOf(s, "isoWeek", r) : t.startOf(s, i)), +s);
}
function x2(n, e, t, o) {
  const i = bn.length;
  for (let r = bn.indexOf(n); r < i - 1; ++r) {
    const s = ju[bn[r]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((t - e) / (a * s.size)) <= o)
      return bn[r];
  }
  return bn[i - 1];
}
function CU(n, e, t, o, i) {
  for (let r = bn.length - 1; r >= bn.indexOf(t); r--) {
    const s = bn[r];
    if (ju[s].common && n._adapter.diff(i, o, s) >= e - 1)
      return s;
  }
  return bn[t ? bn.indexOf(t) : 0];
}
function wU(n) {
  for (let e = bn.indexOf(n) + 1, t = bn.length; e < t; ++e)
    if (ju[bn[e]].common)
      return bn[e];
}
function C2(n, e, t) {
  if (!t)
    n[e] = !0;
  else if (t.length) {
    const { lo: o, hi: i } = Kh(t, e), r = t[o] >= e ? t[o] : t[i];
    n[r] = !0;
  }
}
function kU(n, e, t, o) {
  const i = n._adapter, r = +i.startOf(e[0].value, o), s = e[e.length - 1].value;
  let a, l;
  for (a = r; a <= s; a = +i.add(a, 1, o))
    l = t[a], l >= 0 && (e[l].major = !0);
  return e;
}
function w2(n, e, t) {
  const o = [], i = {}, r = e.length;
  let s, a;
  for (s = 0; s < r; ++s)
    a = e[s], i[a] = s, o.push({
      value: a,
      major: !1
    });
  return r === 0 || !t ? o : kU(n, o, i, t);
}
class iu extends ws {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, t = {}) {
    const o = e.time || (e.time = {}), i = this._adapter = new Nj._date(e.adapters.date);
    i.init(t), sa(o.displayFormats, i.formats()), this._parseOpts = {
      parser: o.parser,
      round: o.round,
      isoWeekday: o.isoWeekday
    }, super.init(e), this._normalized = t.normalized;
  }
  parse(e, t) {
    return e === void 0 ? null : y2(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, t = this._adapter, o = e.time.unit || "day";
    let { min: i, max: r, minDefined: s, maxDefined: a } = this.getUserBounds();
    function l(d) {
      !s && !isNaN(d.min) && (i = Math.min(i, d.min)), !a && !isNaN(d.max) && (r = Math.max(r, d.max));
    }
    (!s || !a) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), i = Gn(i) && !isNaN(i) ? i : +t.startOf(Date.now(), o), r = Gn(r) && !isNaN(r) ? r : +t.endOf(Date.now(), o) + 1, this.min = Math.min(i, r - 1), this.max = Math.max(i + 1, r);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let t = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
    return e.length && (t = e[0], o = e[e.length - 1]), {
      min: t,
      max: o
    };
  }
  buildTicks() {
    const e = this.options, t = e.time, o = e.ticks, i = o.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const r = this.min, s = this.max, a = TH(i, r, s);
    return this._unit = t.unit || (o.autoSkip ? x2(t.minUnit, this.min, this.max, this._getLabelCapacity(r)) : CU(this, a.length, t.minUnit, this.min, this.max)), this._majorUnit = !o.major.enabled || this._unit === "year" ? void 0 : wU(this._unit), this.initOffsets(i), e.reverse && a.reverse(), w2(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let t = 0, o = 0, i, r;
    this.options.offset && e.length && (i = this.getDecimalForValue(e[0]), e.length === 1 ? t = 1 - i : t = (this.getDecimalForValue(e[1]) - i) / 2, r = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? o = r : o = (r - this.getDecimalForValue(e[e.length - 2])) / 2);
    const s = e.length < 3 ? 0.5 : 0.25;
    t = yn(t, 0, s), o = yn(o, 0, s), this._offsets = {
      start: t,
      end: o,
      factor: 1 / (t + 1 + o)
    };
  }
  _generate() {
    const e = this._adapter, t = this.min, o = this.max, i = this.options, r = i.time, s = r.unit || x2(r.minUnit, t, o, this._getLabelCapacity(t)), a = Je(i.ticks.stepSize, 1), l = s === "week" ? r.isoWeekday : !1, d = Xd(l) || l === !0, u = {};
    let c = t, f, h;
    if (d && (c = +e.startOf(c, "isoWeek", l)), c = +e.startOf(c, d ? "day" : s), e.diff(o, t, s) > 1e5 * a)
      throw new Error(t + " and " + o + " are too far apart with stepSize of " + a + " " + s);
    const p = i.ticks.source === "data" && this.getDataTimestamps();
    for (f = c, h = 0; f < o; f = +e.add(f, a, s), h++)
      C2(u, f, p);
    return (f === o || i.bounds === "ticks" || h === 1) && C2(u, f, p), Object.keys(u).sort(b2).map((m) => +m);
  }
  getLabelForValue(e) {
    const t = this._adapter, o = this.options.time;
    return o.tooltipFormat ? t.format(e, o.tooltipFormat) : t.format(e, o.displayFormats.datetime);
  }
  format(e, t) {
    const i = this.options.time.displayFormats, r = this._unit, s = t || i[r];
    return this._adapter.format(e, s);
  }
  _tickFormatFunction(e, t, o, i) {
    const r = this.options, s = r.ticks.callback;
    if (s)
      return at(s, [
        e,
        t,
        o
      ], this);
    const a = r.time.displayFormats, l = this._unit, d = this._majorUnit, u = l && a[l], c = d && a[d], f = o[t], h = d && c && f && f.major;
    return this._adapter.format(e, i || (h ? c : u));
  }
  generateTickLabels(e) {
    let t, o, i;
    for (t = 0, o = e.length; t < o; ++t)
      i = e[t], i.label = this._tickFormatFunction(i.value, t, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const t = this._offsets, o = this.getDecimalForValue(e);
    return this.getPixelForDecimal((t.start + o) * t.factor);
  }
  getValueForPixel(e) {
    const t = this._offsets, o = this.getDecimalForPixel(e) / t.factor - t.end;
    return this.min + o * (this.max - this.min);
  }
  _getLabelSize(e) {
    const t = this.options.ticks, o = this.ctx.measureText(e).width, i = Lo(this.isHorizontal() ? t.maxRotation : t.minRotation), r = Math.cos(i), s = Math.sin(i), a = this._resolveTickFontOptions(0).size;
    return {
      w: o * r + a * s,
      h: o * s + a * r
    };
  }
  _getLabelCapacity(e) {
    const t = this.options.time, o = t.displayFormats, i = o[t.unit] || o.millisecond, r = this._tickFormatFunction(e, 0, w2(this, [
      e
    ], this._majorUnit), i), s = this._getLabelSize(r), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], t, o;
    if (e.length)
      return e;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (t = 0, o = i.length; t < o; ++t)
      e = e.concat(i[t].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let t, o;
    if (e.length)
      return e;
    const i = this.getLabels();
    for (t = 0, o = i.length; t < o; ++t)
      e.push(y2(this, i[t]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return IH(e.sort(b2));
  }
}
Ae(iu, "id", "time"), Ae(iu, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Ol(n, e, t) {
  let o = 0, i = n.length - 1, r, s, a, l;
  t ? (e >= n[o].pos && e <= n[i].pos && ({ lo: o, hi: i } = r1(n, "pos", e)), { pos: r, time: a } = n[o], { pos: s, time: l } = n[i]) : (e >= n[o].time && e <= n[i].time && ({ lo: o, hi: i } = r1(n, "time", e)), { time: r, pos: a } = n[o], { time: s, pos: l } = n[i]);
  const d = s - r;
  return d ? a + (l - a) * (e - r) / d : a;
}
class k2 extends iu {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), t = this._table = this.buildLookupTable(e);
    this._minPos = Ol(t, this.min), this._tableRange = Ol(t, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: t, max: o } = this, i = [], r = [];
    let s, a, l, d, u;
    for (s = 0, a = e.length; s < a; ++s)
      d = e[s], d >= t && d <= o && i.push(d);
    if (i.length < 2)
      return [
        {
          time: t,
          pos: 0
        },
        {
          time: o,
          pos: 1
        }
      ];
    for (s = 0, a = i.length; s < a; ++s)
      u = i[s + 1], l = i[s - 1], d = i[s], Math.round((u + l) / 2) !== d && r.push({
        time: d,
        pos: s / (a - 1)
      });
    return r;
  }
  _generate() {
    const e = this.min, t = this.max;
    let o = super.getDataTimestamps();
    return (!o.includes(e) || !o.length) && o.splice(0, 0, e), (!o.includes(t) || o.length === 1) && o.push(t), o.sort((i, r) => i - r);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const t = this.getDataTimestamps(), o = this.getLabelTimestamps();
    return t.length && o.length ? e = this.normalize(t.concat(o)) : e = t.length ? t : o, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Ol(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const t = this._offsets, o = this.getDecimalForPixel(e) / t.factor - t.end;
    return Ol(this._table, o * this._tableRange + this._minPos, !0);
  }
}
Ae(k2, "id", "timeseries"), Ae(k2, "defaults", iu.defaults);
const U9 = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, $U = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
}, MU = {
  type: {
    type: String,
    required: !0
  },
  destroyDelay: {
    type: Number,
    default: 0
    // No delay by default
  },
  ...U9,
  ...$U
}, SU = vv[0] === "2" ? (n, e) => Object.assign(n, {
  attrs: e
}) : (n, e) => Object.assign(n, e);
function Nr(n) {
  return P2(n) ? vt(n) : n;
}
function _U(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n;
  return P2(e) ? new Proxy(n, {}) : n;
}
function EU(n, e) {
  const t = n.options;
  t && e && Object.assign(t, e);
}
function K9(n, e) {
  n.labels = e;
}
function G9(n, e, t) {
  const o = [];
  n.datasets = e.map((i) => {
    const r = n.datasets.find((s) => s[t] === i[t]);
    return !r || !i.data || o.includes(r) ? {
      ...i
    } : (o.push(r), Object.assign(r, i), r);
  });
}
function OU(n, e) {
  const t = {
    labels: [],
    datasets: []
  };
  return K9(t, n.labels), G9(t, n.datasets, e), t;
}
const TU = H({
  props: MU,
  setup(n, e) {
    let { expose: t, slots: o } = e;
    const i = R(null), r = mr(null);
    t({
      chart: r
    });
    const s = () => {
      if (!i.value) return;
      const { type: d, data: u, options: c, plugins: f, datasetIdKey: h } = n, p = OU(u, h), m = _U(p, u);
      r.value = new Hu(i.value, {
        type: d,
        data: m,
        options: {
          ...c
        },
        plugins: f
      });
    }, a = () => {
      const d = vt(r.value);
      d && (n.destroyDelay > 0 ? setTimeout(() => {
        d.destroy(), r.value = null;
      }, n.destroyDelay) : (d.destroy(), r.value = null));
    }, l = (d) => {
      d.update(n.updateMode);
    };
    return We(s), Ei(a), Ee([
      () => n.options,
      () => n.data
    ], (d, u) => {
      let [c, f] = d, [h, p] = u;
      const m = vt(r.value);
      if (!m)
        return;
      let g = !1;
      if (c) {
        const b = Nr(c), x = Nr(h);
        b && b !== x && (EU(m, b), g = !0);
      }
      if (f) {
        const b = Nr(f.labels), x = Nr(p.labels), w = Nr(f.datasets), M = Nr(p.datasets);
        b !== x && (K9(m.config.data, b), g = !0), w && w !== M && (G9(m.config.data, w, n.datasetIdKey), g = !0);
      }
      g && Ve(() => {
        l(m);
      });
    }, {
      deep: !0
    }), () => lt("canvas", {
      role: "img",
      "aria-label": n.ariaLabel,
      "aria-describedby": n.ariaDescribedby,
      ref: i
    }, [
      lt("p", {}, [
        o.default ? o.default() : ""
      ])
    ]);
  }
});
function AU(n, e) {
  return Hu.register(e), H({
    props: U9,
    setup(t, o) {
      let { expose: i } = o;
      const r = mr(null), s = (a) => {
        r.value = a == null ? void 0 : a.chart;
      };
      return i({
        chart: r
      }), () => lt(TU, SU({
        ref: s
      }, {
        type: n,
        ...t
      }));
    }
  });
}
const IU = /* @__PURE__ */ AU("doughnut", js), DU = { class: "flex items-center gap-5 flex-wrap justify-center" }, NU = { class: "relative" }, PU = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" }, LU = { key: 0 }, RU = { class: "text-mgm-txt-sm text-foreground-default w-20 truncate" }, FU = { class: "text-mgm-txt-sm text-foreground-emphasis font-medium" }, bY = /* @__PURE__ */ H({
  __name: "PieChart",
  props: {
    width: {},
    data: {},
    legend: { type: Boolean }
  },
  setup(n) {
    Hu.register(
      aU,
      mU,
      rU,
      Wl,
      u1,
      c1,
      Us
    );
    const e = n, t = {
      radius: e.width / 2,
      cutout: "70%",
      elements: {
        arc: {
          borderWidth: 2,
          offset: 0
        }
      },
      plugins: {
        legend: {
          display: !1
        },
        tooltip: {
          enabled: !1,
          external: function(i) {
            let r = document.getElementById("chartjs-tooltip");
            r || (r = document.createElement("section"), r.id = "chartjs-tooltip", document.body.appendChild(r));
            const s = i.tooltip;
            if (s.opacity === 0) {
              r.style.opacity = "0";
              return;
            }
            r.classList.remove("above", "below", "no-transform"), s.yAlign ? r.classList.add(s.yAlign) : r.classList.add("no-transform");
            function a(d) {
              return d.lines;
            }
            if (s.body) {
              const d = s.dataPoints.map((f) => f.label) || [], u = s.body.map(a);
              let c = "<div style='display: block; gap: 4px; margin: 0 4px;'></div>";
              u.forEach(function(f, h) {
                let m = "background:" + s.labelColors[h].backgroundColor;
                m += "; width: 10px; height: 10px; display: inline-block; margin-right: 4px; margin-left: 8px; border-radius: 999px";
                const g = '<span style="' + m + '"></span>' + d[h] + ": " + f;
                c += g;
              }), r && (r.innerHTML = c);
            }
            const l = i.chart.canvas.getBoundingClientRect();
            r.style.background = "var(--color-background-emphasis)", r.style.padding = "12px 15px 12px 7px", r.style.borderRadius = "8px", r.style.fontSize = "14px", r.style.color = "white", r.style.opacity = "1", r.style.position = "absolute", r.style.left = l.left + window.pageXOffset + s.caretX + "px", r.style.top = l.top + window.pageYOffset + s.caretY + "px", r.style.padding = s.padding + "px " + s.padding + "px", r.style.pointerEvents = "none";
          }
        }
      }
    }, o = {
      labels: e.data.map((i) => i.legend),
      datasets: [
        {
          data: e.data.map((i) => i.value),
          backgroundColor: e.data.map((i) => i.color),
          hoverOffset: 20
        }
      ]
    };
    return (i, r) => (v(), C("div", DU, [
      y("div", NU, [
        U(k(IU), {
          id: "doughnut-chart",
          options: t,
          data: o,
          width: n.width + 20,
          height: n.width + 20
        }, null, 8, ["width", "height"]),
        y("span", PU, [
          le(i.$slots, "default")
        ])
      ]),
      n.legend ? (v(), C("div", LU, [
        (v(!0), C(re, null, De(e.data, (s, a) => (v(), C("div", {
          key: a + s.color + s.legend + s.value,
          class: "flex items-center gap-2"
        }, [
          y("div", {
            class: "w-2 h-2 rounded-full",
            style: He({ backgroundColor: s.color })
          }, null, 4),
          y("span", RU, j(s.legend), 1),
          y("span", FU, j(s.value), 1)
        ]))), 128))
      ])) : _("", !0)
    ]));
  }
}), BU = { class: "progress-container relative" }, VU = {
  viewBox: "0 0 200 100",
  class: "circular-chart"
}, zU = { class: "bottom-0 left-1/2 -translate-x-1/2 absolute" }, HU = /* @__PURE__ */ H({
  __name: "ProgressArc",
  props: {
    value: {},
    max: {},
    displayText: { type: Boolean }
  },
  setup(n) {
    const e = n, t = L(() => {
      const o = 2 * Math.PI * 80 / 2;
      return `${e.value / e.max * 100 / 100 * o} ${o}`;
    });
    return (o, i) => (v(), C("div", BU, [
      (v(), C("svg", VU, [
        i[0] || (i[0] = y("path", {
          class: "circle-bg",
          d: "M 20,90 A 80,80 0 0,1 180,90"
        }, null, -1)),
        y("path", {
          class: "circle",
          style: He({ strokeDasharray: t.value }),
          d: "M 20,90 A 80,80 0 0,1 180,90"
        }, null, 4)
      ])),
      y("div", zU, [
        le(o.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), yY = /* @__PURE__ */ Ai(HU, [["__scopeId", "data-v-6d049f0b"]]), jU = { class: "h-4 w-full rounded flex gap-1 bg-white" }, WU = ["title"], UU = { class: "group-hover:opacity-100 opacity-0 py-3 px-4 bg-background-emphasis absolute bottom-5 left-1 rounded-lg transition-all duration-150 flex items-center text-white gap-2" }, KU = { class: "text-mgm-txt-sm whitespace-nowrap" }, GU = {
  key: 0,
  class: "flex gap-4 mt-2"
}, YU = { class: "text-mgm-txt-sm whitespace-nowrap" }, qU = /* @__PURE__ */ H({
  __name: "ProgressBar",
  props: {
    data: {},
    legends: { type: Boolean }
  },
  setup(n) {
    const e = n, t = L(() => {
      const o = e.data.reduce((i, r) => i + r.value, 0);
      return e.data.map((i) => ({
        ...i,
        percentage: i.value / o * 100
      }));
    });
    return (o, i) => (v(), C("div", null, [
      y("div", jU, [
        (v(!0), C(re, null, De(t.value, (r, s) => (v(), C("div", {
          key: r.legend,
          style: He({ width: `${r.percentage}%`, backgroundColor: r.color }),
          class: J(`h-full relative group progress-bar-element ${s === 0 ? "rounded-l" : ""} ${s === t.value.length - 1 ? "rounded-r" : "rounded-none"}`),
          title: r.hoverText
        }, [
          y("div", UU, [
            y("div", {
              class: "w-2.5 h-2.5 rounded-full",
              style: He({ backgroundColor: r.color })
            }, null, 4),
            y("p", KU, j(r.hoverText), 1)
          ])
        ], 14, WU))), 128))
      ]),
      n.legends ? (v(), C("div", GU, [
        (v(!0), C(re, null, De(t.value, (r) => (v(), C("div", {
          key: r.legend,
          class: "flex gap-2 items-center"
        }, [
          y("div", {
            class: "w-2.5 h-2.5 rounded-full",
            style: He({ backgroundColor: r.color })
          }, null, 4),
          y("p", YU, j(r.legend), 1)
        ]))), 128))
      ])) : _("", !0)
    ]));
  }
}), xY = /* @__PURE__ */ Ai(qU, [["__scopeId", "data-v-a2b06079"]]), ZU = { class: "" }, JU = {
  width: "221",
  height: "24",
  viewBox: "0 0 221 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XU = { id: "progress-mask" }, QU = ["width"], eK = {
  key: 0,
  class: "flex items-center justify-between w-full mt-2 text-mgm-txt-sm text-foreground-default"
}, tK = /* @__PURE__ */ H({
  __name: "ProgressGradient",
  props: {
    progress: {},
    legends: {}
  },
  setup(n) {
    const e = n, t = L(() => 221 * e.progress / 100);
    return (o, i) => {
      var r, s;
      return v(), C("div", ZU, [
        (v(), C("svg", JU, [
          i[0] || (i[0] = mi('<g data-v-4b5dbe3c><path d="M0.5 2C0.5 0.89543 1.39543 0 2.5 0C3.60457 0 4.5 0.895431 4.5 2V22C4.5 23.1046 3.60457 24 2.5 24C1.39543 24 0.5 23.1046 0.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M8.5 2C8.5 0.89543 9.39543 0 10.5 0C11.6046 0 12.5 0.895431 12.5 2V22C12.5 23.1046 11.6046 24 10.5 24C9.39543 24 8.5 23.1046 8.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M16.5 2C16.5 0.89543 17.3954 0 18.5 0C19.6046 0 20.5 0.895431 20.5 2V22C20.5 23.1046 19.6046 24 18.5 24C17.3954 24 16.5 23.1046 16.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M24.5 2C24.5 0.89543 25.3954 0 26.5 0C27.6046 0 28.5 0.895431 28.5 2V22C28.5 23.1046 27.6046 24 26.5 24C25.3954 24 24.5 23.1046 24.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M32.5 2C32.5 0.89543 33.3954 0 34.5 0C35.6046 0 36.5 0.895431 36.5 2V22C36.5 23.1046 35.6046 24 34.5 24C33.3954 24 32.5 23.1046 32.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M40.5 2C40.5 0.89543 41.3954 0 42.5 0C43.6046 0 44.5 0.895431 44.5 2V22C44.5 23.1046 43.6046 24 42.5 24C41.3954 24 40.5 23.1046 40.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M48.5 2C48.5 0.89543 49.3954 0 50.5 0C51.6046 0 52.5 0.895431 52.5 2V22C52.5 23.1046 51.6046 24 50.5 24C49.3954 24 48.5 23.1046 48.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M56.5 2C56.5 0.89543 57.3954 0 58.5 0C59.6046 0 60.5 0.895431 60.5 2V22C60.5 23.1046 59.6046 24 58.5 24C57.3954 24 56.5 23.1046 56.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M64.5 2C64.5 0.89543 65.3954 0 66.5 0C67.6046 0 68.5 0.895431 68.5 2V22C68.5 23.1046 67.6046 24 66.5 24C65.3954 24 64.5 23.1046 64.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M72.5 2C72.5 0.89543 73.3954 0 74.5 0C75.6046 0 76.5 0.895431 76.5 2V22C76.5 23.1046 75.6046 24 74.5 24C73.3954 24 72.5 23.1046 72.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M80.5 2C80.5 0.89543 81.3954 0 82.5 0C83.6046 0 84.5 0.895431 84.5 2V22C84.5 23.1046 83.6046 24 82.5 24C81.3954 24 80.5 23.1046 80.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M88.5 2C88.5 0.89543 89.3954 0 90.5 0C91.6046 0 92.5 0.895431 92.5 2V22C92.5 23.1046 91.6046 24 90.5 24C89.3954 24 88.5 23.1046 88.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M96.5 2C96.5 0.89543 97.3954 0 98.5 0C99.6046 0 100.5 0.895431 100.5 2V22C100.5 23.1046 99.6046 24 98.5 24C97.3954 24 96.5 23.1046 96.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M104.5 2C104.5 0.89543 105.395 0 106.5 0C107.605 0 108.5 0.895431 108.5 2V22C108.5 23.1046 107.605 24 106.5 24C105.395 24 104.5 23.1046 104.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M112.5 2C112.5 0.89543 113.395 0 114.5 0C115.605 0 116.5 0.895431 116.5 2V22C116.5 23.1046 115.605 24 114.5 24C113.395 24 112.5 23.1046 112.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M120.5 2C120.5 0.89543 121.395 0 122.5 0C123.605 0 124.5 0.895431 124.5 2V22C124.5 23.1046 123.605 24 122.5 24C121.395 24 120.5 23.1046 120.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M128.5 2C128.5 0.89543 129.395 0 130.5 0C131.605 0 132.5 0.895431 132.5 2V22C132.5 23.1046 131.605 24 130.5 24C129.395 24 128.5 23.1046 128.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M136.5 2C136.5 0.89543 137.395 0 138.5 0C139.605 0 140.5 0.895431 140.5 2V22C140.5 23.1046 139.605 24 138.5 24C137.395 24 136.5 23.1046 136.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M144.5 2C144.5 0.89543 145.395 0 146.5 0C147.605 0 148.5 0.895431 148.5 2V22C148.5 23.1046 147.605 24 146.5 24C145.395 24 144.5 23.1046 144.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M152.5 2C152.5 0.89543 153.395 0 154.5 0C155.605 0 156.5 0.895431 156.5 2V22C156.5 23.1046 155.605 24 154.5 24C153.395 24 152.5 23.1046 152.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M160.5 2C160.5 0.89543 161.395 0 162.5 0C163.605 0 164.5 0.895431 164.5 2V22C164.5 23.1046 163.605 24 162.5 24C161.395 24 160.5 23.1046 160.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M168.5 2C168.5 0.89543 169.395 0 170.5 0C171.605 0 172.5 0.895431 172.5 2V22C172.5 23.1046 171.605 24 170.5 24C169.395 24 168.5 23.1046 168.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M176.5 2C176.5 0.89543 177.395 0 178.5 0C179.605 0 180.5 0.895431 180.5 2V22C180.5 23.1046 179.605 24 178.5 24C177.395 24 176.5 23.1046 176.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M184.5 2C184.5 0.89543 185.395 0 186.5 0C187.605 0 188.5 0.895431 188.5 2V22C188.5 23.1046 187.605 24 186.5 24C185.395 24 184.5 23.1046 184.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M192.5 2C192.5 0.89543 193.395 0 194.5 0C195.605 0 196.5 0.895431 196.5 2V22C196.5 23.1046 195.605 24 194.5 24C193.395 24 192.5 23.1046 192.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M200.5 2C200.5 0.89543 201.395 0 202.5 0C203.605 0 204.5 0.895431 204.5 2V22C204.5 23.1046 203.605 24 202.5 24C201.395 24 200.5 23.1046 200.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M208.5 2C208.5 0.89543 209.395 0 210.5 0C211.605 0 212.5 0.895431 212.5 2V22C212.5 23.1046 211.605 24 210.5 24C209.395 24 208.5 23.1046 208.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M216.5 2C216.5 0.89543 217.395 0 218.5 0C219.605 0 220.5 0.895431 220.5 2V22C220.5 23.1046 219.605 24 218.5 24C217.395 24 216.5 23.1046 216.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path></g>', 1)),
          y("mask", XU, [
            y("rect", {
              class: "progress-rect",
              width: t.value,
              height: "24",
              fill: "white"
            }, null, 8, QU)
          ]),
          i[1] || (i[1] = mi('<g mask="url(#progress-mask)" data-v-4b5dbe3c><mask id="bars-mask" data-v-4b5dbe3c><path d="M0.5 2C0.5 0.89543 1.39543 0 2.5 0C3.60457 0 4.5 0.895431 4.5 2V22C4.5 23.1046 3.60457 24 2.5 24C1.39543 24 0.5 23.1046 0.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M8.5 2C8.5 0.89543 9.39543 0 10.5 0C11.6046 0 12.5 0.895431 12.5 2V22C12.5 23.1046 11.6046 24 10.5 24C9.39543 24 8.5 23.1046 8.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M16.5 2C16.5 0.89543 17.3954 0 18.5 0C19.6046 0 20.5 0.895431 20.5 2V22C20.5 23.1046 19.6046 24 18.5 24C17.3954 24 16.5 23.1046 16.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M24.5 2C24.5 0.89543 25.3954 0 26.5 0C27.6046 0 28.5 0.895431 28.5 2V22C28.5 23.1046 27.6046 24 26.5 24C25.3954 24 24.5 23.1046 24.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M32.5 2C32.5 0.89543 33.3954 0 34.5 0C35.6046 0 36.5 0.895431 36.5 2V22C36.5 23.1046 35.6046 24 34.5 24C33.3954 24 32.5 23.1046 32.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M40.5 2C40.5 0.89543 41.3954 0 42.5 0C43.6046 0 44.5 0.895431 44.5 2V22C44.5 23.1046 43.6046 24 42.5 24C41.3954 24 40.5 23.1046 40.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M48.5 2C48.5 0.89543 49.3954 0 50.5 0C51.6046 0 52.5 0.895431 52.5 2V22C52.5 23.1046 51.6046 24 50.5 24C49.3954 24 48.5 23.1046 48.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M56.5 2C56.5 0.89543 57.3954 0 58.5 0C59.6046 0 60.5 0.895431 60.5 2V22C60.5 23.1046 59.6046 24 58.5 24C57.3954 24 56.5 23.1046 56.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M64.5 2C64.5 0.89543 65.3954 0 66.5 0C67.6046 0 68.5 0.895431 68.5 2V22C68.5 23.1046 67.6046 24 66.5 24C65.3954 24 64.5 23.1046 64.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M72.5 2C72.5 0.89543 73.3954 0 74.5 0C75.6046 0 76.5 0.895431 76.5 2V22C76.5 23.1046 75.6046 24 74.5 24C73.3954 24 72.5 23.1046 72.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M80.5 2C80.5 0.89543 81.3954 0 82.5 0C83.6046 0 84.5 0.895431 84.5 2V22C84.5 23.1046 83.6046 24 82.5 24C81.3954 24 80.5 23.1046 80.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M88.5 2C88.5 0.89543 89.3954 0 90.5 0C91.6046 0 92.5 0.895431 92.5 2V22C92.5 23.1046 91.6046 24 90.5 24C89.3954 24 88.5 23.1046 88.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M96.5 2C96.5 0.89543 97.3954 0 98.5 0C99.6046 0 100.5 0.895431 100.5 2V22C100.5 23.1046 99.6046 24 98.5 24C97.3954 24 96.5 23.1046 96.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M104.5 2C104.5 0.89543 105.395 0 106.5 0C107.605 0 108.5 0.895431 108.5 2V22C108.5 23.1046 107.605 24 106.5 24C105.395 24 104.5 23.1046 104.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M112.5 2C112.5 0.89543 113.395 0 114.5 0C115.605 0 116.5 0.895431 116.5 2V22C116.5 23.1046 115.605 24 114.5 24C113.395 24 112.5 23.1046 112.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M120.5 2C120.5 0.89543 121.395 0 122.5 0C123.605 0 124.5 0.895431 124.5 2V22C124.5 23.1046 123.605 24 122.5 24C121.395 24 120.5 23.1046 120.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M128.5 2C128.5 0.89543 129.395 0 130.5 0C131.605 0 132.5 0.895431 132.5 2V22C132.5 23.1046 131.605 24 130.5 24C129.395 24 128.5 23.1046 128.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M136.5 2C136.5 0.89543 137.395 0 138.5 0C139.605 0 140.5 0.895431 140.5 2V22C140.5 23.1046 139.605 24 138.5 24C137.395 24 136.5 23.1046 136.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M144.5 2C144.5 0.89543 145.395 0 146.5 0C147.605 0 148.5 0.895431 148.5 2V22C148.5 23.1046 147.605 24 146.5 24C145.395 24 144.5 23.1046 144.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M152.5 2C152.5 0.89543 153.395 0 154.5 0C155.605 0 156.5 0.895431 156.5 2V22C156.5 23.1046 155.605 24 154.5 24C153.395 24 152.5 23.1046 152.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M160.5 2C160.5 0.89543 161.395 0 162.5 0C163.605 0 164.5 0.895431 164.5 2V22C164.5 23.1046 163.605 24 162.5 24C161.395 24 160.5 23.1046 160.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M168.5 2C168.5 0.89543 169.395 0 170.5 0C171.605 0 172.5 0.895431 172.5 2V22C172.5 23.1046 171.605 24 170.5 24C169.395 24 168.5 23.1046 168.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M176.5 2C176.5 0.89543 177.395 0 178.5 0C179.605 0 180.5 0.895431 180.5 2V22C180.5 23.1046 179.605 24 178.5 24C177.395 24 176.5 23.1046 176.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M184.5 2C184.5 0.89543 185.395 0 186.5 0C187.605 0 188.5 0.895431 188.5 2V22C188.5 23.1046 187.605 24 186.5 24C185.395 24 184.5 23.1046 184.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M192.5 2C192.5 0.89543 193.395 0 194.5 0C195.605 0 196.5 0.895431 196.5 2V22C196.5 23.1046 195.605 24 194.5 24C193.395 24 192.5 23.1046 192.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M200.5 2C200.5 0.89543 201.395 0 202.5 0C203.605 0 204.5 0.895431 204.5 2V22C204.5 23.1046 203.605 24 202.5 24C201.395 24 200.5 23.1046 200.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M208.5 2C208.5 0.89543 209.395 0 210.5 0C211.605 0 212.5 0.895431 212.5 2V22C212.5 23.1046 211.605 24 210.5 24C209.395 24 208.5 23.1046 208.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path><path d="M216.5 2C216.5 0.89543 217.395 0 218.5 0C219.605 0 220.5 0.895431 220.5 2V22C220.5 23.1046 219.605 24 218.5 24C217.395 24 216.5 23.1046 216.5 22V2Z" fill="var(--color-background-brand-default)" data-v-4b5dbe3c></path></mask><rect width="221" height="24" mask="url(#bars-mask)" fill="url(#gradient)" class="bg-gradient-to-r from-blue-500 to-red-500" data-v-4b5dbe3c></rect><linearGradient id="gradient" width="20" data-v-4b5dbe3c><stop offset="0%" stop-color="#9633E0" data-v-4b5dbe3c></stop><stop offset="25%" stop-color="#C42F5E" data-v-4b5dbe3c></stop><stop offset="50%" stop-color="#E8771B" data-v-4b5dbe3c></stop><stop offset="75%" stop-color="#A8B528" data-v-4b5dbe3c></stop><stop offset="100%" stop-color="#0D8A4A" data-v-4b5dbe3c></stop></linearGradient></g>', 1))
        ])),
        n.legends ? (v(), C("div", eK, [
          y("p", null, j((r = n.legends) == null ? void 0 : r.start), 1),
          y("p", null, j((s = n.legends) == null ? void 0 : s.end), 1)
        ])) : _("", !0)
      ]);
    };
  }
}), CY = /* @__PURE__ */ Ai(tK, [["__scopeId", "data-v-4b5dbe3c"]]), nK = { class: "mb-1 font-medium block" }, oK = { class: "mt-1" }, wY = /* @__PURE__ */ H({
  __name: "TextAccordion",
  props: {
    content: {},
    title: {},
    seeMoreButton: {},
    seeLessButton: {}
  },
  setup(n) {
    const e = n, t = R(null), o = R(0), i = R(!1), r = R(!1), s = () => {
      t.value && (t.value.style.webkitLineClamp = "initial", t.value.style.overflow = "initial", t.value.style.textOverflow = "initial", t.value.style.display = "block", t.value.style.webkitBoxOrient = "initial", r.value = !0);
    }, a = () => {
      t.value && (setTimeout(() => {
        t.value && (t.value.style.webkitLineClamp = e.title ? "3" : "2", t.value.style.overflow = "hidden", t.value.style.textOverflow = "ellipsis", t.value.style.display = "-webkit-box", t.value.style.webkitBoxOrient = "vertical");
      }, 300), r.value = !1, t.value.scrollHeight > 40 && (i.value = !0), t.value.scrollHeight <= 40 && (i.value = !1));
    };
    dt(() => {
      if (t.value) {
        const d = t.value.scrollHeight;
        o.value = d, d > (e.title ? 70 : 40) && (t.value.style.webkitLineClamp = e.title ? "3" : "2", t.value.style.overflow = "hidden", t.value.style.textOverflow = "ellipsis", t.value.style.display = "-webkit-box", t.value.style.webkitBoxOrient = "vertical", i.value = !0);
      }
    });
    const l = L(() => r.value ? o.value + 28 + "px" : !r.value && e.title && i.value ? "89px" : !r.value && e.title && !i.value ? "auto" : !r.value && !e.title && i.value ? "71px" : (!r.value && !e.title && !i.value, "auto"));
    return (d, u) => (v(), C("div", {
      class: J("transition-all duration-500 overflow-hidden box-content"),
      style: He(`height: ${l.value}`)
    }, [
      y("div", {
        ref_key: "container",
        ref: t,
        class: "text-sm"
      }, [
        y("p", nK, j(n.title), 1),
        y("p", null, j(n.content), 1)
      ], 512),
      y("div", oK, [
        i.value && !r.value ? (v(), C("button", {
          key: 0,
          onClick: s,
          class: "text-mgm-txt-sm text-foreground-brand-default font-medium flex items-center gap-1"
        }, [
          Se(j(n.seeMoreButton || "Voir plus") + " ", 1),
          U(ye, {
            icon: "chevron-down",
            color: "var(--color-foreground-brand-default)",
            class: "w-3 h-3"
          })
        ])) : _("", !0),
        i.value && r.value ? (v(), C("button", {
          key: 1,
          onClick: a,
          class: "text-mgm-txt-sm text-foreground-brand-default font-medium flex items-center gap-1"
        }, [
          Se(j(n.seeLessButton || "Voir moins") + " ", 1),
          U(ye, {
            icon: "chevron-up",
            color: "var(--color-foreground-brand-default)",
            class: "w-3 h-3"
          })
        ])) : _("", !0)
      ])
    ], 4));
  }
}), Tl = /(?:https?:\/\/|www\.)[^\s<>"']+/gi, $2 = /[.,;:!?]+$/, iK = {
  ")": "(",
  "]": "[",
  "}": "{"
};
function rK(n) {
  let e = n.replace($2, "");
  for (; ; ) {
    const t = e.slice(-1), o = iK[t];
    if (!o) break;
    const i = e.split(o).length - 1;
    if (e.split(t).length - 1 <= i) break;
    e = e.slice(0, -1).replace($2, "");
  }
  return e;
}
function sK(n) {
  return /^(?:https?:\/\/|www\.)[a-z0-9]/i.test(n);
}
function aK(n) {
  if (!n) return [];
  const e = [];
  let t = 0;
  Tl.lastIndex = 0;
  let o;
  for (; (o = Tl.exec(n)) !== null; ) {
    const i = rK(o[0]);
    if (!sK(i)) {
      Tl.lastIndex = o.index + o[0].length;
      continue;
    }
    o.index > t && e.push({ type: "text", value: n.slice(t, o.index) }), e.push({
      type: "link",
      value: i,
      href: i.toLowerCase().startsWith("www.") ? `https://${i}` : i
    }), t = o.index + i.length, Tl.lastIndex = t;
  }
  return t < n.length && e.push({ type: "text", value: n.slice(t) }), e;
}
const lK = ["href"], kY = /* @__PURE__ */ H({
  __name: "LinkedText",
  props: {
    text: {}
  },
  setup(n) {
    const e = n, t = L(() => aK(e.text));
    return (o, i) => (v(), C("span", null, [
      (v(!0), C(re, null, De(t.value, (r, s) => (v(), C(re, { key: s }, [
        r.type === "link" ? (v(), C("a", {
          key: 0,
          href: r.href,
          target: "_blank",
          rel: "noopener noreferrer nofollow",
          class: "text-foreground-brand-default underline underline-offset-2 break-words hover:opacity-80"
        }, j(r.value), 9, lK)) : (v(), C(re, { key: 1 }, [
          Se(j(r.value), 1)
        ], 64))
      ], 64))), 128))
    ]));
  }
}), dK = ["disabled", "onClick"], uK = ["disabled", "onClick"], cK = {
  key: 2,
  class: "border-none w-full h-[1px] bg-border-subtle mt-1 mb-1 block"
}, fK = /* @__PURE__ */ H({
  __name: "PopoverMenu",
  props: {
    items: {},
    noSeparators: { type: Boolean },
    open: { type: Boolean }
  },
  emits: ["openChange"],
  setup(n, { emit: e }) {
    const t = {
      normal: "text-foreground-emphasis hover:bg-background-subtle",
      danger: "text-foreground-danger-default hover:bg-background-danger-default"
    }, o = {
      normal: "var(--color-foreground-default)",
      danger: "var(--color-foreground-danger-default)"
    }, i = n, r = e, s = R(i.open || !1), a = (l) => {
      l.onClick && l.onClick(), setTimeout(() => {
        s.value = !1;
      }, 100);
    };
    return (l, d) => (v(), V(k(es), {
      open: s.value,
      "onUpdate:open": d[0] || (d[0] = (u) => {
        r("openChange", u), s.value = u;
      })
    }, {
      default: B(() => [
        U(k(ts), { asChild: "" }, {
          default: B(() => [
            le(l.$slots, "trigger")
          ]),
          _: 3
        }),
        U(k(ns), null, {
          default: B(() => [
            U(k(is), {
              side: "bottom",
              "side-offset": 4,
              align: "end",
              class: "rounded-[5px] border border-border-default bg-white shadow-lg py-1 data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade"
            }, {
              default: B(() => [
                (v(!0), C(re, null, De(n.items, (u, c) => (v(), C("div", {
                  key: u.name
                }, [
                  u.tooltip ? (v(), V(k(tE), { key: 0 }, {
                    default: B(() => [
                      U(k(oE), { delayDuration: 0 }, {
                        default: B(() => [
                          U(k(iE), { asChild: "" }, {
                            default: B(() => [
                              y("button", {
                                class: J(`h-9 px-3 w-full text-sm font-medium flex items-center gap-2 transition-colors duration-150 ${t[u.type]} ${u.disabled ? "opacity-50" : ""}`),
                                disabled: u.disabled,
                                onClick: () => {
                                  a(u);
                                }
                              }, [
                                u.icon ? (v(), V(ye, {
                                  key: 0,
                                  icon: u.icon,
                                  color: u.iconColor || o[u.type]
                                }, null, 8, ["icon", "color"])) : _("", !0),
                                Se(" " + j(u.name), 1)
                              ], 10, dK)
                            ]),
                            _: 2
                          }, 1024),
                          U(k(aE), null, {
                            default: B(() => [
                              U(k(sE), {
                                class: "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-grass11 select-none rounded-lg bg-neutral-900 px-[15px] py-[10px] text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] text-mgm-txt-sm text-neutral-200",
                                "side-offset": 8,
                                side: "bottom"
                              }, {
                                default: B(() => [
                                  Se(j(u.tooltip), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)) : (v(), C("button", {
                    key: 1,
                    class: J(`h-9 px-3 w-full text-sm font-medium flex items-center gap-2 transition-colors duration-150 ${t[u.type]} ${u.disabled ? "opacity-50" : ""}`),
                    disabled: u.disabled,
                    onClick: () => {
                      a(u);
                    }
                  }, [
                    u.icon ? (v(), V(ye, {
                      key: 0,
                      icon: u.icon,
                      color: u.iconColor || o[u.type]
                    }, null, 8, ["icon", "color"])) : _("", !0),
                    Se(" " + j(u.name), 1)
                  ], 10, uK)),
                  c !== n.items.length - 1 && !n.noSeparators ? (v(), C("hr", cK)) : _("", !0)
                ]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), $Y = /* @__PURE__ */ H({
  __name: "Modal",
  props: {
    open: { type: Boolean },
    contentClass: {},
    title: {},
    description: {}
  },
  emits: ["openChange", "openFocus"],
  setup(n, { emit: e }) {
    const t = n, o = R(t.open ?? !1), i = e, r = (a) => {
      t.open === void 0 && (o.value = a), i("openChange", a);
    }, s = (a) => {
      i("openFocus", a);
    };
    return Ee(
      () => t.open,
      (a) => {
        a !== void 0 && (o.value = a);
      }
    ), (a, l) => (v(), V(k(FS), {
      open: o.value,
      "onUpdate:open": r
    }, {
      default: B(() => [
        U(k(BS), { "as-child": !0 }, {
          default: B(() => [
            le(a.$slots, "trigger")
          ]),
          _: 3
        }),
        U(k(VS), null, {
          default: B(() => [
            U(k(s_), { class: "bg-black/70 data-[state=open]:animate-overlayShow fixed inset-0 z-[2000000] backdrop-blur-md" }),
            U(k(i_), {
              onOpenAutoFocus: (d) => s(d),
              class: J(`data-[state=open]:animate-contentShow fixed top-1/2 left-1/2 max-h-[85vh] w-full max-w-[480px] overflow-x-hidden overflow-y-auto overscroll-contain -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-lg focus:outline-none z-[2000001] ${t.contentClass ? t.contentClass : ""}`)
            }, {
              default: B(() => [
                t.title ? (v(), V(k(l_), {
                  key: 0,
                  class: "sr-only"
                }, {
                  default: B(() => [
                    Se(j(t.title), 1)
                  ]),
                  _: 1
                })) : _("", !0),
                t.description ? (v(), V(k(d_), {
                  key: 1,
                  class: "sr-only"
                }, {
                  default: B(() => [
                    Se(j(t.description), 1)
                  ]),
                  _: 1
                })) : _("", !0),
                le(a.$slots, "content"),
                U(k(a_), { class: "absolute top-6 right-6" }, {
                  default: B(() => [
                    U(ye, {
                      icon: "close",
                      color: "var(--color-foreground-subtle)"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 3
            }, 8, ["onOpenAutoFocus", "class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), hK = { class: "p-4" }, pK = { class: "flex items-center gap-3 mb-3" }, mK = ["src", "alt"], gK = { class: "text-mgm-txt-md text-foreground-emphasis font-medium" }, vK = { class: "text-left text-mgm-txt-sm text-foreground-default" }, MY = /* @__PURE__ */ H({
  __name: "IntegrationCard",
  props: {
    name: {},
    logo: {},
    description: {},
    integrationText: {},
    connected: { type: Boolean },
    connectedText: {}
  },
  setup(n) {
    const e = R(!1);
    return (t, o) => (v(), C("button", {
      class: "bg-white border border-subtle rounded w-full transition-shadow duration-200 hover:shadow-[0_4px_8px_-2px_rgba(28,31,39,0.1),0_2px_4px_-2px_rgba(28,31,39,0.06)] overflow-hidden group",
      onMouseenter: o[0] || (o[0] = (i) => e.value = !0),
      onMouseleave: o[1] || (o[1] = (i) => e.value = !1)
    }, [
      y("div", hK, [
        y("div", pK, [
          y("img", {
            src: n.logo,
            alt: n.name,
            class: "w-8 h-8 rounded-lg"
          }, null, 8, mK),
          y("h3", gK, j(n.name), 1)
        ]),
        y("p", vK, j(n.description), 1)
      ]),
      y("div", {
        class: J(`w-full py-4 px-6 border-t border-border-subtle flex justify-start gap-2 ${n.connected ? "bg-background-success-default" : "bg-background-subtle"}`)
      }, [
        n.connected ? _("", !0) : (v(), V(ye, {
          key: 0,
          icon: "clipboard",
          color: e.value ? "var(--color-foreground-emphasis)" : "var(--color-foreground-default)"
        }, null, 8, ["color"])),
        y("p", {
          class: J(`text-mgm-txt-sm  transition-colors duration-150 ${n.connected ? "text-foreground-success-default" : "text-foreground-default group-hover:text-foreground-emphasis"}`)
        }, j(n.connected ? n.connectedText : n.integrationText), 3)
      ], 2)
    ], 32));
  }
}), bK = { class: "relative w-fit" }, yK = { class: "flex gap-0.5" }, xK = { class: "" }, CK = { class: "flex gap-0.5" }, Y9 = /* @__PURE__ */ H({
  __name: "Stars",
  props: {
    rating: {}
  },
  setup(n) {
    return (e, t) => (v(), C("div", bK, [
      y("div", {
        class: "absolute top-0 left-0 overflow-hidden flex w-full",
        style: He({ width: n.rating * 100 / 5 + "%" })
      }, [
        y("div", yK, [
          (v(), C(re, null, De(5, (o) => y("svg", {
            key: o,
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [...t[0] || (t[0] = [
            y("path", {
              d: "M10.0003 1.66666L12.5753 6.88332L18.3337 7.72499L14.167 11.7833L15.1503 17.5167L10.0003 14.8083L4.85033 17.5167L5.83366 11.7833L1.66699 7.72499L7.42533 6.88332L10.0003 1.66666Z",
              fill: "#FDB022"
            }, null, -1)
          ])])), 64))
        ])
      ], 4),
      y("div", xK, [
        y("div", CK, [
          (v(), C(re, null, De(5, (o) => y("svg", {
            key: o + "empty",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [...t[1] || (t[1] = [
            y("path", {
              d: "M10.0003 1.66666L12.5753 6.88332L18.3337 7.72499L14.167 11.7833L15.1503 17.5167L10.0003 14.8083L4.85033 17.5167L5.83366 11.7833L1.66699 7.72499L7.42533 6.88332L10.0003 1.66666Z",
              fill: "var(--color-border-default)"
            }, null, -1)
          ])])), 64))
        ])
      ])
    ]));
  }
}), wK = { class: "relative" }, kK = { class: "" }, $K = { class: "flex" }, MK = ["onMouseenter", "onClick"], SK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _K = /* @__PURE__ */ H({
  __name: "StarsSelector",
  props: {
    stars: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = R(null), r = R(t.stars || null), s = (d) => {
      i.value = d;
    }, a = () => {
      i.value = null;
    }, l = (d) => {
      t.disabled || (r.value = d, o("update:modelValue", d));
    };
    return (d, u) => (v(), C("div", wK, [
      y("div", kK, [
        y("div", $K, [
          (v(), C(re, null, De(5, (c) => y("button", {
            key: c,
            class: "group hover:-translate-y-[2px] transition-all duration-150 px-0.5",
            onMouseenter: (f) => s(c),
            onMouseleave: a,
            onClick: (f) => l(c)
          }, [
            (v(), C("svg", SK, [
              y("path", {
                d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                class: J(`stroke-foreground-default transition-all duration-150 ${i.value && i.value >= c || r.value && r.value >= c ? "stroke-[#FDB022] fill-[#FDB022]" : ""}`)
              }, null, 2)
            ]))
          ], 40, MK)), 64))
        ])
      ])
    ]));
  }
}), EK = { class: "sm:rounded-lg sm:border sm:border-border-subtle p-10 w-full sm:w-[480px] sm:shadow-lg bg-white h-full flex flex-col justify-between" }, OK = ["src"], TK = { class: "text-mgm-txt-lg text-foreground-emphasis mb-3 font-medium" }, AK = { class: "rounded bg-background-subtle px-4 py-3 mb-4" }, IK = { class: "text-mgm-txt-sm mb-2" }, DK = { class: "flex items-center gap-2" }, NK = ["src"], PK = { class: "text-mgm-txt-sm text-foreground-default" }, LK = { key: 0 }, RK = { class: "text-mgm-txt-sm text-foreground-emphasis mb-2 font-medium" }, SY = /* @__PURE__ */ H({
  __name: "ReviewCard",
  props: {
    customColor: {},
    customRGBColor: {},
    title: {},
    logoUrl: {},
    intro: {},
    rateTitle: {},
    commentLabel: {},
    submitLabel: {},
    stars: {},
    comment: {},
    disabled: { type: Boolean }
  },
  emits: ["submit"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = R(t.stars || void 0), r = R(t.comment || void 0), s = (d) => {
      i.value = d;
    }, a = (d) => {
      r.value = d;
    }, l = () => {
      o("submit", { rating: i.value, comment: r.value });
    };
    return (d, u) => (v(), C("div", EK, [
      y("div", null, [
        y("img", {
          src: n.logoUrl,
          alt: "Learnico",
          class: "w-10 h-10 rounded-full mb-4"
        }, null, 8, OK),
        y("h3", TK, j(n.title), 1),
        y("div", AK, [
          y("p", IK, j(n.intro.text), 1),
          y("div", DK, [
            y("img", {
              src: n.intro.avatarUrl,
              class: "w-5 h-5 rounded-full"
            }, null, 8, NK),
            y("p", PK, [
              Se(j(n.intro.name) + " ", 1),
              n.intro.role ? (v(), C("i", LK, "— " + j(n.intro.role), 1)) : _("", !0)
            ])
          ])
        ]),
        y("h4", RK, j(n.rateTitle), 1),
        U(_K, {
          stars: i.value,
          class: "mb-4",
          "onUpdate:modelValue": s,
          disabled: n.disabled
        }, null, 8, ["stars", "disabled"]),
        U(GV, {
          label: n.commentLabel,
          "onUpdate:modelValue": a,
          "model-value": r.value,
          class: "mb-4",
          disabled: n.disabled
        }, null, 8, ["label", "model-value", "disabled"])
      ]),
      U(Ul, {
        class: "w-full",
        size: "lg",
        "custom-color": n.customColor,
        "custom-rgb-color": n.customRGBColor,
        disabled: !i.value || !r.value,
        onClick: l
      }, {
        default: B(() => [
          Se(j(n.submitLabel), 1)
        ]),
        _: 1
      }, 8, ["custom-color", "custom-rgb-color", "disabled"])
    ]));
  }
}), FK = { class: "flex gap-3 lg:gap-10 w-full min-w-[700px] pb-4 border-b border-border-subtle items-start flex-col lg:flex-row" }, BK = { class: "flex gap-4 items-center shrink-0 w-72" }, VK = ["src", "alt"], zK = { class: "text-mgm-txt-sm font-medium" }, HK = { class: "text-mgm-txt-sm text-foreground-default" }, jK = { class: "text-mgm-txt-sm text-foreground-default" }, WK = {
  key: 0,
  class: "flex-1"
}, UK = { class: "flex gap-4 items-center mb-2" }, KK = { class: "text-mgm-txt-sm text-foreground-default" }, GK = { class: "text-mgm-txt-sm" }, YK = {
  key: 1,
  class: "flex items-center"
}, qK = { class: "bg-background-subtle text-mgm-txt-sm text-foreground-default rounded-full px-3 py-1" }, _Y = /* @__PURE__ */ H({
  __name: "ReviewLine",
  props: {
    id: {},
    photo: {},
    name: {},
    mail: {},
    role: {},
    rating: {},
    date: {},
    comment: {},
    reviewText: {},
    menuItems: {}
  },
  setup(n) {
    const e = R(!1), t = R(!1);
    return (o, i) => (v(), C("div", FK, [
      y("div", BK, [
        y("img", {
          src: n.photo,
          alt: n.name,
          class: "w-10 h-10 rounded-full"
        }, null, 8, VK),
        y("div", null, [
          y("h4", zK, j(n.name), 1),
          y("p", HK, j(n.mail), 1),
          y("p", jK, j(n.role), 1)
        ])
      ]),
      n.rating ? (v(), C("div", WK, [
        y("div", UK, [
          U(Y9, { rating: n.rating }, null, 8, ["rating"]),
          y("p", KK, j(n.date), 1)
        ]),
        y("p", GK, j(n.comment), 1)
      ])) : (v(), C("div", YK, [
        y("span", qK, j(n.reviewText), 1)
      ])),
      n.rating ? (v(), V(fK, {
        key: 2,
        items: n.menuItems || [],
        onOpenChange: i[2] || (i[2] = (r) => t.value = r)
      }, {
        trigger: B(() => [
          y("button", {
            class: J(`w-8 h-8 border border-border-subtle rounded self-center hover:border-border-default transition-colors duration-150 ${t.value ? "!border-border-default" : ""}`),
            onMouseenter: i[0] || (i[0] = (r) => e.value = !0),
            onMouseleave: i[1] || (i[1] = (r) => e.value = !1)
          }, [
            U(ye, {
              icon: "share",
              color: e.value || t.value ? "var(--color-foreground-emphasis)" : "var(--color-foreground-default)"
            }, null, 8, ["color"])
          ], 34)
        ]),
        _: 1
      }, 8, ["items"])) : _("", !0)
    ]));
  }
}), EY = /* @__PURE__ */ H({
  __name: "Pagination",
  props: {
    total: {},
    siblingCount: {},
    defaultPage: {},
    itemsPerPage: {},
    items: {}
  },
  emits: ["update:page"],
  setup(n, { emit: e }) {
    const t = e, o = (i) => {
      t("update:page", i);
    };
    return (i, r) => (v(), V(k(P_), {
      total: n.total,
      "sibling-count": n.siblingCount,
      "show-edges": "",
      "default-page": n.defaultPage,
      "items-per-page": n.itemsPerPage,
      "onUpdate:page": o
    }, {
      default: B(() => [
        U(k(B_), { class: "flex items-center gap-1 text-foreground-default" }, {
          default: B(({ items: s }) => [
            U(k(H_), { class: "w-9 h-9 flex items-center justify-center mr-4 disabled:opacity-0 focus-within:outline focus-within:outline-1 focus-within:outline-offset-1 rounded-full" }, {
              default: B(() => [
                U(ye, {
                  icon: "chevron-left",
                  color: "var(--color-foreground-default)"
                })
              ]),
              _: 1
            }),
            (v(!0), C(re, null, De(s, (a, l) => (v(), C(re, null, [
              a.type === "page" ? (v(), V(k(V_), {
                key: l,
                class: "w-8 h-8 rounded-full data-[selected]:bg-background-brand-default-hover data-[selected]:text-foreground-brand-default after:transition focus-within:outline focus-within:outline-1 focus-within:outline-offset-1 text-mgm-txt-sm",
                value: a.value
              }, {
                default: B(() => [
                  Se(j(a.value), 1)
                ]),
                _: 2
              }, 1032, ["value"])) : (v(), V(k(L_), {
                key: a.type,
                index: l,
                class: "w-9 h-9 flex items-center justify-center"
              }, {
                default: B(() => [...r[0] || (r[0] = [
                  Se(" … ", -1)
                ])]),
                _: 1
              }, 8, ["index"]))
            ], 64))), 256)),
            U(k(z_), { class: "w-9 h-9 flex items-center justify-center ml-4 disabled:opacity-0 focus-within:outline focus-within:outline-1 focus-within:outline-offset-1 rounded-full" }, {
              default: B(() => [
                U(ye, {
                  icon: "chevron-right",
                  color: "var(--color-foreground-default)"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["total", "sibling-count", "default-page", "items-per-page"]));
  }
}), ZK = { class: "w-full h-10 bg-background-subtle border border-border-subtle rounded flex items-center justify-between pl-3 gap-10" }, JK = { class: "text-mgm-txt-sm text-foreground-default" }, OY = /* @__PURE__ */ H({
  __name: "CopyUrl",
  props: {
    url: {},
    buttonLabel: {},
    copyText: {}
  },
  setup(n) {
    const e = n, t = R(!1), o = () => {
      navigator.clipboard.writeText(e.url), t.value = !0, setTimeout(() => {
        t.value = !1;
      }, 2e3);
    };
    return (i, r) => (v(), C("div", ZK, [
      y("span", JK, j(n.url), 1),
      y("button", {
        class: "outline-none bg-white h-full w-28 rounded-r text-mgm-txt-sm text-foreground-emphasis",
        onClick: o
      }, j(t.value ? n.copyText : n.buttonLabel), 1)
    ]));
  }
}), XK = { class: "flex justify-between items-center py-3 px-5" }, QK = { class: "text-mgm-txt-md text-foreground-emphasis font-medium" }, eG = { class: "bg-background-subtle-hover px-5 py-1" }, TY = /* @__PURE__ */ H({
  __name: "PopoverFilter",
  props: {
    title: {},
    clearLabel: {},
    filters: {},
    disabledClear: { type: Boolean }
  },
  emits: ["openChange", "clearAll"],
  setup(n, { emit: e }) {
    const t = e;
    return (o, i) => (v(), V(k(es), {
      "onUpdate:open": i[1] || (i[1] = (r) => t("openChange", r))
    }, {
      default: B(() => [
        U(k(ts), { asChild: "" }, {
          default: B(() => [
            le(o.$slots, "trigger")
          ]),
          _: 3
        }),
        U(k(ns), null, {
          default: B(() => [
            U(k(is), {
              side: "bottom",
              "side-offset": 4,
              align: "end",
              class: "w-[224px] rounded-[5px] border border-border-subtle bg-white data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade outline-none overflow-hidden"
            }, {
              default: B(() => {
                var r;
                return [
                  y("div", XK, [
                    y("p", QK, j(n.title), 1),
                    y("button", {
                      class: J(`text-background-brand-emphasis text-mgm-txt-md ${n.disabledClear ? "opacity-50" : "opacity-100"}`),
                      onClick: i[0] || (i[0] = (s) => t("clearAll"))
                    }, j(n.clearLabel), 3)
                  ]),
                  U(k(AS), {
                    class: "w-full",
                    type: "single",
                    "default-value": ((r = n.filters.find((s) => s.defaultOpen)) == null ? void 0 : r.name) || void 0,
                    collapsible: !0
                  }, {
                    default: B(() => [
                      (v(!0), C(re, null, De(n.filters, (s) => (v(), V(k(DS), {
                        key: s.name,
                        value: s.name
                      }, {
                        default: B(() => [
                          U(k(PS), { class: "flex" }, {
                            default: B(() => [
                              U(k(LS), { class: "flex h-[40px] flex-1 items-center gap-1 bg-white px-5 text-[15px] leading-none outline-none group cursor-pointer" }, {
                                default: B(() => [
                                  U(ye, {
                                    icon: "chevron-down",
                                    class: "group-data-[state=open]:rotate-180 transition-all duration-150"
                                  }),
                                  y("span", null, j(s.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          U(k(NS), { class: "data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden" }, {
                            default: B(() => [
                              y("div", eG, [
                                le(o.$slots, ["filter", s.name].join("-"))
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"]))), 128))
                    ]),
                    _: 3
                  }, 8, ["default-value"])
                ];
              }),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), tG = { class: "flex text-mgm-txt-sm divide-x divide-border-subtle h-7 bg-background-subtle text-foreground-default" }, nG = {
  key: 0,
  class: "w-10"
}, oG = {
  key: 0,
  class: "flex justify-center items-center bg-background-subtle w-10"
}, iG = { key: 0 }, rG = {
  key: 1,
  class: "flex gap-1"
}, sG = { class: "text-mgm-txt-xs font-medium text-foreground-default bg-background-subtle rounded-full px-1.5 py-0.5" }, aG = {
  key: 0,
  class: "text-mgm-txt-xs font-medium text-foreground-default bg-background-subtle rounded-full px-1.5 py-0.5"
}, AY = /* @__PURE__ */ H({
  __name: "SimpleTable",
  props: {
    displayIndex: { type: Boolean },
    data: {},
    keys: {},
    accordion: { type: Boolean },
    seeMoreButton: {},
    seeLessButton: {}
  },
  setup(n) {
    const e = R(null), t = R(0), o = R(!1), i = R(!1), r = () => {
      e.value && (e.value.style.webkitLineClamp = "initial", e.value.style.overflow = "initial", e.value.style.textOverflow = "initial", e.value.style.display = "block", e.value.style.webkitBoxOrient = "initial", i.value = !0);
    }, s = () => {
      e.value && (setTimeout(() => {
        e.value && (e.value.style.overflow = "hidden", e.value.style.textOverflow = "ellipsis", e.value.style.display = "-webkit-box", e.value.style.webkitBoxOrient = "vertical");
      }, 300), i.value = !1, e.value.scrollHeight > 40 && (o.value = !0), e.value.scrollHeight <= 40 && (o.value = !1));
    };
    dt(() => {
      if (e.value) {
        const l = e.value.scrollHeight;
        t.value = l, l > 70 && (e.value.style.overflow = "hidden", e.value.style.textOverflow = "ellipsis", e.value.style.display = "-webkit-box", e.value.style.webkitBoxOrient = "vertical", o.value = !0);
      }
    });
    const a = L(() => i.value ? t.value + 28 + "px" : !i.value && o.value && t.value > 192 ? "192px" : (!i.value && !o.value && t.value < 192, "auto"));
    return (l, d) => (v(), C("div", {
      class: J("transition-all duration-500 overflow-hidden box-content relative border border-border-subtle rounded"),
      style: He(`height: ${n.accordion ? a.value : "auto"}`)
    }, [
      y("div", {
        ref_key: "container",
        ref: e,
        class: J("overflow-hidden divide-y divide-border-subtle w-full")
      }, [
        y("div", tG, [
          n.displayIndex ? (v(), C("div", nG)) : _("", !0),
          (v(!0), C(re, null, De(n.keys, (u) => (v(), C("div", {
            key: "title-col-" + u.id,
            class: J(`px-3 flex items-center flex-1 ${u.columnClass || ""}`)
          }, j(u.title), 3))), 128))
        ]),
        (v(!0), C(re, null, De(n.data, (u, c) => (v(), C("div", {
          key: u.id ?? `row-${c}`,
          class: "flex text-mgm-txt-sm divide-x divide-border-subtle h-7 bg-white"
        }, [
          n.displayIndex ? (v(), C("div", oG, j(c + 1), 1)) : _("", !0),
          (v(!0), C(re, null, De(n.keys, (f) => (v(), C("div", {
            key: "data-col-" + f.id,
            class: "px-3 flex items-center truncate flex-1"
          }, [
            Array.isArray(u[f.id]) ? (v(), C("div", rG, [
              y("span", sG, j(u[f.id][0]), 1),
              u[f.id].length > 1 ? (v(), C("span", aG, "+" + j(u[f.id].length - 1), 1)) : _("", !0)
            ])) : (v(), C("span", iG, j(u[f.id]), 1))
          ]))), 128))
        ]))), 128))
      ], 512),
      n.accordion && t.value > 192 ? (v(), C("button", {
        key: 0,
        class: "absolute bottom-0 left-0 bg-white w-full border-t border-border-subtle text-mgm-txt-sm text-foreground-brand-default h-[27px] flex gap-1 justify-center items-center",
        onClick: d[0] || (d[0] = (u) => i.value ? s() : r())
      }, [
        Se(j(i.value ? n.seeLessButton : n.seeMoreButton) + " ", 1),
        U(ye, {
          icon: "chevron-down",
          color: "var(--color-foreground-brand-default)",
          class: J(`${i.value ? "rotate-180" : "rotate-0"} transition-all duration-150`)
        }, null, 8, ["class"])
      ])) : _("", !0)
    ], 4));
  }
}), lG = { class: "flex gap-1 flex-wrap items-center" }, dG = { class: "text-foreground-emphasis" }, uG = {
  key: 0,
  class: "mx-2 text-mgm-txt-sm text-foreground-default"
}, cG = ["placeholder"], fG = { class: "p-3 flex flex-col gap-3 max-h-[35dvh] overflow-y-auto" }, hG = {
  key: 0,
  class: "text-mgm-txt-xs text-foreground-default mb-2 block"
}, pG = { class: "grid grid-cols-1 gap-3" }, mG = { class: "text-mgm-txt-sm font-medium text-foreground-emphasis -mt-1 block" }, gG = {
  key: 0,
  class: "font-normal text-foreground-default"
}, vG = {
  key: 0,
  class: "text-mgm-txt-sm text-foreground-subtle text-center"
}, bG = { key: 0 }, yG = ["onClick"], xG = { key: 1 }, CG = ["placeholder"], wG = { class: "p-3 grid grid-cols-1 gap-3 max-h-[35dvh] overflow-y-auto" }, kG = {
  key: 0,
  class: "text-mgm-txt-xs text-foreground-default mb-2 block"
}, $G = { class: "grid grid-cols-1 gap-3" }, MG = { class: "text-mgm-txt-sm font-medium text-foreground-emphasis -mt-1 block" }, SG = {
  key: 0,
  class: "font-normal text-foreground-default"
}, _G = {
  key: 0,
  class: "text-mgm-txt-sm text-foreground-subtle text-center"
}, IY = /* @__PURE__ */ H({
  __name: "Filter",
  props: {
    filter: {},
    currentFilters: {},
    modelValue: {},
    text: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = R(null), r = R(""), s = Zr({}), a = R(
      t.modelValue || []
    ), l = L(() => t.filter.find((p) => p.id === i.value) || null), d = (p) => {
      var g;
      return (((g = l.value) == null ? void 0 : g.options.flatMap((b) => b.items)) || []).filter(
        (b) => b.label.toLowerCase().includes(p.toLowerCase())
      );
    }, u = (p, m) => {
      a.value = a.value.filter((g) => g.id !== p), m.length > 0 && a.value.push({ id: p, selected: m });
    }, c = (p) => {
      const m = p.target;
      r.value = m.value, d(r.value);
    }, f = () => {
      var m;
      const p = (m = l.value) == null ? void 0 : m.id;
      if (p) {
        const g = s[p] || {}, b = Object.keys(g).filter((x) => g[x]);
        u(p, b);
      }
      o("update:modelValue", a.value), i.value = null, r.value = "";
    }, h = (p) => {
      const m = s[p] || {}, g = Object.keys(m).filter((b) => m[b]);
      u(p, g), o("update:modelValue", a.value), r.value = "";
    };
    return bv(() => {
      a.value = t.modelValue || [], t.filter.forEach((p) => {
        s[p.id] = {};
        const m = a.value.find((g) => g.id === p.id);
        p.options.forEach((g) => {
          g.items.forEach((b) => {
            s[p.id][b.value] = m ? m.selected.includes(b.value) : !1;
          });
        });
      });
    }), (p, m) => (v(), C("div", lG, [
      (v(!0), C(re, null, De(a.value, (g, b) => (v(), V(k(es), {
        key: g.id,
        "onUpdate:open": (x) => {
          x || h(g.id);
        }
      }, {
        default: B(() => [
          U(k(ts), { asChild: "" }, {
            default: B(() => {
              var x;
              return [
                U(Ul, {
                  state: "scdr",
                  icon: (x = n.filter.find((w) => w.id === g.id)) == null ? void 0 : x.icon,
                  iconPosition: "left"
                }, {
                  default: B(() => {
                    var w, M, $;
                    return [
                      Se(j((w = n.filter.find((T) => T.id === g.id)) == null ? void 0 : w.name) + " " + j(n.text.is) + " ", 1),
                      y("span", dG, j(g.selected.length) + " " + j(g.selected.length > 1 ? (M = n.filter.find((T) => T.id === g.id)) == null ? void 0 : M.text.plural : ($ = n.filter.find((T) => T.id === g.id)) == null ? void 0 : $.text.singular), 1)
                    ];
                  }),
                  _: 2
                }, 1032, ["icon"]),
                a.value.length > 1 && b !== a.value.length - 1 ? (v(), C("p", uG, j(n.text.and), 1)) : _("", !0)
              ];
            }),
            _: 2
          }, 1024),
          U(k(ns), null, {
            default: B(() => [
              U(k(is), {
                side: "bottom",
                "side-offset": 4,
                align: "end",
                class: J("rounded-[5px] w-full border border-border-subtle bg-white shadow-lg data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade overflow-hidden py-0")
              }, {
                default: B(() => {
                  var x, w, M;
                  return [
                    y("div", null, [
                      (x = n.filter.find(($) => $.id === g.id)) != null && x.searchable ? (v(), C("input", {
                        key: 0,
                        placeholder: (w = n.filter.find(($) => $.id === g.id)) == null ? void 0 : w.name,
                        type: "text",
                        class: "h-9 border-b border-border-subtle w-full px-3 text-mgm-txt-sm outline-none",
                        onInput: c
                      }, null, 40, cG)) : _("", !0),
                      y("div", fG, [
                        (v(!0), C(re, null, De((M = n.filter.find(
                          ($) => $.id === g.id
                        )) == null ? void 0 : M.options, ($, T) => {
                          var E;
                          return v(), C("div", {
                            key: T + "-title"
                          }, [
                            (E = n.filter.find((S) => S.id === g.id)) != null && E.groupable && r.value === "" ? (v(), C("span", hG, j($.title), 1)) : _("", !0),
                            y("div", pG, [
                              (v(!0), C(re, null, De(r.value === "" ? $.items : d(r.value), (S) => (v(), C("div", {
                                key: S.value + S.label
                              }, [
                                U(ha, {
                                  modelValue: s[g.id][S.value],
                                  "onUpdate:modelValue": (D) => s[g.id][S.value] = D,
                                  id: S.value,
                                  label: "",
                                  value: S.value,
                                  name: S.label
                                }, {
                                  default: B(() => [
                                    y("p", mG, [
                                      Se(j(S.label) + " ", 1),
                                      S.count ? (v(), C("span", gG, "(" + j(S.count) + ")", 1)) : _("", !0)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "id", "value", "name"])
                              ]))), 128)),
                              r.value !== "" && d(r.value).length === 0 ? (v(), C("p", vG, j(n.text.noResult), 1)) : _("", !0)
                            ])
                          ]);
                        }), 128))
                      ])
                    ])
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["onUpdate:open"]))), 128)),
      n.filter.filter((g) => !a.value.find((b) => b.id === g.id)).length > 0 ? (v(), V(k(es), {
        key: 0,
        "onUpdate:open": m[0] || (m[0] = (g) => {
          g || f();
        })
      }, {
        default: B(() => [
          U(k(ts), { asChild: "" }, {
            default: B(() => [
              U(Ul, {
                state: "trtr",
                icon: "plus",
                iconPosition: "right"
              }, {
                default: B(() => [
                  Se(j(n.text.trigger), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          U(k(ns), null, {
            default: B(() => [
              U(k(is), {
                side: "bottom",
                "side-offset": 4,
                align: "start",
                class: J(`rounded-[5px] w-full border border-border-subtle bg-white shadow-lg data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade overflow-hidden ${i.value ? "py-0" : "py-1"}`)
              }, {
                default: B(() => [
                  i.value ? _("", !0) : (v(), C("div", bG, [
                    (v(!0), C(re, null, De(n.filter.filter((g) => !a.value.find((b) => b.id === g.id)).map((g) => ({
                      name: g.name,
                      type: "normal",
                      icon: g.icon,
                      onClick: () => {
                        i.value = g.id;
                      }
                    })), (g) => (v(), C("div", {
                      key: g.name + g.icon
                    }, [
                      y("button", {
                        class: J("h-9 px-3 w-full text-sm font-medium flex items-center gap-2 hover:bg-background-subtle transition-colors duration-150"),
                        onClick: g.onClick
                      }, [
                        g.icon ? (v(), V(ye, {
                          key: 0,
                          icon: g.icon,
                          color: "var(--color-foreground-default)"
                        }, null, 8, ["icon"])) : _("", !0),
                        Se(" " + j(g.name), 1)
                      ], 8, yG)
                    ]))), 128))
                  ])),
                  i.value && l.value ? (v(), C("div", xG, [
                    l.value.searchable ? (v(), C("input", {
                      key: 0,
                      placeholder: l.value.name,
                      type: "text",
                      class: "h-9 border-b border-border-subtle w-full px-3 text-mgm-txt-sm outline-none",
                      onInput: c
                    }, null, 40, CG)) : _("", !0),
                    y("div", wG, [
                      (v(!0), C(re, null, De(l.value.options, (g, b) => (v(), C("div", {
                        key: b + "title-2"
                      }, [
                        l.value.groupable && r.value === "" ? (v(), C("span", kG, j(g.title), 1)) : _("", !0),
                        y("div", $G, [
                          (v(!0), C(re, null, De(r.value === "" ? g.items : d(r.value), (x) => (v(), C("div", {
                            key: x.value + x.label
                          }, [
                            U(ha, {
                              modelValue: s[l.value.id][x.value],
                              "onUpdate:modelValue": (w) => s[l.value.id][x.value] = w,
                              id: x.value,
                              label: "",
                              value: x.value,
                              name: x.label
                            }, {
                              default: B(() => [
                                y("p", MG, [
                                  Se(j(x.label) + " ", 1),
                                  x.count ? (v(), C("span", SG, "(" + j(x.count) + ")", 1)) : _("", !0)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "id", "value", "name"])
                          ]))), 128)),
                          r.value !== "" && d(r.value).length === 0 ? (v(), C("p", _G, j(n.text.noResult), 1)) : _("", !0)
                        ])
                      ]))), 128))
                    ])
                  ])) : _("", !0)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : _("", !0)
    ]));
  }
}), EG = { class: "flex items-center gap-4" }, DY = /* @__PURE__ */ H({
  __name: "ReviewCount",
  props: {
    rating: {},
    text: {},
    color: {}
  },
  setup(n) {
    return (e, t) => (v(), C("div", EG, [
      y("p", {
        class: J(`text-mgm-dspl-md font-semibold ${n.color === "light" ? "text-foreground-on-emphasis" : "text-foreground-emphasis"}`)
      }, j(n.rating), 3),
      y("div", null, [
        U(Y9, { rating: n.rating }, null, 8, ["rating"]),
        y("p", {
          class: J(`text-mgm-txt-sm ${n.color === "light" ? "text-foreground-on-emphasis" : "text-foreground-default"}`)
        }, j(n.text), 3)
      ])
    ]));
  }
}), OG = {
  key: 0,
  class: "mb-1.5"
}, TG = {
  key: 0,
  class: "flex items-start"
}, AG = {
  key: 0,
  class: "absolute bottom-0 left-0 top-0 flex h-full items-center"
}, IG = ["src"], DG = { class: "font-regular" }, NG = {
  key: 2,
  class: "inline-flex items-center rounded-r-[4.16px] border border-l-0 border-border-default bg-background-subtle-hover px-3 text-foreground-default shadow-sm sm:text-mgm-txt-sm"
}, q9 = /* @__PURE__ */ H({
  __name: "FieldTagInput",
  props: {
    options: { default: () => [] },
    modelValue: { default: () => [] },
    role: { default: "default" },
    id: {},
    locale: { default: "en" },
    label: {},
    description: {},
    placeholder: {},
    autocomplete: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    validationDisabled: { type: Boolean, default: !1 },
    errorMessage: {},
    customColor: {},
    customRgbColor: {},
    icon: {},
    customIcon: {},
    suffix: {},
    noRoundedBottom: { type: Boolean }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(n, { emit: e }) {
    const t = n, { t: o } = Tn(), i = R(), r = R(!1), s = R(!1), a = R(""), l = R([]), d = e, u = (h) => {
      const p = h.target;
      setTimeout(() => {
        s.value = !1;
      }, 100), l.value.length === 0 && (r.value = !1), d("blur", p.value, t.id);
    }, c = (h) => {
      const p = h.target;
      r.value = !0, s.value = !0, d("focus", p.value, t.id);
    }, f = () => {
      d("update:modelValue", "", t.id);
    };
    return Ee(
      l,
      () => {
        a.value = "", d("change", l.value, t.id), d("update:modelValue", l.value, t.id);
      },
      { deep: !0 }
    ), (h, p) => {
      var m, g, b, x, w, M, $;
      return v(), C("div", {
        ref_key: "root",
        ref: i
      }, [
        n.label || n.description ? (v(), C("div", OG, [
          n.label ? (v(), C("div", TG, [
            U(_e, {
              id: `${n.id}`,
              label: n.label
            }, null, 8, ["id", "label"]),
            n.required ? (v(), C("span", {
              key: 0,
              class: J([
                "ml-1 text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !n.customColor }
              ]),
              style: He({ color: n.customColor })
            }, " * ", 6)) : _("", !0)
          ])) : _("", !0),
          n.description ? (v(), V(_e, {
            key: 1,
            label: n.description,
            description: ""
          }, null, 8, ["label"])) : _("", !0)
        ])) : _("", !0),
        y("div", {
          class: J([
            "box-border min-h-[40px] w-full rounded-[4.16px] py-[9px] text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle flex gap-2 items-center",
            n.disabled ? "bg-[rgba(239,239,239,0.3)]" : "",
            (g = (m = n.validation) == null ? void 0 : m.$errors) != null && g.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default",
            n.customIcon || n.icon ? "px-10" : "px-2.5",
            n.customIcon || n.role === "search" || n.icon ? "pl-10" : "pl-2.5",
            n.customIcon || n.icon ? "py-2 pr-10" : "py-2 pr-2.5",
            r.value ? "!border-border-brand-emphasis !shadow-[0px_1px_2px_rgba(16,24,40,0.05)] !ring-2 !ring-border-brand-default" : "",
            {
              "focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:ring-2 focus:ring-border-brand-default": !n.customColor && !((x = (b = n.validation) == null ? void 0 : b.$errors) != null && x.length),
              "!rounded-l-none": n.role === "link",
              "!rounded-r-none": n.suffix,
              "!rounded-b-none": n.noRoundedBottom,
              invisible: n.role === "color-picker"
            }
          ])
        }, [
          n.customIcon ? (v(), C("div", AG, [
            y("img", {
              class: "ml-3 h-5 w-5",
              src: n.customIcon,
              alt: ""
            }, null, 8, IG)
          ])) : _("", !0),
          U(k(y_), {
            modelValue: l.value,
            "onUpdate:modelValue": p[2] || (p[2] = (T) => l.value = T),
            "search-term": a.value,
            "onUpdate:searchTerm": p[3] || (p[3] = (T) => a.value = T),
            disabled: n.disabled,
            multiple: "",
            class: "mx-auto relative w-full",
            filterFunction: (T, E) => [...T.filter(
              (D) => D.toLowerCase().includes(E.toLowerCase())
            ), E]
          }, {
            default: B(() => [
              U(k(w_), { "as-child": "" }, {
                default: B(() => [
                  U(k(C_), { class: "w-full inline-flex items-center justify-between leading-none gap-[5px] hover:bg-mauve3 focus:shadow-black outline-none" }, {
                    default: B(() => [
                      U(k(Y_), {
                        modelValue: l.value,
                        "onUpdate:modelValue": p[1] || (p[1] = (T) => l.value = T),
                        class: "flex gap-2 items-center rounded-lg flex-wrap w-full",
                        "add-on-paste": "",
                        delimiter: ","
                      }, {
                        default: B(({ modelValue: T }) => [
                          (v(!0), C(re, null, De(T, (E) => (v(), V(k(J_), {
                            key: E,
                            value: E,
                            class: "flex items-center justify-center gap-2 text-foreground-default rounded-full px-1.5 bg-background-subtle text-mgm-txt-xs"
                          }, {
                            default: B(() => [
                              U(k(X_), { class: "text-sm" }),
                              U(k(Q_), null, {
                                default: B(() => [
                                  U(ye, {
                                    icon: "close",
                                    class: "w-3"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]))), 128)),
                          U(k(x_), {
                            "as-child": "",
                            class: "flex-1"
                          }, {
                            default: B(() => [
                              U(k(q_), {
                                placeholder: n.placeholder,
                                class: J(`w-full outline-none ${n.disabled ? "bg-transparent" : ""}`),
                                onKeydown: p[0] || (p[0] = Zt(It(() => {
                                }, ["prevent"]), ["enter"])),
                                onBlur: u,
                                onFocus: c
                              }, null, 8, ["placeholder", "class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              U(k(E_), {
                class: J("combobox-content absolute z-10 bg-white w-[calc(100%_+_20px)] -ml-2 mt-4 border border-border-subtle rounded-[5px] shadow-lg overflow-hidden")
              }, {
                default: B(() => [
                  U(k(A_), null, {
                    default: B(() => [
                      U(k(O_), { class: "text-gray-400 text-xs font-medium text-center py-2" }, {
                        default: B(() => [...p[5] || (p[5] = [
                          Se(" No options available ", -1)
                        ])]),
                        _: 1
                      }),
                      U(k(M_), null, {
                        default: B(() => [
                          (v(!0), C(re, null, De(n.options, (T, E) => (v(), V(k(Q0), {
                            key: E,
                            class: "flex h-9 items-center px-3 font-medium text-foreground-emphasis cursor-pointer hover:bg-foreground-brand-default hover:text-white data-[state=checked]:bg-background-subtle data-[state=checked]:hover:text-foreground-emphasis",
                            value: T
                          }, {
                            default: B(() => [
                              y("span", null, j(T), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))), 128)),
                          a.value.length ? (v(), V(k(Q0), {
                            key: 0,
                            class: "flex h-9 items-center px-3 font-medium text-foreground-emphasis cursor-pointer hover:bg-foreground-brand-default hover:text-white data-[state=checked]:bg-background-subtle data-[state=checked]:hover:text-foreground-emphasis",
                            value: a.value
                          }, {
                            default: B(() => [
                              y("span", DG, [
                                p[6] || (p[6] = y("span", { class: "font-regular text-foreground-subtle" }, "Create", -1)),
                                Se(" " + j(a.value), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["value"])) : _("", !0)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "search-term", "disabled", "filterFunction"]),
          n.role === "search" && r.value && ((w = n.modelValue) == null ? void 0 : w.length) > 0 ? (v(), V(ye, {
            key: 1,
            class: "absolute bottom-0 right-4 top-0",
            color: "var(--color-foreground-brand-default)",
            icon: "close",
            onClick: p[4] || (p[4] = (T) => f())
          })) : _("", !0),
          n.suffix ? (v(), C("span", NG, j(n.suffix), 1)) : _("", !0)
        ], 2),
        (n.validation && ((M = n.validation.$errors) == null ? void 0 : M.length) > 0 || n.errorMessage) && !n.validationDisabled ? (v(), V(_e, {
          key: 1,
          class: "mt-[3px]",
          label: (($ = n.validation.$errors[0]) == null ? void 0 : $.$message) || n.errorMessage,
          error: ""
        }, null, 8, ["label"])) : _("", !0)
      ], 512);
    };
  }
});
function M2(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      en: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Pick a color"]);
        }
      },
      fr: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Choisir une couleur"]);
        }
      }
    }
  });
}
typeof M2 == "function" && M2(q9);
const NY = /* @__PURE__ */ Ai(q9, [["__scopeId", "data-v-10b6e82a"]]), PG = ["placeholder"], LG = {
  key: 0,
  class: "p-3 grid grid-cols-1 gap-3 max-h-[40dvh] overflow-y-auto"
}, RG = ["for"], FG = { class: "text-foreground-default" }, BG = /* @__PURE__ */ H({
  __name: "AddTag",
  props: {
    open: { type: Boolean },
    tags: {},
    placeholder: {},
    createText: {}
  },
  emits: ["openChange", "tagChange", "tagCreate"],
  setup(n, { emit: e }) {
    const t = n, o = e, i = R(t.open || !1), r = R(""), s = L(() => t.tags.filter(
      (d) => d.title.toLowerCase().includes(r.value.toLowerCase())
    )), a = (d, u) => {
      const c = t.tags.find((f) => f.id === d);
      c && (c.selected = u, o("tagChange", c));
    }, l = () => {
      o("tagCreate", r.value), i.value = !1;
    };
    return (d, u) => (v(), V(k(es), {
      open: i.value,
      "onUpdate:open": u[1] || (u[1] = (c) => {
        d.$emit("openChange", c), i.value = c;
      })
    }, {
      default: B(() => [
        U(k(ts), { asChild: "" }, {
          default: B(() => [
            le(d.$slots, "trigger", {}, void 0, !0)
          ]),
          _: 3
        }),
        U(k(ns), null, {
          default: B(() => [
            U(k(is), {
              "side-offset": 4,
              "collision-padding": 8,
              class: "rounded outline-none border border-border-default bg-white shadow-lg data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade w-[240px]"
            }, {
              default: B(() => [
                vo(y("input", {
                  "onUpdate:modelValue": u[0] || (u[0] = (c) => r.value = c),
                  type: "text",
                  placeholder: t.placeholder || "Search tags...",
                  class: "h-10 rounded-t border-b border-border-subtle focus:border focus:border-border-brand-emphasis focus:ring-2 focus:ring-background-brand-default-hover outline-none text-mgm-txt-sm px-3 w-full transition-all duration-200",
                  onKeydown: Zt(l, ["enter"])
                }, null, 40, PG), [
                  [m1, r.value]
                ]),
                s.value.length ? (v(), C("div", LG, [
                  (v(!0), C(re, null, De(s.value, (c) => (v(), C("div", {
                    key: c.id,
                    class: "flex items-center gap-0"
                  }, [
                    U(ha, {
                      id: c.id,
                      "model-value": c.selected || !1,
                      onChange: (f) => a(c.id, f)
                    }, null, 8, ["id", "model-value", "onChange"]),
                    y("label", {
                      for: c.id.toString(),
                      class: "text-mgm-txt-sm font-medium text-foreground-emphasis"
                    }, j(c.title), 9, RG)
                  ]))), 128))
                ])) : _("", !0),
                r.value.length ? (v(), C("button", {
                  key: 1,
                  onClick: l,
                  class: "h-10 border-t border-border-subtle w-full px-3 text-left text-mgm-txt-sm font-medium text-foreground-emphasis truncate"
                }, [
                  y("span", FG, j(n.createText), 1),
                  Se(" " + j(r.value), 1)
                ])) : _("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), PY = /* @__PURE__ */ Ai(BG, [["__scopeId", "data-v-69c0c255"]]), VG = { class: "rounded-md w-[28px] h-[28px] flex items-center justify-center mgm-shadow-sm" }, LY = /* @__PURE__ */ H({
  __name: "BaseSquareIcon",
  props: {
    icon: {}
  },
  setup(n) {
    return (e, t) => (v(), C("div", VG, [
      U(ye, {
        color: "var(--color-foreground-default)",
        icon: n.icon
      }, null, 8, ["icon"])
    ]));
  }
}), RY = /* @__PURE__ */ H({
  __name: "BaseCallout",
  props: {
    displayIcon: { type: Boolean, default: !0 },
    icon: { default: "alert-circle" },
    color: { default: "blue" },
    text: { default: void 0 }
  },
  setup(n) {
    const e = n, t = L(() => {
      switch (e.color) {
        case "blue":
          return {
            badge: "border-border-brand-emphasis bg-background-brand-default text-foreground-brand-default",
            icon: "var(--color-foreground-brand-default)"
          };
        case "green":
          return {
            badge: "border-border-success-emphasis bg-background-success-default text-foreground-success-default",
            icon: "var(--color-foreground-success-default)"
          };
        case "grey":
          return {
            badge: "border-border-default bg-background-subtle text-foreground-default",
            icon: "var(--color-foreground-default)"
          };
        case "red":
          return {
            badge: "border-border-danger-emphasis bg-background-danger-subtle text-foreground-danger-default",
            icon: "var(--color-foreground-danger-default)"
          };
        case "yellow":
          return {
            badge: "border-border-warning-emphasis bg-background-warning-default text-foreground-warning-default",
            icon: "var(--color-foreground-warning-default)"
          };
        default:
          return {
            badge: "border-border-brand-emphasis bg-background-brand-default text-foreground-brand-default",
            icon: "var(--color-foreground-brand-default)"
          };
      }
    });
    return (o, i) => (v(), C("div", {
      class: J([
        "p-3 rounded border text-mgm-txt-sm flex items-center gap-2",
        t.value.badge
      ])
    }, [
      n.displayIcon ? (v(), V(ye, {
        key: 0,
        color: t.value.icon,
        icon: n.icon
      }, null, 8, ["color", "icon"])) : _("", !0),
      y("p", null, j(n.text), 1)
    ], 2));
  }
});
function zG(n) {
  return n ? n.split(" ").map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(" ") : "";
}
function FY(n, e, t) {
  return [n, e].filter(Boolean).map((r) => zG(r)).join(" ") || t || "";
}
function BY(n, e, t) {
  var s, a;
  const o = ((s = n == null ? void 0 : n.charAt(0)) == null ? void 0 : s.toUpperCase()) || "", i = ((a = e == null ? void 0 : e.charAt(0)) == null ? void 0 : a.toUpperCase()) || "", r = o + i;
  return r || (t ? t.charAt(0).toUpperCase() : "?");
}
export {
  PY as AddTag,
  mY as BarChart,
  WG as BaseAlert,
  UG as BaseAvatar,
  Jc as BaseBadge,
  KG as BaseBreadcrumb,
  Ul as BaseButton,
  RY as BaseCallout,
  GG as BaseCard,
  YG as BaseEmptyState,
  qG as BaseHorizontalBarChart,
  ye as BaseIcon,
  ZG as BaseLoader,
  JG as BasePieChart,
  XG as BaseProgressRing,
  LY as BaseSquareIcon,
  OY as CopyUrl,
  QG as FieldAvatarUploader,
  ha as FieldCheckbox,
  eY as FieldDatePicker,
  sY as FieldEditor,
  aY as FieldFileUploader,
  C5 as FieldInput,
  _e as FieldLabel,
  _L as FieldMultiFileUploader,
  QF as FieldPhoneNumber,
  lY as FieldRadio,
  dY as FieldRating,
  AV as FieldSearch,
  cY as FieldSelect,
  zV as FieldSelector,
  fY as FieldTabs,
  NY as FieldTagInput,
  GV as FieldTextarea,
  iY as FieldTimePicker,
  hY as FieldToggle,
  IY as Filter,
  MY as IntegrationCard,
  kY as LinkedText,
  $Y as Modal,
  EY as Pagination,
  bY as PieChart,
  TY as PopoverFilter,
  fK as PopoverMenu,
  yY as ProgressArc,
  xY as ProgressBar,
  CY as ProgressGradient,
  SY as ReviewCard,
  DY as ReviewCount,
  _Y as ReviewLine,
  AY as SimpleTable,
  Y9 as Stars,
  _K as StarsSelector,
  wY as TextAccordion,
  zG as capitalizedName,
  FY as getDisplayName,
  BY as getInitials,
  aK as parseTextWithLinks
};
